import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};


export type AddAircraftDocumentInput = {
  aircraftId?: Maybe<Scalars['Int']>;
  documentTypeId?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type AddAircraftEngineManufacturerInput = {
  name?: Maybe<Scalars['String']>;
};

export type AddAircraftInsFormAssociatedDocumentInput = {
  aircraftId?: Maybe<Scalars['Int']>;
  documentTypeId?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  insFormAssociatedDocumentGroupId?: Maybe<Scalars['Int']>;
  insFormId?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type AddAircraftManufacturerInput = {
  name?: Maybe<Scalars['String']>;
};

export type AddAircraftModelInput = {
  name?: Maybe<Scalars['String']>;
};

export type AddAircraftProjectDocumentInput = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  documentTypeId?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type AddAircraftProjectInput = {
  aircraftId?: Maybe<Scalars['Int']>;
  aircraftProjectTypeId?: Maybe<Scalars['Int']>;
  aircraftStatusId?: Maybe<Scalars['Int']>;
  registrationMark?: Maybe<Scalars['String']>;
};

export type AddAircraftProjectInsFormAssociatedDocumentInput = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  documentTypeId?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  insFormAssociatedDocumentGroupId?: Maybe<Scalars['Int']>;
  insFormId?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type AddAircraftPropellerManufacturerInput = {
  name?: Maybe<Scalars['String']>;
};

export type AddAmoProjectDocumentInput = {
  amoProjectId?: Maybe<Scalars['Int']>;
  documentTypeId?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type AddAmoProjectInput = {
  amoId?: Maybe<Scalars['Int']>;
  amoName?: Maybe<Scalars['String']>;
  amoProjectTypeId?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['Int']>;
  dcaCertificateNo?: Maybe<Scalars['String']>;
  localApprovalOpsSpecsNumber?: Maybe<Scalars['String']>;
  specialProject?: Maybe<Scalars['String']>;
};

export type AddCompanyDocumentInput = {
  companyId?: Maybe<Scalars['Int']>;
  documentTypeId?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type AddCrewMemberDocumentInput = {
  crewMemberId?: Maybe<Scalars['Int']>;
  documentTypeId?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type AddCrewMemberInput = {
  certificateDateOfFirstIssue?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate?: Maybe<Scalars['DateTime']>;
  certificateIssuedDate?: Maybe<Scalars['DateTime']>;
  countryId?: Maybe<Scalars['Int']>;
  crewLicenseTypeId?: Maybe<Scalars['Int']>;
  crewPositionId?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
};

export type AddCrewProjectDocumentInput = {
  crewProjectId?: Maybe<Scalars['Int']>;
  documentTypeId?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type AddCrewProjectInput = {
  countryId?: Maybe<Scalars['Int']>;
  crewLicenseTypeId?: Maybe<Scalars['Int']>;
  crewMemberId?: Maybe<Scalars['Int']>;
  crewPositionId?: Maybe<Scalars['Int']>;
  crewProjectRenewalChangeTypeIds?: Maybe<Array<Scalars['Int']>>;
  crewProjectSpecialProjectTypeId?: Maybe<Scalars['Int']>;
  crewProjectTypeId?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
};

export type AddInspectorBlockedDateInput = {
  endDate?: Maybe<Scalars['DateTime']>;
  inspectorId?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type AddInspectorDocumentInput = {
  documentTypeId?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  inspectorId?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type AddInspectorInput = {
  address?: Maybe<Scalars['String']>;
  atsType?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  diAppointmentNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  initials?: Maybe<Scalars['String']>;
  inspectorCategoryId?: Maybe<Scalars['Int']>;
  inspectorCategoryTypeId?: Maybe<Scalars['Int']>;
  inspectorTypeId?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  regionId?: Maybe<Scalars['Int']>;
  stateId?: Maybe<Scalars['Int']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AddInvoiceInput = {
  aircraftProjectIds?: Maybe<Array<Scalars['Int']>>;
  crewProjectIds?: Maybe<Array<Scalars['Int']>>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  mechanicProjectIds?: Maybe<Array<Scalars['Int']>>;
  notes?: Maybe<Scalars['String']>;
  paymentStatusId?: Maybe<Scalars['Int']>;
};

export type AddMechanicDocumentInput = {
  documentTypeId?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  mechanicId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type AddMechanicInput = {
  certificateDateOfFirstIssue?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate?: Maybe<Scalars['DateTime']>;
  certificateIssuedDate?: Maybe<Scalars['DateTime']>;
  countryId?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
  mechanicLicenseTypeId?: Maybe<Scalars['Int']>;
  mechanicPositionId?: Maybe<Scalars['Int']>;
};

export type AddMechanicProjectDocumentInput = {
  documentTypeId?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  mechanicProjectId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type AddMechanicProjectInput = {
  countryId?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
  mechanicId?: Maybe<Scalars['Int']>;
  mechanicLicenseTypeId?: Maybe<Scalars['Int']>;
  mechanicPositionId?: Maybe<Scalars['Int']>;
  mechanicProjectRenewalChangeTypeIds?: Maybe<Array<Scalars['Int']>>;
  mechanicProjectTypeId?: Maybe<Scalars['Int']>;
};

export type Aircraft = {
  activeAircraftProjects: Array<AircraftProject>;
  aircraftCategory?: Maybe<AircraftCategory>;
  aircraftClass?: Maybe<AircraftClass>;
  aircraftEngineManufacturer?: Maybe<AircraftEngineManufacturer>;
  aircraftImageFileAttachment?: Maybe<FileAttachment>;
  aircraftManufacturer?: Maybe<AircraftManufacturer>;
  aircraftModel?: Maybe<AircraftModel>;
  aircraftOperationalApproval: AircraftOperationalApproval;
  aircraftPropellerManufacturer?: Maybe<AircraftPropellerManufacturer>;
  aircraftRadioStationLicenseExpiryDate?: Maybe<Scalars['DateTime']>;
  aircraftRadioStationLicenseIssueDate?: Maybe<Scalars['DateTime']>;
  aircraftStatus: AircraftStatus;
  aircraftType?: Maybe<AircraftType>;
  airspaceApprovalCertificateExpiryDate?: Maybe<Scalars['DateTime']>;
  airspaceApprovalCertificateIssueDate?: Maybe<Scalars['DateTime']>;
  baseOfOperationsAddress: Scalars['String'];
  baseOfOperationsCity: Scalars['String'];
  baseOfOperationsCountry?: Maybe<Country>;
  baseOfOperationsState?: Maybe<State>;
  baseOfOperationsZipCode?: Maybe<Scalars['String']>;
  certificateOfAirworthinessExpirationDate?: Maybe<Scalars['DateTime']>;
  certificateOfAirworthinessIssueDate?: Maybe<Scalars['DateTime']>;
  certificateOfInsuranceExpirationDate?: Maybe<Scalars['DateTime']>;
  certificateOfRegistrationExpirationDate?: Maybe<Scalars['DateTime']>;
  certificateOfRegistrationIssueDate?: Maybe<Scalars['DateTime']>;
  countryOfExport?: Maybe<Country>;
  deregistrationDate?: Maybe<Scalars['DateTime']>;
  documents: Array<AircraftOperatorDocument>;
  documentTypes: Array<DocumentType>;
  exportCertificateOfAirworthinessExpirationDate?: Maybe<Scalars['DateTime']>;
  hasModeSCodeDocument: Scalars['Boolean'];
  homeBaseAddress?: Maybe<Scalars['String']>;
  homeBaseCity: Scalars['String'];
  homeBaseCountry?: Maybe<Country>;
  homeBaseState?: Maybe<State>;
  homeBaseZipCode?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  initialRegistrationDate?: Maybe<Scalars['DateTime']>;
  insFormAssociatedDocuments: Array<AircraftOperatorInsFormAssociatedDocument>;
  insForms: Array<InsForm>;
  isAircraftRadioStationLicenseExpiryIndefinite?: Maybe<Scalars['Boolean']>;
  isAircraftStatusUncertain: Scalars['Boolean'];
  isAirspaceApprovalCertificateExpiryIndefinite?: Maybe<Scalars['Boolean']>;
  isHomeBaseSameAsBaseOfOperations: Scalars['Boolean'];
  isNoiseCertificateExpiryIndefinite?: Maybe<Scalars['Boolean']>;
  leaseAgreementExpirationDate?: Maybe<Scalars['DateTime']>;
  managementAgreementExpirationDate?: Maybe<Scalars['DateTime']>;
  mlw?: Maybe<Scalars['Int']>;
  mtow?: Maybe<Scalars['Int']>;
  noiseCertificateExpiryDate?: Maybe<Scalars['DateTime']>;
  noiseCertificateIssueDate?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Scalars['String']>;
  numberOfPaxSeats?: Maybe<Scalars['Int']>;
  operator?: Maybe<Operator>;
  operators: Array<AircraftOperator>;
  owner?: Maybe<Owner>;
  owners: Array<AircraftOwner>;
  priorRegistrationMarks?: Maybe<Scalars['String']>;
  registeredHolder?: Maybe<RegisteredHolder>;
  registeredHolders: Array<AircraftRegisteredHolder>;
  registrationMark: Scalars['String'];
  serialNumber?: Maybe<Scalars['String']>;
  targetReleaseDateToService?: Maybe<Scalars['DateTime']>;
  totalNewComments: Scalars['Int'];
  uboName?: Maybe<Scalars['String']>;
  uboNationality?: Maybe<Scalars['String']>;
  uboNationalityId?: Maybe<Scalars['Int']>;
  yearOfManufacture?: Maybe<Scalars['Int']>;
};


export type AircraftDocumentsArgs = {
  documentTypeCategoryId?: Maybe<Scalars['Float']>;
};


export type AircraftDocumentTypesArgs = {
  documentTypeCategoryId?: Maybe<Scalars['Float']>;
};

export type AircraftCategory = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AircraftClass = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AircraftEngineManufacturer = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  listManagementActiveAircrafts: Array<Aircraft>;
  listManagementOpenAircraftProjects: Array<AircraftProject>;
  listManagementSkippedAircraftProjects: Array<AircraftProject>;
  listManagementSkippedAircrafts: Array<Aircraft>;
  name: Scalars['String'];
};

export type AircraftManufacturer = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  listManagementActiveAircrafts: Array<Aircraft>;
  listManagementOpenAircraftProjects: Array<AircraftProject>;
  listManagementSkippedAircraftProjects: Array<AircraftProject>;
  listManagementSkippedAircrafts: Array<Aircraft>;
  name: Scalars['String'];
};

export type AircraftModel = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  listManagementActiveAircrafts: Array<Aircraft>;
  listManagementActiveCrewMembers: Array<CrewMember>;
  listManagementOpenAircraftProjects: Array<AircraftProject>;
  listManagementOpenCrewProjects: Array<CrewProject>;
  listManagementSkippedAircraftProjects: Array<AircraftProject>;
  listManagementSkippedAircrafts: Array<Aircraft>;
  listManagementSkippedCrewMembers: Array<CrewMember>;
  listManagementSkippedCrewProjects: Array<CrewProject>;
  name: Scalars['String'];
};

export type AircraftOperationalApproval = {
  acars?: Maybe<Scalars['Boolean']>;
  ads_b?: Maybe<Scalars['Boolean']>;
  aircraftId: Scalars['Int'];
  allWeatherOpsMeters?: Maybe<Scalars['Boolean']>;
  atnb1_cpdlc?: Maybe<Scalars['Boolean']>;
  basicRnp1?: Maybe<Scalars['Boolean']>;
  cat1?: Maybe<Scalars['Boolean']>;
  cat1_dh?: Maybe<Scalars['Int']>;
  cat1_minima?: Maybe<Scalars['Int']>;
  cat1_rvr?: Maybe<Scalars['Int']>;
  cat2?: Maybe<Scalars['Boolean']>;
  cat2_3a?: Maybe<Scalars['Boolean']>;
  cat2_3a_3b?: Maybe<Scalars['Boolean']>;
  cat2_3a_3b_3c?: Maybe<Scalars['Boolean']>;
  cat2_3a_3b_3c_dh?: Maybe<Scalars['Int']>;
  cat2_3a_3b_3c_minima?: Maybe<Scalars['Int']>;
  cat2_3a_3b_3c_rvr?: Maybe<Scalars['Int']>;
  cat2_3a_3b_dh?: Maybe<Scalars['Int']>;
  cat2_3a_3b_minima?: Maybe<Scalars['Int']>;
  cat2_3a_3b_rvr?: Maybe<Scalars['Int']>;
  cat2_3a_dh?: Maybe<Scalars['Int']>;
  cat2_3a_minima?: Maybe<Scalars['Int']>;
  cat2_3a_rvr?: Maybe<Scalars['Int']>;
  cat2_dh?: Maybe<Scalars['Int']>;
  cat2_minima?: Maybe<Scalars['Int']>;
  cat2_rvr?: Maybe<Scalars['Int']>;
  cpdlc_adsc?: Maybe<Scalars['Boolean']>;
  cpdlc_fan1A?: Maybe<Scalars['Boolean']>;
  cpdlc_fan1A_plus?: Maybe<Scalars['Boolean']>;
  cvs?: Maybe<Scalars['Boolean']>;
  dataStorageDeviceCdDvd?: Maybe<Scalars['Boolean']>;
  dataStorageDeviceInstalled?: Maybe<Scalars['Boolean']>;
  dataStorageDeviceMakeAndType?: Maybe<Scalars['String']>;
  dataStorageDeviceNotebook?: Maybe<Scalars['Boolean']>;
  dataStorageDeviceNotepad?: Maybe<Scalars['Boolean']>;
  dataStorageDeviceOther?: Maybe<Scalars['Boolean']>;
  dataStorageDeviceOtherDetail?: Maybe<Scalars['String']>;
  dataStorageDevicePda?: Maybe<Scalars['Boolean']>;
  efb_status?: Maybe<Scalars['String']>;
  efb_status_temporary_expiryDate?: Maybe<Scalars['DateTime']>;
  etops_edto?: Maybe<Scalars['Boolean']>;
  evs_efvs?: Maybe<Scalars['Boolean']>;
  fmc?: Maybe<Scalars['Boolean']>;
  gps?: Maybe<Scalars['Boolean']>;
  hardwareClass1?: Maybe<Scalars['Boolean']>;
  hardwareClass2?: Maybe<Scalars['Boolean']>;
  hardwareClass3?: Maybe<Scalars['Boolean']>;
  hardwareMakeAndType?: Maybe<Scalars['String']>;
  hud?: Maybe<Scalars['Boolean']>;
  hudMakeAndType?: Maybe<Scalars['String']>;
  lvto?: Maybe<Scalars['Boolean']>;
  lvto_dh?: Maybe<Scalars['Int']>;
  lvto_minima?: Maybe<Scalars['Int']>;
  lvto_rvr?: Maybe<Scalars['Int']>;
  maximumDiversionTime?: Maybe<Scalars['Int']>;
  nat_hla_rvsm?: Maybe<Scalars['Boolean']>;
  nvg_nvis?: Maybe<Scalars['Boolean']>;
  opCreditRequestedYes?: Maybe<Scalars['Boolean']>;
  pm_cpdlc?: Maybe<Scalars['Boolean']>;
  rnav1?: Maybe<Scalars['Boolean']>;
  rnav2?: Maybe<Scalars['Boolean']>;
  rnav5?: Maybe<Scalars['Boolean']>;
  rnp_apch?: Maybe<Scalars['Boolean']>;
  rnp_ar?: Maybe<Scalars['Boolean']>;
  rnp10?: Maybe<Scalars['Boolean']>;
  rnp4?: Maybe<Scalars['Boolean']>;
  rvsm?: Maybe<Scalars['Boolean']>;
  singlePilot?: Maybe<Scalars['Boolean']>;
  softwareAppTypeA?: Maybe<Scalars['Boolean']>;
  svs?: Maybe<Scalars['Boolean']>;
};

export enum AircraftOperationalApprovalsFilterBy {
  Acars = 'acars',
  AdsB = 'ads_b',
  Atnb1Cpdlc = 'atnb1_cpdlc',
  BasicRnp1 = 'basicRnp1',
  Cat1 = 'cat1',
  Cat2 = 'cat2',
  Cat2_3a = 'cat2_3a',
  Cat2_3a_3b = 'cat2_3a_3b',
  Cat2_3a_3b_3c = 'cat2_3a_3b_3c',
  CpdlcAdsc = 'cpdlc_adsc',
  CpdlcFan1A = 'cpdlc_fan1A',
  CpdlcFan1APlus = 'cpdlc_fan1A_plus',
  EfbStatusYesNo = 'efb_status_yes_no',
  EtopsEdto = 'etops_edto',
  Fmc = 'fmc',
  Gps = 'gps',
  Hud = 'hud',
  Lvto = 'lvto',
  NatHlaRvsm = 'nat_hla_rvsm',
  PmCpdlc = 'pm_cpdlc',
  Rnav1 = 'rnav1',
  Rnav2 = 'rnav2',
  Rnav5 = 'rnav5',
  RnpApch = 'rnp_apch',
  RnpAr = 'rnp_ar',
  Rnp10 = 'rnp10',
  Rnp4 = 'rnp4',
  Rvsm = 'rvsm'
}

export type AircraftOperator = {
  dateOfOperation: Scalars['DateTime'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  operator: Operator;
};

export type AircraftOperatorDocument = {
  document: Document;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
};

export type AircraftOperatorInsFormAssociatedDocument = {
  document: Document;
  id: Scalars['Int'];
  insForm: InsForm;
  insFormAssociatedDocumentGroup?: Maybe<InsFormAssociatedDocumentGroup>;
  isArchived: Scalars['Boolean'];
};

export type AircraftOwner = {
  dateOfOwnership: Scalars['DateTime'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  owner: Owner;
};

export type AircraftProject = {
  acarsAts?: Maybe<Scalars['Boolean']>;
  acarsAtsDescription?: Maybe<Scalars['String']>;
  acarsAtsRemarks?: Maybe<Scalars['String']>;
  adsBOut?: Maybe<Scalars['Boolean']>;
  adsBOutDescription?: Maybe<Scalars['String']>;
  adsBOutRemarks?: Maybe<Scalars['String']>;
  aircraft: Aircraft;
  aircraftCategory?: Maybe<AircraftCategory>;
  aircraftClass?: Maybe<AircraftClass>;
  aircraftEngineManufacturer?: Maybe<AircraftEngineManufacturer>;
  aircraftImageFileAttachment?: Maybe<FileAttachment>;
  aircraftManufacturer?: Maybe<AircraftManufacturer>;
  aircraftModel?: Maybe<AircraftModel>;
  aircraftProjectInspections: Array<AircraftProjectOperatorInspection>;
  aircraftProjectMissingRequiredDocuments: Array<Scalars['String']>;
  aircraftProjectNameForInvoicing: Scalars['String'];
  aircraftProjectType: AircraftProjectType;
  aircraftPropellerManufacturer?: Maybe<AircraftPropellerManufacturer>;
  aircraftRadioStationLicenseCtcDaysValid: Scalars['Int'];
  aircraftRadioStationLicenseExpiryDate?: Maybe<Scalars['DateTime']>;
  aircraftRadioStationLicenseIssueDate?: Maybe<Scalars['DateTime']>;
  aircraftRadioStationLicenseNumber?: Maybe<Scalars['String']>;
  aircraftStatus: AircraftStatus;
  aircraftType?: Maybe<AircraftType>;
  airspaceAndSpecialApprovalCertificateNumber?: Maybe<Scalars['String']>;
  airspaceApprovalCertificateCtcDaysValid: Scalars['Int'];
  airspaceApprovalCertificateExpiryDate?: Maybe<Scalars['DateTime']>;
  airspaceApprovalCertificateIssueDate?: Maybe<Scalars['DateTime']>;
  archivedDate?: Maybe<Scalars['DateTime']>;
  assignedDepartments: Array<Department>;
  assignedDepartmentUsers: Array<User>;
  assignees: Array<User>;
  atnb1CpdlcLink2000Plus?: Maybe<Scalars['Boolean']>;
  atnb1CpdlcLink2000PlusDescription?: Maybe<Scalars['String']>;
  atnb1CpdlcLink2000PlusRemarks?: Maybe<Scalars['String']>;
  baseOfOperationsAddress: Scalars['String'];
  baseOfOperationsCity: Scalars['String'];
  baseOfOperationsCountry?: Maybe<Country>;
  baseOfOperationsState?: Maybe<State>;
  baseOfOperationsZipCode?: Maybe<Scalars['String']>;
  basicRnp1?: Maybe<Scalars['Boolean']>;
  basicRnp1Description?: Maybe<Scalars['String']>;
  basicRnp1Remarks?: Maybe<Scalars['String']>;
  canToggleInsFormDcaApproved: Scalars['Boolean'];
  cat1Lts?: Maybe<Scalars['Boolean']>;
  cat1LtsRemarks?: Maybe<Scalars['String']>;
  cat1LtsRvr?: Maybe<Scalars['Int']>;
  cat2?: Maybe<Scalars['Boolean']>;
  cat2Dh?: Maybe<Scalars['Int']>;
  cat2Remarks?: Maybe<Scalars['String']>;
  cat2Rvr?: Maybe<Scalars['Int']>;
  cat3?: Maybe<Scalars['Boolean']>;
  cat3Dh?: Maybe<Scalars['Int']>;
  cat3Remarks?: Maybe<Scalars['String']>;
  cat3Rvr?: Maybe<Scalars['Int']>;
  certificateOfAirworthinessCtcDaysValid: Scalars['Int'];
  certificateOfAirworthinessExpirationDate?: Maybe<Scalars['DateTime']>;
  certificateOfAirworthinessIssueDate?: Maybe<Scalars['DateTime']>;
  certificateOfRegistrationCtcDaysValid: Scalars['Int'];
  certificateOfRegistrationExpirationDate?: Maybe<Scalars['DateTime']>;
  certificateOfRegistrationIssueDate?: Maybe<Scalars['DateTime']>;
  clientSubmissionDate?: Maybe<Scalars['DateTime']>;
  cofaCertificateNumber?: Maybe<Scalars['String']>;
  cofrCertificateNumber?: Maybe<Scalars['String']>;
  cofrOwnerRemark?: Maybe<Scalars['String']>;
  countryOfExport?: Maybe<Country>;
  cpdlcAdsCFans1APlus?: Maybe<Scalars['Boolean']>;
  cpdlcAdsCFans1APlusRcp?: Maybe<Scalars['Int']>;
  cpdlcAdsCFans1APlusRemarks?: Maybe<Scalars['String']>;
  cpdlcAdsCFans1APlusRsp?: Maybe<Scalars['Int']>;
  cpdlcFans1A?: Maybe<Scalars['Boolean']>;
  cpdlcFans1APlus?: Maybe<Scalars['Boolean']>;
  cpdlcFans1APlusRcp?: Maybe<Scalars['Int']>;
  cpdlcFans1APlusRemarks?: Maybe<Scalars['String']>;
  cpdlcFans1APlusRsp?: Maybe<Scalars['Int']>;
  cpdlcFans1ARcp?: Maybe<Scalars['Int']>;
  cpdlcFans1ARemarks?: Maybe<Scalars['String']>;
  cpdlcFans1ARsp?: Maybe<Scalars['Int']>;
  dcaAircraftEngineManufacturer?: Maybe<Scalars['String']>;
  dcaAircraftManufacturer?: Maybe<Scalars['String']>;
  dcaAircraftModel?: Maybe<Scalars['String']>;
  dcaAircraftPropellerManufacturer?: Maybe<Scalars['String']>;
  dcaApproachNoiseLevel?: Maybe<Scalars['Float']>;
  dcaFlyoverNoiseLevel?: Maybe<Scalars['Float']>;
  dcaHoldDate: Scalars['DateTime'];
  dcaHoldReason?: Maybe<Scalars['String']>;
  dcaIsOverflightNoiseLevelInDBASELUnits?: Maybe<Scalars['Boolean']>;
  dcaLateralFullPowerNoiseLevel?: Maybe<Scalars['Float']>;
  dcaMlw?: Maybe<Scalars['String']>;
  dcaMtow?: Maybe<Scalars['String']>;
  dcaNoiseCertificationAdditionalModifications?: Maybe<Scalars['String']>;
  dcaNoiseCertificationRemarks?: Maybe<Scalars['String']>;
  dcaNoiseCertificationStandard?: Maybe<Scalars['String']>;
  dcaOperator?: Maybe<Scalars['String']>;
  dcaOperatorAddress?: Maybe<Scalars['String']>;
  dcaOperatorAddressCountry?: Maybe<Scalars['String']>;
  dcaOverflightNoiseLevel?: Maybe<Scalars['Float']>;
  dcaOwner?: Maybe<Scalars['String']>;
  dcaOwnerAddress?: Maybe<Scalars['String']>;
  dcaOwnerAddressCountry?: Maybe<Scalars['String']>;
  dcaOwnerOperator?: Maybe<Scalars['String']>;
  dcaOwnerOperatorAddress?: Maybe<Scalars['String']>;
  dcaOwnerOperatorEmailAddress?: Maybe<Scalars['String']>;
  dcaOwnerOperatorFax?: Maybe<Scalars['String']>;
  dcaOwnerOperatorPhone?: Maybe<Scalars['String']>;
  dcaRegisteredHolder?: Maybe<Scalars['String']>;
  dcaRegisteredHolderAddress?: Maybe<Scalars['String']>;
  dcaRegisteredHolderAddressCountry?: Maybe<Scalars['String']>;
  dcaSubmissionDate?: Maybe<Scalars['DateTime']>;
  dcaTakeoffNoiseLevel?: Maybe<Scalars['Float']>;
  deregistrationDate?: Maybe<Scalars['DateTime']>;
  documents: Array<AircraftProjectOperatorDocument>;
  documentTypeOfficialLetterNotes: Array<ProjectDocumentTypeOfficialLetterNote>;
  documentTypes: Array<DocumentType>;
  edtoEtops?: Maybe<Scalars['Boolean']>;
  edtoEtopsMinutes?: Maybe<Scalars['String']>;
  edtoEtopsRemarks?: Maybe<Scalars['String']>;
  efb?: Maybe<Scalars['Boolean']>;
  efbCategoryInstalled?: Maybe<Scalars['Boolean']>;
  efbCategoryPortable?: Maybe<Scalars['Boolean']>;
  efbRemarks?: Maybe<Scalars['String']>;
  emails: Array<Email>;
  exportAcTcCycles?: Maybe<Scalars['Int']>;
  exportAcTtHours?: Maybe<Scalars['Int']>;
  exportAcTtMinutes?: Maybe<Scalars['Int']>;
  exportCofaCertificateNumber?: Maybe<Scalars['String']>;
  exportCountry?: Maybe<Scalars['String']>;
  exportDate?: Maybe<Scalars['DateTime']>;
  exportExceptions?: Maybe<Scalars['String']>;
  exportIsNew?: Maybe<Scalars['Boolean']>;
  exportIsNewlyOverhauled?: Maybe<Scalars['Boolean']>;
  exportIsUsed?: Maybe<Scalars['Boolean']>;
  exportLhEngine?: Maybe<Scalars['String']>;
  exportLhEngineSerialNumber?: Maybe<Scalars['String']>;
  exportLhEngineTcCycles?: Maybe<Scalars['Int']>;
  exportLhEngineTtHours?: Maybe<Scalars['Int']>;
  exportLhEngineTtMinutes?: Maybe<Scalars['Int']>;
  exportProduct?: Maybe<Scalars['String']>;
  exportRemarks?: Maybe<Scalars['String']>;
  exportRhEngine?: Maybe<Scalars['String']>;
  exportRhEngineSerialNumber?: Maybe<Scalars['String']>;
  exportRhEngineTcCycles?: Maybe<Scalars['Int']>;
  exportRhEngineTtHours?: Maybe<Scalars['Int']>;
  exportRhEngineTtMinutes?: Maybe<Scalars['Int']>;
  exportTCHolder?: Maybe<Scalars['String']>;
  fmcWpr?: Maybe<Scalars['Boolean']>;
  fmcWprDescription?: Maybe<Scalars['String']>;
  fmcWprRemarks?: Maybe<Scalars['String']>;
  homeBaseAddress?: Maybe<Scalars['String']>;
  homeBaseCity: Scalars['String'];
  homeBaseCountry?: Maybe<Country>;
  homeBaseState?: Maybe<State>;
  homeBaseZipCode?: Maybe<Scalars['String']>;
  hudEvsSvsCvs?: Maybe<Scalars['Boolean']>;
  hudEvsSvsCvsDescription?: Maybe<Scalars['String']>;
  hudEvsSvsCvsRemarks?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  initialRegistrationDate?: Maybe<Scalars['DateTime']>;
  insFormAssociatedDocuments: Array<AircraftProjectOperatorInsFormAssociatedDocument>;
  insForms: Array<ProjectInsFormVersion>;
  insFormsExclusiveGroups: Array<ProjectInsFormVersionExclusiveGroup>;
  isAircraftRadioStationLicenseExpiryIndefinite?: Maybe<Scalars['Boolean']>;
  isAircraftStatusUncertain: Scalars['Boolean'];
  isAirspaceApprovalCertificateExpiryIndefinite?: Maybe<Scalars['Boolean']>;
  isArgInvoiced: Scalars['Boolean'];
  isDcaInvoiced: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isHighImportance: Scalars['Boolean'];
  isHomeBaseSameAsBaseOfOperations: Scalars['Boolean'];
  isNoDcaInvoiceRequired: Scalars['Boolean'];
  isNoiseCertificateExpiryIndefinite?: Maybe<Scalars['Boolean']>;
  isOnHold: Scalars['Boolean'];
  isOnHoldByDca: Scalars['Boolean'];
  isPendingDocsFromIaso: Scalars['Boolean'];
  isPendingOther: Scalars['Boolean'];
  lvto?: Maybe<Scalars['Boolean']>;
  lvtoRemarks?: Maybe<Scalars['String']>;
  lvtoRvr?: Maybe<Scalars['Int']>;
  mlw?: Maybe<Scalars['Int']>;
  mtow?: Maybe<Scalars['Int']>;
  natHlaMnps?: Maybe<Scalars['Boolean']>;
  natHlaMnpsDescription?: Maybe<Scalars['String']>;
  natHlaMnpsRemarks?: Maybe<Scalars['String']>;
  noiseCertificateCtcDaysValid: Scalars['Int'];
  noiseCertificateExpiryDate?: Maybe<Scalars['DateTime']>;
  noiseCertificateIssueDate?: Maybe<Scalars['DateTime']>;
  noiseCertificateNumber?: Maybe<Scalars['String']>;
  numberOfPaxSeats?: Maybe<Scalars['Int']>;
  officialLetterDocumentsNote?: Maybe<Scalars['String']>;
  operator?: Maybe<Operator>;
  owner?: Maybe<Owner>;
  pendingReason?: Maybe<Scalars['String']>;
  pmCpdlc?: Maybe<Scalars['Boolean']>;
  pmCpdlcDescription?: Maybe<Scalars['String']>;
  pmCpdlcRemarks?: Maybe<Scalars['String']>;
  preparedByDcaUser?: Maybe<User>;
  priorAircraftRadioStationLicenseIssueDate?: Maybe<Scalars['DateTime']>;
  priorAirspaceApprovalCertificateIssueDate?: Maybe<Scalars['DateTime']>;
  priorCertificateOfAirworthinessExpirationDate?: Maybe<Scalars['DateTime']>;
  priorCertificateOfAirworthinessIssueDate?: Maybe<Scalars['DateTime']>;
  priorCertificateOfRegistrationExpirationDate?: Maybe<Scalars['DateTime']>;
  priorCertificateOfRegistrationIssueDate?: Maybe<Scalars['DateTime']>;
  priorNoiseCertificateIssueDate?: Maybe<Scalars['DateTime']>;
  priorRegistrationMarks?: Maybe<Scalars['String']>;
  projectCreatedByUser: User;
  projectCreationDate: Scalars['DateTime'];
  projectNumber?: Maybe<Scalars['String']>;
  projectStage: ProjectStage;
  projectStatus: ProjectStatus;
  registeredHolder?: Maybe<RegisteredHolder>;
  registrationMark: Scalars['String'];
  rnav1PRnav?: Maybe<Scalars['Boolean']>;
  rnav1PRnavDescription?: Maybe<Scalars['String']>;
  rnav1PRnavRemarks?: Maybe<Scalars['String']>;
  rnav2?: Maybe<Scalars['Boolean']>;
  rnav2Description?: Maybe<Scalars['String']>;
  rnav2Remarks?: Maybe<Scalars['String']>;
  rnav5BRnav?: Maybe<Scalars['Boolean']>;
  rnav5BRnavDescription?: Maybe<Scalars['String']>;
  rnav5BRnavRemarks?: Maybe<Scalars['String']>;
  rnp10?: Maybe<Scalars['Boolean']>;
  rnp10Description?: Maybe<Scalars['String']>;
  rnp10Remarks?: Maybe<Scalars['String']>;
  rnp4?: Maybe<Scalars['Boolean']>;
  rnp4Description?: Maybe<Scalars['String']>;
  rnp4Remarks?: Maybe<Scalars['String']>;
  rnpApch?: Maybe<Scalars['Boolean']>;
  rnpApchDescription?: Maybe<Scalars['String']>;
  rnpApchRemarks?: Maybe<Scalars['String']>;
  rnpAr?: Maybe<Scalars['Boolean']>;
  rnpArDescription?: Maybe<Scalars['String']>;
  rnpArRemarks?: Maybe<Scalars['String']>;
  rvsm?: Maybe<Scalars['Boolean']>;
  rvsmDescription?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  sfpEvacuationFerryFlightFrom?: Maybe<Scalars['String']>;
  sfpEvacuationFerryFlightTo?: Maybe<Scalars['String']>;
  sfpEvacuationFerryFlightVia?: Maybe<Scalars['String']>;
  sfpFerryFlightFrom?: Maybe<Scalars['String']>;
  sfpFerryFlightTo?: Maybe<Scalars['String']>;
  sfpInterimCofAIsNormal?: Maybe<Scalars['Boolean']>;
  sfpInterimCofAIsRadioStationLicense?: Maybe<Scalars['Boolean']>;
  sfpInterimCofAIsRestricted?: Maybe<Scalars['Boolean']>;
  sfpInterimCofAIsTransport?: Maybe<Scalars['Boolean']>;
  sfpIsEvacuationFerryFlight?: Maybe<Scalars['Boolean']>;
  sfpIsFerryFlight?: Maybe<Scalars['Boolean']>;
  sfpIsFlightPermit?: Maybe<Scalars['Boolean']>;
  sfpIsInterimCofA?: Maybe<Scalars['Boolean']>;
  sfpIsOnlyAuthorityAorBApproved?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition1?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition10?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition11?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition12?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition13?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition14?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition2?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition3?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition4?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition5?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition6?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition7?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition8?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition9?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialConditionA?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialConditionB?: Maybe<Scalars['Boolean']>;
  sfpIsSubjectToSpecialConditions?: Maybe<Scalars['Boolean']>;
  sfpIssueDate?: Maybe<Scalars['DateTime']>;
  sfpIssuedTo?: Maybe<Scalars['String']>;
  sfpIssueNumber1?: Maybe<Scalars['String']>;
  sfpIssueNumber2?: Maybe<Scalars['String']>;
  sfpIsTestFlight?: Maybe<Scalars['Boolean']>;
  sfpNumber?: Maybe<Scalars['String']>;
  sfpRevision?: Maybe<Scalars['String']>;
  sfpSpecialCondition13HoursOfFlight?: Maybe<Scalars['Int']>;
  sfpSpecialCondition13HoursOfPilot?: Maybe<Scalars['Int']>;
  sfpSpecialCondition14Other?: Maybe<Scalars['String']>;
  sfpSpecialCondition2Mtow?: Maybe<Scalars['String']>;
  sfpSpecialCondition3License1?: Maybe<Scalars['String']>;
  sfpSpecialCondition3License2?: Maybe<Scalars['String']>;
  sfpSpecialCondition3License3?: Maybe<Scalars['String']>;
  sfpSpecialCondition3License4?: Maybe<Scalars['String']>;
  sfpSpecialCondition3License5?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Name1?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Name2?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Name3?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Name4?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Name5?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Position1?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Position2?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Position3?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Position4?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Position5?: Maybe<Scalars['String']>;
  sfpSpecialCondition8Base?: Maybe<Scalars['String']>;
  sfpSpecialCondition9Base?: Maybe<Scalars['String']>;
  sfpSpecialCondition9Miles?: Maybe<Scalars['Int']>;
  sfpSpecialConditionANumberOfFlights?: Maybe<Scalars['Int']>;
  sfpSpecialConditionAUntilDate?: Maybe<Scalars['DateTime']>;
  sfpSpecialConditionBUntilReceipt?: Maybe<Scalars['DateTime']>;
  sfpTestFlightsRadius?: Maybe<Scalars['String']>;
  sfpTestFlightsWithinDistance?: Maybe<Scalars['String']>;
  steepApproach?: Maybe<Scalars['Boolean']>;
  steepApproachAirport?: Maybe<Scalars['String']>;
  steepApproachRemarks?: Maybe<Scalars['String']>;
  targetReleaseDateToService?: Maybe<Scalars['DateTime']>;
  totalNewComments: Scalars['Int'];
  totalNewDcaComments: Scalars['Int'];
  turnaroundDays?: Maybe<Scalars['Int']>;
  uboName?: Maybe<Scalars['String']>;
  uboNationality?: Maybe<Scalars['String']>;
  uboNationalityId?: Maybe<Scalars['Int']>;
  updateDate: Scalars['DateTime'];
  yearOfManufacture?: Maybe<Scalars['Int']>;
};


export type AircraftProjectAircraftProjectInspectionsArgs = {
  isPrior?: Maybe<Scalars['Boolean']>;
};


export type AircraftProjectDocumentsArgs = {
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
};


export type AircraftProjectDocumentTypesArgs = {
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
};


export type AircraftProjectEmailsArgs = {
  filter?: Maybe<AircraftProjectEmailsFilter>;
};

export type AircraftProjectDocumentTypeApprovalStatus = {
  aircraftProject: AircraftProject;
  aircraftProjectId: Scalars['Int'];
  approvalStatus: ApprovalStatus;
  approvalStatusId: Scalars['Int'];
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['Int']>;
  documentType: DocumentType;
  documentTypeId: Scalars['Int'];
  isApprovalRequired: Scalars['Boolean'];
};

export type AircraftProjectEmailsFilter = {
  /** List of email ID's to filter by */
  id_in?: Maybe<Array<Scalars['Int']>>;
};

export type AircraftProjectHistoryFilter = {
  dcaOnly?: Maybe<Scalars['Boolean']>;
};

export type AircraftProjectOperatorDocument = {
  document: Document;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  isReleasedToDca: Scalars['Boolean'];
};

export type AircraftProjectOperatorInsFormAssociatedDocument = {
  document: Document;
  id: Scalars['Int'];
  insForm: InsForm;
  insFormAssociatedDocumentGroup?: Maybe<InsFormAssociatedDocumentGroup>;
  isArchived: Scalars['Boolean'];
  isReleasedToDca: Scalars['Boolean'];
};

export type AircraftProjectOperatorInspection = {
  aircraftProject: AircraftProject;
  id: Scalars['Int'];
  inspection: Inspection;
  isDeleted: Scalars['Boolean'];
  operator: Operator;
};

export type AircraftProjects = {
  aircraftProjects: Array<AircraftProject>;
};

export type AircraftProjectsResult = AircraftProjects | PaginatedAircraftProjects;

export enum AircraftProjectsSortBy {
  AircraftProjectType = 'aircraftProjectType',
  ArchivedDate = 'archivedDate',
  Category = 'category',
  Class = 'class',
  ClientSubmissionDate = 'clientSubmissionDate',
  DcaSubmissionDate = 'dcaSubmissionDate',
  InitialRegistrationDate = 'initialRegistrationDate',
  IsHighImportance = 'isHighImportance',
  Manufacturer = 'manufacturer',
  Model = 'model',
  Operator = 'operator',
  Owner = 'owner',
  ProjectStage = 'projectStage',
  ProjectStatus = 'projectStatus',
  ProjectStatusOrder = 'projectStatusOrder',
  RegisteredHolder = 'registeredHolder',
  RegistrationMark = 'registrationMark',
  SerialNumber = 'serialNumber',
  Turnaround = 'turnaround'
}

export type AircraftProjectType = {
  abbreviation: Scalars['String'];
  hasInspections: Scalars['Boolean'];
  hasOnlyBasicInspectionDocuments: Scalars['Boolean'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AircraftPropellerManufacturer = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  listManagementActiveAircrafts: Array<Aircraft>;
  listManagementOpenAircraftProjects: Array<AircraftProject>;
  listManagementSkippedAircraftProjects: Array<AircraftProject>;
  listManagementSkippedAircrafts: Array<Aircraft>;
  name: Scalars['String'];
};

export type AircraftRegisteredHolder = {
  dateOfRegisteredHolding: Scalars['DateTime'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  registeredHolder: RegisteredHolder;
};

export type Aircrafts = {
  aircrafts: Array<Aircraft>;
};

export type AircraftsResult = Aircrafts | PaginatedAircrafts;

export enum AircraftsSortBy {
  Acars = 'acars',
  AdsB = 'ads_b',
  AircraftCategory = 'aircraftCategory',
  AircraftClass = 'aircraftClass',
  AircraftEngineManufacturer = 'aircraftEngineManufacturer',
  AircraftManufacturer = 'aircraftManufacturer',
  AircraftModel = 'aircraftModel',
  AircraftType = 'aircraftType',
  Atnb1Cpdlc = 'atnb1_cpdlc',
  BaseOfOperationsCountry = 'baseOfOperationsCountry',
  BasicRnp1 = 'basicRnp1',
  Cat1 = 'cat1',
  Cat2 = 'cat2',
  Cat2_3a = 'cat2_3a',
  Cat2_3a_3b = 'cat2_3a_3b',
  Cat2_3a_3b_3c = 'cat2_3a_3b_3c',
  CertificateOfAirworthinessExpirationDate = 'certificateOfAirworthinessExpirationDate',
  CertificateOfInsuranceExpirationDate = 'certificateOfInsuranceExpirationDate',
  CertificateOfRegistrationExpirationDate = 'certificateOfRegistrationExpirationDate',
  CpdlcAdsc = 'cpdlc_adsc',
  CpdlcFan1A = 'cpdlc_fan1A',
  CpdlcFan1APlus = 'cpdlc_fan1A_plus',
  DeregistrationDate = 'deregistrationDate',
  EfbStatusYesNo = 'efb_status_yes_no',
  EtopsEdto = 'etops_edto',
  ExportCertificateOfAirworthinessExpirationDate = 'exportCertificateOfAirworthinessExpirationDate',
  Fmc = 'fmc',
  Gps = 'gps',
  HasModeSCodeDocument = 'hasModeSCodeDocument',
  HomeBaseCountry = 'homeBaseCountry',
  Hud = 'hud',
  InitialRegistrationDate = 'initialRegistrationDate',
  LeaseAgreementExpirationDate = 'leaseAgreementExpirationDate',
  Lvto = 'lvto',
  ManagementAgreementExpirationDate = 'managementAgreementExpirationDate',
  Mtow = 'mtow',
  NatHlaRvsm = 'nat_hla_rvsm',
  NumberOfPaxSeats = 'numberOfPaxSeats',
  Operator = 'operator',
  Owner = 'owner',
  PmCpdlc = 'pm_cpdlc',
  PriorRegistrationMarks = 'priorRegistrationMarks',
  RegisteredHolder = 'registeredHolder',
  RegistrationMark = 'registrationMark',
  Rnav1 = 'rnav1',
  Rnav2 = 'rnav2',
  Rnav5 = 'rnav5',
  RnpApch = 'rnp_apch',
  RnpAr = 'rnp_ar',
  Rnp10 = 'rnp10',
  Rnp4 = 'rnp4',
  Rvsm = 'rvsm',
  SerialNumber = 'serialNumber',
  Status = 'status',
  UboName = 'uboName',
  UboNationality = 'uboNationality',
  YearOfManufacture = 'yearOfManufacture'
}

export type AircraftStatus = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AircraftType = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type Amo = {
  amoName: Scalars['String'];
  authorizedLocations?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  dateOfExpiry?: Maybe<Scalars['DateTime']>;
  dateOfFirstIssue?: Maybe<Scalars['DateTime']>;
  dcaCertificateNo?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  issueDate?: Maybe<Scalars['DateTime']>;
  localApprovalExpirationDate?: Maybe<Scalars['DateTime']>;
  localApprovalOpsSpecsNumber?: Maybe<Scalars['String']>;
};

export type AmoProject = {
  aircrafts: Array<Aircraft>;
  amo: Amo;
  amoName: Scalars['String'];
  amoProjectType: AmoProjectType;
  assignees: Array<User>;
  assocAircraftProject?: Maybe<AircraftProject>;
  authorizedLocations?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  dateOfExpiry?: Maybe<Scalars['DateTime']>;
  dateOfFirstIssue?: Maybe<Scalars['DateTime']>;
  dcaCertificateNo?: Maybe<Scalars['String']>;
  dcaHoldDate?: Maybe<Scalars['DateTime']>;
  dcaHoldReason?: Maybe<Scalars['String']>;
  dcaHoldUserId?: Maybe<Scalars['Int']>;
  dcaLastUpdatedDate?: Maybe<Scalars['DateTime']>;
  dcaSubmissionDate?: Maybe<Scalars['DateTime']>;
  emails: Array<Email>;
  id: Scalars['Int'];
  insForms: Array<ProjectInsFormVersion>;
  isHighPriority: Scalars['Boolean'];
  isNoDcaInvoiceRequired: Scalars['Boolean'];
  isOnHold: Scalars['Boolean'];
  isOnHoldByDca: Scalars['Boolean'];
  isPendingDocsFromIaso: Scalars['Boolean'];
  isPendingOther: Scalars['Boolean'];
  issueDate?: Maybe<Scalars['DateTime']>;
  localApprovalExpirationDate?: Maybe<Scalars['DateTime']>;
  localApprovalOpsSpecsNumber?: Maybe<Scalars['String']>;
  officialLetterNotes?: Maybe<Scalars['String']>;
  pendingReason?: Maybe<Scalars['String']>;
  projectCreatedByUser: User;
  projectCreationDate: Scalars['DateTime'];
  projectNumber?: Maybe<Scalars['String']>;
  projectStage: ProjectStage;
  projectStatus: ProjectStatus;
  specialProject?: Maybe<Scalars['String']>;
};


export type AmoProjectEmailsArgs = {
  filter?: Maybe<AmoProjectEmailsFilter>;
};

export type AmoProjectAudit = {
  id: Scalars['Int'];
  inspection: Inspection;
  isDeleted: Scalars['Boolean'];
};

export type AmoProjectDocument = {
  document: Document;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  isReleasedToDca: Scalars['Boolean'];
};

export type AmoProjectEmailsFilter = {
  /** List of email ID's to filter by */
  idIn?: Maybe<Array<Scalars['Int']>>;
};

export type AmoProjects = {
  amoProjects: Array<AmoProject>;
};

export type AmoProjectsResult = AmoProjects | PaginatedAmoProjects;

export enum AmoProjectsSortBy {
  AmoName = 'amoName',
  DateOfExpiry = 'dateOfExpiry',
  DateOfFirstIssue = 'dateOfFirstIssue',
  DcaCertificateNo = 'dcaCertificateNo',
  Id = 'id',
  ProjectCreationDate = 'projectCreationDate',
  ProjectStatus = 'projectStatus',
  ProjectStatusOrder = 'projectStatusOrder'
}

export type AmoProjectType = {
  abbreviation: Scalars['String'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type Amos = {
  amos: Array<Amo>;
};

export type AmosResult = Amos | PaginatedAmos;

export type ApprovalStatus = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export enum ApprovalStatusEnum {
  Approved = 'Approved',
  NotSubmittedForApproval = 'NotSubmittedForApproval',
  PendingApproval = 'PendingApproval'
}

export type BannerAlert = {
  id: Scalars['Int'];
  message: Scalars['String'];
  variant: Scalars['String'];
};

export type BannerAlertInput = {
  message: Scalars['String'];
  variant: Scalars['String'];
};

export type BulkUpdateAircraftCrewMembersInput = {
  aircraftId?: Maybe<Scalars['Int']>;
  crewMemberIds?: Maybe<Array<Scalars['Int']>>;
};

export type BulkUpdateCrewMemberStatusInput = {
  crewMemberIds?: Maybe<Array<Scalars['Int']>>;
  crewMemberStatusId?: Maybe<Scalars['Int']>;
};

export type BulkUpdateCrewMemberStatusResult = {
  skippedCrewMemberNames: Array<Scalars['String']>;
  updatedCount: Scalars['Int'];
};

export type Comment = {
  body: Scalars['String'];
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  isVisibleToIaso?: Maybe<Scalars['Boolean']>;
  parentCommentId?: Maybe<Scalars['Int']>;
  postedBy: UserProfile;
};

export type CommentInput = {
  body?: Maybe<Scalars['String']>;
  isVisibleToIaso?: Maybe<Scalars['Boolean']>;
  parentCommentId?: Maybe<Scalars['Int']>;
};

export type Comments = {
  comments: Array<Comment>;
  totalComments: Scalars['Int'];
  totalNewComments: Scalars['Int'];
};

export type Company = {
  address: Scalars['String'];
  city: Scalars['String'];
  corporateEmailAddress?: Maybe<Scalars['String']>;
  country: Country;
  emailHistory: Array<EmailHistoryRecord>;
  emails: Array<Email>;
  goodStandingLetterIssueDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  incorporationDate?: Maybe<Scalars['DateTime']>;
  isActive: Scalars['Boolean'];
  isOperator: Scalars['Boolean'];
  isOwner: Scalars['Boolean'];
  isRegisteredHolder: Scalars['Boolean'];
  name: Scalars['String'];
  ofacComplianceExpirationDate?: Maybe<Scalars['DateTime']>;
  phoneNumbers: Array<PhoneNumber>;
  state?: Maybe<State>;
  totalNewComments: Scalars['Int'];
  zipCode?: Maybe<Scalars['String']>;
};


export type CompanyEmailHistoryArgs = {
  sortBy?: Maybe<EmailHistorySortBy>;
  sortDirection?: Maybe<SortDirection>;
};


export type CompanyEmailsArgs = {
  filter?: Maybe<EmailFilter>;
};

export type CompanyDocument = {
  document: Document;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
};

export type CompleteAircraftProjectTaskInput = {
  id?: Maybe<Scalars['Int']>;
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
};

export type CompleteCrewProjectTaskInput = {
  dcaProjectNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type CompleteMechanicProjectTaskInput = {
  dcaProjectNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type Contact = {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  emailAddresses: Array<ContactEmail>;
  firstName: Scalars['String'];
  functionalGroup: FunctionalGroup;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isRecipientOfSystemGeneratedEmails: Scalars['Boolean'];
  isRoleAdmin: Scalars['Boolean'];
  jobTitle: Scalars['String'];
  lastName: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  phoneNumbers: Array<ContactPhone>;
  region?: Maybe<Region>;
  state?: Maybe<State>;
  userId: Scalars['Int'];
  userName?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type ContactEmail = {
  emailAddress: Scalars['String'];
  emailAddressTypeId: Scalars['Int'];
  id: Scalars['Int'];
};

export type ContactEmailInput = {
  emailAddress?: Maybe<Scalars['String']>;
  emailAddressTypeId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type ContactInput = {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  emailAddresses?: Maybe<Array<ContactEmailInput>>;
  firstName?: Maybe<Scalars['String']>;
  functionalGroupId?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isRecipientOfSystemGeneratedEmails?: Maybe<Scalars['Boolean']>;
  isRoleAdmin?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<ContactPhoneInput>>;
  regionId?: Maybe<Scalars['Int']>;
  stateId?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type ContactPhone = {
  id: Scalars['Int'];
  phoneNumber: Scalars['String'];
  phoneNumberTypeId: Scalars['Int'];
};

export type ContactPhoneInput = {
  id?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberTypeId?: Maybe<Scalars['Int']>;
};

export type Country = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  region: Region;
  states: Array<State>;
};


export type CountryStatesArgs = {
  countryIdIn?: Maybe<Array<Scalars['Int']>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
};

export type CrewCertificateType = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CrewCertificateValidationInfoV1 = {
  basisOf: Scalars['String'];
  certificateDateOfIssue?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate2?: Maybe<Scalars['DateTime']>;
  crewCertificateType: Scalars['String'];
  dcaCrewRatingsList?: Maybe<Scalars['String']>;
  documentValidityId: Scalars['Int'];
  documentValidityName: Scalars['String'];
  firstName: Scalars['String'];
  isLegacyCertificate?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  licenseNumber: Scalars['String'];
  validationNumber: Scalars['String'];
  validationRestrictedTo?: Maybe<Scalars['String']>;
};

export type CrewCertificateValidationInfoV1Result = {
  isQrCodeValid: Scalars['Boolean'];
  validationInfo?: Maybe<CrewCertificateValidationInfoV1>;
};

export type CrewCertificateValidationInfoV2 = {
  documentValidityId: Scalars['Int'];
  documentValidityName: Scalars['String'];
};

export type CrewCertificateValidationInfoV2Result = {
  isQrCodeValid: Scalars['Boolean'];
  validationInfo?: Maybe<CrewCertificateValidationInfoV2>;
};

export type CrewLicenseType = {
  crewPositions: Array<CrewPosition>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  isForCertificateOnly: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CrewMember = {
  activeCrewProjects: Array<CrewProject>;
  aircraftModels: Array<AircraftModel>;
  aircrafts: Array<Aircraft>;
  certificateDateOfFirstIssue?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate?: Maybe<Scalars['DateTime']>;
  certificateIssuedDate?: Maybe<Scalars['DateTime']>;
  country: Country;
  crewLicenseType: CrewLicenseType;
  crewMemberStatus: CrewMemberStatus;
  crewPosition: CrewPosition;
  crewProjects: Array<CrewProject>;
  crewRatings: Array<CrewRating>;
  documents: Array<CrewMemberDocument>;
  documentTypes: Array<DocumentType>;
  elpExpiryDate?: Maybe<Scalars['DateTime']>;
  elpLevel?: Maybe<ElpLevel>;
  employmentCompanies: Array<EmploymentCompany>;
  firstName: Scalars['String'];
  genericLvCompanies: Array<GenericLvCompany>;
  hasActiveProjects: Scalars['Boolean'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  licenseNumber: Scalars['String'];
  numberOfNonInactiveAircraft: Scalars['Int'];
  operators: Array<Operator>;
  totalNewComments: Scalars['Int'];
  validationNumber?: Maybe<Scalars['String']>;
};


export type CrewMemberAircraftModelsArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type CrewMemberAircraftsArgs = {
  aircraftStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  allWeatherOpsAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  baseOfOperationsCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  cOfAStatus?: Maybe<Scalars['String']>;
  cOfRStatus?: Maybe<Scalars['String']>;
  cpdlcAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  designatedAirspaceAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  efbAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  etopsAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  excludeDeregistered?: Maybe<Scalars['Boolean']>;
  hasCertificateOfAirworthinessExpirationDate?: Maybe<Scalars['Boolean']>;
  hascertificateOfInsuranceExpirationDate?: Maybe<Scalars['Boolean']>;
  hasCertificateOfRegistrationExpirationDate?: Maybe<Scalars['Boolean']>;
  hasLeaseAgreementExpirationDate?: Maybe<Scalars['Boolean']>;
  hasManagementAgreementExpirationDate?: Maybe<Scalars['Boolean']>;
  homeBaseCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  hudAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  includeProvisional?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  mtowMaximum?: Maybe<Scalars['Int']>;
  mtowMinimum?: Maybe<Scalars['Int']>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  operatorIdNullOrIn?: Maybe<Array<Scalars['Int']>>;
  ownerIdIn?: Maybe<Array<Scalars['Int']>>;
  registeredHolderIdIn?: Maybe<Array<Scalars['Int']>>;
  registrationMarkContains?: Maybe<Scalars['String']>;
  sortBy?: Maybe<AircraftsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type CrewMemberCrewRatingsArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type CrewMemberDocumentsArgs = {
  documentTypeCategoryId?: Maybe<Scalars['Float']>;
};


export type CrewMemberDocumentTypesArgs = {
  documentTypeCategoryId?: Maybe<Scalars['Float']>;
};


export type CrewMemberEmploymentCompaniesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type CrewMemberGenericLvCompaniesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};

export type CrewMemberDocument = {
  document: Document;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
};

export type CrewMembers = {
  crewMembers: Array<CrewMember>;
};

export type CrewMembersResult = CrewMembers | PaginatedCrewMembers;

export enum CrewMembersSortBy {
  CertificateExpiryDate = 'certificateExpiryDate',
  Country = 'country',
  CrewLicenseType = 'crewLicenseType',
  CrewMemberStatus = 'crewMemberStatus',
  CrewPosition = 'crewPosition',
  CrewRating = 'crewRating',
  EmploymentCompany = 'employmentCompany',
  FirstName = 'firstName',
  LastName = 'lastName',
  LicenseNumber = 'licenseNumber',
  ValidationNumber = 'validationNumber'
}

export type CrewMemberStatus = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CrewPosition = {
  crewLicenseTypes: Array<CrewLicenseType>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};


export type CrewPositionCrewLicenseTypesArgs = {
  crewPositionIdIn?: Maybe<Array<Scalars['Int']>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
};

export type CrewProject = {
  aircraftModels: Array<AircraftModel>;
  aircrafts: Array<Aircraft>;
  archivedDate?: Maybe<Scalars['DateTime']>;
  assignees: Array<User>;
  associatedAircraftProject?: Maybe<AircraftProject>;
  canToggleInsFormDcaApproved: Scalars['Boolean'];
  certificateDateOfIssue?: Maybe<Scalars['DateTime']>;
  certificateDateOfIssue2?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate2?: Maybe<Scalars['DateTime']>;
  certificateFirstIssuedDate?: Maybe<Scalars['DateTime']>;
  clientSubmissionDate?: Maybe<Scalars['DateTime']>;
  country: Country;
  crewCertificateType: CrewCertificateType;
  crewLicenseType: CrewLicenseType;
  crewMember: CrewMember;
  crewPosition: CrewPosition;
  crewProjectCategory?: Maybe<CrewProjectCategory>;
  crewProjectNameForInvoicing: Scalars['String'];
  crewProjectRenewalTypes: Array<CrewProjectRenewalChangeType>;
  crewProjectSpecialProjectType?: Maybe<CrewProjectSpecialProjectType>;
  crewProjectType: CrewProjectType;
  crewRatings: Array<CrewRating>;
  dcaAssigneeUser?: Maybe<User>;
  dcaHoldDate: Scalars['DateTime'];
  dcaHoldReason?: Maybe<Scalars['String']>;
  dcaLastUpdatedDate?: Maybe<Scalars['DateTime']>;
  dcaProjectNumber?: Maybe<Scalars['String']>;
  dcaSubmissionDate?: Maybe<Scalars['DateTime']>;
  documents: Array<CrewProjectDocument>;
  documentTypeOfficialLetterNotes: Array<ProjectDocumentTypeOfficialLetterNote>;
  documentTypes: Array<DocumentType>;
  elpExpiryDate?: Maybe<Scalars['DateTime']>;
  elpLevel?: Maybe<ElpLevel>;
  emails: Array<Email>;
  employmentCompanies: Array<EmploymentCompany>;
  firstIssueCrewProject?: Maybe<CrewProject>;
  firstName: Scalars['String'];
  genericLvCompanies: Array<GenericLvCompany>;
  id: Scalars['Int'];
  insForms: Array<ProjectInsFormVersion>;
  insFormsExclusiveGroups: Array<ProjectInsFormVersionExclusiveGroup>;
  isArgInvoiced: Scalars['Boolean'];
  isDcaInvoiced: Scalars['Boolean'];
  isHighImportance: Scalars['Boolean'];
  isNoDcaInvoiceRequired: Scalars['Boolean'];
  isOnHold: Scalars['Boolean'];
  isOnHoldByDca: Scalars['Boolean'];
  isPendingDocsFromIaso: Scalars['Boolean'];
  isPendingLicenseVerification: Scalars['Boolean'];
  isPendingOther: Scalars['Boolean'];
  lastName: Scalars['String'];
  licenseNumber: Scalars['String'];
  officialLetterDocumentsNote?: Maybe<Scalars['String']>;
  operators: Array<Operator>;
  pendingReason?: Maybe<Scalars['String']>;
  preparedByDcaUser?: Maybe<User>;
  projectCreatedByUser: User;
  projectCreationDate: Scalars['DateTime'];
  projectStage: ProjectStage;
  projectStatus: ProjectStatus;
  provisionalAircraftRegistrationMarks?: Maybe<Scalars['String']>;
  provisionalOperatorNames?: Maybe<Scalars['String']>;
  totalNewComments: Scalars['Int'];
  totalNewDcaComments: Scalars['Int'];
  turnaroundDays?: Maybe<Scalars['Int']>;
  validationNumber?: Maybe<Scalars['String']>;
};


export type CrewProjectAircraftModelsArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type CrewProjectAircraftsArgs = {
  aircraftStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  allWeatherOpsAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  baseOfOperationsCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  cOfAStatus?: Maybe<Scalars['String']>;
  cOfRStatus?: Maybe<Scalars['String']>;
  cpdlcAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  designatedAirspaceAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  efbAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  etopsAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  excludeDeregistered?: Maybe<Scalars['Boolean']>;
  hasCertificateOfAirworthinessExpirationDate?: Maybe<Scalars['Boolean']>;
  hascertificateOfInsuranceExpirationDate?: Maybe<Scalars['Boolean']>;
  hasCertificateOfRegistrationExpirationDate?: Maybe<Scalars['Boolean']>;
  hasLeaseAgreementExpirationDate?: Maybe<Scalars['Boolean']>;
  hasManagementAgreementExpirationDate?: Maybe<Scalars['Boolean']>;
  homeBaseCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  hudAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  includeProvisional?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  mtowMaximum?: Maybe<Scalars['Int']>;
  mtowMinimum?: Maybe<Scalars['Int']>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  operatorIdNullOrIn?: Maybe<Array<Scalars['Int']>>;
  ownerIdIn?: Maybe<Array<Scalars['Int']>>;
  registeredHolderIdIn?: Maybe<Array<Scalars['Int']>>;
  registrationMarkContains?: Maybe<Scalars['String']>;
  sortBy?: Maybe<AircraftsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type CrewProjectCrewProjectRenewalTypesArgs = {
  crewProjectId?: Maybe<Scalars['Int']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type CrewProjectDocumentsArgs = {
  documentTypeCategoryId?: Maybe<Scalars['Float']>;
};


export type CrewProjectDocumentTypesArgs = {
  documentTypeCategoryId?: Maybe<Scalars['Float']>;
};


export type CrewProjectEmailsArgs = {
  filter?: Maybe<CrewProjectEmailsFilter>;
};


export type CrewProjectEmploymentCompaniesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type CrewProjectGenericLvCompaniesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};

export type CrewProjectCategory = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CrewProjectCertificate = {
  assignees: Array<User>;
  certificateDateOfIssue?: Maybe<Scalars['DateTime']>;
  certificateDateOfIssue2?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate2?: Maybe<Scalars['DateTime']>;
  certificateFirstIssuedDate?: Maybe<Scalars['DateTime']>;
  certificateType: CrewCertificateType;
  clientSubmissionDate?: Maybe<Scalars['DateTime']>;
  country: Country;
  crewLicenseType: CrewLicenseType;
  crewPosition: CrewPosition;
  crewProjectCategory?: Maybe<CrewProjectCategory>;
  crewProjectRenewalTypes: Array<CrewProjectRenewalChangeType>;
  crewProjectSpecialProjectType?: Maybe<CrewProjectSpecialProjectType>;
  crewProjectType: CrewProjectType;
  dcaAircraftList?: Maybe<Scalars['String']>;
  dcaAircraftModelsList?: Maybe<Scalars['String']>;
  dcaAssignee?: Maybe<User>;
  dcaCrewRatingsList?: Maybe<Scalars['String']>;
  dcaGenericLvCompaniesList?: Maybe<Scalars['String']>;
  dcaLastUpdatedDate?: Maybe<Scalars['DateTime']>;
  dcaProjectNumber?: Maybe<Scalars['String']>;
  dcaRemarksC?: Maybe<Scalars['String']>;
  dcaRemarksD?: Maybe<Scalars['String']>;
  dcaSubmissionDate?: Maybe<Scalars['DateTime']>;
  elpExpiryDate?: Maybe<Scalars['DateTime']>;
  elpLevel?: Maybe<ElpLevel>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  licenseNumber: Scalars['String'];
  preparedBy?: Maybe<User>;
  projectStatusId: Scalars['Int'];
  turnaroundDays?: Maybe<Scalars['Int']>;
  validationNumber?: Maybe<Scalars['String']>;
  validationRestrictedTo?: Maybe<Scalars['String']>;
};


export type CrewProjectCertificateCrewProjectRenewalTypesArgs = {
  crewProjectId?: Maybe<Scalars['Int']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
};

export type CrewProjectDocument = {
  document: Document;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  isReleasedToDca: Scalars['Boolean'];
};

export type CrewProjectEmailsFilter = {
  /** List of email ID's to filter by */
  id_in?: Maybe<Array<Scalars['Int']>>;
};

export type CrewProjectHistoryFilter = {
  dcaOnly?: Maybe<Scalars['Boolean']>;
};

export type CrewProjectRenewalChangeType = {
  abbreviation: Scalars['String'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CrewProjects = {
  crewProjects: Array<CrewProject>;
};

export type CrewProjectSpecialProjectType = {
  abbreviation: Scalars['String'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CrewProjectsResult = CrewProjects | PaginatedCrewProjects;

export enum CrewProjectsSortBy {
  ArchivedDate = 'archivedDate',
  AssociatedAircraftProject = 'associatedAircraftProject',
  CertificateDateOfIssue = 'certificateDateOfIssue',
  CertificateExpiryDate = 'certificateExpiryDate',
  CertificateFirstIssuedDate = 'certificateFirstIssuedDate',
  ClientSubmissionDate = 'clientSubmissionDate',
  CrewLicenseType = 'crewLicenseType',
  CrewPosition = 'crewPosition',
  CrewProjectCategory = 'crewProjectCategory',
  DcaAssigneeUser = 'dcaAssigneeUser',
  DcaProjectNumber = 'dcaProjectNumber',
  DcaSubmissionDate = 'dcaSubmissionDate',
  ElpLevel = 'elpLevel',
  FirstName = 'firstName',
  Id = 'id',
  IsHighImportance = 'isHighImportance',
  LastName = 'lastName',
  PreparedBy = 'preparedBy',
  ProjectCreationDate = 'projectCreationDate',
  ProjectStage = 'projectStage',
  ProjectStatus = 'projectStatus',
  ProjectStatusOrder = 'projectStatusOrder',
  Turnaround = 'turnaround',
  ValidationNumber = 'validationNumber'
}

export type CrewProjectType = {
  abbreviation: Scalars['String'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CrewRating = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  listManagementActiveCrewMembers: Array<CrewMember>;
  listManagementOpenCrewProjects: Array<CrewProject>;
  listManagementSkippedCrewMembers: Array<CrewMember>;
  listManagementSkippedCrewProjects: Array<CrewProject>;
  name: Scalars['String'];
};

export type DateRangeFilterInput = {
  /** From date */
  from?: Maybe<Scalars['DateTime']>;
  /** To date */
  to?: Maybe<Scalars['DateTime']>;
};


export type DcaHoldAircraftProjectInput = {
  id?: Maybe<Scalars['Int']>;
  pendingDocsFromIaso?: Maybe<Scalars['Boolean']>;
  pendingOther?: Maybe<Scalars['Boolean']>;
  pendingReason?: Maybe<Scalars['String']>;
};

export type DcaHoldAmoProjectInput = {
  id?: Maybe<Scalars['Int']>;
  pendingDocsFromIaso?: Maybe<Scalars['Boolean']>;
  pendingOther?: Maybe<Scalars['Boolean']>;
  pendingReason?: Maybe<Scalars['String']>;
};

export type DcaHoldCrewProjectInput = {
  id?: Maybe<Scalars['Int']>;
  pendingDocsFromIaso?: Maybe<Scalars['Boolean']>;
  pendingLicenseVerification?: Maybe<Scalars['Boolean']>;
  pendingOther?: Maybe<Scalars['Boolean']>;
  pendingReason?: Maybe<Scalars['String']>;
};

export type DcaHoldMechanicProjectInput = {
  id?: Maybe<Scalars['Int']>;
  pendingDocsFromIaso?: Maybe<Scalars['Boolean']>;
  pendingLicenseVerification?: Maybe<Scalars['Boolean']>;
  pendingOther?: Maybe<Scalars['Boolean']>;
  pendingReason?: Maybe<Scalars['String']>;
};

export type Department = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type Document = {
  createDate: Scalars['DateTime'];
  createdByUser: User;
  documentType: DocumentType;
  documentValidity: DocumentValidity;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachment: FileAttachment;
  isAutoRenew: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isIndefiniteExpiration: Scalars['Boolean'];
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated: Scalars['Boolean'];
  name: Scalars['String'];
};

export type DocumentType = {
  documentTypeCategory: DocumentTypeCategory;
  expirationDateThresholdDays?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isAlwaysVisibleToDca: Scalars['Boolean'];
  isAutoRenewAllowed: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isExpirationDateApplicable: Scalars['Boolean'];
  isExpirationDateRequired: Scalars['Boolean'];
  isIndefiniteExpirationAllowed: Scalars['Boolean'];
  isIssueDateApplicable: Scalars['Boolean'];
  isIssueDateRequired: Scalars['Boolean'];
  name: Scalars['String'];
};

export type DocumentTypeCategory = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export enum DocumentTypeCategoryEnum {
  ApprovalLetter = 'ApprovalLetter',
  Certificate = 'Certificate',
  Document = 'Document',
  Manual = 'Manual'
}

export enum DocumentTypeEnum {
  Afm = 'AFM',
  AircraftRadioStationLicense = 'AircraftRadioStationLicense',
  AirspaceAndSpecificApprovalCertificate = 'AirspaceAndSpecificApprovalCertificate',
  AmoAuthorizedReleaseServicePersonnelList = 'AmoAuthorizedReleaseServicePersonnelList',
  AmoCertificateOfApproval = 'AmoCertificateOfApproval',
  AmoCertificateToReleaseToService = 'AmoCertificateToReleaseToService',
  AmoLoepApprovalLetter = 'AmoLoepApprovalLetter',
  AmoMaintenanceOrganizationExposition = 'AmoMaintenanceOrganizationExposition',
  AmoMoeArubaSupplement = 'AmoMoeArubaSupplement',
  AmoMoesLetterOfApproval = 'AmoMoesLetterOfApproval',
  AmoPart145CertificateAndOpsSpecs = 'AmoPart145CertificateAndOpsSpecs',
  AmoQaProgramAndIpm = 'AmoQaProgramAndIpm',
  AppointmentLetter = 'AppointmentLetter',
  CertificateOfAirworthiness = 'CertificateOfAirworthiness',
  CertificateOfInsurance = 'certificateOfInsurance',
  CertificateOfRegistration = 'CertificateOfRegistration',
  CertificateOfValidation = 'CertificateOfValidation',
  CurrentAndSignedForeignLicense = 'CurrentAndSignedForeignLicense',
  CustomDocument = 'CustomDocument',
  ExportCertificateOfAirworthiness = 'ExportCertificateOfAirworthiness',
  Ins3056ComplianceDeclarationFormStamped = 'INS3056ComplianceDeclarationFormStamped',
  Ins4070AmpCommitmentStatementStamped = 'INS4070AMPCommitmentStatementStamped',
  LeaseAgreement = 'LeaseAgreement',
  LegacyApprovalLetter = 'LegacyApprovalLetter',
  LegacyCertificate = 'LegacyCertificate',
  LegacyDocument = 'LegacyDocument',
  LegacyManual = 'LegacyManual',
  LetterOfDeRegistration = 'LetterOfDeRegistration',
  LineMaintenanceAgreement = 'LineMaintenanceAgreement',
  ManagementAgreement = 'ManagementAgreement',
  MelAcceptanceLetter = 'MELAcceptanceLetter',
  ModeSCode = 'ModeSCode',
  NoiseCertificate = 'NoiseCertificate',
  OfacCompliance = 'OfacCompliance',
  OfficialLetter = 'OfficialLetter',
  OperatorLetter = 'OperatorLetter',
  ServiceAgreement = 'ServiceAgreement',
  SpecialFlightPermit = 'SpecialFlightPermit',
  TemporaryApprovalForMmel = 'TemporaryApprovalForMMEL',
  Unknown = 'Unknown'
}

export type DocumentValidity = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type DownloadFile = {
  base64Content: Scalars['String'];
  fileName: Scalars['String'];
  fileSizeBytes: Scalars['Int'];
  mimeType: Scalars['String'];
};

export type ElpLevel = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type Email = {
  bcc: Array<Scalars['String']>;
  body: Scalars['String'];
  cc: Array<Scalars['String']>;
  date: Scalars['DateTime'];
  emailAttachments: Array<EmailAttachment>;
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isHighImportance: Scalars['Boolean'];
  sentByUser: User;
  subject: Scalars['String'];
  to: Array<Scalars['String']>;
};


export type EmailEmailAttachmentsArgs = {
  filter?: Maybe<EmailAttachmentsFilter>;
};

export type EmailAddressInput = {
  emailAddress?: Maybe<Scalars['String']>;
  emailAddressTypeId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type EmailAddressType = {
  id: Scalars['Int'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type EmailAttachment = {
  fileAttachment: FileAttachment;
  id: Scalars['Int'];
};

export type EmailAttachmentsFilter = {
  /** List of attachment ID's to filter by */
  id_in?: Maybe<Array<Scalars['Int']>>;
};

export type EmailFilter = {
  /** List of email ID's to filter by */
  id_in?: Maybe<Array<Scalars['Int']>>;
};

export type EmailHistoryRecord = {
  date: Scalars['DateTime'];
  hasAttachments: Scalars['Boolean'];
  hasErrorMessage: Scalars['Boolean'];
  id: Scalars['Int'];
  isHighImportance: Scalars['Boolean'];
  sentByUser: User;
  subject: Scalars['String'];
  to: Array<Scalars['String']>;
};

export enum EmailHistorySortBy {
  Date = 'date',
  From = 'from',
  Subject = 'subject',
  To = 'to'
}

export type EmailInput = {
  bcc?: Maybe<Array<Scalars['String']>>;
  body: Scalars['String'];
  cc?: Maybe<Array<Scalars['String']>>;
  documentIds?: Maybe<Array<Scalars['Int']>>;
  fileAttachmentIds?: Maybe<Array<Scalars['Int']>>;
  isHighImportance?: Maybe<Scalars['Boolean']>;
  subject: Scalars['String'];
  to?: Maybe<Array<Scalars['String']>>;
};

export type EmploymentCompany = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  listManagementActiveCrewMembers: Array<CrewMember>;
  listManagementOpenCrewProjects: Array<CrewProject>;
  listManagementSkippedCrewMembers: Array<CrewMember>;
  listManagementSkippedCrewProjects: Array<CrewProject>;
  name: Scalars['String'];
};

export type FileAttachment = {
  content: Scalars['String'];
  fileName: Scalars['String'];
  fileSizeBytes: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  mimeType: Scalars['String'];
  uploadedByUser: User;
  uploadedDate: Scalars['DateTime'];
};

export type FunctionalGroup = {
  id: Scalars['Int'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type GenericLvCompany = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  listManagementActiveCrewMembers: Array<CrewMember>;
  listManagementOpenCrewProjects: Array<CrewProject>;
  listManagementSkippedCrewMembers: Array<CrewMember>;
  listManagementSkippedCrewProjects: Array<CrewProject>;
  name: Scalars['String'];
};

export type IdResult = {
  id: Scalars['Int'];
};

export type InsForm = {
  associatedDocumentTypes: Array<InsFormAssociatedDocumentType>;
  generatedDocumentType?: Maybe<DocumentType>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  isHiddenFromDcaUsers: Scalars['Boolean'];
  isSendForExecutionSupported: Scalars['Boolean'];
  name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  willBeEmailedWhenSigned: Scalars['Boolean'];
};

export type InsFormAction = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type InsFormAssociatedDocumentGroup = {
  id: Scalars['Int'];
  insFormId: Scalars['Int'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type InsFormAssociatedDocumentType = {
  documentType: DocumentType;
  id: Scalars['Int'];
  insFormAssociatedDocumentGroup?: Maybe<InsFormAssociatedDocumentGroup>;
  isDeleted: Scalars['Boolean'];
  isOptional: Scalars['Boolean'];
  sortOrder: Scalars['Int'];
};

export type InsFormExecutionStateLookup = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type InsFormVersion = {
  fields: Array<InsFormVersionField>;
  id: Scalars['Int'];
  insForm: InsForm;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type InsFormVersionField = {
  fieldNumber: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  isSignatureField: Scalars['Boolean'];
  requiredInsFormActionId?: Maybe<Scalars['Int']>;
  signatoryRoleId?: Maybe<Scalars['Int']>;
};

export type Inspection = {
  aircraftProjectOperatorInspection?: Maybe<AircraftProjectOperatorInspection>;
  id: Scalars['Int'];
  insForm16005AFileAttachment?: Maybe<FileAttachment>;
  insForm4001FileAttachment?: Maybe<FileAttachment>;
  insForm4004FileAttachment?: Maybe<FileAttachment>;
  insForm4007FileAttachment?: Maybe<FileAttachment>;
  insForm4023BFileAttachment?: Maybe<FileAttachment>;
  insForm4035FileAttachment?: Maybe<FileAttachment>;
  insForm4045FileAttachment?: Maybe<FileAttachment>;
  inspectionStatus: InspectionStatus;
  inspectorInspections: Array<InspectorInspection>;
  isDeleted: Scalars['Boolean'];
  letterOfFindingsFileAttachment?: Maybe<FileAttachment>;
  otherStatusText?: Maybe<Scalars['String']>;
  validityPeriod?: Maybe<Scalars['DateTime']>;
};


export type InspectionInspectorInspectionsArgs = {
  aircraftId?: Maybe<Scalars['Int']>;
  includeAllProjects?: Maybe<Scalars['Boolean']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  includePeerInspectionsForInspectors?: Maybe<Scalars['Boolean']>;
  inspectionIdIn?: Maybe<Array<Scalars['Int']>>;
  inspectorIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<InspectorInspectionsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};

export type InspectionStatus = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type Inspector = {
  appointmentLetterExpirationDate?: Maybe<Scalars['DateTime']>;
  atsType?: Maybe<Scalars['String']>;
  blockedDates: Array<InspectorBlockedDate>;
  coverageAreaRegions: Array<Region>;
  diAppointmentNumber?: Maybe<Scalars['String']>;
  emailHistory: Array<EmailHistoryRecord>;
  emails: Array<Email>;
  id: Scalars['Int'];
  inspectorCategoryId: Scalars['Int'];
  inspectorCategoryTypeId?: Maybe<Scalars['Int']>;
  inspectorInspections: Array<InspectorInspection>;
  inspectorTypeId: Scalars['Int'];
  isActive: Scalars['Boolean'];
  onboardingChecklist?: Maybe<OnboardingChecklist>;
  passportCountries: Array<Country>;
  serviceAgreementExpirationDate?: Maybe<Scalars['DateTime']>;
  totalNewComments: Scalars['Int'];
  user?: Maybe<User>;
  visaCountries: Array<Country>;
};


export type InspectorEmailHistoryArgs = {
  sortBy?: Maybe<EmailHistorySortBy>;
  sortDirection?: Maybe<SortDirection>;
};


export type InspectorEmailsArgs = {
  filter?: Maybe<EmailFilter>;
};


export type InspectorInspectorInspectionsArgs = {
  aircraftId?: Maybe<Scalars['Int']>;
  includeAllProjects?: Maybe<Scalars['Boolean']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  includePeerInspectionsForInspectors?: Maybe<Scalars['Boolean']>;
  inspectionIdIn?: Maybe<Array<Scalars['Int']>>;
  inspectorIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<InspectorInspectionsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};

export type InspectorBlockedDate = {
  endDate: Scalars['DateTime'];
  id: Scalars['Int'];
  inspector: Inspector;
  isDeleted: Scalars['Boolean'];
  reason: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type InspectorDocument = {
  document: Document;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
};

export type InspectorInput = {
  address?: Maybe<Scalars['String']>;
  atsType?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  coverageAreaRegionIds: Array<Scalars['Int']>;
  diAppointmentNumber?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<EmailAddressInput>>;
  firstName?: Maybe<Scalars['String']>;
  initials?: Maybe<Scalars['String']>;
  inspectorCategoryId?: Maybe<Scalars['Int']>;
  inspectorCategoryTypeId?: Maybe<Scalars['Int']>;
  inspectorTypeId?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  onboardingBackpacks?: Maybe<Scalars['Boolean']>;
  onboardingBusinessCard?: Maybe<Scalars['Boolean']>;
  onboardingEmails?: Maybe<Scalars['Boolean']>;
  onboardingIdCardIssued?: Maybe<Scalars['Boolean']>;
  passportCountryIds: Array<Scalars['Int']>;
  password?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<PhoneNumberInput>>;
  regionId?: Maybe<Scalars['Int']>;
  stateId?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
  visaCountryIds: Array<Scalars['Int']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type InspectorInspection = {
  city: Scalars['String'];
  country: Country;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  inspection: Inspection;
  inspectionEstimateFileAttachment?: Maybe<FileAttachment>;
  inspectionInvoiceFileAttachment?: Maybe<FileAttachment>;
  inspectionTimeLogFileAttachment?: Maybe<FileAttachment>;
  inspector: Inspector;
  isDeleted: Scalars['Boolean'];
  startDate?: Maybe<Scalars['DateTime']>;
  state?: Maybe<State>;
};

export type InspectorInspections = {
  inspectorInspections: Array<InspectorInspection>;
};

export type InspectorInspectionsResult = InspectorInspections | PaginatedInspectorInspections;

export enum InspectorInspectionsSortBy {
  AircraftProjectType = 'aircraftProjectType',
  City = 'city',
  Country = 'country',
  EndDate = 'endDate',
  InsForm4001FileAttachment = 'insForm4001FileAttachment',
  InspectionStatus = 'inspectionStatus',
  InspectorName = 'inspectorName',
  LetterOfFindingsFileAttachment = 'letterOfFindingsFileAttachment',
  ProjectStatus = 'projectStatus',
  Region = 'region',
  RegistrationMark = 'registrationMark',
  StartDate = 'startDate',
  State = 'state',
  ValidityPeriod = 'validityPeriod'
}

export type Inspectors = {
  inspectors: Array<Inspector>;
};

export type InspectorsResult = Inspectors | PaginatedInspectors;

export enum InspectorsSortBy {
  AppointmentLetterExpirationDate = 'appointmentLetterExpirationDate',
  Country = 'country',
  DisplayName = 'displayName',
  FirstName = 'firstName',
  InspectorCategory = 'inspectorCategory',
  InspectorCategoryType = 'inspectorCategoryType',
  InspectorType = 'inspectorType',
  IsActive = 'isActive',
  LastName = 'lastName',
  Region = 'region',
  ServiceAgreementExpirationDate = 'serviceAgreementExpirationDate'
}

export type Invoice = {
  aircraftProjects: Array<AircraftProject>;
  createdByUser: User;
  crewProjects: Array<CrewProject>;
  fileAttachment: FileAttachment;
  id: Scalars['Int'];
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceNumber: Scalars['String'];
  isArgInvoice: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  mechanicProjects: Array<MechanicProject>;
  notes?: Maybe<Scalars['String']>;
  paymentStatus: PaymentStatus;
};

export type Invoices = {
  invoices: Array<Invoice>;
};

export type InvoicesResult = Invoices | PaginatedInvoices;

export enum InvoicesSortBy {
  CreatedBy = 'createdBy',
  InvoiceDate = 'invoiceDate',
  InvoiceNumber = 'invoiceNumber',
  IsArgInvoice = 'isArgInvoice',
  PaymentStatus = 'paymentStatus'
}

export type ListManagementAircraftEngineManufacturers = {
  items: Array<AircraftEngineManufacturer>;
  totalItems: Scalars['Int'];
};

export type ListManagementAircraftManufacturers = {
  items: Array<AircraftManufacturer>;
  totalItems: Scalars['Int'];
};

export type ListManagementAircraftModels = {
  items: Array<AircraftModel>;
  totalItems: Scalars['Int'];
};

export type ListManagementAircraftPropellerManufacturers = {
  items: Array<AircraftPropellerManufacturer>;
  totalItems: Scalars['Int'];
};

export type ListManagementCrewRatings = {
  items: Array<CrewRating>;
  totalItems: Scalars['Int'];
};

export type ListManagementEmploymentCompanies = {
  items: Array<EmploymentCompany>;
  totalItems: Scalars['Int'];
};

export type ListManagementGenericLvCompanies = {
  items: Array<GenericLvCompany>;
  totalItems: Scalars['Int'];
};

export type ListManagementLookupConsolidationInput = {
  modifyTo?: Maybe<Scalars['String']>;
  selectedIds?: Maybe<Array<Scalars['Int']>>;
};

export type ListManagementMechanicRatings = {
  items: Array<MechanicRating>;
  totalItems: Scalars['Int'];
};

export type Mechanic = {
  activeMechanicProjects: Array<MechanicProject>;
  aircrafts: Array<Aircraft>;
  certificateDateOfFirstIssue?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate?: Maybe<Scalars['DateTime']>;
  certificateIssuedDate?: Maybe<Scalars['DateTime']>;
  country: Country;
  documents: Array<MechanicDocument>;
  documentTypes: Array<DocumentType>;
  employmentCompanies: Array<EmploymentCompany>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  licenseNumber: Scalars['String'];
  mechanicLicenseType: MechanicLicenseType;
  mechanicPosition: MechanicPosition;
  mechanicProjects: Array<MechanicProject>;
  mechanicRatings: Array<MechanicRating>;
  mechanicStatus: MechanicStatus;
  numberOfNonInactiveAircraft: Scalars['Int'];
  operators: Array<Operator>;
  totalNewComments: Scalars['Int'];
  validationNumber?: Maybe<Scalars['String']>;
};


export type MechanicAircraftsArgs = {
  aircraftStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  allWeatherOpsAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  baseOfOperationsCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  cOfAStatus?: Maybe<Scalars['String']>;
  cOfRStatus?: Maybe<Scalars['String']>;
  cpdlcAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  designatedAirspaceAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  efbAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  etopsAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  excludeDeregistered?: Maybe<Scalars['Boolean']>;
  hasCertificateOfAirworthinessExpirationDate?: Maybe<Scalars['Boolean']>;
  hascertificateOfInsuranceExpirationDate?: Maybe<Scalars['Boolean']>;
  hasCertificateOfRegistrationExpirationDate?: Maybe<Scalars['Boolean']>;
  hasLeaseAgreementExpirationDate?: Maybe<Scalars['Boolean']>;
  hasManagementAgreementExpirationDate?: Maybe<Scalars['Boolean']>;
  homeBaseCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  hudAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  includeProvisional?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  mtowMaximum?: Maybe<Scalars['Int']>;
  mtowMinimum?: Maybe<Scalars['Int']>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  operatorIdNullOrIn?: Maybe<Array<Scalars['Int']>>;
  ownerIdIn?: Maybe<Array<Scalars['Int']>>;
  registeredHolderIdIn?: Maybe<Array<Scalars['Int']>>;
  registrationMarkContains?: Maybe<Scalars['String']>;
  sortBy?: Maybe<AircraftsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type MechanicDocumentsArgs = {
  documentTypeCategoryId?: Maybe<Scalars['Float']>;
};


export type MechanicDocumentTypesArgs = {
  documentTypeCategoryId?: Maybe<Scalars['Float']>;
};


export type MechanicEmploymentCompaniesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type MechanicMechanicRatingsArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};

export type MechanicCertificateType = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type MechanicCertificateValidationInfoV1 = {
  documentValidityId: Scalars['Int'];
  documentValidityName: Scalars['String'];
};

export type MechanicCertificateValidationInfoV1Result = {
  isQrCodeValid: Scalars['Boolean'];
  validationInfo?: Maybe<MechanicCertificateValidationInfoV1>;
};

export type MechanicDocument = {
  document: Document;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
};

export type MechanicLicenseType = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  isForCertificateOnly: Scalars['Boolean'];
  mechanicPositions: Array<MechanicPosition>;
  name: Scalars['String'];
};

export type MechanicPosition = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  mechanicLicenseTypes: Array<MechanicLicenseType>;
  name: Scalars['String'];
};


export type MechanicPositionMechanicLicenseTypesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  mechanicPositionIdIn?: Maybe<Array<Scalars['Int']>>;
};

export type MechanicProject = {
  aircrafts: Array<Aircraft>;
  archivedDate?: Maybe<Scalars['DateTime']>;
  assignees: Array<User>;
  associatedAircraftProject?: Maybe<AircraftProject>;
  canToggleInsFormDcaApproved: Scalars['Boolean'];
  certificateDateOfIssue?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate?: Maybe<Scalars['DateTime']>;
  certificateFirstIssuedDate?: Maybe<Scalars['DateTime']>;
  clientSubmissionDate?: Maybe<Scalars['DateTime']>;
  country: Country;
  dcaApprovedByUser?: Maybe<User>;
  dcaHoldDate: Scalars['DateTime'];
  dcaHoldReason?: Maybe<Scalars['String']>;
  dcaLastUpdatedDate?: Maybe<Scalars['DateTime']>;
  dcaProjectNumber?: Maybe<Scalars['String']>;
  dcaReviewerUser?: Maybe<User>;
  dcaSentForApprovalByUser?: Maybe<User>;
  dcaSubmissionDate?: Maybe<Scalars['DateTime']>;
  dcaValidationIssueBasedOnLine1?: Maybe<Scalars['String']>;
  dcaValidationIssueBasedOnLine2?: Maybe<Scalars['String']>;
  documents: Array<MechanicProjectDocument>;
  documentTypeOfficialLetterNotes: Array<ProjectDocumentTypeOfficialLetterNote>;
  documentTypes: Array<DocumentType>;
  emails: Array<Email>;
  employmentCompanies: Array<EmploymentCompany>;
  firstIssueMechanicProject?: Maybe<MechanicProject>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  insForms: Array<ProjectInsFormVersion>;
  insFormsExclusiveGroups: Array<ProjectInsFormVersionExclusiveGroup>;
  isArgInvoiced: Scalars['Boolean'];
  isDcaInvoiced: Scalars['Boolean'];
  isHighImportance: Scalars['Boolean'];
  isNoDcaInvoiceRequired: Scalars['Boolean'];
  isOnHold: Scalars['Boolean'];
  isOnHoldByDca: Scalars['Boolean'];
  isPendingDocsFromIaso: Scalars['Boolean'];
  isPendingLicenseVerification: Scalars['Boolean'];
  isPendingOther: Scalars['Boolean'];
  lastName: Scalars['String'];
  licenseNumber: Scalars['String'];
  mechanic: Mechanic;
  mechanicCertificateType: MechanicCertificateType;
  mechanicLicenseType: MechanicLicenseType;
  mechanicPosition: MechanicPosition;
  mechanicProjectNameForInvoicing: Scalars['String'];
  mechanicProjectRenewalTypes: Array<MechanicProjectRenewalChangeType>;
  mechanicProjectType: MechanicProjectType;
  mechanicRatings: Array<MechanicRating>;
  officialLetterDocumentsNote?: Maybe<Scalars['String']>;
  operators: Array<Operator>;
  pendingReason?: Maybe<Scalars['String']>;
  projectCreatedByUser: User;
  projectCreationDate: Scalars['DateTime'];
  projectStage: ProjectStage;
  projectStatus: ProjectStatus;
  provisionalAircraftRegistrationMarks?: Maybe<Scalars['String']>;
  provisionalOperatorNames?: Maybe<Scalars['String']>;
  totalNewComments: Scalars['Int'];
  totalNewDcaComments: Scalars['Int'];
  turnaroundDays?: Maybe<Scalars['Int']>;
  validationNumber?: Maybe<Scalars['String']>;
};


export type MechanicProjectAircraftsArgs = {
  aircraftStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  allWeatherOpsAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  baseOfOperationsCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  cOfAStatus?: Maybe<Scalars['String']>;
  cOfRStatus?: Maybe<Scalars['String']>;
  cpdlcAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  designatedAirspaceAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  efbAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  etopsAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  excludeDeregistered?: Maybe<Scalars['Boolean']>;
  hasCertificateOfAirworthinessExpirationDate?: Maybe<Scalars['Boolean']>;
  hascertificateOfInsuranceExpirationDate?: Maybe<Scalars['Boolean']>;
  hasCertificateOfRegistrationExpirationDate?: Maybe<Scalars['Boolean']>;
  hasLeaseAgreementExpirationDate?: Maybe<Scalars['Boolean']>;
  hasManagementAgreementExpirationDate?: Maybe<Scalars['Boolean']>;
  homeBaseCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  hudAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  includeProvisional?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  mtowMaximum?: Maybe<Scalars['Int']>;
  mtowMinimum?: Maybe<Scalars['Int']>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  operatorIdNullOrIn?: Maybe<Array<Scalars['Int']>>;
  ownerIdIn?: Maybe<Array<Scalars['Int']>>;
  registeredHolderIdIn?: Maybe<Array<Scalars['Int']>>;
  registrationMarkContains?: Maybe<Scalars['String']>;
  sortBy?: Maybe<AircraftsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type MechanicProjectDocumentsArgs = {
  documentTypeCategoryId?: Maybe<Scalars['Float']>;
};


export type MechanicProjectDocumentTypesArgs = {
  documentTypeCategoryId?: Maybe<Scalars['Float']>;
};


export type MechanicProjectEmailsArgs = {
  filter?: Maybe<MechanicProjectEmailsFilter>;
};


export type MechanicProjectEmploymentCompaniesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type MechanicProjectMechanicProjectRenewalTypesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  mechanicProjectId?: Maybe<Scalars['Int']>;
};


export type MechanicProjectMechanicRatingsArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};

export type MechanicProjectCertificate = {
  assignees: Array<User>;
  certificateDateOfIssue?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate?: Maybe<Scalars['DateTime']>;
  certificateFirstIssuedDate?: Maybe<Scalars['DateTime']>;
  certificateType: MechanicCertificateType;
  clientSubmissionDate?: Maybe<Scalars['DateTime']>;
  country: Country;
  dcaAircraftList?: Maybe<Scalars['String']>;
  dcaApprovedByUser?: Maybe<User>;
  dcaAuthorizationLimitedTo?: Maybe<Scalars['String']>;
  dcaLastUpdatedDate?: Maybe<Scalars['DateTime']>;
  dcaMechanicRatingsList?: Maybe<Scalars['String']>;
  dcaProjectNumber?: Maybe<Scalars['String']>;
  dcaReviewerUser?: Maybe<User>;
  dcaSentForApprovalByUser?: Maybe<User>;
  dcaSubmissionDate?: Maybe<Scalars['DateTime']>;
  dcaValidationIssueBasedOnLine1?: Maybe<Scalars['String']>;
  dcaValidationIssueBasedOnLine2?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  licenseNumber: Scalars['String'];
  mechanicLicenseType: MechanicLicenseType;
  mechanicPosition: MechanicPosition;
  mechanicProjectRenewalTypes: Array<MechanicProjectRenewalChangeType>;
  mechanicProjectType: MechanicProjectType;
  projectStatusId: Scalars['Int'];
  turnaroundDays?: Maybe<Scalars['Int']>;
  validationNumber?: Maybe<Scalars['String']>;
  validationRestrictedTo?: Maybe<Scalars['String']>;
};


export type MechanicProjectCertificateMechanicProjectRenewalTypesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  mechanicProjectId?: Maybe<Scalars['Int']>;
};

export type MechanicProjectDocument = {
  document: Document;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  isReleasedToDca: Scalars['Boolean'];
};

export type MechanicProjectEmailsFilter = {
  /** List of email ID's to filter by */
  id_in?: Maybe<Array<Scalars['Int']>>;
};

export type MechanicProjectHistoryFilter = {
  dcaOnly?: Maybe<Scalars['Boolean']>;
};

export type MechanicProjectRenewalChangeType = {
  abbreviation: Scalars['String'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type MechanicProjects = {
  mechanicProjects: Array<MechanicProject>;
};

export type MechanicProjectsResult = MechanicProjects | PaginatedMechanicProjects;

export enum MechanicProjectsSortBy {
  ArchivedDate = 'archivedDate',
  AssociatedAircraftProject = 'associatedAircraftProject',
  CertificateDateOfIssue = 'certificateDateOfIssue',
  CertificateExpiryDate = 'certificateExpiryDate',
  CertificateFirstIssuedDate = 'certificateFirstIssuedDate',
  ClientSubmissionDate = 'clientSubmissionDate',
  DcaApprovedByUser = 'dcaApprovedByUser',
  DcaProjectNumber = 'dcaProjectNumber',
  DcaReviewerUser = 'dcaReviewerUser',
  DcaSentForApprovalByUser = 'dcaSentForApprovalByUser',
  DcaSubmissionDate = 'dcaSubmissionDate',
  FirstName = 'firstName',
  Id = 'id',
  IsHighImportance = 'isHighImportance',
  LastName = 'lastName',
  MechanicLicenseType = 'mechanicLicenseType',
  MechanicPosition = 'mechanicPosition',
  ProjectCreationDate = 'projectCreationDate',
  ProjectStage = 'projectStage',
  ProjectStatus = 'projectStatus',
  ProjectStatusOrder = 'projectStatusOrder',
  Turnaround = 'turnaround',
  ValidationNumber = 'validationNumber'
}

export type MechanicProjectType = {
  abbreviation: Scalars['String'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type MechanicRating = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  listManagementActiveMechanics: Array<Mechanic>;
  listManagementOpenMechanicProjects: Array<MechanicProject>;
  listManagementSkippedMechanicProjects: Array<MechanicProject>;
  listManagementSkippedMechanics: Array<Mechanic>;
  name: Scalars['String'];
};

export type Mechanics = {
  mechanics: Array<Mechanic>;
};

export type MechanicsResult = Mechanics | PaginatedMechanics;

export enum MechanicsSortBy {
  CertificateExpiryDate = 'certificateExpiryDate',
  Country = 'country',
  FirstName = 'firstName',
  LastName = 'lastName',
  LicenseNumber = 'licenseNumber',
  MechanicLicenseType = 'mechanicLicenseType',
  MechanicPosition = 'mechanicPosition',
  MechanicStatus = 'mechanicStatus',
  ValidationNumber = 'validationNumber'
}

export type MechanicStatus = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type Mutation = {
  addAircraftComment: Comment;
  addAircraftDocument: AircraftOperatorDocument;
  addAircraftEngineManufacturer: AircraftEngineManufacturer;
  addAircraftInsFormAssociatedDocument: AircraftOperatorInsFormAssociatedDocument;
  addAircraftManufacturer: AircraftManufacturer;
  addAircraftModel: AircraftModel;
  addAircraftProject: AircraftProject;
  addAircraftProjectComment: Comment;
  addAircraftProjectDcaComment: Comment;
  addAircraftProjectDocument: AircraftProjectOperatorDocument;
  addAircraftProjectInsFormAssociatedDocument: AircraftProjectOperatorInsFormAssociatedDocument;
  addAircraftProjectInsFormVersionComment: Comment;
  addAircraftProjectInspectionComment: Comment;
  addAircraftPropellerManufacturer: AircraftPropellerManufacturer;
  addAmoProject: AmoProject;
  addAmoProjectAuditComment: Comment;
  addAmoProjectComment: Comment;
  addAmoProjectDcaComment: Comment;
  addAmoProjectDocument: AmoProjectDocument;
  addAmoProjectInsFormVersionComment: Comment;
  addCompanyComment: Comment;
  addCompanyContact: Contact;
  addCompanyDocument: CompanyDocument;
  addCrewMember: CrewMember;
  addCrewMemberComment: Comment;
  addCrewMemberDocument: CrewMemberDocument;
  addCrewProject: CrewProject;
  addCrewProjectComment: Comment;
  addCrewProjectDcaComment: Comment;
  addCrewProjectDocument: CrewProjectDocument;
  addCrewProjectInsFormVersionComment: Comment;
  addInspector: Inspector;
  addInspectorBlockedDate: InspectorBlockedDate;
  addInspectorComment: Comment;
  addInspectorDocument: InspectorDocument;
  addInvoice: Invoice;
  addMechanic: Mechanic;
  addMechanicComment: Comment;
  addMechanicDocument: MechanicDocument;
  addMechanicProject: MechanicProject;
  addMechanicProjectComment: Comment;
  addMechanicProjectDcaComment: Comment;
  addMechanicProjectDocument: MechanicProjectDocument;
  addMechanicProjectInsFormVersionComment: Comment;
  addOperator: Operator;
  addOwner: Owner;
  addRegisteredHolder: RegisteredHolder;
  addReminder: Reminder;
  addUser: User;
  approveAircraftProjectDocumentType: ProjectTransitionResult;
  bulkUpdateAircraftCrewMembers: Scalars['Boolean'];
  bulkUpdateCrewMemberStatus: BulkUpdateCrewMemberStatusResult;
  clearAircraftProjectInsFormVersionSignatureById: Scalars['Boolean'];
  clearAmoProjectInsFormVersionSignatureById: Scalars['Boolean'];
  clearCrewProjectInsFormVersionSignatureByExecutionKey: Scalars['Boolean'];
  clearCrewProjectInsFormVersionSignatureById: Scalars['Boolean'];
  clearMechanicProjectInsFormVersionSignatureByExecutionKey: Scalars['Boolean'];
  clearMechanicProjectInsFormVersionSignatureById: Scalars['Boolean'];
  completeAircraftProjectTask: ProjectTransitionResult;
  completeCrewProjectTask: CrewProject;
  completeMechanicProjectTask: MechanicProject;
  consolidateAircraftEngineManufacturers: Scalars['Boolean'];
  consolidateAircraftManufacturers: Scalars['Boolean'];
  consolidateAircraftModels: Scalars['Boolean'];
  consolidateAircraftPropellerManufacturers: Scalars['Boolean'];
  consolidateCrewRatings: Scalars['Boolean'];
  consolidateEmploymentCompanies: Scalars['Boolean'];
  consolidateGenericLvCompanies: Scalars['Boolean'];
  consolidateMechanicRatings: Scalars['Boolean'];
  createBannerAlert: BannerAlert;
  dcaHoldAircraftProject: AircraftProject;
  dcaHoldAmoProject: AmoProject;
  dcaHoldCrewProject: CrewProject;
  dcaHoldMechanicProject: MechanicProject;
  dcaReleaseAircraftProject: AircraftProject;
  dcaReleaseAmoProject: AmoProject;
  dcaReleaseCrewProject: CrewProject;
  dcaReleaseMechanicProject: MechanicProject;
  deleteAircraftProject: IdResult;
  deleteAmoProject: IdResult;
  deleteCompanyContact: Scalars['Boolean'];
  deleteCrewProject: IdResult;
  deleteInvoice: Scalars['Boolean'];
  deleteMechanicProject: IdResult;
  deleteReminder: Reminder;
  holdAircraftProject: AircraftProject;
  holdAmoProject: AmoProject;
  holdCrewProject: CrewProject;
  holdMechanicProject: MechanicProject;
  operatorAddCrewProject: CrewProject;
  operatorAddCrewProjectSubmitted: CrewProject;
  operatorAddMechanicProject: MechanicProject;
  operatorAddMechanicProjectSubmitted: MechanicProject;
  releaseAircraftProject: AircraftProject;
  releaseAmoProject: AmoProject;
  releaseCrewProject: CrewProject;
  releaseMechanicProject: MechanicProject;
  removeAircraftDocument: Scalars['Boolean'];
  removeAircraftInsFormAssociatedDocument: Scalars['Boolean'];
  removeAircraftProjectDocument: Scalars['Boolean'];
  removeAircraftProjectInsFormAssociatedDocument: Scalars['Boolean'];
  removeAmoProjectDocument: Scalars['Boolean'];
  removeCompanyDocument: Scalars['Boolean'];
  removeCrewMemberDocument: Scalars['Boolean'];
  removeCrewProjectDocument: Scalars['Boolean'];
  removeInspectorBlockedDate: Scalars['Boolean'];
  removeInspectorDocument: Scalars['Boolean'];
  removeMechanicDocument: Scalars['Boolean'];
  removeMechanicProjectDocument: Scalars['Boolean'];
  reopenAircraftProjectDocumentTypeForApproval: ProjectTransitionResult;
  requestAircraftProjectDocumentDownloadToken: Scalars['String'];
  requestAircraftProjectInsFormAssociatedDocumentDownloadToken: Scalars['String'];
  requestCrewProjectDocumentDownloadToken: Scalars['String'];
  requestMechanicProjectDocumentDownloadToken: Scalars['String'];
  resendCrewProjectInsFormVersionForExecution: ProjectInsFormVersion;
  resendMechanicProjectInsFormVersionForExecution: ProjectInsFormVersion;
  returnAircraftProjectDocumentTypeForAdditionalReview: ProjectTransitionResult;
  revokeCrewProjectInsFormVersionExecution: ProjectInsFormVersion;
  revokeMechanicProjectInsFormVersionExecution: ProjectInsFormVersion;
  sendAircraftProjectBackToIaso: AircraftProject;
  sendAircraftProjectDocumentTypeForApproval: ProjectTransitionResult;
  sendAircraftProjectEmail: IdResult;
  sendAmoProjectBackToIaso: AmoProject;
  sendAmoProjectEmail: IdResult;
  sendCompanyEmail: IdResult;
  sendCrewProjectBackToIaso: CrewProject;
  sendCrewProjectEmail: IdResult;
  sendCrewProjectInsFormVersionForExecution: ProjectInsFormVersion;
  sendEmail: Scalars['Int'];
  sendInspectorEmail: IdResult;
  sendMechanicProjectBackToIaso: MechanicProject;
  sendMechanicProjectEmail: IdResult;
  sendMechanicProjectInsFormVersionForExecution: ProjectInsFormVersion;
  sendNewContactRequest: Operator;
  setAircraftProjectAssignees: IdResult;
  setAircraftProjectNoDcaInvoiceRequiredFlag: Scalars['Boolean'];
  setAircraftProjectPriority: IdResult;
  setAmoProjectAssignees: IdResult;
  setCrewProjectAssignees: IdResult;
  setCrewProjectNoDcaInvoiceRequiredFlag: Scalars['Boolean'];
  setCrewProjectPriority: IdResult;
  setMechanicProjectAssignees: IdResult;
  setMechanicProjectNoDcaInvoiceRequiredFlag: Scalars['Boolean'];
  setMechanicProjectPriority: IdResult;
  signAircraftProjectInsFormVersionById: Scalars['Boolean'];
  signAircraftProjectInsFormVersionByIdWithSignatureImage: SignProjectInsFormVersionResult;
  signAmoProjectInsFormVersionById: Scalars['Boolean'];
  signAmoProjectInsFormVersionByIdWithSignatureImage: SignProjectInsFormVersionResult;
  signCrewProjectInsFormVersionByExecutionKey: Scalars['Boolean'];
  signMechanicProjectInsFormVersionByExecutionKey: Scalars['Boolean'];
  toggleAircraftProjectCertificateIsApprovalRequired: Scalars['Boolean'];
  transitionAircraftProject: ProjectTransitionResult;
  transitionAmoProject: ProjectTransitionResult;
  transitionCrewProject: CrewProject;
  transitionMechanicProject: MechanicProject;
  updateAircraft: Aircraft;
  updateAircraftComment: Comment;
  updateAircraftCommentsLastViewedDate: IdResult;
  updateAircraftDocument: AircraftOperatorDocument;
  updateAircraftInsFormAssociatedDocument: AircraftOperatorInsFormAssociatedDocument;
  updateAircraftOperationalApproval: AircraftOperationalApproval;
  updateAircraftProject: UpdateAircraftProjectResult;
  updateAircraftProjectComment: Comment;
  updateAircraftProjectCommentsLastViewedDate: IdResult;
  updateAircraftProjectDcaComment: Comment;
  updateAircraftProjectDcaCommentsLastViewedDate: IdResult;
  updateAircraftProjectDocument: AircraftProjectOperatorDocument;
  updateAircraftProjectDocumentReleasedToDca: AircraftProjectOperatorDocument;
  updateAircraftProjectInsFormAssociatedDocument: AircraftProjectOperatorInsFormAssociatedDocument;
  updateAircraftProjectInsFormAssociatedDocumentReleasedToDca: AircraftProjectOperatorInsFormAssociatedDocument;
  updateAircraftProjectInsFormFieldComment: Scalars['Boolean'];
  updateAircraftProjectInsFormFieldComments: Scalars['Boolean'];
  updateAircraftProjectInsFormFieldValues: Scalars['Boolean'];
  updateAircraftProjectInsFormFieldValuesByExecutionKey: Scalars['Boolean'];
  updateAircraftProjectInsFormFileAttachment: ProjectInsFormVersion;
  updateAircraftProjectInsFormIsDcaApproved: Scalars['Boolean'];
  updateAircraftProjectInsFormReleasedToDca: ProjectInsFormVersion;
  updateAircraftProjectInsFormTrgApproval: ProjectInsFormVersion;
  updateAircraftProjectInsFormVersionComment: Comment;
  updateAircraftProjectInspectionComment: Comment;
  updateAircraftProjectInspectionCommentsLastViewedDate: IdResult;
  updateAircraftProjectInspectionInsForm16005A: Scalars['Boolean'];
  updateAircraftProjectInspectionInsForm4001: Scalars['Boolean'];
  updateAircraftProjectInspectionInsForm4007: Scalars['Boolean'];
  updateAircraftProjectInspectionInsForm4023B: Scalars['Boolean'];
  updateAircraftProjectInspectionInsForm4045: Scalars['Boolean'];
  updateAircraftProjectInspectionInspectionEstimate: Scalars['Boolean'];
  updateAircraftProjectInspectionInspectionInvoice: Scalars['Boolean'];
  updateAircraftProjectInspectionInspectionTimeLog: Scalars['Boolean'];
  updateAircraftProjectInspectionLetterOfFindings: Scalars['Boolean'];
  updateAircraftProjectInspections: Scalars['Boolean'];
  updateAircraftProjectOfficialLetterDocumentNotes: AircraftProject;
  updateAllAircraftProjectDocumentsReleasedToDca: Scalars['Boolean'];
  updateAllAircraftProjectInsFormsReleasedToDca: Scalars['Boolean'];
  updateAllAmoProjectDocumentsReleasedToDca: Scalars['Boolean'];
  updateAllAmoProjectInsFormsReleasedToDca: Scalars['Boolean'];
  updateAllCrewProjectDocumentsReleasedToDca: Scalars['Boolean'];
  updateAllMechanicProjectDocumentsReleasedToDca: Scalars['Boolean'];
  updateAmoProject: AmoProject;
  updateAmoProjectAuditComment: Comment;
  updateAmoProjectAuditCommentsLastViewedDate: IdResult;
  updateAmoProjectAudits: Scalars['Boolean'];
  updateAmoProjectComment: Comment;
  updateAmoProjectCommentsLastViewedDate: IdResult;
  updateAmoProjectDcaComment: Comment;
  updateAmoProjectDcaCommentsLastViewedDate: IdResult;
  updateAmoProjectDocument: AmoProjectDocument;
  updateAmoProjectDocumentReleasedToDca: AmoProjectDocument;
  updateAmoProjectInsFormFieldComment: Scalars['Boolean'];
  updateAmoProjectInsFormFieldComments: Scalars['Boolean'];
  updateAmoProjectInsFormFieldValues: Scalars['Boolean'];
  updateAmoProjectInsFormFileAttachment: ProjectInsFormVersion;
  updateAmoProjectInsFormIsDcaApproved: Scalars['Boolean'];
  updateAmoProjectInsFormReleasedToDca: ProjectInsFormVersion;
  updateAmoProjectInsFormTrgApproval: ProjectInsFormVersion;
  updateAmoProjectInsFormVersionComment: Comment;
  updateAmoProjectNoDcaInvoiceRequired: AmoProject;
  updateAmoProjectOfficialLetterNotes: AmoProject;
  updateAmoProjectPriority: AmoProject;
  updateCompanyComment: Comment;
  updateCompanyCommentsLastViewedDate: IdResult;
  updateCompanyContact: Contact;
  updateCompanyDocument: CompanyDocument;
  updateCrewMember: CrewMember;
  updateCrewMemberComment: Comment;
  updateCrewMemberCommentsLastViewedDate: IdResult;
  updateCrewMemberDocument: CrewMemberDocument;
  updateCrewProject: UpdateCrewProjectResult;
  updateCrewProjectCertificate: UpdateCrewProjectCertificateResult;
  updateCrewProjectComment: Comment;
  updateCrewProjectCommentsLastViewedDate: IdResult;
  updateCrewProjectDcaComment: Comment;
  updateCrewProjectDcaCommentsLastViewedDate: IdResult;
  updateCrewProjectDocument: CrewProjectDocument;
  updateCrewProjectDocumentReleasedToDca: CrewProjectDocument;
  updateCrewProjectInsFormFieldComment: Scalars['Boolean'];
  updateCrewProjectInsFormFieldComments: Scalars['Boolean'];
  updateCrewProjectInsFormFieldValues: Scalars['Boolean'];
  updateCrewProjectInsFormFieldValuesByExecutionKey: Scalars['Boolean'];
  updateCrewProjectInsFormFileAttachment: ProjectInsFormVersion;
  updateCrewProjectInsFormIsDcaApproved: Scalars['Boolean'];
  updateCrewProjectInsFormReleasedToDca: ProjectInsFormVersion;
  updateCrewProjectInsFormTrgApproval: ProjectInsFormVersion;
  updateCrewProjectInsFormVersionComment: Comment;
  updateCrewProjectOfficialLetterDocumentNotes: CrewProject;
  updateInspector: Inspector;
  updateInspectorBlockedDate: InspectorBlockedDate;
  updateInspectorComment: Comment;
  updateInspectorCommentsLastViewedDate: IdResult;
  updateInspectorDocument: InspectorDocument;
  updateInvoice: Invoice;
  updateMechanic: Mechanic;
  updateMechanicComment: Comment;
  updateMechanicCommentsLastViewedDate: IdResult;
  updateMechanicDocument: MechanicDocument;
  updateMechanicProject: UpdateMechanicProjectResult;
  updateMechanicProjectCertificate: UpdateMechanicProjectCertificateResult;
  updateMechanicProjectComment: Comment;
  updateMechanicProjectCommentsLastViewedDate: IdResult;
  updateMechanicProjectDcaComment: Comment;
  updateMechanicProjectDcaCommentsLastViewedDate: IdResult;
  updateMechanicProjectDocument: MechanicProjectDocument;
  updateMechanicProjectDocumentReleasedToDca: MechanicProjectDocument;
  updateMechanicProjectInsFormFieldComment: Scalars['Boolean'];
  updateMechanicProjectInsFormFieldComments: Scalars['Boolean'];
  updateMechanicProjectInsFormFieldValues: Scalars['Boolean'];
  updateMechanicProjectInsFormFieldValuesByExecutionKey: Scalars['Boolean'];
  updateMechanicProjectInsFormFileAttachment: ProjectInsFormVersion;
  updateMechanicProjectInsFormIsDcaApproved: Scalars['Boolean'];
  updateMechanicProjectInsFormReleasedToDca: ProjectInsFormVersion;
  updateMechanicProjectInsFormTrgApproval: ProjectInsFormVersion;
  updateMechanicProjectInsFormVersionComment: Comment;
  updateMechanicProjectOfficialLetterDocumentNotes: MechanicProject;
  updateOperator: Operator;
  updateOwner: Owner;
  updateProjectInsFormVersionCommentsLastViewedDate: IdResult;
  updateRegisteredHolder: RegisteredHolder;
  updateReminder: Reminder;
  updateUser: User;
  uploadFile: Scalars['Int'];
};


export type MutationAddAircraftCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddAircraftDocumentArgs = {
  addAircraftDocumentInput: AddAircraftDocumentInput;
};


export type MutationAddAircraftEngineManufacturerArgs = {
  addAircraftEngineManufacturerInput: AddAircraftEngineManufacturerInput;
};


export type MutationAddAircraftInsFormAssociatedDocumentArgs = {
  addAircraftInsFormAssociatedDocumentInput: AddAircraftInsFormAssociatedDocumentInput;
};


export type MutationAddAircraftManufacturerArgs = {
  addAircraftManufacturerInput: AddAircraftManufacturerInput;
};


export type MutationAddAircraftModelArgs = {
  addAircraftModelInput: AddAircraftModelInput;
};


export type MutationAddAircraftProjectArgs = {
  addAircraftProjectInput: AddAircraftProjectInput;
};


export type MutationAddAircraftProjectCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddAircraftProjectDcaCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddAircraftProjectDocumentArgs = {
  addAircraftProjectDocumentInput: AddAircraftProjectDocumentInput;
};


export type MutationAddAircraftProjectInsFormAssociatedDocumentArgs = {
  addAircraftProjectInsFormAssociatedDocumentInput: AddAircraftProjectInsFormAssociatedDocumentInput;
};


export type MutationAddAircraftProjectInsFormVersionCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddAircraftProjectInspectionCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddAircraftPropellerManufacturerArgs = {
  addAircraftPropellerManufacturerInput: AddAircraftPropellerManufacturerInput;
};


export type MutationAddAmoProjectArgs = {
  addAmoProjectInput: AddAmoProjectInput;
};


export type MutationAddAmoProjectAuditCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddAmoProjectCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddAmoProjectDcaCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddAmoProjectDocumentArgs = {
  addAmoProjectDocumentInput: AddAmoProjectDocumentInput;
};


export type MutationAddAmoProjectInsFormVersionCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddCompanyCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddCompanyContactArgs = {
  companyId: Scalars['Int'];
  input: ContactInput;
};


export type MutationAddCompanyDocumentArgs = {
  addCompanyDocumentInput: AddCompanyDocumentInput;
};


export type MutationAddCrewMemberArgs = {
  addCrewMemberInput: AddCrewMemberInput;
};


export type MutationAddCrewMemberCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddCrewMemberDocumentArgs = {
  addCrewMemberDocumentInput: AddCrewMemberDocumentInput;
};


export type MutationAddCrewProjectArgs = {
  addCrewProjectInput: AddCrewProjectInput;
};


export type MutationAddCrewProjectCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddCrewProjectDcaCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddCrewProjectDocumentArgs = {
  addCrewProjectDocumentInput: AddCrewProjectDocumentInput;
};


export type MutationAddCrewProjectInsFormVersionCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddInspectorArgs = {
  input: AddInspectorInput;
};


export type MutationAddInspectorBlockedDateArgs = {
  input: AddInspectorBlockedDateInput;
};


export type MutationAddInspectorCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddInspectorDocumentArgs = {
  addInspectorDocumentInput: AddInspectorDocumentInput;
};


export type MutationAddInvoiceArgs = {
  addInvoiceInput: AddInvoiceInput;
};


export type MutationAddMechanicArgs = {
  addMechanicInput: AddMechanicInput;
};


export type MutationAddMechanicCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddMechanicDocumentArgs = {
  addMechanicDocumentInput: AddMechanicDocumentInput;
};


export type MutationAddMechanicProjectArgs = {
  addMechanicProjectInput: AddMechanicProjectInput;
};


export type MutationAddMechanicProjectCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddMechanicProjectDcaCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddMechanicProjectDocumentArgs = {
  addMechanicProjectDocumentInput: AddMechanicProjectDocumentInput;
};


export type MutationAddMechanicProjectInsFormVersionCommentArgs = {
  id: Scalars['Int'];
  input: CommentInput;
};


export type MutationAddOperatorArgs = {
  input: OperatorInput;
};


export type MutationAddOwnerArgs = {
  input: OwnerInput;
};


export type MutationAddRegisteredHolderArgs = {
  input: RegisteredHolderInput;
};


export type MutationAddReminderArgs = {
  input: ReminderInput;
};


export type MutationAddUserArgs = {
  input: UserInput;
};


export type MutationApproveAircraftProjectDocumentTypeArgs = {
  aircraftProjectId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
};


export type MutationBulkUpdateAircraftCrewMembersArgs = {
  input: BulkUpdateAircraftCrewMembersInput;
};


export type MutationBulkUpdateCrewMemberStatusArgs = {
  input: BulkUpdateCrewMemberStatusInput;
};


export type MutationClearAircraftProjectInsFormVersionSignatureByIdArgs = {
  fieldNumber: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationClearAmoProjectInsFormVersionSignatureByIdArgs = {
  fieldNumber: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationClearCrewProjectInsFormVersionSignatureByExecutionKeyArgs = {
  executionKey: Scalars['String'];
  fieldNumber: Scalars['Int'];
};


export type MutationClearCrewProjectInsFormVersionSignatureByIdArgs = {
  fieldNumber: Scalars['Int'];
  projectInsFormVersionId: Scalars['Int'];
};


export type MutationClearMechanicProjectInsFormVersionSignatureByExecutionKeyArgs = {
  executionKey: Scalars['String'];
  fieldNumber: Scalars['Int'];
};


export type MutationClearMechanicProjectInsFormVersionSignatureByIdArgs = {
  fieldNumber: Scalars['Int'];
  projectInsFormVersionId: Scalars['Int'];
};


export type MutationCompleteAircraftProjectTaskArgs = {
  input: CompleteAircraftProjectTaskInput;
};


export type MutationCompleteCrewProjectTaskArgs = {
  input: CompleteCrewProjectTaskInput;
};


export type MutationCompleteMechanicProjectTaskArgs = {
  input: CompleteMechanicProjectTaskInput;
};


export type MutationConsolidateAircraftEngineManufacturersArgs = {
  input: ListManagementLookupConsolidationInput;
};


export type MutationConsolidateAircraftManufacturersArgs = {
  input: ListManagementLookupConsolidationInput;
};


export type MutationConsolidateAircraftModelsArgs = {
  input: ListManagementLookupConsolidationInput;
};


export type MutationConsolidateAircraftPropellerManufacturersArgs = {
  input: ListManagementLookupConsolidationInput;
};


export type MutationConsolidateCrewRatingsArgs = {
  input: ListManagementLookupConsolidationInput;
};


export type MutationConsolidateEmploymentCompaniesArgs = {
  input: ListManagementLookupConsolidationInput;
};


export type MutationConsolidateGenericLvCompaniesArgs = {
  input: ListManagementLookupConsolidationInput;
};


export type MutationConsolidateMechanicRatingsArgs = {
  input: ListManagementLookupConsolidationInput;
};


export type MutationCreateBannerAlertArgs = {
  input: BannerAlertInput;
};


export type MutationDcaHoldAircraftProjectArgs = {
  input: DcaHoldAircraftProjectInput;
};


export type MutationDcaHoldAmoProjectArgs = {
  input: DcaHoldAmoProjectInput;
};


export type MutationDcaHoldCrewProjectArgs = {
  input: DcaHoldCrewProjectInput;
};


export type MutationDcaHoldMechanicProjectArgs = {
  input: DcaHoldMechanicProjectInput;
};


export type MutationDcaReleaseAircraftProjectArgs = {
  id: Scalars['Int'];
};


export type MutationDcaReleaseAmoProjectArgs = {
  id: Scalars['Int'];
};


export type MutationDcaReleaseCrewProjectArgs = {
  id: Scalars['Int'];
};


export type MutationDcaReleaseMechanicProjectArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteAircraftProjectArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteAmoProjectArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteCompanyContactArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteCrewProjectArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteInvoiceArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteMechanicProjectArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteReminderArgs = {
  id: Scalars['Int'];
};


export type MutationHoldAircraftProjectArgs = {
  id: Scalars['Int'];
};


export type MutationHoldAmoProjectArgs = {
  id: Scalars['Int'];
};


export type MutationHoldCrewProjectArgs = {
  id: Scalars['Int'];
};


export type MutationHoldMechanicProjectArgs = {
  id: Scalars['Int'];
};


export type MutationOperatorAddCrewProjectArgs = {
  operatorAddCrewProjectInput: OperatorAddCrewProjectInput;
};


export type MutationOperatorAddCrewProjectSubmittedArgs = {
  id: Scalars['Int'];
};


export type MutationOperatorAddMechanicProjectArgs = {
  operatorAddMechanicProjectInput: OperatorAddMechanicProjectInput;
};


export type MutationOperatorAddMechanicProjectSubmittedArgs = {
  id: Scalars['Int'];
};


export type MutationReleaseAircraftProjectArgs = {
  id: Scalars['Int'];
};


export type MutationReleaseAmoProjectArgs = {
  id: Scalars['Int'];
};


export type MutationReleaseCrewProjectArgs = {
  id: Scalars['Int'];
};


export type MutationReleaseMechanicProjectArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveAircraftDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveAircraftInsFormAssociatedDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveAircraftProjectDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveAircraftProjectInsFormAssociatedDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveAmoProjectDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveCompanyDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveCrewMemberDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveCrewProjectDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveInspectorBlockedDateArgs = {
  inspectorBlockedDateId: Scalars['Int'];
};


export type MutationRemoveInspectorDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveMechanicDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveMechanicProjectDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationReopenAircraftProjectDocumentTypeForApprovalArgs = {
  aircraftProjectId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
};


export type MutationRequestAircraftProjectDocumentDownloadTokenArgs = {
  aircraftProjectId: Scalars['Int'];
  downloadFileName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type MutationRequestAircraftProjectInsFormAssociatedDocumentDownloadTokenArgs = {
  aircraftProjectId: Scalars['Int'];
  downloadFileName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type MutationRequestCrewProjectDocumentDownloadTokenArgs = {
  downloadFileName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type MutationRequestMechanicProjectDocumentDownloadTokenArgs = {
  downloadFileName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type MutationResendCrewProjectInsFormVersionForExecutionArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type MutationResendMechanicProjectInsFormVersionForExecutionArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type MutationReturnAircraftProjectDocumentTypeForAdditionalReviewArgs = {
  aircraftProjectId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
};


export type MutationRevokeCrewProjectInsFormVersionExecutionArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type MutationRevokeMechanicProjectInsFormVersionExecutionArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type MutationSendAircraftProjectBackToIasoArgs = {
  input: SendAircraftProjectToIasoInput;
};


export type MutationSendAircraftProjectDocumentTypeForApprovalArgs = {
  aircraftProjectId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
};


export type MutationSendAircraftProjectEmailArgs = {
  aircraftProjectId: Scalars['Int'];
  email: EmailInput;
};


export type MutationSendAmoProjectBackToIasoArgs = {
  input: SendAmoProjectToIasoInput;
};


export type MutationSendAmoProjectEmailArgs = {
  amoProjectId: Scalars['Int'];
  email: EmailInput;
};


export type MutationSendCompanyEmailArgs = {
  companyId: Scalars['Int'];
  email: EmailInput;
};


export type MutationSendCrewProjectBackToIasoArgs = {
  input: SendCrewProjectToIasoInput;
};


export type MutationSendCrewProjectEmailArgs = {
  crewProjectId: Scalars['Int'];
  email: EmailInput;
};


export type MutationSendCrewProjectInsFormVersionForExecutionArgs = {
  input: SendForExecutionInput;
};


export type MutationSendEmailArgs = {
  email: EmailInput;
};


export type MutationSendInspectorEmailArgs = {
  email: EmailInput;
  inspectorId: Scalars['Int'];
};


export type MutationSendMechanicProjectBackToIasoArgs = {
  input: SendMechanicProjectToIasoInput;
};


export type MutationSendMechanicProjectEmailArgs = {
  email: EmailInput;
  mechanicProjectId: Scalars['Int'];
};


export type MutationSendMechanicProjectInsFormVersionForExecutionArgs = {
  input: SendForExecutionInput;
};


export type MutationSendNewContactRequestArgs = {
  input: NewContactRequestInput;
};


export type MutationSetAircraftProjectAssigneesArgs = {
  aircraftProjectId: Scalars['Int'];
  assigneeUserIds: Array<Scalars['Int']>;
};


export type MutationSetAircraftProjectNoDcaInvoiceRequiredFlagArgs = {
  id: Scalars['Int'];
  isNoDcaInvoiceRequired: Scalars['Boolean'];
};


export type MutationSetAircraftProjectPriorityArgs = {
  id: Scalars['Int'];
  isHighPriority: Scalars['Boolean'];
};


export type MutationSetAmoProjectAssigneesArgs = {
  amoProjectId: Scalars['Int'];
  assigneeUserIds: Array<Scalars['Int']>;
};


export type MutationSetCrewProjectAssigneesArgs = {
  assigneeUserIds: Array<Scalars['Int']>;
  crewProjectId: Scalars['Int'];
};


export type MutationSetCrewProjectNoDcaInvoiceRequiredFlagArgs = {
  id: Scalars['Int'];
  isNoDcaInvoiceRequired: Scalars['Boolean'];
};


export type MutationSetCrewProjectPriorityArgs = {
  id: Scalars['Int'];
  isHighPriority: Scalars['Boolean'];
};


export type MutationSetMechanicProjectAssigneesArgs = {
  assigneeUserIds: Array<Scalars['Int']>;
  mechanicProjectId: Scalars['Int'];
};


export type MutationSetMechanicProjectNoDcaInvoiceRequiredFlagArgs = {
  id: Scalars['Int'];
  isNoDcaInvoiceRequired: Scalars['Boolean'];
};


export type MutationSetMechanicProjectPriorityArgs = {
  id: Scalars['Int'];
  isHighPriority: Scalars['Boolean'];
};


export type MutationSignAircraftProjectInsFormVersionByIdArgs = {
  id: Scalars['Int'];
  input: SignProjectInsFormVersionInput;
};


export type MutationSignAircraftProjectInsFormVersionByIdWithSignatureImageArgs = {
  id: Scalars['Int'];
  input: SignProjectInsFormVersionInputWithSignatureImageInput;
};


export type MutationSignAmoProjectInsFormVersionByIdArgs = {
  id: Scalars['Int'];
  input: SignProjectInsFormVersionInput;
};


export type MutationSignAmoProjectInsFormVersionByIdWithSignatureImageArgs = {
  id: Scalars['Int'];
  input: SignProjectInsFormVersionInputWithSignatureImageInput;
};


export type MutationSignCrewProjectInsFormVersionByExecutionKeyArgs = {
  executionKey: Scalars['String'];
  input: SignProjectInsFormVersionInput;
};


export type MutationSignMechanicProjectInsFormVersionByExecutionKeyArgs = {
  executionKey: Scalars['String'];
  input: SignProjectInsFormVersionInput;
};


export type MutationToggleAircraftProjectCertificateIsApprovalRequiredArgs = {
  aircraftProjectId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
};


export type MutationTransitionAircraftProjectArgs = {
  input: TransitionProjectInput;
};


export type MutationTransitionAmoProjectArgs = {
  input: TransitionProjectInput;
};


export type MutationTransitionCrewProjectArgs = {
  input: TransitionProjectInput;
};


export type MutationTransitionMechanicProjectArgs = {
  input: TransitionProjectInput;
};


export type MutationUpdateAircraftArgs = {
  input: UpdateAircraftInput;
};


export type MutationUpdateAircraftCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateAircraftCommentsLastViewedDateArgs = {
  aircraftId: Scalars['Int'];
};


export type MutationUpdateAircraftDocumentArgs = {
  updateAircraftDocumentInput: UpdateAircraftDocumentInput;
};


export type MutationUpdateAircraftInsFormAssociatedDocumentArgs = {
  updateAircraftInsFormAssociatedDocumentInput: UpdateAircraftInsFormAssociatedDocumentInput;
};


export type MutationUpdateAircraftOperationalApprovalArgs = {
  input: UpdateAircraftOperationalApprovalInput;
};


export type MutationUpdateAircraftProjectArgs = {
  ignoreWarnings: Scalars['Boolean'];
  updateAircraftProjectInput: UpdateAircraftProjectInput;
};


export type MutationUpdateAircraftProjectCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateAircraftProjectCommentsLastViewedDateArgs = {
  aircraftProjectId: Scalars['Int'];
};


export type MutationUpdateAircraftProjectDcaCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateAircraftProjectDcaCommentsLastViewedDateArgs = {
  aircraftProjectId: Scalars['Int'];
};


export type MutationUpdateAircraftProjectDocumentArgs = {
  updateAircraftProjectDocumentInput: UpdateAircraftProjectDocumentInput;
};


export type MutationUpdateAircraftProjectDocumentReleasedToDcaArgs = {
  input: UpdateAircraftProjectOperatorDocumentReleasedToDcaInput;
};


export type MutationUpdateAircraftProjectInsFormAssociatedDocumentArgs = {
  updateAircraftProjectInsFormAssociatedDocumentInput: UpdateAircraftProjectInsFormAssociatedDocumentInput;
};


export type MutationUpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaArgs = {
  input: UpdateAircraftProjectOperatorInsFormAssociatedDocumentReleasedToDcaInput;
};


export type MutationUpdateAircraftProjectInsFormFieldCommentArgs = {
  input: UpdateProjectInsFormVersionFieldCommentInput;
};


export type MutationUpdateAircraftProjectInsFormFieldCommentsArgs = {
  input: UpdateProjectInsFormVersionFieldCommentsInput;
};


export type MutationUpdateAircraftProjectInsFormFieldValuesArgs = {
  input: UpdateProjectInsFormVersionFieldValuesInput;
};


export type MutationUpdateAircraftProjectInsFormFieldValuesByExecutionKeyArgs = {
  fieldValues: Array<UpdateProjectInsFormVersionFieldValueInput>;
  key: Scalars['String'];
};


export type MutationUpdateAircraftProjectInsFormFileAttachmentArgs = {
  input: UpdateProjectInsFormVersionFileAttachmentInput;
};


export type MutationUpdateAircraftProjectInsFormIsDcaApprovedArgs = {
  input: UpdateProjectInsFormIsDcaApprovedInput;
};


export type MutationUpdateAircraftProjectInsFormReleasedToDcaArgs = {
  input: UpdateProjectInsFormVersionReleasedToDcaInput;
};


export type MutationUpdateAircraftProjectInsFormTrgApprovalArgs = {
  input: UpdateProjectInsFormVersionTrgApprovalInput;
};


export type MutationUpdateAircraftProjectInsFormVersionCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateAircraftProjectInspectionCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateAircraftProjectInspectionCommentsLastViewedDateArgs = {
  aircraftProjectOperatorInspectionMapId: Scalars['Int'];
};


export type MutationUpdateAircraftProjectInspectionInsForm16005AArgs = {
  input: UpdateAircraftProjectInspectionInsForm16005AInput;
};


export type MutationUpdateAircraftProjectInspectionInsForm4001Args = {
  input: UpdateAircraftProjectInspectionInsForm4001Input;
};


export type MutationUpdateAircraftProjectInspectionInsForm4007Args = {
  input: UpdateAircraftProjectInspectionInsForm4007Input;
};


export type MutationUpdateAircraftProjectInspectionInsForm4023BArgs = {
  input: UpdateAircraftProjectInspectionInsForm4023BInput;
};


export type MutationUpdateAircraftProjectInspectionInsForm4045Args = {
  input: UpdateAircraftProjectInspectionInsForm4045Input;
};


export type MutationUpdateAircraftProjectInspectionInspectionEstimateArgs = {
  input: UpdateAircraftProjectInspectionInspectionEstimateInput;
};


export type MutationUpdateAircraftProjectInspectionInspectionInvoiceArgs = {
  input: UpdateAircraftProjectInspectionInspectionInvoiceInput;
};


export type MutationUpdateAircraftProjectInspectionInspectionTimeLogArgs = {
  input: UpdateAircraftProjectInspectionInspectionTimeLogInput;
};


export type MutationUpdateAircraftProjectInspectionLetterOfFindingsArgs = {
  input: UpdateAircraftProjectInspectionLetterOfFindingsInput;
};


export type MutationUpdateAircraftProjectInspectionsArgs = {
  input: UpdateAircraftProjectInspectionsInput;
};


export type MutationUpdateAircraftProjectOfficialLetterDocumentNotesArgs = {
  input: UpdateAircraftProjectOfficialLetterNotesInput;
};


export type MutationUpdateAllAircraftProjectDocumentsReleasedToDcaArgs = {
  input: UpdateAllAircraftProjectOperatorDocumentsReleasedToDcaInput;
};


export type MutationUpdateAllAircraftProjectInsFormsReleasedToDcaArgs = {
  input: UpdateAllProjectInsFormVersionsReleasedToDcaInput;
};


export type MutationUpdateAllAmoProjectDocumentsReleasedToDcaArgs = {
  input: UpdateAllAmoProjectDocumentsReleasedToDcaInput;
};


export type MutationUpdateAllAmoProjectInsFormsReleasedToDcaArgs = {
  input: UpdateAllProjectInsFormVersionsReleasedToDcaInput;
};


export type MutationUpdateAllCrewProjectDocumentsReleasedToDcaArgs = {
  input: UpdateAllCrewProjectDocumentsReleasedToDcaInput;
};


export type MutationUpdateAllMechanicProjectDocumentsReleasedToDcaArgs = {
  input: UpdateAllMechanicProjectDocumentsReleasedToDcaInput;
};


export type MutationUpdateAmoProjectArgs = {
  updateAmoProjectInput: UpdateAmoProjectInput;
};


export type MutationUpdateAmoProjectAuditCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateAmoProjectAuditCommentsLastViewedDateArgs = {
  amoProjectAuditMapId: Scalars['Int'];
};


export type MutationUpdateAmoProjectAuditsArgs = {
  input: UpdateAmoProjectAuditsInput;
};


export type MutationUpdateAmoProjectCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateAmoProjectCommentsLastViewedDateArgs = {
  amoProjectId: Scalars['Int'];
};


export type MutationUpdateAmoProjectDcaCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateAmoProjectDcaCommentsLastViewedDateArgs = {
  amoProjectId: Scalars['Int'];
};


export type MutationUpdateAmoProjectDocumentArgs = {
  updateAmoProjectDocumentInput: UpdateAmoProjectDocumentInput;
};


export type MutationUpdateAmoProjectDocumentReleasedToDcaArgs = {
  input: UpdateAmoProjectDocumentReleasedToDcaInput;
};


export type MutationUpdateAmoProjectInsFormFieldCommentArgs = {
  input: UpdateProjectInsFormVersionFieldCommentInput;
};


export type MutationUpdateAmoProjectInsFormFieldCommentsArgs = {
  input: UpdateProjectInsFormVersionFieldCommentsInput;
};


export type MutationUpdateAmoProjectInsFormFieldValuesArgs = {
  input: UpdateProjectInsFormVersionFieldValuesInput;
};


export type MutationUpdateAmoProjectInsFormFileAttachmentArgs = {
  input: UpdateProjectInsFormVersionFileAttachmentInput;
};


export type MutationUpdateAmoProjectInsFormIsDcaApprovedArgs = {
  input: UpdateProjectInsFormIsDcaApprovedInput;
};


export type MutationUpdateAmoProjectInsFormReleasedToDcaArgs = {
  input: UpdateProjectInsFormVersionReleasedToDcaInput;
};


export type MutationUpdateAmoProjectInsFormTrgApprovalArgs = {
  input: UpdateProjectInsFormVersionTrgApprovalInput;
};


export type MutationUpdateAmoProjectInsFormVersionCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateAmoProjectNoDcaInvoiceRequiredArgs = {
  id: Scalars['Int'];
};


export type MutationUpdateAmoProjectOfficialLetterNotesArgs = {
  input: UpdateAmoProjectOfficialLetterNotesInput;
};


export type MutationUpdateAmoProjectPriorityArgs = {
  id: Scalars['Int'];
};


export type MutationUpdateCompanyCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateCompanyCommentsLastViewedDateArgs = {
  companyId: Scalars['Int'];
};


export type MutationUpdateCompanyContactArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  input: ContactInput;
};


export type MutationUpdateCompanyDocumentArgs = {
  updateCompanyDocumentInput: UpdateCompanyDocumentInput;
};


export type MutationUpdateCrewMemberArgs = {
  updateCrewMemberInput: UpdateCrewMemberInput;
};


export type MutationUpdateCrewMemberCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateCrewMemberCommentsLastViewedDateArgs = {
  crewMemberId: Scalars['Int'];
};


export type MutationUpdateCrewMemberDocumentArgs = {
  updateCrewMemberDocumentInput: UpdateCrewMemberDocumentInput;
};


export type MutationUpdateCrewProjectArgs = {
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
  recordHistory?: Maybe<Scalars['Boolean']>;
  updateCrewProjectInput: UpdateCrewProjectInput;
};


export type MutationUpdateCrewProjectCertificateArgs = {
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
  input: UpdateCrewProjectCertificateInput;
  recordHistory?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateCrewProjectCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateCrewProjectCommentsLastViewedDateArgs = {
  crewProjectId: Scalars['Int'];
};


export type MutationUpdateCrewProjectDcaCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateCrewProjectDcaCommentsLastViewedDateArgs = {
  crewProjectId: Scalars['Int'];
};


export type MutationUpdateCrewProjectDocumentArgs = {
  updateCrewProjectDocumentInput: UpdateCrewProjectDocumentInput;
};


export type MutationUpdateCrewProjectDocumentReleasedToDcaArgs = {
  input: UpdateCrewProjectDocumentReleasedToDcaInput;
};


export type MutationUpdateCrewProjectInsFormFieldCommentArgs = {
  input: UpdateProjectInsFormVersionFieldCommentInput;
};


export type MutationUpdateCrewProjectInsFormFieldCommentsArgs = {
  input: UpdateProjectInsFormVersionFieldCommentsInput;
};


export type MutationUpdateCrewProjectInsFormFieldValuesArgs = {
  input: UpdateProjectInsFormVersionFieldValuesInput;
};


export type MutationUpdateCrewProjectInsFormFieldValuesByExecutionKeyArgs = {
  fieldValues: Array<UpdateProjectInsFormVersionFieldValueInput>;
  key: Scalars['String'];
};


export type MutationUpdateCrewProjectInsFormFileAttachmentArgs = {
  input: UpdateProjectInsFormVersionFileAttachmentInput;
};


export type MutationUpdateCrewProjectInsFormIsDcaApprovedArgs = {
  input: UpdateProjectInsFormIsDcaApprovedInput;
};


export type MutationUpdateCrewProjectInsFormReleasedToDcaArgs = {
  input: UpdateProjectInsFormVersionReleasedToDcaInput;
};


export type MutationUpdateCrewProjectInsFormTrgApprovalArgs = {
  input: UpdateProjectInsFormVersionTrgApprovalInput;
};


export type MutationUpdateCrewProjectInsFormVersionCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateCrewProjectOfficialLetterDocumentNotesArgs = {
  input: UpdateCrewProjectOfficialLetterNotesInput;
};


export type MutationUpdateInspectorArgs = {
  id: Scalars['Int'];
  input: InspectorInput;
};


export type MutationUpdateInspectorBlockedDateArgs = {
  input: UpdateInspectorBlockedDateInput;
};


export type MutationUpdateInspectorCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateInspectorCommentsLastViewedDateArgs = {
  inspectorId: Scalars['Int'];
};


export type MutationUpdateInspectorDocumentArgs = {
  updateInspectorDocumentInput: UpdateInspectorDocumentInput;
};


export type MutationUpdateInvoiceArgs = {
  updateInvoiceInput: UpdateInvoiceInput;
};


export type MutationUpdateMechanicArgs = {
  updateMechanicInput: UpdateMechanicInput;
};


export type MutationUpdateMechanicCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateMechanicCommentsLastViewedDateArgs = {
  mechanicId: Scalars['Int'];
};


export type MutationUpdateMechanicDocumentArgs = {
  updateMechanicDocumentInput: UpdateMechanicDocumentInput;
};


export type MutationUpdateMechanicProjectArgs = {
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
  recordHistory?: Maybe<Scalars['Boolean']>;
  updateMechanicProjectInput: UpdateMechanicProjectInput;
};


export type MutationUpdateMechanicProjectCertificateArgs = {
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
  input: UpdateMechanicProjectCertificateInput;
  recordHistory?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateMechanicProjectCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateMechanicProjectCommentsLastViewedDateArgs = {
  mechanicProjectId: Scalars['Int'];
};


export type MutationUpdateMechanicProjectDcaCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateMechanicProjectDcaCommentsLastViewedDateArgs = {
  mechanicProjectId: Scalars['Int'];
};


export type MutationUpdateMechanicProjectDocumentArgs = {
  updateMechanicProjectDocumentInput: UpdateMechanicProjectDocumentInput;
};


export type MutationUpdateMechanicProjectDocumentReleasedToDcaArgs = {
  input: UpdateMechanicProjectDocumentReleasedToDcaInput;
};


export type MutationUpdateMechanicProjectInsFormFieldCommentArgs = {
  input: UpdateProjectInsFormVersionFieldCommentInput;
};


export type MutationUpdateMechanicProjectInsFormFieldCommentsArgs = {
  input: UpdateProjectInsFormVersionFieldCommentsInput;
};


export type MutationUpdateMechanicProjectInsFormFieldValuesArgs = {
  input: UpdateProjectInsFormVersionFieldValuesInput;
};


export type MutationUpdateMechanicProjectInsFormFieldValuesByExecutionKeyArgs = {
  fieldValues: Array<UpdateProjectInsFormVersionFieldValueInput>;
  key: Scalars['String'];
};


export type MutationUpdateMechanicProjectInsFormFileAttachmentArgs = {
  input: UpdateProjectInsFormVersionFileAttachmentInput;
};


export type MutationUpdateMechanicProjectInsFormIsDcaApprovedArgs = {
  input: UpdateProjectInsFormIsDcaApprovedInput;
};


export type MutationUpdateMechanicProjectInsFormReleasedToDcaArgs = {
  input: UpdateProjectInsFormVersionReleasedToDcaInput;
};


export type MutationUpdateMechanicProjectInsFormTrgApprovalArgs = {
  input: UpdateProjectInsFormVersionTrgApprovalInput;
};


export type MutationUpdateMechanicProjectInsFormVersionCommentArgs = {
  body: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationUpdateMechanicProjectOfficialLetterDocumentNotesArgs = {
  input: UpdateMechanicProjectOfficialLetterNotesInput;
};


export type MutationUpdateOperatorArgs = {
  id: Scalars['Int'];
  input: OperatorInput;
};


export type MutationUpdateOwnerArgs = {
  id: Scalars['Int'];
  input: OwnerInput;
};


export type MutationUpdateProjectInsFormVersionCommentsLastViewedDateArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type MutationUpdateRegisteredHolderArgs = {
  id: Scalars['Int'];
  input: RegisteredHolderInput;
};


export type MutationUpdateReminderArgs = {
  id: Scalars['Int'];
  input: ReminderInput;
};


export type MutationUpdateUserArgs = {
  input: UserInput;
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload'];
};

export type NewContactRequestInput = {
  emailAddress?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  group?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  mobilePhoneNumber?: Maybe<Scalars['String']>;
  officePhoneNumber?: Maybe<Scalars['String']>;
  operatorId: Scalars['Int'];
};

export type OnboardingChecklist = {
  backpacks: Scalars['Boolean'];
  businessCard: Scalars['Boolean'];
  emails: Scalars['Boolean'];
  idCardIssued: Scalars['Boolean'];
};

export type Operator = {
  aircraft: Array<Aircraft>;
  company: Company;
  documentTypes: Array<DocumentType>;
  id: Scalars['Int'];
  includeInReminderEmails: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  numberOfNonInactiveAircraft: Scalars['Int'];
};


export type OperatorAircraftArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  operatorId?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<AircraftsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type OperatorDocumentTypesArgs = {
  documentTypeCategoryId?: Maybe<Scalars['Float']>;
};

export type OperatorAddCrewProjectInput = {
  countryId?: Maybe<Scalars['Int']>;
  crewLicenseTypeId?: Maybe<Scalars['Int']>;
  crewMemberId?: Maybe<Scalars['Int']>;
  crewPositionId?: Maybe<Scalars['Int']>;
  crewProjectCategoryId?: Maybe<Scalars['Int']>;
  crewProjectRenewalChangeTypeIds?: Maybe<Array<Scalars['Int']>>;
  crewProjectSpecialProjectTypeId?: Maybe<Scalars['Int']>;
  crewProjectTypeId?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
};

export type OperatorAddMechanicProjectInput = {
  countryId?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
  mechanicId?: Maybe<Scalars['Int']>;
  mechanicLicenseTypeId?: Maybe<Scalars['Int']>;
  mechanicPositionId?: Maybe<Scalars['Int']>;
  mechanicProjectRenewalChangeTypeIds?: Maybe<Array<Scalars['Int']>>;
  mechanicProjectTypeId?: Maybe<Scalars['Int']>;
};

export type OperatorInput = {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  corporateEmailAddress?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  goodStandingLetterIssueDate?: Maybe<Scalars['DateTime']>;
  includeInReminderEmails?: Maybe<Scalars['Boolean']>;
  incorporationDate?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAlsoOperator?: Maybe<Scalars['Boolean']>;
  isAlsoOwner?: Maybe<Scalars['Boolean']>;
  isAlsoRegisteredHolder?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<PhoneNumberInput>>;
  regionId?: Maybe<Scalars['Int']>;
  stateId?: Maybe<Scalars['Int']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type Operators = {
  operators: Array<Operator>;
};

export type OperatorsResult = Operators | PaginatedOperators;

export enum OperatorsSortBy {
  Country = 'country',
  IsActive = 'isActive',
  Name = 'name',
  OfacComplianceExpirationDate = 'ofacComplianceExpirationDate',
  Region = 'region',
  State = 'state'
}

export type Owner = {
  aircraft: Array<Aircraft>;
  company: Company;
  documentTypes: Array<DocumentType>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
};


export type OwnerAircraftArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  ownerId?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<AircraftsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type OwnerDocumentTypesArgs = {
  documentTypeCategoryId?: Maybe<Scalars['Float']>;
};

export type OwnerInput = {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  corporateEmailAddress?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  goodStandingLetterIssueDate?: Maybe<Scalars['DateTime']>;
  incorporationDate?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAlsoOperator?: Maybe<Scalars['Boolean']>;
  isAlsoOwner?: Maybe<Scalars['Boolean']>;
  isAlsoRegisteredHolder?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<PhoneNumberInput>>;
  regionId?: Maybe<Scalars['Int']>;
  stateId?: Maybe<Scalars['Int']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type Owners = {
  owners: Array<Owner>;
};

export type OwnersResult = Owners | PaginatedOwners;

export enum OwnersSortBy {
  Country = 'country',
  IsActive = 'isActive',
  Name = 'name',
  OfacComplianceExpirationDate = 'ofacComplianceExpirationDate',
  Region = 'region',
  State = 'state'
}

export type PaginatedAircraftProjects = {
  aircraftProjects: Array<AircraftProject>;
  totalItems: Scalars['Int'];
};

export type PaginatedAircrafts = {
  aircrafts: Array<Aircraft>;
  totalItems: Scalars['Int'];
};

export type PaginatedAmoProjects = {
  amoProjects: Array<AmoProject>;
  totalItems: Scalars['Int'];
};

export type PaginatedAmos = {
  amos: Array<Amo>;
  totalItems: Scalars['Int'];
};

export type PaginatedCrewMembers = {
  crewMembers: Array<CrewMember>;
  totalItems: Scalars['Int'];
};

export type PaginatedCrewProjects = {
  crewProjects: Array<CrewProject>;
  totalItems: Scalars['Int'];
};

export type PaginatedInspectorInspections = {
  inspectorInspections: Array<InspectorInspection>;
  totalItems: Scalars['Int'];
};

export type PaginatedInspectors = {
  inspectors: Array<Inspector>;
  totalItems: Scalars['Int'];
};

export type PaginatedInvoices = {
  invoices: Array<Invoice>;
  totalItems: Scalars['Int'];
};

export type PaginatedMechanicProjects = {
  mechanicProjects: Array<MechanicProject>;
  totalItems: Scalars['Int'];
};

export type PaginatedMechanics = {
  mechanics: Array<Mechanic>;
  totalItems: Scalars['Int'];
};

export type PaginatedOperators = {
  operators: Array<Operator>;
  totalItems: Scalars['Int'];
};

export type PaginatedOwners = {
  owners: Array<Owner>;
  totalItems: Scalars['Int'];
};

export type PaginatedRegisteredHolders = {
  registeredHolders: Array<RegisteredHolder>;
  totalItems: Scalars['Int'];
};

export type PaginatedUsers = {
  totalItems: Scalars['Int'];
  users: Array<User>;
};

export type PaginationOptions = {
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type PaymentStatus = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type PhoneNumber = {
  id: Scalars['Int'];
  phoneNumber: Scalars['String'];
  phoneNumberTypeId: Scalars['Int'];
};

export type PhoneNumberInput = {
  id?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberTypeId?: Maybe<Scalars['Int']>;
};

export type PhoneNumberType = {
  id: Scalars['Int'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type ProjectDocumentTypeOfficialLetterNote = {
  documentType: DocumentType;
  officialLetterNote?: Maybe<Scalars['String']>;
};

export type ProjectHistoryRecord = {
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Int'];
  performedByName: Scalars['String'];
  projectStatus?: Maybe<ProjectStatus>;
  projectTransition?: Maybe<ProjectTransition>;
};

export type ProjectInsFormVersion = {
  dcaApprovalByUser?: Maybe<User>;
  dcaApprovalDate?: Maybe<Scalars['DateTime']>;
  exclusiveGroupNumber?: Maybe<Scalars['Int']>;
  executionKeys: Array<ProjectInsFormVersionExecutionKey>;
  fieldCommentCount: Scalars['Int'];
  fieldComments: Array<ProjectInsFormVersionFieldComment>;
  fieldValues: Array<ProjectInsFormVersionFieldValue>;
  generatedDocumentFileAttachment?: Maybe<FileAttachment>;
  hasFieldValues: Scalars['Boolean'];
  id: Scalars['Int'];
  insFormExecutionState?: Maybe<InsFormExecutionStateLookup>;
  insFormVersion: InsFormVersion;
  instanceNumber: Scalars['Int'];
  isDcaApproved?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  isFullySigned: Scalars['Boolean'];
  isOptional: Scalars['Boolean'];
  isReleasedToDca: Scalars['Boolean'];
  isSigned: Scalars['Boolean'];
  isSignedByDca: Scalars['Boolean'];
  isTrgApproved: Scalars['Boolean'];
  projectId: Scalars['Int'];
  projectType: ProjectType;
  totalNewFormComments: Scalars['Int'];
  uploadedFileAttachment?: Maybe<FileAttachment>;
};

export type ProjectInsFormVersionExclusiveGroup = {
  exclusiveGroupNumber: Scalars['Int'];
  otherProjectInsFormVersions: Array<ProjectInsFormVersion>;
  startedProjectInsFormVersion?: Maybe<ProjectInsFormVersion>;
};

export type ProjectInsFormVersionExecutionKey = {
  sentToUserEmailAddress: UserEmailAddress;
};

export type ProjectInsFormVersionFieldComment = {
  id: Scalars['Int'];
  insFormVersionField: InsFormVersionField;
  isDeleted: Scalars['Boolean'];
};

export type ProjectInsFormVersionFieldValue = {
  id: Scalars['Int'];
  insFormVersionField: InsFormVersionField;
  signedByUser?: Maybe<User>;
  text?: Maybe<Scalars['String']>;
};

export type ProjectStage = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ProjectStatus = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ProjectTransition = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ProjectTransitionResult = {
  id: Scalars['Int'];
  warnings?: Maybe<Array<Scalars['String']>>;
};

export type ProjectType = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  shortName?: Maybe<Scalars['String']>;
};

export type Query = {
  aircraft: Aircraft;
  aircraftCategories: Array<AircraftCategory>;
  aircraftCategory: AircraftCategory;
  aircraftClass: AircraftClass;
  aircraftClasses: Array<AircraftClass>;
  aircraftComments: Comments;
  aircraftDocument: AircraftOperatorDocument;
  aircraftDocuments: Array<AircraftOperatorDocument>;
  aircraftDocumentTypes: Array<DocumentType>;
  aircraftEngineManufacturer: AircraftEngineManufacturer;
  aircraftEngineManufacturers: Array<AircraftEngineManufacturer>;
  aircraftManufacturer: AircraftManufacturer;
  aircraftManufacturers: Array<AircraftManufacturer>;
  aircraftModel: AircraftModel;
  aircraftModels: Array<AircraftModel>;
  aircraftOperationalApproval: AircraftOperationalApproval;
  aircraftOperator: AircraftOperator;
  aircraftOperators: Array<AircraftOperator>;
  aircraftOwner: AircraftOwner;
  aircraftOwners: Array<AircraftOwner>;
  aircraftProject: AircraftProject;
  aircraftProjectAssignableUsers: Array<User>;
  aircraftProjectComments: Comments;
  aircraftProjectDcaComments: Comments;
  aircraftProjectDocument: AircraftProjectOperatorDocument;
  aircraftProjectDocuments: Array<AircraftProjectOperatorDocument>;
  aircraftProjectDocumentTypeApprovalStatuses: Array<AircraftProjectDocumentTypeApprovalStatus>;
  aircraftProjectDocumentTypes: Array<DocumentType>;
  aircraftProjectDocumentTypesForProjectApproval: Array<DocumentType>;
  aircraftProjectEmailHistory: Array<EmailHistoryRecord>;
  aircraftProjectHistory: Array<ProjectHistoryRecord>;
  aircraftProjectInsFormFieldComments: Array<ProjectInsFormVersionFieldComment>;
  aircraftProjectInsFormFieldValues: Array<ProjectInsFormVersionFieldValue>;
  aircraftProjectInsForms: Array<ProjectInsFormVersion>;
  aircraftProjectInsFormsExclusiveGroups: Array<ProjectInsFormVersionExclusiveGroup>;
  aircraftProjectInspection: AircraftProjectOperatorInspection;
  aircraftProjectInspectionComments: Comments;
  aircraftProjectInspections: Array<AircraftProjectOperatorInspection>;
  aircraftProjects: AircraftProjectsResult;
  aircraftProjectsForSelectionOnInvoice: Array<AircraftProject>;
  aircraftProjectType: AircraftProjectType;
  aircraftProjectTypes: Array<AircraftProjectType>;
  aircraftPropellerManufacturer: AircraftPropellerManufacturer;
  aircraftPropellerManufacturers: Array<AircraftPropellerManufacturer>;
  aircraftRegisteredHolder: AircraftRegisteredHolder;
  aircraftRegisteredHolders: Array<AircraftRegisteredHolder>;
  aircrafts: AircraftsResult;
  aircraftStatus: AircraftStatus;
  aircraftStatuses: Array<AircraftStatus>;
  aircraftType: AircraftType;
  aircraftTypes: Array<AircraftType>;
  amo: Amo;
  amoProject: AmoProject;
  amoProjectAssignableUsers: Array<User>;
  amoProjectAuditComments: Comments;
  amoProjectAudits: Array<AmoProjectAudit>;
  amoProjectComments: Comments;
  amoProjectDcaComments: Comments;
  amoProjectDocument: AmoProjectDocument;
  amoProjectDocuments: Array<AmoProjectDocument>;
  amoProjectDocumentTypeOfficialLetterNotes: Array<ProjectDocumentTypeOfficialLetterNote>;
  amoProjectDocumentTypes: Array<DocumentType>;
  amoProjectEmailHistory: Array<EmailHistoryRecord>;
  amoProjectHistory: Array<ProjectHistoryRecord>;
  amoProjectInsFormFieldComments: Array<ProjectInsFormVersionFieldComment>;
  amoProjectInsFormFieldValues: Array<ProjectInsFormVersionFieldValue>;
  amoProjectInsForms: Array<ProjectInsFormVersion>;
  amoProjects: AmoProjectsResult;
  amoProjectType: AmoProjectType;
  amoProjectTypes: Array<AmoProjectType>;
  amos: AmosResult;
  bannerAlerts: Array<BannerAlert>;
  company: Company;
  companyComments: Comments;
  companyContact: Contact;
  companyContacts: Array<Contact>;
  companyDocument: CompanyDocument;
  companyDocuments: Array<CompanyDocument>;
  countries: Array<Country>;
  country: Country;
  crewCertificateType: CrewCertificateType;
  crewCertificateTypes: Array<CrewCertificateType>;
  crewLicenseType: CrewLicenseType;
  crewLicenseTypes: Array<CrewLicenseType>;
  crewMember: CrewMember;
  crewMemberComments: Comments;
  crewMemberDocument: CrewMemberDocument;
  crewMemberDocuments: Array<CrewMemberDocument>;
  crewMemberDocumentTypes: Array<DocumentType>;
  crewMembers: CrewMembersResult;
  crewMembersForOperatorAddCrewProject: Array<CrewMember>;
  crewMemberStatus: CrewMemberStatus;
  crewMemberStatuses: Array<CrewMemberStatus>;
  crewPosition: CrewPosition;
  crewPositions: Array<CrewPosition>;
  crewProject: CrewProject;
  crewProjectAssignableUsers: Array<User>;
  crewProjectCategories: Array<CrewProjectCategory>;
  crewProjectCategory: CrewProjectCategory;
  crewProjectCertificate: CrewProjectCertificate;
  crewProjectComments: Comments;
  crewProjectDcaComments: Comments;
  crewProjectDcaProjectApprovers: Array<User>;
  crewProjectDocument: CrewProjectDocument;
  crewProjectDocuments: Array<CrewProjectDocument>;
  crewProjectDocumentTypes: Array<DocumentType>;
  crewProjectEmailHistory: Array<EmailHistoryRecord>;
  crewProjectHistory: Array<ProjectHistoryRecord>;
  crewProjectInsFormFieldComments: Array<ProjectInsFormVersionFieldComment>;
  crewProjectInsFormFieldValues: Array<ProjectInsFormVersionFieldValue>;
  crewProjectInsForms: Array<ProjectInsFormVersion>;
  crewProjectInsFormsExclusiveGroups: Array<ProjectInsFormVersionExclusiveGroup>;
  crewProjectRenewalChangeType: CrewProjectRenewalChangeType;
  crewProjectRenewalChangeTypes: Array<CrewProjectRenewalChangeType>;
  crewProjects: CrewProjectsResult;
  crewProjectsForSelectionOnInvoice: Array<CrewProject>;
  crewProjectSpecialProjectType: CrewProjectSpecialProjectType;
  crewProjectSpecialProjectTypes: Array<CrewProjectSpecialProjectType>;
  crewProjectType: CrewProjectType;
  crewProjectTypes: Array<CrewProjectType>;
  crewRating: CrewRating;
  crewRatings: Array<CrewRating>;
  department: Department;
  departments: Array<Department>;
  documentType: Document;
  documentTypeCategories: Array<DocumentTypeCategory>;
  documentTypeCategory: DocumentTypeCategory;
  documentTypeIdsEditableByInspector: Array<Scalars['Int']>;
  documentTypes: Array<DocumentType>;
  documentValidities: Array<DocumentValidity>;
  documentValidity: DocumentValidity;
  downloadAircraftCertificatePreview?: Maybe<DownloadFile>;
  downloadAircraftDocument?: Maybe<DownloadFile>;
  downloadAircraftImage?: Maybe<DownloadFile>;
  downloadAircraftInsFormAssociatedDocument?: Maybe<DownloadFile>;
  downloadAircraftProjectDocument?: Maybe<DownloadFile>;
  downloadAircraftProjectEmailAttachmentContent?: Maybe<Scalars['String']>;
  downloadAircraftProjectFilledInInsForm?: Maybe<DownloadFile>;
  downloadAircraftProjectGeneratedInsFormDocument?: Maybe<DownloadFile>;
  downloadAircraftProjectInsFormAssociatedDocument?: Maybe<DownloadFile>;
  downloadAircraftProjectInspectionInsForm16005A?: Maybe<Scalars['String']>;
  downloadAircraftProjectInspectionInsForm4001?: Maybe<Scalars['String']>;
  downloadAircraftProjectInspectionInsForm4007?: Maybe<Scalars['String']>;
  downloadAircraftProjectInspectionInsForm4023B?: Maybe<Scalars['String']>;
  downloadAircraftProjectInspectionInsForm4045?: Maybe<Scalars['String']>;
  downloadAircraftProjectInspectionInspectorInspectionEstimate?: Maybe<Scalars['String']>;
  downloadAircraftProjectInspectionInspectorInspectionInvoice?: Maybe<Scalars['String']>;
  downloadAircraftProjectInspectionInspectorInspectionTimeLog?: Maybe<Scalars['String']>;
  downloadAircraftProjectInspectionLetterOfFindings?: Maybe<Scalars['String']>;
  downloadAircraftProjectUploadedInsForm?: Maybe<DownloadFile>;
  downloadAmoProjectAuditInsForm4004?: Maybe<Scalars['String']>;
  downloadAmoProjectAuditInsForm4035?: Maybe<Scalars['String']>;
  downloadAmoProjectAuditInspectorInspectionEstimate?: Maybe<Scalars['String']>;
  downloadAmoProjectAuditInspectorInspectionInvoice?: Maybe<Scalars['String']>;
  downloadAmoProjectAuditInspectorInspectionTimeLog?: Maybe<Scalars['String']>;
  downloadAmoProjectAuditLetterOfFindings?: Maybe<Scalars['String']>;
  downloadAmoProjectDocument?: Maybe<DownloadFile>;
  downloadAmoProjectEmailAttachmentContent?: Maybe<Scalars['String']>;
  downloadAmoProjectFilledInInsForm?: Maybe<DownloadFile>;
  downloadAmoProjectUploadedInsForm?: Maybe<DownloadFile>;
  downloadCompanyDocument?: Maybe<DownloadFile>;
  downloadCompanyEmailAttachmentContent?: Maybe<Scalars['String']>;
  downloadCrewCertificate?: Maybe<DownloadFile>;
  downloadCrewCertificatePreview?: Maybe<DownloadFile>;
  downloadCrewMemberDocument?: Maybe<DownloadFile>;
  downloadCrewProjectDocument?: Maybe<DownloadFile>;
  downloadCrewProjectEmailAttachmentContent?: Maybe<Scalars['String']>;
  downloadCrewProjectFilledInInsForm?: Maybe<DownloadFile>;
  downloadCrewProjectFilledInInsFormByExecutionKey?: Maybe<DownloadFile>;
  downloadCrewProjectOfficialLetterPreview?: Maybe<DownloadFile>;
  downloadCrewProjectUploadedInsForm?: Maybe<DownloadFile>;
  downloadInspectorDocument?: Maybe<DownloadFile>;
  downloadInspectorEmailAttachmentContent?: Maybe<Scalars['String']>;
  downloadInvoiceFileAttachment?: Maybe<Scalars['String']>;
  downloadMechanicCertificate?: Maybe<DownloadFile>;
  downloadMechanicCertificatePreview?: Maybe<DownloadFile>;
  downloadMechanicDocument?: Maybe<DownloadFile>;
  downloadMechanicProjectDocument?: Maybe<DownloadFile>;
  downloadMechanicProjectEmailAttachmentContent?: Maybe<Scalars['String']>;
  downloadMechanicProjectFilledInInsForm?: Maybe<DownloadFile>;
  downloadMechanicProjectFilledInInsFormByExecutionKey?: Maybe<DownloadFile>;
  downloadMechanicProjectOfficialLetterPreview?: Maybe<DownloadFile>;
  downloadMechanicProjectUploadedInsForm?: Maybe<DownloadFile>;
  elpLevel: ElpLevel;
  elpLevels: Array<ElpLevel>;
  emailAddressTypes: Array<EmailAddressType>;
  employmentCompanies: Array<EmploymentCompany>;
  employmentCompany: EmploymentCompany;
  functionalGroups: Array<FunctionalGroup>;
  genericLvCompanies: Array<GenericLvCompany>;
  genericLvCompany: GenericLvCompany;
  insFormAction: InsFormAction;
  insFormActions: Array<InsFormAction>;
  insFormAssociatedDocumentGroup: InsFormAssociatedDocumentGroup;
  insFormAssociatedDocumentGroups: Array<InsFormAssociatedDocumentGroup>;
  insFormExecutionStateLookup: InsFormExecutionStateLookup;
  inspectionStatus: InspectionStatus;
  inspectionStatuses: Array<InspectionStatus>;
  inspector: Inspector;
  inspectorBlockedDate: InspectorBlockedDate;
  inspectorBlockedDates: Array<InspectorBlockedDate>;
  inspectorComments: Comments;
  inspectorDocument: InspectorDocument;
  inspectorDocuments: Array<InspectorDocument>;
  inspectorDocumentTypes: Array<DocumentType>;
  inspectorInspections: InspectorInspectionsResult;
  inspectors: InspectorsResult;
  invoice: Invoice;
  invoices: InvoicesResult;
  listManagementAircraftEngineManufacturers: ListManagementAircraftEngineManufacturers;
  listManagementAircraftManufacturers: ListManagementAircraftManufacturers;
  listManagementAircraftModels: ListManagementAircraftModels;
  listManagementAircraftPropellerManufacturers: ListManagementAircraftPropellerManufacturers;
  listManagementCrewRatings: ListManagementCrewRatings;
  listManagementEmploymentCompanies: ListManagementEmploymentCompanies;
  listManagementGenericLvCompanies: ListManagementGenericLvCompanies;
  listManagementMechanicRatings: ListManagementMechanicRatings;
  me: User;
  mechanic: Mechanic;
  mechanicCertificateType: MechanicCertificateType;
  mechanicCertificateTypes: Array<MechanicCertificateType>;
  mechanicComments: Comments;
  mechanicDocument: MechanicDocument;
  mechanicDocuments: Array<MechanicDocument>;
  mechanicDocumentTypes: Array<DocumentType>;
  mechanicLicenseType: MechanicLicenseType;
  mechanicLicenseTypes: Array<MechanicLicenseType>;
  mechanicPosition: MechanicPosition;
  mechanicPositions: Array<MechanicPosition>;
  mechanicProject: MechanicProject;
  mechanicProjectAssignableUsers: Array<User>;
  mechanicProjectCertificate: MechanicProjectCertificate;
  mechanicProjectComments: Comments;
  mechanicProjectDcaApprovedByUsers: Array<User>;
  mechanicProjectDcaComments: Comments;
  mechanicProjectDcaReviewerUsers: Array<User>;
  mechanicProjectDcaSentForApprovalByUsers: Array<User>;
  mechanicProjectDocument: MechanicProjectDocument;
  mechanicProjectDocuments: Array<MechanicProjectDocument>;
  mechanicProjectDocumentTypes: Array<DocumentType>;
  mechanicProjectEmailHistory: Array<EmailHistoryRecord>;
  mechanicProjectHistory: Array<ProjectHistoryRecord>;
  mechanicProjectInsFormFieldComments: Array<ProjectInsFormVersionFieldComment>;
  mechanicProjectInsFormFieldValues: Array<ProjectInsFormVersionFieldValue>;
  mechanicProjectInsForms: Array<ProjectInsFormVersion>;
  mechanicProjectInsFormsExclusiveGroups: Array<ProjectInsFormVersionExclusiveGroup>;
  mechanicProjectRenewalChangeType: MechanicProjectRenewalChangeType;
  mechanicProjectRenewalChangeTypes: Array<MechanicProjectRenewalChangeType>;
  mechanicProjects: MechanicProjectsResult;
  mechanicProjectsForSelectionOnInvoice: Array<MechanicProject>;
  mechanicProjectType: MechanicProjectType;
  mechanicProjectTypes: Array<MechanicProjectType>;
  mechanicRating: MechanicRating;
  mechanicRatings: Array<MechanicRating>;
  mechanics: MechanicsResult;
  mechanicsForOperatorAddMechanicProject: Array<Mechanic>;
  mechanicStatus: MechanicStatus;
  mechanicStatuses: Array<MechanicStatus>;
  myPreviousRecipients: Array<Scalars['String']>;
  operator: Operator;
  operatorDocumentTypes: Array<DocumentType>;
  operators: OperatorsResult;
  owner: Owner;
  ownerDocumentTypes: Array<DocumentType>;
  owners: OwnersResult;
  paymentStatus: PaymentStatus;
  paymentStatuses: Array<PaymentStatus>;
  phoneNumberTypes: Array<PhoneNumberType>;
  projectInsFormVersionByExecutionKey: ProjectInsFormVersion;
  projectInsFormVersionComments: Comments;
  projectStatus: ProjectStage;
  projectStatuses: Array<ProjectStage>;
  region: Region;
  regions: Array<Region>;
  registeredHolder: RegisteredHolder;
  registeredHolderDocumentTypes: Array<DocumentType>;
  registeredHolders: RegisteredHoldersResult;
  reminderApplicabilities: Array<ReminderApplicability>;
  reminderApplicability: ReminderApplicability;
  reminders: Array<Reminder>;
  role: Role;
  roles: Array<Role>;
  state: State;
  states: Array<State>;
  user: User;
  users: UsersResult;
  validateCrewCertificateOfValidationQrCodeV1: CrewCertificateValidationInfoV1Result;
  validateCrewCertificateOfValidationQrCodeV2: CrewCertificateValidationInfoV2Result;
  validateLegacyCrewCertificateOfValidationQrCode?: Maybe<CrewCertificateValidationInfoV1>;
  validateMechanicCertificateOfValidationQrCodeV1: MechanicCertificateValidationInfoV1Result;
};


export type QueryAircraftArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftCategoriesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryAircraftCategoryArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftClassArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftClassesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryAircraftCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftDocumentsArgs = {
  aircraftId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  documentTypeCategoryIdIn?: Maybe<Array<Scalars['Int']>>;
  documentTypeId?: Maybe<Scalars['Int']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  take?: Maybe<Scalars['Int']>;
};


export type QueryAircraftDocumentTypesArgs = {
  aircraftId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
};


export type QueryAircraftEngineManufacturerArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftEngineManufacturersArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type QueryAircraftManufacturerArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftManufacturersArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type QueryAircraftModelArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftModelsArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type QueryAircraftOperationalApprovalArgs = {
  aircraftId: Scalars['Int'];
};


export type QueryAircraftOperatorArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftOperatorsArgs = {
  aircraftId?: Maybe<Scalars['Int']>;
  operatorId?: Maybe<Scalars['Int']>;
};


export type QueryAircraftOwnerArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftOwnersArgs = {
  aircraftId?: Maybe<Scalars['Int']>;
};


export type QueryAircraftProjectArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftProjectCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftProjectDcaCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftProjectDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftProjectDocumentsArgs = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  documentTypeCategoryIdIn?: Maybe<Array<DocumentTypeCategoryEnum>>;
  documentTypeIdIn?: Maybe<Array<DocumentTypeEnum>>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isReleasedToDca?: Maybe<Scalars['Boolean']>;
};


export type QueryAircraftProjectDocumentTypeApprovalStatusesArgs = {
  approvalStatus?: Maybe<ApprovalStatusEnum>;
  documentTypeId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
};


export type QueryAircraftProjectDocumentTypesArgs = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  aircraftProjectTypeId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  documentTypeCategoryIdIn?: Maybe<Array<DocumentTypeCategoryEnum>>;
  documentTypeId?: Maybe<DocumentTypeEnum>;
  isRequiredForProjectCompletion?: Maybe<Scalars['Boolean']>;
};


export type QueryAircraftProjectDocumentTypesForProjectApprovalArgs = {
  aircraftProjectId: Scalars['Int'];
};


export type QueryAircraftProjectEmailHistoryArgs = {
  aircraftProjectId: Scalars['Int'];
  sortBy?: Maybe<EmailHistorySortBy>;
  sortDirection?: Maybe<SortDirection>;
};


export type QueryAircraftProjectHistoryArgs = {
  aircraftProjectId: Scalars['Int'];
  filter?: Maybe<AircraftProjectHistoryFilter>;
  take?: Maybe<Scalars['Int']>;
};


export type QueryAircraftProjectInsFormFieldCommentsArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryAircraftProjectInsFormFieldValuesArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryAircraftProjectInsFormsArgs = {
  aircraftProjectId: Scalars['Int'];
};


export type QueryAircraftProjectInsFormsExclusiveGroupsArgs = {
  aircraftProjectId: Scalars['Int'];
};


export type QueryAircraftProjectInspectionArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftProjectInspectionCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftProjectInspectionsArgs = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  isPrior?: Maybe<Scalars['Boolean']>;
};


export type QueryAircraftProjectsArgs = {
  aircraftId?: Maybe<Scalars['Int']>;
  aircraftProjectTypeIdIn?: Maybe<Array<Scalars['Int']>>;
  archivedDate?: Maybe<DateRangeFilterInput>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  isSubmittedToDca?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  paginationOptions?: Maybe<PaginationOptions>;
  projectStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  registrationMark?: Maybe<Scalars['String']>;
  sortBy?: Maybe<AircraftProjectsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type QueryAircraftProjectsForSelectionOnInvoiceArgs = {
  invoiceId?: Maybe<Scalars['Int']>;
};


export type QueryAircraftProjectTypeArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftProjectTypesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryAircraftPropellerManufacturerArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftPropellerManufacturersArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type QueryAircraftRegisteredHolderArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftRegisteredHoldersArgs = {
  aircraftId?: Maybe<Scalars['Int']>;
};


export type QueryAircraftsArgs = {
  aircraftStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  allWeatherOpsAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  baseOfOperationsCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  cOfAStatus?: Maybe<Scalars['String']>;
  cOfRStatus?: Maybe<Scalars['String']>;
  cpdlcAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  designatedAirspaceAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  efbAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  etopsAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  excludeDeregistered?: Maybe<Scalars['Boolean']>;
  hasCertificateOfAirworthinessExpirationDate?: Maybe<Scalars['Boolean']>;
  hascertificateOfInsuranceExpirationDate?: Maybe<Scalars['Boolean']>;
  hasCertificateOfRegistrationExpirationDate?: Maybe<Scalars['Boolean']>;
  hasLeaseAgreementExpirationDate?: Maybe<Scalars['Boolean']>;
  hasManagementAgreementExpirationDate?: Maybe<Scalars['Boolean']>;
  homeBaseCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  hudAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  includeProvisional?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  mtowMaximum?: Maybe<Scalars['Int']>;
  mtowMinimum?: Maybe<Scalars['Int']>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  operatorIdNullOrIn?: Maybe<Array<Scalars['Int']>>;
  ownerIdIn?: Maybe<Array<Scalars['Int']>>;
  paginationOptions?: Maybe<PaginationOptions>;
  registeredHolderIdIn?: Maybe<Array<Scalars['Int']>>;
  registrationMarkContains?: Maybe<Scalars['String']>;
  sortBy?: Maybe<AircraftsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type QueryAircraftStatusArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftStatusesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryAircraftTypeArgs = {
  id: Scalars['Int'];
};


export type QueryAircraftTypesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryAmoArgs = {
  id: Scalars['Int'];
};


export type QueryAmoProjectArgs = {
  id: Scalars['Int'];
};


export type QueryAmoProjectAuditCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryAmoProjectAuditsArgs = {
  amoProjectId?: Maybe<Scalars['Int']>;
  isPrior?: Maybe<Scalars['Boolean']>;
};


export type QueryAmoProjectCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryAmoProjectDcaCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryAmoProjectDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryAmoProjectDocumentsArgs = {
  amoProjectId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  documentTypeId?: Maybe<DocumentTypeEnum>;
};


export type QueryAmoProjectDocumentTypeOfficialLetterNotesArgs = {
  amoProjectId: Scalars['Int'];
};


export type QueryAmoProjectDocumentTypesArgs = {
  amoProjectId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
};


export type QueryAmoProjectEmailHistoryArgs = {
  amoProjectId: Scalars['Int'];
  sortBy?: Maybe<EmailHistorySortBy>;
  sortDirection?: Maybe<SortDirection>;
};


export type QueryAmoProjectHistoryArgs = {
  amoProjectId: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
};


export type QueryAmoProjectInsFormFieldCommentsArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryAmoProjectInsFormFieldValuesArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryAmoProjectInsFormsArgs = {
  amoProjectId: Scalars['Int'];
};


export type QueryAmoProjectsArgs = {
  aircraftRegistrationMarkContains?: Maybe<Scalars['String']>;
  assigneeIdIn?: Maybe<Array<Scalars['Int']>>;
  createDate?: Maybe<DateRangeFilterInput>;
  dateOfExpiry?: Maybe<DateRangeFilterInput>;
  dateOfFirstIssue?: Maybe<DateRangeFilterInput>;
  keyword?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
  projectStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<AmoProjectsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type QueryAmoProjectTypeArgs = {
  id: Scalars['Int'];
};


export type QueryAmoProjectTypesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryAmosArgs = {
  nameContains?: Maybe<Scalars['String']>;
  onlyRenewable?: Maybe<Scalars['Boolean']>;
  paginationOptions?: Maybe<PaginationOptions>;
};


export type QueryBannerAlertsArgs = {
  isEnabled?: Maybe<Scalars['Boolean']>;
};


export type QueryCompanyArgs = {
  id: Scalars['Int'];
};


export type QueryCompanyCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryCompanyContactArgs = {
  id: Scalars['Int'];
};


export type QueryCompanyContactsArgs = {
  id?: Maybe<Scalars['Int']>;
};


export type QueryCompanyDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryCompanyDocumentsArgs = {
  companyId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  documentTypeId?: Maybe<DocumentTypeEnum>;
  isArchived?: Maybe<Scalars['Boolean']>;
};


export type QueryCountriesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  regionIdIn?: Maybe<Array<Scalars['Int']>>;
};


export type QueryCountryArgs = {
  id: Scalars['Int'];
};


export type QueryCrewCertificateTypeArgs = {
  id: Scalars['Int'];
};


export type QueryCrewCertificateTypesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryCrewLicenseTypeArgs = {
  id: Scalars['Int'];
};


export type QueryCrewLicenseTypesArgs = {
  crewPositionIdIn?: Maybe<Array<Scalars['Int']>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryCrewMemberArgs = {
  id: Scalars['Int'];
};


export type QueryCrewMemberCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryCrewMemberDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryCrewMemberDocumentsArgs = {
  crewMemberId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  isArchived?: Maybe<Scalars['Boolean']>;
};


export type QueryCrewMemberDocumentTypesArgs = {
  crewMemberId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
};


export type QueryCrewMembersArgs = {
  aircraftIdIn?: Maybe<Array<Scalars['Int']>>;
  crewMemberStatusId?: Maybe<Scalars['Int']>;
  crewRatingIdIn?: Maybe<Array<Scalars['Int']>>;
  excludeRetired?: Maybe<Scalars['Boolean']>;
  expiringWithinDays?: Maybe<Scalars['Int']>;
  hasActiveProjects?: Maybe<Scalars['Boolean']>;
  hasCertificationExpiryDate?: Maybe<Scalars['Boolean']>;
  includeProvisional?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  lastNameContains?: Maybe<Scalars['String']>;
  licenseCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  paginationOptions?: Maybe<PaginationOptions>;
  sortBy?: Maybe<CrewMembersSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type QueryCrewMembersForOperatorAddCrewProjectArgs = {
  lastNameContains?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['Int']>;
};


export type QueryCrewMemberStatusArgs = {
  id: Scalars['Int'];
};


export type QueryCrewMemberStatusesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryCrewPositionArgs = {
  id: Scalars['Int'];
};


export type QueryCrewPositionsArgs = {
  crewLicenseTypeIdIn?: Maybe<Array<Scalars['Int']>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryCrewProjectArgs = {
  id: Scalars['Int'];
};


export type QueryCrewProjectCategoriesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryCrewProjectCategoryArgs = {
  id: Scalars['Int'];
};


export type QueryCrewProjectCertificateArgs = {
  crewProjectId: Scalars['Int'];
};


export type QueryCrewProjectCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryCrewProjectDcaCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryCrewProjectDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryCrewProjectDocumentsArgs = {
  crewProjectId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  documentTypeId?: Maybe<DocumentTypeEnum>;
};


export type QueryCrewProjectDocumentTypesArgs = {
  crewProjectId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
};


export type QueryCrewProjectEmailHistoryArgs = {
  crewProjectId: Scalars['Int'];
  sortBy?: Maybe<EmailHistorySortBy>;
  sortDirection?: Maybe<SortDirection>;
};


export type QueryCrewProjectHistoryArgs = {
  crewProjectId: Scalars['Int'];
  filter?: Maybe<CrewProjectHistoryFilter>;
  take?: Maybe<Scalars['Int']>;
};


export type QueryCrewProjectInsFormFieldCommentsArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryCrewProjectInsFormFieldValuesArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryCrewProjectInsFormsArgs = {
  crewProjectId: Scalars['Int'];
};


export type QueryCrewProjectInsFormsExclusiveGroupsArgs = {
  crewProjectId: Scalars['Int'];
};


export type QueryCrewProjectRenewalChangeTypeArgs = {
  id: Scalars['Int'];
};


export type QueryCrewProjectRenewalChangeTypesArgs = {
  crewProjectId?: Maybe<Scalars['Int']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryCrewProjectsArgs = {
  archivedDate?: Maybe<DateRangeFilterInput>;
  associatedAircraftProjectIdIn?: Maybe<Array<Scalars['Int']>>;
  certificateDateOfIssue?: Maybe<DateRangeFilterInput>;
  crewMemberId?: Maybe<Scalars['Int']>;
  isSubmittedToDca?: Maybe<Scalars['Boolean']>;
  lastNameContains?: Maybe<Scalars['String']>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  paginationOptions?: Maybe<PaginationOptions>;
  projectStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<CrewProjectsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  validationNumberContains?: Maybe<Scalars['String']>;
};


export type QueryCrewProjectsForSelectionOnInvoiceArgs = {
  invoiceId?: Maybe<Scalars['Int']>;
};


export type QueryCrewProjectSpecialProjectTypeArgs = {
  id: Scalars['Int'];
};


export type QueryCrewProjectSpecialProjectTypesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryCrewProjectTypeArgs = {
  id: Scalars['Int'];
};


export type QueryCrewProjectTypesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryCrewRatingArgs = {
  id: Scalars['Int'];
};


export type QueryCrewRatingsArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type QueryDepartmentArgs = {
  id: Scalars['Int'];
};


export type QueryDepartmentsArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryDocumentTypeArgs = {
  id: Scalars['Int'];
};


export type QueryDocumentTypeCategoriesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryDocumentTypeCategoryArgs = {
  id: Scalars['Int'];
};


export type QueryDocumentTypesArgs = {
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  idIn?: Maybe<Array<Scalars['Int']>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryDocumentValiditiesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryDocumentValidityArgs = {
  id: Scalars['Int'];
};


export type QueryDownloadAircraftCertificatePreviewArgs = {
  aircraftProjectId: Scalars['Int'];
  certificateDocumentTypeId: Scalars['Int'];
};


export type QueryDownloadAircraftDocumentArgs = {
  aircraftId: Scalars['Int'];
  id: Scalars['Int'];
};


export type QueryDownloadAircraftImageArgs = {
  id: Scalars['Int'];
};


export type QueryDownloadAircraftInsFormAssociatedDocumentArgs = {
  aircraftId: Scalars['Int'];
  id: Scalars['Int'];
};


export type QueryDownloadAircraftProjectDocumentArgs = {
  aircraftProjectId: Scalars['Int'];
  id: Scalars['Int'];
};


export type QueryDownloadAircraftProjectEmailAttachmentContentArgs = {
  aircraftProjectId: Scalars['Int'];
  attachmentId: Scalars['Int'];
  emailId: Scalars['Int'];
};


export type QueryDownloadAircraftProjectFilledInInsFormArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryDownloadAircraftProjectGeneratedInsFormDocumentArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryDownloadAircraftProjectInsFormAssociatedDocumentArgs = {
  aircraftProjectId: Scalars['Int'];
  id: Scalars['Int'];
};


export type QueryDownloadAircraftProjectInspectionInsForm16005AArgs = {
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
};


export type QueryDownloadAircraftProjectInspectionInsForm4001Args = {
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
};


export type QueryDownloadAircraftProjectInspectionInsForm4007Args = {
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
};


export type QueryDownloadAircraftProjectInspectionInsForm4023BArgs = {
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
};


export type QueryDownloadAircraftProjectInspectionInsForm4045Args = {
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
};


export type QueryDownloadAircraftProjectInspectionInspectorInspectionEstimateArgs = {
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
  inspectorInspectionId: Scalars['Int'];
};


export type QueryDownloadAircraftProjectInspectionInspectorInspectionInvoiceArgs = {
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
  inspectorInspectionId: Scalars['Int'];
};


export type QueryDownloadAircraftProjectInspectionInspectorInspectionTimeLogArgs = {
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
  inspectorInspectionId: Scalars['Int'];
};


export type QueryDownloadAircraftProjectInspectionLetterOfFindingsArgs = {
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
};


export type QueryDownloadAircraftProjectUploadedInsFormArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryDownloadAmoProjectAuditInsForm4004Args = {
  amoProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
};


export type QueryDownloadAmoProjectAuditInsForm4035Args = {
  amoProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
};


export type QueryDownloadAmoProjectAuditInspectorInspectionEstimateArgs = {
  amoProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
  inspectorInspectionId: Scalars['Int'];
};


export type QueryDownloadAmoProjectAuditInspectorInspectionInvoiceArgs = {
  amoProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
  inspectorInspectionId: Scalars['Int'];
};


export type QueryDownloadAmoProjectAuditInspectorInspectionTimeLogArgs = {
  amoProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
  inspectorInspectionId: Scalars['Int'];
};


export type QueryDownloadAmoProjectAuditLetterOfFindingsArgs = {
  amoProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
};


export type QueryDownloadAmoProjectDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryDownloadAmoProjectEmailAttachmentContentArgs = {
  amoProjectId: Scalars['Int'];
  attachmentId: Scalars['Int'];
  emailId: Scalars['Int'];
};


export type QueryDownloadAmoProjectFilledInInsFormArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryDownloadAmoProjectUploadedInsFormArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryDownloadCompanyDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryDownloadCompanyEmailAttachmentContentArgs = {
  attachmentId: Scalars['Int'];
  companyId: Scalars['Int'];
  emailId: Scalars['Int'];
};


export type QueryDownloadCrewCertificateArgs = {
  identifier: Scalars['String'];
};


export type QueryDownloadCrewCertificatePreviewArgs = {
  crewProjectId: Scalars['Int'];
};


export type QueryDownloadCrewMemberDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryDownloadCrewProjectDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryDownloadCrewProjectEmailAttachmentContentArgs = {
  attachmentId: Scalars['Int'];
  crewProjectId: Scalars['Int'];
  emailId: Scalars['Int'];
};


export type QueryDownloadCrewProjectFilledInInsFormArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryDownloadCrewProjectFilledInInsFormByExecutionKeyArgs = {
  key: Scalars['String'];
};


export type QueryDownloadCrewProjectOfficialLetterPreviewArgs = {
  crewProjectId: Scalars['Int'];
};


export type QueryDownloadCrewProjectUploadedInsFormArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryDownloadInspectorDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryDownloadInspectorEmailAttachmentContentArgs = {
  attachmentId: Scalars['Int'];
  emailId: Scalars['Int'];
  inspectorId: Scalars['Int'];
};


export type QueryDownloadInvoiceFileAttachmentArgs = {
  invoiceId: Scalars['Int'];
};


export type QueryDownloadMechanicCertificateArgs = {
  identifier: Scalars['String'];
};


export type QueryDownloadMechanicCertificatePreviewArgs = {
  mechanicProjectId: Scalars['Int'];
};


export type QueryDownloadMechanicDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryDownloadMechanicProjectDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryDownloadMechanicProjectEmailAttachmentContentArgs = {
  attachmentId: Scalars['Int'];
  emailId: Scalars['Int'];
  mechanicProjectId: Scalars['Int'];
};


export type QueryDownloadMechanicProjectFilledInInsFormArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryDownloadMechanicProjectFilledInInsFormByExecutionKeyArgs = {
  key: Scalars['String'];
};


export type QueryDownloadMechanicProjectOfficialLetterPreviewArgs = {
  mechanicProjectId: Scalars['Int'];
};


export type QueryDownloadMechanicProjectUploadedInsFormArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryElpLevelArgs = {
  id: Scalars['Int'];
};


export type QueryElpLevelsArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryEmploymentCompaniesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type QueryEmploymentCompanyArgs = {
  id: Scalars['Int'];
};


export type QueryGenericLvCompaniesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type QueryGenericLvCompanyArgs = {
  id: Scalars['Int'];
};


export type QueryInsFormActionArgs = {
  id: Scalars['Int'];
};


export type QueryInsFormAssociatedDocumentGroupArgs = {
  id: Scalars['Int'];
};


export type QueryInsFormExecutionStateLookupArgs = {
  id: Scalars['Int'];
};


export type QueryInspectionStatusArgs = {
  id: Scalars['Int'];
};


export type QueryInspectionStatusesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryInspectorArgs = {
  id: Scalars['Int'];
};


export type QueryInspectorBlockedDateArgs = {
  id: Scalars['Int'];
};


export type QueryInspectorBlockedDatesArgs = {
  inspectorIdIn?: Maybe<Array<Scalars['Int']>>;
};


export type QueryInspectorCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryInspectorDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryInspectorDocumentsArgs = {
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  inspectorId?: Maybe<Scalars['Int']>;
  isArchived?: Maybe<Scalars['Boolean']>;
};


export type QueryInspectorDocumentTypesArgs = {
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  inspectorId?: Maybe<Scalars['Int']>;
};


export type QueryInspectorInspectionsArgs = {
  aircraftId?: Maybe<Scalars['Int']>;
  includeAllProjects?: Maybe<Scalars['Boolean']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  includePeerInspectionsForInspectors?: Maybe<Scalars['Boolean']>;
  inspectionIdIn?: Maybe<Array<Scalars['Int']>>;
  inspectorIdIn?: Maybe<Array<Scalars['Int']>>;
  paginationOptions?: Maybe<PaginationOptions>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<InspectorInspectionsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type QueryInspectorsArgs = {
  countryIdIn?: Maybe<Array<Scalars['Int']>>;
  coverageAreaRegionIdIn?: Maybe<Array<Scalars['Int']>>;
  hasAppointmentLetterExpirationDate?: Maybe<Scalars['Boolean']>;
  inspectorCategoryIdIn?: Maybe<Array<Scalars['Int']>>;
  inspectorCategoryTypeIdIn?: Maybe<Array<Scalars['Int']>>;
  inspectorPassportCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  inspectorTypeIdIn?: Maybe<Array<Scalars['Int']>>;
  inspectorVisaCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  isActive?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
  regionIdIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<InspectorsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type QueryInvoiceArgs = {
  id: Scalars['Int'];
};


export type QueryInvoicesArgs = {
  aircraftProjectIdIn?: Maybe<Array<Scalars['Int']>>;
  createDate?: Maybe<DateRangeFilterInput>;
  crewProjectIdIn?: Maybe<Array<Scalars['Int']>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  isArgInvoice?: Maybe<Scalars['Boolean']>;
  mechanicProjectIdIn?: Maybe<Array<Scalars['Int']>>;
  paginationOptions?: Maybe<PaginationOptions>;
  sortBy?: Maybe<InvoicesSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type QueryListManagementAircraftEngineManufacturersArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameEquals?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
};


export type QueryListManagementAircraftManufacturersArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameEquals?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
};


export type QueryListManagementAircraftModelsArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
};


export type QueryListManagementAircraftPropellerManufacturersArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameEquals?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
};


export type QueryListManagementCrewRatingsArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
};


export type QueryListManagementEmploymentCompaniesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
};


export type QueryListManagementGenericLvCompaniesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
};


export type QueryListManagementMechanicRatingsArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
};


export type QueryMechanicArgs = {
  id: Scalars['Int'];
};


export type QueryMechanicCertificateTypeArgs = {
  id: Scalars['Int'];
};


export type QueryMechanicCertificateTypesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryMechanicCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryMechanicDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryMechanicDocumentsArgs = {
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  isArchived?: Maybe<Scalars['Boolean']>;
  mechanicId?: Maybe<Scalars['Int']>;
};


export type QueryMechanicDocumentTypesArgs = {
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  mechanicId?: Maybe<Scalars['Int']>;
};


export type QueryMechanicLicenseTypeArgs = {
  id: Scalars['Int'];
};


export type QueryMechanicLicenseTypesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  mechanicPositionIdIn?: Maybe<Array<Scalars['Int']>>;
};


export type QueryMechanicPositionArgs = {
  id: Scalars['Int'];
};


export type QueryMechanicPositionsArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  mechanicLicenseTypeIdIn?: Maybe<Array<Scalars['Int']>>;
};


export type QueryMechanicProjectArgs = {
  id: Scalars['Int'];
};


export type QueryMechanicProjectCertificateArgs = {
  mechanicProjectId: Scalars['Int'];
};


export type QueryMechanicProjectCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryMechanicProjectDcaApprovedByUsersArgs = {
  includeId?: Maybe<Scalars['Int']>;
};


export type QueryMechanicProjectDcaCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryMechanicProjectDcaReviewerUsersArgs = {
  includeId?: Maybe<Scalars['Int']>;
};


export type QueryMechanicProjectDcaSentForApprovalByUsersArgs = {
  includeId?: Maybe<Scalars['Int']>;
};


export type QueryMechanicProjectDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryMechanicProjectDocumentsArgs = {
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  documentTypeId?: Maybe<DocumentTypeEnum>;
  mechanicProjectId?: Maybe<Scalars['Int']>;
};


export type QueryMechanicProjectDocumentTypesArgs = {
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  mechanicProjectId?: Maybe<Scalars['Int']>;
};


export type QueryMechanicProjectEmailHistoryArgs = {
  mechanicProjectId: Scalars['Int'];
  sortBy?: Maybe<EmailHistorySortBy>;
  sortDirection?: Maybe<SortDirection>;
};


export type QueryMechanicProjectHistoryArgs = {
  filter?: Maybe<MechanicProjectHistoryFilter>;
  mechanicProjectId: Scalars['Int'];
  take?: Maybe<Scalars['Int']>;
};


export type QueryMechanicProjectInsFormFieldCommentsArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryMechanicProjectInsFormFieldValuesArgs = {
  projectInsFormVersionId: Scalars['Int'];
};


export type QueryMechanicProjectInsFormsArgs = {
  mechanicProjectId: Scalars['Int'];
};


export type QueryMechanicProjectInsFormsExclusiveGroupsArgs = {
  mechanicProjectId: Scalars['Int'];
};


export type QueryMechanicProjectRenewalChangeTypeArgs = {
  id: Scalars['Int'];
};


export type QueryMechanicProjectRenewalChangeTypesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  mechanicProjectId?: Maybe<Scalars['Int']>;
};


export type QueryMechanicProjectsArgs = {
  archivedDate?: Maybe<DateRangeFilterInput>;
  associatedAircraftProjectIdIn?: Maybe<Array<Scalars['Int']>>;
  certificateDateOfIssue?: Maybe<DateRangeFilterInput>;
  isSubmittedToDca?: Maybe<Scalars['Boolean']>;
  lastNameContains?: Maybe<Scalars['String']>;
  mechanicId?: Maybe<Scalars['Int']>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  paginationOptions?: Maybe<PaginationOptions>;
  projectStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<MechanicProjectsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  validationNumberContains?: Maybe<Scalars['String']>;
};


export type QueryMechanicProjectsForSelectionOnInvoiceArgs = {
  invoiceId?: Maybe<Scalars['Int']>;
};


export type QueryMechanicProjectTypeArgs = {
  id: Scalars['Int'];
};


export type QueryMechanicProjectTypesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryMechanicRatingArgs = {
  id: Scalars['Int'];
};


export type QueryMechanicRatingsArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
  nameEquals?: Maybe<Scalars['String']>;
};


export type QueryMechanicsArgs = {
  aircraftIdIn?: Maybe<Array<Scalars['Int']>>;
  excludeRetired?: Maybe<Scalars['Boolean']>;
  hasCertificationExpiryDate?: Maybe<Scalars['Boolean']>;
  includeProvisional?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  lastNameContains?: Maybe<Scalars['String']>;
  licenseCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  mechanicRatingIdIn?: Maybe<Array<Scalars['Int']>>;
  mechanicStatusId?: Maybe<Scalars['Int']>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  paginationOptions?: Maybe<PaginationOptions>;
  sortBy?: Maybe<MechanicsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type QueryMechanicsForOperatorAddMechanicProjectArgs = {
  lastNameContains?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['Int']>;
};


export type QueryMechanicStatusArgs = {
  id: Scalars['Int'];
};


export type QueryMechanicStatusesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryMyPreviousRecipientsArgs = {
  filter?: Maybe<Scalars['String']>;
};


export type QueryOperatorArgs = {
  id: Scalars['Int'];
};


export type QueryOperatorDocumentTypesArgs = {
  companyId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
};


export type QueryOperatorsArgs = {
  countryIdIn?: Maybe<Array<Scalars['Int']>>;
  hasActiveAircraft?: Maybe<Scalars['Boolean']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  nameContains?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
  regionIdIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<OperatorsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type QueryOwnerArgs = {
  id: Scalars['Int'];
};


export type QueryOwnerDocumentTypesArgs = {
  companyId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
};


export type QueryOwnersArgs = {
  countryIdIn?: Maybe<Array<Scalars['Int']>>;
  hasActiveAircraft?: Maybe<Scalars['Boolean']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  nameContains?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
  regionIdIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<OwnersSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type QueryPaymentStatusArgs = {
  id: Scalars['Int'];
};


export type QueryPaymentStatusesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryProjectInsFormVersionByExecutionKeyArgs = {
  key: Scalars['String'];
};


export type QueryProjectInsFormVersionCommentsArgs = {
  id: Scalars['Int'];
};


export type QueryProjectStatusArgs = {
  id: Scalars['Int'];
};


export type QueryProjectStatusesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryRegionArgs = {
  id: Scalars['Int'];
};


export type QueryRegionsArgs = {
  countryIdIn?: Maybe<Array<Scalars['Int']>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryRegisteredHolderArgs = {
  id: Scalars['Int'];
};


export type QueryRegisteredHolderDocumentTypesArgs = {
  companyId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
};


export type QueryRegisteredHoldersArgs = {
  countryIdIn?: Maybe<Array<Scalars['Int']>>;
  hasActiveAircraft?: Maybe<Scalars['Boolean']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  nameContains?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
  regionIdIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<RegisteredHoldersSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type QueryReminderApplicabilitiesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryReminderApplicabilityArgs = {
  id: Scalars['Int'];
};


export type QueryRemindersArgs = {
  createdByUserIdIn?: Maybe<Array<Scalars['Int']>>;
  reminderApplicabilityIdIn?: Maybe<Array<Scalars['Int']>>;
  reminderDate?: Maybe<DateRangeFilterInput>;
  sortBy?: Maybe<RemindersSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type QueryRoleArgs = {
  id: Scalars['Int'];
};


export type QueryStateArgs = {
  id: Scalars['Int'];
};


export type QueryStatesArgs = {
  countryIdIn?: Maybe<Array<Scalars['Int']>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
};


export type QueryUserArgs = {
  id: Scalars['Int'];
};


export type QueryUsersArgs = {
  departmentIdIn?: Maybe<Array<Scalars['Int']>>;
  idIn?: Maybe<Array<Scalars['Int']>>;
  isActive?: Maybe<Scalars['Boolean']>;
  paginationOptions?: Maybe<PaginationOptions>;
  roleIdIn?: Maybe<Array<Scalars['Int']>>;
  skip?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<UsersSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  take?: Maybe<Scalars['Int']>;
};


export type QueryValidateCrewCertificateOfValidationQrCodeV1Args = {
  qrCodeUrlSearchParams: Scalars['String'];
};


export type QueryValidateCrewCertificateOfValidationQrCodeV2Args = {
  qrCodeUrlSearchParams: Scalars['String'];
};


export type QueryValidateLegacyCrewCertificateOfValidationQrCodeArgs = {
  identifier?: Maybe<Scalars['String']>;
};


export type QueryValidateMechanicCertificateOfValidationQrCodeV1Args = {
  qrCodeUrlSearchParams: Scalars['String'];
};

export type Region = {
  countries: Array<Country>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};


export type RegionCountriesArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  regionIdIn?: Maybe<Array<Scalars['Int']>>;
};

export type RegisteredHolder = {
  aircraft: Array<Aircraft>;
  company: Company;
  documentTypes: Array<DocumentType>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
};


export type RegisteredHolderAircraftArgs = {
  includeDeleted?: Maybe<Scalars['Boolean']>;
  includeRetired?: Maybe<Scalars['Boolean']>;
  registeredHolderId?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<AircraftsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
};


export type RegisteredHolderDocumentTypesArgs = {
  documentTypeCategoryId?: Maybe<Scalars['Float']>;
};

export type RegisteredHolderInput = {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  corporateEmailAddress?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  goodStandingLetterIssueDate?: Maybe<Scalars['DateTime']>;
  incorporationDate?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAlsoOperator?: Maybe<Scalars['Boolean']>;
  isAlsoOwner?: Maybe<Scalars['Boolean']>;
  isAlsoRegisteredHolder?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<PhoneNumberInput>>;
  regionId?: Maybe<Scalars['Int']>;
  stateId?: Maybe<Scalars['Int']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type RegisteredHolders = {
  registeredHolders: Array<RegisteredHolder>;
};

export type RegisteredHoldersResult = PaginatedRegisteredHolders | RegisteredHolders;

export enum RegisteredHoldersSortBy {
  Country = 'country',
  GoodStandingLetterIssueDate = 'goodStandingLetterIssueDate',
  IsActive = 'isActive',
  Name = 'name',
  Region = 'region',
  State = 'state'
}

export type Reminder = {
  createDate: Scalars['DateTime'];
  createdByUser: User;
  id: Scalars['Int'];
  isSent: Scalars['Boolean'];
  otherUsers: Array<User>;
  reminderApplicability: ReminderApplicability;
  reminderDate: Scalars['DateTime'];
  reminderText: Scalars['String'];
  sendErrorMessage?: Maybe<Scalars['String']>;
};

export type ReminderApplicability = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ReminderInput = {
  otherUserIds?: Maybe<Array<Scalars['Int']>>;
  reminderApplicabilityId?: Maybe<Scalars['Int']>;
  reminderDate: Scalars['DateTime'];
  reminderText?: Maybe<Scalars['String']>;
};

export enum RemindersSortBy {
  AppliesTo = 'appliesTo',
  CreateDate = 'createDate',
  CreatedBy = 'createdBy',
  ReminderDate = 'reminderDate'
}

export type Role = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type SendAircraftProjectToIasoInput = {
  id?: Maybe<Scalars['Int']>;
  pendingDocsFromIaso?: Maybe<Scalars['Boolean']>;
  pendingOther?: Maybe<Scalars['Boolean']>;
  pendingReason?: Maybe<Scalars['String']>;
};

export type SendAmoProjectToIasoInput = {
  id?: Maybe<Scalars['Int']>;
  pendingDocsFromIaso?: Maybe<Scalars['Boolean']>;
  pendingOther?: Maybe<Scalars['Boolean']>;
  pendingReason?: Maybe<Scalars['String']>;
};

export type SendCrewProjectToIasoInput = {
  id?: Maybe<Scalars['Int']>;
  pendingDocsFromIaso?: Maybe<Scalars['Boolean']>;
  pendingLicenseVerification?: Maybe<Scalars['Boolean']>;
  pendingOther?: Maybe<Scalars['Boolean']>;
  pendingReason?: Maybe<Scalars['String']>;
};

export type SendForExecutionInput = {
  projectInsFormVersionId?: Maybe<Scalars['Int']>;
  recipientEmailAddresses?: Maybe<Array<Scalars['String']>>;
};

export type SendMechanicProjectToIasoInput = {
  id?: Maybe<Scalars['Int']>;
  pendingDocsFromIaso?: Maybe<Scalars['Boolean']>;
  pendingLicenseVerification?: Maybe<Scalars['Boolean']>;
  pendingOther?: Maybe<Scalars['Boolean']>;
  pendingReason?: Maybe<Scalars['String']>;
};

export type SignProjectInsFormVersionInput = {
  date?: Maybe<Scalars['String']>;
  fieldNumber?: Maybe<Scalars['Int']>;
  signeeJobTitle?: Maybe<Scalars['String']>;
  signeeName?: Maybe<Scalars['String']>;
};

export type SignProjectInsFormVersionInputWithSignatureImageInput = {
  date?: Maybe<Scalars['String']>;
  fieldNumber?: Maybe<Scalars['Int']>;
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
};

export type SignProjectInsFormVersionResult = {
  areAllSignaturesAcquired: Scalars['Boolean'];
  warnings?: Maybe<Array<Scalars['String']>>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type State = {
  country: Country;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

export type TransitionProjectInput = {
  id?: Maybe<Scalars['Int']>;
  transitionId?: Maybe<Scalars['Int']>;
};

export type UpdateAircraftDocumentInput = {
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateAircraftInput = {
  aircraftCategoryId?: Maybe<Scalars['Int']>;
  aircraftClassId?: Maybe<Scalars['Int']>;
  aircraftEngineManufacturerId?: Maybe<Scalars['Int']>;
  aircraftManufacturerId?: Maybe<Scalars['Int']>;
  aircraftModelId?: Maybe<Scalars['Int']>;
  aircraftPropellerManufacturerId?: Maybe<Scalars['Int']>;
  aircraftStatusId?: Maybe<Scalars['Int']>;
  aircraftTypeId?: Maybe<Scalars['Int']>;
  baseOfOperationsAddress?: Maybe<Scalars['String']>;
  baseOfOperationsCity?: Maybe<Scalars['String']>;
  baseOfOperationsCountryId?: Maybe<Scalars['Int']>;
  baseOfOperationsStateId?: Maybe<Scalars['Int']>;
  baseOfOperationsZipCode?: Maybe<Scalars['String']>;
  deregistrationDate?: Maybe<Scalars['DateTime']>;
  documentChangeDescriptions?: Maybe<Array<Scalars['String']>>;
  homeBaseAddress?: Maybe<Scalars['String']>;
  homeBaseCity?: Maybe<Scalars['String']>;
  homeBaseCountryId?: Maybe<Scalars['Int']>;
  homeBaseStateId?: Maybe<Scalars['Int']>;
  homeBaseZipCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  initialRegistrationDate?: Maybe<Scalars['DateTime']>;
  isAircraftImageFileAttachmentRemoved?: Maybe<Scalars['Boolean']>;
  isAircraftStatusUncertain?: Maybe<Scalars['Boolean']>;
  isHomeBaseSameAsBaseOfOperations?: Maybe<Scalars['Boolean']>;
  mlw?: Maybe<Scalars['Int']>;
  mtow?: Maybe<Scalars['Int']>;
  newAircraftEngineManufacturer?: Maybe<Scalars['String']>;
  newAircraftImageFileAttachmentId?: Maybe<Scalars['Int']>;
  newAircraftManufacturer?: Maybe<Scalars['String']>;
  newAircraftModel?: Maybe<Scalars['String']>;
  newAircraftPropellerManufacturer?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  numberOfPaxSeats?: Maybe<Scalars['Int']>;
  operatorId?: Maybe<Scalars['Int']>;
  ownerId?: Maybe<Scalars['Int']>;
  priorRegistrationMarks?: Maybe<Scalars['String']>;
  registeredHolderId?: Maybe<Scalars['Int']>;
  registrationMark?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  targetReleaseDateToService?: Maybe<Scalars['DateTime']>;
  uboName?: Maybe<Scalars['String']>;
  uboNationality?: Maybe<Scalars['String']>;
  uboNationalityId?: Maybe<Scalars['Int']>;
  yearOfManufacture?: Maybe<Scalars['Int']>;
};

export type UpdateAircraftInsFormAssociatedDocumentInput = {
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  insFormId?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateAircraftOperationalApprovalInput = {
  acars?: Maybe<Scalars['Boolean']>;
  ads_b?: Maybe<Scalars['Boolean']>;
  aircraftId?: Maybe<Scalars['Int']>;
  allWeatherOpsMeters?: Maybe<Scalars['Boolean']>;
  atnb1_cpdlc?: Maybe<Scalars['Boolean']>;
  basicRnp1?: Maybe<Scalars['Boolean']>;
  cat1?: Maybe<Scalars['Boolean']>;
  cat1_dh?: Maybe<Scalars['Int']>;
  cat1_minima?: Maybe<Scalars['Int']>;
  cat1_rvr?: Maybe<Scalars['Int']>;
  cat2?: Maybe<Scalars['Boolean']>;
  cat2_3a?: Maybe<Scalars['Boolean']>;
  cat2_3a_3b?: Maybe<Scalars['Boolean']>;
  cat2_3a_3b_3c?: Maybe<Scalars['Boolean']>;
  cat2_3a_3b_3c_dh?: Maybe<Scalars['Int']>;
  cat2_3a_3b_3c_minima?: Maybe<Scalars['Int']>;
  cat2_3a_3b_3c_rvr?: Maybe<Scalars['Int']>;
  cat2_3a_3b_dh?: Maybe<Scalars['Int']>;
  cat2_3a_3b_minima?: Maybe<Scalars['Int']>;
  cat2_3a_3b_rvr?: Maybe<Scalars['Int']>;
  cat2_3a_dh?: Maybe<Scalars['Int']>;
  cat2_3a_minima?: Maybe<Scalars['Int']>;
  cat2_3a_rvr?: Maybe<Scalars['Int']>;
  cat2_dh?: Maybe<Scalars['Int']>;
  cat2_minima?: Maybe<Scalars['Int']>;
  cat2_rvr?: Maybe<Scalars['Int']>;
  cpdlc_adsc?: Maybe<Scalars['Boolean']>;
  cpdlc_fan1A?: Maybe<Scalars['Boolean']>;
  cpdlc_fan1A_plus?: Maybe<Scalars['Boolean']>;
  cvs?: Maybe<Scalars['Boolean']>;
  dataStorageDeviceCdDvd?: Maybe<Scalars['Boolean']>;
  dataStorageDeviceInstalled?: Maybe<Scalars['Boolean']>;
  dataStorageDeviceMakeAndType?: Maybe<Scalars['String']>;
  dataStorageDeviceNotebook?: Maybe<Scalars['Boolean']>;
  dataStorageDeviceNotepad?: Maybe<Scalars['Boolean']>;
  dataStorageDeviceOther?: Maybe<Scalars['Boolean']>;
  dataStorageDeviceOtherDetail?: Maybe<Scalars['String']>;
  dataStorageDevicePda?: Maybe<Scalars['Boolean']>;
  efb_status?: Maybe<Scalars['String']>;
  efb_status_temporary_expiryDate?: Maybe<Scalars['DateTime']>;
  etops_edto?: Maybe<Scalars['Boolean']>;
  evs_efvs?: Maybe<Scalars['Boolean']>;
  fmc?: Maybe<Scalars['Boolean']>;
  gps?: Maybe<Scalars['Boolean']>;
  hardwareClass1?: Maybe<Scalars['Boolean']>;
  hardwareClass2?: Maybe<Scalars['Boolean']>;
  hardwareClass3?: Maybe<Scalars['Boolean']>;
  hardwareMakeAndType?: Maybe<Scalars['String']>;
  hud?: Maybe<Scalars['Boolean']>;
  hudMakeAndType?: Maybe<Scalars['String']>;
  lvto?: Maybe<Scalars['Boolean']>;
  lvto_dh?: Maybe<Scalars['Int']>;
  lvto_minima?: Maybe<Scalars['Int']>;
  lvto_rvr?: Maybe<Scalars['Int']>;
  maximumDiversionTime?: Maybe<Scalars['Int']>;
  nat_hla_rvsm?: Maybe<Scalars['Boolean']>;
  nvg_nvis?: Maybe<Scalars['Boolean']>;
  opCreditRequestedYes?: Maybe<Scalars['Boolean']>;
  pm_cpdlc?: Maybe<Scalars['Boolean']>;
  rnav1?: Maybe<Scalars['Boolean']>;
  rnav2?: Maybe<Scalars['Boolean']>;
  rnav5?: Maybe<Scalars['Boolean']>;
  rnp_apch?: Maybe<Scalars['Boolean']>;
  rnp_ar?: Maybe<Scalars['Boolean']>;
  rnp10?: Maybe<Scalars['Boolean']>;
  rnp4?: Maybe<Scalars['Boolean']>;
  rvsm?: Maybe<Scalars['Boolean']>;
  singlePilot?: Maybe<Scalars['Boolean']>;
  softwareAppTypeA?: Maybe<Scalars['Boolean']>;
  svs?: Maybe<Scalars['Boolean']>;
};

export type UpdateAircraftProjectDocumentInput = {
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateAircraftProjectInput = {
  acarsAts?: Maybe<Scalars['Boolean']>;
  acarsAtsDescription?: Maybe<Scalars['String']>;
  acarsAtsRemarks?: Maybe<Scalars['String']>;
  adsBOut?: Maybe<Scalars['Boolean']>;
  adsBOutDescription?: Maybe<Scalars['String']>;
  adsBOutRemarks?: Maybe<Scalars['String']>;
  aircraftCategoryId?: Maybe<Scalars['Int']>;
  aircraftClassId?: Maybe<Scalars['Int']>;
  aircraftEngineManufacturerId?: Maybe<Scalars['Int']>;
  aircraftManufacturerId?: Maybe<Scalars['Int']>;
  aircraftModelId?: Maybe<Scalars['Int']>;
  aircraftPropellerManufacturerId?: Maybe<Scalars['Int']>;
  aircraftRadioStationLicenseCtcDaysValid?: Maybe<Scalars['Int']>;
  aircraftRadioStationLicenseExpiryDate?: Maybe<Scalars['DateTime']>;
  aircraftRadioStationLicenseIssueDate?: Maybe<Scalars['DateTime']>;
  aircraftRadioStationLicenseNumber?: Maybe<Scalars['String']>;
  aircraftStatusId?: Maybe<Scalars['Int']>;
  aircraftTypeId?: Maybe<Scalars['Int']>;
  airspaceAndSpecialApprovalCertificateNumber?: Maybe<Scalars['String']>;
  airspaceApprovalCertificateCtcDaysValid?: Maybe<Scalars['Int']>;
  airspaceApprovalCertificateExpiryDate?: Maybe<Scalars['DateTime']>;
  airspaceApprovalCertificateIssueDate?: Maybe<Scalars['DateTime']>;
  assignedDepartmentIds?: Maybe<Array<Scalars['Int']>>;
  assignedUserIds?: Maybe<Array<Scalars['Int']>>;
  atnb1CpdlcLink2000Plus?: Maybe<Scalars['Boolean']>;
  atnb1CpdlcLink2000PlusDescription?: Maybe<Scalars['String']>;
  atnb1CpdlcLink2000PlusRemarks?: Maybe<Scalars['String']>;
  baseOfOperationsAddress?: Maybe<Scalars['String']>;
  baseOfOperationsCity?: Maybe<Scalars['String']>;
  baseOfOperationsCountryId?: Maybe<Scalars['Int']>;
  baseOfOperationsStateId?: Maybe<Scalars['Int']>;
  baseOfOperationsZipCode?: Maybe<Scalars['String']>;
  basicRnp1?: Maybe<Scalars['Boolean']>;
  basicRnp1Description?: Maybe<Scalars['String']>;
  basicRnp1Remarks?: Maybe<Scalars['String']>;
  cat1Lts?: Maybe<Scalars['Boolean']>;
  cat1LtsRemarks?: Maybe<Scalars['String']>;
  cat1LtsRvr?: Maybe<Scalars['Int']>;
  cat2?: Maybe<Scalars['Boolean']>;
  cat2Dh?: Maybe<Scalars['Int']>;
  cat2Remarks?: Maybe<Scalars['String']>;
  cat2Rvr?: Maybe<Scalars['Int']>;
  cat3?: Maybe<Scalars['Boolean']>;
  cat3Dh?: Maybe<Scalars['Int']>;
  cat3Remarks?: Maybe<Scalars['String']>;
  cat3Rvr?: Maybe<Scalars['Int']>;
  certificateOfAirworthinessCtcDaysValid?: Maybe<Scalars['Int']>;
  certificateOfAirworthinessExpirationDate?: Maybe<Scalars['DateTime']>;
  certificateOfAirworthinessIssueDate?: Maybe<Scalars['DateTime']>;
  certificateOfRegistrationCtcDaysValid?: Maybe<Scalars['Int']>;
  certificateOfRegistrationExpirationDate?: Maybe<Scalars['DateTime']>;
  certificateOfRegistrationIssueDate?: Maybe<Scalars['DateTime']>;
  clientSubmissionDate?: Maybe<Scalars['DateTime']>;
  cofaCertificateNumber?: Maybe<Scalars['String']>;
  cofrCertificateNumber?: Maybe<Scalars['String']>;
  cofrOwnerRemark?: Maybe<Scalars['String']>;
  cpdlcAdsCFans1APlus?: Maybe<Scalars['Boolean']>;
  cpdlcAdsCFans1APlusRcp?: Maybe<Scalars['Int']>;
  cpdlcAdsCFans1APlusRemarks?: Maybe<Scalars['String']>;
  cpdlcAdsCFans1APlusRsp?: Maybe<Scalars['Int']>;
  cpdlcFans1A?: Maybe<Scalars['Boolean']>;
  cpdlcFans1APlus?: Maybe<Scalars['Boolean']>;
  cpdlcFans1APlusRcp?: Maybe<Scalars['Int']>;
  cpdlcFans1APlusRemarks?: Maybe<Scalars['String']>;
  cpdlcFans1APlusRsp?: Maybe<Scalars['Int']>;
  cpdlcFans1ARcp?: Maybe<Scalars['Int']>;
  cpdlcFans1ARemarks?: Maybe<Scalars['String']>;
  cpdlcFans1ARsp?: Maybe<Scalars['Int']>;
  dcaAircraftEngineManufacturer?: Maybe<Scalars['String']>;
  dcaAircraftManufacturer?: Maybe<Scalars['String']>;
  dcaAircraftModel?: Maybe<Scalars['String']>;
  dcaAircraftPropellerManufacturer?: Maybe<Scalars['String']>;
  dcaApproachNoiseLevel?: Maybe<Scalars['Float']>;
  dcaFlyoverNoiseLevel?: Maybe<Scalars['Float']>;
  dcaIsOverflightNoiseLevelInDBASELUnits?: Maybe<Scalars['Boolean']>;
  dcaLateralFullPowerNoiseLevel?: Maybe<Scalars['Float']>;
  dcaMlw?: Maybe<Scalars['String']>;
  dcaMtow?: Maybe<Scalars['String']>;
  dcaNoiseCertificationAdditionalModifications?: Maybe<Scalars['String']>;
  dcaNoiseCertificationRemarks?: Maybe<Scalars['String']>;
  dcaNoiseCertificationStandard?: Maybe<Scalars['String']>;
  dcaOperator?: Maybe<Scalars['String']>;
  dcaOperatorAddress?: Maybe<Scalars['String']>;
  dcaOperatorAddressCountry?: Maybe<Scalars['String']>;
  dcaOverflightNoiseLevel?: Maybe<Scalars['Float']>;
  dcaOwner?: Maybe<Scalars['String']>;
  dcaOwnerAddress?: Maybe<Scalars['String']>;
  dcaOwnerAddressCountry?: Maybe<Scalars['String']>;
  dcaOwnerOperator?: Maybe<Scalars['String']>;
  dcaOwnerOperatorAddress?: Maybe<Scalars['String']>;
  dcaOwnerOperatorEmailAddress?: Maybe<Scalars['String']>;
  dcaOwnerOperatorFax?: Maybe<Scalars['String']>;
  dcaOwnerOperatorPhone?: Maybe<Scalars['String']>;
  dcaRegisteredHolder?: Maybe<Scalars['String']>;
  dcaRegisteredHolderAddress?: Maybe<Scalars['String']>;
  dcaRegisteredHolderAddressCountry?: Maybe<Scalars['String']>;
  dcaSubmissionDate?: Maybe<Scalars['DateTime']>;
  dcaTakeoffNoiseLevel?: Maybe<Scalars['Float']>;
  deregistrationDate?: Maybe<Scalars['DateTime']>;
  edtoEtops?: Maybe<Scalars['Boolean']>;
  edtoEtopsMinutes?: Maybe<Scalars['String']>;
  edtoEtopsRemarks?: Maybe<Scalars['String']>;
  efb?: Maybe<Scalars['Boolean']>;
  efbCategoryInstalled?: Maybe<Scalars['Boolean']>;
  efbCategoryPortable?: Maybe<Scalars['Boolean']>;
  efbRemarks?: Maybe<Scalars['String']>;
  exportAcTcCycles?: Maybe<Scalars['Int']>;
  exportAcTtHours?: Maybe<Scalars['Int']>;
  exportAcTtMinutes?: Maybe<Scalars['Int']>;
  exportCofaCertificateNumber?: Maybe<Scalars['String']>;
  exportCountry?: Maybe<Scalars['String']>;
  exportDate?: Maybe<Scalars['DateTime']>;
  exportExceptions?: Maybe<Scalars['String']>;
  exportIsNew?: Maybe<Scalars['Boolean']>;
  exportIsNewlyOverhauled?: Maybe<Scalars['Boolean']>;
  exportIsUsed?: Maybe<Scalars['Boolean']>;
  exportLhEngine?: Maybe<Scalars['String']>;
  exportLhEngineSerialNumber?: Maybe<Scalars['String']>;
  exportLhEngineTcCycles?: Maybe<Scalars['Int']>;
  exportLhEngineTtHours?: Maybe<Scalars['Int']>;
  exportLhEngineTtMinutes?: Maybe<Scalars['Int']>;
  exportProduct?: Maybe<Scalars['String']>;
  exportRemarks?: Maybe<Scalars['String']>;
  exportRhEngine?: Maybe<Scalars['String']>;
  exportRhEngineSerialNumber?: Maybe<Scalars['String']>;
  exportRhEngineTcCycles?: Maybe<Scalars['Int']>;
  exportRhEngineTtHours?: Maybe<Scalars['Int']>;
  exportRhEngineTtMinutes?: Maybe<Scalars['Int']>;
  exportTCHolder?: Maybe<Scalars['String']>;
  fmcWpr?: Maybe<Scalars['Boolean']>;
  fmcWprDescription?: Maybe<Scalars['String']>;
  fmcWprRemarks?: Maybe<Scalars['String']>;
  homeBaseAddress?: Maybe<Scalars['String']>;
  homeBaseCity?: Maybe<Scalars['String']>;
  homeBaseCountryId?: Maybe<Scalars['Int']>;
  homeBaseStateId?: Maybe<Scalars['Int']>;
  homeBaseZipCode?: Maybe<Scalars['String']>;
  hudEvsSvsCvs?: Maybe<Scalars['Boolean']>;
  hudEvsSvsCvsDescription?: Maybe<Scalars['String']>;
  hudEvsSvsCvsRemarks?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  initialRegistrationDate?: Maybe<Scalars['DateTime']>;
  isAircraftImageFileAttachmentRemoved?: Maybe<Scalars['Boolean']>;
  isAircraftRadioStationLicenseExpiryIndefinite?: Maybe<Scalars['Boolean']>;
  isAircraftStatusUncertain?: Maybe<Scalars['Boolean']>;
  isAirspaceApprovalCertificateExpiryIndefinite?: Maybe<Scalars['Boolean']>;
  isHomeBaseSameAsBaseOfOperations?: Maybe<Scalars['Boolean']>;
  isNoiseCertificateExpiryIndefinite?: Maybe<Scalars['Boolean']>;
  lvto?: Maybe<Scalars['Boolean']>;
  lvtoRemarks?: Maybe<Scalars['String']>;
  lvtoRvr?: Maybe<Scalars['Int']>;
  mlw?: Maybe<Scalars['Int']>;
  mtow?: Maybe<Scalars['Int']>;
  natHlaMnps?: Maybe<Scalars['Boolean']>;
  natHlaMnpsDescription?: Maybe<Scalars['String']>;
  natHlaMnpsRemarks?: Maybe<Scalars['String']>;
  newAircraftEngineManufacturer?: Maybe<Scalars['String']>;
  newAircraftImageFileAttachmentId?: Maybe<Scalars['Int']>;
  newAircraftManufacturer?: Maybe<Scalars['String']>;
  newAircraftModel?: Maybe<Scalars['String']>;
  newAircraftPropellerManufacturer?: Maybe<Scalars['String']>;
  noiseCertificateCtcDaysValid?: Maybe<Scalars['Int']>;
  noiseCertificateExpiryDate?: Maybe<Scalars['DateTime']>;
  noiseCertificateIssueDate?: Maybe<Scalars['DateTime']>;
  noiseCertificateNumber?: Maybe<Scalars['String']>;
  numberOfPaxSeats?: Maybe<Scalars['Int']>;
  operatorId?: Maybe<Scalars['Int']>;
  ownerId?: Maybe<Scalars['Int']>;
  pmCpdlc?: Maybe<Scalars['Boolean']>;
  pmCpdlcDescription?: Maybe<Scalars['String']>;
  pmCpdlcRemarks?: Maybe<Scalars['String']>;
  preparedByDcaUserId?: Maybe<Scalars['Int']>;
  priorRegistrationMarks?: Maybe<Scalars['String']>;
  projectNumber?: Maybe<Scalars['String']>;
  registeredHolderId?: Maybe<Scalars['Int']>;
  registrationMark?: Maybe<Scalars['String']>;
  rnav1PRnav?: Maybe<Scalars['Boolean']>;
  rnav1PRnavDescription?: Maybe<Scalars['String']>;
  rnav1PRnavRemarks?: Maybe<Scalars['String']>;
  rnav2?: Maybe<Scalars['Boolean']>;
  rnav2Description?: Maybe<Scalars['String']>;
  rnav2Remarks?: Maybe<Scalars['String']>;
  rnav5BRnav?: Maybe<Scalars['Boolean']>;
  rnav5BRnavDescription?: Maybe<Scalars['String']>;
  rnav5BRnavRemarks?: Maybe<Scalars['String']>;
  rnp10?: Maybe<Scalars['Boolean']>;
  rnp10Description?: Maybe<Scalars['String']>;
  rnp10Remarks?: Maybe<Scalars['String']>;
  rnp4?: Maybe<Scalars['Boolean']>;
  rnp4Description?: Maybe<Scalars['String']>;
  rnp4Remarks?: Maybe<Scalars['String']>;
  rnpApch?: Maybe<Scalars['Boolean']>;
  rnpApchDescription?: Maybe<Scalars['String']>;
  rnpApchRemarks?: Maybe<Scalars['String']>;
  rnpAr?: Maybe<Scalars['Boolean']>;
  rnpArDescription?: Maybe<Scalars['String']>;
  rnpArRemarks?: Maybe<Scalars['String']>;
  rvsm?: Maybe<Scalars['Boolean']>;
  rvsmDescription?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  sfpEvacuationFerryFlightFrom?: Maybe<Scalars['String']>;
  sfpEvacuationFerryFlightTo?: Maybe<Scalars['String']>;
  sfpEvacuationFerryFlightVia?: Maybe<Scalars['String']>;
  sfpFerryFlightFrom?: Maybe<Scalars['String']>;
  sfpFerryFlightTo?: Maybe<Scalars['String']>;
  sfpInterimCofAIsNormal?: Maybe<Scalars['Boolean']>;
  sfpInterimCofAIsRadioStationLicense?: Maybe<Scalars['Boolean']>;
  sfpInterimCofAIsRestricted?: Maybe<Scalars['Boolean']>;
  sfpInterimCofAIsTransport?: Maybe<Scalars['Boolean']>;
  sfpIsEvacuationFerryFlight?: Maybe<Scalars['Boolean']>;
  sfpIsFerryFlight?: Maybe<Scalars['Boolean']>;
  sfpIsFlightPermit?: Maybe<Scalars['Boolean']>;
  sfpIsInterimCofA?: Maybe<Scalars['Boolean']>;
  sfpIsOnlyAuthorityAorBApproved?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition1?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition10?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition11?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition12?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition13?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition14?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition2?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition3?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition4?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition5?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition6?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition7?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition8?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialCondition9?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialConditionA?: Maybe<Scalars['Boolean']>;
  sfpIsSpecialConditionB?: Maybe<Scalars['Boolean']>;
  sfpIsSubjectToSpecialConditions?: Maybe<Scalars['Boolean']>;
  sfpIssueDate?: Maybe<Scalars['DateTime']>;
  sfpIssuedTo?: Maybe<Scalars['String']>;
  sfpIssueNumber1?: Maybe<Scalars['String']>;
  sfpIssueNumber2?: Maybe<Scalars['String']>;
  sfpIsTestFlight?: Maybe<Scalars['Boolean']>;
  sfpNumber?: Maybe<Scalars['String']>;
  sfpRevision?: Maybe<Scalars['String']>;
  sfpSpecialCondition13HoursOfFlight?: Maybe<Scalars['Int']>;
  sfpSpecialCondition13HoursOfPilot?: Maybe<Scalars['Int']>;
  sfpSpecialCondition14Other?: Maybe<Scalars['String']>;
  sfpSpecialCondition2Mtow?: Maybe<Scalars['String']>;
  sfpSpecialCondition3License1?: Maybe<Scalars['String']>;
  sfpSpecialCondition3License2?: Maybe<Scalars['String']>;
  sfpSpecialCondition3License3?: Maybe<Scalars['String']>;
  sfpSpecialCondition3License4?: Maybe<Scalars['String']>;
  sfpSpecialCondition3License5?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Name1?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Name2?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Name3?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Name4?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Name5?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Position1?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Position2?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Position3?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Position4?: Maybe<Scalars['String']>;
  sfpSpecialCondition3Position5?: Maybe<Scalars['String']>;
  sfpSpecialCondition8Base?: Maybe<Scalars['String']>;
  sfpSpecialCondition9Base?: Maybe<Scalars['String']>;
  sfpSpecialCondition9Miles?: Maybe<Scalars['Int']>;
  sfpSpecialConditionANumberOfFlights?: Maybe<Scalars['Int']>;
  sfpSpecialConditionAUntilDate?: Maybe<Scalars['DateTime']>;
  sfpSpecialConditionBUntilReceipt?: Maybe<Scalars['DateTime']>;
  sfpTestFlightsRadius?: Maybe<Scalars['String']>;
  sfpTestFlightsWithinDistance?: Maybe<Scalars['String']>;
  steepApproach?: Maybe<Scalars['Boolean']>;
  steepApproachAirport?: Maybe<Scalars['String']>;
  steepApproachRemarks?: Maybe<Scalars['String']>;
  targetReleaseDateToService?: Maybe<Scalars['DateTime']>;
  uboName?: Maybe<Scalars['String']>;
  uboNationality?: Maybe<Scalars['String']>;
  uboNationalityId?: Maybe<Scalars['Int']>;
  yearOfManufacture?: Maybe<Scalars['Int']>;
};

export type UpdateAircraftProjectInsFormAssociatedDocumentInput = {
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  insFormId?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateAircraftProjectInspectionInsForm16005AInput = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  insForm16005AFileAttachmentId?: Maybe<Scalars['Int']>;
  inspectionId?: Maybe<Scalars['Int']>;
};

export type UpdateAircraftProjectInspectionInsForm4001Input = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  insForm4001FileAttachmentId?: Maybe<Scalars['Int']>;
  inspectionId?: Maybe<Scalars['Int']>;
};

export type UpdateAircraftProjectInspectionInsForm4007Input = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  insForm4007FileAttachmentId?: Maybe<Scalars['Int']>;
  inspectionId?: Maybe<Scalars['Int']>;
};

export type UpdateAircraftProjectInspectionInsForm4023BInput = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  insForm4023BFileAttachmentId?: Maybe<Scalars['Int']>;
  inspectionId?: Maybe<Scalars['Int']>;
};

export type UpdateAircraftProjectInspectionInsForm4045Input = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  insForm4045FileAttachmentId?: Maybe<Scalars['Int']>;
  inspectionId?: Maybe<Scalars['Int']>;
};

export type UpdateAircraftProjectInspectionInspectionEstimateInput = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  inspectionEstimateFileAttachmentId?: Maybe<Scalars['Int']>;
  inspectionId?: Maybe<Scalars['Int']>;
  inspectorInspectionId?: Maybe<Scalars['Int']>;
};

export type UpdateAircraftProjectInspectionInspectionInvoiceInput = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  inspectionId?: Maybe<Scalars['Int']>;
  inspectionInvoiceFileAttachmentId?: Maybe<Scalars['Int']>;
  inspectorInspectionId?: Maybe<Scalars['Int']>;
};

export type UpdateAircraftProjectInspectionInspectionTimeLogInput = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  inspectionId?: Maybe<Scalars['Int']>;
  inspectionTimeLogFileAttachmentId?: Maybe<Scalars['Int']>;
  inspectorInspectionId?: Maybe<Scalars['Int']>;
};

export type UpdateAircraftProjectInspectionLetterOfFindingsInput = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  inspectionId?: Maybe<Scalars['Int']>;
  letterOfFindingsFileAttachmentId?: Maybe<Scalars['Int']>;
};

export type UpdateAircraftProjectInspectionsInput = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  inspections?: Maybe<Array<UpdateInspectionGraphInspectionInput>>;
};

export type UpdateAircraftProjectOfficialLetterNotesInput = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  documentTypeNotes?: Maybe<Array<UpdateProjectDocumentTypeOfficialLetterNoteInput>>;
  officialLetterDocumentsNote?: Maybe<Scalars['String']>;
};

export type UpdateAircraftProjectOperatorDocumentReleasedToDcaInput = {
  id?: Maybe<Scalars['Int']>;
  isReleasedToDca?: Maybe<Scalars['Boolean']>;
};

export type UpdateAircraftProjectOperatorInsFormAssociatedDocumentReleasedToDcaInput = {
  id?: Maybe<Scalars['Int']>;
  isReleasedToDca?: Maybe<Scalars['Boolean']>;
};

export type UpdateAircraftProjectResult = {
  aircraftProject?: Maybe<AircraftProject>;
  warnings?: Maybe<Array<Scalars['String']>>;
};

export type UpdateAllAircraftProjectOperatorDocumentsReleasedToDcaInput = {
  aircraftProjectId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  isReleasedToDca?: Maybe<Scalars['Boolean']>;
};

export type UpdateAllAmoProjectDocumentsReleasedToDcaInput = {
  amoProjectId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  isReleasedToDca?: Maybe<Scalars['Boolean']>;
};

export type UpdateAllCrewProjectDocumentsReleasedToDcaInput = {
  crewProjectId?: Maybe<Scalars['Int']>;
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  isReleasedToDca?: Maybe<Scalars['Boolean']>;
};

export type UpdateAllMechanicProjectDocumentsReleasedToDcaInput = {
  documentTypeCategoryId?: Maybe<DocumentTypeCategoryEnum>;
  isReleasedToDca?: Maybe<Scalars['Boolean']>;
  mechanicProjectId?: Maybe<Scalars['Int']>;
};

export type UpdateAllProjectInsFormVersionsReleasedToDcaInput = {
  isReleasedToDca?: Maybe<Scalars['Boolean']>;
  projectId?: Maybe<Scalars['Int']>;
};

export type UpdateAmoProjectAuditsInput = {
  amoProjectId?: Maybe<Scalars['Int']>;
  inspections?: Maybe<Array<UpdateInspectionGraphInspectionInput>>;
};

export type UpdateAmoProjectDocumentInput = {
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateAmoProjectDocumentReleasedToDcaInput = {
  id?: Maybe<Scalars['Int']>;
  isReleasedToDca?: Maybe<Scalars['Boolean']>;
};

export type UpdateAmoProjectInput = {
  amoName?: Maybe<Scalars['String']>;
  amoProjectTypeId?: Maybe<Scalars['Int']>;
  assocAircraftProjectId?: Maybe<Scalars['Int']>;
  authorizedLocations?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  dateOfExpiry?: Maybe<Scalars['DateTime']>;
  dateOfFirstIssue?: Maybe<Scalars['DateTime']>;
  dcaCertificateNo?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  localApprovalExpirationDate?: Maybe<Scalars['DateTime']>;
  localApprovalOpsSpecsNumber?: Maybe<Scalars['String']>;
  projectNumber?: Maybe<Scalars['String']>;
  specialProject?: Maybe<Scalars['String']>;
};

export type UpdateAmoProjectOfficialLetterNotesInput = {
  amoProjectId?: Maybe<Scalars['Int']>;
  documentTypeNotes?: Maybe<Array<UpdateProjectDocumentTypeOfficialLetterNoteInput>>;
  officialLetterNotes?: Maybe<Scalars['String']>;
};

export type UpdateCompanyDocumentInput = {
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateCrewMemberDocumentInput = {
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateCrewMemberInput = {
  aircraftIds?: Maybe<Array<Scalars['Int']>>;
  aircraftModelIds?: Maybe<Array<Scalars['Int']>>;
  certificateDateOfFirstIssue?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate?: Maybe<Scalars['DateTime']>;
  certificateIssuedDate?: Maybe<Scalars['DateTime']>;
  countryId?: Maybe<Scalars['Int']>;
  crewLicenseTypeId?: Maybe<Scalars['Int']>;
  crewMemberStatusId?: Maybe<Scalars['Int']>;
  crewPositionId?: Maybe<Scalars['Int']>;
  crewRatingIds?: Maybe<Array<Scalars['Int']>>;
  elpExpiryDate?: Maybe<Scalars['DateTime']>;
  elpLevelId?: Maybe<Scalars['Int']>;
  employmentCompanyIds?: Maybe<Array<Scalars['Int']>>;
  firstName?: Maybe<Scalars['String']>;
  genericLvCompanyIds?: Maybe<Array<Scalars['Int']>>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
  newAircraftModels?: Maybe<Array<Scalars['String']>>;
  newCrewRatings?: Maybe<Array<Scalars['String']>>;
  newEmploymentCompanies?: Maybe<Array<Scalars['String']>>;
  newGenericLvCompanies?: Maybe<Array<Scalars['String']>>;
  operatorIds?: Maybe<Array<Scalars['Int']>>;
  validationNumber?: Maybe<Scalars['String']>;
};

export type UpdateCrewProjectCertificateInput = {
  aircraftList?: Maybe<Scalars['String']>;
  aircraftModelsList?: Maybe<Scalars['String']>;
  assigneeUserId?: Maybe<Scalars['Int']>;
  certificateDateOfIssue1?: Maybe<Scalars['DateTime']>;
  certificateDateOfIssue2?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate1?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate2?: Maybe<Scalars['DateTime']>;
  countryId?: Maybe<Scalars['Int']>;
  crewCertificateTypeId?: Maybe<Scalars['Int']>;
  crewLicenseTypeId?: Maybe<Scalars['Int']>;
  crewPositionId?: Maybe<Scalars['Int']>;
  crewProjectCategoryId?: Maybe<Scalars['Int']>;
  crewProjectId?: Maybe<Scalars['Int']>;
  crewRatingsList?: Maybe<Scalars['String']>;
  currentCertificateFirstIssuedDate?: Maybe<Scalars['DateTime']>;
  elpExpiryDate?: Maybe<Scalars['DateTime']>;
  elpLevelId?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  genericLvCompaniesList?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
  preparedByUserId?: Maybe<Scalars['Int']>;
  remarksC?: Maybe<Scalars['String']>;
  remarksD?: Maybe<Scalars['String']>;
  validationNumber?: Maybe<Scalars['String']>;
  validationRestrictedTo?: Maybe<Scalars['String']>;
};

export type UpdateCrewProjectCertificateResult = {
  crewProjectCertificate?: Maybe<CrewProjectCertificate>;
  warnings?: Maybe<Array<Scalars['String']>>;
};

export type UpdateCrewProjectDocumentInput = {
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateCrewProjectDocumentReleasedToDcaInput = {
  id?: Maybe<Scalars['Int']>;
  isReleasedToDca?: Maybe<Scalars['Boolean']>;
};

export type UpdateCrewProjectInput = {
  aircraftIds?: Maybe<Array<Scalars['Int']>>;
  aircraftModelIds?: Maybe<Array<Scalars['Int']>>;
  associatedAircraftProjectId?: Maybe<Scalars['Int']>;
  clientSubmissionDate?: Maybe<Scalars['DateTime']>;
  crewLicenseTypeId?: Maybe<Scalars['Int']>;
  crewPositionId?: Maybe<Scalars['Int']>;
  crewProjectCategoryId?: Maybe<Scalars['Int']>;
  crewProjectRenewalChangeTypeIds?: Maybe<Array<Scalars['Int']>>;
  crewProjectSpecialProjectTypeId?: Maybe<Scalars['Int']>;
  crewProjectTypeId?: Maybe<Scalars['Int']>;
  crewRatingIds?: Maybe<Array<Scalars['Int']>>;
  dateOfFirstIssue?: Maybe<Scalars['DateTime']>;
  dcaSubmissionDate?: Maybe<Scalars['DateTime']>;
  elpExpiryDate?: Maybe<Scalars['DateTime']>;
  elpLevelId?: Maybe<Scalars['Int']>;
  employmentCompanyIds?: Maybe<Array<Scalars['Int']>>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  genericLvCompanyIds?: Maybe<Array<Scalars['Int']>>;
  id?: Maybe<Scalars['Int']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
  newAircraftModels?: Maybe<Array<Scalars['String']>>;
  newCrewRatings?: Maybe<Array<Scalars['String']>>;
  newEmploymentCompanies?: Maybe<Array<Scalars['String']>>;
  newGenericLvCompanies?: Maybe<Array<Scalars['String']>>;
  operatorIds?: Maybe<Array<Scalars['Int']>>;
  provisionalAircraftRegistrationMarks?: Maybe<Scalars['String']>;
  provisionalOperatorNames?: Maybe<Scalars['String']>;
  validationNumber?: Maybe<Scalars['String']>;
};

export type UpdateCrewProjectOfficialLetterNotesInput = {
  crewProjectId?: Maybe<Scalars['Int']>;
  documentTypeNotes?: Maybe<Array<UpdateProjectDocumentTypeOfficialLetterNoteInput>>;
  officialLetterDocumentsNote?: Maybe<Scalars['String']>;
};

export type UpdateCrewProjectResult = {
  crewProject?: Maybe<CrewProject>;
  warnings?: Maybe<Array<Scalars['String']>>;
};

export type UpdateInspectionGraphInspectionInput = {
  id?: Maybe<Scalars['Int']>;
  insForm16005AFileAttachmentId?: Maybe<Scalars['Int']>;
  insForm4001FileAttachmentId?: Maybe<Scalars['Int']>;
  insForm4004FileAttachmentId?: Maybe<Scalars['Int']>;
  insForm4007FileAttachmentId?: Maybe<Scalars['Int']>;
  insForm4023BFileAttachmentId?: Maybe<Scalars['Int']>;
  insForm4035FileAttachmentId?: Maybe<Scalars['Int']>;
  insForm4045FileAttachmentId?: Maybe<Scalars['Int']>;
  inspectionStatusId?: Maybe<Scalars['Int']>;
  inspectorInspections?: Maybe<Array<UpdateInspectionGraphInspectorInspectionInput>>;
  letterOfFindingsFileAttachmentId?: Maybe<Scalars['Int']>;
  otherStatusText?: Maybe<Scalars['String']>;
  validityPeriod?: Maybe<Scalars['DateTime']>;
};

export type UpdateInspectionGraphInspectorInspectionInput = {
  city?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  inspectionEstimateFileAttachmentId?: Maybe<Scalars['Int']>;
  inspectionInvoiceFileAttachmentId?: Maybe<Scalars['Int']>;
  inspectionTimeLogFileAttachmentId?: Maybe<Scalars['Int']>;
  inspectorId?: Maybe<Scalars['Int']>;
  regionId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  stateId?: Maybe<Scalars['Int']>;
};

export type UpdateInspectorBlockedDateInput = {
  endDate?: Maybe<Scalars['DateTime']>;
  inspectorBlockedDateId?: Maybe<Scalars['Int']>;
  inspectorId?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type UpdateInspectorDocumentInput = {
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateInvoiceInput = {
  aircraftProjectIds?: Maybe<Array<Scalars['Int']>>;
  crewProjectIds?: Maybe<Array<Scalars['Int']>>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceId?: Maybe<Scalars['Int']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  mechanicProjectIds?: Maybe<Array<Scalars['Int']>>;
  notes?: Maybe<Scalars['String']>;
  paymentStatusId?: Maybe<Scalars['Int']>;
};

export type UpdateMechanicDocumentInput = {
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateMechanicInput = {
  aircraftIds?: Maybe<Array<Scalars['Int']>>;
  certificateDateOfFirstIssue?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate?: Maybe<Scalars['DateTime']>;
  certificateIssuedDate?: Maybe<Scalars['DateTime']>;
  countryId?: Maybe<Scalars['Int']>;
  employmentCompanyIds?: Maybe<Array<Scalars['Int']>>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
  mechanicLicenseTypeId?: Maybe<Scalars['Int']>;
  mechanicPositionId?: Maybe<Scalars['Int']>;
  mechanicRatingIds?: Maybe<Array<Scalars['Int']>>;
  mechanicStatusId?: Maybe<Scalars['Int']>;
  newEmploymentCompanies?: Maybe<Array<Scalars['String']>>;
  newMechanicRatings?: Maybe<Array<Scalars['String']>>;
  operatorIds?: Maybe<Array<Scalars['Int']>>;
  validationNumber?: Maybe<Scalars['String']>;
};

export type UpdateMechanicProjectCertificateInput = {
  aircraftList?: Maybe<Scalars['String']>;
  authorizationLimitedTo?: Maybe<Scalars['String']>;
  certificateDateOfIssue?: Maybe<Scalars['DateTime']>;
  certificateExpiryDate?: Maybe<Scalars['DateTime']>;
  countryId?: Maybe<Scalars['Int']>;
  currentCertificateFirstIssuedDate?: Maybe<Scalars['DateTime']>;
  dcaApprovedByUserId?: Maybe<Scalars['Int']>;
  dcaReviewerUserId?: Maybe<Scalars['Int']>;
  dcaSentForApprovalByUserId?: Maybe<Scalars['Int']>;
  dcaValidationIssueBasedOnLine1?: Maybe<Scalars['String']>;
  dcaValidationIssueBasedOnLine2?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
  mechanicCertificateTypeId?: Maybe<Scalars['Int']>;
  mechanicLicenseTypeId?: Maybe<Scalars['Int']>;
  mechanicPositionId?: Maybe<Scalars['Int']>;
  mechanicProjectId?: Maybe<Scalars['Int']>;
  mechanicRatingsList?: Maybe<Scalars['String']>;
  validationNumber?: Maybe<Scalars['String']>;
  validationRestrictedTo?: Maybe<Scalars['String']>;
};

export type UpdateMechanicProjectCertificateResult = {
  mechanicProjectCertificate?: Maybe<MechanicProjectCertificate>;
  warnings?: Maybe<Array<Scalars['String']>>;
};

export type UpdateMechanicProjectDocumentInput = {
  expirationDate?: Maybe<Scalars['DateTime']>;
  fileAttachmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isAutoRenew?: Maybe<Scalars['Boolean']>;
  isIndefiniteExpiration?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateMechanicProjectDocumentReleasedToDcaInput = {
  id?: Maybe<Scalars['Int']>;
  isReleasedToDca?: Maybe<Scalars['Boolean']>;
};

export type UpdateMechanicProjectInput = {
  aircraftIds?: Maybe<Array<Scalars['Int']>>;
  associatedAircraftProjectId?: Maybe<Scalars['Int']>;
  clientSubmissionDate?: Maybe<Scalars['DateTime']>;
  dateOfFirstIssue?: Maybe<Scalars['DateTime']>;
  dcaSubmissionDate?: Maybe<Scalars['DateTime']>;
  employmentCompanyIds?: Maybe<Array<Scalars['Int']>>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
  mechanicLicenseTypeId?: Maybe<Scalars['Int']>;
  mechanicPositionId?: Maybe<Scalars['Int']>;
  mechanicProjectRenewalChangeTypeIds?: Maybe<Array<Scalars['Int']>>;
  mechanicProjectTypeId?: Maybe<Scalars['Int']>;
  mechanicRatingIds?: Maybe<Array<Scalars['Int']>>;
  newEmploymentCompanies?: Maybe<Array<Scalars['String']>>;
  newMechanicRatings?: Maybe<Array<Scalars['String']>>;
  operatorIds?: Maybe<Array<Scalars['Int']>>;
  provisionalAircraftRegistrationMarks?: Maybe<Scalars['String']>;
  provisionalOperatorNames?: Maybe<Scalars['String']>;
  validationNumber?: Maybe<Scalars['String']>;
};

export type UpdateMechanicProjectOfficialLetterNotesInput = {
  documentTypeNotes?: Maybe<Array<UpdateProjectDocumentTypeOfficialLetterNoteInput>>;
  mechanicProjectId?: Maybe<Scalars['Int']>;
  officialLetterDocumentsNote?: Maybe<Scalars['String']>;
};

export type UpdateMechanicProjectResult = {
  mechanicProject?: Maybe<MechanicProject>;
  warnings?: Maybe<Array<Scalars['String']>>;
};

export type UpdateProjectDocumentTypeOfficialLetterNoteInput = {
  documentTypeId?: Maybe<Scalars['Int']>;
  officialLetterNote?: Maybe<Scalars['String']>;
};

export type UpdateProjectInsFormIsDcaApprovedInput = {
  isDcaApproved?: Maybe<Scalars['Boolean']>;
  projectId?: Maybe<Scalars['Int']>;
  projectInsFormVersionId?: Maybe<Scalars['Int']>;
  rejectionReason?: Maybe<Scalars['String']>;
};

export type UpdateProjectInsFormVersionFieldComment = {
  fieldNumber?: Maybe<Scalars['Int']>;
};

export type UpdateProjectInsFormVersionFieldCommentInput = {
  fieldNumber?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isSet?: Maybe<Scalars['Boolean']>;
};

export type UpdateProjectInsFormVersionFieldCommentsInput = {
  fieldComments?: Maybe<Array<UpdateProjectInsFormVersionFieldComment>>;
  projectInsFormVersionId?: Maybe<Scalars['Int']>;
};

export type UpdateProjectInsFormVersionFieldValueInput = {
  fieldNumber?: Maybe<Scalars['Int']>;
  fieldValue?: Maybe<Scalars['String']>;
};

export type UpdateProjectInsFormVersionFieldValuesInput = {
  fieldValues?: Maybe<Array<UpdateProjectInsFormVersionFieldValueInput>>;
  projectInsFormVersionId?: Maybe<Scalars['Int']>;
};

export type UpdateProjectInsFormVersionFileAttachmentInput = {
  projectInsFormVersionId?: Maybe<Scalars['Int']>;
  uploadedFileAttachmentId?: Maybe<Scalars['Int']>;
};

export type UpdateProjectInsFormVersionReleasedToDcaInput = {
  id?: Maybe<Scalars['Int']>;
  isReleasedToDca?: Maybe<Scalars['Boolean']>;
};

export type UpdateProjectInsFormVersionTrgApprovalInput = {
  id?: Maybe<Scalars['Int']>;
  isTrgApproved?: Maybe<Scalars['Boolean']>;
};


export type User = {
  address?: Maybe<Scalars['String']>;
  canCancelMechanicProjects: Scalars['Boolean'];
  city?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  department?: Maybe<Department>;
  departmentRoleId?: Maybe<Scalars['Int']>;
  displayName: Scalars['String'];
  emailAddresses: Array<UserEmailAddress>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  initials?: Maybe<Scalars['String']>;
  inspector?: Maybe<Inspector>;
  isActive: Scalars['Boolean'];
  isDcaLicensing?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  isMaintenanceInspector: Scalars['Boolean'];
  isMechanicProjectDcaApprovedByUser: Scalars['Boolean'];
  isMechanicProjectDcaReviewerUser: Scalars['Boolean'];
  isMechanicProjectDcaSentForApprovalByUser: Scalars['Boolean'];
  isOperator?: Maybe<Scalars['Boolean']>;
  isTrg?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  operator?: Maybe<Operator>;
  phoneNumbers: Array<PhoneNumber>;
  regionId?: Maybe<Scalars['Int']>;
  role?: Maybe<Role>;
  signatureImageFileAttachment?: Maybe<FileAttachment>;
  signatureName?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type UserEmailAddress = {
  emailAddress: Scalars['String'];
  emailAddressTypeId: Scalars['Int'];
  id: Scalars['Int'];
};

export type UserInput = {
  address?: Maybe<Scalars['String']>;
  canCancelMechanicProjects?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  departmentId?: Maybe<Scalars['Int']>;
  departmentRoleId?: Maybe<Scalars['Int']>;
  emailAddresses?: Maybe<Array<EmailAddressInput>>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  initials?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMaintenanceInspector?: Maybe<Scalars['Boolean']>;
  isMechanicProjectDcaApprovedByUser?: Maybe<Scalars['Boolean']>;
  isMechanicProjectDcaReviewerUser?: Maybe<Scalars['Boolean']>;
  isMechanicProjectDcaSentForApprovalByUser?: Maybe<Scalars['Boolean']>;
  isSignatureImageFileAttachmentRemoved?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  newSignatureImageFileAttachmentId?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<PhoneNumberInput>>;
  regionId?: Maybe<Scalars['Int']>;
  roleId?: Maybe<Scalars['Int']>;
  signatureName?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type UserProfile = {
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type Users = {
  users: Array<User>;
};

export type UsersResult = PaginatedUsers | Users;

export enum UsersSortBy {
  DisplayName = 'displayName',
  FirstName = 'firstName',
  IsActive = 'isActive',
  LastName = 'lastName',
  Operator = 'operator',
  Role = 'role'
}

export type AddAircraftModelMutationMutationVariables = Exact<{
  addAircraftModelInput: AddAircraftModelInput;
}>;


export type AddAircraftModelMutationMutation = { addAircraftModel: { id: number, name: string } };

export type CompanyCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CompanyCommentsQuery = { companyComments: CommentsFragment };

export type AddCompanyCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddCompanyCommentMutation = { addCompanyComment: CommentFragment };

export type UpdateCompanyCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateCompanyCommentMutation = { updateCompanyComment: CommentFragment };

export type UpdateCompanyCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateCompanyCommentsLastViewedDateMutation = { updateCompanyCommentsLastViewedDate: { id: number } };

export type CompanyContactsQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type CompanyContactsQuery = { companyContacts: Array<ContactFragment> };

export type CompanyContactQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CompanyContactQuery = { companyContact: ContactFragment };

export type AddCompanyContactMutationVariables = Exact<{
  companyId: Scalars['Int'];
  input: ContactInput;
}>;


export type AddCompanyContactMutation = { addCompanyContact: ContactFragment };

export type UpdateCompanyContactMutationVariables = Exact<{
  id: Scalars['Int'];
  companyId: Scalars['Int'];
  input: ContactInput;
}>;


export type UpdateCompanyContactMutation = { updateCompanyContact: ContactFragment };

export type DeleteCompanyContactMutationVariables = Exact<{
  id: Scalars['Int'];
  companyId: Scalars['Int'];
}>;


export type DeleteCompanyContactMutation = { deleteCompanyContact: boolean };

export type CompanyDocumentFragment = { id: number, isArchived: boolean, document: DocumentForDocumentListsFragment };

export type CompanyDocumentsQueryQueryVariables = Exact<{
  companyId: Scalars['Int'];
  documentTypeCategoryId: DocumentTypeCategoryEnum;
}>;


export type CompanyDocumentsQueryQuery = { documents: Array<CompanyDocumentFragment> };

export type AddCompanyDocumentMutationMutationVariables = Exact<{
  addCompanyDocumentInput: AddCompanyDocumentInput;
}>;


export type AddCompanyDocumentMutationMutation = { addCompanyDocument: { id: number } };

export type UpdateCompanyDocumentMutationMutationVariables = Exact<{
  updateCompanyDocumentInput: UpdateCompanyDocumentInput;
}>;


export type UpdateCompanyDocumentMutationMutation = { updateCompanyDocument: { id: number } };

export type RemoveCompanyDocumentMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveCompanyDocumentMutationMutation = { removeCompanyDocument: boolean };

export type DownloadCompanyDocumentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadCompanyDocumentQuery = { file?: Maybe<DownloadFileFragment> };

export type CompanyEmailHistoryQueryVariables = Exact<{
  companyId: Scalars['Int'];
  sortBy?: Maybe<EmailHistorySortBy>;
  sortDirection?: Maybe<SortDirection>;
}>;


export type CompanyEmailHistoryQuery = { company: { emailHistory: Array<EmailHistoryFragment> } };

export type CompanyEmailViewQueryVariables = Exact<{
  id: Scalars['Int'];
  emailId: Scalars['Int'];
  includeFileAttachments?: Maybe<Scalars['Boolean']>;
  includeFileContent?: Maybe<Scalars['Boolean']>;
}>;


export type CompanyEmailViewQuery = { company: { emails: Array<EmailFragment> } };

export type DownloadCompanyEmailAttachmentContentQueryVariables = Exact<{
  companyId: Scalars['Int'];
  emailId: Scalars['Int'];
  attachmentId: Scalars['Int'];
}>;


export type DownloadCompanyEmailAttachmentContentQuery = { downloadCompanyEmailAttachmentContent?: Maybe<string> };

export type SendCompanyEmailMutationVariables = Exact<{
  companyId: Scalars['Int'];
  email: EmailInput;
}>;


export type SendCompanyEmailMutation = { sendCompanyEmail: { id: number } };

export type MyPreviousRecipientsQueryVariables = Exact<{
  filter?: Maybe<Scalars['String']>;
}>;


export type MyPreviousRecipientsQuery = { myPreviousRecipients: Array<string> };

export type SendEmailMutationVariables = Exact<{
  email: EmailInput;
}>;


export type SendEmailMutation = { sendEmail: number };

export type DownloadFileFragment = { fileName: string, fileSizeBytes: number, mimeType: string, base64Content: string };

export type UploadFileMutationMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadFileMutationMutation = { uploadFile: number };

export type AircraftCategorySelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type AircraftCategorySelectOptionsQuery = { aircraftCategories: Array<{ id: number, name: string }> };

export type AircraftChipSelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
  operatorIdNullOrIn?: Maybe<Array<Scalars['Int']>>;
}>;


export type AircraftChipSelectOptionsQuery = { aircrafts: { aircrafts: Array<{ id: number, registrationMark: string, aircraftStatus: { id: number }, operator?: Maybe<{ id: number }> }> } };

export type AircraftClassSelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type AircraftClassSelectOptionsQuery = { aircraftClasses: Array<{ id: number, name: string }> };

export type AircraftModelSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AircraftModelSelectOptionsQuery = { aircraftModels: Array<{ id: number, name: string, isDeleted: boolean }> };

export type AircraftModelsSelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
}>;


export type AircraftModelsSelectOptionsQuery = { aircraftModels: Array<{ id: number, name: string }> };

export type AircraftProjectTypeOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type AircraftProjectTypeOptionsQuery = { aircraftProjectTypes: Array<{ id: number, name: string }> };

export type AircraftSelectOptionsQueryVariables = Exact<{
  registrationMarkContains?: Maybe<Scalars['String']>;
}>;


export type AircraftSelectOptionsQuery = { aircrafts: { aircrafts: Array<{ id: number, registrationMark: string }> } };

export type AircraftStatusSelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type AircraftStatusSelectOptionsQuery = { aircraftStatuses: Array<{ id: number, name: string }> };

export type AircraftTypeSelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type AircraftTypeSelectOptionsQuery = { aircraftCategories: Array<{ id: number, name: string }> };

export type AmoProjectAssociatedAircraftProjectSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type AmoProjectAssociatedAircraftProjectSelectQuery = { aircraftProjects: { aircraftProjects: Array<{ id: number, isDeleted: boolean, aircraftProjectType: { id: number, abbreviation: string }, projectStatus: { id: number }, aircraft: { id: number, registrationMark: string } }> } };

export type AmoProjectTypeOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type AmoProjectTypeOptionsQuery = { amoProjectTypes: Array<{ id: number, name: string }> };

export type AmoSelectOptionsQueryVariables = Exact<{
  nameContains?: Maybe<Scalars['String']>;
  onlyRenewable?: Maybe<Scalars['Boolean']>;
}>;


export type AmoSelectOptionsQuery = { amos: { amos: Array<{ id: number, amoName: string, dcaCertificateNo?: Maybe<string> }> } };

export type CountrySelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
  regionIdIn?: Maybe<Array<Scalars['Int']>>;
}>;


export type CountrySelectOptionsQuery = { countries: Array<{ id: number, name: string }> };

export type CrewCertificateTypeOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type CrewCertificateTypeOptionsQuery = { crewCertificateTypes: Array<{ id: number, name: string, description?: Maybe<string> }> };

export type CrewLicenseTypeOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type CrewLicenseTypeOptionsQuery = { crewLicenseTypes: Array<{ id: number, name: string, description?: Maybe<string>, isDeleted: boolean, isForCertificateOnly: boolean, crewPositions: Array<{ id: number }> }> };

export type CrewMemberForOperatorAddCrewProjectSelectOptionsQueryVariables = Exact<{
  operatorId: Scalars['Int'];
  lastNameContains?: Maybe<Scalars['String']>;
}>;


export type CrewMemberForOperatorAddCrewProjectSelectOptionsQuery = { crewMembersForOperatorAddCrewProject: Array<{ id: number, firstName: string, lastName: string }> };

export type CrewMemberSelectOptionsQueryVariables = Exact<{
  lastNameContains?: Maybe<Scalars['String']>;
  hasActiveProjects?: Maybe<Scalars['Boolean']>;
}>;


export type CrewMemberSelectOptionsQuery = { crewMembers: { crewMembers: Array<{ id: number, firstName: string, lastName: string, validationNumber?: Maybe<string>, country: { name: string } }> } };

export type CrewPositionSelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
  crewLicenseTypeIdIn?: Maybe<Array<Scalars['Int']>>;
}>;


export type CrewPositionSelectOptionsQuery = { crewPositions: Array<{ id: number, name: string, description?: Maybe<string> }> };

export type CrewProjectAssociatedAircraftProjectSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type CrewProjectAssociatedAircraftProjectSelectQuery = { aircraftProjects: { aircraftProjects: Array<{ id: number, isDeleted: boolean, aircraftProjectType: { id: number, abbreviation: string }, projectStatus: { id: number }, aircraft: { id: number, registrationMark: string } }> } };

export type CrewProjectCategorySelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type CrewProjectCategorySelectOptionsQuery = { crewProjectCategories: Array<{ id: number, name: string }> };

export type CrewProjectRenewalChangeTypeOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CrewProjectRenewalChangeTypeOptionsQuery = { crewProjectRenewalChangeTypes: Array<CrewProjectRenewalChangeTypeFragment> };

export type CrewProjectSpecialProjectTypeOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type CrewProjectSpecialProjectTypeOptionsQuery = { crewProjectSpecialProjectTypes: Array<{ id: number, name: string }> };

export type CrewProjectTypeOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type CrewProjectTypeOptionsQuery = { crewProjectTypes: Array<{ id: number, name: string }> };

export type CrewRatingsSelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
}>;


export type CrewRatingsSelectOptionsQuery = { crewRatings: Array<{ id: number, name: string }> };

export type DepartmentSelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type DepartmentSelectOptionsQuery = { departments: Array<{ id: number, name: string }> };

export type ElpLevelSelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type ElpLevelSelectOptionsQuery = { elpLevels: Array<{ id: number, name: string }> };

export type FunctionalGroupFragment = { id: number, name: string, sortOrder: number };

export type FunctionalGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type FunctionalGroupsQuery = { functionalGroups: Array<FunctionalGroupFragment> };

export type GenericLvCompanySelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type GenericLvCompanySelectOptionsQuery = { genericLvCompanies: Array<{ id: number, name: string }> };

export type GenericLvCompaniesSelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
}>;


export type GenericLvCompaniesSelectOptionsQuery = { genericLvCompanies: Array<{ id: number, name: string }> };

export type MechanicCertificateTypeOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type MechanicCertificateTypeOptionsQuery = { mechanicCertificateTypes: Array<{ id: number, name: string, description?: Maybe<string> }> };

export type MechanicForOperatorAddMechanicProjectSelectOptionsQueryVariables = Exact<{
  operatorId: Scalars['Int'];
  lastNameContains?: Maybe<Scalars['String']>;
}>;


export type MechanicForOperatorAddMechanicProjectSelectOptionsQuery = { mechanicsForOperatorAddMechanicProject: Array<{ id: number, firstName: string, lastName: string }> };

export type MechanicLicenseTypeOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type MechanicLicenseTypeOptionsQuery = { mechanicLicenseTypes: Array<{ id: number, name: string, description?: Maybe<string>, isDeleted: boolean, isForCertificateOnly: boolean, mechanicPositions: Array<{ id: number }> }> };

export type MechanicPositionSelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
  mechanicLicenseTypeIdIn?: Maybe<Array<Scalars['Int']>>;
}>;


export type MechanicPositionSelectOptionsQuery = { mechanicPositions: Array<{ id: number, name: string, description?: Maybe<string> }> };

export type MechanicProjectAssociatedAircraftProjectSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type MechanicProjectAssociatedAircraftProjectSelectQuery = { aircraftProjects: { aircraftProjects: Array<{ id: number, isDeleted: boolean, aircraftProjectType: { id: number, abbreviation: string }, projectStatus: { id: number }, aircraft: { id: number, registrationMark: string } }> } };

export type MechanicProjectRenewalChangeTypeOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MechanicProjectRenewalChangeTypeOptionsQuery = { mechanicProjectRenewalChangeTypes: Array<MechanicProjectRenewalChangeTypeFragment> };

export type MechanicProjectTypeOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type MechanicProjectTypeOptionsQuery = { mechanicProjectTypes: Array<{ id: number, name: string }> };

export type MechanicRatingsSelectOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
  nameContains?: Maybe<Scalars['String']>;
}>;


export type MechanicRatingsSelectOptionsQuery = { mechanicRatings: Array<{ id: number, name: string }> };

export type MechanicSelectOptionsQueryVariables = Exact<{
  lastNameContains?: Maybe<Scalars['String']>;
}>;


export type MechanicSelectOptionsQuery = { mechanics: { mechanics: Array<{ id: number, firstName: string, lastName: string, validationNumber?: Maybe<string>, country: { name: string }, activeMechanicProjects: Array<{ id: number }> }> } };

export type OperatorAircraftModelOptionsQueryVariables = Exact<{
  operatorId: Scalars['Int'];
}>;


export type OperatorAircraftModelOptionsQuery = { aircrafts: { aircrafts: Array<{ aircraftStatus: { id: number }, aircraftModel?: Maybe<AircraftModelFragment> }> } };

export type OperatorSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OperatorSelectOptionsQuery = { operators: { operators: Array<OperatorLookupFragment> } };

export type PaymentStatusOptionsQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type PaymentStatusOptionsQuery = { paymentStatuses: Array<{ id: number, name: string }> };

export type ReminderApplicabilitiesQueryVariables = Exact<{
  includeDeleted?: Maybe<Scalars['Boolean']>;
}>;


export type ReminderApplicabilitiesQuery = { reminderApplicabilities: Array<{ id: number, name: string }> };

export type RoleFragment = { id: number, name: string };

export type RolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesQuery = { roles: Array<RoleFragment> };

export type UserSelectOptionsQueryVariables = Exact<{
  roleIdIn?: Maybe<Array<Scalars['Int']>>;
  departmentIdIn?: Maybe<Array<Scalars['Int']>>;
  isActive?: Maybe<Scalars['Boolean']>;
  idIn?: Maybe<Array<Scalars['Int']>>;
}>;


export type UserSelectOptionsQuery = { users: { users: Array<UserFragment> } };

export type InspectionStatusFragment = { id: number, name: string, isDeleted: boolean };

export type InspectorLookupFragment = { id: number, isActive: boolean, user?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, userName?: Maybe<string>, emailAddresses: Array<{ emailAddress: string }> }> };

export type InspectionLookupsQueryVariables = Exact<{ [key: string]: never; }>;


export type InspectionLookupsQuery = { inspectionStatuses: Array<InspectionStatusFragment>, inspectors: { inspectors: Array<InspectorLookupFragment> }, regions: Array<RegionLookupFragment>, countries: Array<CountryLookupFragment>, states: Array<StateLookupFragment> };

export type InspectionHistoryGridItemFragment = { id: number, city: string, startDate?: Maybe<any>, endDate?: Maybe<any>, inspector: { user?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string> }> }, inspection: { validityPeriod?: Maybe<any>, otherStatusText?: Maybe<string>, inspectionStatus: { id: number, name: string }, letterOfFindingsFileAttachment?: Maybe<{ fileName: string }>, insForm4001FileAttachment?: Maybe<{ fileName: string }>, aircraftProjectOperatorInspection?: Maybe<{ aircraftProject: { id: number } }> }, country: { id: number, name: string, region: { id: number, name: string } }, state?: Maybe<{ name: string }> };

export type InspectionHistoryGridQueryVariables = Exact<{
  sortBy?: Maybe<InspectorInspectionsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  aircraftId?: Maybe<Scalars['Int']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type InspectionHistoryGridQuery = { inspectorInspections: { inspectorInspections: Array<InspectionHistoryGridItemFragment> } | { totalItems: number, inspectorInspections: Array<InspectionHistoryGridItemFragment> } };

export type ProjectInsFormVersionFragment = { id: number, exclusiveGroupNumber?: Maybe<number>, isOptional: boolean, isTrgApproved: boolean, isReleasedToDca: boolean, fieldCommentCount: number, hasFieldValues: boolean, totalNewFormComments: number, isSignedByDca: boolean, isFullySigned: boolean, isDcaApproved?: Maybe<boolean>, dcaApprovalDate?: Maybe<any>, insFormVersion: { id: number, insForm: { name: string, title?: Maybe<string>, isHiddenFromDcaUsers: boolean, isSendForExecutionSupported: boolean, willBeEmailedWhenSigned: boolean, generatedDocumentType?: Maybe<{ name: string, documentTypeCategory: { id: number, name: string } }> }, fields: Array<{ fieldNumber: number, isSignatureField: boolean, signatoryRoleId?: Maybe<number> }> }, uploadedFileAttachment?: Maybe<{ fileName: string, fileSizeBytes: number, mimeType: string }>, generatedDocumentFileAttachment?: Maybe<{ fileName: string, fileSizeBytes: number, mimeType: string }>, insFormExecutionState?: Maybe<{ id: number, name: string }>, projectType: { id: number, shortName?: Maybe<string> }, executionKeys: Array<{ sentToUserEmailAddress: { emailAddress: string } }>, dcaApprovalByUser?: Maybe<{ id: number, displayName: string }> };

export type ProjectInsFormVersionExclusiveGroupFragment = { exclusiveGroupNumber: number, startedProjectInsFormVersion?: Maybe<{ id: number, insFormVersion: { insForm: { name: string } } }>, otherProjectInsFormVersions: Array<{ id: number, insFormVersion: { insForm: { name: string } } }> };

export type ProjectInsFormVersionFieldValueFragment = { text?: Maybe<string>, insFormVersionField: { fieldNumber: number }, signedByUser?: Maybe<{ id: number, userName?: Maybe<string>, displayName: string }> };

export type ProjectInsFormVersionFieldCommentFragment = { insFormVersionField: { fieldNumber: number } };

export type ProjectInsFormVersionCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProjectInsFormVersionCommentsQuery = { projectInsFormVersionComments: CommentsFragment };

export type UpdateProjectInsFormVersionCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateProjectInsFormVersionCommentsLastViewedDateMutation = { updateProjectInsFormVersionCommentsLastViewedDate: { id: number } };

export type CommentFragment = { id: number, body: string, parentCommentId?: Maybe<number>, date: any, isVisibleToIaso?: Maybe<boolean>, postedBy: { id: number, name?: Maybe<string> } };

export type CommentsFragment = { totalComments: number, totalNewComments: number, comments: Array<CommentFragment> };

export type DocumentForDocumentListsFragment = { name: string, isSystemGenerated: boolean, issueDate?: Maybe<any>, expirationDate?: Maybe<any>, isAutoRenew: boolean, isIndefiniteExpiration: boolean, documentType: { id: number, isAlwaysVisibleToDca: boolean, documentTypeCategory: { id: number } }, documentValidity: { id: number, name: string }, fileAttachment: { fileName: string, fileSizeBytes: number, mimeType: string, uploadedDate: any, uploadedByUser: { firstName?: Maybe<string>, lastName?: Maybe<string> } } };

export type DocumentTypeFragment = { id: number, name: string, isIssueDateApplicable: boolean, isIssueDateRequired: boolean, isExpirationDateApplicable: boolean, isExpirationDateRequired: boolean, expirationDateThresholdDays?: Maybe<number>, isAutoRenewAllowed: boolean, isIndefiniteExpirationAllowed: boolean, isAlwaysVisibleToDca: boolean, documentTypeCategory: { id: number } };

export type AssociatedDocumentTypeFragment = { isDeleted: boolean, isOptional: boolean, sortOrder: number, documentType: DocumentTypeFragment, insFormAssociatedDocumentGroup?: Maybe<{ id: number }> };

export type ProjectInsFormAssociatedDocumentTypesFragment = { insFormVersion: { insForm: { id: number, name: string, title?: Maybe<string>, associatedDocumentTypes: Array<AssociatedDocumentTypeFragment> } } };

export type RegionLookupFragment = { id: number, name: string, isDeleted: boolean };

export type CountryLookupFragment = { id: number, name: string, isDeleted: boolean, region: { id: number } };

export type StateLookupFragment = { id: number, name: string, isDeleted: boolean, country: { id: number } };

export type EmailHistoryFragment = { id: number, to: Array<string>, subject: string, date: any, isHighImportance: boolean, hasAttachments: boolean, hasErrorMessage: boolean, sentByUser: { displayName: string, firstName?: Maybe<string>, lastName?: Maybe<string> } };

export type FileAttachmentFragment = { fileName: string, fileSizeBytes: number, mimeType: string, content?: Maybe<string> };

export type EmailFragment = { id: number, to: Array<string>, cc: Array<string>, bcc: Array<string>, subject: string, date: any, body: string, isHighImportance: boolean, errorMessage?: Maybe<string>, sentByUser: { displayName: string, firstName?: Maybe<string>, lastName?: Maybe<string> }, emailAttachments: Maybe<Array<{ id: number, fileAttachment: FileAttachmentFragment }>> };

export type ProjectHistoryFragment = { id: number, description: string, performedByName: string, date: any };

export type UserFragment = { id: number, firstName?: Maybe<string>, lastName?: Maybe<string>, initials?: Maybe<string>, userName?: Maybe<string>, displayName: string, isTrg?: Maybe<boolean>, isOperator?: Maybe<boolean>, isDcaLicensing?: Maybe<boolean>, department?: Maybe<{ id: number }>, role?: Maybe<{ id: number }> };

export type ContactFragment = { id: number, userId: number, firstName: string, lastName: string, jobTitle: string, userName?: Maybe<string>, isRoleAdmin: boolean, address?: Maybe<string>, city?: Maybe<string>, zipCode?: Maybe<string>, isRecipientOfSystemGeneratedEmails: boolean, isActive: boolean, notes?: Maybe<string>, functionalGroup: { id: number }, emailAddresses: Array<{ id: number, emailAddressTypeId: number, emailAddress: string }>, phoneNumbers: Array<{ id: number, phoneNumberTypeId: number, phoneNumber: string }>, region?: Maybe<{ id: number, name: string }>, country?: Maybe<{ id: number, name: string }>, state?: Maybe<{ id: number, name: string }> };

export type PhoneNumberTypeFragment = { id: number, name: string };

export type PhoneNumberFragment = { id: number, phoneNumberTypeId: number, phoneNumber: string };

export type EmailAddressTypeFragment = { id: number, name: string };

export type AircraftStatusFragment = { id: number, name: string, isDeleted: boolean };

export type AircraftTypeFragment = { id: number, name: string, isDeleted: boolean };

export type AircraftCategoryFragment = { id: number, name: string, isDeleted: boolean };

export type AircraftClassFragment = { id: number, name: string, isDeleted: boolean };

export type AircraftModelFragment = { id: number, name: string, isDeleted: boolean };

export type AircraftManufacturerFragment = { id: number, name: string, isDeleted: boolean };

export type AircraftEngineManufacturerFragment = { id: number, name: string, isDeleted: boolean };

export type AircraftPropellerManufacturerFragment = { id: number, name: string, isDeleted: boolean };

export type AircraftOwnerLookupFragment = { id: number, isActive: boolean, isDeleted: boolean, company: { name: string, isActive: boolean } };

export type AircraftRegisteredHolderLookupFragment = { id: number, isActive: boolean, isDeleted: boolean, company: { name: string, isActive: boolean } };

export type InspectionFileAttachmentFragment = { fileName: string, fileSizeBytes: number, mimeType: string };

export type CrewRatingFragment = { id: number, name: string, isDeleted: boolean };

export type MechanicRatingFragment = { id: number, name: string, isDeleted: boolean };

export type InspectorInspectionDetailFragment = { id: number, city: string, startDate?: Maybe<any>, endDate?: Maybe<any>, isDeleted: boolean, inspector: { id: number, user?: Maybe<{ id: number, emailAddresses: Array<{ emailAddress: string }> }> }, country: { id: number, region: { id: number } }, state?: Maybe<{ id: number }>, inspectionEstimateFileAttachment?: Maybe<InspectionFileAttachmentFragment>, inspectionInvoiceFileAttachment?: Maybe<InspectionFileAttachmentFragment>, inspectionTimeLogFileAttachment?: Maybe<InspectionFileAttachmentFragment> };

export type InspectionDetailForActiveProjectsFragment = { id: number, validityPeriod?: Maybe<any>, isDeleted: boolean, inspectionStatus: { id: number }, letterOfFindingsFileAttachment?: Maybe<InspectionFileAttachmentFragment>, insForm4001FileAttachment?: Maybe<InspectionFileAttachmentFragment>, insForm4007FileAttachment?: Maybe<InspectionFileAttachmentFragment>, insForm4023BFileAttachment?: Maybe<InspectionFileAttachmentFragment>, insForm4045FileAttachment?: Maybe<InspectionFileAttachmentFragment>, insForm16005AFileAttachment?: Maybe<InspectionFileAttachmentFragment>, inspectorInspections: Array<InspectorInspectionDetailFragment> };

export type InspectionDetailForAllProjectsFragment = { id: number, otherStatusText?: Maybe<string>, validityPeriod?: Maybe<any>, isDeleted: boolean, inspectionStatus: { id: number }, letterOfFindingsFileAttachment?: Maybe<InspectionFileAttachmentFragment>, insForm4001FileAttachment?: Maybe<InspectionFileAttachmentFragment>, insForm4007FileAttachment?: Maybe<InspectionFileAttachmentFragment>, insForm4023BFileAttachment?: Maybe<InspectionFileAttachmentFragment>, insForm4045FileAttachment?: Maybe<InspectionFileAttachmentFragment>, insForm16005AFileAttachment?: Maybe<InspectionFileAttachmentFragment>, inspectorInspections: Array<InspectorInspectionDetailFragment> };

export type SendToDcaCheckFragment = { isTrgApproved: boolean, isReleasedToDca: boolean, insFormVersion: { insForm: { name: string, isHiddenFromDcaUsers: boolean } } };

export type CrewProjectTypeFragment = { id: number, name: string, isDeleted: boolean };

export type CrewProjectRenewalChangeTypeFragment = { id: number, name: string, isDeleted: boolean };

export type MechanicProjectTypeFragment = { id: number, name: string, isDeleted: boolean };

export type MechanicProjectRenewalChangeTypeFragment = { id: number, name: string, isDeleted: boolean };

export type OperatorLookupFragment = { id: number, isActive: boolean, isDeleted: boolean, company: { name: string, isActive: boolean } };

export type CompanyDetailFragment = { id: number, name: string, isActive: boolean, address: string, city: string, zipCode?: Maybe<string>, corporateEmailAddress?: Maybe<string>, incorporationDate?: Maybe<any>, goodStandingLetterIssueDate?: Maybe<any>, ofacComplianceExpirationDate?: Maybe<any>, isOperator: boolean, isOwner: boolean, isRegisteredHolder: boolean, totalNewComments: number, country: { id: number, name: string, region: { id: number, name: string } }, state?: Maybe<{ id: number, name: string }>, phoneNumbers: Array<PhoneNumberFragment> };

export type InsFormAssociatedDocumentGroupFragment = { id: number, name: string, sortOrder: number };

export type LocationLookupsQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationLookupsQuery = { regions: Array<RegionLookupFragment>, countries: Array<CountryLookupFragment>, states: Array<StateLookupFragment> };

export type AllRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRegionsQuery = { regions: Array<RegionLookupFragment> };

export type AllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCountriesQuery = { countries: Array<CountryLookupFragment> };

export type PhoneNumberTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type PhoneNumberTypesQuery = { phoneNumberTypes: Array<PhoneNumberTypeFragment> };

export type EmailAddressTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailAddressTypesQuery = { emailAddressTypes: Array<EmailAddressTypeFragment> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me: UserFragment };

export type BannerAlertForHeaderDisplayFragment = { message: string, variant: string };

export type BannerAlertsForHeaderDisplayQueryVariables = Exact<{ [key: string]: never; }>;


export type BannerAlertsForHeaderDisplayQuery = { bannerAlerts: Array<BannerAlertForHeaderDisplayFragment> };

export type AircraftCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AircraftCommentsQuery = { aircraftComments: CommentsFragment };

export type AddAircraftCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddAircraftCommentMutation = { addAircraftComment: CommentFragment };

export type UpdateAircraftCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateAircraftCommentMutation = { updateAircraftComment: CommentFragment };

export type UpdateAircraftCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateAircraftCommentsLastViewedDateMutation = { updateAircraftCommentsLastViewedDate: { id: number } };

export type AircraftDocumentFragment = { id: number, isArchived: boolean, document: DocumentForDocumentListsFragment };

export type AircraftDocumentsQueryQueryVariables = Exact<{
  aircraftId: Scalars['Int'];
  documentTypeCategoryId: DocumentTypeCategoryEnum;
}>;


export type AircraftDocumentsQueryQuery = { documents: Array<AircraftDocumentFragment>, documentTypes: Array<DocumentTypeFragment> };

export type AddAircraftDocumentMutationMutationVariables = Exact<{
  addAircraftDocumentInput: AddAircraftDocumentInput;
}>;


export type AddAircraftDocumentMutationMutation = { addAircraftDocument: { id: number } };

export type UpdateAircraftDocumentMutationMutationVariables = Exact<{
  updateAircraftDocumentInput: UpdateAircraftDocumentInput;
}>;


export type UpdateAircraftDocumentMutationMutation = { updateAircraftDocument: { id: number } };

export type RemoveAircraftDocumentMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveAircraftDocumentMutationMutation = { removeAircraftDocument: boolean };

export type DownloadAircraftDocumentQueryVariables = Exact<{
  id: Scalars['Int'];
  aicraftId: Scalars['Int'];
}>;


export type DownloadAircraftDocumentQuery = { file?: Maybe<DownloadFileFragment> };

export type AircraftInsFormAssociatedDocumentFragment = { id: number, isArchived: boolean, insForm: { id: number }, insFormAssociatedDocumentGroup?: Maybe<{ id: number }>, document: DocumentForDocumentListsFragment };

export type AircraftInsFormAssociatedDocumentsQueryQueryVariables = Exact<{
  aircraftId: Scalars['Int'];
}>;


export type AircraftInsFormAssociatedDocumentsQueryQuery = { aircraft: { documents: Array<AircraftInsFormAssociatedDocumentFragment>, insForms: Array<{ id: number, name: string, title?: Maybe<string>, associatedDocumentTypes: Array<AssociatedDocumentTypeFragment> }> }, insFormAssociatedDocumentGroups: Array<InsFormAssociatedDocumentGroupFragment> };

export type AddAircraftInsFormAssociatedDocumentMutationMutationVariables = Exact<{
  addAircraftInsFormAssociatedDocumentInput: AddAircraftInsFormAssociatedDocumentInput;
}>;


export type AddAircraftInsFormAssociatedDocumentMutationMutation = { addAircraftInsFormAssociatedDocument: { id: number } };

export type UpdateAircraftInsFormAssociatedDocumentMutationMutationVariables = Exact<{
  updateAircraftInsFormAssociatedDocumentInput: UpdateAircraftInsFormAssociatedDocumentInput;
}>;


export type UpdateAircraftInsFormAssociatedDocumentMutationMutation = { updateAircraftInsFormAssociatedDocument: { id: number } };

export type RemoveAircraftInsFormAssociatedDocumentMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveAircraftInsFormAssociatedDocumentMutationMutation = { removeAircraftInsFormAssociatedDocument: boolean };

export type DownloadAircraftInsFormAssociatedDocumentQueryVariables = Exact<{
  id: Scalars['Int'];
  aircraftId: Scalars['Int'];
}>;


export type DownloadAircraftInsFormAssociatedDocumentQuery = { file?: Maybe<DownloadFileFragment> };

export type BulkUpdateCrewAircraftInfoFragment = { registrationMark: string, operator?: Maybe<{ id: number, company: { name: string } }>, aircraftModel?: Maybe<AircraftModelFragment> };

export type BulkUpdateCrewAircraftQueryVariables = Exact<{
  aircraftId: Scalars['Int'];
}>;


export type BulkUpdateCrewAircraftQuery = { aircraft: BulkUpdateCrewAircraftInfoFragment };

export type BulkUpdateCrewSearchCrewMemberFragment = { id: number, firstName: string, lastName: string, crewRatings: Array<{ id: number, name: string }>, aircrafts: Array<{ id: number, registrationMark: string, aircraftStatus: { id: number }, aircraftModel?: Maybe<{ id: number, name: string }>, operator?: Maybe<{ id: number }> }> };

export type BulkUpdateCrewSearchQueryVariables = Exact<{
  operatorId: Scalars['Int'];
}>;


export type BulkUpdateCrewSearchQuery = { crewMembers: { crewMembers: Array<BulkUpdateCrewSearchCrewMemberFragment> } };

export type BulkUpdateAircraftCrewMembersMutationVariables = Exact<{
  aircraftId: Scalars['Int'];
  crewMemberIds: Array<Scalars['Int']>;
}>;


export type BulkUpdateAircraftCrewMembersMutation = { bulkUpdateAircraftCrewMembers: boolean };

export type AircraftStatusLookupFragment = { id: number, name: string, isDeleted: boolean };

export type AircraftGridItemFragment = { id: number, registrationMark: string, priorRegistrationMarks?: Maybe<string>, serialNumber?: Maybe<string>, mtow?: Maybe<number>, certificateOfRegistrationExpirationDate?: Maybe<any>, certificateOfAirworthinessExpirationDate?: Maybe<any>, exportCertificateOfAirworthinessExpirationDate?: Maybe<any>, certificateOfInsuranceExpirationDate?: Maybe<any>, leaseAgreementExpirationDate?: Maybe<any>, managementAgreementExpirationDate?: Maybe<any>, uboName?: Maybe<string>, uboNationality?: Maybe<string>, yearOfManufacture?: Maybe<number>, numberOfPaxSeats?: Maybe<number>, initialRegistrationDate?: Maybe<any>, deregistrationDate?: Maybe<any>, hasModeSCodeDocument: boolean, totalNewComments: number, aircraftModel?: Maybe<{ name: string }>, aircraftType?: Maybe<{ name: string }>, aircraftCategory?: Maybe<{ name: string }>, aircraftClass?: Maybe<{ name: string }>, operator?: Maybe<{ isActive: boolean, company: { id: number, name: string } }>, owner?: Maybe<{ company: { id: number, name: string } }>, registeredHolder?: Maybe<{ company: { id: number, name: string } }>, aircraftStatus: { name: string }, activeAircraftProjects: Array<{ id: number }>, baseOfOperationsCountry?: Maybe<{ name: string }>, homeBaseCountry?: Maybe<{ name: string }>, aircraftManufacturer?: Maybe<{ name: string }>, aircraftEngineManufacturer?: Maybe<{ name: string }>, aircraftOperationalApproval: { rvsm?: Maybe<boolean>, nat_hla_rvsm?: Maybe<boolean>, rnp_ar?: Maybe<boolean>, rnp_apch?: Maybe<boolean>, rnav1?: Maybe<boolean>, rnav2?: Maybe<boolean>, rnav5?: Maybe<boolean>, basicRnp1?: Maybe<boolean>, rnp4?: Maybe<boolean>, rnp10?: Maybe<boolean>, gps?: Maybe<boolean>, lvto?: Maybe<boolean>, cat1?: Maybe<boolean>, cat2?: Maybe<boolean>, cat2_3a?: Maybe<boolean>, cat2_3a_3b?: Maybe<boolean>, cat2_3a_3b_3c?: Maybe<boolean>, efb_status?: Maybe<string>, hud?: Maybe<boolean>, atnb1_cpdlc?: Maybe<boolean>, cpdlc_adsc?: Maybe<boolean>, ads_b?: Maybe<boolean>, cpdlc_fan1A_plus?: Maybe<boolean>, fmc?: Maybe<boolean>, pm_cpdlc?: Maybe<boolean>, cpdlc_fan1A?: Maybe<boolean>, acars?: Maybe<boolean>, etops_edto?: Maybe<boolean> } };

export type AircraftCountryFragment = { id: number, name: string, isDeleted: boolean };

export type AircraftOperatorFragment = { id: number, isActive: boolean, company: { name: string, isActive: boolean } };

export type AircraftGridFilterLookupsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AircraftGridFilterLookupsQueryQuery = { countries: Array<AircraftCountryFragment>, operators: { operators: Array<AircraftOperatorFragment> }, aircraftStatuses: Array<AircraftStatusLookupFragment> };

export type AircraftGridQueryVariables = Exact<{
  aircraftStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  cOfAStatus?: Maybe<Scalars['String']>;
  cOfRStatus?: Maybe<Scalars['String']>;
  baseOfOperationsCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  homeBaseCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  ownerIdIn?: Maybe<Array<Scalars['Int']>>;
  registeredHolderIdIn?: Maybe<Array<Scalars['Int']>>;
  mtowMinimum?: Maybe<Scalars['Int']>;
  mtowMaximum?: Maybe<Scalars['Int']>;
  designatedAirspaceAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  allWeatherOpsAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  efbAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  hudAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  cpdlcAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  etopsAircraftOperationalApprovalFilters?: Maybe<Array<AircraftOperationalApprovalsFilterBy>>;
  keyword?: Maybe<Scalars['String']>;
  sortBy?: Maybe<AircraftsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type AircraftGridQuery = { aircrafts: { aircrafts: Array<AircraftGridItemFragment> } | { totalItems: number, aircrafts: Array<AircraftGridItemFragment> } };

export type AircraftDetailFragment = { id: number, registrationMark: string, priorRegistrationMarks?: Maybe<string>, isAircraftStatusUncertain: boolean, serialNumber?: Maybe<string>, yearOfManufacture?: Maybe<number>, mtow?: Maybe<number>, mlw?: Maybe<number>, numberOfPaxSeats?: Maybe<number>, homeBaseCity: string, homeBaseZipCode?: Maybe<string>, homeBaseAddress?: Maybe<string>, isHomeBaseSameAsBaseOfOperations: boolean, baseOfOperationsCity: string, baseOfOperationsZipCode?: Maybe<string>, baseOfOperationsAddress: string, targetReleaseDateToService?: Maybe<any>, initialRegistrationDate?: Maybe<any>, deregistrationDate?: Maybe<any>, uboName?: Maybe<string>, uboNationality?: Maybe<string>, uboNationalityId?: Maybe<number>, notes?: Maybe<string>, aircraftStatus: { id: number }, aircraftManufacturer?: Maybe<{ id: number }>, aircraftEngineManufacturer?: Maybe<{ id: number }>, aircraftPropellerManufacturer?: Maybe<{ id: number }>, aircraftModel?: Maybe<{ id: number }>, aircraftType?: Maybe<{ id: number }>, aircraftCategory?: Maybe<{ id: number }>, aircraftClass?: Maybe<{ id: number }>, homeBaseCountry?: Maybe<{ id: number, region: { id: number } }>, homeBaseState?: Maybe<{ id: number }>, baseOfOperationsCountry?: Maybe<{ id: number, region: { id: number } }>, baseOfOperationsState?: Maybe<{ id: number }>, countryOfExport?: Maybe<{ id: number }>, operator?: Maybe<{ id: number }>, owner?: Maybe<{ id: number }>, registeredHolder?: Maybe<{ id: number }>, aircraftImageFileAttachment?: Maybe<{ mimeType: string, content: string }>, activeAircraftProjects: Array<{ id: number }> };

export type AircraftDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AircraftDetailQuery = { aircraft: AircraftDetailFragment, aircraftTypes: Array<AircraftTypeFragment>, aircraftCategories: Array<AircraftCategoryFragment>, aircraftClasses: Array<AircraftClassFragment>, aircraftModels: Array<AircraftModelFragment>, aircraftManufacturers: Array<AircraftManufacturerFragment>, aircraftEngineManufacturers: Array<AircraftEngineManufacturerFragment>, aircraftPropellerManufacturers: Array<AircraftPropellerManufacturerFragment> };

export type AircraftOperationalApprovalFragment = { rvsm?: Maybe<boolean>, nat_hla_rvsm?: Maybe<boolean>, rnp_ar?: Maybe<boolean>, rnp_apch?: Maybe<boolean>, rnav1?: Maybe<boolean>, rnav2?: Maybe<boolean>, rnav5?: Maybe<boolean>, basicRnp1?: Maybe<boolean>, rnp4?: Maybe<boolean>, rnp10?: Maybe<boolean>, gps?: Maybe<boolean>, allWeatherOpsMeters?: Maybe<boolean>, lvto?: Maybe<boolean>, lvto_dh?: Maybe<number>, lvto_rvr?: Maybe<number>, lvto_minima?: Maybe<number>, cat1?: Maybe<boolean>, cat1_dh?: Maybe<number>, cat1_rvr?: Maybe<number>, cat1_minima?: Maybe<number>, cat2?: Maybe<boolean>, cat2_dh?: Maybe<number>, cat2_rvr?: Maybe<number>, cat2_minima?: Maybe<number>, cat2_3a?: Maybe<boolean>, cat2_3a_dh?: Maybe<number>, cat2_3a_rvr?: Maybe<number>, cat2_3a_minima?: Maybe<number>, cat2_3a_3b?: Maybe<boolean>, cat2_3a_3b_dh?: Maybe<number>, cat2_3a_3b_rvr?: Maybe<number>, cat2_3a_3b_minima?: Maybe<number>, cat2_3a_3b_3c?: Maybe<boolean>, cat2_3a_3b_3c_dh?: Maybe<number>, cat2_3a_3b_3c_rvr?: Maybe<number>, cat2_3a_3b_3c_minima?: Maybe<number>, efb_status?: Maybe<string>, efb_status_temporary_expiryDate?: Maybe<any>, hardwareClass1?: Maybe<boolean>, hardwareClass2?: Maybe<boolean>, hardwareClass3?: Maybe<boolean>, hardwareMakeAndType?: Maybe<string>, softwareAppTypeA?: Maybe<boolean>, dataStorageDeviceInstalled?: Maybe<boolean>, dataStorageDeviceCdDvd?: Maybe<boolean>, dataStorageDeviceOther?: Maybe<boolean>, dataStorageDeviceOtherDetail?: Maybe<string>, dataStorageDeviceNotebook?: Maybe<boolean>, dataStorageDeviceNotepad?: Maybe<boolean>, dataStorageDevicePda?: Maybe<boolean>, dataStorageDeviceMakeAndType?: Maybe<string>, hud?: Maybe<boolean>, svs?: Maybe<boolean>, nvg_nvis?: Maybe<boolean>, evs_efvs?: Maybe<boolean>, cvs?: Maybe<boolean>, hudMakeAndType?: Maybe<string>, opCreditRequestedYes?: Maybe<boolean>, singlePilot?: Maybe<boolean>, atnb1_cpdlc?: Maybe<boolean>, cpdlc_adsc?: Maybe<boolean>, ads_b?: Maybe<boolean>, cpdlc_fan1A_plus?: Maybe<boolean>, fmc?: Maybe<boolean>, pm_cpdlc?: Maybe<boolean>, cpdlc_fan1A?: Maybe<boolean>, acars?: Maybe<boolean>, etops_edto?: Maybe<boolean>, maximumDiversionTime?: Maybe<number> };

export type AircraftOperationalApprovalQueryVariables = Exact<{
  aircraftId: Scalars['Int'];
}>;


export type AircraftOperationalApprovalQuery = { aircraftOperationalApproval: AircraftOperationalApprovalFragment };

export type UpdateAircraftMutationVariables = Exact<{
  input: UpdateAircraftInput;
}>;


export type UpdateAircraftMutation = { updateAircraft: { id: number } };

export type UpdateAircraftOperationalApprovalMutationVariables = Exact<{
  input: UpdateAircraftOperationalApprovalInput;
}>;


export type UpdateAircraftOperationalApprovalMutation = { updateAircraftOperationalApproval: { aircraftId: number } };

export type AircraftMainLookupsQueryVariables = Exact<{ [key: string]: never; }>;


export type AircraftMainLookupsQuery = { aircraftStatuses: Array<AircraftStatusFragment>, operators: { operators: Array<OperatorLookupFragment> }, owners: { owners: Array<AircraftOwnerLookupFragment> }, registeredHolders: { registeredHolders: Array<AircraftRegisteredHolderLookupFragment> } };

export type ApproveAircraftProjectCertificateMutationVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
}>;


export type ApproveAircraftProjectCertificateMutation = { approveAircraftProjectDocumentType: { id: number, warnings?: Maybe<Array<string>> } };

export type ReopenAircraftProjectCertificateMutationVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
}>;


export type ReopenAircraftProjectCertificateMutation = { reopenAircraftProjectDocumentTypeForApproval: { id: number, warnings?: Maybe<Array<string>> } };

export type ReturnAircraftProjectCertificateForAdditionalReviewMutationVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
}>;


export type ReturnAircraftProjectCertificateForAdditionalReviewMutation = { returnAircraftProjectDocumentTypeForAdditionalReview: { id: number, warnings?: Maybe<Array<string>> } };

export type SendAircraftProjectCertificateForApprovalMutationVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
}>;


export type SendAircraftProjectCertificateForApprovalMutation = { sendAircraftProjectDocumentTypeForApproval: { id: number, warnings?: Maybe<Array<string>> } };

export type ToggleAircraftProjectCertificateIsApprovalRequiredMutationVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
}>;


export type ToggleAircraftProjectCertificateIsApprovalRequiredMutation = { toggleAircraftProjectCertificateIsApprovalRequired: boolean };

export type AircraftProjectIncompleteInspectionsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AircraftProjectIncompleteInspectionsQuery = { aircraftProject: { aircraftProjectInspections: Array<{ inspection: { id: number, inspectionStatus: { id: number } } }> } };

export type AircraftProjectAccessCheckQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
}>;


export type AircraftProjectAccessCheckQuery = { aircraftProject: { projectStatus: { id: number } } };

export type AircraftProjectDetailFragment = { id: number, uboName?: Maybe<string>, uboNationality?: Maybe<string>, uboNationalityId?: Maybe<number>, registrationMark: string, priorRegistrationMarks?: Maybe<string>, projectNumber?: Maybe<string>, updateDate: any, isAircraftStatusUncertain: boolean, serialNumber?: Maybe<string>, dcaAircraftManufacturer?: Maybe<string>, dcaAircraftEngineManufacturer?: Maybe<string>, dcaAircraftPropellerManufacturer?: Maybe<string>, dcaAircraftModel?: Maybe<string>, yearOfManufacture?: Maybe<number>, mtow?: Maybe<number>, dcaMtow?: Maybe<string>, mlw?: Maybe<number>, dcaMlw?: Maybe<string>, numberOfPaxSeats?: Maybe<number>, homeBaseCity: string, homeBaseZipCode?: Maybe<string>, homeBaseAddress?: Maybe<string>, isHomeBaseSameAsBaseOfOperations: boolean, baseOfOperationsCity: string, baseOfOperationsZipCode?: Maybe<string>, baseOfOperationsAddress: string, targetReleaseDateToService?: Maybe<any>, initialRegistrationDate?: Maybe<any>, deregistrationDate?: Maybe<any>, clientSubmissionDate?: Maybe<any>, dcaSubmissionDate?: Maybe<any>, dcaOperator?: Maybe<string>, dcaOperatorAddress?: Maybe<string>, dcaOperatorAddressCountry?: Maybe<string>, dcaOwner?: Maybe<string>, dcaOwnerAddress?: Maybe<string>, dcaOwnerAddressCountry?: Maybe<string>, dcaOwnerOperator?: Maybe<string>, dcaOwnerOperatorAddress?: Maybe<string>, dcaOwnerOperatorPhone?: Maybe<string>, dcaOwnerOperatorFax?: Maybe<string>, dcaOwnerOperatorEmailAddress?: Maybe<string>, dcaRegisteredHolder?: Maybe<string>, dcaRegisteredHolderAddress?: Maybe<string>, dcaRegisteredHolderAddressCountry?: Maybe<string>, turnaroundDays?: Maybe<number>, dcaNoiseCertificationStandard?: Maybe<string>, dcaNoiseCertificationAdditionalModifications?: Maybe<string>, dcaLateralFullPowerNoiseLevel?: Maybe<number>, dcaApproachNoiseLevel?: Maybe<number>, dcaFlyoverNoiseLevel?: Maybe<number>, dcaOverflightNoiseLevel?: Maybe<number>, dcaIsOverflightNoiseLevelInDBASELUnits?: Maybe<boolean>, dcaTakeoffNoiseLevel?: Maybe<number>, dcaNoiseCertificationRemarks?: Maybe<string>, rvsm?: Maybe<boolean>, rvsmDescription?: Maybe<string>, natHlaMnps?: Maybe<boolean>, natHlaMnpsDescription?: Maybe<string>, natHlaMnpsRemarks?: Maybe<string>, lvto?: Maybe<boolean>, lvtoRvr?: Maybe<number>, lvtoRemarks?: Maybe<string>, cat1Lts?: Maybe<boolean>, cat1LtsRvr?: Maybe<number>, cat1LtsRemarks?: Maybe<string>, cat2?: Maybe<boolean>, cat2Rvr?: Maybe<number>, cat2Dh?: Maybe<number>, cat2Remarks?: Maybe<string>, cat3?: Maybe<boolean>, cat3Rvr?: Maybe<number>, cat3Dh?: Maybe<number>, cat3Remarks?: Maybe<string>, hudEvsSvsCvs?: Maybe<boolean>, hudEvsSvsCvsDescription?: Maybe<string>, hudEvsSvsCvsRemarks?: Maybe<string>, rnpAr?: Maybe<boolean>, rnpArDescription?: Maybe<string>, rnpArRemarks?: Maybe<string>, rnpApch?: Maybe<boolean>, rnpApchDescription?: Maybe<string>, rnpApchRemarks?: Maybe<string>, rnav1PRnav?: Maybe<boolean>, rnav1PRnavDescription?: Maybe<string>, rnav1PRnavRemarks?: Maybe<string>, rnav2?: Maybe<boolean>, rnav2Description?: Maybe<string>, rnav2Remarks?: Maybe<string>, rnav5BRnav?: Maybe<boolean>, rnav5BRnavDescription?: Maybe<string>, rnav5BRnavRemarks?: Maybe<string>, basicRnp1?: Maybe<boolean>, basicRnp1Description?: Maybe<string>, basicRnp1Remarks?: Maybe<string>, rnp4?: Maybe<boolean>, rnp4Description?: Maybe<string>, rnp4Remarks?: Maybe<string>, rnp10?: Maybe<boolean>, rnp10Description?: Maybe<string>, rnp10Remarks?: Maybe<string>, atnb1CpdlcLink2000Plus?: Maybe<boolean>, atnb1CpdlcLink2000PlusDescription?: Maybe<string>, atnb1CpdlcLink2000PlusRemarks?: Maybe<string>, cpdlcFans1APlus?: Maybe<boolean>, cpdlcFans1APlusRcp?: Maybe<number>, cpdlcFans1APlusRsp?: Maybe<number>, cpdlcFans1APlusRemarks?: Maybe<string>, cpdlcFans1A?: Maybe<boolean>, cpdlcFans1ARcp?: Maybe<number>, cpdlcFans1ARsp?: Maybe<number>, cpdlcFans1ARemarks?: Maybe<string>, cpdlcAdsCFans1APlus?: Maybe<boolean>, cpdlcAdsCFans1APlusRcp?: Maybe<number>, cpdlcAdsCFans1APlusRsp?: Maybe<number>, cpdlcAdsCFans1APlusRemarks?: Maybe<string>, fmcWpr?: Maybe<boolean>, fmcWprDescription?: Maybe<string>, fmcWprRemarks?: Maybe<string>, acarsAts?: Maybe<boolean>, acarsAtsDescription?: Maybe<string>, acarsAtsRemarks?: Maybe<string>, adsBOut?: Maybe<boolean>, adsBOutDescription?: Maybe<string>, adsBOutRemarks?: Maybe<string>, pmCpdlc?: Maybe<boolean>, pmCpdlcDescription?: Maybe<string>, pmCpdlcRemarks?: Maybe<string>, edtoEtops?: Maybe<boolean>, edtoEtopsMinutes?: Maybe<string>, edtoEtopsRemarks?: Maybe<string>, efb?: Maybe<boolean>, efbCategoryPortable?: Maybe<boolean>, efbCategoryInstalled?: Maybe<boolean>, efbRemarks?: Maybe<string>, steepApproach?: Maybe<boolean>, steepApproachAirport?: Maybe<string>, steepApproachRemarks?: Maybe<string>, priorCertificateOfRegistrationIssueDate?: Maybe<any>, priorCertificateOfRegistrationExpirationDate?: Maybe<any>, priorCertificateOfAirworthinessIssueDate?: Maybe<any>, priorCertificateOfAirworthinessExpirationDate?: Maybe<any>, priorNoiseCertificateIssueDate?: Maybe<any>, priorAircraftRadioStationLicenseIssueDate?: Maybe<any>, priorAirspaceApprovalCertificateIssueDate?: Maybe<any>, certificateOfRegistrationIssueDate?: Maybe<any>, certificateOfRegistrationExpirationDate?: Maybe<any>, certificateOfRegistrationCtcDaysValid: number, certificateOfAirworthinessIssueDate?: Maybe<any>, certificateOfAirworthinessExpirationDate?: Maybe<any>, certificateOfAirworthinessCtcDaysValid: number, noiseCertificateIssueDate?: Maybe<any>, noiseCertificateExpiryDate?: Maybe<any>, isNoiseCertificateExpiryIndefinite?: Maybe<boolean>, noiseCertificateCtcDaysValid: number, aircraftRadioStationLicenseIssueDate?: Maybe<any>, aircraftRadioStationLicenseExpiryDate?: Maybe<any>, isAircraftRadioStationLicenseExpiryIndefinite?: Maybe<boolean>, aircraftRadioStationLicenseCtcDaysValid: number, airspaceApprovalCertificateIssueDate?: Maybe<any>, airspaceApprovalCertificateExpiryDate?: Maybe<any>, isAirspaceApprovalCertificateExpiryIndefinite?: Maybe<boolean>, airspaceApprovalCertificateCtcDaysValid: number, exportProduct?: Maybe<string>, exportTCHolder?: Maybe<string>, exportIsNew?: Maybe<boolean>, exportIsNewlyOverhauled?: Maybe<boolean>, exportIsUsed?: Maybe<boolean>, exportCountry?: Maybe<string>, exportRemarks?: Maybe<string>, exportExceptions?: Maybe<string>, exportDate?: Maybe<any>, exportAcTtHours?: Maybe<number>, exportAcTtMinutes?: Maybe<number>, exportAcTcCycles?: Maybe<number>, exportLhEngine?: Maybe<string>, exportLhEngineSerialNumber?: Maybe<string>, exportLhEngineTtHours?: Maybe<number>, exportLhEngineTtMinutes?: Maybe<number>, exportLhEngineTcCycles?: Maybe<number>, exportRhEngine?: Maybe<string>, exportRhEngineSerialNumber?: Maybe<string>, exportRhEngineTtHours?: Maybe<number>, exportRhEngineTtMinutes?: Maybe<number>, exportRhEngineTcCycles?: Maybe<number>, sfpNumber?: Maybe<string>, sfpRevision?: Maybe<string>, sfpIssueDate?: Maybe<any>, sfpIssuedTo?: Maybe<string>, sfpIsFlightPermit?: Maybe<boolean>, sfpIsTestFlight?: Maybe<boolean>, sfpTestFlightsWithinDistance?: Maybe<string>, sfpTestFlightsRadius?: Maybe<string>, sfpIsFerryFlight?: Maybe<boolean>, sfpFerryFlightFrom?: Maybe<string>, sfpFerryFlightTo?: Maybe<string>, sfpIsEvacuationFerryFlight?: Maybe<boolean>, sfpEvacuationFerryFlightFrom?: Maybe<string>, sfpEvacuationFerryFlightTo?: Maybe<string>, sfpEvacuationFerryFlightVia?: Maybe<string>, sfpIsInterimCofA?: Maybe<boolean>, sfpInterimCofAIsTransport?: Maybe<boolean>, sfpInterimCofAIsNormal?: Maybe<boolean>, sfpInterimCofAIsRestricted?: Maybe<boolean>, sfpInterimCofAIsRadioStationLicense?: Maybe<boolean>, sfpIsSubjectToSpecialConditions?: Maybe<boolean>, sfpIssueNumber1?: Maybe<string>, sfpIssueNumber2?: Maybe<string>, sfpIsSpecialConditionA?: Maybe<boolean>, sfpSpecialConditionANumberOfFlights?: Maybe<number>, sfpSpecialConditionAUntilDate?: Maybe<any>, sfpIsSpecialConditionB?: Maybe<boolean>, sfpSpecialConditionBUntilReceipt?: Maybe<any>, sfpIsOnlyAuthorityAorBApproved?: Maybe<boolean>, sfpIsSpecialCondition1?: Maybe<boolean>, sfpIsSpecialCondition2?: Maybe<boolean>, sfpSpecialCondition2Mtow?: Maybe<string>, sfpIsSpecialCondition3?: Maybe<boolean>, sfpSpecialCondition3Name1?: Maybe<string>, sfpSpecialCondition3Position1?: Maybe<string>, sfpSpecialCondition3License1?: Maybe<string>, sfpSpecialCondition3Name2?: Maybe<string>, sfpSpecialCondition3Position2?: Maybe<string>, sfpSpecialCondition3License2?: Maybe<string>, sfpSpecialCondition3Name3?: Maybe<string>, sfpSpecialCondition3Position3?: Maybe<string>, sfpSpecialCondition3License3?: Maybe<string>, sfpSpecialCondition3Name4?: Maybe<string>, sfpSpecialCondition3Position4?: Maybe<string>, sfpSpecialCondition3License4?: Maybe<string>, sfpSpecialCondition3Name5?: Maybe<string>, sfpSpecialCondition3Position5?: Maybe<string>, sfpSpecialCondition3License5?: Maybe<string>, sfpIsSpecialCondition4?: Maybe<boolean>, sfpIsSpecialCondition5?: Maybe<boolean>, sfpIsSpecialCondition6?: Maybe<boolean>, sfpIsSpecialCondition7?: Maybe<boolean>, sfpIsSpecialCondition8?: Maybe<boolean>, sfpSpecialCondition8Base?: Maybe<string>, sfpIsSpecialCondition9?: Maybe<boolean>, sfpSpecialCondition9Miles?: Maybe<number>, sfpSpecialCondition9Base?: Maybe<string>, sfpIsSpecialCondition10?: Maybe<boolean>, sfpIsSpecialCondition11?: Maybe<boolean>, sfpIsSpecialCondition12?: Maybe<boolean>, sfpIsSpecialCondition13?: Maybe<boolean>, sfpSpecialCondition13HoursOfFlight?: Maybe<number>, sfpSpecialCondition13HoursOfPilot?: Maybe<number>, sfpIsSpecialCondition14?: Maybe<boolean>, sfpSpecialCondition14Other?: Maybe<string>, cofrOwnerRemark?: Maybe<string>, cofrCertificateNumber?: Maybe<string>, cofaCertificateNumber?: Maybe<string>, noiseCertificateNumber?: Maybe<string>, aircraftRadioStationLicenseNumber?: Maybe<string>, airspaceAndSpecialApprovalCertificateNumber?: Maybe<string>, exportCofaCertificateNumber?: Maybe<string>, aircraft: { id: number, uboName?: Maybe<string>, uboNationality?: Maybe<string>, uboNationalityId?: Maybe<number> }, aircraftProjectType: { id: number, hasInspections: boolean, hasOnlyBasicInspectionDocuments: boolean }, projectStatus: { id: number }, preparedByDcaUser?: Maybe<{ id: number }>, aircraftStatus: { id: number }, aircraftManufacturer?: Maybe<{ id: number }>, aircraftEngineManufacturer?: Maybe<{ id: number }>, aircraftPropellerManufacturer?: Maybe<{ id: number }>, aircraftModel?: Maybe<{ id: number }>, aircraftType?: Maybe<{ id: number }>, aircraftCategory?: Maybe<{ id: number }>, aircraftClass?: Maybe<{ id: number }>, homeBaseCountry?: Maybe<{ id: number, region: { id: number } }>, homeBaseState?: Maybe<{ id: number }>, baseOfOperationsCountry?: Maybe<{ id: number, region: { id: number } }>, baseOfOperationsState?: Maybe<{ id: number }>, countryOfExport?: Maybe<{ id: number }>, operator?: Maybe<{ id: number }>, owner?: Maybe<{ id: number }>, registeredHolder?: Maybe<{ id: number }>, aircraftImageFileAttachment?: Maybe<{ mimeType: string, content: string }>, assignedDepartments: Array<{ id: number }>, assignedDepartmentUsers: Array<{ id: number, department?: Maybe<{ id: number }> }>, assignees: Array<{ id: number, displayName: string }> };

export type AircraftProjectDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AircraftProjectDetailQuery = { aircraftProject: AircraftProjectDetailFragment, aircraftTypes: Array<AircraftTypeFragment>, aircraftCategories: Array<AircraftCategoryFragment>, aircraftClasses: Array<AircraftClassFragment>, aircraftModels: Array<AircraftModelFragment>, aircraftManufacturers: Array<AircraftManufacturerFragment>, aircraftEngineManufacturers: Array<AircraftEngineManufacturerFragment>, aircraftPropellerManufacturers: Array<AircraftPropellerManufacturerFragment> };

export type AircraftProjectDocumentTypeApprovalStatusFragment = { isApprovalRequired: boolean, documentType: DocumentTypeFragment, approvalStatus: { id: number }, document?: Maybe<{ createDate: any, createdByUser: { id: number, displayName: string } }> };

export type AircraftProjectDocumentTypeApprovalStatusesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AircraftProjectDocumentTypeApprovalStatusesQuery = { aircraftProjectDocumentTypeApprovalStatuses: Array<AircraftProjectDocumentTypeApprovalStatusFragment> };

export type AircraftProjectDocumentFragment = { id: number, isReleasedToDca: boolean, isArchived: boolean, document: DocumentForDocumentListsFragment };

export type AircraftProjectDocumentsQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  aircraftProjectTypeId: Scalars['Int'];
  documentTypeCategoryIds: Array<DocumentTypeCategoryEnum>;
}>;


export type AircraftProjectDocumentsQuery = { documents: Array<AircraftProjectDocumentFragment>, documentTypes: Array<DocumentTypeFragment> };

export type AircraftProjectHeaderQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
}>;


export type AircraftProjectHeaderQuery = { aircraftProject: AircraftProjectHeaderFragment, documentTypesForApproval: Array<{ id: number }>, documentTypesApproved: Array<{ documentType: { id: number } }>, documentTypesPendingApproval: Array<{ documentType: { name: string } }>, certificateTypes: Array<{ id: number }> };

export type AircraftProjectHeaderFragment = { id: number, registrationMark: string, projectCreationDate: any, isOnHold: boolean, isOnHoldByDca: boolean, dcaHoldReason?: Maybe<string>, isDcaInvoiced: boolean, isArgInvoiced: boolean, operator?: Maybe<{ company: { name: string } }>, aircraftProjectType: { id: number, name: string }, projectStatus: { id: number, name: string }, projectStage: { id: number, name: string }, projectCreatedByUser: { firstName?: Maybe<string>, lastName?: Maybe<string> }, assignees: Array<{ id: number }> };

export type AircraftProjectInsFormAssociatedDocumentFragment = { id: number, isReleasedToDca: boolean, isArchived: boolean, insForm: { id: number }, insFormAssociatedDocumentGroup?: Maybe<{ id: number }>, document: DocumentForDocumentListsFragment };

export type AircraftProjectInsFormAssociatedDocumentsQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
}>;


export type AircraftProjectInsFormAssociatedDocumentsQuery = { aircraftProject: { insFormAssociatedDocuments: Array<AircraftProjectInsFormAssociatedDocumentFragment>, projectInsForms: Array<ProjectInsFormAssociatedDocumentTypesFragment> }, insFormAssociatedDocumentGroups: Array<InsFormAssociatedDocumentGroupFragment> };

export type AircraftProjectInspectionsQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
}>;


export type AircraftProjectInspectionsQuery = { aircraftProject: { currentInspections: Array<{ id: number, inspection: InspectionDetailForAllProjectsFragment }>, priorInspections: Array<{ id: number, inspection: InspectionDetailForAllProjectsFragment }> } };

export type AircraftProjectLinkedCrewProjectsCheckQueryVariables = Exact<{
  associatedAircraftProjectIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
}>;


export type AircraftProjectLinkedCrewProjectsCheckQuery = { crewProjects: { crewProjects: Array<{ id: number }> } };

export type AircraftProjectLinkedMechanicProjectsCheckQueryVariables = Exact<{
  associatedAircraftProjectIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
}>;


export type AircraftProjectLinkedMechanicProjectsCheckQuery = { mechanicProjects: { mechanicProjects: Array<{ id: number }> } };

export type AircraftProjectMissingInspectionFileAttachmentsInspectionFragment = { id: number, inspectionStatus: { id: number }, letterOfFindingsFileAttachment?: Maybe<{ fileSizeBytes: number }>, insForm4001FileAttachment?: Maybe<{ fileSizeBytes: number }>, inspectorInspections: Array<{ inspectionTimeLogFileAttachment?: Maybe<{ fileSizeBytes: number }>, inspectionInvoiceFileAttachment?: Maybe<{ fileSizeBytes: number }> }> };

export type AircraftProjectMissingInspectionFileAttachmentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AircraftProjectMissingInspectionFileAttachmentsQuery = { aircraftProject: { aircraftProjectInspections: Array<{ inspection: AircraftProjectMissingInspectionFileAttachmentsInspectionFragment }> } };

export type AircraftProjectMissingRequiredDocumentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AircraftProjectMissingRequiredDocumentsQuery = { aircraftProject: { aircraftProjectMissingRequiredDocuments: Array<string> } };

export type AircraftProjectOfficialLetterNotesQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
}>;


export type AircraftProjectOfficialLetterNotesQuery = { aircraftProject: { officialLetterDocumentsNote?: Maybe<string>, documentTypeOfficialLetterNotes: Array<{ officialLetterNote?: Maybe<string>, documentType: { id: number, name: string } }> } };

export type AircraftProjectQuickGlanceQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
}>;


export type AircraftProjectQuickGlanceQuery = { dcaHistory: Array<{ performedByName: string, date: any, projectStatus?: Maybe<{ id: number, name: string }>, projectTransition?: Maybe<{ id: number, name: string }> }> };

export type AircraftProjectReopenByDcaOpenProjectsCheckQueryVariables = Exact<{
  aircraftId: Scalars['Int'];
  projectStatusIdNotIn: Array<Scalars['Int']>;
}>;


export type AircraftProjectReopenByDcaOpenProjectsCheckQuery = { aircraftProjects: { aircraftProjects: Array<{ id: number }> } };

export type AircraftProjectSendToDcaCheckQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
}>;


export type AircraftProjectSendToDcaCheckQuery = { aircraftProjectInsForms: Array<SendToDcaCheckFragment> };

export type AircraftProjectSummaryQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
}>;


export type AircraftProjectSummaryQuery = { aircraftProject: { id: number, registrationMark: string, isHighImportance: boolean, isOnHold: boolean, isOnHoldByDca: boolean, dcaHoldReason?: Maybe<string>, projectCreationDate: any, isNoDcaInvoiceRequired: boolean, certificateOfAirworthinessExpirationDate?: Maybe<any>, certificateOfRegistrationExpirationDate?: Maybe<any>, noiseCertificateExpiryDate?: Maybe<any>, aircraftRadioStationLicenseExpiryDate?: Maybe<any>, airspaceApprovalCertificateExpiryDate?: Maybe<any>, aircraftProjectType: { name: string }, projectStatus: { id: number }, assignees: Array<(
      { id: number, firstName?: Maybe<string>, lastName?: Maybe<string> }
      & UserFragment
    )>, assignedDepartmentUsers: Array<{ displayName: string }>, projectCreatedByUser: { id: number, firstName?: Maybe<string>, lastName?: Maybe<string> }, documents: Array<{ id: number, isReleasedToDca: boolean, document: { documentType: { id: number, isAlwaysVisibleToDca: boolean }, fileAttachment: { fileName: string, fileSizeBytes: number, mimeType: string } } }> } };

export type ArgHoldAircraftProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ArgHoldAircraftProjectMutation = { holdAircraftProject: { id: number } };

export type ArgRemoveHoldAircraftProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ArgRemoveHoldAircraftProjectMutation = { releaseAircraftProject: { id: number } };

export type DcaCompleteAircraftProjectTaskMutationVariables = Exact<{
  input: CompleteAircraftProjectTaskInput;
}>;


export type DcaCompleteAircraftProjectTaskMutation = { completeAircraftProjectTask: { id: number, warnings?: Maybe<Array<string>> } };

export type DcaHoldAircraftProjectMutationVariables = Exact<{
  input: DcaHoldAircraftProjectInput;
}>;


export type DcaHoldAircraftProjectMutation = { dcaHoldAircraftProject: { id: number } };

export type DcaRemoveHoldAircraftProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DcaRemoveHoldAircraftProjectMutation = { dcaReleaseAircraftProject: { id: number } };

export type DcaSendAircraftProjectBackToIasoMutationVariables = Exact<{
  input: SendAircraftProjectToIasoInput;
}>;


export type DcaSendAircraftProjectBackToIasoMutation = { sendAircraftProjectBackToIaso: { id: number } };

export type DeleteAircraftProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAircraftProjectMutation = { deleteAircraftProject: { id: number } };

export type TransitionAircraftProjectMutationVariables = Exact<{
  input: TransitionProjectInput;
}>;


export type TransitionAircraftProjectMutation = { transitionAircraftProject: { id: number, warnings?: Maybe<Array<string>> } };

export type SetAircraftProjectAssigneesMutationVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  assigneeUserIds: Array<Scalars['Int']>;
}>;


export type SetAircraftProjectAssigneesMutation = { setAircraftProjectAssignees: { id: number } };

export type SetAircraftProjectNoDcaInvoiceRequiredFlagMutationVariables = Exact<{
  id: Scalars['Int'];
  isNoDcaInvoiceRequired: Scalars['Boolean'];
}>;


export type SetAircraftProjectNoDcaInvoiceRequiredFlagMutation = { setAircraftProjectNoDcaInvoiceRequiredFlag: boolean };

export type SetAircraftProjectPriorityMutationVariables = Exact<{
  id: Scalars['Int'];
  isHighPriority: Scalars['Boolean'];
}>;


export type SetAircraftProjectPriorityMutation = { setAircraftProjectPriority: { id: number } };

export type UpdateAircraftProjectMutationMutationVariables = Exact<{
  updateAircraftProjectInput: UpdateAircraftProjectInput;
  ignoreWarnings: Scalars['Boolean'];
}>;


export type UpdateAircraftProjectMutationMutation = { updateAircraftProject: { warnings?: Maybe<Array<string>>, aircraftProject?: Maybe<{ id: number }> } };

export type UpdateAircraftProjectInspectionsMutationVariables = Exact<{
  input: UpdateAircraftProjectInspectionsInput;
}>;


export type UpdateAircraftProjectInspectionsMutation = { updateAircraftProjectInspections: boolean };

export type UpdateAircraftProjectOfficialLetterDocumentNotesMutationVariables = Exact<{
  input: UpdateAircraftProjectOfficialLetterNotesInput;
}>;


export type UpdateAircraftProjectOfficialLetterDocumentNotesMutation = { updateAircraftProjectOfficialLetterDocumentNotes: { id: number } };

export type AddAircraftProjectDocumentMutationMutationVariables = Exact<{
  addAircraftProjectDocumentInput: AddAircraftProjectDocumentInput;
}>;


export type AddAircraftProjectDocumentMutationMutation = { addAircraftProjectDocument: { id: number } };

export type UpdateAircraftProjectDocumentMutationMutationVariables = Exact<{
  updateAircraftProjectDocumentInput: UpdateAircraftProjectDocumentInput;
}>;


export type UpdateAircraftProjectDocumentMutationMutation = { updateAircraftProjectDocument: { id: number } };

export type RemoveAircraftProjectDocumentMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveAircraftProjectDocumentMutationMutation = { removeAircraftProjectDocument: boolean };

export type DownloadAircraftProjectDocumentQueryVariables = Exact<{
  id: Scalars['Int'];
  aircraftProjectId: Scalars['Int'];
}>;


export type DownloadAircraftProjectDocumentQuery = { file?: Maybe<DownloadFileFragment> };

export type RequestAircraftProjectDocumentDownloadTokenMutationMutationVariables = Exact<{
  id: Scalars['Int'];
  aircraftProjectId: Scalars['Int'];
  downloadFileName?: Maybe<Scalars['String']>;
}>;


export type RequestAircraftProjectDocumentDownloadTokenMutationMutation = { requestAircraftProjectDocumentDownloadToken: string };

export type UpdateAircraftProjectDocumentReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateAircraftProjectOperatorDocumentReleasedToDcaInput;
}>;


export type UpdateAircraftProjectDocumentReleasedToDcaMutationMutation = { updateAircraftProjectDocumentReleasedToDca: { id: number } };

export type AircraftProjectGridItemFragment = { id: number, registrationMark: string, isHighImportance: boolean, isOnHold: boolean, isOnHoldByDca: boolean, clientSubmissionDate?: Maybe<any>, dcaSubmissionDate?: Maybe<any>, turnaroundDays?: Maybe<number>, totalNewComments: number, totalNewDcaComments: number, yearOfManufacture?: Maybe<number>, initialRegistrationDate?: Maybe<any>, numberOfPaxSeats?: Maybe<number>, serialNumber?: Maybe<string>, archivedDate?: Maybe<any>, aircraftProjectType: { id: number, name: string }, operator?: Maybe<{ company: { name: string } }>, projectStatus: { name: string }, projectStage: { name: string }, assignees: Array<{ firstName?: Maybe<string>, lastName?: Maybe<string>, userName?: Maybe<string> }>, aircraftClass?: Maybe<{ id: number, name: string }>, aircraftCategory?: Maybe<{ id: number, name: string }>, aircraftManufacturer?: Maybe<{ id: number, name: string }>, aircraftModel?: Maybe<{ id: number, name: string }>, aircraftStatus: { id: number, name: string }, aircraftEngineManufacturer?: Maybe<{ id: number, name: string }>, owner?: Maybe<{ company: { name: string } }>, registeredHolder?: Maybe<{ company: { name: string } }> };

export type AircraftProjectGridQueryVariables = Exact<{
  sortBy?: Maybe<AircraftProjectsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  aircraftId?: Maybe<Scalars['Int']>;
  projectStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  keyword?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type AircraftProjectGridQuery = { aircraftProjects: { aircraftProjects: Array<AircraftProjectGridItemFragment> } | { totalItems: number, aircraftProjects: Array<AircraftProjectGridItemFragment> } };

export type AddAircraftProjectInsFormAssociatedDocumentMutationMutationVariables = Exact<{
  addAircraftProjectInsFormAssociatedDocumentInput: AddAircraftProjectInsFormAssociatedDocumentInput;
}>;


export type AddAircraftProjectInsFormAssociatedDocumentMutationMutation = { addAircraftProjectInsFormAssociatedDocument: { id: number } };

export type UpdateAircraftProjectInsFormAssociatedDocumentMutationMutationVariables = Exact<{
  updateAircraftProjectInsFormAssociatedDocumentInput: UpdateAircraftProjectInsFormAssociatedDocumentInput;
}>;


export type UpdateAircraftProjectInsFormAssociatedDocumentMutationMutation = { updateAircraftProjectInsFormAssociatedDocument: { id: number } };

export type RemoveAircraftProjectInsFormAssociatedDocumentMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveAircraftProjectInsFormAssociatedDocumentMutationMutation = { removeAircraftProjectInsFormAssociatedDocument: boolean };

export type DownloadAircraftProjectInsFormAssociatedDocumentQueryVariables = Exact<{
  id: Scalars['Int'];
  aircraftProjectId: Scalars['Int'];
}>;


export type DownloadAircraftProjectInsFormAssociatedDocumentQuery = { file?: Maybe<DownloadFileFragment> };

export type RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutationVariables = Exact<{
  id: Scalars['Int'];
  aircraftProjectId: Scalars['Int'];
  downloadFileName?: Maybe<Scalars['String']>;
}>;


export type RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutation = { requestAircraftProjectInsFormAssociatedDocumentDownloadToken: string };

export type UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateAircraftProjectOperatorInsFormAssociatedDocumentReleasedToDcaInput;
}>;


export type UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutation = { updateAircraftProjectInsFormAssociatedDocumentReleasedToDca: { id: number } };

export type AircraftProjectInspectionCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AircraftProjectInspectionCommentsQuery = { aircraftProjectInspectionComments: CommentsFragment };

export type AddAircraftProjectInspectionCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddAircraftProjectInspectionCommentMutation = { addAircraftProjectInspectionComment: CommentFragment };

export type UpdateAircraftProjectInspectionCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateAircraftProjectInspectionCommentMutation = { updateAircraftProjectInspectionComment: CommentFragment };

export type UpdateAircraftProjectInspectionCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateAircraftProjectInspectionCommentsLastViewedDateMutation = { updateAircraftProjectInspectionCommentsLastViewedDate: { id: number } };

export type DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
}>;


export type DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQuery = { downloadAircraftProjectInspectionLetterOfFindings?: Maybe<string> };

export type DownloadAircraftProjectInspectionInsForm4001AttachmentContentQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
}>;


export type DownloadAircraftProjectInspectionInsForm4001AttachmentContentQuery = { downloadAircraftProjectInspectionInsForm4001?: Maybe<string> };

export type DownloadAircraftProjectInspectionInsForm4007AttachmentContentQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
}>;


export type DownloadAircraftProjectInspectionInsForm4007AttachmentContentQuery = { downloadAircraftProjectInspectionInsForm4007?: Maybe<string> };

export type DownloadAircraftProjectInspectionInsForm4023BAttachmentContentQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
}>;


export type DownloadAircraftProjectInspectionInsForm4023BAttachmentContentQuery = { downloadAircraftProjectInspectionInsForm4023B?: Maybe<string> };

export type DownloadAircraftProjectInspectionInsForm4045AttachmentContentQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
}>;


export type DownloadAircraftProjectInspectionInsForm4045AttachmentContentQuery = { downloadAircraftProjectInspectionInsForm4045?: Maybe<string> };

export type DownloadAircraftProjectInspectionInsForm16005AAttachmentContentQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
}>;


export type DownloadAircraftProjectInspectionInsForm16005AAttachmentContentQuery = { downloadAircraftProjectInspectionInsForm16005A?: Maybe<string> };

export type DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
  inspectorInspectionId: Scalars['Int'];
}>;


export type DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQuery = { downloadAircraftProjectInspectionInspectorInspectionEstimate?: Maybe<string> };

export type DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
  inspectorInspectionId: Scalars['Int'];
}>;


export type DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQuery = { downloadAircraftProjectInspectionInspectorInspectionInvoice?: Maybe<string> };

export type DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
  inspectorInspectionId: Scalars['Int'];
}>;


export type DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQuery = { downloadAircraftProjectInspectionInspectorInspectionTimeLog?: Maybe<string> };

export type AircraftProjectCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AircraftProjectCommentsQuery = { aircraftProjectComments: CommentsFragment };

export type AddAircraftProjectCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddAircraftProjectCommentMutation = { addAircraftProjectComment: CommentFragment };

export type UpdateAircraftProjectCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateAircraftProjectCommentMutation = { updateAircraftProjectComment: CommentFragment };

export type AircraftProjectDcaCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AircraftProjectDcaCommentsQuery = { aircraftProjectDcaComments: CommentsFragment };

export type AddAircraftProjectDcaCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddAircraftProjectDcaCommentMutation = { addAircraftProjectDcaComment: CommentFragment };

export type UpdateAircraftProjectDcaCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateAircraftProjectDcaCommentMutation = { updateAircraftProjectDcaComment: CommentFragment };

export type UpdateAircraftProjectInspectionLetterOfFindingsMutationVariables = Exact<{
  input: UpdateAircraftProjectInspectionLetterOfFindingsInput;
}>;


export type UpdateAircraftProjectInspectionLetterOfFindingsMutation = { updateAircraftProjectInspectionLetterOfFindings: boolean };

export type UpdateAircraftProjectInspectionInsForm4001MutationVariables = Exact<{
  input: UpdateAircraftProjectInspectionInsForm4001Input;
}>;


export type UpdateAircraftProjectInspectionInsForm4001Mutation = { updateAircraftProjectInspectionInsForm4001: boolean };

export type UpdateAircraftProjectInspectionInsForm4007MutationVariables = Exact<{
  input: UpdateAircraftProjectInspectionInsForm4007Input;
}>;


export type UpdateAircraftProjectInspectionInsForm4007Mutation = { updateAircraftProjectInspectionInsForm4007: boolean };

export type UpdateAircraftProjectInspectionInsForm4023BMutationVariables = Exact<{
  input: UpdateAircraftProjectInspectionInsForm4023BInput;
}>;


export type UpdateAircraftProjectInspectionInsForm4023BMutation = { updateAircraftProjectInspectionInsForm4023B: boolean };

export type UpdateAircraftProjectInspectionInsForm4045MutationVariables = Exact<{
  input: UpdateAircraftProjectInspectionInsForm4045Input;
}>;


export type UpdateAircraftProjectInspectionInsForm4045Mutation = { updateAircraftProjectInspectionInsForm4045: boolean };

export type UpdateAircraftProjectInspectionInsForm16005AMutationVariables = Exact<{
  input: UpdateAircraftProjectInspectionInsForm16005AInput;
}>;


export type UpdateAircraftProjectInspectionInsForm16005AMutation = { updateAircraftProjectInspectionInsForm16005A: boolean };

export type UpdateAircraftProjectInspectionInspectionEstimateMutationVariables = Exact<{
  input: UpdateAircraftProjectInspectionInspectionEstimateInput;
}>;


export type UpdateAircraftProjectInspectionInspectionEstimateMutation = { updateAircraftProjectInspectionInspectionEstimate: boolean };

export type UpdateAircraftProjectInspectionInspectionInvoiceMutationVariables = Exact<{
  input: UpdateAircraftProjectInspectionInspectionInvoiceInput;
}>;


export type UpdateAircraftProjectInspectionInspectionInvoiceMutation = { updateAircraftProjectInspectionInspectionInvoice: boolean };

export type UpdateAircraftProjectInspectionInspectionTimeLogMutationVariables = Exact<{
  input: UpdateAircraftProjectInspectionInspectionTimeLogInput;
}>;


export type UpdateAircraftProjectInspectionInspectionTimeLogMutation = { updateAircraftProjectInspectionInspectionTimeLog: boolean };

export type AddAircraftProjectMutationMutationVariables = Exact<{
  addAircraftProjectInput: AddAircraftProjectInput;
}>;


export type AddAircraftProjectMutationMutation = { addAircraftProject: { id: number } };

export type AircraftInspectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AircraftInspectionsQuery = { inspectorInspections: { inspectorInspections: Array<InspectorAvailabilityEventFragment> } };

export type UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateAllAircraftProjectOperatorDocumentsReleasedToDcaInput;
}>;


export type UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutation = { updateAllAircraftProjectDocumentsReleasedToDca: boolean };

export type UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateAllProjectInsFormVersionsReleasedToDcaInput;
}>;


export type UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutation = { updateAllAircraftProjectInsFormsReleasedToDca: boolean };

export type AircraftProjectCertificatePreviewQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  certificateDocumentTypeId: Scalars['Int'];
}>;


export type AircraftProjectCertificatePreviewQuery = { downloadAircraftCertificatePreview?: Maybe<DownloadFileFragment> };

export type AircraftProjectFormsTabQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
}>;


export type AircraftProjectFormsTabQuery = { aircraftProject: { canToggleInsFormDcaApproved: boolean }, aircraftProjectInsForms: Array<ProjectInsFormVersionFragment>, aircraftProjectInsFormsExclusiveGroups: Array<ProjectInsFormVersionExclusiveGroupFragment> };

export type AircraftProjectInsFormFieldValuesAndCommentsQueryQueryVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type AircraftProjectInsFormFieldValuesAndCommentsQueryQuery = { fieldValues: Array<ProjectInsFormVersionFieldValueFragment>, fieldComments: Array<ProjectInsFormVersionFieldCommentFragment> };

export type AircraftProjectInsFormFieldValuesOnlyQueryQueryVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type AircraftProjectInsFormFieldValuesOnlyQueryQuery = { fieldValues: Array<ProjectInsFormVersionFieldValueFragment> };

export type DownloadAircraftProjectUploadedInsFormQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadAircraftProjectUploadedInsFormQuery = { file?: Maybe<DownloadFileFragment> };

export type DownloadAircraftProjectGeneratedInsFormDocumentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadAircraftProjectGeneratedInsFormDocumentQuery = { file?: Maybe<DownloadFileFragment> };

export type DownloadAircraftProjectFilledInInsFormQueryVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type DownloadAircraftProjectFilledInInsFormQuery = { file?: Maybe<DownloadFileFragment> };

export type UpdateAircraftProjectInsFormTrgApprovalMutationMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionTrgApprovalInput;
}>;


export type UpdateAircraftProjectInsFormTrgApprovalMutationMutation = { updateAircraftProjectInsFormTrgApproval: ProjectInsFormVersionFragment };

export type UpdateAircraftProjectInsFormFileAttachmentMutationMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionFileAttachmentInput;
}>;


export type UpdateAircraftProjectInsFormFileAttachmentMutationMutation = { updateAircraftProjectInsFormFileAttachment: ProjectInsFormVersionFragment };

export type UpdateAircraftProjectInsFormReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionReleasedToDcaInput;
}>;


export type UpdateAircraftProjectInsFormReleasedToDcaMutationMutation = { updateAircraftProjectInsFormReleasedToDca: ProjectInsFormVersionFragment };

export type UpdateAircraftProjectInsFormFieldValuesMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionFieldValuesInput;
}>;


export type UpdateAircraftProjectInsFormFieldValuesMutation = { updateAircraftProjectInsFormFieldValues: boolean };

export type UpdateAircraftProjectInsFormFieldCommentMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionFieldCommentInput;
}>;


export type UpdateAircraftProjectInsFormFieldCommentMutation = { updateAircraftProjectInsFormFieldComment: boolean };

export type UpdateAircraftProjectInsFormIsDcaApprovedMutationVariables = Exact<{
  input: UpdateProjectInsFormIsDcaApprovedInput;
}>;


export type UpdateAircraftProjectInsFormIsDcaApprovedMutation = { updateAircraftProjectInsFormIsDcaApproved: boolean };

export type SignAircraftProjectInsFormVersionByIdMutationVariables = Exact<{
  id: Scalars['Int'];
  input: SignProjectInsFormVersionInput;
}>;


export type SignAircraftProjectInsFormVersionByIdMutation = { signAircraftProjectInsFormVersionById: boolean };

export type SignAircraftProjectInsFormVersionByIdWithSignatureImageMutationVariables = Exact<{
  id: Scalars['Int'];
  input: SignProjectInsFormVersionInputWithSignatureImageInput;
}>;


export type SignAircraftProjectInsFormVersionByIdWithSignatureImageMutation = { signAircraftProjectInsFormVersionByIdWithSignatureImage: { warnings?: Maybe<Array<string>> } };

export type ClearAircraftProjectInsFormVersionSignatureByIdMutationVariables = Exact<{
  id: Scalars['Int'];
  fieldNumber: Scalars['Int'];
}>;


export type ClearAircraftProjectInsFormVersionSignatureByIdMutation = { clearAircraftProjectInsFormVersionSignatureById: boolean };

export type AddAircraftProjectInsFormVersionCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddAircraftProjectInsFormVersionCommentMutation = { addAircraftProjectInsFormVersionComment: CommentFragment };

export type UpdateAircraftProjectInsFormVersionCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateAircraftProjectInsFormVersionCommentMutation = { updateAircraftProjectInsFormVersionComment: CommentFragment };

export type AircraftProjectEmailHistoryQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  sortBy?: Maybe<EmailHistorySortBy>;
  sortDirection?: Maybe<SortDirection>;
}>;


export type AircraftProjectEmailHistoryQuery = { aircraftProjectEmailHistory: Array<EmailHistoryFragment> };

export type AircraftProjectHistoryQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
}>;


export type AircraftProjectHistoryQuery = { aircraftProjectHistory: Array<ProjectHistoryFragment> };

export type SendAircraftProjectEmailMutationVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  email: EmailInput;
}>;


export type SendAircraftProjectEmailMutation = { sendAircraftProjectEmail: { id: number } };

export type UpdateAircraftProjectCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateAircraftProjectCommentsLastViewedDateMutation = { updateAircraftProjectCommentsLastViewedDate: { id: number } };

export type UpdateAircraftProjectDcaCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateAircraftProjectDcaCommentsLastViewedDateMutation = { updateAircraftProjectDcaCommentsLastViewedDate: { id: number } };

export type AircraftProjectAssignableUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type AircraftProjectAssignableUsersQuery = { aircraftProjectAssignableUsers: Array<UserFragment> };

export type AircraftProjectEmailViewQueryVariables = Exact<{
  id: Scalars['Int'];
  emailId: Scalars['Int'];
  includeFileAttachments?: Maybe<Scalars['Boolean']>;
  includeFileContent?: Maybe<Scalars['Boolean']>;
}>;


export type AircraftProjectEmailViewQuery = { aircraftProject: { emails: Array<EmailFragment> } };

export type DownloadAircraftProjectEmailAttachmentContentQueryVariables = Exact<{
  aircraftProjectId: Scalars['Int'];
  emailId: Scalars['Int'];
  attachmentId: Scalars['Int'];
}>;


export type DownloadAircraftProjectEmailAttachmentContentQuery = { downloadAircraftProjectEmailAttachmentContent?: Maybe<string> };

export type AmoProjectAuditCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AmoProjectAuditCommentsQuery = { amoProjectAuditComments: CommentsFragment };

export type AddAmoProjectAuditCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddAmoProjectAuditCommentMutation = { addAmoProjectAuditComment: CommentFragment };

export type UpdateAmoProjectAuditCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateAmoProjectAuditCommentMutation = { updateAmoProjectAuditComment: CommentFragment };

export type UpdateAmoProjectAuditCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateAmoProjectAuditCommentsLastViewedDateMutation = { updateAmoProjectAuditCommentsLastViewedDate: { id: number } };

export type AmoProjectCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AmoProjectCommentsQuery = { amoProjectComments: CommentsFragment };

export type AddAmoProjectCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddAmoProjectCommentMutation = { addAmoProjectComment: CommentFragment };

export type UpdateAmoProjectCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateAmoProjectCommentMutation = { updateAmoProjectComment: CommentFragment };

export type UpdateAmoProjectCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateAmoProjectCommentsLastViewedDateMutation = { updateAmoProjectCommentsLastViewedDate: { id: number } };

export type AmoProjectDcaCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AmoProjectDcaCommentsQuery = { amoProjectDcaComments: CommentsFragment };

export type AddAmoProjectDcaCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddAmoProjectDcaCommentMutation = { addAmoProjectDcaComment: CommentFragment };

export type UpdateAmoProjectDcaCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateAmoProjectDcaCommentMutation = { updateAmoProjectDcaComment: CommentFragment };

export type UpdateAmoProjectDcaCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateAmoProjectDcaCommentsLastViewedDateMutation = { updateAmoProjectDcaCommentsLastViewedDate: { id: number } };

export type AmoProjectDocumentFragment = { id: number, isReleasedToDca: boolean, isArchived: boolean, document: DocumentForDocumentListsFragment };

export type AmoProjectDocumentsQueryQueryVariables = Exact<{
  amoProjectId: Scalars['Int'];
  documentTypeCategoryId: DocumentTypeCategoryEnum;
}>;


export type AmoProjectDocumentsQueryQuery = { documents: Array<AmoProjectDocumentFragment>, documentTypes: Array<DocumentTypeFragment> };

export type AddAmoProjectDocumentMutationMutationVariables = Exact<{
  addAmoProjectDocumentInput: AddAmoProjectDocumentInput;
}>;


export type AddAmoProjectDocumentMutationMutation = { addAmoProjectDocument: { id: number } };

export type UpdateAmoProjectDocumentMutationMutationVariables = Exact<{
  updateAmoProjectDocumentInput: UpdateAmoProjectDocumentInput;
}>;


export type UpdateAmoProjectDocumentMutationMutation = { updateAmoProjectDocument: { id: number } };

export type RemoveAmoProjectDocumentMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveAmoProjectDocumentMutationMutation = { removeAmoProjectDocument: boolean };

export type DownloadAmoProjectDocumentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadAmoProjectDocumentQuery = { file?: Maybe<DownloadFileFragment> };

export type UpdateAmoProjectDocumentReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateAmoProjectDocumentReleasedToDcaInput;
}>;


export type UpdateAmoProjectDocumentReleasedToDcaMutationMutation = { updateAmoProjectDocumentReleasedToDca: { id: number } };

export type AmoProjectGridItemFragment = { id: number, amoName: string, dcaCertificateNo?: Maybe<string>, dateOfFirstIssue?: Maybe<any>, dateOfExpiry?: Maybe<any>, projectCreationDate: any, amoProjectType: { id: number, abbreviation: string }, assocAircraftProject?: Maybe<{ aircraft: { registrationMark: string } }>, projectStatus: { name: string } };

export type AmoProjectGridQueryVariables = Exact<{
  sortBy?: Maybe<AmoProjectsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  projectStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  assigneeIdIn?: Maybe<Array<Scalars['Int']>>;
  aircraftRegistrationMarkContains?: Maybe<Scalars['String']>;
  dateOfFirstIssue?: Maybe<DateRangeFilterInput>;
  dateOfExpiry?: Maybe<DateRangeFilterInput>;
  createDate?: Maybe<DateRangeFilterInput>;
  keyword?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type AmoProjectGridQuery = { amoProjects: { amoProjects: Array<AmoProjectGridItemFragment> } | { totalItems: number, amoProjects: Array<AmoProjectGridItemFragment> } };

export type AddAmoProjectModalAmoQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AddAmoProjectModalAmoQuery = { amo: { id: number, dcaCertificateNo?: Maybe<string> } };

export type AddAmoProjectMutationMutationVariables = Exact<{
  addAmoProjectInput: AddAmoProjectInput;
}>;


export type AddAmoProjectMutationMutation = { addAmoProject: { id: number } };

export type AmoProjectPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AmoProjectPageQuery = { amoProject: { id: number, amoName: string, dcaCertificateNo?: Maybe<string>, localApprovalOpsSpecsNumber?: Maybe<string>, specialProject?: Maybe<string>, amoProjectType: { name: string }, projectStatus: { name: string }, projectStage: { name: string }, country?: Maybe<{ name: string }> } };

export type AmoProjectHeaderQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AmoProjectHeaderQuery = { amoProject: { id: number, amoName: string, projectCreationDate: any, isOnHold: boolean, isOnHoldByDca: boolean, dcaSubmissionDate?: Maybe<any>, amoProjectType: { name: string }, country?: Maybe<{ name: string }>, projectStatus: { id: number, name: string }, projectCreatedByUser: { firstName?: Maybe<string>, lastName?: Maybe<string> }, assignees: Array<{ id: number }> } };

export type TransitionAmoProjectMutationVariables = Exact<{
  input: TransitionProjectInput;
}>;


export type TransitionAmoProjectMutation = { transitionAmoProject: { id: number, warnings?: Maybe<Array<string>> } };

export type HoldAmoProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type HoldAmoProjectMutation = { holdAmoProject: { id: number } };

export type ReleaseAmoProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ReleaseAmoProjectMutation = { releaseAmoProject: { id: number } };

export type DcaHoldAmoProjectMutationVariables = Exact<{
  input: DcaHoldAmoProjectInput;
}>;


export type DcaHoldAmoProjectMutation = { dcaHoldAmoProject: { id: number } };

export type DcaReleaseAmoProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DcaReleaseAmoProjectMutation = { dcaReleaseAmoProject: { id: number } };

export type SendAmoProjectBackToIasoMutationVariables = Exact<{
  input: SendAmoProjectToIasoInput;
}>;


export type SendAmoProjectBackToIasoMutation = { sendAmoProjectBackToIaso: { id: number } };

export type DeleteAmoProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAmoProjectMutation = { deleteAmoProject: { id: number } };

export type AmoProjectApplicationTabQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AmoProjectApplicationTabQuery = { amoProject: { id: number, amoName: string, localApprovalOpsSpecsNumber?: Maybe<string>, localApprovalExpirationDate?: Maybe<any>, dcaCertificateNo?: Maybe<string>, issueDate?: Maybe<any>, dateOfExpiry?: Maybe<any>, dateOfFirstIssue?: Maybe<any>, authorizedLocations?: Maybe<string>, specialProject?: Maybe<string>, projectNumber?: Maybe<string>, amoProjectType: { id: number }, assocAircraftProject?: Maybe<{ id: number, aircraft: { registrationMark: string }, aircraftProjectType: { abbreviation: string } }>, country?: Maybe<{ id: number }> } };

export type UpdateAmoProjectApplicationMutationVariables = Exact<{
  updateAmoProjectInput: UpdateAmoProjectInput;
}>;


export type UpdateAmoProjectApplicationMutation = { updateAmoProject: { id: number } };

export type AmoAuditDetailForAllProjectsFragment = { id: number, otherStatusText?: Maybe<string>, isDeleted: boolean, inspectionStatus: { id: number }, letterOfFindingsFileAttachment?: Maybe<InspectionFileAttachmentFragment>, insForm4004FileAttachment?: Maybe<InspectionFileAttachmentFragment>, insForm4035FileAttachment?: Maybe<InspectionFileAttachmentFragment>, inspectorInspections: Array<InspectorInspectionDetailFragment> };

export type AmoProjectAuditInfoQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AmoProjectAuditInfoQuery = { amoProject: { id: number, amoName: string, dcaCertificateNo?: Maybe<string>, assocAircraftProject?: Maybe<{ id: number, registrationMark: string }>, assignees: Array<{ id: number }> } };

export type AmoProjectAuditsQueryVariables = Exact<{
  amoProjectId: Scalars['Int'];
}>;


export type AmoProjectAuditsQuery = { currentAudits: Array<{ id: number, inspection: AmoAuditDetailForAllProjectsFragment }>, priorAudits: Array<{ id: number, inspection: AmoAuditDetailForAllProjectsFragment }> };

export type UpdateAmoProjectAuditsMutationMutationVariables = Exact<{
  input: UpdateAmoProjectAuditsInput;
}>;


export type UpdateAmoProjectAuditsMutationMutation = { updateAmoProjectAudits: boolean };

export type DownloadAmoProjectAuditLetterOfFindingsQueryVariables = Exact<{
  amoProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
}>;


export type DownloadAmoProjectAuditLetterOfFindingsQuery = { downloadAmoProjectAuditLetterOfFindings?: Maybe<string> };

export type DownloadAmoProjectAuditInsForm4004QueryVariables = Exact<{
  amoProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
}>;


export type DownloadAmoProjectAuditInsForm4004Query = { downloadAmoProjectAuditInsForm4004?: Maybe<string> };

export type DownloadAmoProjectAuditInsForm4035QueryVariables = Exact<{
  amoProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
}>;


export type DownloadAmoProjectAuditInsForm4035Query = { downloadAmoProjectAuditInsForm4035?: Maybe<string> };

export type DownloadAmoProjectAuditInspectorInspectionEstimateQueryVariables = Exact<{
  amoProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
  inspectorInspectionId: Scalars['Int'];
}>;


export type DownloadAmoProjectAuditInspectorInspectionEstimateQuery = { downloadAmoProjectAuditInspectorInspectionEstimate?: Maybe<string> };

export type DownloadAmoProjectAuditInspectorInspectionInvoiceQueryVariables = Exact<{
  amoProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
  inspectorInspectionId: Scalars['Int'];
}>;


export type DownloadAmoProjectAuditInspectorInspectionInvoiceQuery = { downloadAmoProjectAuditInspectorInspectionInvoice?: Maybe<string> };

export type DownloadAmoProjectAuditInspectorInspectionTimeLogQueryVariables = Exact<{
  amoProjectId: Scalars['Int'];
  inspectionId: Scalars['Int'];
  inspectorInspectionId: Scalars['Int'];
}>;


export type DownloadAmoProjectAuditInspectorInspectionTimeLogQuery = { downloadAmoProjectAuditInspectorInspectionTimeLog?: Maybe<string> };

export type UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateAllAmoProjectDocumentsReleasedToDcaInput;
}>;


export type UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutation = { updateAllAmoProjectDocumentsReleasedToDca: boolean };

export type AmoProjectFormsTabQueryVariables = Exact<{
  amoProjectId: Scalars['Int'];
}>;


export type AmoProjectFormsTabQuery = { amoProject: { assignees: Array<{ id: number }>, projectStatus: { id: number } }, amoProjectInsForms: Array<ProjectInsFormVersionFragment> };

export type AmoProjectInsFormFieldValuesAndCommentsQueryQueryVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type AmoProjectInsFormFieldValuesAndCommentsQueryQuery = { fieldValues: Array<ProjectInsFormVersionFieldValueFragment>, fieldComments: Array<ProjectInsFormVersionFieldCommentFragment> };

export type AmoProjectInsFormFieldValuesOnlyQueryQueryVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type AmoProjectInsFormFieldValuesOnlyQueryQuery = { fieldValues: Array<ProjectInsFormVersionFieldValueFragment> };

export type DownloadAmoProjectUploadedInsFormQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadAmoProjectUploadedInsFormQuery = { file?: Maybe<DownloadFileFragment> };

export type DownloadAmoProjectFilledInInsFormQueryVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type DownloadAmoProjectFilledInInsFormQuery = { file?: Maybe<DownloadFileFragment> };

export type UpdateAmoProjectInsFormTrgApprovalMutationMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionTrgApprovalInput;
}>;


export type UpdateAmoProjectInsFormTrgApprovalMutationMutation = { updateAmoProjectInsFormTrgApproval: ProjectInsFormVersionFragment };

export type UpdateAmoProjectInsFormFileAttachmentMutationMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionFileAttachmentInput;
}>;


export type UpdateAmoProjectInsFormFileAttachmentMutationMutation = { updateAmoProjectInsFormFileAttachment: ProjectInsFormVersionFragment };

export type UpdateAmoProjectInsFormReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionReleasedToDcaInput;
}>;


export type UpdateAmoProjectInsFormReleasedToDcaMutationMutation = { updateAmoProjectInsFormReleasedToDca: ProjectInsFormVersionFragment };

export type UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateAllProjectInsFormVersionsReleasedToDcaInput;
}>;


export type UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutation = { updateAllAmoProjectInsFormsReleasedToDca: boolean };

export type UpdateAmoProjectInsFormFieldValuesMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionFieldValuesInput;
}>;


export type UpdateAmoProjectInsFormFieldValuesMutation = { updateAmoProjectInsFormFieldValues: boolean };

export type UpdateAmoProjectInsFormFieldCommentMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionFieldCommentInput;
}>;


export type UpdateAmoProjectInsFormFieldCommentMutation = { updateAmoProjectInsFormFieldComment: boolean };

export type UpdateAmoProjectInsFormIsDcaApprovedMutationVariables = Exact<{
  input: UpdateProjectInsFormIsDcaApprovedInput;
}>;


export type UpdateAmoProjectInsFormIsDcaApprovedMutation = { updateAmoProjectInsFormIsDcaApproved: boolean };

export type SignAmoProjectInsFormVersionByIdMutationVariables = Exact<{
  id: Scalars['Int'];
  input: SignProjectInsFormVersionInput;
}>;


export type SignAmoProjectInsFormVersionByIdMutation = { signAmoProjectInsFormVersionById: boolean };

export type SignAmoProjectInsFormVersionByIdWithSignatureImageMutationVariables = Exact<{
  id: Scalars['Int'];
  input: SignProjectInsFormVersionInputWithSignatureImageInput;
}>;


export type SignAmoProjectInsFormVersionByIdWithSignatureImageMutation = { signAmoProjectInsFormVersionByIdWithSignatureImage: { warnings?: Maybe<Array<string>> } };

export type ClearAmoProjectInsFormVersionSignatureByIdMutationVariables = Exact<{
  id: Scalars['Int'];
  fieldNumber: Scalars['Int'];
}>;


export type ClearAmoProjectInsFormVersionSignatureByIdMutation = { clearAmoProjectInsFormVersionSignatureById: boolean };

export type AddAmoProjectInsFormVersionCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddAmoProjectInsFormVersionCommentMutation = { addAmoProjectInsFormVersionComment: CommentFragment };

export type UpdateAmoProjectInsFormVersionCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateAmoProjectInsFormVersionCommentMutation = { updateAmoProjectInsFormVersionComment: CommentFragment };

export type AmoProjectSummaryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AmoProjectSummaryQuery = { amoProject: { id: number, amoName: string, isHighPriority: boolean, isNoDcaInvoiceRequired: boolean, officialLetterNotes?: Maybe<string>, projectCreationDate: any, amoProjectType: { id: number, name: string }, projectStatus: { id: number, name: string }, projectCreatedByUser: { id: number, firstName?: Maybe<string>, lastName?: Maybe<string> }, assignees: Array<UserFragment> } };

export type AmoProjectDocumentTypeOfficialLetterNotesQueryVariables = Exact<{
  amoProjectId: Scalars['Int'];
}>;


export type AmoProjectDocumentTypeOfficialLetterNotesQuery = { amoProjectDocumentTypeOfficialLetterNotes: Array<{ officialLetterNote?: Maybe<string>, documentType: { id: number, name: string } }> };

export type UpdateAmoProjectPriorityMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateAmoProjectPriorityMutation = { updateAmoProjectPriority: { id: number, isHighPriority: boolean } };

export type UpdateAmoProjectNoDcaInvoiceRequiredMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateAmoProjectNoDcaInvoiceRequiredMutation = { updateAmoProjectNoDcaInvoiceRequired: { id: number, isNoDcaInvoiceRequired: boolean } };

export type UpdateAmoProjectOfficialLetterNotesMutationVariables = Exact<{
  input: UpdateAmoProjectOfficialLetterNotesInput;
}>;


export type UpdateAmoProjectOfficialLetterNotesMutation = { updateAmoProjectOfficialLetterNotes: { id: number } };

export type SetAmoProjectAssigneesMutationVariables = Exact<{
  amoProjectId: Scalars['Int'];
  assigneeUserIds: Array<Scalars['Int']>;
}>;


export type SetAmoProjectAssigneesMutation = { setAmoProjectAssignees: { id: number } };

export type AmoProjectAssignableUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type AmoProjectAssignableUsersQuery = { amoProjectAssignableUsers: Array<UserFragment> };

export type AmoProjectHistoryQueryVariables = Exact<{
  amoProjectId: Scalars['Int'];
}>;


export type AmoProjectHistoryQuery = { amoProjectHistory: Array<ProjectHistoryFragment> };

export type AmoProjectEmailHistoryQueryVariables = Exact<{
  amoProjectId: Scalars['Int'];
  sortBy?: Maybe<EmailHistorySortBy>;
  sortDirection?: Maybe<SortDirection>;
}>;


export type AmoProjectEmailHistoryQuery = { amoProjectEmailHistory: Array<EmailHistoryFragment> };

export type AmoProjectEmailViewQueryVariables = Exact<{
  id: Scalars['Int'];
  emailId: Scalars['Int'];
  includeFileAttachments?: Maybe<Scalars['Boolean']>;
  includeFileContent?: Maybe<Scalars['Boolean']>;
}>;


export type AmoProjectEmailViewQuery = { amoProject: { emails: Array<EmailFragment> } };

export type DownloadAmoProjectEmailAttachmentContentQueryVariables = Exact<{
  amoProjectId: Scalars['Int'];
  emailId: Scalars['Int'];
  attachmentId: Scalars['Int'];
}>;


export type DownloadAmoProjectEmailAttachmentContentQuery = { downloadAmoProjectEmailAttachmentContent?: Maybe<string> };

export type SendAmoProjectEmailMutationVariables = Exact<{
  amoProjectId: Scalars['Int'];
  email: EmailInput;
}>;


export type SendAmoProjectEmailMutation = { sendAmoProjectEmail: { id: number } };

export type ArgDashboardAircraftReportItemFragment = { id: number, registrationMark: string, certificateOfAirworthinessExpirationDate?: Maybe<any>, certificateOfRegistrationExpirationDate?: Maybe<any>, certificateOfInsuranceExpirationDate?: Maybe<any>, leaseAgreementExpirationDate?: Maybe<any>, managementAgreementExpirationDate?: Maybe<any>, aircraftStatus: { id: number, name: string }, operator?: Maybe<{ company: { name: string } }> };

export type ArgDashboardAircraftReportQueryVariables = Exact<{
  hasCertificateOfAirworthinessExpirationDate?: Maybe<Scalars['Boolean']>;
  hasCertificateOfRegistrationExpirationDate?: Maybe<Scalars['Boolean']>;
  hascertificateOfInsuranceExpirationDate?: Maybe<Scalars['Boolean']>;
  hasLeaseAgreementExpirationDate?: Maybe<Scalars['Boolean']>;
  hasManagementAgreementExpirationDate?: Maybe<Scalars['Boolean']>;
  aircraftStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<AircraftsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type ArgDashboardAircraftReportQuery = { aircrafts: { aircrafts: Array<ArgDashboardAircraftReportItemFragment> } | { totalItems: number, aircrafts: Array<ArgDashboardAircraftReportItemFragment> } };

export type ArgDashboardCrewMembersReportItemFragment = { id: number, firstName: string, lastName: string, validationNumber?: Maybe<string>, licenseNumber: string, certificateExpiryDate?: Maybe<any>, crewPosition: { name: string }, crewLicenseType: { name: string }, country: { name: string }, aircrafts: Array<{ registrationMark: string, aircraftStatus: { id: number } }>, operators: Array<{ isActive: boolean, company: { name: string } }>, activeCrewProjects: Array<{ id: number }> };

export type ArgDashboardCrewMembersReportQueryVariables = Exact<{
  hasCertificationExpiryDate?: Maybe<Scalars['Boolean']>;
  sortBy?: Maybe<CrewMembersSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type ArgDashboardCrewMembersReportQuery = { crewMembers: { crewMembers: Array<ArgDashboardCrewMembersReportItemFragment> } | { totalItems: number, crewMembers: Array<ArgDashboardCrewMembersReportItemFragment> } };

export type ArgDashboardInspectorsReportItemFragment = { id: number, inspectorTypeId: number, inspectorCategoryId: number, inspectorCategoryTypeId?: Maybe<number>, appointmentLetterExpirationDate?: Maybe<any>, user?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string> }> };

export type ArgDashboardInspectorsReportQueryVariables = Exact<{
  hasAppointmentLetterExpirationDate?: Maybe<Scalars['Boolean']>;
  sortBy?: Maybe<InspectorsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type ArgDashboardInspectorsReportQuery = { inspectors: { inspectors: Array<ArgDashboardInspectorsReportItemFragment> } | { totalItems: number, inspectors: Array<ArgDashboardInspectorsReportItemFragment> } };

export type ArgDashboardMechanicsReportItemFragment = { id: number, firstName: string, lastName: string, validationNumber?: Maybe<string>, licenseNumber: string, certificateExpiryDate?: Maybe<any>, mechanicPosition: { name: string }, mechanicLicenseType: { name: string }, country: { name: string }, aircrafts: Array<{ registrationMark: string, aircraftStatus: { id: number } }>, operators: Array<{ company: { name: string } }>, activeMechanicProjects: Array<{ id: number }> };

export type ArgDashboardMechanicsReportQueryVariables = Exact<{
  hasCertificationExpiryDate?: Maybe<Scalars['Boolean']>;
  sortBy?: Maybe<MechanicsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type ArgDashboardMechanicsReportQuery = { mechanics: { mechanics: Array<ArgDashboardMechanicsReportItemFragment> } | { totalItems: number, mechanics: Array<ArgDashboardMechanicsReportItemFragment> } };

export type ReminderFragment = { id: number, reminderDate: any, reminderText: string, createDate: any, isSent: boolean, sendErrorMessage?: Maybe<string>, reminderApplicability: { id: number, name: string }, createdByUser: { displayName: string }, otherUsers: Array<{ id: number, displayName: string }> };

export type RemindersQueryVariables = Exact<{
  reminderApplicabilityIdIn?: Maybe<Array<Scalars['Int']>>;
  reminderDate?: Maybe<DateRangeFilterInput>;
  createdByUserIdIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<RemindersSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
}>;


export type RemindersQuery = { reminders: Array<ReminderFragment> };

export type AddReminderMutationVariables = Exact<{
  input: ReminderInput;
}>;


export type AddReminderMutation = { addReminder: ReminderFragment };

export type UpdateReminderMutationVariables = Exact<{
  id: Scalars['Int'];
  input: ReminderInput;
}>;


export type UpdateReminderMutation = { updateReminder: ReminderFragment };

export type DeleteReminderMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteReminderMutation = { deleteReminder: ReminderFragment };

export type DownloadCrewCertificateQueryVariables = Exact<{
  identifier: Scalars['String'];
}>;


export type DownloadCrewCertificateQuery = { downloadCrewCertificate?: Maybe<DownloadFileFragment> };

export type CrewCertificateValidationInfoV1Fragment = { crewCertificateType: string, validationRestrictedTo?: Maybe<string>, validationNumber: string, firstName: string, lastName: string, basisOf: string, dcaCrewRatingsList?: Maybe<string>, certificateExpiryDate?: Maybe<any>, certificateExpiryDate2?: Maybe<any>, certificateDateOfIssue?: Maybe<any>, licenseNumber: string, isLegacyCertificate?: Maybe<boolean>, documentValidityId: number, documentValidityName: string };

export type ValidateLegacyCrewCertificateOfValidationQrCodeQueryVariables = Exact<{
  identifier: Scalars['String'];
}>;


export type ValidateLegacyCrewCertificateOfValidationQrCodeQuery = { validateLegacyCrewCertificateOfValidationQrCode?: Maybe<CrewCertificateValidationInfoV1Fragment> };

export type ValidateCrewCertificateOfValidationQrCodeV1QueryVariables = Exact<{
  qrCodeUrlSearchParams: Scalars['String'];
}>;


export type ValidateCrewCertificateOfValidationQrCodeV1Query = { validateCrewCertificateOfValidationQrCodeV1: { isQrCodeValid: boolean, validationInfo?: Maybe<CrewCertificateValidationInfoV1Fragment> } };

export type CrewCertificateValidationInfoV2Fragment = { documentValidityId: number, documentValidityName: string };

export type ValidateCrewCertificateOfValidationQrCodeV2QueryVariables = Exact<{
  qrCodeUrlSearchParams: Scalars['String'];
}>;


export type ValidateCrewCertificateOfValidationQrCodeV2Query = { validateCrewCertificateOfValidationQrCodeV2: { isQrCodeValid: boolean, validationInfo?: Maybe<CrewCertificateValidationInfoV2Fragment> } };

export type DownloadMechanicCertificateQueryVariables = Exact<{
  identifier: Scalars['String'];
}>;


export type DownloadMechanicCertificateQuery = { downloadMechanicCertificate?: Maybe<DownloadFileFragment> };

export type MechanicCertificateValidationInfoV1Fragment = { documentValidityId: number, documentValidityName: string };

export type ValidateMechanicCertificateOfValidationQrCodeV1QueryVariables = Exact<{
  qrCodeUrlSearchParams: Scalars['String'];
}>;


export type ValidateMechanicCertificateOfValidationQrCodeV1Query = { validateMechanicCertificateOfValidationQrCodeV1: { isQrCodeValid: boolean, validationInfo?: Maybe<MechanicCertificateValidationInfoV1Fragment> } };

export type CrewMemberDocumentFragment = { id: number, isArchived: boolean, document: DocumentForDocumentListsFragment };

export type CrewMemberGridItemFragment = { id: number, firstName: string, lastName: string, validationNumber?: Maybe<string>, certificateDateOfFirstIssue?: Maybe<any>, certificateExpiryDate?: Maybe<any>, totalNewComments: number, hasActiveProjects: boolean, numberOfNonInactiveAircraft: number, crewPosition: { name: string }, crewLicenseType: { name: string }, country: { name: string }, crewRatings: Array<{ name: string }>, operators: Array<{ id: number, isActive: boolean, company: { name: string } }>, employmentCompanies: Array<{ id: number, name: string }>, aircrafts: Array<{ id: number, registrationMark: string, aircraftStatus: { id: number } }>, crewMemberStatus: { id: number, name: string } };

export type CrewMemberCountryFragment = { id: number, name: string, isDeleted: boolean };

export type CrewMemberOperatorFragment = { id: number, isActive: boolean, isDeleted: boolean, company: { name: string, isActive: boolean } };

export type CrewMemberGridFilterLookupsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CrewMemberGridFilterLookupsQueryQuery = { countries: Array<CrewMemberCountryFragment>, crewRatings: Array<CrewRatingFragment>, operators: { operators: Array<CrewMemberOperatorFragment> } };

export type CrewMemberGridQueryVariables = Exact<{
  sortBy?: Maybe<CrewMembersSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  lastNameContains?: Maybe<Scalars['String']>;
  crewMemberStatusId?: Maybe<Scalars['Int']>;
  licenseCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  crewRatingIdIn?: Maybe<Array<Scalars['Int']>>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  aircraftIdIn?: Maybe<Array<Scalars['Int']>>;
  keyword?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type CrewMemberGridQuery = { crewMembers: { crewMembers: Array<CrewMemberGridItemFragment> } | { totalItems: number, crewMembers: Array<CrewMemberGridItemFragment> } };

export type CrewMemberEmploymentCompanyFragment = { id: number, name: string, isDeleted: boolean };

export type CrewMemberGenericLvCompanyFragment = { id: number, name: string, isDeleted: boolean };

export type CrewMemberAircraftFragment = { id: number, registrationMark: string, aircraftStatus: { id: number } };

export type CrewMemberPageQueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CrewMemberPageQueryQuery = { crewMember: { id: number, firstName: string, lastName: string, licenseNumber: string, elpExpiryDate?: Maybe<any>, validationNumber?: Maybe<string>, certificateDateOfFirstIssue?: Maybe<any>, certificateIssuedDate?: Maybe<any>, certificateExpiryDate?: Maybe<any>, hasActiveProjects: boolean, crewMemberStatus: { id: number }, crewPosition: { id: number }, country: { id: number }, crewLicenseType: { id: number }, elpLevel?: Maybe<{ id: number }>, operators: Array<CrewMemberOperatorFragment>, employmentCompanies: Array<CrewMemberEmploymentCompanyFragment>, crewRatings: Array<CrewRatingFragment>, aircrafts: Array<CrewMemberAircraftFragment>, genericLvCompanies: Array<CrewMemberGenericLvCompanyFragment>, aircraftModels: Array<AircraftModelFragment> }, employmentCompanies: Array<CrewMemberEmploymentCompanyFragment>, operators: { operators: Array<CrewMemberOperatorFragment> }, aircrafts: { aircrafts: Array<CrewMemberAircraftFragment> } };

export type CrewMemberPageDateOfFirstIssueQueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CrewMemberPageDateOfFirstIssueQueryQuery = { crewMember: { certificateDateOfFirstIssue?: Maybe<any>, crewMemberStatus: { id: number } } };

export type UpdateCrewMemberMutationMutationVariables = Exact<{
  updateCrewMemberInput: UpdateCrewMemberInput;
}>;


export type UpdateCrewMemberMutationMutation = { updateCrewMember: { id: number } };

export type CrewMemberCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CrewMemberCommentsQuery = { crewMemberComments: CommentsFragment };

export type AddCrewMemberCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddCrewMemberCommentMutation = { addCrewMemberComment: CommentFragment };

export type UpdateCrewMemberCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateCrewMemberCommentMutation = { updateCrewMemberComment: CommentFragment };

export type UpdateCrewMemberCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateCrewMemberCommentsLastViewedDateMutation = { updateCrewMemberCommentsLastViewedDate: { id: number } };

export type CrewMemberDocumentsQueryQueryVariables = Exact<{
  crewMemberId: Scalars['Int'];
  documentTypeCategoryId: DocumentTypeCategoryEnum;
}>;


export type CrewMemberDocumentsQueryQuery = { crewMember: { certificateDateOfFirstIssue?: Maybe<any> }, documents: Array<CrewMemberDocumentFragment>, documentTypes: Array<DocumentTypeFragment> };

export type AddCrewMemberDocumentMutationMutationVariables = Exact<{
  addCrewMemberDocumentInput: AddCrewMemberDocumentInput;
}>;


export type AddCrewMemberDocumentMutationMutation = { addCrewMemberDocument: { id: number } };

export type UpdateCrewMemberDocumentMutationMutationVariables = Exact<{
  updateCrewMemberDocumentInput: UpdateCrewMemberDocumentInput;
}>;


export type UpdateCrewMemberDocumentMutationMutation = { updateCrewMemberDocument: { id: number } };

export type RemoveCrewMemberDocumentMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveCrewMemberDocumentMutationMutation = { removeCrewMemberDocument: boolean };

export type DownloadCrewMemberDocumentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadCrewMemberDocumentQuery = { file?: Maybe<DownloadFileFragment> };

export type AddCrewMemberMutationMutationVariables = Exact<{
  addCrewMemberInput: AddCrewMemberInput;
}>;


export type AddCrewMemberMutationMutation = { addCrewMember: { id: number } };

export type BulkUpdateCrewMemberStatusMutationVariables = Exact<{
  crewMemberIds: Array<Scalars['Int']>;
  crewMemberStatusId: Scalars['Int'];
}>;


export type BulkUpdateCrewMemberStatusMutation = { bulkUpdateCrewMemberStatus: { updatedCount: number, skippedCrewMemberNames: Array<string> } };

export type CrewProjectDocumentFragment = { id: number, isReleasedToDca: boolean, isArchived: boolean, document: DocumentForDocumentListsFragment };

export type CrewProjectDocumentsQueryQueryVariables = Exact<{
  crewProjectId: Scalars['Int'];
  documentTypeCategoryId: DocumentTypeCategoryEnum;
}>;


export type CrewProjectDocumentsQueryQuery = { crewProject: { certificateExpiryDate?: Maybe<any>, crewMember: { certificateDateOfFirstIssue?: Maybe<any> } }, documents: Array<CrewProjectDocumentFragment>, documentTypes: Array<DocumentTypeFragment> };

export type AddCrewProjectDocumentMutationMutationVariables = Exact<{
  addCrewProjectDocumentInput: AddCrewProjectDocumentInput;
}>;


export type AddCrewProjectDocumentMutationMutation = { addCrewProjectDocument: { id: number } };

export type UpdateCrewProjectDocumentMutationMutationVariables = Exact<{
  updateCrewProjectDocumentInput: UpdateCrewProjectDocumentInput;
}>;


export type UpdateCrewProjectDocumentMutationMutation = { updateCrewProjectDocument: { id: number } };

export type RemoveCrewProjectDocumentMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveCrewProjectDocumentMutationMutation = { removeCrewProjectDocument: boolean };

export type DownloadCrewProjectDocumentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadCrewProjectDocumentQuery = { file?: Maybe<DownloadFileFragment> };

export type RequestCrewProjectDocumentDownloadTokenMutationMutationVariables = Exact<{
  id: Scalars['Int'];
  downloadFileName?: Maybe<Scalars['String']>;
}>;


export type RequestCrewProjectDocumentDownloadTokenMutationMutation = { requestCrewProjectDocumentDownloadToken: string };

export type UpdateCrewProjectDocumentReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateCrewProjectDocumentReleasedToDcaInput;
}>;


export type UpdateCrewProjectDocumentReleasedToDcaMutationMutation = { updateCrewProjectDocumentReleasedToDca: { id: number } };

export type CrewProjectGridItemFragment = { id: number, lastName: string, firstName: string, certificateFirstIssuedDate?: Maybe<any>, validationNumber?: Maybe<string>, certificateDateOfIssue?: Maybe<any>, certificateExpiryDate?: Maybe<any>, isHighImportance: boolean, isOnHold: boolean, isOnHoldByDca: boolean, provisionalOperatorNames?: Maybe<string>, provisionalAircraftRegistrationMarks?: Maybe<string>, elpExpiryDate?: Maybe<any>, projectCreationDate: any, clientSubmissionDate?: Maybe<any>, dcaSubmissionDate?: Maybe<any>, totalNewComments: number, totalNewDcaComments: number, turnaroundDays?: Maybe<number>, archivedDate?: Maybe<any>, crewProjectType: { id: number, abbreviation: string }, crewProjectSpecialProjectType?: Maybe<{ id: number, abbreviation: string }>, crewProjectRenewalTypes: Array<{ abbreviation: string }>, crewPosition: { name: string }, projectStatus: { name: string }, projectStage: { name: string }, crewLicenseType: { name: string }, operators: Array<{ company: { name: string } }>, employmentCompanies: Array<{ id: number, name: string }>, crewProjectCategory?: Maybe<{ name: string }>, genericLvCompanies: Array<{ name: string }>, aircraftModels: Array<{ name: string }>, elpLevel?: Maybe<{ name: string }>, assignees: Array<{ firstName?: Maybe<string>, lastName?: Maybe<string>, userName?: Maybe<string> }>, aircrafts: Array<{ registrationMark: string, aircraftStatus: { id: number } }>, associatedAircraftProject?: Maybe<{ id: number, aircraft: { id: number, registrationMark: string }, aircraftProjectType: { id: number, abbreviation: string } }> };

export type CrewProjectGridQueryVariables = Exact<{
  sortBy?: Maybe<CrewProjectsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  crewMemberId?: Maybe<Scalars['Int']>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  associatedAircraftProjectIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type CrewProjectGridQuery = { crewProjects: { crewProjects: Array<CrewProjectGridItemFragment> } | { totalItems: number, crewProjects: Array<CrewProjectGridItemFragment> } };

export type CrewProjectCertificatePreviewQueryVariables = Exact<{
  crewProjectId: Scalars['Int'];
}>;


export type CrewProjectCertificatePreviewQuery = { downloadCrewCertificatePreview?: Maybe<DownloadFileFragment> };

export type DownloadCrewProjectOfficialLetterPreviewQueryVariables = Exact<{
  crewProjectId: Scalars['Int'];
}>;


export type DownloadCrewProjectOfficialLetterPreviewQuery = { downloadCrewProjectOfficialLetterPreview?: Maybe<DownloadFileFragment> };

export type AddCrewProjectModalCrewMemberQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AddCrewProjectModalCrewMemberQuery = { crewMember: { id: number, crewPosition: { id: number } } };

export type AddCrewProjectMutationMutationVariables = Exact<{
  addCrewProjectInput: AddCrewProjectInput;
}>;


export type AddCrewProjectMutationMutation = { addCrewProject: { id: number } };

export type CrewProjectCrewLicenseTypeFragment = { id: number, name: string, isDeleted: boolean };

export type CrewProjectCrewPositionFragment = { id: number, name: string, isDeleted: boolean, crewLicenseTypes: Array<CrewProjectCrewLicenseTypeFragment> };

export type CrewProjectCountryFragment = { id: number, name: string, isDeleted: boolean };

export type CrewProjectHeaderQueryVariables = Exact<{
  crewProjectId: Scalars['Int'];
}>;


export type CrewProjectHeaderQuery = { crewProject: CrewProjectHeaderFragment };

export type CrewProjectHeaderFragment = { id: number, firstName: string, lastName: string, provisionalOperatorNames?: Maybe<string>, projectCreationDate: any, isOnHold: boolean, isOnHoldByDca: boolean, dcaHoldReason?: Maybe<string>, isDcaInvoiced: boolean, isArgInvoiced: boolean, dcaSubmissionDate?: Maybe<any>, crewMember: { id: number }, crewProjectType: { name: string }, crewProjectSpecialProjectType?: Maybe<{ id: number, name: string }>, operators: Array<{ company: { name: string } }>, projectStatus: { id: number, name: string }, projectStage: { id: number, name: string }, projectCreatedByUser: { firstName?: Maybe<string>, lastName?: Maybe<string> }, assignees: Array<{ id: number }> };

export type CrewProjectCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CrewProjectCommentsQuery = { crewProjectComments: CommentsFragment };

export type CrewProjectSendToDcaCheckQueryVariables = Exact<{
  crewProjectId: Scalars['Int'];
}>;


export type CrewProjectSendToDcaCheckQuery = { crewProjectInsForms: Array<SendToDcaCheckFragment> };

export type CrewProjectReopenByDcaOpenProjectsCheckQueryVariables = Exact<{
  crewMemberId: Scalars['Int'];
  projectStatusIdNotIn: Array<Scalars['Int']>;
}>;


export type CrewProjectReopenByDcaOpenProjectsCheckQuery = { crewProjects: { crewProjects: Array<{ id: number }> } };

export type AddCrewProjectCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddCrewProjectCommentMutation = { addCrewProjectComment: CommentFragment };

export type UpdateCrewProjectCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateCrewProjectCommentMutation = { updateCrewProjectComment: CommentFragment };

export type CrewProjectDcaCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CrewProjectDcaCommentsQuery = { crewProjectDcaComments: CommentsFragment };

export type AddCrewProjectDcaCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddCrewProjectDcaCommentMutation = { addCrewProjectDcaComment: CommentFragment };

export type UpdateCrewProjectDcaCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateCrewProjectDcaCommentMutation = { updateCrewProjectDcaComment: CommentFragment };

export type HoldCrewProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type HoldCrewProjectMutation = { holdCrewProject: { id: number } };

export type ReleaseCrewProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ReleaseCrewProjectMutation = { releaseCrewProject: { id: number } };

export type DcaHoldCrewProjectMutationVariables = Exact<{
  input: DcaHoldCrewProjectInput;
}>;


export type DcaHoldCrewProjectMutation = { dcaHoldCrewProject: { id: number } };

export type DcaReleaseCrewProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DcaReleaseCrewProjectMutation = { dcaReleaseCrewProject: { id: number } };

export type DeleteCrewProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCrewProjectMutation = { deleteCrewProject: { id: number } };

export type TransitionCrewProjectMutationVariables = Exact<{
  input: TransitionProjectInput;
}>;


export type TransitionCrewProjectMutation = { transitionCrewProject: { id: number, projectStatus: { id: number } } };

export type SendCrewProjectBackToIasoMutationVariables = Exact<{
  input: SendCrewProjectToIasoInput;
}>;


export type SendCrewProjectBackToIasoMutation = { sendCrewProjectBackToIaso: { id: number } };

export type CompleteCrewProjectTaskMutationVariables = Exact<{
  input: CompleteCrewProjectTaskInput;
}>;


export type CompleteCrewProjectTaskMutation = { completeCrewProjectTask: { id: number } };

export type SendCrewProjectInsFormVersionForExecutionMutationVariables = Exact<{
  input: SendForExecutionInput;
}>;


export type SendCrewProjectInsFormVersionForExecutionMutation = { sendCrewProjectInsFormVersionForExecution: { id: number } };

export type ResendCrewProjectInsFormVersionForExecutionMutationVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type ResendCrewProjectInsFormVersionForExecutionMutation = { resendCrewProjectInsFormVersionForExecution: { id: number } };

export type RevokeCrewProjectInsFormVersionExecutionMutationVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type RevokeCrewProjectInsFormVersionExecutionMutation = { revokeCrewProjectInsFormVersionExecution: { id: number } };

export type UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateAllCrewProjectDocumentsReleasedToDcaInput;
}>;


export type UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutation = { updateAllCrewProjectDocumentsReleasedToDca: boolean };

export type CrewProjectCertificateInformationFragment = { id: number, firstName: string, lastName: string, certificateFirstIssuedDate?: Maybe<any>, validationNumber?: Maybe<string>, validationRestrictedTo?: Maybe<string>, certificateDateOfIssue?: Maybe<any>, certificateExpiryDate?: Maybe<any>, certificateDateOfIssue2?: Maybe<any>, certificateExpiryDate2?: Maybe<any>, licenseNumber: string, dcaCrewRatingsList?: Maybe<string>, elpExpiryDate?: Maybe<any>, dcaAircraftList?: Maybe<string>, dcaAircraftModelsList?: Maybe<string>, dcaGenericLvCompaniesList?: Maybe<string>, dcaSubmissionDate?: Maybe<any>, dcaRemarksC?: Maybe<string>, dcaRemarksD?: Maybe<string>, turnaroundDays?: Maybe<number>, dcaLastUpdatedDate?: Maybe<any>, projectStatusId: number, dcaProjectNumber?: Maybe<string>, certificateType: { id: number, description?: Maybe<string> }, country: { id: number, name: string }, crewProjectType: { id: number, abbreviation: string, name: string }, crewProjectSpecialProjectType?: Maybe<{ id: number, abbreviation: string, name: string }>, crewPosition: { id: number, name: string }, crewProjectRenewalTypes: Array<{ abbreviation: string, name: string }>, crewLicenseType: { id: number, description?: Maybe<string> }, elpLevel?: Maybe<{ id: number, name: string }>, crewProjectCategory?: Maybe<{ id: number, name: string }>, assignees: Array<UserFragment>, dcaAssignee?: Maybe<UserFragment>, preparedBy?: Maybe<UserFragment> };

export type CrewProjectCertificateInformationQueryVariables = Exact<{
  crewProjectId: Scalars['Int'];
}>;


export type CrewProjectCertificateInformationQuery = { crewProjectCertificate: CrewProjectCertificateInformationFragment, crewProject: { provisionalOperatorNames?: Maybe<string> } };

export type UpdateCrewProjectCertificateMutationVariables = Exact<{
  input: UpdateCrewProjectCertificateInput;
  recordHistory?: Maybe<Scalars['Boolean']>;
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateCrewProjectCertificateMutation = { updateCrewProjectCertificate: { warnings?: Maybe<Array<string>>, crewProjectCertificate?: Maybe<CrewProjectCertificateInformationFragment> } };

export type CrewProjectDcaProjectApproversQueryVariables = Exact<{ [key: string]: never; }>;


export type CrewProjectDcaProjectApproversQuery = { dcaProjectApprovers: Array<UserFragment> };

export type CrewProjectFormsTabQueryVariables = Exact<{
  crewProjectId: Scalars['Int'];
}>;


export type CrewProjectFormsTabQuery = { crewProject: { canToggleInsFormDcaApproved: boolean }, crewProjectInsForms: Array<ProjectInsFormVersionFragment>, crewProjectInsFormsExclusiveGroups: Array<ProjectInsFormVersionExclusiveGroupFragment> };

export type CrewProjectInsFormFieldValuesAndCommentsQueryQueryVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type CrewProjectInsFormFieldValuesAndCommentsQueryQuery = { fieldValues: Array<ProjectInsFormVersionFieldValueFragment>, fieldComments: Array<ProjectInsFormVersionFieldCommentFragment> };

export type CrewProjectInsFormFieldValuesOnlyQueryQueryVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type CrewProjectInsFormFieldValuesOnlyQueryQuery = { fieldValues: Array<ProjectInsFormVersionFieldValueFragment> };

export type DownloadCrewProjectUploadedInsFormQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadCrewProjectUploadedInsFormQuery = { file?: Maybe<DownloadFileFragment> };

export type DownloadCrewProjectFilledInInsFormQueryVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type DownloadCrewProjectFilledInInsFormQuery = { file?: Maybe<DownloadFileFragment> };

export type UpdateCrewProjectInsFormTrgApprovalMutationMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionTrgApprovalInput;
}>;


export type UpdateCrewProjectInsFormTrgApprovalMutationMutation = { updateCrewProjectInsFormTrgApproval: ProjectInsFormVersionFragment };

export type UpdateCrewProjectInsFormFileAttachmentMutationMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionFileAttachmentInput;
}>;


export type UpdateCrewProjectInsFormFileAttachmentMutationMutation = { updateCrewProjectInsFormFileAttachment: ProjectInsFormVersionFragment };

export type UpdateCrewProjectInsFormReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionReleasedToDcaInput;
}>;


export type UpdateCrewProjectInsFormReleasedToDcaMutationMutation = { updateCrewProjectInsFormReleasedToDca: ProjectInsFormVersionFragment };

export type UpdateCrewProjectInsFormFieldValuesMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionFieldValuesInput;
}>;


export type UpdateCrewProjectInsFormFieldValuesMutation = { updateCrewProjectInsFormFieldValues: boolean };

export type UpdateCrewProjectInsFormFieldCommentMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionFieldCommentInput;
}>;


export type UpdateCrewProjectInsFormFieldCommentMutation = { updateCrewProjectInsFormFieldComment: boolean };

export type UpdateCrewProjectInsFormIsDcaApprovedMutationVariables = Exact<{
  input: UpdateProjectInsFormIsDcaApprovedInput;
}>;


export type UpdateCrewProjectInsFormIsDcaApprovedMutation = { updateCrewProjectInsFormIsDcaApproved: boolean };

export type AddCrewProjectInsFormVersionCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddCrewProjectInsFormVersionCommentMutation = { addCrewProjectInsFormVersionComment: CommentFragment };

export type UpdateCrewProjectInsFormVersionCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateCrewProjectInsFormVersionCommentMutation = { updateCrewProjectInsFormVersionComment: CommentFragment };

export type ClearCrewProjectInsFormVersionSignatureByIdMutationVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
  fieldNumber: Scalars['Int'];
}>;


export type ClearCrewProjectInsFormVersionSignatureByIdMutation = { clearCrewProjectInsFormVersionSignatureById: boolean };

export type CrewProjectEmailHistoryQueryVariables = Exact<{
  crewProjectId: Scalars['Int'];
  sortBy?: Maybe<EmailHistorySortBy>;
  sortDirection?: Maybe<SortDirection>;
}>;


export type CrewProjectEmailHistoryQuery = { crewProjectEmailHistory: Array<EmailHistoryFragment> };

export type CrewProjectHistoryQueryVariables = Exact<{
  crewProjectId: Scalars['Int'];
}>;


export type CrewProjectHistoryQuery = { crewProjectHistory: Array<ProjectHistoryFragment> };

export type CrewProjectSummaryTabQueryVariables = Exact<{
  crewProjectId: Scalars['Int'];
}>;


export type CrewProjectSummaryTabQuery = { crewProject: { id: number, firstName: string, lastName: string, licenseNumber: string, validationNumber?: Maybe<string>, provisionalOperatorNames?: Maybe<string>, provisionalAircraftRegistrationMarks?: Maybe<string>, isHighImportance: boolean, isOnHold: boolean, isOnHoldByDca: boolean, dcaHoldReason?: Maybe<string>, projectCreationDate: any, isNoDcaInvoiceRequired: boolean, crewProjectType: { id: number, name: string }, crewProjectSpecialProjectType?: Maybe<{ id: number, name: string }>, crewProjectRenewalTypes: Array<{ id: number, name: string }>, projectStatus: { id: number }, country: { id: number, name: string }, crewLicenseType: { id: number, name: string }, crewPosition: { id: number, name: string }, operators: Array<{ id: number, company: { name: string } }>, aircrafts: Array<{ id: number, registrationMark: string, aircraftModel?: Maybe<{ id: number, name: string }> }>, assignees: Array<(
      { id: number, firstName?: Maybe<string>, lastName?: Maybe<string> }
      & UserFragment
    )>, projectCreatedByUser: { id: number, firstName?: Maybe<string>, lastName?: Maybe<string> }, dcaAssigneeUser?: Maybe<UserFragment>, documents: Array<{ id: number, isReleasedToDca: boolean, document: { documentType: { id: number, isAlwaysVisibleToDca: boolean }, fileAttachment: { fileName: string, fileSizeBytes: number, mimeType: string } } }> }, dcaHistory: Array<{ performedByName: string, date: any, projectStatus?: Maybe<{ id: number, name: string }>, projectTransition?: Maybe<{ id: number, name: string }> }> };

export type CrewProjectOfficialLetterNotesQueryVariables = Exact<{
  crewProjectId: Scalars['Int'];
}>;


export type CrewProjectOfficialLetterNotesQuery = { crewProject: { officialLetterDocumentsNote?: Maybe<string>, documentTypeOfficialLetterNotes: Array<{ officialLetterNote?: Maybe<string>, documentType: { id: number, name: string } }> } };

export type UpdateCrewProjectOfficialLetterDocumentNotesMutationVariables = Exact<{
  input: UpdateCrewProjectOfficialLetterNotesInput;
}>;


export type UpdateCrewProjectOfficialLetterDocumentNotesMutation = { updateCrewProjectOfficialLetterDocumentNotes: { id: number } };

export type SendCrewProjectEmailMutationVariables = Exact<{
  crewProjectId: Scalars['Int'];
  email: EmailInput;
}>;


export type SendCrewProjectEmailMutation = { sendCrewProjectEmail: { id: number } };

export type UpdateCrewProjectCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateCrewProjectCommentsLastViewedDateMutation = { updateCrewProjectCommentsLastViewedDate: { id: number } };

export type UpdateCrewProjectDcaCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateCrewProjectDcaCommentsLastViewedDateMutation = { updateCrewProjectDcaCommentsLastViewedDate: { id: number } };

export type CrewProjectAssignableUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type CrewProjectAssignableUsersQuery = { crewProjectAssignableUsers: Array<UserFragment> };

export type SetCrewProjectAssigneesMutationVariables = Exact<{
  crewProjectId: Scalars['Int'];
  assigneeUserIds: Array<Scalars['Int']>;
}>;


export type SetCrewProjectAssigneesMutation = { setCrewProjectAssignees: { id: number } };

export type SetCrewProjectPriorityMutationVariables = Exact<{
  id: Scalars['Int'];
  isHighPriority: Scalars['Boolean'];
}>;


export type SetCrewProjectPriorityMutation = { setCrewProjectPriority: { id: number } };

export type SetCrewProjectNoDcaInvoiceRequiredFlagMutationVariables = Exact<{
  id: Scalars['Int'];
  isNoDcaInvoiceRequired: Scalars['Boolean'];
}>;


export type SetCrewProjectNoDcaInvoiceRequiredFlagMutation = { setCrewProjectNoDcaInvoiceRequiredFlag: boolean };

export type CrewProjectEmailViewQueryVariables = Exact<{
  id: Scalars['Int'];
  emailId: Scalars['Int'];
  includeFileAttachments?: Maybe<Scalars['Boolean']>;
  includeFileContent?: Maybe<Scalars['Boolean']>;
}>;


export type CrewProjectEmailViewQuery = { crewProject: { emails: Array<EmailFragment> } };

export type DownloadCrewProjectEmailAttachmentContentQueryVariables = Exact<{
  crewProjectId: Scalars['Int'];
  emailId: Scalars['Int'];
  attachmentId: Scalars['Int'];
}>;


export type DownloadCrewProjectEmailAttachmentContentQuery = { downloadCrewProjectEmailAttachmentContent?: Maybe<string> };

export type CrewProjectCrewRatingFragment = { id: number, name: string, isDeleted: boolean };

export type CrewProjectAircraftFragment = { id: number, registrationMark: string, aircraftStatus: { id: number }, operator?: Maybe<{ id: number }> };

export type CrewProjectOperatorFragment = { id: number, isActive: boolean, isDeleted: boolean, company: { name: string, isActive: boolean } };

export type CrewProjectCategoryFragment = { id: number, name: string, isDeleted: boolean };

export type CrewProjectElpLevelFragment = { id: number, name: string, isDeleted: boolean };

export type CrewProjectGenericLvCompanyFragment = { id: number, name: string, isDeleted: boolean };

export type CrewProjectEmploymentCompanyFragment = { id: number, name: string, isDeleted: boolean };

export type CrewProjectApplicationTabQueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CrewProjectApplicationTabQueryQuery = { crewProject: { id: number, certificateFirstIssuedDate?: Maybe<any>, certificateDateOfIssue?: Maybe<any>, validationNumber?: Maybe<string>, certificateExpiryDate?: Maybe<any>, clientSubmissionDate?: Maybe<any>, dcaSubmissionDate?: Maybe<any>, firstName: string, lastName: string, licenseNumber: string, elpExpiryDate?: Maybe<any>, provisionalOperatorNames?: Maybe<string>, provisionalAircraftRegistrationMarks?: Maybe<string>, crewProjectType: { id: number, name: string }, crewProjectSpecialProjectType?: Maybe<{ id: number, name: string }>, crewProjectRenewalTypes: Array<{ id: number }>, crewPosition: { id: number }, country: { id: number }, crewLicenseType: { id: number }, elpLevel?: Maybe<{ id: number }>, operators: Array<CrewProjectOperatorFragment>, genericLvCompanies: Array<CrewProjectGenericLvCompanyFragment>, crewProjectCategory?: Maybe<{ id: number }>, aircraftModels: Array<AircraftModelFragment>, employmentCompanies: Array<CrewProjectEmploymentCompanyFragment>, crewRatings: Array<CrewProjectCrewRatingFragment>, aircrafts: Array<CrewProjectAircraftFragment>, associatedAircraftProject?: Maybe<{ id: number }> }, crewPositions: Array<CrewProjectCrewPositionFragment>, elpLevels: Array<CrewProjectElpLevelFragment>, crewProjectCategories: Array<CrewProjectCategoryFragment>, genericLvCompanies: Array<CrewProjectGenericLvCompanyFragment>, aircraftModels: Array<AircraftModelFragment>, employmentCompanies: Array<CrewProjectEmploymentCompanyFragment>, crewRatings: Array<CrewProjectCrewRatingFragment>, operators: { operators: Array<CrewProjectOperatorFragment> } };

export type UpdateCrewProjectMutationMutationVariables = Exact<{
  updateCrewProjectInput: UpdateCrewProjectInput;
  recordHistory?: Maybe<Scalars['Boolean']>;
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateCrewProjectMutationMutation = { updateCrewProject: { warnings?: Maybe<Array<string>> } };

export type DashboardUserQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DashboardUserQuery = { user: { id: number, operator?: Maybe<{ id: number }>, inspector?: Maybe<{ id: number }> } };

export type AircraftLicensingGridItemFragment = { id: number, registrationMark: string, isDcaInvoiced: boolean, isNoDcaInvoiceRequired: boolean, isPendingDocsFromIaso: boolean, isPendingOther: boolean, pendingReason?: Maybe<string>, isOnHoldByDca: boolean, dcaHoldReason?: Maybe<string>, isHighImportance: boolean, serialNumber?: Maybe<string>, yearOfManufacture?: Maybe<number>, initialRegistrationDate?: Maybe<any>, numberOfPaxSeats?: Maybe<number>, archivedDate?: Maybe<any>, aircraftClass?: Maybe<{ id: number, name: string }>, aircraftCategory?: Maybe<{ id: number, name: string }>, aircraftManufacturer?: Maybe<{ id: number, name: string }>, aircraftModel?: Maybe<{ id: number, name: string }>, aircraftStatus: { id: number, name: string }, aircraftEngineManufacturer?: Maybe<{ id: number, name: string }>, aircraftProjectType: { id: number, name: string }, operator?: Maybe<{ company: { name: string } }>, assignedDepartmentUsers: Array<{ displayName: string }>, projectStatus: { id: number, name: string }, owner?: Maybe<{ company: { name: string } }>, registeredHolder?: Maybe<{ company: { name: string } }> };

export type AircraftLicensingGridQueryVariables = Exact<{
  registrationMark?: Maybe<Scalars['String']>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  aircraftProjectTypeIdIn?: Maybe<Array<Scalars['Int']>>;
  archivedDate?: Maybe<DateRangeFilterInput>;
  sortBy?: Maybe<AircraftProjectsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
}>;


export type AircraftLicensingGridQuery = { aircraftProjects: { aircraftProjects: Array<AircraftLicensingGridItemFragment> } };

export type CrewLicenseValidationsGridItemFragment = { id: number, firstName: string, lastName: string, certificateExpiryDate?: Maybe<any>, validationNumber?: Maybe<string>, isHighImportance: boolean, licenseNumber: string, elpExpiryDate?: Maybe<any>, dcaSubmissionDate?: Maybe<any>, dcaProjectNumber?: Maybe<string>, isPendingDocsFromIaso: boolean, isPendingLicenseVerification: boolean, isPendingOther: boolean, pendingReason?: Maybe<string>, isOnHoldByDca: boolean, dcaHoldReason?: Maybe<string>, isDcaInvoiced: boolean, isNoDcaInvoiceRequired: boolean, turnaroundDays?: Maybe<number>, certificateDateOfIssue?: Maybe<any>, archivedDate?: Maybe<any>, projectStatus: { id: number, name: string }, country: { name: string }, crewProjectType: { id: number, abbreviation: string, name: string }, crewProjectRenewalTypes: Array<{ abbreviation: string, name: string }>, crewLicenseType: { description?: Maybe<string> }, crewPosition: { name: string }, crewRatings: Array<{ name: string }>, elpLevel?: Maybe<{ name: string }>, crewProjectCategory?: Maybe<{ name: string }>, operators: Array<{ company: { name: string } }>, aircrafts: Array<{ registrationMark: string }>, genericLvCompanies: Array<{ name: string }>, aircraftModels: Array<{ name: string }>, dcaAssigneeUser?: Maybe<{ displayName: string }>, preparedByDcaUser?: Maybe<{ displayName: string }>, associatedAircraftProject?: Maybe<{ aircraft: { registrationMark: string }, aircraftProjectType: { abbreviation: string } }> };

export type CrewLicenseValidationsGridQueryVariables = Exact<{
  projectStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  archivedDate?: Maybe<DateRangeFilterInput>;
  certificateDateOfIssue?: Maybe<DateRangeFilterInput>;
  lastNameContains?: Maybe<Scalars['String']>;
  validationNumberContains?: Maybe<Scalars['String']>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<CrewProjectsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
}>;


export type CrewLicenseValidationsGridQuery = { crewProjects: { crewProjects: Array<CrewLicenseValidationsGridItemFragment> } };

export type MechanicLicenseValidationsGridItemFragment = { id: number, firstName: string, lastName: string, certificateExpiryDate?: Maybe<any>, validationNumber?: Maybe<string>, isHighImportance: boolean, dcaValidationIssueBasedOnLine1?: Maybe<string>, dcaValidationIssueBasedOnLine2?: Maybe<string>, licenseNumber: string, dcaSubmissionDate?: Maybe<any>, dcaProjectNumber?: Maybe<string>, isPendingDocsFromIaso: boolean, isPendingLicenseVerification: boolean, isPendingOther: boolean, pendingReason?: Maybe<string>, isOnHoldByDca: boolean, dcaHoldReason?: Maybe<string>, isDcaInvoiced: boolean, isNoDcaInvoiceRequired: boolean, turnaroundDays?: Maybe<number>, archivedDate?: Maybe<any>, certificateDateOfIssue?: Maybe<any>, projectStatus: { id: number, name: string }, country: { name: string }, mechanicProjectType: { id: number, abbreviation: string, name: string }, mechanicProjectRenewalTypes: Array<{ abbreviation: string, name: string }>, mechanicLicenseType: { description?: Maybe<string> }, mechanicPosition: { name: string }, mechanicRatings: Array<{ name: string }>, operators: Array<{ company: { name: string } }>, aircrafts: Array<{ registrationMark: string }>, dcaReviewerUser?: Maybe<{ displayName: string }>, dcaSentForApprovalByUser?: Maybe<{ displayName: string }>, dcaApprovedByUser?: Maybe<{ displayName: string }>, associatedAircraftProject?: Maybe<{ aircraft: { registrationMark: string }, aircraftProjectType: { abbreviation: string } }> };

export type MechanicLicenseValidationsGridQueryVariables = Exact<{
  projectStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  archivedDate?: Maybe<DateRangeFilterInput>;
  certificateDateOfIssue?: Maybe<DateRangeFilterInput>;
  lastNameContains?: Maybe<Scalars['String']>;
  validationNumberContains?: Maybe<Scalars['String']>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<MechanicProjectsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
}>;


export type MechanicLicenseValidationsGridQuery = { mechanicProjects: { mechanicProjects: Array<MechanicLicenseValidationsGridItemFragment> } };

export type CrewProjectInformationForInsFormQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CrewProjectInformationForInsFormQuery = { crewProject: { projectStatus: { id: number } } };

export type SignCrewProjectInsFormVersionByExecutionKeyMutationVariables = Exact<{
  executionKey: Scalars['String'];
  input: SignProjectInsFormVersionInput;
}>;


export type SignCrewProjectInsFormVersionByExecutionKeyMutation = { signCrewProjectInsFormVersionByExecutionKey: boolean };

export type ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutationVariables = Exact<{
  executionKey: Scalars['String'];
  fieldNumber: Scalars['Int'];
}>;


export type ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutation = { clearCrewProjectInsFormVersionSignatureByExecutionKey: boolean };

export type DownloadCrewProjectFilledInInsFormByExecutionKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type DownloadCrewProjectFilledInInsFormByExecutionKeyQuery = { file?: Maybe<DownloadFileFragment> };

export type UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutationVariables = Exact<{
  key: Scalars['String'];
  fieldValues: Array<UpdateProjectInsFormVersionFieldValueInput>;
}>;


export type UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutation = { updateCrewProjectInsFormFieldValuesByExecutionKey: boolean };

export type MechanicProjectInformationForInsFormQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MechanicProjectInformationForInsFormQuery = { mechanicProject: { projectStatus: { id: number } } };

export type SignMechanicProjectInsFormVersionByExecutionKeyMutationVariables = Exact<{
  executionKey: Scalars['String'];
  input: SignProjectInsFormVersionInput;
}>;


export type SignMechanicProjectInsFormVersionByExecutionKeyMutation = { signMechanicProjectInsFormVersionByExecutionKey: boolean };

export type ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutationVariables = Exact<{
  executionKey: Scalars['String'];
  fieldNumber: Scalars['Int'];
}>;


export type ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutation = { clearMechanicProjectInsFormVersionSignatureByExecutionKey: boolean };

export type DownloadMechanicProjectFilledInInsFormByExecutionKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type DownloadMechanicProjectFilledInInsFormByExecutionKeyQuery = { file?: Maybe<DownloadFileFragment> };

export type UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutationVariables = Exact<{
  key: Scalars['String'];
  fieldValues: Array<UpdateProjectInsFormVersionFieldValueInput>;
}>;


export type UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutation = { updateMechanicProjectInsFormFieldValuesByExecutionKey: boolean };

export type ProjectInsFormVersionByExecutionKeyFragment = { id: number, projectId: number, isSigned: boolean, isSignedByDca: boolean, isFullySigned: boolean, insFormVersion: { id: number, insForm: { willBeEmailedWhenSigned: boolean }, fields: Array<{ fieldNumber: number, isSignatureField: boolean, signatoryRoleId?: Maybe<number> }> }, fieldValues: Array<{ id: number, text?: Maybe<string>, signedByUser?: Maybe<{ id: number, userName?: Maybe<string>, displayName: string }>, insFormVersionField: { fieldNumber: number } }>, fieldComments: Array<{ insFormVersionField: { fieldNumber: number } }>, insFormExecutionState?: Maybe<{ id: number }> };

export type ProjectInsFormVersionByExecutionKeyForDownloadFragment = { id: number, insFormVersion: { insForm: { name: string } }, insFormExecutionState?: Maybe<{ id: number }> };

export type ProjectInsFormVersionByExecutionKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type ProjectInsFormVersionByExecutionKeyQuery = { projectInsFormVersionByExecutionKey: ProjectInsFormVersionByExecutionKeyFragment };

export type ProjectInsFormVersionByExecutionKeyForDownloadQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type ProjectInsFormVersionByExecutionKeyForDownloadQuery = { projectInsFormVersionByExecutionKey: ProjectInsFormVersionByExecutionKeyForDownloadFragment };

export type InspectorGridItemFragment = { id: number, inspectorTypeId: number, inspectorCategoryId: number, inspectorCategoryTypeId?: Maybe<number>, isActive: boolean, serviceAgreementExpirationDate?: Maybe<any>, appointmentLetterExpirationDate?: Maybe<any>, totalNewComments: number, user?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, countryId?: Maybe<number>, regionId?: Maybe<number> }>, coverageAreaRegions: Array<{ name: string }>, passportCountries: Array<{ name: string }>, visaCountries: Array<{ name: string }> };

export type InspectorRegionFragment = { id: number, name: string, isDeleted: boolean };

export type InspectorCountryFragment = { id: number, name: string, isDeleted: boolean };

export type InspectorGridFilterLookupsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type InspectorGridFilterLookupsQueryQuery = { regions: Array<InspectorRegionFragment>, countries: Array<InspectorCountryFragment> };

export type InspectorGridQueryVariables = Exact<{
  regionIdIn?: Maybe<Array<Scalars['Int']>>;
  countryIdIn?: Maybe<Array<Scalars['Int']>>;
  isActive?: Maybe<Scalars['Boolean']>;
  coverageAreaRegionIdIn?: Maybe<Array<Scalars['Int']>>;
  inspectorTypeIdIn?: Maybe<Array<Scalars['Int']>>;
  inspectorCategoryIdIn?: Maybe<Array<Scalars['Int']>>;
  inspectorCategoryTypeIdIn?: Maybe<Array<Scalars['Int']>>;
  inspectorPassportCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  inspectorVisaCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  sortBy?: Maybe<InspectorsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type InspectorGridQuery = { inspectors: { inspectors: Array<InspectorGridItemFragment> } | { totalItems: number, inspectors: Array<InspectorGridItemFragment> } };

export type InspectorInspectionsGridItemFragment = { id: number, city: string, startDate?: Maybe<any>, endDate?: Maybe<any>, inspector: { user?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string> }> }, inspection: { otherStatusText?: Maybe<string>, inspectionStatus: { id: number, name: string }, aircraftProjectOperatorInspection?: Maybe<{ aircraftProject: { id: number, registrationMark: string, aircraftProjectType: { id: number, name: string }, projectStatus: { name: string } } }> }, country: { name: string }, state?: Maybe<{ name: string }> };

export type InspectorInspectionGridQueryVariables = Exact<{
  sortBy?: Maybe<InspectorInspectionsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  inspectorIdIn?: Maybe<Array<Scalars['Int']>>;
  includePeerInspectionsForInspectors?: Maybe<Scalars['Boolean']>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type InspectorInspectionGridQuery = { inspectorInspections: { inspectorInspections: Array<InspectorInspectionsGridItemFragment> } | { totalItems: number, inspectorInspections: Array<InspectorInspectionsGridItemFragment> } };

export type InspectorAvailabilityEventFragment = { id: number, startDate?: Maybe<any>, endDate?: Maybe<any>, inspector: { user?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, initials?: Maybe<string>, emailAddresses: Array<{ emailAddress: string }> }> }, inspection: { aircraftProjectOperatorInspection?: Maybe<{ aircraftProject: { id: number, registrationMark: string, projectStatus: { id: number }, aircraftProjectType: { id: number } } }> } };

export type InspectorAvailabilityBlockedDateFragment = { id: number, startDate: any, endDate: any, inspector: { user?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, initials?: Maybe<string> }> } };

export type InspectorAvailabilityQueryVariables = Exact<{
  inspectorIdIn?: Maybe<Array<Scalars['Int']>>;
}>;


export type InspectorAvailabilityQuery = { inspectorInspections: { inspectorInspections: Array<InspectorAvailabilityEventFragment> }, inspectorBlockedDates: Array<InspectorAvailabilityBlockedDateFragment> };

export type InspectorDetailFragment = { id: number, inspectorTypeId: number, inspectorCategoryId: number, inspectorCategoryTypeId?: Maybe<number>, atsType?: Maybe<string>, diAppointmentNumber?: Maybe<string>, isActive: boolean, user?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, initials?: Maybe<string>, userName?: Maybe<string>, regionId?: Maybe<number>, countryId?: Maybe<number>, stateId?: Maybe<number>, address?: Maybe<string>, city?: Maybe<string>, zipCode?: Maybe<string>, phoneNumbers: Array<{ id: number, phoneNumberTypeId: number, phoneNumber: string }>, emailAddresses: Array<{ id: number, emailAddressTypeId: number, emailAddress: string }> }>, passportCountries: Array<{ id: number }>, visaCountries: Array<{ id: number }>, coverageAreaRegions: Array<{ id: number }>, onboardingChecklist?: Maybe<{ idCardIssued: boolean, emails: boolean, backpacks: boolean, businessCard: boolean }> };

export type InspectorDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type InspectorDetailQuery = { inspector: InspectorDetailFragment };

export type AddInspectorModalQueryVariables = Exact<{ [key: string]: never; }>;


export type AddInspectorModalQuery = { countries: Array<CountryLookupFragment>, regions: Array<RegionLookupFragment>, states: Array<StateLookupFragment> };

export type AddInspectorMutationVariables = Exact<{
  input: AddInspectorInput;
}>;


export type AddInspectorMutation = { addInspector: { id: number } };

export type UpdateInspectorMutationVariables = Exact<{
  id: Scalars['Int'];
  input: InspectorInput;
}>;


export type UpdateInspectorMutation = { updateInspector: { id: number } };

export type InspectorBlockedDateFragment = { id: number, startDate: any, endDate: any, reason: string };

export type InspectorBlockedDatesQueryVariables = Exact<{
  inspectorIdIn?: Maybe<Array<Scalars['Int']>>;
}>;


export type InspectorBlockedDatesQuery = { inspectorBlockedDates: Array<InspectorBlockedDateFragment> };

export type AddInspectorBlockedDateMutationVariables = Exact<{
  input: AddInspectorBlockedDateInput;
}>;


export type AddInspectorBlockedDateMutation = { addInspectorBlockedDate: { id: number } };

export type UpdateInspectorBlockedDateMutationVariables = Exact<{
  input: UpdateInspectorBlockedDateInput;
}>;


export type UpdateInspectorBlockedDateMutation = { updateInspectorBlockedDate: { id: number } };

export type RemoveInspectorBlockedDateMutationVariables = Exact<{
  inspectorBlockedDateId: Scalars['Int'];
}>;


export type RemoveInspectorBlockedDateMutation = { removeInspectorBlockedDate: boolean };

export type InspectorCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type InspectorCommentsQuery = { inspectorComments: CommentsFragment };

export type AddInspectorCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddInspectorCommentMutation = { addInspectorComment: CommentFragment };

export type UpdateInspectorCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateInspectorCommentMutation = { updateInspectorComment: CommentFragment };

export type UpdateInspectorCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateInspectorCommentsLastViewedDateMutation = { updateInspectorCommentsLastViewedDate: { id: number } };

export type InspectorDocumentFragment = { id: number, isArchived: boolean, document: DocumentForDocumentListsFragment };

export type InspectorDocumentsQueryQueryVariables = Exact<{
  inspectorId: Scalars['Int'];
  documentTypeCategoryId: DocumentTypeCategoryEnum;
}>;


export type InspectorDocumentsQueryQuery = { documentTypeIdsEditableByInspector: Array<number>, documents: Array<InspectorDocumentFragment>, documentTypes: Array<DocumentTypeFragment> };

export type AddInspectorDocumentMutationMutationVariables = Exact<{
  addInspectorDocumentInput: AddInspectorDocumentInput;
}>;


export type AddInspectorDocumentMutationMutation = { addInspectorDocument: { id: number } };

export type UpdateInspectorDocumentMutationMutationVariables = Exact<{
  updateInspectorDocumentInput: UpdateInspectorDocumentInput;
}>;


export type UpdateInspectorDocumentMutationMutation = { updateInspectorDocument: { id: number } };

export type RemoveInspectorDocumentMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveInspectorDocumentMutationMutation = { removeInspectorDocument: boolean };

export type DownloadInspectorDocumentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadInspectorDocumentQuery = { file?: Maybe<DownloadFileFragment> };

export type InspectorEmailHistoryQueryVariables = Exact<{
  inspectorId: Scalars['Int'];
  sortBy?: Maybe<EmailHistorySortBy>;
  sortDirection?: Maybe<SortDirection>;
}>;


export type InspectorEmailHistoryQuery = { inspector: { emailHistory: Array<EmailHistoryFragment> } };

export type InspectorEmailViewQueryVariables = Exact<{
  id: Scalars['Int'];
  emailId: Scalars['Int'];
  includeFileAttachments?: Maybe<Scalars['Boolean']>;
  includeFileContent?: Maybe<Scalars['Boolean']>;
}>;


export type InspectorEmailViewQuery = { inspector: { emails: Array<EmailFragment> } };

export type DownloadInspectorEmailAttachmentContentQueryVariables = Exact<{
  inspectorId: Scalars['Int'];
  emailId: Scalars['Int'];
  attachmentId: Scalars['Int'];
}>;


export type DownloadInspectorEmailAttachmentContentQuery = { downloadInspectorEmailAttachmentContent?: Maybe<string> };

export type SendInspectorEmailMutationVariables = Exact<{
  inspectorId: Scalars['Int'];
  email: EmailInput;
}>;


export type SendInspectorEmailMutation = { sendInspectorEmail: { id: number } };

export type InvoiceGridItemFragment = { id: number, isArgInvoice: boolean, invoiceNumber: string, invoiceDate?: Maybe<any>, createdByUser: { firstName?: Maybe<string>, lastName?: Maybe<string> }, aircraftProjects: Array<{ id: number, aircraftProjectNameForInvoicing: string }>, crewProjects: Array<{ id: number, crewProjectNameForInvoicing: string }>, mechanicProjects: Array<{ id: number, mechanicProjectNameForInvoicing: string }>, paymentStatus: { id: number, name: string } };

export type InvoiceGridQueryVariables = Exact<{
  isArgInvoice?: Maybe<Scalars['Boolean']>;
  aircraftProjectIdIn?: Maybe<Array<Scalars['Int']>>;
  crewProjectIdIn?: Maybe<Array<Scalars['Int']>>;
  mechanicProjectIdIn?: Maybe<Array<Scalars['Int']>>;
  createDate?: Maybe<DateRangeFilterInput>;
  sortBy?: Maybe<InvoicesSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type InvoiceGridQuery = { invoices: { invoices: Array<InvoiceGridItemFragment> } | { totalItems: number, invoices: Array<InvoiceGridItemFragment> } };

export type InvoiceProjectSelectionQueryVariables = Exact<{
  invoiceId?: Maybe<Scalars['Int']>;
}>;


export type InvoiceProjectSelectionQuery = { aircraftProjectsForSelectionOnInvoice: Array<{ id: number, aircraftProjectNameForInvoicing: string }>, crewProjectsForSelectionOnInvoice: Array<{ id: number, crewProjectNameForInvoicing: string }>, mechanicProjectsForSelectionOnInvoice: Array<{ id: number, mechanicProjectNameForInvoicing: string }> };

export type InvoiceModalQueryVariables = Exact<{
  invoiceId: Scalars['Int'];
}>;


export type InvoiceModalQuery = { invoice: { invoiceNumber: string, invoiceDate?: Maybe<any>, notes?: Maybe<string>, fileAttachment: { fileName: string, fileSizeBytes: number, mimeType: string }, aircraftProjects: Array<{ id: number, aircraftProjectNameForInvoicing: string }>, crewProjects: Array<{ id: number, crewProjectNameForInvoicing: string }>, mechanicProjects: Array<{ id: number, mechanicProjectNameForInvoicing: string }>, paymentStatus: { id: number } } };

export type DownloadInvoiceFileAttachmentContentQueryVariables = Exact<{
  invoiceId: Scalars['Int'];
}>;


export type DownloadInvoiceFileAttachmentContentQuery = { downloadInvoiceFileAttachment?: Maybe<string> };

export type AddInvoiceMutationVariables = Exact<{
  addInvoiceInput: AddInvoiceInput;
}>;


export type AddInvoiceMutation = { addInvoice: { id: number } };

export type UpdateInvoiceMutationVariables = Exact<{
  updateInvoiceInput: UpdateInvoiceInput;
}>;


export type UpdateInvoiceMutation = { updateInvoice: { id: number } };

export type DeleteInvoiceMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteInvoiceMutation = { deleteInvoice: boolean };

export type ListManagementAircraftEngineManufacturerFragment = { id: number, isDeleted: boolean, name: string, listManagementActiveAircrafts: Array<{ registrationMark: string }>, listManagementSkippedAircrafts: Array<{ registrationMark: string }>, listManagementOpenAircraftProjects: Array<{ registrationMark: string }>, listManagementSkippedAircraftProjects: Array<{ registrationMark: string }> };

export type ListManagementAircraftEngineManufacturersQueryVariables = Exact<{
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type ListManagementAircraftEngineManufacturersQuery = { listManagementItems: { totalItems: number, items: Array<ListManagementAircraftEngineManufacturerFragment> } };

export type ConsolidateAircraftEngineManufacturersMutationVariables = Exact<{
  input: ListManagementLookupConsolidationInput;
}>;


export type ConsolidateAircraftEngineManufacturersMutation = { consolidateAircraftEngineManufacturers: boolean };

export type ListManagementAircraftManufacturerFragment = { id: number, isDeleted: boolean, name: string, listManagementActiveAircrafts: Array<{ registrationMark: string }>, listManagementSkippedAircrafts: Array<{ registrationMark: string }>, listManagementOpenAircraftProjects: Array<{ registrationMark: string }>, listManagementSkippedAircraftProjects: Array<{ registrationMark: string }> };

export type ListManagementAircraftManufacturersQueryVariables = Exact<{
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type ListManagementAircraftManufacturersQuery = { listManagementItems: { totalItems: number, items: Array<ListManagementAircraftManufacturerFragment> } };

export type ConsolidateAircraftManufacturersMutationVariables = Exact<{
  input: ListManagementLookupConsolidationInput;
}>;


export type ConsolidateAircraftManufacturersMutation = { consolidateAircraftManufacturers: boolean };

export type ListManagementAircraftModelFragment = { id: number, isDeleted: boolean, name: string, listManagementActiveAircrafts: Array<{ registrationMark: string }>, listManagementSkippedAircrafts: Array<{ registrationMark: string }>, listManagementOpenAircraftProjects: Array<{ registrationMark: string }>, listManagementSkippedAircraftProjects: Array<{ registrationMark: string }>, listManagementActiveCrewMembers: Array<{ firstName: string, lastName: string }>, listManagementSkippedCrewMembers: Array<{ firstName: string, lastName: string }>, listManagementOpenCrewProjects: Array<{ firstName: string, lastName: string }>, listManagementSkippedCrewProjects: Array<{ firstName: string, lastName: string }> };

export type ListManagementAircraftModelsQueryVariables = Exact<{
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type ListManagementAircraftModelsQuery = { listManagementItems: { totalItems: number, items: Array<ListManagementAircraftModelFragment> } };

export type ConsolidateAircraftModelsMutationVariables = Exact<{
  input: ListManagementLookupConsolidationInput;
}>;


export type ConsolidateAircraftModelsMutation = { consolidateAircraftModels: boolean };

export type ListManagementAircraftPropellerManufacturerFragment = { id: number, isDeleted: boolean, name: string, listManagementActiveAircrafts: Array<{ registrationMark: string }>, listManagementSkippedAircrafts: Array<{ registrationMark: string }>, listManagementOpenAircraftProjects: Array<{ registrationMark: string }>, listManagementSkippedAircraftProjects: Array<{ registrationMark: string }> };

export type ListManagementAircraftPropellerManufacturersQueryVariables = Exact<{
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type ListManagementAircraftPropellerManufacturersQuery = { listManagementItems: { totalItems: number, items: Array<ListManagementAircraftPropellerManufacturerFragment> } };

export type ConsolidateAircraftPropellerManufacturersMutationVariables = Exact<{
  input: ListManagementLookupConsolidationInput;
}>;


export type ConsolidateAircraftPropellerManufacturersMutation = { consolidateAircraftPropellerManufacturers: boolean };

export type ListManagementCrewRatingFragment = { id: number, isDeleted: boolean, name: string, listManagementActiveCrewMembers: Array<{ firstName: string, lastName: string }>, listManagementSkippedCrewMembers: Array<{ firstName: string, lastName: string }>, listManagementOpenCrewProjects: Array<{ firstName: string, lastName: string }>, listManagementSkippedCrewProjects: Array<{ firstName: string, lastName: string }> };

export type ListManagementCrewRatingsQueryVariables = Exact<{
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type ListManagementCrewRatingsQuery = { listManagementItems: { totalItems: number, items: Array<ListManagementCrewRatingFragment> } };

export type ConsolidateCrewRatingsMutationVariables = Exact<{
  input: ListManagementLookupConsolidationInput;
}>;


export type ConsolidateCrewRatingsMutation = { consolidateCrewRatings: boolean };

export type ListManagementEmploymentCompanyFragment = { id: number, isDeleted: boolean, name: string, listManagementActiveCrewMembers: Array<{ firstName: string, lastName: string }>, listManagementSkippedCrewMembers: Array<{ firstName: string, lastName: string }>, listManagementOpenCrewProjects: Array<{ firstName: string, lastName: string }>, listManagementSkippedCrewProjects: Array<{ firstName: string, lastName: string }> };

export type ListManagementEmploymentCompaniesQueryVariables = Exact<{
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type ListManagementEmploymentCompaniesQuery = { listManagementItems: { totalItems: number, items: Array<ListManagementEmploymentCompanyFragment> } };

export type ConsolidateEmploymentCompaniesMutationVariables = Exact<{
  input: ListManagementLookupConsolidationInput;
}>;


export type ConsolidateEmploymentCompaniesMutation = { consolidateEmploymentCompanies: boolean };

export type ListManagementGenericLvCompanyFragment = { id: number, isDeleted: boolean, name: string, listManagementActiveCrewMembers: Array<{ firstName: string, lastName: string }>, listManagementSkippedCrewMembers: Array<{ firstName: string, lastName: string }>, listManagementOpenCrewProjects: Array<{ firstName: string, lastName: string }>, listManagementSkippedCrewProjects: Array<{ firstName: string, lastName: string }> };

export type ListManagementGenericLvCompaniesQueryVariables = Exact<{
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type ListManagementGenericLvCompaniesQuery = { listManagementItems: { totalItems: number, items: Array<ListManagementGenericLvCompanyFragment> } };

export type ConsolidateGenericLvCompaniesMutationVariables = Exact<{
  input: ListManagementLookupConsolidationInput;
}>;


export type ConsolidateGenericLvCompaniesMutation = { consolidateGenericLvCompanies: boolean };

export type ListManagementMechanicRatingFragment = { id: number, isDeleted: boolean, name: string, listManagementActiveMechanics: Array<{ firstName: string, lastName: string }>, listManagementSkippedMechanics: Array<{ firstName: string, lastName: string }>, listManagementOpenMechanicProjects: Array<{ firstName: string, lastName: string }>, listManagementSkippedMechanicProjects: Array<{ firstName: string, lastName: string }> };

export type ListManagementMechanicRatingsQueryVariables = Exact<{
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type ListManagementMechanicRatingsQuery = { listManagementItems: { totalItems: number, items: Array<ListManagementMechanicRatingFragment> } };

export type ConsolidateMechanicRatingsMutationVariables = Exact<{
  input: ListManagementLookupConsolidationInput;
}>;


export type ConsolidateMechanicRatingsMutation = { consolidateMechanicRatings: boolean };

export type MechanicGridItemFragment = { id: number, firstName: string, lastName: string, validationNumber?: Maybe<string>, certificateDateOfFirstIssue?: Maybe<any>, certificateExpiryDate?: Maybe<any>, totalNewComments: number, numberOfNonInactiveAircraft: number, mechanicPosition: { name: string }, mechanicLicenseType: { name: string }, country: { name: string }, mechanicRatings: Array<{ name: string }>, operators: Array<{ id: number, isActive: boolean, company: { name: string } }>, mechanicStatus: { name: string }, activeMechanicProjects: Array<{ id: number }> };

export type MechanicCountryFragment = { id: number, name: string, isDeleted: boolean };

export type MechanicOperatorFragment = { id: number, isActive: boolean, isDeleted: boolean, company: { name: string, isActive: boolean } };

export type MechanicGridFilterLookupsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MechanicGridFilterLookupsQueryQuery = { countries: Array<MechanicCountryFragment>, mechanicRatings: Array<MechanicRatingFragment>, operators: { operators: Array<MechanicOperatorFragment> } };

export type MechanicGridQueryVariables = Exact<{
  sortBy?: Maybe<MechanicsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  lastNameContains?: Maybe<Scalars['String']>;
  mechanicStatusId?: Maybe<Scalars['Int']>;
  licenseCountryIdIn?: Maybe<Array<Scalars['Int']>>;
  mechanicRatingIdIn?: Maybe<Array<Scalars['Int']>>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  aircraftIdIn?: Maybe<Array<Scalars['Int']>>;
  keyword?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type MechanicGridQuery = { mechanics: { mechanics: Array<MechanicGridItemFragment> } | { totalItems: number, mechanics: Array<MechanicGridItemFragment> } };

export type MechanicEmploymentCompanyFragment = { id: number, name: string, isDeleted: boolean };

export type MechanicAircraftFragment = { id: number, registrationMark: string, aircraftStatus: { id: number } };

export type MechanicPageQueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MechanicPageQueryQuery = { mechanic: { id: number, firstName: string, lastName: string, licenseNumber: string, validationNumber?: Maybe<string>, certificateDateOfFirstIssue?: Maybe<any>, certificateIssuedDate?: Maybe<any>, certificateExpiryDate?: Maybe<any>, mechanicStatus: { id: number }, mechanicPosition: { id: number }, country: { id: number }, mechanicLicenseType: { id: number }, operators: Array<MechanicOperatorFragment>, employmentCompanies: Array<MechanicEmploymentCompanyFragment>, mechanicRatings: Array<MechanicRatingFragment>, aircrafts: Array<MechanicAircraftFragment>, activeMechanicProjects: Array<{ id: number }> }, employmentCompanies: Array<MechanicEmploymentCompanyFragment>, operators: { operators: Array<MechanicOperatorFragment> }, aircrafts: { aircrafts: Array<MechanicAircraftFragment> } };

export type MechanicPageDateOfFirstIssueQueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MechanicPageDateOfFirstIssueQueryQuery = { mechanic: { certificateDateOfFirstIssue?: Maybe<any>, mechanicStatus: { id: number } } };

export type UpdateMechanicMutationMutationVariables = Exact<{
  updateMechanicInput: UpdateMechanicInput;
}>;


export type UpdateMechanicMutationMutation = { updateMechanic: { id: number } };

export type MechanicCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MechanicCommentsQuery = { mechanicComments: CommentsFragment };

export type AddMechanicCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddMechanicCommentMutation = { addMechanicComment: CommentFragment };

export type UpdateMechanicCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateMechanicCommentMutation = { updateMechanicComment: CommentFragment };

export type UpdateMechanicCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateMechanicCommentsLastViewedDateMutation = { updateMechanicCommentsLastViewedDate: { id: number } };

export type MechanicDocumentFragment = { id: number, isArchived: boolean, document: DocumentForDocumentListsFragment };

export type MechanicDocumentsQueryQueryVariables = Exact<{
  mechanicId: Scalars['Int'];
  documentTypeCategoryId: DocumentTypeCategoryEnum;
}>;


export type MechanicDocumentsQueryQuery = { mechanic: { certificateDateOfFirstIssue?: Maybe<any> }, documents: Array<MechanicDocumentFragment>, documentTypes: Array<DocumentTypeFragment> };

export type AddMechanicDocumentMutationMutationVariables = Exact<{
  addMechanicDocumentInput: AddMechanicDocumentInput;
}>;


export type AddMechanicDocumentMutationMutation = { addMechanicDocument: { id: number } };

export type UpdateMechanicDocumentMutationMutationVariables = Exact<{
  updateMechanicDocumentInput: UpdateMechanicDocumentInput;
}>;


export type UpdateMechanicDocumentMutationMutation = { updateMechanicDocument: { id: number } };

export type RemoveMechanicDocumentMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveMechanicDocumentMutationMutation = { removeMechanicDocument: boolean };

export type DownloadMechanicDocumentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadMechanicDocumentQuery = { file?: Maybe<DownloadFileFragment> };

export type AddMechanicMutationMutationVariables = Exact<{
  addMechanicInput: AddMechanicInput;
}>;


export type AddMechanicMutationMutation = { addMechanic: { id: number } };

export type MechanicProjectDocumentFragment = { id: number, isReleasedToDca: boolean, isArchived: boolean, document: DocumentForDocumentListsFragment };

export type MechanicProjectDocumentsQueryQueryVariables = Exact<{
  mechanicProjectId: Scalars['Int'];
  documentTypeCategoryId: DocumentTypeCategoryEnum;
}>;


export type MechanicProjectDocumentsQueryQuery = { mechanicProject: { certificateExpiryDate?: Maybe<any>, mechanic: { certificateDateOfFirstIssue?: Maybe<any> } }, documents: Array<MechanicProjectDocumentFragment>, documentTypes: Array<DocumentTypeFragment> };

export type AddMechanicProjectDocumentMutationMutationVariables = Exact<{
  addMechanicProjectDocumentInput: AddMechanicProjectDocumentInput;
}>;


export type AddMechanicProjectDocumentMutationMutation = { addMechanicProjectDocument: { id: number } };

export type UpdateMechanicProjectDocumentMutationMutationVariables = Exact<{
  updateMechanicProjectDocumentInput: UpdateMechanicProjectDocumentInput;
}>;


export type UpdateMechanicProjectDocumentMutationMutation = { updateMechanicProjectDocument: { id: number } };

export type RemoveMechanicProjectDocumentMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveMechanicProjectDocumentMutationMutation = { removeMechanicProjectDocument: boolean };

export type DownloadMechanicProjectDocumentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadMechanicProjectDocumentQuery = { file?: Maybe<DownloadFileFragment> };

export type RequestMechanicProjectDocumentDownloadTokenMutationMutationVariables = Exact<{
  id: Scalars['Int'];
  downloadFileName?: Maybe<Scalars['String']>;
}>;


export type RequestMechanicProjectDocumentDownloadTokenMutationMutation = { requestMechanicProjectDocumentDownloadToken: string };

export type UpdateMechanicProjectDocumentReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateMechanicProjectDocumentReleasedToDcaInput;
}>;


export type UpdateMechanicProjectDocumentReleasedToDcaMutationMutation = { updateMechanicProjectDocumentReleasedToDca: { id: number } };

export type MechanicProjectGridItemFragment = { id: number, lastName: string, firstName: string, certificateFirstIssuedDate?: Maybe<any>, validationNumber?: Maybe<string>, certificateDateOfIssue?: Maybe<any>, certificateExpiryDate?: Maybe<any>, isHighImportance: boolean, isOnHold: boolean, isOnHoldByDca: boolean, provisionalOperatorNames?: Maybe<string>, provisionalAircraftRegistrationMarks?: Maybe<string>, projectCreationDate: any, clientSubmissionDate?: Maybe<any>, dcaSubmissionDate?: Maybe<any>, totalNewComments: number, totalNewDcaComments: number, turnaroundDays?: Maybe<number>, archivedDate?: Maybe<any>, mechanicProjectType: { id: number, abbreviation: string }, mechanicProjectRenewalTypes: Array<{ abbreviation: string }>, mechanicPosition: { name: string }, projectStatus: { name: string }, projectStage: { name: string }, mechanicLicenseType: { name: string }, operators: Array<{ company: { name: string } }>, assignees: Array<{ firstName?: Maybe<string>, lastName?: Maybe<string>, userName?: Maybe<string> }>, aircrafts: Array<{ registrationMark: string, aircraftStatus: { id: number } }>, associatedAircraftProject?: Maybe<{ id: number, aircraft: { id: number, registrationMark: string }, aircraftProjectType: { id: number, abbreviation: string } }> };

export type MechanicProjectGridQueryVariables = Exact<{
  sortBy?: Maybe<MechanicProjectsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  mechanicId?: Maybe<Scalars['Int']>;
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  associatedAircraftProjectIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdIn?: Maybe<Array<Scalars['Int']>>;
  projectStatusIdNotIn?: Maybe<Array<Scalars['Int']>>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type MechanicProjectGridQuery = { mechanicProjects: { mechanicProjects: Array<MechanicProjectGridItemFragment> } | { totalItems: number, mechanicProjects: Array<MechanicProjectGridItemFragment> } };

export type MechanicProjectCertificatePreviewQueryVariables = Exact<{
  mechanicProjectId: Scalars['Int'];
}>;


export type MechanicProjectCertificatePreviewQuery = { downloadMechanicCertificatePreview?: Maybe<DownloadFileFragment> };

export type DownloadMechanicProjectOfficialLetterPreviewQueryVariables = Exact<{
  mechanicProjectId: Scalars['Int'];
}>;


export type DownloadMechanicProjectOfficialLetterPreviewQuery = { downloadMechanicProjectOfficialLetterPreview?: Maybe<DownloadFileFragment> };

export type AddMechanicProjectMutationMutationVariables = Exact<{
  addMechanicProjectInput: AddMechanicProjectInput;
}>;


export type AddMechanicProjectMutationMutation = { addMechanicProject: { id: number } };

export type AddMechanicProjectModalMechanicQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AddMechanicProjectModalMechanicQuery = { mechanic: { id: number, mechanicPosition: { id: number } } };

export type MechanicProjectMechanicLicenseTypeFragment = { id: number, name: string, isDeleted: boolean };

export type MechanicProjectMechanicPositionFragment = { id: number, name: string, isDeleted: boolean, mechanicLicenseTypes: Array<MechanicProjectMechanicLicenseTypeFragment> };

export type MechanicProjectCountryFragment = { id: number, name: string, isDeleted: boolean };

export type MechanicProjectHeaderQueryVariables = Exact<{
  mechanicProjectId: Scalars['Int'];
}>;


export type MechanicProjectHeaderQuery = { mechanicProject: MechanicProjectHeaderFragment };

export type MechanicProjectHeaderFragment = { id: number, firstName: string, lastName: string, provisionalOperatorNames?: Maybe<string>, projectCreationDate: any, isOnHold: boolean, isOnHoldByDca: boolean, dcaHoldReason?: Maybe<string>, isDcaInvoiced: boolean, isArgInvoiced: boolean, dcaSubmissionDate?: Maybe<any>, mechanic: { id: number }, mechanicProjectType: { name: string }, operators: Array<{ company: { name: string } }>, projectStatus: { id: number, name: string }, projectStage: { id: number, name: string }, projectCreatedByUser: { firstName?: Maybe<string>, lastName?: Maybe<string> }, assignees: Array<{ id: number }> };

export type MechanicProjectCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MechanicProjectCommentsQuery = { mechanicProjectComments: CommentsFragment };

export type MechanicProjectSendToDcaCheckQueryVariables = Exact<{
  mechanicProjectId: Scalars['Int'];
}>;


export type MechanicProjectSendToDcaCheckQuery = { mechanicProjectInsForms: Array<SendToDcaCheckFragment> };

export type MechanicProjectReopenByDcaOpenProjectsCheckQueryVariables = Exact<{
  mechanicId: Scalars['Int'];
  projectStatusIdNotIn: Array<Scalars['Int']>;
}>;


export type MechanicProjectReopenByDcaOpenProjectsCheckQuery = { mechanicProjects: { mechanicProjects: Array<{ id: number }> } };

export type AddMechanicProjectCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddMechanicProjectCommentMutation = { addMechanicProjectComment: CommentFragment };

export type UpdateMechanicProjectCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateMechanicProjectCommentMutation = { updateMechanicProjectComment: CommentFragment };

export type MechanicProjectDcaCommentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MechanicProjectDcaCommentsQuery = { mechanicProjectDcaComments: CommentsFragment };

export type AddMechanicProjectDcaCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddMechanicProjectDcaCommentMutation = { addMechanicProjectDcaComment: CommentFragment };

export type UpdateMechanicProjectDcaCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateMechanicProjectDcaCommentMutation = { updateMechanicProjectDcaComment: CommentFragment };

export type HoldMechanicProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type HoldMechanicProjectMutation = { holdMechanicProject: { id: number } };

export type ReleaseMechanicProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ReleaseMechanicProjectMutation = { releaseMechanicProject: { id: number } };

export type DcaHoldMechanicProjectMutationVariables = Exact<{
  input: DcaHoldMechanicProjectInput;
}>;


export type DcaHoldMechanicProjectMutation = { dcaHoldMechanicProject: { id: number } };

export type DcaReleaseMechanicProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DcaReleaseMechanicProjectMutation = { dcaReleaseMechanicProject: { id: number } };

export type DeleteMechanicProjectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteMechanicProjectMutation = { deleteMechanicProject: { id: number } };

export type TransitionMechanicProjectMutationVariables = Exact<{
  input: TransitionProjectInput;
}>;


export type TransitionMechanicProjectMutation = { transitionMechanicProject: { id: number, projectStatus: { id: number } } };

export type SendMechanicProjectBackToIasoMutationVariables = Exact<{
  input: SendMechanicProjectToIasoInput;
}>;


export type SendMechanicProjectBackToIasoMutation = { sendMechanicProjectBackToIaso: { id: number } };

export type CompleteMechanicProjectTaskMutationVariables = Exact<{
  input: CompleteMechanicProjectTaskInput;
}>;


export type CompleteMechanicProjectTaskMutation = { completeMechanicProjectTask: { id: number } };

export type SendMechanicProjectInsFormVersionForExecutionMutationVariables = Exact<{
  input: SendForExecutionInput;
}>;


export type SendMechanicProjectInsFormVersionForExecutionMutation = { sendMechanicProjectInsFormVersionForExecution: { id: number } };

export type ResendMechanicProjectInsFormVersionForExecutionMutationVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type ResendMechanicProjectInsFormVersionForExecutionMutation = { resendMechanicProjectInsFormVersionForExecution: { id: number } };

export type RevokeMechanicProjectInsFormVersionExecutionMutationVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type RevokeMechanicProjectInsFormVersionExecutionMutation = { revokeMechanicProjectInsFormVersionExecution: { id: number } };

export type UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateAllMechanicProjectDocumentsReleasedToDcaInput;
}>;


export type UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutation = { updateAllMechanicProjectDocumentsReleasedToDca: boolean };

export type MechanicProjectCertificateInformationFragment = { id: number, firstName: string, lastName: string, certificateFirstIssuedDate?: Maybe<any>, validationNumber?: Maybe<string>, validationRestrictedTo?: Maybe<string>, certificateDateOfIssue?: Maybe<any>, certificateExpiryDate?: Maybe<any>, licenseNumber: string, dcaMechanicRatingsList?: Maybe<string>, dcaAircraftList?: Maybe<string>, dcaSubmissionDate?: Maybe<any>, dcaAuthorizationLimitedTo?: Maybe<string>, dcaValidationIssueBasedOnLine1?: Maybe<string>, dcaValidationIssueBasedOnLine2?: Maybe<string>, turnaroundDays?: Maybe<number>, dcaLastUpdatedDate?: Maybe<any>, projectStatusId: number, dcaProjectNumber?: Maybe<string>, certificateType: { id: number, description?: Maybe<string> }, country: { id: number, name: string }, mechanicProjectType: { id: number, abbreviation: string, name: string }, mechanicPosition: { id: number, name: string }, mechanicProjectRenewalTypes: Array<{ abbreviation: string, name: string }>, mechanicLicenseType: { id: number, description?: Maybe<string> }, assignees: Array<UserFragment>, dcaReviewerUser?: Maybe<UserFragment>, dcaSentForApprovalByUser?: Maybe<UserFragment>, dcaApprovedByUser?: Maybe<UserFragment> };

export type MechanicProjectCertificateInformationQueryVariables = Exact<{
  mechanicProjectId: Scalars['Int'];
}>;


export type MechanicProjectCertificateInformationQuery = { mechanicProjectCertificate: MechanicProjectCertificateInformationFragment, mechanicProject: { provisionalOperatorNames?: Maybe<string> } };

export type UpdateMechanicProjectCertificateMutationVariables = Exact<{
  input: UpdateMechanicProjectCertificateInput;
  recordHistory?: Maybe<Scalars['Boolean']>;
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateMechanicProjectCertificateMutation = { updateMechanicProjectCertificate: { warnings?: Maybe<Array<string>>, mechanicProjectCertificate?: Maybe<MechanicProjectCertificateInformationFragment> } };

export type MechanicProjectDcaReviewerUsersQueryVariables = Exact<{
  includeId?: Maybe<Scalars['Int']>;
}>;


export type MechanicProjectDcaReviewerUsersQuery = { dcaProjectApprovers: Array<UserFragment> };

export type MechanicProjectDcaSentForApprovalByUsersQueryVariables = Exact<{
  includeId?: Maybe<Scalars['Int']>;
}>;


export type MechanicProjectDcaSentForApprovalByUsersQuery = { dcaProjectApprovers: Array<UserFragment> };

export type MechanicProjectDcaApprovedByUsersQueryVariables = Exact<{
  includeId?: Maybe<Scalars['Int']>;
}>;


export type MechanicProjectDcaApprovedByUsersQuery = { dcaProjectApprovers: Array<UserFragment> };

export type MechanicProjectFormsTabQueryVariables = Exact<{
  mechanicProjectId: Scalars['Int'];
}>;


export type MechanicProjectFormsTabQuery = { mechanicProject: { canToggleInsFormDcaApproved: boolean }, mechanicProjectInsForms: Array<ProjectInsFormVersionFragment>, mechanicProjectInsFormsExclusiveGroups: Array<ProjectInsFormVersionExclusiveGroupFragment> };

export type MechanicProjectInsFormFieldValuesAndCommentsQueryQueryVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type MechanicProjectInsFormFieldValuesAndCommentsQueryQuery = { fieldValues: Array<ProjectInsFormVersionFieldValueFragment>, fieldComments: Array<ProjectInsFormVersionFieldCommentFragment> };

export type MechanicProjectInsFormFieldValuesOnlyQueryQueryVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type MechanicProjectInsFormFieldValuesOnlyQueryQuery = { fieldValues: Array<ProjectInsFormVersionFieldValueFragment> };

export type DownloadMechanicProjectUploadedInsFormQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadMechanicProjectUploadedInsFormQuery = { file?: Maybe<DownloadFileFragment> };

export type DownloadMechanicProjectFilledInInsFormQueryVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
}>;


export type DownloadMechanicProjectFilledInInsFormQuery = { file?: Maybe<DownloadFileFragment> };

export type UpdateMechanicProjectInsFormTrgApprovalMutationMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionTrgApprovalInput;
}>;


export type UpdateMechanicProjectInsFormTrgApprovalMutationMutation = { updateMechanicProjectInsFormTrgApproval: ProjectInsFormVersionFragment };

export type UpdateMechanicProjectInsFormFileAttachmentMutationMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionFileAttachmentInput;
}>;


export type UpdateMechanicProjectInsFormFileAttachmentMutationMutation = { updateMechanicProjectInsFormFileAttachment: ProjectInsFormVersionFragment };

export type UpdateMechanicProjectInsFormReleasedToDcaMutationMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionReleasedToDcaInput;
}>;


export type UpdateMechanicProjectInsFormReleasedToDcaMutationMutation = { updateMechanicProjectInsFormReleasedToDca: ProjectInsFormVersionFragment };

export type UpdateMechanicProjectInsFormFieldValuesMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionFieldValuesInput;
}>;


export type UpdateMechanicProjectInsFormFieldValuesMutation = { updateMechanicProjectInsFormFieldValues: boolean };

export type UpdateMechanicProjectInsFormFieldCommentMutationVariables = Exact<{
  input: UpdateProjectInsFormVersionFieldCommentInput;
}>;


export type UpdateMechanicProjectInsFormFieldCommentMutation = { updateMechanicProjectInsFormFieldComment: boolean };

export type UpdateMechanicProjectInsFormIsDcaApprovedMutationVariables = Exact<{
  input: UpdateProjectInsFormIsDcaApprovedInput;
}>;


export type UpdateMechanicProjectInsFormIsDcaApprovedMutation = { updateMechanicProjectInsFormIsDcaApproved: boolean };

export type AddMechanicProjectInsFormVersionCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CommentInput;
}>;


export type AddMechanicProjectInsFormVersionCommentMutation = { addMechanicProjectInsFormVersionComment: CommentFragment };

export type UpdateMechanicProjectInsFormVersionCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  body: Scalars['String'];
}>;


export type UpdateMechanicProjectInsFormVersionCommentMutation = { updateMechanicProjectInsFormVersionComment: CommentFragment };

export type ClearMechanicProjectInsFormVersionSignatureByIdMutationVariables = Exact<{
  projectInsFormVersionId: Scalars['Int'];
  fieldNumber: Scalars['Int'];
}>;


export type ClearMechanicProjectInsFormVersionSignatureByIdMutation = { clearMechanicProjectInsFormVersionSignatureById: boolean };

export type MechanicProjectEmailHistoryQueryVariables = Exact<{
  mechanicProjectId: Scalars['Int'];
  sortBy?: Maybe<EmailHistorySortBy>;
  sortDirection?: Maybe<SortDirection>;
}>;


export type MechanicProjectEmailHistoryQuery = { mechanicProjectEmailHistory: Array<EmailHistoryFragment> };

export type MechanicProjectHistoryQueryVariables = Exact<{
  mechanicProjectId: Scalars['Int'];
}>;


export type MechanicProjectHistoryQuery = { mechanicProjectHistory: Array<ProjectHistoryFragment> };

export type MechanicProjectSummaryTabQueryVariables = Exact<{
  mechanicProjectId: Scalars['Int'];
}>;


export type MechanicProjectSummaryTabQuery = { mechanicProject: { id: number, firstName: string, lastName: string, licenseNumber: string, validationNumber?: Maybe<string>, provisionalOperatorNames?: Maybe<string>, provisionalAircraftRegistrationMarks?: Maybe<string>, isHighImportance: boolean, isOnHold: boolean, isOnHoldByDca: boolean, dcaHoldReason?: Maybe<string>, projectCreationDate: any, isNoDcaInvoiceRequired: boolean, mechanicProjectType: { id: number, name: string }, mechanicProjectRenewalTypes: Array<{ id: number, name: string }>, projectStatus: { id: number }, country: { id: number, name: string }, mechanicLicenseType: { id: number, name: string }, mechanicPosition: { id: number, name: string }, operators: Array<{ id: number, company: { name: string } }>, aircrafts: Array<{ id: number, registrationMark: string, aircraftModel?: Maybe<{ id: number, name: string }> }>, assignees: Array<(
      { id: number, firstName?: Maybe<string>, lastName?: Maybe<string> }
      & UserFragment
    )>, projectCreatedByUser: { id: number, firstName?: Maybe<string>, lastName?: Maybe<string> }, dcaReviewerUser?: Maybe<UserFragment>, documents: Array<{ id: number, isReleasedToDca: boolean, document: { documentType: { id: number, isAlwaysVisibleToDca: boolean }, fileAttachment: { fileName: string, fileSizeBytes: number, mimeType: string } } }> }, dcaHistory: Array<{ performedByName: string, date: any, projectStatus?: Maybe<{ id: number, name: string }>, projectTransition?: Maybe<{ id: number, name: string }> }> };

export type MechanicProjectOfficialLetterNotesQueryVariables = Exact<{
  mechanicProjectId: Scalars['Int'];
}>;


export type MechanicProjectOfficialLetterNotesQuery = { mechanicProject: { officialLetterDocumentsNote?: Maybe<string>, documentTypeOfficialLetterNotes: Array<{ officialLetterNote?: Maybe<string>, documentType: { id: number, name: string } }> } };

export type UpdateMechanicProjectOfficialLetterDocumentNotesMutationVariables = Exact<{
  input: UpdateMechanicProjectOfficialLetterNotesInput;
}>;


export type UpdateMechanicProjectOfficialLetterDocumentNotesMutation = { updateMechanicProjectOfficialLetterDocumentNotes: { id: number } };

export type SendMechanicProjectEmailMutationVariables = Exact<{
  mechanicProjectId: Scalars['Int'];
  email: EmailInput;
}>;


export type SendMechanicProjectEmailMutation = { sendMechanicProjectEmail: { id: number } };

export type UpdateMechanicProjectCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateMechanicProjectCommentsLastViewedDateMutation = { updateMechanicProjectCommentsLastViewedDate: { id: number } };

export type UpdateMechanicProjectDcaCommentsLastViewedDateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateMechanicProjectDcaCommentsLastViewedDateMutation = { updateMechanicProjectDcaCommentsLastViewedDate: { id: number } };

export type MechanicProjectAssignableUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type MechanicProjectAssignableUsersQuery = { mechanicProjectAssignableUsers: Array<UserFragment> };

export type SetMechanicProjectAssigneesMutationVariables = Exact<{
  mechanicProjectId: Scalars['Int'];
  assigneeUserIds: Array<Scalars['Int']>;
}>;


export type SetMechanicProjectAssigneesMutation = { setMechanicProjectAssignees: { id: number } };

export type SetMechanicProjectPriorityMutationVariables = Exact<{
  id: Scalars['Int'];
  isHighPriority: Scalars['Boolean'];
}>;


export type SetMechanicProjectPriorityMutation = { setMechanicProjectPriority: { id: number } };

export type SetMechanicProjectNoDcaInvoiceRequiredFlagMutationVariables = Exact<{
  id: Scalars['Int'];
  isNoDcaInvoiceRequired: Scalars['Boolean'];
}>;


export type SetMechanicProjectNoDcaInvoiceRequiredFlagMutation = { setMechanicProjectNoDcaInvoiceRequiredFlag: boolean };

export type MechanicProjectEmailViewQueryVariables = Exact<{
  id: Scalars['Int'];
  emailId: Scalars['Int'];
  includeFileAttachments?: Maybe<Scalars['Boolean']>;
  includeFileContent?: Maybe<Scalars['Boolean']>;
}>;


export type MechanicProjectEmailViewQuery = { mechanicProject: { emails: Array<EmailFragment> } };

export type DownloadMechanicProjectEmailAttachmentContentQueryVariables = Exact<{
  mechanicProjectId: Scalars['Int'];
  emailId: Scalars['Int'];
  attachmentId: Scalars['Int'];
}>;


export type DownloadMechanicProjectEmailAttachmentContentQuery = { downloadMechanicProjectEmailAttachmentContent?: Maybe<string> };

export type MechanicProjectMechanicRatingFragment = { id: number, name: string, isDeleted: boolean };

export type MechanicProjectAircraftFragment = { id: number, registrationMark: string, aircraftStatus: { id: number }, operator?: Maybe<{ id: number }> };

export type MechanicProjectOperatorFragment = { id: number, isActive: boolean, isDeleted: boolean, company: { name: string, isActive: boolean } };

export type MechanicProjectEmploymentCompanyFragment = { id: number, name: string, isDeleted: boolean };

export type MechanicProjectApplicationTabQueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MechanicProjectApplicationTabQueryQuery = { mechanicProject: { id: number, certificateFirstIssuedDate?: Maybe<any>, certificateDateOfIssue?: Maybe<any>, validationNumber?: Maybe<string>, certificateExpiryDate?: Maybe<any>, clientSubmissionDate?: Maybe<any>, dcaSubmissionDate?: Maybe<any>, firstName: string, lastName: string, licenseNumber: string, provisionalOperatorNames?: Maybe<string>, provisionalAircraftRegistrationMarks?: Maybe<string>, mechanicProjectType: { id: number, name: string }, mechanicProjectRenewalTypes: Array<{ id: number }>, mechanicPosition: { id: number }, country: { id: number }, mechanicLicenseType: { id: number }, operators: Array<MechanicProjectOperatorFragment>, employmentCompanies: Array<MechanicProjectEmploymentCompanyFragment>, mechanicRatings: Array<MechanicProjectMechanicRatingFragment>, aircrafts: Array<MechanicProjectAircraftFragment>, associatedAircraftProject?: Maybe<{ id: number }> }, mechanicPositions: Array<MechanicProjectMechanicPositionFragment>, employmentCompanies: Array<MechanicProjectEmploymentCompanyFragment>, mechanicRatings: Array<MechanicProjectMechanicRatingFragment>, operators: { operators: Array<MechanicProjectOperatorFragment> } };

export type UpdateMechanicProjectMutationMutationVariables = Exact<{
  updateMechanicProjectInput: UpdateMechanicProjectInput;
  recordHistory?: Maybe<Scalars['Boolean']>;
  ignoreWarnings?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateMechanicProjectMutationMutation = { updateMechanicProject: { warnings?: Maybe<Array<string>> } };

export type OperatorGridItemFragment = { id: number, numberOfNonInactiveAircraft: number, isActive: boolean, company: CompanyDetailFragment, aircraft: Array<{ id: number, registrationMark: string, aircraftStatus: { id: number } }> };

export type OperatorDetailFragment = { id: number, isActive: boolean, includeInReminderEmails: boolean, company: CompanyDetailFragment };

export type OperatorGridFilterLookupsQueryVariables = Exact<{ [key: string]: never; }>;


export type OperatorGridFilterLookupsQuery = { countries: Array<CountryLookupFragment>, regions: Array<RegionLookupFragment> };

export type OperatorGridQueryVariables = Exact<{
  sortBy?: Maybe<OperatorsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  nameContains?: Maybe<Scalars['String']>;
  countryIdIn?: Maybe<Array<Scalars['Int']>>;
  regionIdIn?: Maybe<Array<Scalars['Int']>>;
  hasActiveAircraft?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type OperatorGridQuery = { operators: { operators: Array<OperatorGridItemFragment> } | { totalItems: number, operators: Array<OperatorGridItemFragment> } };

export type OperatorDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type OperatorDetailQuery = { operator: OperatorDetailFragment };

export type AddOperatorMutationVariables = Exact<{
  input: OperatorInput;
}>;


export type AddOperatorMutation = { addOperator: { id: number, company: { id: number, name: string } } };

export type UpdateOperatorMutationVariables = Exact<{
  id: Scalars['Int'];
  input: OperatorInput;
}>;


export type UpdateOperatorMutation = { updateOperator: { id: number, company: { id: number, name: string } } };

export type OperatorDocumentTypesQueryQueryVariables = Exact<{
  companyId: Scalars['Int'];
  documentTypeCategoryId: DocumentTypeCategoryEnum;
}>;


export type OperatorDocumentTypesQueryQuery = { documentTypes: Array<DocumentTypeFragment> };

export type OperatorAddCrewProjectCrewMemberDetailQueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type OperatorAddCrewProjectCrewMemberDetailQueryQuery = { crewMember: { id: number, firstName: string, lastName: string, licenseNumber: string, crewPosition: { id: number }, country: { id: number }, crewLicenseType: { id: number } } };

export type OperatorAddCrewProjectMutationMutationVariables = Exact<{
  operatorAddCrewProjectInput: OperatorAddCrewProjectInput;
}>;


export type OperatorAddCrewProjectMutationMutation = { operatorAddCrewProject: { id: number } };

export type OperatorAddCrewProjectSubmittedMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type OperatorAddCrewProjectSubmittedMutationMutation = { operatorAddCrewProjectSubmitted: { id: number } };

export type OperatorAddMechanicProjectMechanicDetailQueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type OperatorAddMechanicProjectMechanicDetailQueryQuery = { mechanic: { id: number, firstName: string, lastName: string, licenseNumber: string, mechanicPosition: { id: number }, country: { id: number }, mechanicLicenseType: { id: number } } };

export type OperatorAddMechanicProjectMutationMutationVariables = Exact<{
  operatorAddMechanicProjectInput: OperatorAddMechanicProjectInput;
}>;


export type OperatorAddMechanicProjectMutationMutation = { operatorAddMechanicProject: { id: number } };

export type OperatorAddMechanicProjectSubmittedMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type OperatorAddMechanicProjectSubmittedMutationMutation = { operatorAddMechanicProjectSubmitted: { id: number } };

export type OperatorDashboardCrewMembersReportItemFragment = { id: number, firstName: string, lastName: string, validationNumber?: Maybe<string>, licenseNumber: string, certificateExpiryDate?: Maybe<any>, crewPosition: { name: string }, crewLicenseType: { name: string }, country: { name: string }, aircrafts: Array<{ registrationMark: string, aircraftStatus: { id: number } }>, operators: Array<{ isActive: boolean, company: { name: string } }>, activeCrewProjects: Array<{ id: number }> };

export type OperatorDashboardCrewMembersReportQueryVariables = Exact<{
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  hasCertificationExpiryDate?: Maybe<Scalars['Boolean']>;
  sortBy?: Maybe<CrewMembersSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type OperatorDashboardCrewMembersReportQuery = { crewMembers: { crewMembers: Array<OperatorDashboardCrewMembersReportItemFragment> } | { totalItems: number, crewMembers: Array<OperatorDashboardCrewMembersReportItemFragment> } };

export type OperatorDashboardAircraftReportItemFragment = { id: number, registrationMark: string, certificateOfAirworthinessExpirationDate?: Maybe<any>, certificateOfRegistrationExpirationDate?: Maybe<any>, certificateOfInsuranceExpirationDate?: Maybe<any>, leaseAgreementExpirationDate?: Maybe<any>, managementAgreementExpirationDate?: Maybe<any>, aircraftStatus: { id: number, name: string }, aircraftModel?: Maybe<{ name: string }>, owner?: Maybe<{ company: { name: string } }>, operator?: Maybe<{ company: { name: string } }> };

export type OperatorDashboardAircraftReportQueryVariables = Exact<{
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  hasCertificateOfAirworthinessExpirationDate?: Maybe<Scalars['Boolean']>;
  hasCertificateOfRegistrationExpirationDate?: Maybe<Scalars['Boolean']>;
  hascertificateOfInsuranceExpirationDate?: Maybe<Scalars['Boolean']>;
  hasLeaseAgreementExpirationDate?: Maybe<Scalars['Boolean']>;
  hasManagementAgreementExpirationDate?: Maybe<Scalars['Boolean']>;
  sortBy?: Maybe<AircraftsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type OperatorDashboardAircraftReportQuery = { aircrafts: { aircrafts: Array<OperatorDashboardAircraftReportItemFragment> } | { totalItems: number, aircrafts: Array<OperatorDashboardAircraftReportItemFragment> } };

export type OperatorDashboardMechanicsReportItemFragment = { id: number, firstName: string, lastName: string, validationNumber?: Maybe<string>, licenseNumber: string, certificateExpiryDate?: Maybe<any>, mechanicPosition: { name: string }, mechanicLicenseType: { name: string }, country: { name: string }, aircrafts: Array<{ registrationMark: string, aircraftStatus: { id: number } }>, operators: Array<{ isActive: boolean, company: { name: string } }>, activeMechanicProjects: Array<{ id: number }> };

export type OperatorDashboardMechanicsReportQueryVariables = Exact<{
  operatorIdIn?: Maybe<Array<Scalars['Int']>>;
  hasCertificationExpiryDate?: Maybe<Scalars['Boolean']>;
  sortBy?: Maybe<MechanicsSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type OperatorDashboardMechanicsReportQuery = { mechanics: { mechanics: Array<OperatorDashboardMechanicsReportItemFragment> } | { totalItems: number, mechanics: Array<OperatorDashboardMechanicsReportItemFragment> } };

export type NewOperatorContactRequestMutationVariables = Exact<{
  input: NewContactRequestInput;
}>;


export type NewOperatorContactRequestMutation = { sendNewContactRequest: { id: number } };

export type OwnerGridItemFragment = { id: number, isActive: boolean, company: CompanyDetailFragment, aircraft: Array<{ id: number, registrationMark: string, aircraftStatus: { id: number } }> };

export type OwnerDetailFragment = { id: number, isActive: boolean, company: CompanyDetailFragment };

export type OwnerGridFilterLookupsQueryVariables = Exact<{ [key: string]: never; }>;


export type OwnerGridFilterLookupsQuery = { countries: Array<CountryLookupFragment>, regions: Array<RegionLookupFragment> };

export type OwnerGridQueryVariables = Exact<{
  sortBy?: Maybe<OwnersSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  nameContains?: Maybe<Scalars['String']>;
  countryIdIn?: Maybe<Array<Scalars['Int']>>;
  regionIdIn?: Maybe<Array<Scalars['Int']>>;
  isActive?: Maybe<Scalars['Boolean']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type OwnerGridQuery = { owners: { owners: Array<OwnerGridItemFragment> } | { totalItems: number, owners: Array<OwnerGridItemFragment> } };

export type OwnerDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type OwnerDetailQuery = { owner: OwnerDetailFragment };

export type AddOwnerMutationVariables = Exact<{
  input: OwnerInput;
}>;


export type AddOwnerMutation = { addOwner: { id: number, company: { id: number, name: string } } };

export type UpdateOwnerMutationVariables = Exact<{
  id: Scalars['Int'];
  input: OwnerInput;
}>;


export type UpdateOwnerMutation = { updateOwner: { id: number, company: { id: number, name: string } } };

export type OwnerDocumentTypesQueryQueryVariables = Exact<{
  companyId: Scalars['Int'];
  documentTypeCategoryId: DocumentTypeCategoryEnum;
}>;


export type OwnerDocumentTypesQueryQuery = { documentTypes: Array<DocumentTypeFragment> };

export type RegisteredHolderGridItemFragment = { id: number, isActive: boolean, company: CompanyDetailFragment, aircraft: Array<{ id: number, registrationMark: string, aircraftStatus: { id: number } }> };

export type RegisteredHolderDetailFragment = { id: number, isActive: boolean, company: CompanyDetailFragment };

export type RegisteredHolderGridFilterLookupsQueryVariables = Exact<{ [key: string]: never; }>;


export type RegisteredHolderGridFilterLookupsQuery = { countries: Array<CountryLookupFragment>, regions: Array<RegionLookupFragment> };

export type RegisteredHolderGridQueryVariables = Exact<{
  sortBy?: Maybe<RegisteredHoldersSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  nameContains?: Maybe<Scalars['String']>;
  countryIdIn?: Maybe<Array<Scalars['Int']>>;
  regionIdIn?: Maybe<Array<Scalars['Int']>>;
  isActive?: Maybe<Scalars['Boolean']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type RegisteredHolderGridQuery = { registeredHolders: { totalItems: number, registeredHolders: Array<RegisteredHolderGridItemFragment> } | { registeredHolders: Array<RegisteredHolderGridItemFragment> } };

export type RegisteredHolderDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RegisteredHolderDetailQuery = { registeredHolder: RegisteredHolderDetailFragment };

export type AddRegisteredHolderMutationVariables = Exact<{
  input: RegisteredHolderInput;
}>;


export type AddRegisteredHolderMutation = { addRegisteredHolder: { id: number, company: { id: number, name: string } } };

export type UpdateRegisteredHolderMutationVariables = Exact<{
  id: Scalars['Int'];
  input: RegisteredHolderInput;
}>;


export type UpdateRegisteredHolderMutation = { updateRegisteredHolder: { id: number, company: { id: number, name: string } } };

export type RegisteredHolderDocumentTypesQueryQueryVariables = Exact<{
  companyId: Scalars['Int'];
  documentTypeCategoryId: DocumentTypeCategoryEnum;
}>;


export type RegisteredHolderDocumentTypesQueryQuery = { documentTypes: Array<DocumentTypeFragment> };

export type UserGridItemFragment = { id: number, firstName?: Maybe<string>, lastName?: Maybe<string>, isActive: boolean, role?: Maybe<{ id: number, name: string }>, operator?: Maybe<{ id: number, company: { id: number, name: string } }>, inspector?: Maybe<{ id: number }>, emailAddresses: Array<{ id: number, emailAddress: string }> };

export type UserRoleFragment = { id: number, name: string };

export type UserGridFilterLookupsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UserGridFilterLookupsQueryQuery = { roles: Array<UserRoleFragment> };

export type UserGridQueryVariables = Exact<{
  roleIdIn?: Maybe<Array<Scalars['Int']>>;
  isActive?: Maybe<Scalars['Boolean']>;
  sortBy?: Maybe<UsersSortBy>;
  sortDirection?: Maybe<Scalars['String']>;
  paginationOptions?: Maybe<PaginationOptions>;
}>;


export type UserGridQuery = { users: { totalItems: number, users: Array<UserGridItemFragment> } | { users: Array<UserGridItemFragment> } };

export type UserGridCompanyContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserGridCompanyContactsQuery = { companyContacts: Array<ContactFragment> };

export type UserDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UserDetailQuery = { user: { id: number, firstName?: Maybe<string>, lastName?: Maybe<string>, initials?: Maybe<string>, userName?: Maybe<string>, jobTitle?: Maybe<string>, isActive: boolean, notes?: Maybe<string>, signatureName?: Maybe<string>, departmentRoleId?: Maybe<number>, isMaintenanceInspector: boolean, isMechanicProjectDcaReviewerUser: boolean, isMechanicProjectDcaSentForApprovalByUser: boolean, isMechanicProjectDcaApprovedByUser: boolean, canCancelMechanicProjects: boolean, role?: Maybe<{ id: number }>, emailAddresses: Array<{ id: number, emailAddressTypeId: number, emailAddress: string }>, phoneNumbers: Array<{ id: number, phoneNumberTypeId: number, phoneNumber: string }>, signatureImageFileAttachment?: Maybe<{ mimeType: string, content: string }>, department?: Maybe<{ id: number }> } };

export type AddUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type AddUserMutation = { addUser: { id: number } };

export type UpdateUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type UpdateUserMutation = { updateUser: { id: number } };

export const DocumentForDocumentListsFragmentDoc = gql`
    fragment documentForDocumentLists on Document {
  name
  documentType {
    id
    isAlwaysVisibleToDca
    documentTypeCategory {
      id
    }
  }
  isSystemGenerated
  documentValidity {
    id
    name
  }
  issueDate
  expirationDate
  fileAttachment {
    fileName
    fileSizeBytes
    mimeType
    uploadedByUser {
      firstName
      lastName
    }
    uploadedDate
  }
  isAutoRenew
  isIndefiniteExpiration
}
    `;
export const CompanyDocumentFragmentDoc = gql`
    fragment companyDocument on CompanyDocument {
  id
  isArchived
  document {
    ...documentForDocumentLists
  }
}
    ${DocumentForDocumentListsFragmentDoc}`;
export const DownloadFileFragmentDoc = gql`
    fragment downloadFile on DownloadFile {
  fileName
  fileSizeBytes
  mimeType
  base64Content
}
    `;
export const FunctionalGroupFragmentDoc = gql`
    fragment functionalGroup on FunctionalGroup {
  id
  name
  sortOrder
}
    `;
export const RoleFragmentDoc = gql`
    fragment role on Role {
  id
  name
}
    `;
export const InspectionStatusFragmentDoc = gql`
    fragment inspectionStatus on InspectionStatus {
  id
  name
  isDeleted
}
    `;
export const InspectorLookupFragmentDoc = gql`
    fragment inspectorLookup on Inspector {
  id
  user {
    firstName
    lastName
    userName
    emailAddresses {
      emailAddress
    }
  }
  isActive
}
    `;
export const InspectionHistoryGridItemFragmentDoc = gql`
    fragment inspectionHistoryGridItem on InspectorInspection {
  id
  inspector {
    user {
      firstName
      lastName
    }
  }
  inspection {
    validityPeriod
    inspectionStatus {
      id
      name
    }
    otherStatusText
    letterOfFindingsFileAttachment {
      fileName
    }
    insForm4001FileAttachment {
      fileName
    }
    aircraftProjectOperatorInspection {
      aircraftProject {
        id
      }
    }
  }
  country {
    id
    name
    region {
      id
      name
    }
  }
  state {
    name
  }
  city
  startDate
  endDate
}
    `;
export const ProjectInsFormVersionFragmentDoc = gql`
    fragment projectInsFormVersion on ProjectInsFormVersion {
  id
  exclusiveGroupNumber
  insFormVersion {
    id
    insForm {
      name
      title
      isHiddenFromDcaUsers
      isSendForExecutionSupported
      willBeEmailedWhenSigned
      generatedDocumentType {
        name
        documentTypeCategory {
          id
          name
        }
      }
    }
    fields {
      fieldNumber
      isSignatureField
      signatoryRoleId
    }
  }
  isOptional
  isTrgApproved
  isReleasedToDca
  uploadedFileAttachment {
    fileName
    fileSizeBytes
    mimeType
  }
  generatedDocumentFileAttachment {
    fileName
    fileSizeBytes
    mimeType
  }
  fieldCommentCount
  hasFieldValues
  totalNewFormComments
  insFormExecutionState {
    id
    name
  }
  projectType {
    id
    shortName
  }
  executionKeys {
    sentToUserEmailAddress {
      emailAddress
    }
  }
  isSignedByDca
  isFullySigned
  isDcaApproved
  dcaApprovalDate
  dcaApprovalByUser {
    id
    displayName
  }
}
    `;
export const ProjectInsFormVersionExclusiveGroupFragmentDoc = gql`
    fragment projectInsFormVersionExclusiveGroup on ProjectInsFormVersionExclusiveGroup {
  exclusiveGroupNumber
  startedProjectInsFormVersion {
    id
    insFormVersion {
      insForm {
        name
      }
    }
  }
  otherProjectInsFormVersions {
    id
    insFormVersion {
      insForm {
        name
      }
    }
  }
}
    `;
export const ProjectInsFormVersionFieldValueFragmentDoc = gql`
    fragment projectInsFormVersionFieldValue on ProjectInsFormVersionFieldValue {
  insFormVersionField {
    fieldNumber
  }
  signedByUser {
    id
    userName
    displayName
  }
  text
}
    `;
export const ProjectInsFormVersionFieldCommentFragmentDoc = gql`
    fragment projectInsFormVersionFieldComment on ProjectInsFormVersionFieldComment {
  insFormVersionField {
    fieldNumber
  }
}
    `;
export const CommentFragmentDoc = gql`
    fragment comment on Comment {
  id
  body
  parentCommentId
  postedBy {
    id
    name
  }
  date
  isVisibleToIaso
}
    `;
export const CommentsFragmentDoc = gql`
    fragment comments on Comments {
  totalComments
  totalNewComments
  comments {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export const DocumentTypeFragmentDoc = gql`
    fragment documentType on DocumentType {
  id
  name
  isIssueDateApplicable
  isIssueDateRequired
  isExpirationDateApplicable
  isExpirationDateRequired
  expirationDateThresholdDays
  isAutoRenewAllowed
  isIndefiniteExpirationAllowed
  isAlwaysVisibleToDca
  documentTypeCategory {
    id
  }
}
    `;
export const AssociatedDocumentTypeFragmentDoc = gql`
    fragment associatedDocumentType on InsFormAssociatedDocumentType {
  isDeleted
  isOptional
  sortOrder
  documentType {
    ...documentType
  }
  insFormAssociatedDocumentGroup {
    id
  }
}
    ${DocumentTypeFragmentDoc}`;
export const ProjectInsFormAssociatedDocumentTypesFragmentDoc = gql`
    fragment projectInsFormAssociatedDocumentTypes on ProjectInsFormVersion {
  insFormVersion {
    insForm {
      id
      name
      title
      associatedDocumentTypes {
        ...associatedDocumentType
      }
    }
  }
}
    ${AssociatedDocumentTypeFragmentDoc}`;
export const RegionLookupFragmentDoc = gql`
    fragment regionLookup on Region {
  id
  name
  isDeleted
}
    `;
export const CountryLookupFragmentDoc = gql`
    fragment countryLookup on Country {
  id
  name
  region {
    id
  }
  isDeleted
}
    `;
export const StateLookupFragmentDoc = gql`
    fragment stateLookup on State {
  id
  name
  country {
    id
  }
  isDeleted
}
    `;
export const EmailHistoryFragmentDoc = gql`
    fragment emailHistory on EmailHistoryRecord {
  id
  to
  sentByUser {
    displayName
    firstName
    lastName
  }
  subject
  date
  isHighImportance
  hasAttachments
  hasErrorMessage
}
    `;
export const FileAttachmentFragmentDoc = gql`
    fragment fileAttachment on FileAttachment {
  fileName
  fileSizeBytes
  mimeType
  content @include(if: $includeFileContent)
}
    `;
export const EmailFragmentDoc = gql`
    fragment email on Email {
  id
  sentByUser {
    displayName
    firstName
    lastName
  }
  to
  cc
  bcc
  subject
  date
  body
  isHighImportance
  emailAttachments @include(if: $includeFileAttachments) {
    id
    fileAttachment {
      ...fileAttachment
    }
  }
  errorMessage
}
    ${FileAttachmentFragmentDoc}`;
export const ProjectHistoryFragmentDoc = gql`
    fragment projectHistory on ProjectHistoryRecord {
  id
  description
  performedByName
  date
}
    `;
export const ContactFragmentDoc = gql`
    fragment contact on Contact {
  id
  userId
  firstName
  lastName
  jobTitle
  userName
  isRoleAdmin
  functionalGroup {
    id
  }
  emailAddresses {
    id
    emailAddressTypeId
    emailAddress
  }
  phoneNumbers {
    id
    phoneNumberTypeId
    phoneNumber
  }
  address
  city
  zipCode
  region {
    id
    name
  }
  country {
    id
    name
  }
  state {
    id
    name
  }
  isRecipientOfSystemGeneratedEmails
  isActive
  notes
}
    `;
export const PhoneNumberTypeFragmentDoc = gql`
    fragment phoneNumberType on PhoneNumberType {
  id
  name
}
    `;
export const EmailAddressTypeFragmentDoc = gql`
    fragment emailAddressType on EmailAddressType {
  id
  name
}
    `;
export const AircraftStatusFragmentDoc = gql`
    fragment aircraftStatus on AircraftStatus {
  id
  name
  isDeleted
}
    `;
export const AircraftTypeFragmentDoc = gql`
    fragment aircraftType on AircraftType {
  id
  name
  isDeleted
}
    `;
export const AircraftCategoryFragmentDoc = gql`
    fragment aircraftCategory on AircraftCategory {
  id
  name
  isDeleted
}
    `;
export const AircraftClassFragmentDoc = gql`
    fragment aircraftClass on AircraftClass {
  id
  name
  isDeleted
}
    `;
export const AircraftManufacturerFragmentDoc = gql`
    fragment aircraftManufacturer on AircraftManufacturer {
  id
  name
  isDeleted
}
    `;
export const AircraftEngineManufacturerFragmentDoc = gql`
    fragment aircraftEngineManufacturer on AircraftEngineManufacturer {
  id
  name
  isDeleted
}
    `;
export const AircraftPropellerManufacturerFragmentDoc = gql`
    fragment aircraftPropellerManufacturer on AircraftPropellerManufacturer {
  id
  name
  isDeleted
}
    `;
export const AircraftOwnerLookupFragmentDoc = gql`
    fragment aircraftOwnerLookup on Owner {
  id
  company {
    name
    isActive
  }
  isActive
  isDeleted
}
    `;
export const AircraftRegisteredHolderLookupFragmentDoc = gql`
    fragment aircraftRegisteredHolderLookup on RegisteredHolder {
  id
  company {
    name
    isActive
  }
  isActive
  isDeleted
}
    `;
export const CrewRatingFragmentDoc = gql`
    fragment crewRating on CrewRating {
  id
  name
  isDeleted
}
    `;
export const MechanicRatingFragmentDoc = gql`
    fragment mechanicRating on MechanicRating {
  id
  name
  isDeleted
}
    `;
export const InspectionFileAttachmentFragmentDoc = gql`
    fragment inspectionFileAttachment on FileAttachment {
  fileName
  fileSizeBytes
  mimeType
}
    `;
export const InspectorInspectionDetailFragmentDoc = gql`
    fragment inspectorInspectionDetail on InspectorInspection {
  id
  inspector {
    id
    user {
      id
      emailAddresses {
        emailAddress
      }
    }
  }
  country {
    id
    region {
      id
    }
  }
  state {
    id
  }
  city
  startDate
  endDate
  inspectionEstimateFileAttachment {
    ...inspectionFileAttachment
  }
  inspectionInvoiceFileAttachment {
    ...inspectionFileAttachment
  }
  inspectionTimeLogFileAttachment {
    ...inspectionFileAttachment
  }
  isDeleted
}
    ${InspectionFileAttachmentFragmentDoc}`;
export const InspectionDetailForActiveProjectsFragmentDoc = gql`
    fragment inspectionDetailForActiveProjects on Inspection {
  id
  inspectionStatus {
    id
  }
  validityPeriod
  letterOfFindingsFileAttachment {
    ...inspectionFileAttachment
  }
  insForm4001FileAttachment {
    ...inspectionFileAttachment
  }
  insForm4007FileAttachment {
    ...inspectionFileAttachment
  }
  insForm4023BFileAttachment {
    ...inspectionFileAttachment
  }
  insForm4045FileAttachment {
    ...inspectionFileAttachment
  }
  insForm16005AFileAttachment {
    ...inspectionFileAttachment
  }
  inspectorInspections {
    ...inspectorInspectionDetail
  }
  isDeleted
}
    ${InspectionFileAttachmentFragmentDoc}
${InspectorInspectionDetailFragmentDoc}`;
export const InspectionDetailForAllProjectsFragmentDoc = gql`
    fragment inspectionDetailForAllProjects on Inspection {
  id
  inspectionStatus {
    id
  }
  otherStatusText
  validityPeriod
  letterOfFindingsFileAttachment {
    ...inspectionFileAttachment
  }
  insForm4001FileAttachment {
    ...inspectionFileAttachment
  }
  insForm4007FileAttachment {
    ...inspectionFileAttachment
  }
  insForm4023BFileAttachment {
    ...inspectionFileAttachment
  }
  insForm4045FileAttachment {
    ...inspectionFileAttachment
  }
  insForm16005AFileAttachment {
    ...inspectionFileAttachment
  }
  inspectorInspections(includeAllProjects: true) {
    ...inspectorInspectionDetail
  }
  isDeleted
}
    ${InspectionFileAttachmentFragmentDoc}
${InspectorInspectionDetailFragmentDoc}`;
export const SendToDcaCheckFragmentDoc = gql`
    fragment sendToDcaCheck on ProjectInsFormVersion {
  isTrgApproved
  isReleasedToDca
  insFormVersion {
    insForm {
      name
      isHiddenFromDcaUsers
    }
  }
}
    `;
export const CrewProjectTypeFragmentDoc = gql`
    fragment crewProjectType on CrewProjectType {
  id
  name
  isDeleted
}
    `;
export const CrewProjectRenewalChangeTypeFragmentDoc = gql`
    fragment crewProjectRenewalChangeType on CrewProjectRenewalChangeType {
  id
  name
  isDeleted
}
    `;
export const MechanicProjectTypeFragmentDoc = gql`
    fragment mechanicProjectType on MechanicProjectType {
  id
  name
  isDeleted
}
    `;
export const MechanicProjectRenewalChangeTypeFragmentDoc = gql`
    fragment mechanicProjectRenewalChangeType on MechanicProjectRenewalChangeType {
  id
  name
  isDeleted
}
    `;
export const OperatorLookupFragmentDoc = gql`
    fragment operatorLookup on Operator {
  id
  company {
    name
    isActive
  }
  isActive
  isDeleted
}
    `;
export const InsFormAssociatedDocumentGroupFragmentDoc = gql`
    fragment insFormAssociatedDocumentGroup on InsFormAssociatedDocumentGroup {
  id
  name
  sortOrder
}
    `;
export const BannerAlertForHeaderDisplayFragmentDoc = gql`
    fragment bannerAlertForHeaderDisplay on BannerAlert {
  message
  variant
}
    `;
export const AircraftDocumentFragmentDoc = gql`
    fragment aircraftDocument on AircraftOperatorDocument {
  id
  isArchived
  document {
    ...documentForDocumentLists
  }
}
    ${DocumentForDocumentListsFragmentDoc}`;
export const AircraftInsFormAssociatedDocumentFragmentDoc = gql`
    fragment aircraftInsFormAssociatedDocument on AircraftOperatorInsFormAssociatedDocument {
  id
  insForm {
    id
  }
  insFormAssociatedDocumentGroup {
    id
  }
  isArchived
  document {
    ...documentForDocumentLists
  }
}
    ${DocumentForDocumentListsFragmentDoc}`;
export const AircraftModelFragmentDoc = gql`
    fragment aircraftModel on AircraftModel {
  id
  name
  isDeleted
}
    `;
export const BulkUpdateCrewAircraftInfoFragmentDoc = gql`
    fragment bulkUpdateCrewAircraftInfo on Aircraft {
  registrationMark
  operator {
    id
    company {
      name
    }
  }
  aircraftModel {
    ...aircraftModel
  }
}
    ${AircraftModelFragmentDoc}`;
export const BulkUpdateCrewSearchCrewMemberFragmentDoc = gql`
    fragment bulkUpdateCrewSearchCrewMember on CrewMember {
  id
  firstName
  lastName
  crewRatings {
    id
    name
  }
  aircrafts {
    id
    registrationMark
    aircraftStatus {
      id
    }
    aircraftModel {
      id
      name
    }
    operator {
      id
    }
  }
}
    `;
export const AircraftStatusLookupFragmentDoc = gql`
    fragment aircraftStatusLookup on AircraftStatus {
  id
  name
  isDeleted
}
    `;
export const AircraftGridItemFragmentDoc = gql`
    fragment aircraftGridItem on Aircraft {
  id
  registrationMark
  priorRegistrationMarks
  serialNumber
  aircraftModel {
    name
  }
  aircraftType {
    name
  }
  aircraftCategory {
    name
  }
  aircraftClass {
    name
  }
  mtow
  operator {
    company {
      id
      name
    }
    isActive
  }
  owner {
    company {
      id
      name
    }
  }
  registeredHolder {
    company {
      id
      name
    }
  }
  aircraftStatus {
    name
  }
  activeAircraftProjects {
    id
  }
  certificateOfRegistrationExpirationDate
  certificateOfAirworthinessExpirationDate
  exportCertificateOfAirworthinessExpirationDate
  certificateOfInsuranceExpirationDate
  leaseAgreementExpirationDate
  managementAgreementExpirationDate
  baseOfOperationsCountry {
    name
  }
  homeBaseCountry {
    name
  }
  uboName
  uboNationality
  aircraftManufacturer {
    name
  }
  yearOfManufacture
  aircraftEngineManufacturer {
    name
  }
  numberOfPaxSeats
  initialRegistrationDate
  deregistrationDate
  hasModeSCodeDocument
  aircraftOperationalApproval {
    rvsm
    nat_hla_rvsm
    rnp_ar
    rnp_apch
    rnav1
    rnav2
    rnav5
    basicRnp1
    rnp4
    rnp10
    gps
    lvto
    cat1
    cat2
    cat2_3a
    cat2_3a_3b
    cat2_3a_3b_3c
    efb_status
    hud
    atnb1_cpdlc
    cpdlc_adsc
    ads_b
    cpdlc_fan1A_plus
    fmc
    pm_cpdlc
    cpdlc_fan1A
    acars
    etops_edto
  }
  totalNewComments
}
    `;
export const AircraftCountryFragmentDoc = gql`
    fragment aircraftCountry on Country {
  id
  name
  isDeleted
}
    `;
export const AircraftOperatorFragmentDoc = gql`
    fragment aircraftOperator on Operator {
  id
  company {
    name
    isActive
  }
  isActive
}
    `;
export const AircraftDetailFragmentDoc = gql`
    fragment aircraftDetail on Aircraft {
  id
  registrationMark
  priorRegistrationMarks
  aircraftStatus {
    id
  }
  isAircraftStatusUncertain
  serialNumber
  aircraftManufacturer {
    id
  }
  aircraftEngineManufacturer {
    id
  }
  aircraftPropellerManufacturer {
    id
  }
  aircraftModel {
    id
  }
  yearOfManufacture
  mtow
  mlw
  numberOfPaxSeats
  aircraftType {
    id
  }
  aircraftType {
    id
  }
  aircraftCategory {
    id
  }
  aircraftClass {
    id
  }
  homeBaseCountry {
    id
    region {
      id
    }
  }
  homeBaseState {
    id
  }
  homeBaseCity
  homeBaseZipCode
  homeBaseAddress
  isHomeBaseSameAsBaseOfOperations
  baseOfOperationsCountry {
    id
    region {
      id
    }
  }
  baseOfOperationsState {
    id
  }
  baseOfOperationsCity
  baseOfOperationsZipCode
  baseOfOperationsAddress
  targetReleaseDateToService
  initialRegistrationDate
  deregistrationDate
  countryOfExport {
    id
  }
  operator {
    id
  }
  owner {
    id
  }
  registeredHolder {
    id
  }
  uboName
  uboNationality
  uboNationalityId
  aircraftImageFileAttachment {
    mimeType
    content
  }
  activeAircraftProjects {
    id
  }
  notes
}
    `;
export const AircraftOperationalApprovalFragmentDoc = gql`
    fragment aircraftOperationalApproval on AircraftOperationalApproval {
  rvsm
  nat_hla_rvsm
  rnp_ar
  rnp_apch
  rnav1
  rnav2
  rnav5
  basicRnp1
  rnp4
  rnp10
  gps
  allWeatherOpsMeters
  lvto
  lvto_dh
  lvto_rvr
  lvto_minima
  cat1
  cat1_dh
  cat1_rvr
  cat1_minima
  cat2
  cat2_dh
  cat2_rvr
  cat2_minima
  cat2_3a
  cat2_3a_dh
  cat2_3a_rvr
  cat2_3a_minima
  cat2_3a_3b
  cat2_3a_3b_dh
  cat2_3a_3b_rvr
  cat2_3a_3b_minima
  cat2_3a_3b_3c
  cat2_3a_3b_3c_dh
  cat2_3a_3b_3c_rvr
  cat2_3a_3b_3c_minima
  efb_status
  efb_status_temporary_expiryDate
  hardwareClass1
  hardwareClass2
  hardwareClass3
  hardwareMakeAndType
  softwareAppTypeA
  dataStorageDeviceInstalled
  dataStorageDeviceCdDvd
  dataStorageDeviceOther
  dataStorageDeviceOtherDetail
  dataStorageDeviceNotebook
  dataStorageDeviceNotepad
  dataStorageDevicePda
  dataStorageDeviceMakeAndType
  hud
  svs
  nvg_nvis
  evs_efvs
  cvs
  hudMakeAndType
  opCreditRequestedYes
  singlePilot
  atnb1_cpdlc
  cpdlc_adsc
  ads_b
  cpdlc_fan1A_plus
  fmc
  pm_cpdlc
  cpdlc_fan1A
  acars
  etops_edto
  maximumDiversionTime
}
    `;
export const AircraftProjectDetailFragmentDoc = gql`
    fragment aircraftProjectDetail on AircraftProject {
  id
  uboName
  uboNationality
  uboNationalityId
  aircraft {
    id
    uboName
    uboNationality
    uboNationalityId
  }
  aircraftProjectType {
    id
    hasInspections
    hasOnlyBasicInspectionDocuments
  }
  projectStatus {
    id
  }
  preparedByDcaUser {
    id
  }
  registrationMark
  priorRegistrationMarks
  projectNumber
  updateDate
  aircraftStatus {
    id
  }
  isAircraftStatusUncertain
  serialNumber
  aircraftManufacturer {
    id
  }
  dcaAircraftManufacturer
  aircraftEngineManufacturer {
    id
  }
  dcaAircraftEngineManufacturer
  aircraftPropellerManufacturer {
    id
  }
  dcaAircraftPropellerManufacturer
  aircraftModel {
    id
  }
  dcaAircraftModel
  yearOfManufacture
  mtow
  dcaMtow
  mlw
  dcaMlw
  numberOfPaxSeats
  aircraftType {
    id
  }
  aircraftCategory {
    id
  }
  aircraftClass {
    id
  }
  homeBaseCountry {
    id
    region {
      id
    }
  }
  homeBaseState {
    id
  }
  homeBaseCity
  homeBaseZipCode
  homeBaseAddress
  isHomeBaseSameAsBaseOfOperations
  baseOfOperationsCountry {
    id
    region {
      id
    }
  }
  baseOfOperationsState {
    id
  }
  baseOfOperationsCity
  baseOfOperationsZipCode
  baseOfOperationsAddress
  targetReleaseDateToService
  initialRegistrationDate
  deregistrationDate
  clientSubmissionDate
  dcaSubmissionDate
  countryOfExport {
    id
  }
  operator {
    id
  }
  dcaOperator
  dcaOperatorAddress
  dcaOperatorAddressCountry
  owner {
    id
  }
  dcaOwner
  dcaOwnerAddress
  dcaOwnerAddressCountry
  dcaOwnerOperator
  dcaOwnerOperatorAddress
  dcaOwnerOperatorPhone
  dcaOwnerOperatorFax
  dcaOwnerOperatorEmailAddress
  registeredHolder {
    id
  }
  dcaRegisteredHolder
  dcaRegisteredHolderAddress
  dcaRegisteredHolderAddressCountry
  aircraftImageFileAttachment {
    mimeType
    content
  }
  assignedDepartments {
    id
  }
  assignedDepartmentUsers {
    id
    department {
      id
    }
  }
  assignees {
    id
    displayName
  }
  turnaroundDays
  dcaNoiseCertificationStandard
  dcaNoiseCertificationAdditionalModifications
  dcaLateralFullPowerNoiseLevel
  dcaApproachNoiseLevel
  dcaFlyoverNoiseLevel
  dcaOverflightNoiseLevel
  dcaIsOverflightNoiseLevelInDBASELUnits
  dcaTakeoffNoiseLevel
  dcaNoiseCertificationRemarks
  rvsm
  rvsmDescription
  natHlaMnps
  natHlaMnpsDescription
  natHlaMnpsRemarks
  lvto
  lvtoRvr
  lvtoRemarks
  cat1Lts
  cat1LtsRvr
  cat1LtsRemarks
  cat2
  cat2Rvr
  cat2Dh
  cat2Remarks
  cat3
  cat3Rvr
  cat3Dh
  cat3Remarks
  hudEvsSvsCvs
  hudEvsSvsCvsDescription
  hudEvsSvsCvsRemarks
  rnpAr
  rnpArDescription
  rnpArRemarks
  rnpApch
  rnpApchDescription
  rnpApchRemarks
  rnav1PRnav
  rnav1PRnavDescription
  rnav1PRnavRemarks
  rnav2
  rnav2Description
  rnav2Remarks
  rnav5BRnav
  rnav5BRnavDescription
  rnav5BRnavRemarks
  basicRnp1
  basicRnp1Description
  basicRnp1Remarks
  rnp4
  rnp4Description
  rnp4Remarks
  rnp10
  rnp10Description
  rnp10Remarks
  atnb1CpdlcLink2000Plus
  atnb1CpdlcLink2000PlusDescription
  atnb1CpdlcLink2000PlusRemarks
  cpdlcFans1APlus
  cpdlcFans1APlusRcp
  cpdlcFans1APlusRsp
  cpdlcFans1APlusRemarks
  cpdlcFans1A
  cpdlcFans1ARcp
  cpdlcFans1ARsp
  cpdlcFans1ARemarks
  cpdlcAdsCFans1APlus
  cpdlcAdsCFans1APlusRcp
  cpdlcAdsCFans1APlusRsp
  cpdlcAdsCFans1APlusRemarks
  fmcWpr
  fmcWprDescription
  fmcWprRemarks
  acarsAts
  acarsAtsDescription
  acarsAtsRemarks
  adsBOut
  adsBOutDescription
  adsBOutRemarks
  pmCpdlc
  pmCpdlcDescription
  pmCpdlcRemarks
  edtoEtops
  edtoEtopsMinutes
  edtoEtopsRemarks
  efb
  efbCategoryPortable
  efbCategoryInstalled
  efbRemarks
  steepApproach
  steepApproachAirport
  steepApproachRemarks
  priorCertificateOfRegistrationIssueDate
  priorCertificateOfRegistrationExpirationDate
  priorCertificateOfAirworthinessIssueDate
  priorCertificateOfAirworthinessExpirationDate
  priorNoiseCertificateIssueDate
  priorAircraftRadioStationLicenseIssueDate
  priorAirspaceApprovalCertificateIssueDate
  certificateOfRegistrationIssueDate
  certificateOfRegistrationExpirationDate
  certificateOfRegistrationCtcDaysValid
  certificateOfAirworthinessIssueDate
  certificateOfAirworthinessExpirationDate
  certificateOfAirworthinessCtcDaysValid
  noiseCertificateIssueDate
  noiseCertificateExpiryDate
  isNoiseCertificateExpiryIndefinite
  noiseCertificateCtcDaysValid
  aircraftRadioStationLicenseIssueDate
  aircraftRadioStationLicenseExpiryDate
  isAircraftRadioStationLicenseExpiryIndefinite
  aircraftRadioStationLicenseCtcDaysValid
  airspaceApprovalCertificateIssueDate
  airspaceApprovalCertificateExpiryDate
  isAirspaceApprovalCertificateExpiryIndefinite
  airspaceApprovalCertificateCtcDaysValid
  exportProduct
  exportTCHolder
  exportIsNew
  exportIsNewlyOverhauled
  exportIsUsed
  exportCountry
  exportRemarks
  exportExceptions
  exportDate
  exportAcTtHours
  exportAcTtMinutes
  exportAcTcCycles
  exportLhEngine
  exportLhEngineSerialNumber
  exportLhEngineTtHours
  exportLhEngineTtMinutes
  exportLhEngineTcCycles
  exportRhEngine
  exportRhEngineSerialNumber
  exportRhEngineTtHours
  exportRhEngineTtMinutes
  exportRhEngineTcCycles
  sfpNumber
  sfpRevision
  sfpIssueDate
  sfpIssuedTo
  sfpIsFlightPermit
  sfpIsTestFlight
  sfpTestFlightsWithinDistance
  sfpTestFlightsRadius
  sfpIsFerryFlight
  sfpFerryFlightFrom
  sfpFerryFlightTo
  sfpIsEvacuationFerryFlight
  sfpEvacuationFerryFlightFrom
  sfpEvacuationFerryFlightTo
  sfpEvacuationFerryFlightVia
  sfpIsInterimCofA
  sfpInterimCofAIsTransport
  sfpInterimCofAIsNormal
  sfpInterimCofAIsRestricted
  sfpInterimCofAIsRadioStationLicense
  sfpIsSubjectToSpecialConditions
  sfpIssueNumber1
  sfpIssueNumber2
  sfpIsSpecialConditionA
  sfpSpecialConditionANumberOfFlights
  sfpSpecialConditionAUntilDate
  sfpIsSpecialConditionB
  sfpSpecialConditionBUntilReceipt
  sfpIsOnlyAuthorityAorBApproved
  sfpIsSpecialCondition1
  sfpIsSpecialCondition2
  sfpSpecialCondition2Mtow
  sfpIsSpecialCondition3
  sfpSpecialCondition3Name1
  sfpSpecialCondition3Position1
  sfpSpecialCondition3License1
  sfpSpecialCondition3Name2
  sfpSpecialCondition3Position2
  sfpSpecialCondition3License2
  sfpSpecialCondition3Name3
  sfpSpecialCondition3Position3
  sfpSpecialCondition3License3
  sfpSpecialCondition3Name4
  sfpSpecialCondition3Position4
  sfpSpecialCondition3License4
  sfpSpecialCondition3Name5
  sfpSpecialCondition3Position5
  sfpSpecialCondition3License5
  sfpIsSpecialCondition4
  sfpIsSpecialCondition5
  sfpIsSpecialCondition6
  sfpIsSpecialCondition7
  sfpIsSpecialCondition8
  sfpSpecialCondition8Base
  sfpIsSpecialCondition9
  sfpSpecialCondition9Miles
  sfpSpecialCondition9Base
  sfpIsSpecialCondition10
  sfpIsSpecialCondition11
  sfpIsSpecialCondition12
  sfpIsSpecialCondition13
  sfpSpecialCondition13HoursOfFlight
  sfpSpecialCondition13HoursOfPilot
  sfpIsSpecialCondition14
  sfpSpecialCondition14Other
  cofrOwnerRemark
  cofrCertificateNumber
  cofaCertificateNumber
  noiseCertificateNumber
  aircraftRadioStationLicenseNumber
  airspaceAndSpecialApprovalCertificateNumber
  exportCofaCertificateNumber
}
    `;
export const AircraftProjectDocumentTypeApprovalStatusFragmentDoc = gql`
    fragment aircraftProjectDocumentTypeApprovalStatus on AircraftProjectDocumentTypeApprovalStatus {
  documentType {
    ...documentType
  }
  isApprovalRequired
  approvalStatus {
    id
  }
  document {
    createdByUser {
      id
      displayName
    }
    createDate
  }
}
    ${DocumentTypeFragmentDoc}`;
export const AircraftProjectDocumentFragmentDoc = gql`
    fragment aircraftProjectDocument on AircraftProjectOperatorDocument {
  id
  isReleasedToDca
  isArchived
  document {
    ...documentForDocumentLists
  }
}
    ${DocumentForDocumentListsFragmentDoc}`;
export const AircraftProjectHeaderFragmentDoc = gql`
    fragment aircraftProjectHeader on AircraftProject {
  id
  registrationMark
  operator {
    company {
      name
    }
  }
  aircraftProjectType {
    id
    name
  }
  projectStatus {
    id
    name
  }
  projectStage {
    id
    name
  }
  projectCreationDate
  projectCreatedByUser {
    firstName
    lastName
  }
  isOnHold
  isOnHoldByDca
  dcaHoldReason
  assignees {
    id
  }
  isDcaInvoiced
  isArgInvoiced
}
    `;
export const AircraftProjectInsFormAssociatedDocumentFragmentDoc = gql`
    fragment aircraftProjectInsFormAssociatedDocument on AircraftProjectOperatorInsFormAssociatedDocument {
  id
  insForm {
    id
  }
  insFormAssociatedDocumentGroup {
    id
  }
  isReleasedToDca
  isArchived
  document {
    ...documentForDocumentLists
  }
}
    ${DocumentForDocumentListsFragmentDoc}`;
export const AircraftProjectMissingInspectionFileAttachmentsInspectionFragmentDoc = gql`
    fragment aircraftProjectMissingInspectionFileAttachmentsInspection on Inspection {
  inspectionStatus {
    id
  }
  id
  letterOfFindingsFileAttachment {
    fileSizeBytes
  }
  insForm4001FileAttachment {
    fileSizeBytes
  }
  inspectorInspections {
    inspectionTimeLogFileAttachment {
      fileSizeBytes
    }
    inspectionInvoiceFileAttachment {
      fileSizeBytes
    }
  }
}
    `;
export const AircraftProjectGridItemFragmentDoc = gql`
    fragment aircraftProjectGridItem on AircraftProject {
  id
  registrationMark
  aircraftProjectType {
    id
    name
  }
  operator {
    company {
      name
    }
  }
  isHighImportance
  isOnHold
  isOnHoldByDca
  projectStatus {
    name
  }
  projectStage {
    name
  }
  clientSubmissionDate
  dcaSubmissionDate
  turnaroundDays
  assignees {
    firstName
    lastName
    userName
  }
  totalNewComments
  totalNewDcaComments
  aircraftClass {
    id
    name
  }
  aircraftCategory {
    id
    name
  }
  aircraftManufacturer {
    id
    name
  }
  aircraftModel {
    id
    name
  }
  aircraftStatus {
    id
    name
  }
  aircraftEngineManufacturer {
    id
    name
  }
  owner {
    company {
      name
    }
  }
  registeredHolder {
    company {
      name
    }
  }
  yearOfManufacture
  initialRegistrationDate
  numberOfPaxSeats
  serialNumber
  archivedDate
}
    `;
export const AmoProjectDocumentFragmentDoc = gql`
    fragment amoProjectDocument on AmoProjectDocument {
  id
  isReleasedToDca
  isArchived
  document {
    ...documentForDocumentLists
  }
}
    ${DocumentForDocumentListsFragmentDoc}`;
export const AmoProjectGridItemFragmentDoc = gql`
    fragment amoProjectGridItem on AmoProject {
  id
  amoProjectType {
    id
    abbreviation
  }
  amoName
  dcaCertificateNo
  assocAircraftProject {
    aircraft {
      registrationMark
    }
  }
  dateOfFirstIssue
  dateOfExpiry
  projectStatus {
    name
  }
  projectCreationDate
}
    `;
export const AmoAuditDetailForAllProjectsFragmentDoc = gql`
    fragment amoAuditDetailForAllProjects on Inspection {
  id
  inspectionStatus {
    id
  }
  otherStatusText
  letterOfFindingsFileAttachment {
    ...inspectionFileAttachment
  }
  insForm4004FileAttachment {
    ...inspectionFileAttachment
  }
  insForm4035FileAttachment {
    ...inspectionFileAttachment
  }
  inspectorInspections(includeAllProjects: true) {
    ...inspectorInspectionDetail
  }
  isDeleted
}
    ${InspectionFileAttachmentFragmentDoc}
${InspectorInspectionDetailFragmentDoc}`;
export const ArgDashboardAircraftReportItemFragmentDoc = gql`
    fragment argDashboardAircraftReportItem on Aircraft {
  id
  aircraftStatus {
    id
    name
  }
  registrationMark
  operator {
    company {
      name
    }
  }
  certificateOfAirworthinessExpirationDate
  certificateOfRegistrationExpirationDate
  certificateOfInsuranceExpirationDate
  leaseAgreementExpirationDate
  managementAgreementExpirationDate
}
    `;
export const ArgDashboardCrewMembersReportItemFragmentDoc = gql`
    fragment argDashboardCrewMembersReportItem on CrewMember {
  id
  firstName
  lastName
  crewPosition {
    name
  }
  validationNumber
  crewLicenseType {
    name
  }
  country {
    name
  }
  licenseNumber
  aircrafts {
    registrationMark
    aircraftStatus {
      id
    }
  }
  operators {
    isActive
    company {
      name
    }
  }
  certificateExpiryDate
  activeCrewProjects {
    id
  }
}
    `;
export const ArgDashboardInspectorsReportItemFragmentDoc = gql`
    fragment argDashboardInspectorsReportItem on Inspector {
  id
  user {
    firstName
    lastName
  }
  inspectorTypeId
  inspectorCategoryId
  inspectorCategoryTypeId
  appointmentLetterExpirationDate
}
    `;
export const ArgDashboardMechanicsReportItemFragmentDoc = gql`
    fragment argDashboardMechanicsReportItem on Mechanic {
  id
  firstName
  lastName
  mechanicPosition {
    name
  }
  validationNumber
  mechanicLicenseType {
    name
  }
  country {
    name
  }
  licenseNumber
  aircrafts {
    registrationMark
    aircraftStatus {
      id
    }
  }
  operators {
    company {
      name
    }
  }
  certificateExpiryDate
  activeMechanicProjects {
    id
  }
}
    `;
export const ReminderFragmentDoc = gql`
    fragment reminder on Reminder {
  id
  reminderDate
  reminderApplicability {
    id
    name
  }
  reminderText
  createDate
  createdByUser {
    displayName
  }
  otherUsers {
    id
    displayName
  }
  isSent
  sendErrorMessage
}
    `;
export const CrewCertificateValidationInfoV1FragmentDoc = gql`
    fragment crewCertificateValidationInfoV1 on CrewCertificateValidationInfoV1 {
  crewCertificateType
  validationRestrictedTo
  validationNumber
  firstName
  lastName
  basisOf
  dcaCrewRatingsList
  certificateExpiryDate
  certificateExpiryDate2
  certificateDateOfIssue
  licenseNumber
  isLegacyCertificate
  documentValidityId
  documentValidityName
}
    `;
export const CrewCertificateValidationInfoV2FragmentDoc = gql`
    fragment crewCertificateValidationInfoV2 on CrewCertificateValidationInfoV2 {
  documentValidityId
  documentValidityName
}
    `;
export const MechanicCertificateValidationInfoV1FragmentDoc = gql`
    fragment mechanicCertificateValidationInfoV1 on MechanicCertificateValidationInfoV1 {
  documentValidityId
  documentValidityName
}
    `;
export const CrewMemberDocumentFragmentDoc = gql`
    fragment crewMemberDocument on CrewMemberDocument {
  id
  isArchived
  document {
    ...documentForDocumentLists
  }
}
    ${DocumentForDocumentListsFragmentDoc}`;
export const CrewMemberGridItemFragmentDoc = gql`
    fragment crewMemberGridItem on CrewMember {
  id
  firstName
  lastName
  crewPosition {
    name
  }
  crewLicenseType {
    name
  }
  country {
    name
  }
  crewRatings {
    name
  }
  validationNumber
  certificateDateOfFirstIssue
  certificateExpiryDate
  operators {
    id
    company {
      name
    }
    isActive
  }
  employmentCompanies {
    id
    name
  }
  aircrafts {
    id
    registrationMark
    aircraftStatus {
      id
    }
  }
  crewMemberStatus {
    id
    name
  }
  totalNewComments
  hasActiveProjects
  numberOfNonInactiveAircraft
}
    `;
export const CrewMemberCountryFragmentDoc = gql`
    fragment crewMemberCountry on Country {
  id
  name
  isDeleted
}
    `;
export const CrewMemberOperatorFragmentDoc = gql`
    fragment crewMemberOperator on Operator {
  id
  company {
    name
    isActive
  }
  isActive
  isDeleted
}
    `;
export const CrewMemberEmploymentCompanyFragmentDoc = gql`
    fragment crewMemberEmploymentCompany on EmploymentCompany {
  id
  name
  isDeleted
}
    `;
export const CrewMemberGenericLvCompanyFragmentDoc = gql`
    fragment crewMemberGenericLvCompany on GenericLvCompany {
  id
  name
  isDeleted
}
    `;
export const CrewMemberAircraftFragmentDoc = gql`
    fragment crewMemberAircraft on Aircraft {
  id
  registrationMark
  aircraftStatus {
    id
  }
}
    `;
export const CrewProjectDocumentFragmentDoc = gql`
    fragment crewProjectDocument on CrewProjectDocument {
  id
  isReleasedToDca
  isArchived
  document {
    ...documentForDocumentLists
  }
}
    ${DocumentForDocumentListsFragmentDoc}`;
export const CrewProjectGridItemFragmentDoc = gql`
    fragment crewProjectGridItem on CrewProject {
  id
  crewProjectType {
    id
    abbreviation
  }
  crewProjectType {
    id
    abbreviation
  }
  crewProjectSpecialProjectType {
    id
    abbreviation
  }
  crewProjectRenewalTypes {
    abbreviation
  }
  crewPosition {
    name
  }
  lastName
  firstName
  certificateFirstIssuedDate
  validationNumber
  certificateDateOfIssue
  certificateExpiryDate
  isHighImportance
  isOnHold
  isOnHoldByDca
  projectStatus {
    name
  }
  projectStage {
    name
  }
  crewLicenseType {
    name
  }
  operators {
    company {
      name
    }
  }
  employmentCompanies {
    id
    name
  }
  provisionalOperatorNames
  provisionalAircraftRegistrationMarks
  crewProjectCategory {
    name
  }
  genericLvCompanies {
    name
  }
  aircraftModels {
    name
  }
  elpLevel {
    name
  }
  elpExpiryDate
  projectCreationDate
  clientSubmissionDate
  dcaSubmissionDate
  assignees {
    firstName
    lastName
    userName
  }
  aircrafts {
    registrationMark
    aircraftStatus {
      id
    }
  }
  totalNewComments
  totalNewDcaComments
  turnaroundDays
  associatedAircraftProject {
    id
    aircraft {
      id
      registrationMark
    }
    aircraftProjectType {
      id
      abbreviation
    }
  }
  archivedDate
}
    `;
export const CrewProjectCrewLicenseTypeFragmentDoc = gql`
    fragment crewProjectCrewLicenseType on CrewLicenseType {
  id
  name
  isDeleted
}
    `;
export const CrewProjectCrewPositionFragmentDoc = gql`
    fragment crewProjectCrewPosition on CrewPosition {
  id
  name
  isDeleted
  crewLicenseTypes {
    ...crewProjectCrewLicenseType
  }
}
    ${CrewProjectCrewLicenseTypeFragmentDoc}`;
export const CrewProjectCountryFragmentDoc = gql`
    fragment crewProjectCountry on Country {
  id
  name
  isDeleted
}
    `;
export const CrewProjectHeaderFragmentDoc = gql`
    fragment crewProjectHeader on CrewProject {
  id
  crewMember {
    id
  }
  firstName
  lastName
  crewProjectType {
    name
  }
  crewProjectSpecialProjectType {
    id
    name
  }
  operators {
    company {
      name
    }
  }
  provisionalOperatorNames
  projectStatus {
    id
    name
  }
  projectStage {
    id
    name
  }
  projectCreationDate
  projectCreatedByUser {
    firstName
    lastName
  }
  isOnHold
  isOnHoldByDca
  dcaHoldReason
  assignees {
    id
  }
  isDcaInvoiced
  isArgInvoiced
  dcaSubmissionDate
}
    `;
export const UserFragmentDoc = gql`
    fragment user on User {
  id
  firstName
  lastName
  initials
  userName
  displayName
  department {
    id
  }
  role {
    id
  }
  isTrg
  isOperator
  isDcaLicensing
}
    `;
export const CrewProjectCertificateInformationFragmentDoc = gql`
    fragment crewProjectCertificateInformation on CrewProjectCertificate {
  id
  certificateType {
    id
    description
  }
  firstName
  lastName
  certificateFirstIssuedDate
  validationNumber
  validationRestrictedTo
  certificateDateOfIssue
  certificateExpiryDate
  certificateDateOfIssue2
  certificateExpiryDate2
  country {
    id
    name
  }
  licenseNumber
  crewProjectType {
    id
    abbreviation
    name
  }
  crewProjectSpecialProjectType {
    id
    abbreviation
    name
  }
  crewPosition {
    id
    name
  }
  crewProjectRenewalTypes {
    abbreviation
    name
  }
  crewLicenseType {
    id
    description
  }
  dcaCrewRatingsList
  elpLevel {
    id
    name
  }
  elpExpiryDate
  crewProjectCategory {
    id
    name
  }
  dcaAircraftList
  dcaAircraftModelsList
  dcaGenericLvCompaniesList
  dcaSubmissionDate
  dcaRemarksC
  dcaRemarksD
  turnaroundDays
  assignees {
    ...user
  }
  dcaAssignee {
    ...user
  }
  preparedBy {
    ...user
  }
  dcaLastUpdatedDate
  projectStatusId
  dcaProjectNumber
}
    ${UserFragmentDoc}`;
export const CrewProjectCrewRatingFragmentDoc = gql`
    fragment crewProjectCrewRating on CrewRating {
  id
  name
  isDeleted
}
    `;
export const CrewProjectAircraftFragmentDoc = gql`
    fragment crewProjectAircraft on Aircraft {
  id
  registrationMark
  aircraftStatus {
    id
  }
  operator {
    id
  }
}
    `;
export const CrewProjectOperatorFragmentDoc = gql`
    fragment crewProjectOperator on Operator {
  id
  company {
    name
    isActive
  }
  isActive
  isDeleted
}
    `;
export const CrewProjectCategoryFragmentDoc = gql`
    fragment crewProjectCategory on CrewProjectCategory {
  id
  name
  isDeleted
}
    `;
export const CrewProjectElpLevelFragmentDoc = gql`
    fragment crewProjectElpLevel on ElpLevel {
  id
  name
  isDeleted
}
    `;
export const CrewProjectGenericLvCompanyFragmentDoc = gql`
    fragment crewProjectGenericLvCompany on GenericLvCompany {
  id
  name
  isDeleted
}
    `;
export const CrewProjectEmploymentCompanyFragmentDoc = gql`
    fragment crewProjectEmploymentCompany on EmploymentCompany {
  id
  name
  isDeleted
}
    `;
export const AircraftLicensingGridItemFragmentDoc = gql`
    fragment aircraftLicensingGridItem on AircraftProject {
  id
  registrationMark
  aircraftClass {
    id
    name
  }
  aircraftCategory {
    id
    name
  }
  aircraftManufacturer {
    id
    name
  }
  aircraftModel {
    id
    name
  }
  aircraftStatus {
    id
    name
  }
  aircraftEngineManufacturer {
    id
    name
  }
  aircraftProjectType {
    id
    name
  }
  operator {
    company {
      name
    }
  }
  assignedDepartmentUsers {
    displayName
  }
  projectStatus {
    id
    name
  }
  owner {
    company {
      name
    }
  }
  registeredHolder {
    company {
      name
    }
  }
  isDcaInvoiced
  isNoDcaInvoiceRequired
  isPendingDocsFromIaso
  isPendingOther
  pendingReason
  isOnHoldByDca
  dcaHoldReason
  isHighImportance
  serialNumber
  yearOfManufacture
  initialRegistrationDate
  numberOfPaxSeats
  archivedDate
}
    `;
export const CrewLicenseValidationsGridItemFragmentDoc = gql`
    fragment crewLicenseValidationsGridItem on CrewProject {
  id
  firstName
  lastName
  certificateExpiryDate
  validationNumber
  isHighImportance
  projectStatus {
    id
    name
  }
  country {
    name
  }
  licenseNumber
  crewProjectType {
    id
    abbreviation
    name
  }
  crewProjectRenewalTypes {
    abbreviation
    name
  }
  crewLicenseType {
    description
  }
  crewPosition {
    name
  }
  crewRatings {
    name
  }
  elpLevel {
    name
  }
  elpExpiryDate
  crewProjectCategory {
    name
  }
  operators {
    company {
      name
    }
  }
  aircrafts {
    registrationMark
  }
  genericLvCompanies {
    name
  }
  aircraftModels {
    name
  }
  dcaAssigneeUser {
    displayName
  }
  preparedByDcaUser {
    displayName
  }
  dcaSubmissionDate
  dcaProjectNumber
  isPendingDocsFromIaso
  isPendingLicenseVerification
  isPendingOther
  pendingReason
  isOnHoldByDca
  dcaHoldReason
  associatedAircraftProject {
    aircraft {
      registrationMark
    }
    aircraftProjectType {
      abbreviation
    }
  }
  isDcaInvoiced
  isNoDcaInvoiceRequired
  turnaroundDays
  certificateDateOfIssue
  archivedDate
}
    `;
export const MechanicLicenseValidationsGridItemFragmentDoc = gql`
    fragment mechanicLicenseValidationsGridItem on MechanicProject {
  id
  firstName
  lastName
  certificateExpiryDate
  validationNumber
  isHighImportance
  projectStatus {
    id
    name
  }
  country {
    name
  }
  dcaValidationIssueBasedOnLine1
  dcaValidationIssueBasedOnLine2
  licenseNumber
  mechanicProjectType {
    id
    abbreviation
    name
  }
  mechanicProjectRenewalTypes {
    abbreviation
    name
  }
  mechanicLicenseType {
    description
  }
  mechanicPosition {
    name
  }
  mechanicRatings {
    name
  }
  operators {
    company {
      name
    }
  }
  aircrafts {
    registrationMark
  }
  dcaReviewerUser {
    displayName
  }
  dcaSentForApprovalByUser {
    displayName
  }
  dcaApprovedByUser {
    displayName
  }
  dcaSubmissionDate
  dcaProjectNumber
  isPendingDocsFromIaso
  isPendingLicenseVerification
  isPendingOther
  pendingReason
  isOnHoldByDca
  dcaHoldReason
  associatedAircraftProject {
    aircraft {
      registrationMark
    }
    aircraftProjectType {
      abbreviation
    }
  }
  isDcaInvoiced
  isNoDcaInvoiceRequired
  turnaroundDays
  archivedDate
  certificateDateOfIssue
}
    `;
export const ProjectInsFormVersionByExecutionKeyFragmentDoc = gql`
    fragment projectInsFormVersionByExecutionKey on ProjectInsFormVersion {
  id
  projectId
  insFormVersion {
    id
    insForm {
      willBeEmailedWhenSigned
    }
    fields {
      fieldNumber
      isSignatureField
      signatoryRoleId
    }
  }
  fieldValues {
    id
    text
    signedByUser {
      id
      userName
      displayName
    }
    insFormVersionField {
      fieldNumber
    }
  }
  fieldComments {
    insFormVersionField {
      fieldNumber
    }
  }
  isSigned
  isSignedByDca
  isFullySigned
  insFormExecutionState {
    id
  }
}
    `;
export const ProjectInsFormVersionByExecutionKeyForDownloadFragmentDoc = gql`
    fragment projectInsFormVersionByExecutionKeyForDownload on ProjectInsFormVersion {
  id
  insFormVersion {
    insForm {
      name
    }
  }
  insFormExecutionState {
    id
  }
}
    `;
export const InspectorGridItemFragmentDoc = gql`
    fragment inspectorGridItem on Inspector {
  id
  user {
    firstName
    lastName
    countryId
    regionId
  }
  inspectorTypeId
  inspectorCategoryId
  inspectorCategoryTypeId
  isActive
  serviceAgreementExpirationDate
  appointmentLetterExpirationDate
  coverageAreaRegions {
    name
  }
  passportCountries {
    name
  }
  visaCountries {
    name
  }
  totalNewComments
}
    `;
export const InspectorRegionFragmentDoc = gql`
    fragment inspectorRegion on Region {
  id
  name
  isDeleted
}
    `;
export const InspectorCountryFragmentDoc = gql`
    fragment inspectorCountry on Country {
  id
  name
  isDeleted
}
    `;
export const InspectorInspectionsGridItemFragmentDoc = gql`
    fragment inspectorInspectionsGridItem on InspectorInspection {
  id
  inspector {
    user {
      firstName
      lastName
    }
  }
  inspection {
    inspectionStatus {
      id
      name
    }
    otherStatusText
    aircraftProjectOperatorInspection {
      aircraftProject {
        id
        registrationMark
        aircraftProjectType {
          id
          name
        }
        projectStatus {
          name
        }
      }
    }
  }
  country {
    name
  }
  state {
    name
  }
  city
  startDate
  endDate
}
    `;
export const InspectorAvailabilityEventFragmentDoc = gql`
    fragment inspectorAvailabilityEvent on InspectorInspection {
  id
  inspector {
    user {
      firstName
      lastName
      initials
      emailAddresses {
        emailAddress
      }
    }
  }
  inspection {
    aircraftProjectOperatorInspection {
      aircraftProject {
        id
        projectStatus {
          id
        }
        aircraftProjectType {
          id
        }
        registrationMark
      }
    }
  }
  startDate
  endDate
}
    `;
export const InspectorAvailabilityBlockedDateFragmentDoc = gql`
    fragment inspectorAvailabilityBlockedDate on InspectorBlockedDate {
  id
  inspector {
    user {
      firstName
      lastName
      initials
    }
  }
  startDate
  endDate
}
    `;
export const InspectorDetailFragmentDoc = gql`
    fragment inspectorDetail on Inspector {
  id
  inspectorTypeId
  inspectorCategoryId
  inspectorCategoryTypeId
  atsType
  diAppointmentNumber
  isActive
  user {
    firstName
    lastName
    initials
    userName
    regionId
    countryId
    stateId
    address
    city
    zipCode
    phoneNumbers {
      id
      phoneNumberTypeId
      phoneNumber
    }
    emailAddresses {
      id
      emailAddressTypeId
      emailAddress
    }
  }
  passportCountries {
    id
  }
  visaCountries {
    id
  }
  coverageAreaRegions {
    id
  }
  onboardingChecklist {
    idCardIssued
    emails
    backpacks
    businessCard
  }
}
    `;
export const InspectorBlockedDateFragmentDoc = gql`
    fragment inspectorBlockedDate on InspectorBlockedDate {
  id
  startDate
  endDate
  reason
}
    `;
export const InspectorDocumentFragmentDoc = gql`
    fragment inspectorDocument on InspectorDocument {
  id
  isArchived
  document {
    ...documentForDocumentLists
  }
}
    ${DocumentForDocumentListsFragmentDoc}`;
export const InvoiceGridItemFragmentDoc = gql`
    fragment invoiceGridItem on Invoice {
  id
  isArgInvoice
  invoiceNumber
  invoiceDate
  createdByUser {
    firstName
    lastName
  }
  aircraftProjects {
    id
    aircraftProjectNameForInvoicing
  }
  crewProjects {
    id
    crewProjectNameForInvoicing
  }
  mechanicProjects {
    id
    mechanicProjectNameForInvoicing
  }
  paymentStatus {
    id
    name
  }
}
    `;
export const ListManagementAircraftEngineManufacturerFragmentDoc = gql`
    fragment listManagementAircraftEngineManufacturer on AircraftEngineManufacturer {
  id
  isDeleted
  name
  listManagementActiveAircrafts {
    registrationMark
  }
  listManagementSkippedAircrafts {
    registrationMark
  }
  listManagementOpenAircraftProjects {
    registrationMark
  }
  listManagementSkippedAircraftProjects {
    registrationMark
  }
}
    `;
export const ListManagementAircraftManufacturerFragmentDoc = gql`
    fragment listManagementAircraftManufacturer on AircraftManufacturer {
  id
  isDeleted
  name
  listManagementActiveAircrafts {
    registrationMark
  }
  listManagementSkippedAircrafts {
    registrationMark
  }
  listManagementOpenAircraftProjects {
    registrationMark
  }
  listManagementSkippedAircraftProjects {
    registrationMark
  }
}
    `;
export const ListManagementAircraftModelFragmentDoc = gql`
    fragment listManagementAircraftModel on AircraftModel {
  id
  isDeleted
  name
  listManagementActiveAircrafts {
    registrationMark
  }
  listManagementSkippedAircrafts {
    registrationMark
  }
  listManagementOpenAircraftProjects {
    registrationMark
  }
  listManagementSkippedAircraftProjects {
    registrationMark
  }
  listManagementActiveCrewMembers {
    firstName
    lastName
  }
  listManagementSkippedCrewMembers {
    firstName
    lastName
  }
  listManagementOpenCrewProjects {
    firstName
    lastName
  }
  listManagementSkippedCrewProjects {
    firstName
    lastName
  }
}
    `;
export const ListManagementAircraftPropellerManufacturerFragmentDoc = gql`
    fragment listManagementAircraftPropellerManufacturer on AircraftPropellerManufacturer {
  id
  isDeleted
  name
  listManagementActiveAircrafts {
    registrationMark
  }
  listManagementSkippedAircrafts {
    registrationMark
  }
  listManagementOpenAircraftProjects {
    registrationMark
  }
  listManagementSkippedAircraftProjects {
    registrationMark
  }
}
    `;
export const ListManagementCrewRatingFragmentDoc = gql`
    fragment listManagementCrewRating on CrewRating {
  id
  isDeleted
  name
  listManagementActiveCrewMembers {
    firstName
    lastName
  }
  listManagementSkippedCrewMembers {
    firstName
    lastName
  }
  listManagementOpenCrewProjects {
    firstName
    lastName
  }
  listManagementSkippedCrewProjects {
    firstName
    lastName
  }
}
    `;
export const ListManagementEmploymentCompanyFragmentDoc = gql`
    fragment listManagementEmploymentCompany on EmploymentCompany {
  id
  isDeleted
  name
  listManagementActiveCrewMembers {
    firstName
    lastName
  }
  listManagementSkippedCrewMembers {
    firstName
    lastName
  }
  listManagementOpenCrewProjects {
    firstName
    lastName
  }
  listManagementSkippedCrewProjects {
    firstName
    lastName
  }
}
    `;
export const ListManagementGenericLvCompanyFragmentDoc = gql`
    fragment listManagementGenericLvCompany on GenericLvCompany {
  id
  isDeleted
  name
  listManagementActiveCrewMembers {
    firstName
    lastName
  }
  listManagementSkippedCrewMembers {
    firstName
    lastName
  }
  listManagementOpenCrewProjects {
    firstName
    lastName
  }
  listManagementSkippedCrewProjects {
    firstName
    lastName
  }
}
    `;
export const ListManagementMechanicRatingFragmentDoc = gql`
    fragment listManagementMechanicRating on MechanicRating {
  id
  isDeleted
  name
  listManagementActiveMechanics {
    firstName
    lastName
  }
  listManagementSkippedMechanics {
    firstName
    lastName
  }
  listManagementOpenMechanicProjects {
    firstName
    lastName
  }
  listManagementSkippedMechanicProjects {
    firstName
    lastName
  }
}
    `;
export const MechanicGridItemFragmentDoc = gql`
    fragment mechanicGridItem on Mechanic {
  id
  firstName
  lastName
  mechanicPosition {
    name
  }
  mechanicLicenseType {
    name
  }
  country {
    name
  }
  mechanicRatings {
    name
  }
  validationNumber
  certificateDateOfFirstIssue
  certificateExpiryDate
  operators {
    id
    company {
      name
    }
    isActive
  }
  mechanicStatus {
    name
  }
  totalNewComments
  activeMechanicProjects {
    id
  }
  numberOfNonInactiveAircraft
}
    `;
export const MechanicCountryFragmentDoc = gql`
    fragment mechanicCountry on Country {
  id
  name
  isDeleted
}
    `;
export const MechanicOperatorFragmentDoc = gql`
    fragment mechanicOperator on Operator {
  id
  company {
    name
    isActive
  }
  isActive
  isDeleted
}
    `;
export const MechanicEmploymentCompanyFragmentDoc = gql`
    fragment mechanicEmploymentCompany on EmploymentCompany {
  id
  name
  isDeleted
}
    `;
export const MechanicAircraftFragmentDoc = gql`
    fragment mechanicAircraft on Aircraft {
  id
  registrationMark
  aircraftStatus {
    id
  }
}
    `;
export const MechanicDocumentFragmentDoc = gql`
    fragment mechanicDocument on MechanicDocument {
  id
  isArchived
  document {
    ...documentForDocumentLists
  }
}
    ${DocumentForDocumentListsFragmentDoc}`;
export const MechanicProjectDocumentFragmentDoc = gql`
    fragment mechanicProjectDocument on MechanicProjectDocument {
  id
  isReleasedToDca
  isArchived
  document {
    ...documentForDocumentLists
  }
}
    ${DocumentForDocumentListsFragmentDoc}`;
export const MechanicProjectGridItemFragmentDoc = gql`
    fragment mechanicProjectGridItem on MechanicProject {
  id
  mechanicProjectType {
    id
    abbreviation
  }
  mechanicProjectType {
    id
    abbreviation
  }
  mechanicProjectRenewalTypes {
    abbreviation
  }
  mechanicPosition {
    name
  }
  lastName
  firstName
  certificateFirstIssuedDate
  validationNumber
  certificateDateOfIssue
  certificateExpiryDate
  isHighImportance
  isOnHold
  isOnHoldByDca
  projectStatus {
    name
  }
  projectStage {
    name
  }
  mechanicLicenseType {
    name
  }
  operators {
    company {
      name
    }
  }
  provisionalOperatorNames
  provisionalAircraftRegistrationMarks
  projectCreationDate
  clientSubmissionDate
  dcaSubmissionDate
  assignees {
    firstName
    lastName
    userName
  }
  aircrafts {
    registrationMark
    aircraftStatus {
      id
    }
  }
  totalNewComments
  totalNewDcaComments
  turnaroundDays
  associatedAircraftProject {
    id
    aircraft {
      id
      registrationMark
    }
    aircraftProjectType {
      id
      abbreviation
    }
  }
  archivedDate
}
    `;
export const MechanicProjectMechanicLicenseTypeFragmentDoc = gql`
    fragment mechanicProjectMechanicLicenseType on MechanicLicenseType {
  id
  name
  isDeleted
}
    `;
export const MechanicProjectMechanicPositionFragmentDoc = gql`
    fragment mechanicProjectMechanicPosition on MechanicPosition {
  id
  name
  isDeleted
  mechanicLicenseTypes {
    ...mechanicProjectMechanicLicenseType
  }
}
    ${MechanicProjectMechanicLicenseTypeFragmentDoc}`;
export const MechanicProjectCountryFragmentDoc = gql`
    fragment mechanicProjectCountry on Country {
  id
  name
  isDeleted
}
    `;
export const MechanicProjectHeaderFragmentDoc = gql`
    fragment mechanicProjectHeader on MechanicProject {
  id
  mechanic {
    id
  }
  firstName
  lastName
  mechanicProjectType {
    name
  }
  operators {
    company {
      name
    }
  }
  provisionalOperatorNames
  projectStatus {
    id
    name
  }
  projectStage {
    id
    name
  }
  projectCreationDate
  projectCreatedByUser {
    firstName
    lastName
  }
  isOnHold
  isOnHoldByDca
  dcaHoldReason
  assignees {
    id
  }
  isDcaInvoiced
  isArgInvoiced
  dcaSubmissionDate
}
    `;
export const MechanicProjectCertificateInformationFragmentDoc = gql`
    fragment mechanicProjectCertificateInformation on MechanicProjectCertificate {
  id
  certificateType {
    id
    description
  }
  firstName
  lastName
  certificateFirstIssuedDate
  validationNumber
  validationRestrictedTo
  certificateDateOfIssue
  certificateExpiryDate
  country {
    id
    name
  }
  licenseNumber
  mechanicProjectType {
    id
    abbreviation
    name
  }
  mechanicPosition {
    id
    name
  }
  mechanicProjectRenewalTypes {
    abbreviation
    name
  }
  mechanicLicenseType {
    id
    description
  }
  dcaMechanicRatingsList
  dcaAircraftList
  dcaSubmissionDate
  dcaAuthorizationLimitedTo
  dcaValidationIssueBasedOnLine1
  dcaValidationIssueBasedOnLine2
  turnaroundDays
  assignees {
    ...user
  }
  dcaReviewerUser {
    ...user
  }
  dcaSentForApprovalByUser {
    ...user
  }
  dcaApprovedByUser {
    ...user
  }
  dcaLastUpdatedDate
  projectStatusId
  dcaProjectNumber
}
    ${UserFragmentDoc}`;
export const MechanicProjectMechanicRatingFragmentDoc = gql`
    fragment mechanicProjectMechanicRating on MechanicRating {
  id
  name
  isDeleted
}
    `;
export const MechanicProjectAircraftFragmentDoc = gql`
    fragment mechanicProjectAircraft on Aircraft {
  id
  registrationMark
  aircraftStatus {
    id
  }
  operator {
    id
  }
}
    `;
export const MechanicProjectOperatorFragmentDoc = gql`
    fragment mechanicProjectOperator on Operator {
  id
  company {
    name
    isActive
  }
  isActive
  isDeleted
}
    `;
export const MechanicProjectEmploymentCompanyFragmentDoc = gql`
    fragment mechanicProjectEmploymentCompany on EmploymentCompany {
  id
  name
  isDeleted
}
    `;
export const PhoneNumberFragmentDoc = gql`
    fragment phoneNumber on PhoneNumber {
  id
  phoneNumberTypeId
  phoneNumber
}
    `;
export const CompanyDetailFragmentDoc = gql`
    fragment companyDetail on Company {
  id
  name
  isActive
  address
  city
  country {
    id
    name
    region {
      id
      name
    }
  }
  state {
    id
    name
  }
  zipCode
  phoneNumbers {
    ...phoneNumber
  }
  corporateEmailAddress
  incorporationDate
  goodStandingLetterIssueDate
  ofacComplianceExpirationDate
  isOperator
  isOwner
  isRegisteredHolder
  totalNewComments
}
    ${PhoneNumberFragmentDoc}`;
export const OperatorGridItemFragmentDoc = gql`
    fragment operatorGridItem on Operator {
  id
  company {
    ...companyDetail
  }
  aircraft(sortBy: registrationMark) {
    id
    registrationMark
    aircraftStatus {
      id
    }
  }
  numberOfNonInactiveAircraft
  isActive
}
    ${CompanyDetailFragmentDoc}`;
export const OperatorDetailFragmentDoc = gql`
    fragment operatorDetail on Operator {
  id
  company {
    ...companyDetail
  }
  isActive
  includeInReminderEmails
}
    ${CompanyDetailFragmentDoc}`;
export const OperatorDashboardCrewMembersReportItemFragmentDoc = gql`
    fragment operatorDashboardCrewMembersReportItem on CrewMember {
  id
  firstName
  lastName
  crewPosition {
    name
  }
  validationNumber
  crewLicenseType {
    name
  }
  country {
    name
  }
  licenseNumber
  aircrafts {
    registrationMark
    aircraftStatus {
      id
    }
  }
  operators {
    isActive
    company {
      name
    }
  }
  certificateExpiryDate
  activeCrewProjects {
    id
  }
}
    `;
export const OperatorDashboardAircraftReportItemFragmentDoc = gql`
    fragment operatorDashboardAircraftReportItem on Aircraft {
  id
  aircraftStatus {
    id
    name
  }
  registrationMark
  aircraftModel {
    name
  }
  owner {
    company {
      name
    }
  }
  operator {
    company {
      name
    }
  }
  certificateOfAirworthinessExpirationDate
  certificateOfRegistrationExpirationDate
  certificateOfInsuranceExpirationDate
  leaseAgreementExpirationDate
  managementAgreementExpirationDate
}
    `;
export const OperatorDashboardMechanicsReportItemFragmentDoc = gql`
    fragment operatorDashboardMechanicsReportItem on Mechanic {
  id
  firstName
  lastName
  mechanicPosition {
    name
  }
  validationNumber
  mechanicLicenseType {
    name
  }
  country {
    name
  }
  licenseNumber
  aircrafts {
    registrationMark
    aircraftStatus {
      id
    }
  }
  operators {
    isActive
    company {
      name
    }
  }
  certificateExpiryDate
  activeMechanicProjects {
    id
  }
}
    `;
export const OwnerGridItemFragmentDoc = gql`
    fragment ownerGridItem on Owner {
  id
  company {
    ...companyDetail
  }
  aircraft(sortBy: registrationMark) {
    id
    registrationMark
    aircraftStatus {
      id
    }
  }
  isActive
}
    ${CompanyDetailFragmentDoc}`;
export const OwnerDetailFragmentDoc = gql`
    fragment ownerDetail on Owner {
  id
  company {
    ...companyDetail
  }
  isActive
}
    ${CompanyDetailFragmentDoc}`;
export const RegisteredHolderGridItemFragmentDoc = gql`
    fragment registeredHolderGridItem on RegisteredHolder {
  id
  company {
    ...companyDetail
  }
  aircraft(sortBy: registrationMark) {
    id
    registrationMark
    aircraftStatus {
      id
    }
  }
  isActive
}
    ${CompanyDetailFragmentDoc}`;
export const RegisteredHolderDetailFragmentDoc = gql`
    fragment registeredHolderDetail on RegisteredHolder {
  id
  company {
    ...companyDetail
  }
  isActive
}
    ${CompanyDetailFragmentDoc}`;
export const UserGridItemFragmentDoc = gql`
    fragment userGridItem on User {
  id
  firstName
  lastName
  role {
    id
    name
  }
  isActive
  operator {
    id
    company {
      id
      name
    }
  }
  inspector {
    id
  }
  emailAddresses {
    id
    emailAddress
  }
}
    `;
export const UserRoleFragmentDoc = gql`
    fragment userRole on Role {
  id
  name
}
    `;
export const AddAircraftModelMutationDocument = gql`
    mutation addAircraftModelMutation($addAircraftModelInput: AddAircraftModelInput!) {
  addAircraftModel(addAircraftModelInput: $addAircraftModelInput) {
    id
    name
  }
}
    `;
export type AddAircraftModelMutationMutationFn = Apollo.MutationFunction<AddAircraftModelMutationMutation, AddAircraftModelMutationMutationVariables>;

/**
 * __useAddAircraftModelMutationMutation__
 *
 * To run a mutation, you first call `useAddAircraftModelMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAircraftModelMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAircraftModelMutationMutation, { data, loading, error }] = useAddAircraftModelMutationMutation({
 *   variables: {
 *      addAircraftModelInput: // value for 'addAircraftModelInput'
 *   },
 * });
 */
export function useAddAircraftModelMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddAircraftModelMutationMutation, AddAircraftModelMutationMutationVariables>) {
        return Apollo.useMutation<AddAircraftModelMutationMutation, AddAircraftModelMutationMutationVariables>(AddAircraftModelMutationDocument, baseOptions);
      }
export type AddAircraftModelMutationMutationHookResult = ReturnType<typeof useAddAircraftModelMutationMutation>;
export type AddAircraftModelMutationMutationResult = Apollo.MutationResult<AddAircraftModelMutationMutation>;
export type AddAircraftModelMutationMutationOptions = Apollo.BaseMutationOptions<AddAircraftModelMutationMutation, AddAircraftModelMutationMutationVariables>;
export const CompanyCommentsDocument = gql`
    query companyComments($id: Int!) {
  companyComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useCompanyCommentsQuery__
 *
 * To run a query within a React component, call `useCompanyCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyCommentsQuery(baseOptions: Apollo.QueryHookOptions<CompanyCommentsQuery, CompanyCommentsQueryVariables>) {
        return Apollo.useQuery<CompanyCommentsQuery, CompanyCommentsQueryVariables>(CompanyCommentsDocument, baseOptions);
      }
export function useCompanyCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyCommentsQuery, CompanyCommentsQueryVariables>) {
          return Apollo.useLazyQuery<CompanyCommentsQuery, CompanyCommentsQueryVariables>(CompanyCommentsDocument, baseOptions);
        }
export type CompanyCommentsQueryHookResult = ReturnType<typeof useCompanyCommentsQuery>;
export type CompanyCommentsLazyQueryHookResult = ReturnType<typeof useCompanyCommentsLazyQuery>;
export type CompanyCommentsQueryResult = Apollo.QueryResult<CompanyCommentsQuery, CompanyCommentsQueryVariables>;
export const AddCompanyCommentDocument = gql`
    mutation addCompanyComment($id: Int!, $input: CommentInput!) {
  addCompanyComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddCompanyCommentMutationFn = Apollo.MutationFunction<AddCompanyCommentMutation, AddCompanyCommentMutationVariables>;

/**
 * __useAddCompanyCommentMutation__
 *
 * To run a mutation, you first call `useAddCompanyCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyCommentMutation, { data, loading, error }] = useAddCompanyCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCompanyCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyCommentMutation, AddCompanyCommentMutationVariables>) {
        return Apollo.useMutation<AddCompanyCommentMutation, AddCompanyCommentMutationVariables>(AddCompanyCommentDocument, baseOptions);
      }
export type AddCompanyCommentMutationHookResult = ReturnType<typeof useAddCompanyCommentMutation>;
export type AddCompanyCommentMutationResult = Apollo.MutationResult<AddCompanyCommentMutation>;
export type AddCompanyCommentMutationOptions = Apollo.BaseMutationOptions<AddCompanyCommentMutation, AddCompanyCommentMutationVariables>;
export const UpdateCompanyCommentDocument = gql`
    mutation updateCompanyComment($id: Int!, $body: String!) {
  updateCompanyComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateCompanyCommentMutationFn = Apollo.MutationFunction<UpdateCompanyCommentMutation, UpdateCompanyCommentMutationVariables>;

/**
 * __useUpdateCompanyCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyCommentMutation, { data, loading, error }] = useUpdateCompanyCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateCompanyCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyCommentMutation, UpdateCompanyCommentMutationVariables>) {
        return Apollo.useMutation<UpdateCompanyCommentMutation, UpdateCompanyCommentMutationVariables>(UpdateCompanyCommentDocument, baseOptions);
      }
export type UpdateCompanyCommentMutationHookResult = ReturnType<typeof useUpdateCompanyCommentMutation>;
export type UpdateCompanyCommentMutationResult = Apollo.MutationResult<UpdateCompanyCommentMutation>;
export type UpdateCompanyCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyCommentMutation, UpdateCompanyCommentMutationVariables>;
export const UpdateCompanyCommentsLastViewedDateDocument = gql`
    mutation updateCompanyCommentsLastViewedDate($id: Int!) {
  updateCompanyCommentsLastViewedDate(companyId: $id) {
    id
  }
}
    `;
export type UpdateCompanyCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateCompanyCommentsLastViewedDateMutation, UpdateCompanyCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateCompanyCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateCompanyCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCompanyCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyCommentsLastViewedDateMutation, UpdateCompanyCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateCompanyCommentsLastViewedDateMutation, UpdateCompanyCommentsLastViewedDateMutationVariables>(UpdateCompanyCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateCompanyCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateCompanyCommentsLastViewedDateMutation>;
export type UpdateCompanyCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateCompanyCommentsLastViewedDateMutation>;
export type UpdateCompanyCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyCommentsLastViewedDateMutation, UpdateCompanyCommentsLastViewedDateMutationVariables>;
export const CompanyContactsDocument = gql`
    query companyContacts($companyId: Int!) {
  companyContacts(id: $companyId) {
    ...contact
  }
}
    ${ContactFragmentDoc}`;

/**
 * __useCompanyContactsQuery__
 *
 * To run a query within a React component, call `useCompanyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyContactsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyContactsQuery(baseOptions: Apollo.QueryHookOptions<CompanyContactsQuery, CompanyContactsQueryVariables>) {
        return Apollo.useQuery<CompanyContactsQuery, CompanyContactsQueryVariables>(CompanyContactsDocument, baseOptions);
      }
export function useCompanyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyContactsQuery, CompanyContactsQueryVariables>) {
          return Apollo.useLazyQuery<CompanyContactsQuery, CompanyContactsQueryVariables>(CompanyContactsDocument, baseOptions);
        }
export type CompanyContactsQueryHookResult = ReturnType<typeof useCompanyContactsQuery>;
export type CompanyContactsLazyQueryHookResult = ReturnType<typeof useCompanyContactsLazyQuery>;
export type CompanyContactsQueryResult = Apollo.QueryResult<CompanyContactsQuery, CompanyContactsQueryVariables>;
export const CompanyContactDocument = gql`
    query companyContact($id: Int!) {
  companyContact(id: $id) {
    ...contact
  }
}
    ${ContactFragmentDoc}`;

/**
 * __useCompanyContactQuery__
 *
 * To run a query within a React component, call `useCompanyContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyContactQuery(baseOptions: Apollo.QueryHookOptions<CompanyContactQuery, CompanyContactQueryVariables>) {
        return Apollo.useQuery<CompanyContactQuery, CompanyContactQueryVariables>(CompanyContactDocument, baseOptions);
      }
export function useCompanyContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyContactQuery, CompanyContactQueryVariables>) {
          return Apollo.useLazyQuery<CompanyContactQuery, CompanyContactQueryVariables>(CompanyContactDocument, baseOptions);
        }
export type CompanyContactQueryHookResult = ReturnType<typeof useCompanyContactQuery>;
export type CompanyContactLazyQueryHookResult = ReturnType<typeof useCompanyContactLazyQuery>;
export type CompanyContactQueryResult = Apollo.QueryResult<CompanyContactQuery, CompanyContactQueryVariables>;
export const AddCompanyContactDocument = gql`
    mutation addCompanyContact($companyId: Int!, $input: ContactInput!) {
  addCompanyContact(companyId: $companyId, input: $input) {
    ...contact
  }
}
    ${ContactFragmentDoc}`;
export type AddCompanyContactMutationFn = Apollo.MutationFunction<AddCompanyContactMutation, AddCompanyContactMutationVariables>;

/**
 * __useAddCompanyContactMutation__
 *
 * To run a mutation, you first call `useAddCompanyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyContactMutation, { data, loading, error }] = useAddCompanyContactMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCompanyContactMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyContactMutation, AddCompanyContactMutationVariables>) {
        return Apollo.useMutation<AddCompanyContactMutation, AddCompanyContactMutationVariables>(AddCompanyContactDocument, baseOptions);
      }
export type AddCompanyContactMutationHookResult = ReturnType<typeof useAddCompanyContactMutation>;
export type AddCompanyContactMutationResult = Apollo.MutationResult<AddCompanyContactMutation>;
export type AddCompanyContactMutationOptions = Apollo.BaseMutationOptions<AddCompanyContactMutation, AddCompanyContactMutationVariables>;
export const UpdateCompanyContactDocument = gql`
    mutation updateCompanyContact($id: Int!, $companyId: Int!, $input: ContactInput!) {
  updateCompanyContact(id: $id, companyId: $companyId, input: $input) {
    ...contact
  }
}
    ${ContactFragmentDoc}`;
export type UpdateCompanyContactMutationFn = Apollo.MutationFunction<UpdateCompanyContactMutation, UpdateCompanyContactMutationVariables>;

/**
 * __useUpdateCompanyContactMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyContactMutation, { data, loading, error }] = useUpdateCompanyContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyContactMutation, UpdateCompanyContactMutationVariables>) {
        return Apollo.useMutation<UpdateCompanyContactMutation, UpdateCompanyContactMutationVariables>(UpdateCompanyContactDocument, baseOptions);
      }
export type UpdateCompanyContactMutationHookResult = ReturnType<typeof useUpdateCompanyContactMutation>;
export type UpdateCompanyContactMutationResult = Apollo.MutationResult<UpdateCompanyContactMutation>;
export type UpdateCompanyContactMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyContactMutation, UpdateCompanyContactMutationVariables>;
export const DeleteCompanyContactDocument = gql`
    mutation deleteCompanyContact($id: Int!, $companyId: Int!) {
  deleteCompanyContact(id: $id, companyId: $companyId)
}
    `;
export type DeleteCompanyContactMutationFn = Apollo.MutationFunction<DeleteCompanyContactMutation, DeleteCompanyContactMutationVariables>;

/**
 * __useDeleteCompanyContactMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyContactMutation, { data, loading, error }] = useDeleteCompanyContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeleteCompanyContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyContactMutation, DeleteCompanyContactMutationVariables>) {
        return Apollo.useMutation<DeleteCompanyContactMutation, DeleteCompanyContactMutationVariables>(DeleteCompanyContactDocument, baseOptions);
      }
export type DeleteCompanyContactMutationHookResult = ReturnType<typeof useDeleteCompanyContactMutation>;
export type DeleteCompanyContactMutationResult = Apollo.MutationResult<DeleteCompanyContactMutation>;
export type DeleteCompanyContactMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyContactMutation, DeleteCompanyContactMutationVariables>;
export const CompanyDocumentsQueryDocument = gql`
    query companyDocumentsQuery($companyId: Int!, $documentTypeCategoryId: DocumentTypeCategoryEnum!) {
  documents: companyDocuments(companyId: $companyId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...companyDocument
  }
}
    ${CompanyDocumentFragmentDoc}`;

/**
 * __useCompanyDocumentsQueryQuery__
 *
 * To run a query within a React component, call `useCompanyDocumentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDocumentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDocumentsQueryQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      documentTypeCategoryId: // value for 'documentTypeCategoryId'
 *   },
 * });
 */
export function useCompanyDocumentsQueryQuery(baseOptions: Apollo.QueryHookOptions<CompanyDocumentsQueryQuery, CompanyDocumentsQueryQueryVariables>) {
        return Apollo.useQuery<CompanyDocumentsQueryQuery, CompanyDocumentsQueryQueryVariables>(CompanyDocumentsQueryDocument, baseOptions);
      }
export function useCompanyDocumentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyDocumentsQueryQuery, CompanyDocumentsQueryQueryVariables>) {
          return Apollo.useLazyQuery<CompanyDocumentsQueryQuery, CompanyDocumentsQueryQueryVariables>(CompanyDocumentsQueryDocument, baseOptions);
        }
export type CompanyDocumentsQueryQueryHookResult = ReturnType<typeof useCompanyDocumentsQueryQuery>;
export type CompanyDocumentsQueryLazyQueryHookResult = ReturnType<typeof useCompanyDocumentsQueryLazyQuery>;
export type CompanyDocumentsQueryQueryResult = Apollo.QueryResult<CompanyDocumentsQueryQuery, CompanyDocumentsQueryQueryVariables>;
export const AddCompanyDocumentMutationDocument = gql`
    mutation addCompanyDocumentMutation($addCompanyDocumentInput: AddCompanyDocumentInput!) {
  addCompanyDocument(addCompanyDocumentInput: $addCompanyDocumentInput) {
    id
  }
}
    `;
export type AddCompanyDocumentMutationMutationFn = Apollo.MutationFunction<AddCompanyDocumentMutationMutation, AddCompanyDocumentMutationMutationVariables>;

/**
 * __useAddCompanyDocumentMutationMutation__
 *
 * To run a mutation, you first call `useAddCompanyDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyDocumentMutationMutation, { data, loading, error }] = useAddCompanyDocumentMutationMutation({
 *   variables: {
 *      addCompanyDocumentInput: // value for 'addCompanyDocumentInput'
 *   },
 * });
 */
export function useAddCompanyDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyDocumentMutationMutation, AddCompanyDocumentMutationMutationVariables>) {
        return Apollo.useMutation<AddCompanyDocumentMutationMutation, AddCompanyDocumentMutationMutationVariables>(AddCompanyDocumentMutationDocument, baseOptions);
      }
export type AddCompanyDocumentMutationMutationHookResult = ReturnType<typeof useAddCompanyDocumentMutationMutation>;
export type AddCompanyDocumentMutationMutationResult = Apollo.MutationResult<AddCompanyDocumentMutationMutation>;
export type AddCompanyDocumentMutationMutationOptions = Apollo.BaseMutationOptions<AddCompanyDocumentMutationMutation, AddCompanyDocumentMutationMutationVariables>;
export const UpdateCompanyDocumentMutationDocument = gql`
    mutation updateCompanyDocumentMutation($updateCompanyDocumentInput: UpdateCompanyDocumentInput!) {
  updateCompanyDocument(updateCompanyDocumentInput: $updateCompanyDocumentInput) {
    id
  }
}
    `;
export type UpdateCompanyDocumentMutationMutationFn = Apollo.MutationFunction<UpdateCompanyDocumentMutationMutation, UpdateCompanyDocumentMutationMutationVariables>;

/**
 * __useUpdateCompanyDocumentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyDocumentMutationMutation, { data, loading, error }] = useUpdateCompanyDocumentMutationMutation({
 *   variables: {
 *      updateCompanyDocumentInput: // value for 'updateCompanyDocumentInput'
 *   },
 * });
 */
export function useUpdateCompanyDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyDocumentMutationMutation, UpdateCompanyDocumentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateCompanyDocumentMutationMutation, UpdateCompanyDocumentMutationMutationVariables>(UpdateCompanyDocumentMutationDocument, baseOptions);
      }
export type UpdateCompanyDocumentMutationMutationHookResult = ReturnType<typeof useUpdateCompanyDocumentMutationMutation>;
export type UpdateCompanyDocumentMutationMutationResult = Apollo.MutationResult<UpdateCompanyDocumentMutationMutation>;
export type UpdateCompanyDocumentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyDocumentMutationMutation, UpdateCompanyDocumentMutationMutationVariables>;
export const RemoveCompanyDocumentMutationDocument = gql`
    mutation removeCompanyDocumentMutation($id: Int!) {
  removeCompanyDocument(id: $id)
}
    `;
export type RemoveCompanyDocumentMutationMutationFn = Apollo.MutationFunction<RemoveCompanyDocumentMutationMutation, RemoveCompanyDocumentMutationMutationVariables>;

/**
 * __useRemoveCompanyDocumentMutationMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyDocumentMutationMutation, { data, loading, error }] = useRemoveCompanyDocumentMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCompanyDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyDocumentMutationMutation, RemoveCompanyDocumentMutationMutationVariables>) {
        return Apollo.useMutation<RemoveCompanyDocumentMutationMutation, RemoveCompanyDocumentMutationMutationVariables>(RemoveCompanyDocumentMutationDocument, baseOptions);
      }
export type RemoveCompanyDocumentMutationMutationHookResult = ReturnType<typeof useRemoveCompanyDocumentMutationMutation>;
export type RemoveCompanyDocumentMutationMutationResult = Apollo.MutationResult<RemoveCompanyDocumentMutationMutation>;
export type RemoveCompanyDocumentMutationMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyDocumentMutationMutation, RemoveCompanyDocumentMutationMutationVariables>;
export const DownloadCompanyDocumentDocument = gql`
    query downloadCompanyDocument($id: Int!) {
  file: downloadCompanyDocument(id: $id) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadCompanyDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadCompanyDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCompanyDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCompanyDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadCompanyDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadCompanyDocumentQuery, DownloadCompanyDocumentQueryVariables>) {
        return Apollo.useQuery<DownloadCompanyDocumentQuery, DownloadCompanyDocumentQueryVariables>(DownloadCompanyDocumentDocument, baseOptions);
      }
export function useDownloadCompanyDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCompanyDocumentQuery, DownloadCompanyDocumentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadCompanyDocumentQuery, DownloadCompanyDocumentQueryVariables>(DownloadCompanyDocumentDocument, baseOptions);
        }
export type DownloadCompanyDocumentQueryHookResult = ReturnType<typeof useDownloadCompanyDocumentQuery>;
export type DownloadCompanyDocumentLazyQueryHookResult = ReturnType<typeof useDownloadCompanyDocumentLazyQuery>;
export type DownloadCompanyDocumentQueryResult = Apollo.QueryResult<DownloadCompanyDocumentQuery, DownloadCompanyDocumentQueryVariables>;
export const CompanyEmailHistoryDocument = gql`
    query companyEmailHistory($companyId: Int!, $sortBy: EmailHistorySortBy, $sortDirection: SortDirection) {
  company(id: $companyId) {
    emailHistory(sortBy: $sortBy, sortDirection: $sortDirection) {
      ...emailHistory
    }
  }
}
    ${EmailHistoryFragmentDoc}`;

/**
 * __useCompanyEmailHistoryQuery__
 *
 * To run a query within a React component, call `useCompanyEmailHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyEmailHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyEmailHistoryQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useCompanyEmailHistoryQuery(baseOptions: Apollo.QueryHookOptions<CompanyEmailHistoryQuery, CompanyEmailHistoryQueryVariables>) {
        return Apollo.useQuery<CompanyEmailHistoryQuery, CompanyEmailHistoryQueryVariables>(CompanyEmailHistoryDocument, baseOptions);
      }
export function useCompanyEmailHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyEmailHistoryQuery, CompanyEmailHistoryQueryVariables>) {
          return Apollo.useLazyQuery<CompanyEmailHistoryQuery, CompanyEmailHistoryQueryVariables>(CompanyEmailHistoryDocument, baseOptions);
        }
export type CompanyEmailHistoryQueryHookResult = ReturnType<typeof useCompanyEmailHistoryQuery>;
export type CompanyEmailHistoryLazyQueryHookResult = ReturnType<typeof useCompanyEmailHistoryLazyQuery>;
export type CompanyEmailHistoryQueryResult = Apollo.QueryResult<CompanyEmailHistoryQuery, CompanyEmailHistoryQueryVariables>;
export const CompanyEmailViewDocument = gql`
    query companyEmailView($id: Int!, $emailId: Int!, $includeFileAttachments: Boolean = false, $includeFileContent: Boolean = false) {
  company(id: $id) {
    emails(filter: {id_in: [$emailId]}) {
      ...email
    }
  }
}
    ${EmailFragmentDoc}`;

/**
 * __useCompanyEmailViewQuery__
 *
 * To run a query within a React component, call `useCompanyEmailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyEmailViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyEmailViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      emailId: // value for 'emailId'
 *      includeFileAttachments: // value for 'includeFileAttachments'
 *      includeFileContent: // value for 'includeFileContent'
 *   },
 * });
 */
export function useCompanyEmailViewQuery(baseOptions: Apollo.QueryHookOptions<CompanyEmailViewQuery, CompanyEmailViewQueryVariables>) {
        return Apollo.useQuery<CompanyEmailViewQuery, CompanyEmailViewQueryVariables>(CompanyEmailViewDocument, baseOptions);
      }
export function useCompanyEmailViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyEmailViewQuery, CompanyEmailViewQueryVariables>) {
          return Apollo.useLazyQuery<CompanyEmailViewQuery, CompanyEmailViewQueryVariables>(CompanyEmailViewDocument, baseOptions);
        }
export type CompanyEmailViewQueryHookResult = ReturnType<typeof useCompanyEmailViewQuery>;
export type CompanyEmailViewLazyQueryHookResult = ReturnType<typeof useCompanyEmailViewLazyQuery>;
export type CompanyEmailViewQueryResult = Apollo.QueryResult<CompanyEmailViewQuery, CompanyEmailViewQueryVariables>;
export const DownloadCompanyEmailAttachmentContentDocument = gql`
    query downloadCompanyEmailAttachmentContent($companyId: Int!, $emailId: Int!, $attachmentId: Int!) {
  downloadCompanyEmailAttachmentContent(companyId: $companyId, emailId: $emailId, attachmentId: $attachmentId)
}
    `;

/**
 * __useDownloadCompanyEmailAttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadCompanyEmailAttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCompanyEmailAttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCompanyEmailAttachmentContentQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      emailId: // value for 'emailId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDownloadCompanyEmailAttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadCompanyEmailAttachmentContentQuery, DownloadCompanyEmailAttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadCompanyEmailAttachmentContentQuery, DownloadCompanyEmailAttachmentContentQueryVariables>(DownloadCompanyEmailAttachmentContentDocument, baseOptions);
      }
export function useDownloadCompanyEmailAttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCompanyEmailAttachmentContentQuery, DownloadCompanyEmailAttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadCompanyEmailAttachmentContentQuery, DownloadCompanyEmailAttachmentContentQueryVariables>(DownloadCompanyEmailAttachmentContentDocument, baseOptions);
        }
export type DownloadCompanyEmailAttachmentContentQueryHookResult = ReturnType<typeof useDownloadCompanyEmailAttachmentContentQuery>;
export type DownloadCompanyEmailAttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadCompanyEmailAttachmentContentLazyQuery>;
export type DownloadCompanyEmailAttachmentContentQueryResult = Apollo.QueryResult<DownloadCompanyEmailAttachmentContentQuery, DownloadCompanyEmailAttachmentContentQueryVariables>;
export const SendCompanyEmailDocument = gql`
    mutation sendCompanyEmail($companyId: Int!, $email: EmailInput!) {
  sendCompanyEmail(companyId: $companyId, email: $email) {
    id
  }
}
    `;
export type SendCompanyEmailMutationFn = Apollo.MutationFunction<SendCompanyEmailMutation, SendCompanyEmailMutationVariables>;

/**
 * __useSendCompanyEmailMutation__
 *
 * To run a mutation, you first call `useSendCompanyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCompanyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCompanyEmailMutation, { data, loading, error }] = useSendCompanyEmailMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendCompanyEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendCompanyEmailMutation, SendCompanyEmailMutationVariables>) {
        return Apollo.useMutation<SendCompanyEmailMutation, SendCompanyEmailMutationVariables>(SendCompanyEmailDocument, baseOptions);
      }
export type SendCompanyEmailMutationHookResult = ReturnType<typeof useSendCompanyEmailMutation>;
export type SendCompanyEmailMutationResult = Apollo.MutationResult<SendCompanyEmailMutation>;
export type SendCompanyEmailMutationOptions = Apollo.BaseMutationOptions<SendCompanyEmailMutation, SendCompanyEmailMutationVariables>;
export const MyPreviousRecipientsDocument = gql`
    query myPreviousRecipients($filter: String) {
  myPreviousRecipients(filter: $filter)
}
    `;

/**
 * __useMyPreviousRecipientsQuery__
 *
 * To run a query within a React component, call `useMyPreviousRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPreviousRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPreviousRecipientsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMyPreviousRecipientsQuery(baseOptions?: Apollo.QueryHookOptions<MyPreviousRecipientsQuery, MyPreviousRecipientsQueryVariables>) {
        return Apollo.useQuery<MyPreviousRecipientsQuery, MyPreviousRecipientsQueryVariables>(MyPreviousRecipientsDocument, baseOptions);
      }
export function useMyPreviousRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPreviousRecipientsQuery, MyPreviousRecipientsQueryVariables>) {
          return Apollo.useLazyQuery<MyPreviousRecipientsQuery, MyPreviousRecipientsQueryVariables>(MyPreviousRecipientsDocument, baseOptions);
        }
export type MyPreviousRecipientsQueryHookResult = ReturnType<typeof useMyPreviousRecipientsQuery>;
export type MyPreviousRecipientsLazyQueryHookResult = ReturnType<typeof useMyPreviousRecipientsLazyQuery>;
export type MyPreviousRecipientsQueryResult = Apollo.QueryResult<MyPreviousRecipientsQuery, MyPreviousRecipientsQueryVariables>;
export const SendEmailDocument = gql`
    mutation sendEmail($email: EmailInput!) {
  sendEmail(email: $email)
}
    `;
export type SendEmailMutationFn = Apollo.MutationFunction<SendEmailMutation, SendEmailMutationVariables>;

/**
 * __useSendEmailMutation__
 *
 * To run a mutation, you first call `useSendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailMutation, { data, loading, error }] = useSendEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailMutation, SendEmailMutationVariables>) {
        return Apollo.useMutation<SendEmailMutation, SendEmailMutationVariables>(SendEmailDocument, baseOptions);
      }
export type SendEmailMutationHookResult = ReturnType<typeof useSendEmailMutation>;
export type SendEmailMutationResult = Apollo.MutationResult<SendEmailMutation>;
export type SendEmailMutationOptions = Apollo.BaseMutationOptions<SendEmailMutation, SendEmailMutationVariables>;
export const UploadFileMutationDocument = gql`
    mutation uploadFileMutation($file: Upload!) {
  uploadFile(file: $file)
}
    `;
export type UploadFileMutationMutationFn = Apollo.MutationFunction<UploadFileMutationMutation, UploadFileMutationMutationVariables>;

/**
 * __useUploadFileMutationMutation__
 *
 * To run a mutation, you first call `useUploadFileMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutationMutation, { data, loading, error }] = useUploadFileMutationMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadFileMutationMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileMutationMutation, UploadFileMutationMutationVariables>) {
        return Apollo.useMutation<UploadFileMutationMutation, UploadFileMutationMutationVariables>(UploadFileMutationDocument, baseOptions);
      }
export type UploadFileMutationMutationHookResult = ReturnType<typeof useUploadFileMutationMutation>;
export type UploadFileMutationMutationResult = Apollo.MutationResult<UploadFileMutationMutation>;
export type UploadFileMutationMutationOptions = Apollo.BaseMutationOptions<UploadFileMutationMutation, UploadFileMutationMutationVariables>;
export const AircraftCategorySelectOptionsDocument = gql`
    query aircraftCategorySelectOptions($includeDeleted: Boolean) {
  aircraftCategories(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __useAircraftCategorySelectOptionsQuery__
 *
 * To run a query within a React component, call `useAircraftCategorySelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftCategorySelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftCategorySelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useAircraftCategorySelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AircraftCategorySelectOptionsQuery, AircraftCategorySelectOptionsQueryVariables>) {
        return Apollo.useQuery<AircraftCategorySelectOptionsQuery, AircraftCategorySelectOptionsQueryVariables>(AircraftCategorySelectOptionsDocument, baseOptions);
      }
export function useAircraftCategorySelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftCategorySelectOptionsQuery, AircraftCategorySelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftCategorySelectOptionsQuery, AircraftCategorySelectOptionsQueryVariables>(AircraftCategorySelectOptionsDocument, baseOptions);
        }
export type AircraftCategorySelectOptionsQueryHookResult = ReturnType<typeof useAircraftCategorySelectOptionsQuery>;
export type AircraftCategorySelectOptionsLazyQueryHookResult = ReturnType<typeof useAircraftCategorySelectOptionsLazyQuery>;
export type AircraftCategorySelectOptionsQueryResult = Apollo.QueryResult<AircraftCategorySelectOptionsQuery, AircraftCategorySelectOptionsQueryVariables>;
export const AircraftChipSelectOptionsDocument = gql`
    query aircraftChipSelectOptions($includeDeleted: Boolean, $operatorIdNullOrIn: [Int!]) {
  aircrafts(includeDeleted: $includeDeleted, operatorIdNullOrIn: $operatorIdNullOrIn, sortBy: registrationMark) {
    ... on Aircrafts {
      aircrafts {
        id
        registrationMark
        aircraftStatus {
          id
        }
        operator {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useAircraftChipSelectOptionsQuery__
 *
 * To run a query within a React component, call `useAircraftChipSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftChipSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftChipSelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *      operatorIdNullOrIn: // value for 'operatorIdNullOrIn'
 *   },
 * });
 */
export function useAircraftChipSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AircraftChipSelectOptionsQuery, AircraftChipSelectOptionsQueryVariables>) {
        return Apollo.useQuery<AircraftChipSelectOptionsQuery, AircraftChipSelectOptionsQueryVariables>(AircraftChipSelectOptionsDocument, baseOptions);
      }
export function useAircraftChipSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftChipSelectOptionsQuery, AircraftChipSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftChipSelectOptionsQuery, AircraftChipSelectOptionsQueryVariables>(AircraftChipSelectOptionsDocument, baseOptions);
        }
export type AircraftChipSelectOptionsQueryHookResult = ReturnType<typeof useAircraftChipSelectOptionsQuery>;
export type AircraftChipSelectOptionsLazyQueryHookResult = ReturnType<typeof useAircraftChipSelectOptionsLazyQuery>;
export type AircraftChipSelectOptionsQueryResult = Apollo.QueryResult<AircraftChipSelectOptionsQuery, AircraftChipSelectOptionsQueryVariables>;
export const AircraftClassSelectOptionsDocument = gql`
    query aircraftClassSelectOptions($includeDeleted: Boolean) {
  aircraftClasses(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __useAircraftClassSelectOptionsQuery__
 *
 * To run a query within a React component, call `useAircraftClassSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftClassSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftClassSelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useAircraftClassSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AircraftClassSelectOptionsQuery, AircraftClassSelectOptionsQueryVariables>) {
        return Apollo.useQuery<AircraftClassSelectOptionsQuery, AircraftClassSelectOptionsQueryVariables>(AircraftClassSelectOptionsDocument, baseOptions);
      }
export function useAircraftClassSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftClassSelectOptionsQuery, AircraftClassSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftClassSelectOptionsQuery, AircraftClassSelectOptionsQueryVariables>(AircraftClassSelectOptionsDocument, baseOptions);
        }
export type AircraftClassSelectOptionsQueryHookResult = ReturnType<typeof useAircraftClassSelectOptionsQuery>;
export type AircraftClassSelectOptionsLazyQueryHookResult = ReturnType<typeof useAircraftClassSelectOptionsLazyQuery>;
export type AircraftClassSelectOptionsQueryResult = Apollo.QueryResult<AircraftClassSelectOptionsQuery, AircraftClassSelectOptionsQueryVariables>;
export const AircraftModelSelectOptionsDocument = gql`
    query aircraftModelSelectOptions {
  aircraftModels(includeDeleted: true) {
    id
    name
    isDeleted
  }
}
    `;

/**
 * __useAircraftModelSelectOptionsQuery__
 *
 * To run a query within a React component, call `useAircraftModelSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftModelSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftModelSelectOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAircraftModelSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AircraftModelSelectOptionsQuery, AircraftModelSelectOptionsQueryVariables>) {
        return Apollo.useQuery<AircraftModelSelectOptionsQuery, AircraftModelSelectOptionsQueryVariables>(AircraftModelSelectOptionsDocument, baseOptions);
      }
export function useAircraftModelSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftModelSelectOptionsQuery, AircraftModelSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftModelSelectOptionsQuery, AircraftModelSelectOptionsQueryVariables>(AircraftModelSelectOptionsDocument, baseOptions);
        }
export type AircraftModelSelectOptionsQueryHookResult = ReturnType<typeof useAircraftModelSelectOptionsQuery>;
export type AircraftModelSelectOptionsLazyQueryHookResult = ReturnType<typeof useAircraftModelSelectOptionsLazyQuery>;
export type AircraftModelSelectOptionsQueryResult = Apollo.QueryResult<AircraftModelSelectOptionsQuery, AircraftModelSelectOptionsQueryVariables>;
export const AircraftModelsSelectOptionsDocument = gql`
    query aircraftModelsSelectOptions($includeDeleted: Boolean, $nameContains: String) {
  aircraftModels(includeDeleted: $includeDeleted, nameContains: $nameContains) {
    id
    name
  }
}
    `;

/**
 * __useAircraftModelsSelectOptionsQuery__
 *
 * To run a query within a React component, call `useAircraftModelsSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftModelsSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftModelsSelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *      nameContains: // value for 'nameContains'
 *   },
 * });
 */
export function useAircraftModelsSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AircraftModelsSelectOptionsQuery, AircraftModelsSelectOptionsQueryVariables>) {
        return Apollo.useQuery<AircraftModelsSelectOptionsQuery, AircraftModelsSelectOptionsQueryVariables>(AircraftModelsSelectOptionsDocument, baseOptions);
      }
export function useAircraftModelsSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftModelsSelectOptionsQuery, AircraftModelsSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftModelsSelectOptionsQuery, AircraftModelsSelectOptionsQueryVariables>(AircraftModelsSelectOptionsDocument, baseOptions);
        }
export type AircraftModelsSelectOptionsQueryHookResult = ReturnType<typeof useAircraftModelsSelectOptionsQuery>;
export type AircraftModelsSelectOptionsLazyQueryHookResult = ReturnType<typeof useAircraftModelsSelectOptionsLazyQuery>;
export type AircraftModelsSelectOptionsQueryResult = Apollo.QueryResult<AircraftModelsSelectOptionsQuery, AircraftModelsSelectOptionsQueryVariables>;
export const AircraftProjectTypeOptionsDocument = gql`
    query aircraftProjectTypeOptions($includeDeleted: Boolean = false) {
  aircraftProjectTypes(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __useAircraftProjectTypeOptionsQuery__
 *
 * To run a query within a React component, call `useAircraftProjectTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectTypeOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useAircraftProjectTypeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AircraftProjectTypeOptionsQuery, AircraftProjectTypeOptionsQueryVariables>) {
        return Apollo.useQuery<AircraftProjectTypeOptionsQuery, AircraftProjectTypeOptionsQueryVariables>(AircraftProjectTypeOptionsDocument, baseOptions);
      }
export function useAircraftProjectTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectTypeOptionsQuery, AircraftProjectTypeOptionsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectTypeOptionsQuery, AircraftProjectTypeOptionsQueryVariables>(AircraftProjectTypeOptionsDocument, baseOptions);
        }
export type AircraftProjectTypeOptionsQueryHookResult = ReturnType<typeof useAircraftProjectTypeOptionsQuery>;
export type AircraftProjectTypeOptionsLazyQueryHookResult = ReturnType<typeof useAircraftProjectTypeOptionsLazyQuery>;
export type AircraftProjectTypeOptionsQueryResult = Apollo.QueryResult<AircraftProjectTypeOptionsQuery, AircraftProjectTypeOptionsQueryVariables>;
export const AircraftSelectOptionsDocument = gql`
    query aircraftSelectOptions($registrationMarkContains: String) {
  aircrafts(registrationMarkContains: $registrationMarkContains, excludeDeregistered: true) {
    ... on Aircrafts {
      aircrafts {
        id
        registrationMark
      }
    }
  }
}
    `;

/**
 * __useAircraftSelectOptionsQuery__
 *
 * To run a query within a React component, call `useAircraftSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftSelectOptionsQuery({
 *   variables: {
 *      registrationMarkContains: // value for 'registrationMarkContains'
 *   },
 * });
 */
export function useAircraftSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AircraftSelectOptionsQuery, AircraftSelectOptionsQueryVariables>) {
        return Apollo.useQuery<AircraftSelectOptionsQuery, AircraftSelectOptionsQueryVariables>(AircraftSelectOptionsDocument, baseOptions);
      }
export function useAircraftSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftSelectOptionsQuery, AircraftSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftSelectOptionsQuery, AircraftSelectOptionsQueryVariables>(AircraftSelectOptionsDocument, baseOptions);
        }
export type AircraftSelectOptionsQueryHookResult = ReturnType<typeof useAircraftSelectOptionsQuery>;
export type AircraftSelectOptionsLazyQueryHookResult = ReturnType<typeof useAircraftSelectOptionsLazyQuery>;
export type AircraftSelectOptionsQueryResult = Apollo.QueryResult<AircraftSelectOptionsQuery, AircraftSelectOptionsQueryVariables>;
export const AircraftStatusSelectOptionsDocument = gql`
    query aircraftStatusSelectOptions($includeDeleted: Boolean) {
  aircraftStatuses(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __useAircraftStatusSelectOptionsQuery__
 *
 * To run a query within a React component, call `useAircraftStatusSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftStatusSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftStatusSelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useAircraftStatusSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AircraftStatusSelectOptionsQuery, AircraftStatusSelectOptionsQueryVariables>) {
        return Apollo.useQuery<AircraftStatusSelectOptionsQuery, AircraftStatusSelectOptionsQueryVariables>(AircraftStatusSelectOptionsDocument, baseOptions);
      }
export function useAircraftStatusSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftStatusSelectOptionsQuery, AircraftStatusSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftStatusSelectOptionsQuery, AircraftStatusSelectOptionsQueryVariables>(AircraftStatusSelectOptionsDocument, baseOptions);
        }
export type AircraftStatusSelectOptionsQueryHookResult = ReturnType<typeof useAircraftStatusSelectOptionsQuery>;
export type AircraftStatusSelectOptionsLazyQueryHookResult = ReturnType<typeof useAircraftStatusSelectOptionsLazyQuery>;
export type AircraftStatusSelectOptionsQueryResult = Apollo.QueryResult<AircraftStatusSelectOptionsQuery, AircraftStatusSelectOptionsQueryVariables>;
export const AircraftTypeSelectOptionsDocument = gql`
    query aircraftTypeSelectOptions($includeDeleted: Boolean) {
  aircraftCategories(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __useAircraftTypeSelectOptionsQuery__
 *
 * To run a query within a React component, call `useAircraftTypeSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftTypeSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftTypeSelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useAircraftTypeSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AircraftTypeSelectOptionsQuery, AircraftTypeSelectOptionsQueryVariables>) {
        return Apollo.useQuery<AircraftTypeSelectOptionsQuery, AircraftTypeSelectOptionsQueryVariables>(AircraftTypeSelectOptionsDocument, baseOptions);
      }
export function useAircraftTypeSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftTypeSelectOptionsQuery, AircraftTypeSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftTypeSelectOptionsQuery, AircraftTypeSelectOptionsQueryVariables>(AircraftTypeSelectOptionsDocument, baseOptions);
        }
export type AircraftTypeSelectOptionsQueryHookResult = ReturnType<typeof useAircraftTypeSelectOptionsQuery>;
export type AircraftTypeSelectOptionsLazyQueryHookResult = ReturnType<typeof useAircraftTypeSelectOptionsLazyQuery>;
export type AircraftTypeSelectOptionsQueryResult = Apollo.QueryResult<AircraftTypeSelectOptionsQuery, AircraftTypeSelectOptionsQueryVariables>;
export const AmoProjectAssociatedAircraftProjectSelectDocument = gql`
    query amoProjectAssociatedAircraftProjectSelect {
  aircraftProjects(sortBy: registrationMark, includeDeleted: true) {
    ... on AircraftProjects {
      aircraftProjects {
        id
        aircraftProjectType {
          id
          abbreviation
        }
        projectStatus {
          id
        }
        aircraft {
          id
          registrationMark
        }
        isDeleted
      }
    }
  }
}
    `;

/**
 * __useAmoProjectAssociatedAircraftProjectSelectQuery__
 *
 * To run a query within a React component, call `useAmoProjectAssociatedAircraftProjectSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectAssociatedAircraftProjectSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectAssociatedAircraftProjectSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useAmoProjectAssociatedAircraftProjectSelectQuery(baseOptions?: Apollo.QueryHookOptions<AmoProjectAssociatedAircraftProjectSelectQuery, AmoProjectAssociatedAircraftProjectSelectQueryVariables>) {
        return Apollo.useQuery<AmoProjectAssociatedAircraftProjectSelectQuery, AmoProjectAssociatedAircraftProjectSelectQueryVariables>(AmoProjectAssociatedAircraftProjectSelectDocument, baseOptions);
      }
export function useAmoProjectAssociatedAircraftProjectSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectAssociatedAircraftProjectSelectQuery, AmoProjectAssociatedAircraftProjectSelectQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectAssociatedAircraftProjectSelectQuery, AmoProjectAssociatedAircraftProjectSelectQueryVariables>(AmoProjectAssociatedAircraftProjectSelectDocument, baseOptions);
        }
export type AmoProjectAssociatedAircraftProjectSelectQueryHookResult = ReturnType<typeof useAmoProjectAssociatedAircraftProjectSelectQuery>;
export type AmoProjectAssociatedAircraftProjectSelectLazyQueryHookResult = ReturnType<typeof useAmoProjectAssociatedAircraftProjectSelectLazyQuery>;
export type AmoProjectAssociatedAircraftProjectSelectQueryResult = Apollo.QueryResult<AmoProjectAssociatedAircraftProjectSelectQuery, AmoProjectAssociatedAircraftProjectSelectQueryVariables>;
export const AmoProjectTypeOptionsDocument = gql`
    query amoProjectTypeOptions($includeDeleted: Boolean = false) {
  amoProjectTypes(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __useAmoProjectTypeOptionsQuery__
 *
 * To run a query within a React component, call `useAmoProjectTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectTypeOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useAmoProjectTypeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AmoProjectTypeOptionsQuery, AmoProjectTypeOptionsQueryVariables>) {
        return Apollo.useQuery<AmoProjectTypeOptionsQuery, AmoProjectTypeOptionsQueryVariables>(AmoProjectTypeOptionsDocument, baseOptions);
      }
export function useAmoProjectTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectTypeOptionsQuery, AmoProjectTypeOptionsQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectTypeOptionsQuery, AmoProjectTypeOptionsQueryVariables>(AmoProjectTypeOptionsDocument, baseOptions);
        }
export type AmoProjectTypeOptionsQueryHookResult = ReturnType<typeof useAmoProjectTypeOptionsQuery>;
export type AmoProjectTypeOptionsLazyQueryHookResult = ReturnType<typeof useAmoProjectTypeOptionsLazyQuery>;
export type AmoProjectTypeOptionsQueryResult = Apollo.QueryResult<AmoProjectTypeOptionsQuery, AmoProjectTypeOptionsQueryVariables>;
export const AmoSelectOptionsDocument = gql`
    query amoSelectOptions($nameContains: String, $onlyRenewable: Boolean) {
  amos(nameContains: $nameContains, onlyRenewable: $onlyRenewable) {
    ... on Amos {
      amos {
        id
        amoName
        dcaCertificateNo
      }
    }
  }
}
    `;

/**
 * __useAmoSelectOptionsQuery__
 *
 * To run a query within a React component, call `useAmoSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoSelectOptionsQuery({
 *   variables: {
 *      nameContains: // value for 'nameContains'
 *      onlyRenewable: // value for 'onlyRenewable'
 *   },
 * });
 */
export function useAmoSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AmoSelectOptionsQuery, AmoSelectOptionsQueryVariables>) {
        return Apollo.useQuery<AmoSelectOptionsQuery, AmoSelectOptionsQueryVariables>(AmoSelectOptionsDocument, baseOptions);
      }
export function useAmoSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoSelectOptionsQuery, AmoSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<AmoSelectOptionsQuery, AmoSelectOptionsQueryVariables>(AmoSelectOptionsDocument, baseOptions);
        }
export type AmoSelectOptionsQueryHookResult = ReturnType<typeof useAmoSelectOptionsQuery>;
export type AmoSelectOptionsLazyQueryHookResult = ReturnType<typeof useAmoSelectOptionsLazyQuery>;
export type AmoSelectOptionsQueryResult = Apollo.QueryResult<AmoSelectOptionsQuery, AmoSelectOptionsQueryVariables>;
export const CountrySelectOptionsDocument = gql`
    query countrySelectOptions($includeDeleted: Boolean = false, $regionIdIn: [Int!]) {
  countries(includeDeleted: $includeDeleted, regionIdIn: $regionIdIn) {
    id
    name
  }
}
    `;

/**
 * __useCountrySelectOptionsQuery__
 *
 * To run a query within a React component, call `useCountrySelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountrySelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountrySelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *      regionIdIn: // value for 'regionIdIn'
 *   },
 * });
 */
export function useCountrySelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CountrySelectOptionsQuery, CountrySelectOptionsQueryVariables>) {
        return Apollo.useQuery<CountrySelectOptionsQuery, CountrySelectOptionsQueryVariables>(CountrySelectOptionsDocument, baseOptions);
      }
export function useCountrySelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountrySelectOptionsQuery, CountrySelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<CountrySelectOptionsQuery, CountrySelectOptionsQueryVariables>(CountrySelectOptionsDocument, baseOptions);
        }
export type CountrySelectOptionsQueryHookResult = ReturnType<typeof useCountrySelectOptionsQuery>;
export type CountrySelectOptionsLazyQueryHookResult = ReturnType<typeof useCountrySelectOptionsLazyQuery>;
export type CountrySelectOptionsQueryResult = Apollo.QueryResult<CountrySelectOptionsQuery, CountrySelectOptionsQueryVariables>;
export const CrewCertificateTypeOptionsDocument = gql`
    query crewCertificateTypeOptions($includeDeleted: Boolean = false) {
  crewCertificateTypes(includeDeleted: $includeDeleted) {
    id
    name
    description
  }
}
    `;

/**
 * __useCrewCertificateTypeOptionsQuery__
 *
 * To run a query within a React component, call `useCrewCertificateTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewCertificateTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewCertificateTypeOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useCrewCertificateTypeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CrewCertificateTypeOptionsQuery, CrewCertificateTypeOptionsQueryVariables>) {
        return Apollo.useQuery<CrewCertificateTypeOptionsQuery, CrewCertificateTypeOptionsQueryVariables>(CrewCertificateTypeOptionsDocument, baseOptions);
      }
export function useCrewCertificateTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewCertificateTypeOptionsQuery, CrewCertificateTypeOptionsQueryVariables>) {
          return Apollo.useLazyQuery<CrewCertificateTypeOptionsQuery, CrewCertificateTypeOptionsQueryVariables>(CrewCertificateTypeOptionsDocument, baseOptions);
        }
export type CrewCertificateTypeOptionsQueryHookResult = ReturnType<typeof useCrewCertificateTypeOptionsQuery>;
export type CrewCertificateTypeOptionsLazyQueryHookResult = ReturnType<typeof useCrewCertificateTypeOptionsLazyQuery>;
export type CrewCertificateTypeOptionsQueryResult = Apollo.QueryResult<CrewCertificateTypeOptionsQuery, CrewCertificateTypeOptionsQueryVariables>;
export const CrewLicenseTypeOptionsDocument = gql`
    query crewLicenseTypeOptions($includeDeleted: Boolean = false) {
  crewLicenseTypes(includeDeleted: $includeDeleted) {
    id
    name
    description
    isDeleted
    isForCertificateOnly
    crewPositions {
      id
    }
  }
}
    `;

/**
 * __useCrewLicenseTypeOptionsQuery__
 *
 * To run a query within a React component, call `useCrewLicenseTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewLicenseTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewLicenseTypeOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useCrewLicenseTypeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CrewLicenseTypeOptionsQuery, CrewLicenseTypeOptionsQueryVariables>) {
        return Apollo.useQuery<CrewLicenseTypeOptionsQuery, CrewLicenseTypeOptionsQueryVariables>(CrewLicenseTypeOptionsDocument, baseOptions);
      }
export function useCrewLicenseTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewLicenseTypeOptionsQuery, CrewLicenseTypeOptionsQueryVariables>) {
          return Apollo.useLazyQuery<CrewLicenseTypeOptionsQuery, CrewLicenseTypeOptionsQueryVariables>(CrewLicenseTypeOptionsDocument, baseOptions);
        }
export type CrewLicenseTypeOptionsQueryHookResult = ReturnType<typeof useCrewLicenseTypeOptionsQuery>;
export type CrewLicenseTypeOptionsLazyQueryHookResult = ReturnType<typeof useCrewLicenseTypeOptionsLazyQuery>;
export type CrewLicenseTypeOptionsQueryResult = Apollo.QueryResult<CrewLicenseTypeOptionsQuery, CrewLicenseTypeOptionsQueryVariables>;
export const CrewMemberForOperatorAddCrewProjectSelectOptionsDocument = gql`
    query crewMemberForOperatorAddCrewProjectSelectOptions($operatorId: Int!, $lastNameContains: String) {
  crewMembersForOperatorAddCrewProject(operatorId: $operatorId, lastNameContains: $lastNameContains) {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useCrewMemberForOperatorAddCrewProjectSelectOptionsQuery__
 *
 * To run a query within a React component, call `useCrewMemberForOperatorAddCrewProjectSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewMemberForOperatorAddCrewProjectSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewMemberForOperatorAddCrewProjectSelectOptionsQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *      lastNameContains: // value for 'lastNameContains'
 *   },
 * });
 */
export function useCrewMemberForOperatorAddCrewProjectSelectOptionsQuery(baseOptions: Apollo.QueryHookOptions<CrewMemberForOperatorAddCrewProjectSelectOptionsQuery, CrewMemberForOperatorAddCrewProjectSelectOptionsQueryVariables>) {
        return Apollo.useQuery<CrewMemberForOperatorAddCrewProjectSelectOptionsQuery, CrewMemberForOperatorAddCrewProjectSelectOptionsQueryVariables>(CrewMemberForOperatorAddCrewProjectSelectOptionsDocument, baseOptions);
      }
export function useCrewMemberForOperatorAddCrewProjectSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewMemberForOperatorAddCrewProjectSelectOptionsQuery, CrewMemberForOperatorAddCrewProjectSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<CrewMemberForOperatorAddCrewProjectSelectOptionsQuery, CrewMemberForOperatorAddCrewProjectSelectOptionsQueryVariables>(CrewMemberForOperatorAddCrewProjectSelectOptionsDocument, baseOptions);
        }
export type CrewMemberForOperatorAddCrewProjectSelectOptionsQueryHookResult = ReturnType<typeof useCrewMemberForOperatorAddCrewProjectSelectOptionsQuery>;
export type CrewMemberForOperatorAddCrewProjectSelectOptionsLazyQueryHookResult = ReturnType<typeof useCrewMemberForOperatorAddCrewProjectSelectOptionsLazyQuery>;
export type CrewMemberForOperatorAddCrewProjectSelectOptionsQueryResult = Apollo.QueryResult<CrewMemberForOperatorAddCrewProjectSelectOptionsQuery, CrewMemberForOperatorAddCrewProjectSelectOptionsQueryVariables>;
export const CrewMemberSelectOptionsDocument = gql`
    query crewMemberSelectOptions($lastNameContains: String, $hasActiveProjects: Boolean) {
  crewMembers(lastNameContains: $lastNameContains, hasActiveProjects: $hasActiveProjects) {
    ... on CrewMembers {
      crewMembers {
        id
        firstName
        lastName
        country {
          name
        }
        validationNumber
      }
    }
  }
}
    `;

/**
 * __useCrewMemberSelectOptionsQuery__
 *
 * To run a query within a React component, call `useCrewMemberSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewMemberSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewMemberSelectOptionsQuery({
 *   variables: {
 *      lastNameContains: // value for 'lastNameContains'
 *      hasActiveProjects: // value for 'hasActiveProjects'
 *   },
 * });
 */
export function useCrewMemberSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CrewMemberSelectOptionsQuery, CrewMemberSelectOptionsQueryVariables>) {
        return Apollo.useQuery<CrewMemberSelectOptionsQuery, CrewMemberSelectOptionsQueryVariables>(CrewMemberSelectOptionsDocument, baseOptions);
      }
export function useCrewMemberSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewMemberSelectOptionsQuery, CrewMemberSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<CrewMemberSelectOptionsQuery, CrewMemberSelectOptionsQueryVariables>(CrewMemberSelectOptionsDocument, baseOptions);
        }
export type CrewMemberSelectOptionsQueryHookResult = ReturnType<typeof useCrewMemberSelectOptionsQuery>;
export type CrewMemberSelectOptionsLazyQueryHookResult = ReturnType<typeof useCrewMemberSelectOptionsLazyQuery>;
export type CrewMemberSelectOptionsQueryResult = Apollo.QueryResult<CrewMemberSelectOptionsQuery, CrewMemberSelectOptionsQueryVariables>;
export const CrewPositionSelectOptionsDocument = gql`
    query crewPositionSelectOptions($includeDeleted: Boolean = false, $crewLicenseTypeIdIn: [Int!]) {
  crewPositions(includeDeleted: $includeDeleted, crewLicenseTypeIdIn: $crewLicenseTypeIdIn) {
    id
    name
    description
  }
}
    `;

/**
 * __useCrewPositionSelectOptionsQuery__
 *
 * To run a query within a React component, call `useCrewPositionSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewPositionSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewPositionSelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *      crewLicenseTypeIdIn: // value for 'crewLicenseTypeIdIn'
 *   },
 * });
 */
export function useCrewPositionSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CrewPositionSelectOptionsQuery, CrewPositionSelectOptionsQueryVariables>) {
        return Apollo.useQuery<CrewPositionSelectOptionsQuery, CrewPositionSelectOptionsQueryVariables>(CrewPositionSelectOptionsDocument, baseOptions);
      }
export function useCrewPositionSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewPositionSelectOptionsQuery, CrewPositionSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<CrewPositionSelectOptionsQuery, CrewPositionSelectOptionsQueryVariables>(CrewPositionSelectOptionsDocument, baseOptions);
        }
export type CrewPositionSelectOptionsQueryHookResult = ReturnType<typeof useCrewPositionSelectOptionsQuery>;
export type CrewPositionSelectOptionsLazyQueryHookResult = ReturnType<typeof useCrewPositionSelectOptionsLazyQuery>;
export type CrewPositionSelectOptionsQueryResult = Apollo.QueryResult<CrewPositionSelectOptionsQuery, CrewPositionSelectOptionsQueryVariables>;
export const CrewProjectAssociatedAircraftProjectSelectDocument = gql`
    query crewProjectAssociatedAircraftProjectSelect {
  aircraftProjects(sortBy: registrationMark, includeDeleted: true) {
    ... on AircraftProjects {
      aircraftProjects {
        id
        aircraftProjectType {
          id
          abbreviation
        }
        projectStatus {
          id
        }
        aircraft {
          id
          registrationMark
        }
        isDeleted
      }
    }
  }
}
    `;

/**
 * __useCrewProjectAssociatedAircraftProjectSelectQuery__
 *
 * To run a query within a React component, call `useCrewProjectAssociatedAircraftProjectSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectAssociatedAircraftProjectSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectAssociatedAircraftProjectSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrewProjectAssociatedAircraftProjectSelectQuery(baseOptions?: Apollo.QueryHookOptions<CrewProjectAssociatedAircraftProjectSelectQuery, CrewProjectAssociatedAircraftProjectSelectQueryVariables>) {
        return Apollo.useQuery<CrewProjectAssociatedAircraftProjectSelectQuery, CrewProjectAssociatedAircraftProjectSelectQueryVariables>(CrewProjectAssociatedAircraftProjectSelectDocument, baseOptions);
      }
export function useCrewProjectAssociatedAircraftProjectSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectAssociatedAircraftProjectSelectQuery, CrewProjectAssociatedAircraftProjectSelectQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectAssociatedAircraftProjectSelectQuery, CrewProjectAssociatedAircraftProjectSelectQueryVariables>(CrewProjectAssociatedAircraftProjectSelectDocument, baseOptions);
        }
export type CrewProjectAssociatedAircraftProjectSelectQueryHookResult = ReturnType<typeof useCrewProjectAssociatedAircraftProjectSelectQuery>;
export type CrewProjectAssociatedAircraftProjectSelectLazyQueryHookResult = ReturnType<typeof useCrewProjectAssociatedAircraftProjectSelectLazyQuery>;
export type CrewProjectAssociatedAircraftProjectSelectQueryResult = Apollo.QueryResult<CrewProjectAssociatedAircraftProjectSelectQuery, CrewProjectAssociatedAircraftProjectSelectQueryVariables>;
export const CrewProjectCategorySelectOptionsDocument = gql`
    query crewProjectCategorySelectOptions($includeDeleted: Boolean) {
  crewProjectCategories(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __useCrewProjectCategorySelectOptionsQuery__
 *
 * To run a query within a React component, call `useCrewProjectCategorySelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectCategorySelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectCategorySelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useCrewProjectCategorySelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CrewProjectCategorySelectOptionsQuery, CrewProjectCategorySelectOptionsQueryVariables>) {
        return Apollo.useQuery<CrewProjectCategorySelectOptionsQuery, CrewProjectCategorySelectOptionsQueryVariables>(CrewProjectCategorySelectOptionsDocument, baseOptions);
      }
export function useCrewProjectCategorySelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectCategorySelectOptionsQuery, CrewProjectCategorySelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectCategorySelectOptionsQuery, CrewProjectCategorySelectOptionsQueryVariables>(CrewProjectCategorySelectOptionsDocument, baseOptions);
        }
export type CrewProjectCategorySelectOptionsQueryHookResult = ReturnType<typeof useCrewProjectCategorySelectOptionsQuery>;
export type CrewProjectCategorySelectOptionsLazyQueryHookResult = ReturnType<typeof useCrewProjectCategorySelectOptionsLazyQuery>;
export type CrewProjectCategorySelectOptionsQueryResult = Apollo.QueryResult<CrewProjectCategorySelectOptionsQuery, CrewProjectCategorySelectOptionsQueryVariables>;
export const CrewProjectRenewalChangeTypeOptionsDocument = gql`
    query crewProjectRenewalChangeTypeOptions {
  crewProjectRenewalChangeTypes {
    ...crewProjectRenewalChangeType
  }
}
    ${CrewProjectRenewalChangeTypeFragmentDoc}`;

/**
 * __useCrewProjectRenewalChangeTypeOptionsQuery__
 *
 * To run a query within a React component, call `useCrewProjectRenewalChangeTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectRenewalChangeTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectRenewalChangeTypeOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrewProjectRenewalChangeTypeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CrewProjectRenewalChangeTypeOptionsQuery, CrewProjectRenewalChangeTypeOptionsQueryVariables>) {
        return Apollo.useQuery<CrewProjectRenewalChangeTypeOptionsQuery, CrewProjectRenewalChangeTypeOptionsQueryVariables>(CrewProjectRenewalChangeTypeOptionsDocument, baseOptions);
      }
export function useCrewProjectRenewalChangeTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectRenewalChangeTypeOptionsQuery, CrewProjectRenewalChangeTypeOptionsQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectRenewalChangeTypeOptionsQuery, CrewProjectRenewalChangeTypeOptionsQueryVariables>(CrewProjectRenewalChangeTypeOptionsDocument, baseOptions);
        }
export type CrewProjectRenewalChangeTypeOptionsQueryHookResult = ReturnType<typeof useCrewProjectRenewalChangeTypeOptionsQuery>;
export type CrewProjectRenewalChangeTypeOptionsLazyQueryHookResult = ReturnType<typeof useCrewProjectRenewalChangeTypeOptionsLazyQuery>;
export type CrewProjectRenewalChangeTypeOptionsQueryResult = Apollo.QueryResult<CrewProjectRenewalChangeTypeOptionsQuery, CrewProjectRenewalChangeTypeOptionsQueryVariables>;
export const CrewProjectSpecialProjectTypeOptionsDocument = gql`
    query crewProjectSpecialProjectTypeOptions($includeDeleted: Boolean = false) {
  crewProjectSpecialProjectTypes(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __useCrewProjectSpecialProjectTypeOptionsQuery__
 *
 * To run a query within a React component, call `useCrewProjectSpecialProjectTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectSpecialProjectTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectSpecialProjectTypeOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useCrewProjectSpecialProjectTypeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CrewProjectSpecialProjectTypeOptionsQuery, CrewProjectSpecialProjectTypeOptionsQueryVariables>) {
        return Apollo.useQuery<CrewProjectSpecialProjectTypeOptionsQuery, CrewProjectSpecialProjectTypeOptionsQueryVariables>(CrewProjectSpecialProjectTypeOptionsDocument, baseOptions);
      }
export function useCrewProjectSpecialProjectTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectSpecialProjectTypeOptionsQuery, CrewProjectSpecialProjectTypeOptionsQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectSpecialProjectTypeOptionsQuery, CrewProjectSpecialProjectTypeOptionsQueryVariables>(CrewProjectSpecialProjectTypeOptionsDocument, baseOptions);
        }
export type CrewProjectSpecialProjectTypeOptionsQueryHookResult = ReturnType<typeof useCrewProjectSpecialProjectTypeOptionsQuery>;
export type CrewProjectSpecialProjectTypeOptionsLazyQueryHookResult = ReturnType<typeof useCrewProjectSpecialProjectTypeOptionsLazyQuery>;
export type CrewProjectSpecialProjectTypeOptionsQueryResult = Apollo.QueryResult<CrewProjectSpecialProjectTypeOptionsQuery, CrewProjectSpecialProjectTypeOptionsQueryVariables>;
export const CrewProjectTypeOptionsDocument = gql`
    query crewProjectTypeOptions($includeDeleted: Boolean = false) {
  crewProjectTypes(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __useCrewProjectTypeOptionsQuery__
 *
 * To run a query within a React component, call `useCrewProjectTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectTypeOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useCrewProjectTypeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CrewProjectTypeOptionsQuery, CrewProjectTypeOptionsQueryVariables>) {
        return Apollo.useQuery<CrewProjectTypeOptionsQuery, CrewProjectTypeOptionsQueryVariables>(CrewProjectTypeOptionsDocument, baseOptions);
      }
export function useCrewProjectTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectTypeOptionsQuery, CrewProjectTypeOptionsQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectTypeOptionsQuery, CrewProjectTypeOptionsQueryVariables>(CrewProjectTypeOptionsDocument, baseOptions);
        }
export type CrewProjectTypeOptionsQueryHookResult = ReturnType<typeof useCrewProjectTypeOptionsQuery>;
export type CrewProjectTypeOptionsLazyQueryHookResult = ReturnType<typeof useCrewProjectTypeOptionsLazyQuery>;
export type CrewProjectTypeOptionsQueryResult = Apollo.QueryResult<CrewProjectTypeOptionsQuery, CrewProjectTypeOptionsQueryVariables>;
export const CrewRatingsSelectOptionsDocument = gql`
    query crewRatingsSelectOptions($includeDeleted: Boolean, $nameContains: String) {
  crewRatings(includeDeleted: $includeDeleted, nameContains: $nameContains) {
    id
    name
  }
}
    `;

/**
 * __useCrewRatingsSelectOptionsQuery__
 *
 * To run a query within a React component, call `useCrewRatingsSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewRatingsSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewRatingsSelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *      nameContains: // value for 'nameContains'
 *   },
 * });
 */
export function useCrewRatingsSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CrewRatingsSelectOptionsQuery, CrewRatingsSelectOptionsQueryVariables>) {
        return Apollo.useQuery<CrewRatingsSelectOptionsQuery, CrewRatingsSelectOptionsQueryVariables>(CrewRatingsSelectOptionsDocument, baseOptions);
      }
export function useCrewRatingsSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewRatingsSelectOptionsQuery, CrewRatingsSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<CrewRatingsSelectOptionsQuery, CrewRatingsSelectOptionsQueryVariables>(CrewRatingsSelectOptionsDocument, baseOptions);
        }
export type CrewRatingsSelectOptionsQueryHookResult = ReturnType<typeof useCrewRatingsSelectOptionsQuery>;
export type CrewRatingsSelectOptionsLazyQueryHookResult = ReturnType<typeof useCrewRatingsSelectOptionsLazyQuery>;
export type CrewRatingsSelectOptionsQueryResult = Apollo.QueryResult<CrewRatingsSelectOptionsQuery, CrewRatingsSelectOptionsQueryVariables>;
export const DepartmentSelectOptionsDocument = gql`
    query departmentSelectOptions($includeDeleted: Boolean = false) {
  departments(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __useDepartmentSelectOptionsQuery__
 *
 * To run a query within a React component, call `useDepartmentSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentSelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useDepartmentSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<DepartmentSelectOptionsQuery, DepartmentSelectOptionsQueryVariables>) {
        return Apollo.useQuery<DepartmentSelectOptionsQuery, DepartmentSelectOptionsQueryVariables>(DepartmentSelectOptionsDocument, baseOptions);
      }
export function useDepartmentSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepartmentSelectOptionsQuery, DepartmentSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<DepartmentSelectOptionsQuery, DepartmentSelectOptionsQueryVariables>(DepartmentSelectOptionsDocument, baseOptions);
        }
export type DepartmentSelectOptionsQueryHookResult = ReturnType<typeof useDepartmentSelectOptionsQuery>;
export type DepartmentSelectOptionsLazyQueryHookResult = ReturnType<typeof useDepartmentSelectOptionsLazyQuery>;
export type DepartmentSelectOptionsQueryResult = Apollo.QueryResult<DepartmentSelectOptionsQuery, DepartmentSelectOptionsQueryVariables>;
export const ElpLevelSelectOptionsDocument = gql`
    query elpLevelSelectOptions($includeDeleted: Boolean) {
  elpLevels(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __useElpLevelSelectOptionsQuery__
 *
 * To run a query within a React component, call `useElpLevelSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useElpLevelSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useElpLevelSelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useElpLevelSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ElpLevelSelectOptionsQuery, ElpLevelSelectOptionsQueryVariables>) {
        return Apollo.useQuery<ElpLevelSelectOptionsQuery, ElpLevelSelectOptionsQueryVariables>(ElpLevelSelectOptionsDocument, baseOptions);
      }
export function useElpLevelSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ElpLevelSelectOptionsQuery, ElpLevelSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<ElpLevelSelectOptionsQuery, ElpLevelSelectOptionsQueryVariables>(ElpLevelSelectOptionsDocument, baseOptions);
        }
export type ElpLevelSelectOptionsQueryHookResult = ReturnType<typeof useElpLevelSelectOptionsQuery>;
export type ElpLevelSelectOptionsLazyQueryHookResult = ReturnType<typeof useElpLevelSelectOptionsLazyQuery>;
export type ElpLevelSelectOptionsQueryResult = Apollo.QueryResult<ElpLevelSelectOptionsQuery, ElpLevelSelectOptionsQueryVariables>;
export const FunctionalGroupsDocument = gql`
    query functionalGroups {
  functionalGroups {
    ...functionalGroup
  }
}
    ${FunctionalGroupFragmentDoc}`;

/**
 * __useFunctionalGroupsQuery__
 *
 * To run a query within a React component, call `useFunctionalGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFunctionalGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFunctionalGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFunctionalGroupsQuery(baseOptions?: Apollo.QueryHookOptions<FunctionalGroupsQuery, FunctionalGroupsQueryVariables>) {
        return Apollo.useQuery<FunctionalGroupsQuery, FunctionalGroupsQueryVariables>(FunctionalGroupsDocument, baseOptions);
      }
export function useFunctionalGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FunctionalGroupsQuery, FunctionalGroupsQueryVariables>) {
          return Apollo.useLazyQuery<FunctionalGroupsQuery, FunctionalGroupsQueryVariables>(FunctionalGroupsDocument, baseOptions);
        }
export type FunctionalGroupsQueryHookResult = ReturnType<typeof useFunctionalGroupsQuery>;
export type FunctionalGroupsLazyQueryHookResult = ReturnType<typeof useFunctionalGroupsLazyQuery>;
export type FunctionalGroupsQueryResult = Apollo.QueryResult<FunctionalGroupsQuery, FunctionalGroupsQueryVariables>;
export const GenericLvCompanySelectOptionsDocument = gql`
    query genericLvCompanySelectOptions($includeDeleted: Boolean) {
  genericLvCompanies(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __useGenericLvCompanySelectOptionsQuery__
 *
 * To run a query within a React component, call `useGenericLvCompanySelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericLvCompanySelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericLvCompanySelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useGenericLvCompanySelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GenericLvCompanySelectOptionsQuery, GenericLvCompanySelectOptionsQueryVariables>) {
        return Apollo.useQuery<GenericLvCompanySelectOptionsQuery, GenericLvCompanySelectOptionsQueryVariables>(GenericLvCompanySelectOptionsDocument, baseOptions);
      }
export function useGenericLvCompanySelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericLvCompanySelectOptionsQuery, GenericLvCompanySelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<GenericLvCompanySelectOptionsQuery, GenericLvCompanySelectOptionsQueryVariables>(GenericLvCompanySelectOptionsDocument, baseOptions);
        }
export type GenericLvCompanySelectOptionsQueryHookResult = ReturnType<typeof useGenericLvCompanySelectOptionsQuery>;
export type GenericLvCompanySelectOptionsLazyQueryHookResult = ReturnType<typeof useGenericLvCompanySelectOptionsLazyQuery>;
export type GenericLvCompanySelectOptionsQueryResult = Apollo.QueryResult<GenericLvCompanySelectOptionsQuery, GenericLvCompanySelectOptionsQueryVariables>;
export const GenericLvCompaniesSelectOptionsDocument = gql`
    query genericLvCompaniesSelectOptions($includeDeleted: Boolean, $nameContains: String) {
  genericLvCompanies(includeDeleted: $includeDeleted, nameContains: $nameContains) {
    id
    name
  }
}
    `;

/**
 * __useGenericLvCompaniesSelectOptionsQuery__
 *
 * To run a query within a React component, call `useGenericLvCompaniesSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericLvCompaniesSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericLvCompaniesSelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *      nameContains: // value for 'nameContains'
 *   },
 * });
 */
export function useGenericLvCompaniesSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GenericLvCompaniesSelectOptionsQuery, GenericLvCompaniesSelectOptionsQueryVariables>) {
        return Apollo.useQuery<GenericLvCompaniesSelectOptionsQuery, GenericLvCompaniesSelectOptionsQueryVariables>(GenericLvCompaniesSelectOptionsDocument, baseOptions);
      }
export function useGenericLvCompaniesSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericLvCompaniesSelectOptionsQuery, GenericLvCompaniesSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<GenericLvCompaniesSelectOptionsQuery, GenericLvCompaniesSelectOptionsQueryVariables>(GenericLvCompaniesSelectOptionsDocument, baseOptions);
        }
export type GenericLvCompaniesSelectOptionsQueryHookResult = ReturnType<typeof useGenericLvCompaniesSelectOptionsQuery>;
export type GenericLvCompaniesSelectOptionsLazyQueryHookResult = ReturnType<typeof useGenericLvCompaniesSelectOptionsLazyQuery>;
export type GenericLvCompaniesSelectOptionsQueryResult = Apollo.QueryResult<GenericLvCompaniesSelectOptionsQuery, GenericLvCompaniesSelectOptionsQueryVariables>;
export const MechanicCertificateTypeOptionsDocument = gql`
    query mechanicCertificateTypeOptions($includeDeleted: Boolean = false) {
  mechanicCertificateTypes(includeDeleted: $includeDeleted) {
    id
    name
    description
  }
}
    `;

/**
 * __useMechanicCertificateTypeOptionsQuery__
 *
 * To run a query within a React component, call `useMechanicCertificateTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicCertificateTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicCertificateTypeOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useMechanicCertificateTypeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<MechanicCertificateTypeOptionsQuery, MechanicCertificateTypeOptionsQueryVariables>) {
        return Apollo.useQuery<MechanicCertificateTypeOptionsQuery, MechanicCertificateTypeOptionsQueryVariables>(MechanicCertificateTypeOptionsDocument, baseOptions);
      }
export function useMechanicCertificateTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicCertificateTypeOptionsQuery, MechanicCertificateTypeOptionsQueryVariables>) {
          return Apollo.useLazyQuery<MechanicCertificateTypeOptionsQuery, MechanicCertificateTypeOptionsQueryVariables>(MechanicCertificateTypeOptionsDocument, baseOptions);
        }
export type MechanicCertificateTypeOptionsQueryHookResult = ReturnType<typeof useMechanicCertificateTypeOptionsQuery>;
export type MechanicCertificateTypeOptionsLazyQueryHookResult = ReturnType<typeof useMechanicCertificateTypeOptionsLazyQuery>;
export type MechanicCertificateTypeOptionsQueryResult = Apollo.QueryResult<MechanicCertificateTypeOptionsQuery, MechanicCertificateTypeOptionsQueryVariables>;
export const MechanicForOperatorAddMechanicProjectSelectOptionsDocument = gql`
    query mechanicForOperatorAddMechanicProjectSelectOptions($operatorId: Int!, $lastNameContains: String) {
  mechanicsForOperatorAddMechanicProject(operatorId: $operatorId, lastNameContains: $lastNameContains) {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useMechanicForOperatorAddMechanicProjectSelectOptionsQuery__
 *
 * To run a query within a React component, call `useMechanicForOperatorAddMechanicProjectSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicForOperatorAddMechanicProjectSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicForOperatorAddMechanicProjectSelectOptionsQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *      lastNameContains: // value for 'lastNameContains'
 *   },
 * });
 */
export function useMechanicForOperatorAddMechanicProjectSelectOptionsQuery(baseOptions: Apollo.QueryHookOptions<MechanicForOperatorAddMechanicProjectSelectOptionsQuery, MechanicForOperatorAddMechanicProjectSelectOptionsQueryVariables>) {
        return Apollo.useQuery<MechanicForOperatorAddMechanicProjectSelectOptionsQuery, MechanicForOperatorAddMechanicProjectSelectOptionsQueryVariables>(MechanicForOperatorAddMechanicProjectSelectOptionsDocument, baseOptions);
      }
export function useMechanicForOperatorAddMechanicProjectSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicForOperatorAddMechanicProjectSelectOptionsQuery, MechanicForOperatorAddMechanicProjectSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<MechanicForOperatorAddMechanicProjectSelectOptionsQuery, MechanicForOperatorAddMechanicProjectSelectOptionsQueryVariables>(MechanicForOperatorAddMechanicProjectSelectOptionsDocument, baseOptions);
        }
export type MechanicForOperatorAddMechanicProjectSelectOptionsQueryHookResult = ReturnType<typeof useMechanicForOperatorAddMechanicProjectSelectOptionsQuery>;
export type MechanicForOperatorAddMechanicProjectSelectOptionsLazyQueryHookResult = ReturnType<typeof useMechanicForOperatorAddMechanicProjectSelectOptionsLazyQuery>;
export type MechanicForOperatorAddMechanicProjectSelectOptionsQueryResult = Apollo.QueryResult<MechanicForOperatorAddMechanicProjectSelectOptionsQuery, MechanicForOperatorAddMechanicProjectSelectOptionsQueryVariables>;
export const MechanicLicenseTypeOptionsDocument = gql`
    query mechanicLicenseTypeOptions($includeDeleted: Boolean = false) {
  mechanicLicenseTypes(includeDeleted: $includeDeleted) {
    id
    name
    description
    isDeleted
    isForCertificateOnly
    mechanicPositions {
      id
    }
  }
}
    `;

/**
 * __useMechanicLicenseTypeOptionsQuery__
 *
 * To run a query within a React component, call `useMechanicLicenseTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicLicenseTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicLicenseTypeOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useMechanicLicenseTypeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<MechanicLicenseTypeOptionsQuery, MechanicLicenseTypeOptionsQueryVariables>) {
        return Apollo.useQuery<MechanicLicenseTypeOptionsQuery, MechanicLicenseTypeOptionsQueryVariables>(MechanicLicenseTypeOptionsDocument, baseOptions);
      }
export function useMechanicLicenseTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicLicenseTypeOptionsQuery, MechanicLicenseTypeOptionsQueryVariables>) {
          return Apollo.useLazyQuery<MechanicLicenseTypeOptionsQuery, MechanicLicenseTypeOptionsQueryVariables>(MechanicLicenseTypeOptionsDocument, baseOptions);
        }
export type MechanicLicenseTypeOptionsQueryHookResult = ReturnType<typeof useMechanicLicenseTypeOptionsQuery>;
export type MechanicLicenseTypeOptionsLazyQueryHookResult = ReturnType<typeof useMechanicLicenseTypeOptionsLazyQuery>;
export type MechanicLicenseTypeOptionsQueryResult = Apollo.QueryResult<MechanicLicenseTypeOptionsQuery, MechanicLicenseTypeOptionsQueryVariables>;
export const MechanicPositionSelectOptionsDocument = gql`
    query mechanicPositionSelectOptions($includeDeleted: Boolean = false, $mechanicLicenseTypeIdIn: [Int!]) {
  mechanicPositions(includeDeleted: $includeDeleted, mechanicLicenseTypeIdIn: $mechanicLicenseTypeIdIn) {
    id
    name
    description
  }
}
    `;

/**
 * __useMechanicPositionSelectOptionsQuery__
 *
 * To run a query within a React component, call `useMechanicPositionSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicPositionSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicPositionSelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *      mechanicLicenseTypeIdIn: // value for 'mechanicLicenseTypeIdIn'
 *   },
 * });
 */
export function useMechanicPositionSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<MechanicPositionSelectOptionsQuery, MechanicPositionSelectOptionsQueryVariables>) {
        return Apollo.useQuery<MechanicPositionSelectOptionsQuery, MechanicPositionSelectOptionsQueryVariables>(MechanicPositionSelectOptionsDocument, baseOptions);
      }
export function useMechanicPositionSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicPositionSelectOptionsQuery, MechanicPositionSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<MechanicPositionSelectOptionsQuery, MechanicPositionSelectOptionsQueryVariables>(MechanicPositionSelectOptionsDocument, baseOptions);
        }
export type MechanicPositionSelectOptionsQueryHookResult = ReturnType<typeof useMechanicPositionSelectOptionsQuery>;
export type MechanicPositionSelectOptionsLazyQueryHookResult = ReturnType<typeof useMechanicPositionSelectOptionsLazyQuery>;
export type MechanicPositionSelectOptionsQueryResult = Apollo.QueryResult<MechanicPositionSelectOptionsQuery, MechanicPositionSelectOptionsQueryVariables>;
export const MechanicProjectAssociatedAircraftProjectSelectDocument = gql`
    query mechanicProjectAssociatedAircraftProjectSelect {
  aircraftProjects(sortBy: registrationMark, includeDeleted: true) {
    ... on AircraftProjects {
      aircraftProjects {
        id
        aircraftProjectType {
          id
          abbreviation
        }
        projectStatus {
          id
        }
        aircraft {
          id
          registrationMark
        }
        isDeleted
      }
    }
  }
}
    `;

/**
 * __useMechanicProjectAssociatedAircraftProjectSelectQuery__
 *
 * To run a query within a React component, call `useMechanicProjectAssociatedAircraftProjectSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectAssociatedAircraftProjectSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectAssociatedAircraftProjectSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useMechanicProjectAssociatedAircraftProjectSelectQuery(baseOptions?: Apollo.QueryHookOptions<MechanicProjectAssociatedAircraftProjectSelectQuery, MechanicProjectAssociatedAircraftProjectSelectQueryVariables>) {
        return Apollo.useQuery<MechanicProjectAssociatedAircraftProjectSelectQuery, MechanicProjectAssociatedAircraftProjectSelectQueryVariables>(MechanicProjectAssociatedAircraftProjectSelectDocument, baseOptions);
      }
export function useMechanicProjectAssociatedAircraftProjectSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectAssociatedAircraftProjectSelectQuery, MechanicProjectAssociatedAircraftProjectSelectQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectAssociatedAircraftProjectSelectQuery, MechanicProjectAssociatedAircraftProjectSelectQueryVariables>(MechanicProjectAssociatedAircraftProjectSelectDocument, baseOptions);
        }
export type MechanicProjectAssociatedAircraftProjectSelectQueryHookResult = ReturnType<typeof useMechanicProjectAssociatedAircraftProjectSelectQuery>;
export type MechanicProjectAssociatedAircraftProjectSelectLazyQueryHookResult = ReturnType<typeof useMechanicProjectAssociatedAircraftProjectSelectLazyQuery>;
export type MechanicProjectAssociatedAircraftProjectSelectQueryResult = Apollo.QueryResult<MechanicProjectAssociatedAircraftProjectSelectQuery, MechanicProjectAssociatedAircraftProjectSelectQueryVariables>;
export const MechanicProjectRenewalChangeTypeOptionsDocument = gql`
    query mechanicProjectRenewalChangeTypeOptions {
  mechanicProjectRenewalChangeTypes {
    ...mechanicProjectRenewalChangeType
  }
}
    ${MechanicProjectRenewalChangeTypeFragmentDoc}`;

/**
 * __useMechanicProjectRenewalChangeTypeOptionsQuery__
 *
 * To run a query within a React component, call `useMechanicProjectRenewalChangeTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectRenewalChangeTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectRenewalChangeTypeOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMechanicProjectRenewalChangeTypeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<MechanicProjectRenewalChangeTypeOptionsQuery, MechanicProjectRenewalChangeTypeOptionsQueryVariables>) {
        return Apollo.useQuery<MechanicProjectRenewalChangeTypeOptionsQuery, MechanicProjectRenewalChangeTypeOptionsQueryVariables>(MechanicProjectRenewalChangeTypeOptionsDocument, baseOptions);
      }
export function useMechanicProjectRenewalChangeTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectRenewalChangeTypeOptionsQuery, MechanicProjectRenewalChangeTypeOptionsQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectRenewalChangeTypeOptionsQuery, MechanicProjectRenewalChangeTypeOptionsQueryVariables>(MechanicProjectRenewalChangeTypeOptionsDocument, baseOptions);
        }
export type MechanicProjectRenewalChangeTypeOptionsQueryHookResult = ReturnType<typeof useMechanicProjectRenewalChangeTypeOptionsQuery>;
export type MechanicProjectRenewalChangeTypeOptionsLazyQueryHookResult = ReturnType<typeof useMechanicProjectRenewalChangeTypeOptionsLazyQuery>;
export type MechanicProjectRenewalChangeTypeOptionsQueryResult = Apollo.QueryResult<MechanicProjectRenewalChangeTypeOptionsQuery, MechanicProjectRenewalChangeTypeOptionsQueryVariables>;
export const MechanicProjectTypeOptionsDocument = gql`
    query mechanicProjectTypeOptions($includeDeleted: Boolean = false) {
  mechanicProjectTypes(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __useMechanicProjectTypeOptionsQuery__
 *
 * To run a query within a React component, call `useMechanicProjectTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectTypeOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useMechanicProjectTypeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<MechanicProjectTypeOptionsQuery, MechanicProjectTypeOptionsQueryVariables>) {
        return Apollo.useQuery<MechanicProjectTypeOptionsQuery, MechanicProjectTypeOptionsQueryVariables>(MechanicProjectTypeOptionsDocument, baseOptions);
      }
export function useMechanicProjectTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectTypeOptionsQuery, MechanicProjectTypeOptionsQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectTypeOptionsQuery, MechanicProjectTypeOptionsQueryVariables>(MechanicProjectTypeOptionsDocument, baseOptions);
        }
export type MechanicProjectTypeOptionsQueryHookResult = ReturnType<typeof useMechanicProjectTypeOptionsQuery>;
export type MechanicProjectTypeOptionsLazyQueryHookResult = ReturnType<typeof useMechanicProjectTypeOptionsLazyQuery>;
export type MechanicProjectTypeOptionsQueryResult = Apollo.QueryResult<MechanicProjectTypeOptionsQuery, MechanicProjectTypeOptionsQueryVariables>;
export const MechanicRatingsSelectOptionsDocument = gql`
    query mechanicRatingsSelectOptions($includeDeleted: Boolean, $nameContains: String) {
  mechanicRatings(includeDeleted: $includeDeleted, nameContains: $nameContains) {
    id
    name
  }
}
    `;

/**
 * __useMechanicRatingsSelectOptionsQuery__
 *
 * To run a query within a React component, call `useMechanicRatingsSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicRatingsSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicRatingsSelectOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *      nameContains: // value for 'nameContains'
 *   },
 * });
 */
export function useMechanicRatingsSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<MechanicRatingsSelectOptionsQuery, MechanicRatingsSelectOptionsQueryVariables>) {
        return Apollo.useQuery<MechanicRatingsSelectOptionsQuery, MechanicRatingsSelectOptionsQueryVariables>(MechanicRatingsSelectOptionsDocument, baseOptions);
      }
export function useMechanicRatingsSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicRatingsSelectOptionsQuery, MechanicRatingsSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<MechanicRatingsSelectOptionsQuery, MechanicRatingsSelectOptionsQueryVariables>(MechanicRatingsSelectOptionsDocument, baseOptions);
        }
export type MechanicRatingsSelectOptionsQueryHookResult = ReturnType<typeof useMechanicRatingsSelectOptionsQuery>;
export type MechanicRatingsSelectOptionsLazyQueryHookResult = ReturnType<typeof useMechanicRatingsSelectOptionsLazyQuery>;
export type MechanicRatingsSelectOptionsQueryResult = Apollo.QueryResult<MechanicRatingsSelectOptionsQuery, MechanicRatingsSelectOptionsQueryVariables>;
export const MechanicSelectOptionsDocument = gql`
    query mechanicSelectOptions($lastNameContains: String) {
  mechanics(lastNameContains: $lastNameContains) {
    ... on Mechanics {
      mechanics {
        id
        firstName
        lastName
        country {
          name
        }
        validationNumber
        activeMechanicProjects {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useMechanicSelectOptionsQuery__
 *
 * To run a query within a React component, call `useMechanicSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicSelectOptionsQuery({
 *   variables: {
 *      lastNameContains: // value for 'lastNameContains'
 *   },
 * });
 */
export function useMechanicSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<MechanicSelectOptionsQuery, MechanicSelectOptionsQueryVariables>) {
        return Apollo.useQuery<MechanicSelectOptionsQuery, MechanicSelectOptionsQueryVariables>(MechanicSelectOptionsDocument, baseOptions);
      }
export function useMechanicSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicSelectOptionsQuery, MechanicSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<MechanicSelectOptionsQuery, MechanicSelectOptionsQueryVariables>(MechanicSelectOptionsDocument, baseOptions);
        }
export type MechanicSelectOptionsQueryHookResult = ReturnType<typeof useMechanicSelectOptionsQuery>;
export type MechanicSelectOptionsLazyQueryHookResult = ReturnType<typeof useMechanicSelectOptionsLazyQuery>;
export type MechanicSelectOptionsQueryResult = Apollo.QueryResult<MechanicSelectOptionsQuery, MechanicSelectOptionsQueryVariables>;
export const OperatorAircraftModelOptionsDocument = gql`
    query operatorAircraftModelOptions($operatorId: Int!) {
  aircrafts(operatorIdIn: [$operatorId], includeProvisional: false, includeDeleted: false, excludeDeregistered: true, sortBy: aircraftModel) {
    ... on Aircrafts {
      aircrafts {
        aircraftStatus {
          id
        }
        aircraftModel {
          ...aircraftModel
        }
      }
    }
  }
}
    ${AircraftModelFragmentDoc}`;

/**
 * __useOperatorAircraftModelOptionsQuery__
 *
 * To run a query within a React component, call `useOperatorAircraftModelOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorAircraftModelOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorAircraftModelOptionsQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *   },
 * });
 */
export function useOperatorAircraftModelOptionsQuery(baseOptions: Apollo.QueryHookOptions<OperatorAircraftModelOptionsQuery, OperatorAircraftModelOptionsQueryVariables>) {
        return Apollo.useQuery<OperatorAircraftModelOptionsQuery, OperatorAircraftModelOptionsQueryVariables>(OperatorAircraftModelOptionsDocument, baseOptions);
      }
export function useOperatorAircraftModelOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorAircraftModelOptionsQuery, OperatorAircraftModelOptionsQueryVariables>) {
          return Apollo.useLazyQuery<OperatorAircraftModelOptionsQuery, OperatorAircraftModelOptionsQueryVariables>(OperatorAircraftModelOptionsDocument, baseOptions);
        }
export type OperatorAircraftModelOptionsQueryHookResult = ReturnType<typeof useOperatorAircraftModelOptionsQuery>;
export type OperatorAircraftModelOptionsLazyQueryHookResult = ReturnType<typeof useOperatorAircraftModelOptionsLazyQuery>;
export type OperatorAircraftModelOptionsQueryResult = Apollo.QueryResult<OperatorAircraftModelOptionsQuery, OperatorAircraftModelOptionsQueryVariables>;
export const OperatorSelectOptionsDocument = gql`
    query operatorSelectOptions {
  operators {
    ... on Operators {
      operators {
        ...operatorLookup
      }
    }
  }
}
    ${OperatorLookupFragmentDoc}`;

/**
 * __useOperatorSelectOptionsQuery__
 *
 * To run a query within a React component, call `useOperatorSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorSelectOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOperatorSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<OperatorSelectOptionsQuery, OperatorSelectOptionsQueryVariables>) {
        return Apollo.useQuery<OperatorSelectOptionsQuery, OperatorSelectOptionsQueryVariables>(OperatorSelectOptionsDocument, baseOptions);
      }
export function useOperatorSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorSelectOptionsQuery, OperatorSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<OperatorSelectOptionsQuery, OperatorSelectOptionsQueryVariables>(OperatorSelectOptionsDocument, baseOptions);
        }
export type OperatorSelectOptionsQueryHookResult = ReturnType<typeof useOperatorSelectOptionsQuery>;
export type OperatorSelectOptionsLazyQueryHookResult = ReturnType<typeof useOperatorSelectOptionsLazyQuery>;
export type OperatorSelectOptionsQueryResult = Apollo.QueryResult<OperatorSelectOptionsQuery, OperatorSelectOptionsQueryVariables>;
export const PaymentStatusOptionsDocument = gql`
    query paymentStatusOptions($includeDeleted: Boolean = false) {
  paymentStatuses(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __usePaymentStatusOptionsQuery__
 *
 * To run a query within a React component, call `usePaymentStatusOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentStatusOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentStatusOptionsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function usePaymentStatusOptionsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentStatusOptionsQuery, PaymentStatusOptionsQueryVariables>) {
        return Apollo.useQuery<PaymentStatusOptionsQuery, PaymentStatusOptionsQueryVariables>(PaymentStatusOptionsDocument, baseOptions);
      }
export function usePaymentStatusOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentStatusOptionsQuery, PaymentStatusOptionsQueryVariables>) {
          return Apollo.useLazyQuery<PaymentStatusOptionsQuery, PaymentStatusOptionsQueryVariables>(PaymentStatusOptionsDocument, baseOptions);
        }
export type PaymentStatusOptionsQueryHookResult = ReturnType<typeof usePaymentStatusOptionsQuery>;
export type PaymentStatusOptionsLazyQueryHookResult = ReturnType<typeof usePaymentStatusOptionsLazyQuery>;
export type PaymentStatusOptionsQueryResult = Apollo.QueryResult<PaymentStatusOptionsQuery, PaymentStatusOptionsQueryVariables>;
export const ReminderApplicabilitiesDocument = gql`
    query reminderApplicabilities($includeDeleted: Boolean = false) {
  reminderApplicabilities(includeDeleted: $includeDeleted) {
    id
    name
  }
}
    `;

/**
 * __useReminderApplicabilitiesQuery__
 *
 * To run a query within a React component, call `useReminderApplicabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReminderApplicabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReminderApplicabilitiesQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useReminderApplicabilitiesQuery(baseOptions?: Apollo.QueryHookOptions<ReminderApplicabilitiesQuery, ReminderApplicabilitiesQueryVariables>) {
        return Apollo.useQuery<ReminderApplicabilitiesQuery, ReminderApplicabilitiesQueryVariables>(ReminderApplicabilitiesDocument, baseOptions);
      }
export function useReminderApplicabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReminderApplicabilitiesQuery, ReminderApplicabilitiesQueryVariables>) {
          return Apollo.useLazyQuery<ReminderApplicabilitiesQuery, ReminderApplicabilitiesQueryVariables>(ReminderApplicabilitiesDocument, baseOptions);
        }
export type ReminderApplicabilitiesQueryHookResult = ReturnType<typeof useReminderApplicabilitiesQuery>;
export type ReminderApplicabilitiesLazyQueryHookResult = ReturnType<typeof useReminderApplicabilitiesLazyQuery>;
export type ReminderApplicabilitiesQueryResult = Apollo.QueryResult<ReminderApplicabilitiesQuery, ReminderApplicabilitiesQueryVariables>;
export const RolesDocument = gql`
    query roles {
  roles {
    ...role
  }
}
    ${RoleFragmentDoc}`;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, baseOptions);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, baseOptions);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const UserSelectOptionsDocument = gql`
    query userSelectOptions($roleIdIn: [Int!], $departmentIdIn: [Int!], $isActive: Boolean, $idIn: [Int!]) {
  users(roleIdIn: $roleIdIn, departmentIdIn: $departmentIdIn, isActive: $isActive, idIn: $idIn) {
    ... on Users {
      users {
        ...user
      }
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserSelectOptionsQuery__
 *
 * To run a query within a React component, call `useUserSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSelectOptionsQuery({
 *   variables: {
 *      roleIdIn: // value for 'roleIdIn'
 *      departmentIdIn: // value for 'departmentIdIn'
 *      isActive: // value for 'isActive'
 *      idIn: // value for 'idIn'
 *   },
 * });
 */
export function useUserSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<UserSelectOptionsQuery, UserSelectOptionsQueryVariables>) {
        return Apollo.useQuery<UserSelectOptionsQuery, UserSelectOptionsQueryVariables>(UserSelectOptionsDocument, baseOptions);
      }
export function useUserSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSelectOptionsQuery, UserSelectOptionsQueryVariables>) {
          return Apollo.useLazyQuery<UserSelectOptionsQuery, UserSelectOptionsQueryVariables>(UserSelectOptionsDocument, baseOptions);
        }
export type UserSelectOptionsQueryHookResult = ReturnType<typeof useUserSelectOptionsQuery>;
export type UserSelectOptionsLazyQueryHookResult = ReturnType<typeof useUserSelectOptionsLazyQuery>;
export type UserSelectOptionsQueryResult = Apollo.QueryResult<UserSelectOptionsQuery, UserSelectOptionsQueryVariables>;
export const InspectionLookupsDocument = gql`
    query inspectionLookups {
  inspectionStatuses(includeDeleted: false) {
    ...inspectionStatus
  }
  inspectors {
    ... on Inspectors {
      inspectors {
        ...inspectorLookup
      }
    }
  }
  regions(includeDeleted: true) {
    ...regionLookup
  }
  countries(includeDeleted: true) {
    ...countryLookup
  }
  states(includeDeleted: true) {
    ...stateLookup
  }
}
    ${InspectionStatusFragmentDoc}
${InspectorLookupFragmentDoc}
${RegionLookupFragmentDoc}
${CountryLookupFragmentDoc}
${StateLookupFragmentDoc}`;

/**
 * __useInspectionLookupsQuery__
 *
 * To run a query within a React component, call `useInspectionLookupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionLookupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionLookupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInspectionLookupsQuery(baseOptions?: Apollo.QueryHookOptions<InspectionLookupsQuery, InspectionLookupsQueryVariables>) {
        return Apollo.useQuery<InspectionLookupsQuery, InspectionLookupsQueryVariables>(InspectionLookupsDocument, baseOptions);
      }
export function useInspectionLookupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionLookupsQuery, InspectionLookupsQueryVariables>) {
          return Apollo.useLazyQuery<InspectionLookupsQuery, InspectionLookupsQueryVariables>(InspectionLookupsDocument, baseOptions);
        }
export type InspectionLookupsQueryHookResult = ReturnType<typeof useInspectionLookupsQuery>;
export type InspectionLookupsLazyQueryHookResult = ReturnType<typeof useInspectionLookupsLazyQuery>;
export type InspectionLookupsQueryResult = Apollo.QueryResult<InspectionLookupsQuery, InspectionLookupsQueryVariables>;
export const InspectionHistoryGridDocument = gql`
    query inspectionHistoryGrid($sortBy: InspectorInspectionsSortBy, $sortDirection: String, $aircraftId: Int, $paginationOptions: PaginationOptions) {
  inspectorInspections(sortBy: $sortBy, sortDirection: $sortDirection, aircraftId: $aircraftId, includeAllProjects: true, paginationOptions: $paginationOptions) {
    ... on PaginatedInspectorInspections {
      totalItems
      inspectorInspections {
        ...inspectionHistoryGridItem
      }
    }
    ... on InspectorInspections {
      inspectorInspections {
        ...inspectionHistoryGridItem
      }
    }
  }
}
    ${InspectionHistoryGridItemFragmentDoc}`;

/**
 * __useInspectionHistoryGridQuery__
 *
 * To run a query within a React component, call `useInspectionHistoryGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionHistoryGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionHistoryGridQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      aircraftId: // value for 'aircraftId'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useInspectionHistoryGridQuery(baseOptions?: Apollo.QueryHookOptions<InspectionHistoryGridQuery, InspectionHistoryGridQueryVariables>) {
        return Apollo.useQuery<InspectionHistoryGridQuery, InspectionHistoryGridQueryVariables>(InspectionHistoryGridDocument, baseOptions);
      }
export function useInspectionHistoryGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionHistoryGridQuery, InspectionHistoryGridQueryVariables>) {
          return Apollo.useLazyQuery<InspectionHistoryGridQuery, InspectionHistoryGridQueryVariables>(InspectionHistoryGridDocument, baseOptions);
        }
export type InspectionHistoryGridQueryHookResult = ReturnType<typeof useInspectionHistoryGridQuery>;
export type InspectionHistoryGridLazyQueryHookResult = ReturnType<typeof useInspectionHistoryGridLazyQuery>;
export type InspectionHistoryGridQueryResult = Apollo.QueryResult<InspectionHistoryGridQuery, InspectionHistoryGridQueryVariables>;
export const ProjectInsFormVersionCommentsDocument = gql`
    query projectInsFormVersionComments($id: Int!) {
  projectInsFormVersionComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useProjectInsFormVersionCommentsQuery__
 *
 * To run a query within a React component, call `useProjectInsFormVersionCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectInsFormVersionCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectInsFormVersionCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectInsFormVersionCommentsQuery(baseOptions: Apollo.QueryHookOptions<ProjectInsFormVersionCommentsQuery, ProjectInsFormVersionCommentsQueryVariables>) {
        return Apollo.useQuery<ProjectInsFormVersionCommentsQuery, ProjectInsFormVersionCommentsQueryVariables>(ProjectInsFormVersionCommentsDocument, baseOptions);
      }
export function useProjectInsFormVersionCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectInsFormVersionCommentsQuery, ProjectInsFormVersionCommentsQueryVariables>) {
          return Apollo.useLazyQuery<ProjectInsFormVersionCommentsQuery, ProjectInsFormVersionCommentsQueryVariables>(ProjectInsFormVersionCommentsDocument, baseOptions);
        }
export type ProjectInsFormVersionCommentsQueryHookResult = ReturnType<typeof useProjectInsFormVersionCommentsQuery>;
export type ProjectInsFormVersionCommentsLazyQueryHookResult = ReturnType<typeof useProjectInsFormVersionCommentsLazyQuery>;
export type ProjectInsFormVersionCommentsQueryResult = Apollo.QueryResult<ProjectInsFormVersionCommentsQuery, ProjectInsFormVersionCommentsQueryVariables>;
export const UpdateProjectInsFormVersionCommentsLastViewedDateDocument = gql`
    mutation updateProjectInsFormVersionCommentsLastViewedDate($id: Int!) {
  updateProjectInsFormVersionCommentsLastViewedDate(projectInsFormVersionId: $id) {
    id
  }
}
    `;
export type UpdateProjectInsFormVersionCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateProjectInsFormVersionCommentsLastViewedDateMutation, UpdateProjectInsFormVersionCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateProjectInsFormVersionCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateProjectInsFormVersionCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectInsFormVersionCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectInsFormVersionCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateProjectInsFormVersionCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateProjectInsFormVersionCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectInsFormVersionCommentsLastViewedDateMutation, UpdateProjectInsFormVersionCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateProjectInsFormVersionCommentsLastViewedDateMutation, UpdateProjectInsFormVersionCommentsLastViewedDateMutationVariables>(UpdateProjectInsFormVersionCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateProjectInsFormVersionCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateProjectInsFormVersionCommentsLastViewedDateMutation>;
export type UpdateProjectInsFormVersionCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateProjectInsFormVersionCommentsLastViewedDateMutation>;
export type UpdateProjectInsFormVersionCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateProjectInsFormVersionCommentsLastViewedDateMutation, UpdateProjectInsFormVersionCommentsLastViewedDateMutationVariables>;
export const LocationLookupsDocument = gql`
    query locationLookups {
  regions {
    ...regionLookup
  }
  countries {
    ...countryLookup
  }
  states {
    ...stateLookup
  }
}
    ${RegionLookupFragmentDoc}
${CountryLookupFragmentDoc}
${StateLookupFragmentDoc}`;

/**
 * __useLocationLookupsQuery__
 *
 * To run a query within a React component, call `useLocationLookupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationLookupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationLookupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationLookupsQuery(baseOptions?: Apollo.QueryHookOptions<LocationLookupsQuery, LocationLookupsQueryVariables>) {
        return Apollo.useQuery<LocationLookupsQuery, LocationLookupsQueryVariables>(LocationLookupsDocument, baseOptions);
      }
export function useLocationLookupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationLookupsQuery, LocationLookupsQueryVariables>) {
          return Apollo.useLazyQuery<LocationLookupsQuery, LocationLookupsQueryVariables>(LocationLookupsDocument, baseOptions);
        }
export type LocationLookupsQueryHookResult = ReturnType<typeof useLocationLookupsQuery>;
export type LocationLookupsLazyQueryHookResult = ReturnType<typeof useLocationLookupsLazyQuery>;
export type LocationLookupsQueryResult = Apollo.QueryResult<LocationLookupsQuery, LocationLookupsQueryVariables>;
export const AllRegionsDocument = gql`
    query allRegions {
  regions {
    ...regionLookup
  }
}
    ${RegionLookupFragmentDoc}`;

/**
 * __useAllRegionsQuery__
 *
 * To run a query within a React component, call `useAllRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllRegionsQuery(baseOptions?: Apollo.QueryHookOptions<AllRegionsQuery, AllRegionsQueryVariables>) {
        return Apollo.useQuery<AllRegionsQuery, AllRegionsQueryVariables>(AllRegionsDocument, baseOptions);
      }
export function useAllRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRegionsQuery, AllRegionsQueryVariables>) {
          return Apollo.useLazyQuery<AllRegionsQuery, AllRegionsQueryVariables>(AllRegionsDocument, baseOptions);
        }
export type AllRegionsQueryHookResult = ReturnType<typeof useAllRegionsQuery>;
export type AllRegionsLazyQueryHookResult = ReturnType<typeof useAllRegionsLazyQuery>;
export type AllRegionsQueryResult = Apollo.QueryResult<AllRegionsQuery, AllRegionsQueryVariables>;
export const AllCountriesDocument = gql`
    query allCountries {
  countries {
    ...countryLookup
  }
}
    ${CountryLookupFragmentDoc}`;

/**
 * __useAllCountriesQuery__
 *
 * To run a query within a React component, call `useAllCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCountriesQuery(baseOptions?: Apollo.QueryHookOptions<AllCountriesQuery, AllCountriesQueryVariables>) {
        return Apollo.useQuery<AllCountriesQuery, AllCountriesQueryVariables>(AllCountriesDocument, baseOptions);
      }
export function useAllCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCountriesQuery, AllCountriesQueryVariables>) {
          return Apollo.useLazyQuery<AllCountriesQuery, AllCountriesQueryVariables>(AllCountriesDocument, baseOptions);
        }
export type AllCountriesQueryHookResult = ReturnType<typeof useAllCountriesQuery>;
export type AllCountriesLazyQueryHookResult = ReturnType<typeof useAllCountriesLazyQuery>;
export type AllCountriesQueryResult = Apollo.QueryResult<AllCountriesQuery, AllCountriesQueryVariables>;
export const PhoneNumberTypesDocument = gql`
    query phoneNumberTypes {
  phoneNumberTypes {
    ...phoneNumberType
  }
}
    ${PhoneNumberTypeFragmentDoc}`;

/**
 * __usePhoneNumberTypesQuery__
 *
 * To run a query within a React component, call `usePhoneNumberTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneNumberTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneNumberTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePhoneNumberTypesQuery(baseOptions?: Apollo.QueryHookOptions<PhoneNumberTypesQuery, PhoneNumberTypesQueryVariables>) {
        return Apollo.useQuery<PhoneNumberTypesQuery, PhoneNumberTypesQueryVariables>(PhoneNumberTypesDocument, baseOptions);
      }
export function usePhoneNumberTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhoneNumberTypesQuery, PhoneNumberTypesQueryVariables>) {
          return Apollo.useLazyQuery<PhoneNumberTypesQuery, PhoneNumberTypesQueryVariables>(PhoneNumberTypesDocument, baseOptions);
        }
export type PhoneNumberTypesQueryHookResult = ReturnType<typeof usePhoneNumberTypesQuery>;
export type PhoneNumberTypesLazyQueryHookResult = ReturnType<typeof usePhoneNumberTypesLazyQuery>;
export type PhoneNumberTypesQueryResult = Apollo.QueryResult<PhoneNumberTypesQuery, PhoneNumberTypesQueryVariables>;
export const EmailAddressTypesDocument = gql`
    query emailAddressTypes {
  emailAddressTypes {
    ...emailAddressType
  }
}
    ${EmailAddressTypeFragmentDoc}`;

/**
 * __useEmailAddressTypesQuery__
 *
 * To run a query within a React component, call `useEmailAddressTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailAddressTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmailAddressTypesQuery(baseOptions?: Apollo.QueryHookOptions<EmailAddressTypesQuery, EmailAddressTypesQueryVariables>) {
        return Apollo.useQuery<EmailAddressTypesQuery, EmailAddressTypesQueryVariables>(EmailAddressTypesDocument, baseOptions);
      }
export function useEmailAddressTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailAddressTypesQuery, EmailAddressTypesQueryVariables>) {
          return Apollo.useLazyQuery<EmailAddressTypesQuery, EmailAddressTypesQueryVariables>(EmailAddressTypesDocument, baseOptions);
        }
export type EmailAddressTypesQueryHookResult = ReturnType<typeof useEmailAddressTypesQuery>;
export type EmailAddressTypesLazyQueryHookResult = ReturnType<typeof useEmailAddressTypesLazyQuery>;
export type EmailAddressTypesQueryResult = Apollo.QueryResult<EmailAddressTypesQuery, EmailAddressTypesQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const BannerAlertsForHeaderDisplayDocument = gql`
    query bannerAlertsForHeaderDisplay {
  bannerAlerts(isEnabled: true) {
    ...bannerAlertForHeaderDisplay
  }
}
    ${BannerAlertForHeaderDisplayFragmentDoc}`;

/**
 * __useBannerAlertsForHeaderDisplayQuery__
 *
 * To run a query within a React component, call `useBannerAlertsForHeaderDisplayQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannerAlertsForHeaderDisplayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannerAlertsForHeaderDisplayQuery({
 *   variables: {
 *   },
 * });
 */
export function useBannerAlertsForHeaderDisplayQuery(baseOptions?: Apollo.QueryHookOptions<BannerAlertsForHeaderDisplayQuery, BannerAlertsForHeaderDisplayQueryVariables>) {
        return Apollo.useQuery<BannerAlertsForHeaderDisplayQuery, BannerAlertsForHeaderDisplayQueryVariables>(BannerAlertsForHeaderDisplayDocument, baseOptions);
      }
export function useBannerAlertsForHeaderDisplayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BannerAlertsForHeaderDisplayQuery, BannerAlertsForHeaderDisplayQueryVariables>) {
          return Apollo.useLazyQuery<BannerAlertsForHeaderDisplayQuery, BannerAlertsForHeaderDisplayQueryVariables>(BannerAlertsForHeaderDisplayDocument, baseOptions);
        }
export type BannerAlertsForHeaderDisplayQueryHookResult = ReturnType<typeof useBannerAlertsForHeaderDisplayQuery>;
export type BannerAlertsForHeaderDisplayLazyQueryHookResult = ReturnType<typeof useBannerAlertsForHeaderDisplayLazyQuery>;
export type BannerAlertsForHeaderDisplayQueryResult = Apollo.QueryResult<BannerAlertsForHeaderDisplayQuery, BannerAlertsForHeaderDisplayQueryVariables>;
export const AircraftCommentsDocument = gql`
    query aircraftComments($id: Int!) {
  aircraftComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useAircraftCommentsQuery__
 *
 * To run a query within a React component, call `useAircraftCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAircraftCommentsQuery(baseOptions: Apollo.QueryHookOptions<AircraftCommentsQuery, AircraftCommentsQueryVariables>) {
        return Apollo.useQuery<AircraftCommentsQuery, AircraftCommentsQueryVariables>(AircraftCommentsDocument, baseOptions);
      }
export function useAircraftCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftCommentsQuery, AircraftCommentsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftCommentsQuery, AircraftCommentsQueryVariables>(AircraftCommentsDocument, baseOptions);
        }
export type AircraftCommentsQueryHookResult = ReturnType<typeof useAircraftCommentsQuery>;
export type AircraftCommentsLazyQueryHookResult = ReturnType<typeof useAircraftCommentsLazyQuery>;
export type AircraftCommentsQueryResult = Apollo.QueryResult<AircraftCommentsQuery, AircraftCommentsQueryVariables>;
export const AddAircraftCommentDocument = gql`
    mutation addAircraftComment($id: Int!, $input: CommentInput!) {
  addAircraftComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddAircraftCommentMutationFn = Apollo.MutationFunction<AddAircraftCommentMutation, AddAircraftCommentMutationVariables>;

/**
 * __useAddAircraftCommentMutation__
 *
 * To run a mutation, you first call `useAddAircraftCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAircraftCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAircraftCommentMutation, { data, loading, error }] = useAddAircraftCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAircraftCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddAircraftCommentMutation, AddAircraftCommentMutationVariables>) {
        return Apollo.useMutation<AddAircraftCommentMutation, AddAircraftCommentMutationVariables>(AddAircraftCommentDocument, baseOptions);
      }
export type AddAircraftCommentMutationHookResult = ReturnType<typeof useAddAircraftCommentMutation>;
export type AddAircraftCommentMutationResult = Apollo.MutationResult<AddAircraftCommentMutation>;
export type AddAircraftCommentMutationOptions = Apollo.BaseMutationOptions<AddAircraftCommentMutation, AddAircraftCommentMutationVariables>;
export const UpdateAircraftCommentDocument = gql`
    mutation updateAircraftComment($id: Int!, $body: String!) {
  updateAircraftComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateAircraftCommentMutationFn = Apollo.MutationFunction<UpdateAircraftCommentMutation, UpdateAircraftCommentMutationVariables>;

/**
 * __useUpdateAircraftCommentMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftCommentMutation, { data, loading, error }] = useUpdateAircraftCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateAircraftCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftCommentMutation, UpdateAircraftCommentMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftCommentMutation, UpdateAircraftCommentMutationVariables>(UpdateAircraftCommentDocument, baseOptions);
      }
export type UpdateAircraftCommentMutationHookResult = ReturnType<typeof useUpdateAircraftCommentMutation>;
export type UpdateAircraftCommentMutationResult = Apollo.MutationResult<UpdateAircraftCommentMutation>;
export type UpdateAircraftCommentMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftCommentMutation, UpdateAircraftCommentMutationVariables>;
export const UpdateAircraftCommentsLastViewedDateDocument = gql`
    mutation updateAircraftCommentsLastViewedDate($id: Int!) {
  updateAircraftCommentsLastViewedDate(aircraftId: $id) {
    id
  }
}
    `;
export type UpdateAircraftCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateAircraftCommentsLastViewedDateMutation, UpdateAircraftCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateAircraftCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateAircraftCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAircraftCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftCommentsLastViewedDateMutation, UpdateAircraftCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftCommentsLastViewedDateMutation, UpdateAircraftCommentsLastViewedDateMutationVariables>(UpdateAircraftCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateAircraftCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateAircraftCommentsLastViewedDateMutation>;
export type UpdateAircraftCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateAircraftCommentsLastViewedDateMutation>;
export type UpdateAircraftCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftCommentsLastViewedDateMutation, UpdateAircraftCommentsLastViewedDateMutationVariables>;
export const AircraftDocumentsQueryDocument = gql`
    query aircraftDocumentsQuery($aircraftId: Int!, $documentTypeCategoryId: DocumentTypeCategoryEnum!) {
  documents: aircraftDocuments(aircraftId: $aircraftId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...aircraftDocument
  }
  documentTypes: aircraftDocumentTypes(aircraftId: $aircraftId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...documentType
  }
}
    ${AircraftDocumentFragmentDoc}
${DocumentTypeFragmentDoc}`;

/**
 * __useAircraftDocumentsQueryQuery__
 *
 * To run a query within a React component, call `useAircraftDocumentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftDocumentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftDocumentsQueryQuery({
 *   variables: {
 *      aircraftId: // value for 'aircraftId'
 *      documentTypeCategoryId: // value for 'documentTypeCategoryId'
 *   },
 * });
 */
export function useAircraftDocumentsQueryQuery(baseOptions: Apollo.QueryHookOptions<AircraftDocumentsQueryQuery, AircraftDocumentsQueryQueryVariables>) {
        return Apollo.useQuery<AircraftDocumentsQueryQuery, AircraftDocumentsQueryQueryVariables>(AircraftDocumentsQueryDocument, baseOptions);
      }
export function useAircraftDocumentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftDocumentsQueryQuery, AircraftDocumentsQueryQueryVariables>) {
          return Apollo.useLazyQuery<AircraftDocumentsQueryQuery, AircraftDocumentsQueryQueryVariables>(AircraftDocumentsQueryDocument, baseOptions);
        }
export type AircraftDocumentsQueryQueryHookResult = ReturnType<typeof useAircraftDocumentsQueryQuery>;
export type AircraftDocumentsQueryLazyQueryHookResult = ReturnType<typeof useAircraftDocumentsQueryLazyQuery>;
export type AircraftDocumentsQueryQueryResult = Apollo.QueryResult<AircraftDocumentsQueryQuery, AircraftDocumentsQueryQueryVariables>;
export const AddAircraftDocumentMutationDocument = gql`
    mutation addAircraftDocumentMutation($addAircraftDocumentInput: AddAircraftDocumentInput!) {
  addAircraftDocument(addAircraftDocumentInput: $addAircraftDocumentInput) {
    id
  }
}
    `;
export type AddAircraftDocumentMutationMutationFn = Apollo.MutationFunction<AddAircraftDocumentMutationMutation, AddAircraftDocumentMutationMutationVariables>;

/**
 * __useAddAircraftDocumentMutationMutation__
 *
 * To run a mutation, you first call `useAddAircraftDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAircraftDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAircraftDocumentMutationMutation, { data, loading, error }] = useAddAircraftDocumentMutationMutation({
 *   variables: {
 *      addAircraftDocumentInput: // value for 'addAircraftDocumentInput'
 *   },
 * });
 */
export function useAddAircraftDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddAircraftDocumentMutationMutation, AddAircraftDocumentMutationMutationVariables>) {
        return Apollo.useMutation<AddAircraftDocumentMutationMutation, AddAircraftDocumentMutationMutationVariables>(AddAircraftDocumentMutationDocument, baseOptions);
      }
export type AddAircraftDocumentMutationMutationHookResult = ReturnType<typeof useAddAircraftDocumentMutationMutation>;
export type AddAircraftDocumentMutationMutationResult = Apollo.MutationResult<AddAircraftDocumentMutationMutation>;
export type AddAircraftDocumentMutationMutationOptions = Apollo.BaseMutationOptions<AddAircraftDocumentMutationMutation, AddAircraftDocumentMutationMutationVariables>;
export const UpdateAircraftDocumentMutationDocument = gql`
    mutation updateAircraftDocumentMutation($updateAircraftDocumentInput: UpdateAircraftDocumentInput!) {
  updateAircraftDocument(updateAircraftDocumentInput: $updateAircraftDocumentInput) {
    id
  }
}
    `;
export type UpdateAircraftDocumentMutationMutationFn = Apollo.MutationFunction<UpdateAircraftDocumentMutationMutation, UpdateAircraftDocumentMutationMutationVariables>;

/**
 * __useUpdateAircraftDocumentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftDocumentMutationMutation, { data, loading, error }] = useUpdateAircraftDocumentMutationMutation({
 *   variables: {
 *      updateAircraftDocumentInput: // value for 'updateAircraftDocumentInput'
 *   },
 * });
 */
export function useUpdateAircraftDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftDocumentMutationMutation, UpdateAircraftDocumentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftDocumentMutationMutation, UpdateAircraftDocumentMutationMutationVariables>(UpdateAircraftDocumentMutationDocument, baseOptions);
      }
export type UpdateAircraftDocumentMutationMutationHookResult = ReturnType<typeof useUpdateAircraftDocumentMutationMutation>;
export type UpdateAircraftDocumentMutationMutationResult = Apollo.MutationResult<UpdateAircraftDocumentMutationMutation>;
export type UpdateAircraftDocumentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftDocumentMutationMutation, UpdateAircraftDocumentMutationMutationVariables>;
export const RemoveAircraftDocumentMutationDocument = gql`
    mutation removeAircraftDocumentMutation($id: Int!) {
  removeAircraftDocument(id: $id)
}
    `;
export type RemoveAircraftDocumentMutationMutationFn = Apollo.MutationFunction<RemoveAircraftDocumentMutationMutation, RemoveAircraftDocumentMutationMutationVariables>;

/**
 * __useRemoveAircraftDocumentMutationMutation__
 *
 * To run a mutation, you first call `useRemoveAircraftDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAircraftDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAircraftDocumentMutationMutation, { data, loading, error }] = useRemoveAircraftDocumentMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAircraftDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAircraftDocumentMutationMutation, RemoveAircraftDocumentMutationMutationVariables>) {
        return Apollo.useMutation<RemoveAircraftDocumentMutationMutation, RemoveAircraftDocumentMutationMutationVariables>(RemoveAircraftDocumentMutationDocument, baseOptions);
      }
export type RemoveAircraftDocumentMutationMutationHookResult = ReturnType<typeof useRemoveAircraftDocumentMutationMutation>;
export type RemoveAircraftDocumentMutationMutationResult = Apollo.MutationResult<RemoveAircraftDocumentMutationMutation>;
export type RemoveAircraftDocumentMutationMutationOptions = Apollo.BaseMutationOptions<RemoveAircraftDocumentMutationMutation, RemoveAircraftDocumentMutationMutationVariables>;
export const DownloadAircraftDocumentDocument = gql`
    query downloadAircraftDocument($id: Int!, $aicraftId: Int!) {
  file: downloadAircraftDocument(id: $id, aircraftId: $aicraftId) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadAircraftDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      aicraftId: // value for 'aicraftId'
 *   },
 * });
 */
export function useDownloadAircraftDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftDocumentQuery, DownloadAircraftDocumentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftDocumentQuery, DownloadAircraftDocumentQueryVariables>(DownloadAircraftDocumentDocument, baseOptions);
      }
export function useDownloadAircraftDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftDocumentQuery, DownloadAircraftDocumentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftDocumentQuery, DownloadAircraftDocumentQueryVariables>(DownloadAircraftDocumentDocument, baseOptions);
        }
export type DownloadAircraftDocumentQueryHookResult = ReturnType<typeof useDownloadAircraftDocumentQuery>;
export type DownloadAircraftDocumentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftDocumentLazyQuery>;
export type DownloadAircraftDocumentQueryResult = Apollo.QueryResult<DownloadAircraftDocumentQuery, DownloadAircraftDocumentQueryVariables>;
export const AircraftInsFormAssociatedDocumentsQueryDocument = gql`
    query aircraftInsFormAssociatedDocumentsQuery($aircraftId: Int!) {
  aircraft(id: $aircraftId) {
    documents: insFormAssociatedDocuments {
      ...aircraftInsFormAssociatedDocument
    }
    insForms {
      id
      name
      title
      associatedDocumentTypes {
        ...associatedDocumentType
      }
    }
  }
  insFormAssociatedDocumentGroups {
    ...insFormAssociatedDocumentGroup
  }
}
    ${AircraftInsFormAssociatedDocumentFragmentDoc}
${AssociatedDocumentTypeFragmentDoc}
${InsFormAssociatedDocumentGroupFragmentDoc}`;

/**
 * __useAircraftInsFormAssociatedDocumentsQueryQuery__
 *
 * To run a query within a React component, call `useAircraftInsFormAssociatedDocumentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftInsFormAssociatedDocumentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftInsFormAssociatedDocumentsQueryQuery({
 *   variables: {
 *      aircraftId: // value for 'aircraftId'
 *   },
 * });
 */
export function useAircraftInsFormAssociatedDocumentsQueryQuery(baseOptions: Apollo.QueryHookOptions<AircraftInsFormAssociatedDocumentsQueryQuery, AircraftInsFormAssociatedDocumentsQueryQueryVariables>) {
        return Apollo.useQuery<AircraftInsFormAssociatedDocumentsQueryQuery, AircraftInsFormAssociatedDocumentsQueryQueryVariables>(AircraftInsFormAssociatedDocumentsQueryDocument, baseOptions);
      }
export function useAircraftInsFormAssociatedDocumentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftInsFormAssociatedDocumentsQueryQuery, AircraftInsFormAssociatedDocumentsQueryQueryVariables>) {
          return Apollo.useLazyQuery<AircraftInsFormAssociatedDocumentsQueryQuery, AircraftInsFormAssociatedDocumentsQueryQueryVariables>(AircraftInsFormAssociatedDocumentsQueryDocument, baseOptions);
        }
export type AircraftInsFormAssociatedDocumentsQueryQueryHookResult = ReturnType<typeof useAircraftInsFormAssociatedDocumentsQueryQuery>;
export type AircraftInsFormAssociatedDocumentsQueryLazyQueryHookResult = ReturnType<typeof useAircraftInsFormAssociatedDocumentsQueryLazyQuery>;
export type AircraftInsFormAssociatedDocumentsQueryQueryResult = Apollo.QueryResult<AircraftInsFormAssociatedDocumentsQueryQuery, AircraftInsFormAssociatedDocumentsQueryQueryVariables>;
export const AddAircraftInsFormAssociatedDocumentMutationDocument = gql`
    mutation addAircraftInsFormAssociatedDocumentMutation($addAircraftInsFormAssociatedDocumentInput: AddAircraftInsFormAssociatedDocumentInput!) {
  addAircraftInsFormAssociatedDocument(addAircraftInsFormAssociatedDocumentInput: $addAircraftInsFormAssociatedDocumentInput) {
    id
  }
}
    `;
export type AddAircraftInsFormAssociatedDocumentMutationMutationFn = Apollo.MutationFunction<AddAircraftInsFormAssociatedDocumentMutationMutation, AddAircraftInsFormAssociatedDocumentMutationMutationVariables>;

/**
 * __useAddAircraftInsFormAssociatedDocumentMutationMutation__
 *
 * To run a mutation, you first call `useAddAircraftInsFormAssociatedDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAircraftInsFormAssociatedDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAircraftInsFormAssociatedDocumentMutationMutation, { data, loading, error }] = useAddAircraftInsFormAssociatedDocumentMutationMutation({
 *   variables: {
 *      addAircraftInsFormAssociatedDocumentInput: // value for 'addAircraftInsFormAssociatedDocumentInput'
 *   },
 * });
 */
export function useAddAircraftInsFormAssociatedDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddAircraftInsFormAssociatedDocumentMutationMutation, AddAircraftInsFormAssociatedDocumentMutationMutationVariables>) {
        return Apollo.useMutation<AddAircraftInsFormAssociatedDocumentMutationMutation, AddAircraftInsFormAssociatedDocumentMutationMutationVariables>(AddAircraftInsFormAssociatedDocumentMutationDocument, baseOptions);
      }
export type AddAircraftInsFormAssociatedDocumentMutationMutationHookResult = ReturnType<typeof useAddAircraftInsFormAssociatedDocumentMutationMutation>;
export type AddAircraftInsFormAssociatedDocumentMutationMutationResult = Apollo.MutationResult<AddAircraftInsFormAssociatedDocumentMutationMutation>;
export type AddAircraftInsFormAssociatedDocumentMutationMutationOptions = Apollo.BaseMutationOptions<AddAircraftInsFormAssociatedDocumentMutationMutation, AddAircraftInsFormAssociatedDocumentMutationMutationVariables>;
export const UpdateAircraftInsFormAssociatedDocumentMutationDocument = gql`
    mutation updateAircraftInsFormAssociatedDocumentMutation($updateAircraftInsFormAssociatedDocumentInput: UpdateAircraftInsFormAssociatedDocumentInput!) {
  updateAircraftInsFormAssociatedDocument(updateAircraftInsFormAssociatedDocumentInput: $updateAircraftInsFormAssociatedDocumentInput) {
    id
  }
}
    `;
export type UpdateAircraftInsFormAssociatedDocumentMutationMutationFn = Apollo.MutationFunction<UpdateAircraftInsFormAssociatedDocumentMutationMutation, UpdateAircraftInsFormAssociatedDocumentMutationMutationVariables>;

/**
 * __useUpdateAircraftInsFormAssociatedDocumentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftInsFormAssociatedDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftInsFormAssociatedDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftInsFormAssociatedDocumentMutationMutation, { data, loading, error }] = useUpdateAircraftInsFormAssociatedDocumentMutationMutation({
 *   variables: {
 *      updateAircraftInsFormAssociatedDocumentInput: // value for 'updateAircraftInsFormAssociatedDocumentInput'
 *   },
 * });
 */
export function useUpdateAircraftInsFormAssociatedDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftInsFormAssociatedDocumentMutationMutation, UpdateAircraftInsFormAssociatedDocumentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftInsFormAssociatedDocumentMutationMutation, UpdateAircraftInsFormAssociatedDocumentMutationMutationVariables>(UpdateAircraftInsFormAssociatedDocumentMutationDocument, baseOptions);
      }
export type UpdateAircraftInsFormAssociatedDocumentMutationMutationHookResult = ReturnType<typeof useUpdateAircraftInsFormAssociatedDocumentMutationMutation>;
export type UpdateAircraftInsFormAssociatedDocumentMutationMutationResult = Apollo.MutationResult<UpdateAircraftInsFormAssociatedDocumentMutationMutation>;
export type UpdateAircraftInsFormAssociatedDocumentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftInsFormAssociatedDocumentMutationMutation, UpdateAircraftInsFormAssociatedDocumentMutationMutationVariables>;
export const RemoveAircraftInsFormAssociatedDocumentMutationDocument = gql`
    mutation removeAircraftInsFormAssociatedDocumentMutation($id: Int!) {
  removeAircraftInsFormAssociatedDocument(id: $id)
}
    `;
export type RemoveAircraftInsFormAssociatedDocumentMutationMutationFn = Apollo.MutationFunction<RemoveAircraftInsFormAssociatedDocumentMutationMutation, RemoveAircraftInsFormAssociatedDocumentMutationMutationVariables>;

/**
 * __useRemoveAircraftInsFormAssociatedDocumentMutationMutation__
 *
 * To run a mutation, you first call `useRemoveAircraftInsFormAssociatedDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAircraftInsFormAssociatedDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAircraftInsFormAssociatedDocumentMutationMutation, { data, loading, error }] = useRemoveAircraftInsFormAssociatedDocumentMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAircraftInsFormAssociatedDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAircraftInsFormAssociatedDocumentMutationMutation, RemoveAircraftInsFormAssociatedDocumentMutationMutationVariables>) {
        return Apollo.useMutation<RemoveAircraftInsFormAssociatedDocumentMutationMutation, RemoveAircraftInsFormAssociatedDocumentMutationMutationVariables>(RemoveAircraftInsFormAssociatedDocumentMutationDocument, baseOptions);
      }
export type RemoveAircraftInsFormAssociatedDocumentMutationMutationHookResult = ReturnType<typeof useRemoveAircraftInsFormAssociatedDocumentMutationMutation>;
export type RemoveAircraftInsFormAssociatedDocumentMutationMutationResult = Apollo.MutationResult<RemoveAircraftInsFormAssociatedDocumentMutationMutation>;
export type RemoveAircraftInsFormAssociatedDocumentMutationMutationOptions = Apollo.BaseMutationOptions<RemoveAircraftInsFormAssociatedDocumentMutationMutation, RemoveAircraftInsFormAssociatedDocumentMutationMutationVariables>;
export const DownloadAircraftInsFormAssociatedDocumentDocument = gql`
    query downloadAircraftInsFormAssociatedDocument($id: Int!, $aircraftId: Int!) {
  file: downloadAircraftInsFormAssociatedDocument(id: $id, aircraftId: $aircraftId) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadAircraftInsFormAssociatedDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftInsFormAssociatedDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftInsFormAssociatedDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftInsFormAssociatedDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      aircraftId: // value for 'aircraftId'
 *   },
 * });
 */
export function useDownloadAircraftInsFormAssociatedDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftInsFormAssociatedDocumentQuery, DownloadAircraftInsFormAssociatedDocumentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftInsFormAssociatedDocumentQuery, DownloadAircraftInsFormAssociatedDocumentQueryVariables>(DownloadAircraftInsFormAssociatedDocumentDocument, baseOptions);
      }
export function useDownloadAircraftInsFormAssociatedDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftInsFormAssociatedDocumentQuery, DownloadAircraftInsFormAssociatedDocumentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftInsFormAssociatedDocumentQuery, DownloadAircraftInsFormAssociatedDocumentQueryVariables>(DownloadAircraftInsFormAssociatedDocumentDocument, baseOptions);
        }
export type DownloadAircraftInsFormAssociatedDocumentQueryHookResult = ReturnType<typeof useDownloadAircraftInsFormAssociatedDocumentQuery>;
export type DownloadAircraftInsFormAssociatedDocumentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftInsFormAssociatedDocumentLazyQuery>;
export type DownloadAircraftInsFormAssociatedDocumentQueryResult = Apollo.QueryResult<DownloadAircraftInsFormAssociatedDocumentQuery, DownloadAircraftInsFormAssociatedDocumentQueryVariables>;
export const BulkUpdateCrewAircraftDocument = gql`
    query bulkUpdateCrewAircraft($aircraftId: Int!) {
  aircraft(id: $aircraftId) {
    ...bulkUpdateCrewAircraftInfo
  }
}
    ${BulkUpdateCrewAircraftInfoFragmentDoc}`;

/**
 * __useBulkUpdateCrewAircraftQuery__
 *
 * To run a query within a React component, call `useBulkUpdateCrewAircraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateCrewAircraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkUpdateCrewAircraftQuery({
 *   variables: {
 *      aircraftId: // value for 'aircraftId'
 *   },
 * });
 */
export function useBulkUpdateCrewAircraftQuery(baseOptions: Apollo.QueryHookOptions<BulkUpdateCrewAircraftQuery, BulkUpdateCrewAircraftQueryVariables>) {
        return Apollo.useQuery<BulkUpdateCrewAircraftQuery, BulkUpdateCrewAircraftQueryVariables>(BulkUpdateCrewAircraftDocument, baseOptions);
      }
export function useBulkUpdateCrewAircraftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkUpdateCrewAircraftQuery, BulkUpdateCrewAircraftQueryVariables>) {
          return Apollo.useLazyQuery<BulkUpdateCrewAircraftQuery, BulkUpdateCrewAircraftQueryVariables>(BulkUpdateCrewAircraftDocument, baseOptions);
        }
export type BulkUpdateCrewAircraftQueryHookResult = ReturnType<typeof useBulkUpdateCrewAircraftQuery>;
export type BulkUpdateCrewAircraftLazyQueryHookResult = ReturnType<typeof useBulkUpdateCrewAircraftLazyQuery>;
export type BulkUpdateCrewAircraftQueryResult = Apollo.QueryResult<BulkUpdateCrewAircraftQuery, BulkUpdateCrewAircraftQueryVariables>;
export const BulkUpdateCrewSearchDocument = gql`
    query bulkUpdateCrewSearch($operatorId: Int!) {
  crewMembers(operatorIdIn: [$operatorId], crewMemberStatusId: 1, includeProvisional: false, sortBy: lastName) {
    ... on CrewMembers {
      crewMembers {
        ...bulkUpdateCrewSearchCrewMember
      }
    }
  }
}
    ${BulkUpdateCrewSearchCrewMemberFragmentDoc}`;

/**
 * __useBulkUpdateCrewSearchQuery__
 *
 * To run a query within a React component, call `useBulkUpdateCrewSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateCrewSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkUpdateCrewSearchQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *   },
 * });
 */
export function useBulkUpdateCrewSearchQuery(baseOptions: Apollo.QueryHookOptions<BulkUpdateCrewSearchQuery, BulkUpdateCrewSearchQueryVariables>) {
        return Apollo.useQuery<BulkUpdateCrewSearchQuery, BulkUpdateCrewSearchQueryVariables>(BulkUpdateCrewSearchDocument, baseOptions);
      }
export function useBulkUpdateCrewSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkUpdateCrewSearchQuery, BulkUpdateCrewSearchQueryVariables>) {
          return Apollo.useLazyQuery<BulkUpdateCrewSearchQuery, BulkUpdateCrewSearchQueryVariables>(BulkUpdateCrewSearchDocument, baseOptions);
        }
export type BulkUpdateCrewSearchQueryHookResult = ReturnType<typeof useBulkUpdateCrewSearchQuery>;
export type BulkUpdateCrewSearchLazyQueryHookResult = ReturnType<typeof useBulkUpdateCrewSearchLazyQuery>;
export type BulkUpdateCrewSearchQueryResult = Apollo.QueryResult<BulkUpdateCrewSearchQuery, BulkUpdateCrewSearchQueryVariables>;
export const BulkUpdateAircraftCrewMembersDocument = gql`
    mutation bulkUpdateAircraftCrewMembers($aircraftId: Int!, $crewMemberIds: [Int!]!) {
  bulkUpdateAircraftCrewMembers(input: {aircraftId: $aircraftId, crewMemberIds: $crewMemberIds})
}
    `;
export type BulkUpdateAircraftCrewMembersMutationFn = Apollo.MutationFunction<BulkUpdateAircraftCrewMembersMutation, BulkUpdateAircraftCrewMembersMutationVariables>;

/**
 * __useBulkUpdateAircraftCrewMembersMutation__
 *
 * To run a mutation, you first call `useBulkUpdateAircraftCrewMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateAircraftCrewMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateAircraftCrewMembersMutation, { data, loading, error }] = useBulkUpdateAircraftCrewMembersMutation({
 *   variables: {
 *      aircraftId: // value for 'aircraftId'
 *      crewMemberIds: // value for 'crewMemberIds'
 *   },
 * });
 */
export function useBulkUpdateAircraftCrewMembersMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateAircraftCrewMembersMutation, BulkUpdateAircraftCrewMembersMutationVariables>) {
        return Apollo.useMutation<BulkUpdateAircraftCrewMembersMutation, BulkUpdateAircraftCrewMembersMutationVariables>(BulkUpdateAircraftCrewMembersDocument, baseOptions);
      }
export type BulkUpdateAircraftCrewMembersMutationHookResult = ReturnType<typeof useBulkUpdateAircraftCrewMembersMutation>;
export type BulkUpdateAircraftCrewMembersMutationResult = Apollo.MutationResult<BulkUpdateAircraftCrewMembersMutation>;
export type BulkUpdateAircraftCrewMembersMutationOptions = Apollo.BaseMutationOptions<BulkUpdateAircraftCrewMembersMutation, BulkUpdateAircraftCrewMembersMutationVariables>;
export const AircraftGridFilterLookupsQueryDocument = gql`
    query aircraftGridFilterLookupsQuery {
  countries {
    ...aircraftCountry
  }
  operators {
    ... on Operators {
      operators {
        ...aircraftOperator
      }
    }
  }
  aircraftStatuses {
    ...aircraftStatusLookup
  }
}
    ${AircraftCountryFragmentDoc}
${AircraftOperatorFragmentDoc}
${AircraftStatusLookupFragmentDoc}`;

/**
 * __useAircraftGridFilterLookupsQueryQuery__
 *
 * To run a query within a React component, call `useAircraftGridFilterLookupsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftGridFilterLookupsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftGridFilterLookupsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAircraftGridFilterLookupsQueryQuery(baseOptions?: Apollo.QueryHookOptions<AircraftGridFilterLookupsQueryQuery, AircraftGridFilterLookupsQueryQueryVariables>) {
        return Apollo.useQuery<AircraftGridFilterLookupsQueryQuery, AircraftGridFilterLookupsQueryQueryVariables>(AircraftGridFilterLookupsQueryDocument, baseOptions);
      }
export function useAircraftGridFilterLookupsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftGridFilterLookupsQueryQuery, AircraftGridFilterLookupsQueryQueryVariables>) {
          return Apollo.useLazyQuery<AircraftGridFilterLookupsQueryQuery, AircraftGridFilterLookupsQueryQueryVariables>(AircraftGridFilterLookupsQueryDocument, baseOptions);
        }
export type AircraftGridFilterLookupsQueryQueryHookResult = ReturnType<typeof useAircraftGridFilterLookupsQueryQuery>;
export type AircraftGridFilterLookupsQueryLazyQueryHookResult = ReturnType<typeof useAircraftGridFilterLookupsQueryLazyQuery>;
export type AircraftGridFilterLookupsQueryQueryResult = Apollo.QueryResult<AircraftGridFilterLookupsQueryQuery, AircraftGridFilterLookupsQueryQueryVariables>;
export const AircraftGridDocument = gql`
    query aircraftGrid($aircraftStatusIdIn: [Int!], $cOfAStatus: String, $cOfRStatus: String, $baseOfOperationsCountryIdIn: [Int!], $homeBaseCountryIdIn: [Int!], $operatorIdIn: [Int!], $ownerIdIn: [Int!], $registeredHolderIdIn: [Int!], $mtowMinimum: Int, $mtowMaximum: Int, $designatedAirspaceAircraftOperationalApprovalFilters: [AircraftOperationalApprovalsFilterBy!], $allWeatherOpsAircraftOperationalApprovalFilters: [AircraftOperationalApprovalsFilterBy!], $efbAircraftOperationalApprovalFilters: [AircraftOperationalApprovalsFilterBy!], $hudAircraftOperationalApprovalFilters: [AircraftOperationalApprovalsFilterBy!], $cpdlcAircraftOperationalApprovalFilters: [AircraftOperationalApprovalsFilterBy!], $etopsAircraftOperationalApprovalFilters: [AircraftOperationalApprovalsFilterBy!], $keyword: String, $sortBy: AircraftsSortBy, $sortDirection: String, $paginationOptions: PaginationOptions) {
  aircrafts(aircraftStatusIdIn: $aircraftStatusIdIn, cOfAStatus: $cOfAStatus, cOfRStatus: $cOfRStatus, baseOfOperationsCountryIdIn: $baseOfOperationsCountryIdIn, homeBaseCountryIdIn: $homeBaseCountryIdIn, operatorIdIn: $operatorIdIn, ownerIdIn: $ownerIdIn, registeredHolderIdIn: $registeredHolderIdIn, mtowMinimum: $mtowMinimum, mtowMaximum: $mtowMaximum, designatedAirspaceAircraftOperationalApprovalFilters: $designatedAirspaceAircraftOperationalApprovalFilters, allWeatherOpsAircraftOperationalApprovalFilters: $allWeatherOpsAircraftOperationalApprovalFilters, efbAircraftOperationalApprovalFilters: $efbAircraftOperationalApprovalFilters, hudAircraftOperationalApprovalFilters: $hudAircraftOperationalApprovalFilters, cpdlcAircraftOperationalApprovalFilters: $cpdlcAircraftOperationalApprovalFilters, etopsAircraftOperationalApprovalFilters: $etopsAircraftOperationalApprovalFilters, keyword: $keyword, sortBy: $sortBy, sortDirection: $sortDirection, paginationOptions: $paginationOptions) {
    ... on PaginatedAircrafts {
      totalItems
      aircrafts {
        ...aircraftGridItem
      }
    }
    ... on Aircrafts {
      aircrafts {
        ...aircraftGridItem
      }
    }
  }
}
    ${AircraftGridItemFragmentDoc}`;

/**
 * __useAircraftGridQuery__
 *
 * To run a query within a React component, call `useAircraftGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftGridQuery({
 *   variables: {
 *      aircraftStatusIdIn: // value for 'aircraftStatusIdIn'
 *      cOfAStatus: // value for 'cOfAStatus'
 *      cOfRStatus: // value for 'cOfRStatus'
 *      baseOfOperationsCountryIdIn: // value for 'baseOfOperationsCountryIdIn'
 *      homeBaseCountryIdIn: // value for 'homeBaseCountryIdIn'
 *      operatorIdIn: // value for 'operatorIdIn'
 *      ownerIdIn: // value for 'ownerIdIn'
 *      registeredHolderIdIn: // value for 'registeredHolderIdIn'
 *      mtowMinimum: // value for 'mtowMinimum'
 *      mtowMaximum: // value for 'mtowMaximum'
 *      designatedAirspaceAircraftOperationalApprovalFilters: // value for 'designatedAirspaceAircraftOperationalApprovalFilters'
 *      allWeatherOpsAircraftOperationalApprovalFilters: // value for 'allWeatherOpsAircraftOperationalApprovalFilters'
 *      efbAircraftOperationalApprovalFilters: // value for 'efbAircraftOperationalApprovalFilters'
 *      hudAircraftOperationalApprovalFilters: // value for 'hudAircraftOperationalApprovalFilters'
 *      cpdlcAircraftOperationalApprovalFilters: // value for 'cpdlcAircraftOperationalApprovalFilters'
 *      etopsAircraftOperationalApprovalFilters: // value for 'etopsAircraftOperationalApprovalFilters'
 *      keyword: // value for 'keyword'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useAircraftGridQuery(baseOptions?: Apollo.QueryHookOptions<AircraftGridQuery, AircraftGridQueryVariables>) {
        return Apollo.useQuery<AircraftGridQuery, AircraftGridQueryVariables>(AircraftGridDocument, baseOptions);
      }
export function useAircraftGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftGridQuery, AircraftGridQueryVariables>) {
          return Apollo.useLazyQuery<AircraftGridQuery, AircraftGridQueryVariables>(AircraftGridDocument, baseOptions);
        }
export type AircraftGridQueryHookResult = ReturnType<typeof useAircraftGridQuery>;
export type AircraftGridLazyQueryHookResult = ReturnType<typeof useAircraftGridLazyQuery>;
export type AircraftGridQueryResult = Apollo.QueryResult<AircraftGridQuery, AircraftGridQueryVariables>;
export const AircraftDetailDocument = gql`
    query aircraftDetail($id: Int!) {
  aircraft(id: $id) {
    ...aircraftDetail
  }
  aircraftTypes(includeDeleted: true) {
    ...aircraftType
  }
  aircraftCategories(includeDeleted: true) {
    ...aircraftCategory
  }
  aircraftClasses(includeDeleted: true) {
    ...aircraftClass
  }
  aircraftModels(includeDeleted: true) {
    ...aircraftModel
  }
  aircraftManufacturers(includeDeleted: true) {
    ...aircraftManufacturer
  }
  aircraftEngineManufacturers(includeDeleted: true) {
    ...aircraftEngineManufacturer
  }
  aircraftPropellerManufacturers(includeDeleted: true) {
    ...aircraftPropellerManufacturer
  }
}
    ${AircraftDetailFragmentDoc}
${AircraftTypeFragmentDoc}
${AircraftCategoryFragmentDoc}
${AircraftClassFragmentDoc}
${AircraftModelFragmentDoc}
${AircraftManufacturerFragmentDoc}
${AircraftEngineManufacturerFragmentDoc}
${AircraftPropellerManufacturerFragmentDoc}`;

/**
 * __useAircraftDetailQuery__
 *
 * To run a query within a React component, call `useAircraftDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAircraftDetailQuery(baseOptions: Apollo.QueryHookOptions<AircraftDetailQuery, AircraftDetailQueryVariables>) {
        return Apollo.useQuery<AircraftDetailQuery, AircraftDetailQueryVariables>(AircraftDetailDocument, baseOptions);
      }
export function useAircraftDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftDetailQuery, AircraftDetailQueryVariables>) {
          return Apollo.useLazyQuery<AircraftDetailQuery, AircraftDetailQueryVariables>(AircraftDetailDocument, baseOptions);
        }
export type AircraftDetailQueryHookResult = ReturnType<typeof useAircraftDetailQuery>;
export type AircraftDetailLazyQueryHookResult = ReturnType<typeof useAircraftDetailLazyQuery>;
export type AircraftDetailQueryResult = Apollo.QueryResult<AircraftDetailQuery, AircraftDetailQueryVariables>;
export const AircraftOperationalApprovalDocument = gql`
    query aircraftOperationalApproval($aircraftId: Int!) {
  aircraftOperationalApproval(aircraftId: $aircraftId) {
    ...aircraftOperationalApproval
  }
}
    ${AircraftOperationalApprovalFragmentDoc}`;

/**
 * __useAircraftOperationalApprovalQuery__
 *
 * To run a query within a React component, call `useAircraftOperationalApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftOperationalApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftOperationalApprovalQuery({
 *   variables: {
 *      aircraftId: // value for 'aircraftId'
 *   },
 * });
 */
export function useAircraftOperationalApprovalQuery(baseOptions: Apollo.QueryHookOptions<AircraftOperationalApprovalQuery, AircraftOperationalApprovalQueryVariables>) {
        return Apollo.useQuery<AircraftOperationalApprovalQuery, AircraftOperationalApprovalQueryVariables>(AircraftOperationalApprovalDocument, baseOptions);
      }
export function useAircraftOperationalApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftOperationalApprovalQuery, AircraftOperationalApprovalQueryVariables>) {
          return Apollo.useLazyQuery<AircraftOperationalApprovalQuery, AircraftOperationalApprovalQueryVariables>(AircraftOperationalApprovalDocument, baseOptions);
        }
export type AircraftOperationalApprovalQueryHookResult = ReturnType<typeof useAircraftOperationalApprovalQuery>;
export type AircraftOperationalApprovalLazyQueryHookResult = ReturnType<typeof useAircraftOperationalApprovalLazyQuery>;
export type AircraftOperationalApprovalQueryResult = Apollo.QueryResult<AircraftOperationalApprovalQuery, AircraftOperationalApprovalQueryVariables>;
export const UpdateAircraftDocument = gql`
    mutation updateAircraft($input: UpdateAircraftInput!) {
  updateAircraft(input: $input) {
    id
  }
}
    `;
export type UpdateAircraftMutationFn = Apollo.MutationFunction<UpdateAircraftMutation, UpdateAircraftMutationVariables>;

/**
 * __useUpdateAircraftMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftMutation, { data, loading, error }] = useUpdateAircraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftMutation, UpdateAircraftMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftMutation, UpdateAircraftMutationVariables>(UpdateAircraftDocument, baseOptions);
      }
export type UpdateAircraftMutationHookResult = ReturnType<typeof useUpdateAircraftMutation>;
export type UpdateAircraftMutationResult = Apollo.MutationResult<UpdateAircraftMutation>;
export type UpdateAircraftMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftMutation, UpdateAircraftMutationVariables>;
export const UpdateAircraftOperationalApprovalDocument = gql`
    mutation updateAircraftOperationalApproval($input: UpdateAircraftOperationalApprovalInput!) {
  updateAircraftOperationalApproval(input: $input) {
    aircraftId
  }
}
    `;
export type UpdateAircraftOperationalApprovalMutationFn = Apollo.MutationFunction<UpdateAircraftOperationalApprovalMutation, UpdateAircraftOperationalApprovalMutationVariables>;

/**
 * __useUpdateAircraftOperationalApprovalMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftOperationalApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftOperationalApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftOperationalApprovalMutation, { data, loading, error }] = useUpdateAircraftOperationalApprovalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftOperationalApprovalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftOperationalApprovalMutation, UpdateAircraftOperationalApprovalMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftOperationalApprovalMutation, UpdateAircraftOperationalApprovalMutationVariables>(UpdateAircraftOperationalApprovalDocument, baseOptions);
      }
export type UpdateAircraftOperationalApprovalMutationHookResult = ReturnType<typeof useUpdateAircraftOperationalApprovalMutation>;
export type UpdateAircraftOperationalApprovalMutationResult = Apollo.MutationResult<UpdateAircraftOperationalApprovalMutation>;
export type UpdateAircraftOperationalApprovalMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftOperationalApprovalMutation, UpdateAircraftOperationalApprovalMutationVariables>;
export const AircraftMainLookupsDocument = gql`
    query aircraftMainLookups {
  aircraftStatuses(includeDeleted: true) {
    ...aircraftStatus
  }
  operators(includeInactive: true, includeDeleted: true) {
    ... on Operators {
      operators {
        ...operatorLookup
      }
    }
  }
  owners(includeInactive: true, includeDeleted: true) {
    ... on Owners {
      owners {
        ...aircraftOwnerLookup
      }
    }
  }
  registeredHolders(includeInactive: true, includeDeleted: true) {
    ... on RegisteredHolders {
      registeredHolders {
        ...aircraftRegisteredHolderLookup
      }
    }
  }
}
    ${AircraftStatusFragmentDoc}
${OperatorLookupFragmentDoc}
${AircraftOwnerLookupFragmentDoc}
${AircraftRegisteredHolderLookupFragmentDoc}`;

/**
 * __useAircraftMainLookupsQuery__
 *
 * To run a query within a React component, call `useAircraftMainLookupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftMainLookupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftMainLookupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAircraftMainLookupsQuery(baseOptions?: Apollo.QueryHookOptions<AircraftMainLookupsQuery, AircraftMainLookupsQueryVariables>) {
        return Apollo.useQuery<AircraftMainLookupsQuery, AircraftMainLookupsQueryVariables>(AircraftMainLookupsDocument, baseOptions);
      }
export function useAircraftMainLookupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftMainLookupsQuery, AircraftMainLookupsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftMainLookupsQuery, AircraftMainLookupsQueryVariables>(AircraftMainLookupsDocument, baseOptions);
        }
export type AircraftMainLookupsQueryHookResult = ReturnType<typeof useAircraftMainLookupsQuery>;
export type AircraftMainLookupsLazyQueryHookResult = ReturnType<typeof useAircraftMainLookupsLazyQuery>;
export type AircraftMainLookupsQueryResult = Apollo.QueryResult<AircraftMainLookupsQuery, AircraftMainLookupsQueryVariables>;
export const ApproveAircraftProjectCertificateDocument = gql`
    mutation approveAircraftProjectCertificate($aircraftProjectId: Int!, $documentTypeId: Int!, $ignoreWarnings: Boolean) {
  approveAircraftProjectDocumentType(aircraftProjectId: $aircraftProjectId, documentTypeId: $documentTypeId, ignoreWarnings: $ignoreWarnings) {
    id
    warnings
  }
}
    `;
export type ApproveAircraftProjectCertificateMutationFn = Apollo.MutationFunction<ApproveAircraftProjectCertificateMutation, ApproveAircraftProjectCertificateMutationVariables>;

/**
 * __useApproveAircraftProjectCertificateMutation__
 *
 * To run a mutation, you first call `useApproveAircraftProjectCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveAircraftProjectCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveAircraftProjectCertificateMutation, { data, loading, error }] = useApproveAircraftProjectCertificateMutation({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      documentTypeId: // value for 'documentTypeId'
 *      ignoreWarnings: // value for 'ignoreWarnings'
 *   },
 * });
 */
export function useApproveAircraftProjectCertificateMutation(baseOptions?: Apollo.MutationHookOptions<ApproveAircraftProjectCertificateMutation, ApproveAircraftProjectCertificateMutationVariables>) {
        return Apollo.useMutation<ApproveAircraftProjectCertificateMutation, ApproveAircraftProjectCertificateMutationVariables>(ApproveAircraftProjectCertificateDocument, baseOptions);
      }
export type ApproveAircraftProjectCertificateMutationHookResult = ReturnType<typeof useApproveAircraftProjectCertificateMutation>;
export type ApproveAircraftProjectCertificateMutationResult = Apollo.MutationResult<ApproveAircraftProjectCertificateMutation>;
export type ApproveAircraftProjectCertificateMutationOptions = Apollo.BaseMutationOptions<ApproveAircraftProjectCertificateMutation, ApproveAircraftProjectCertificateMutationVariables>;
export const ReopenAircraftProjectCertificateDocument = gql`
    mutation reopenAircraftProjectCertificate($aircraftProjectId: Int!, $documentTypeId: Int!) {
  reopenAircraftProjectDocumentTypeForApproval(aircraftProjectId: $aircraftProjectId, documentTypeId: $documentTypeId) {
    id
    warnings
  }
}
    `;
export type ReopenAircraftProjectCertificateMutationFn = Apollo.MutationFunction<ReopenAircraftProjectCertificateMutation, ReopenAircraftProjectCertificateMutationVariables>;

/**
 * __useReopenAircraftProjectCertificateMutation__
 *
 * To run a mutation, you first call `useReopenAircraftProjectCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenAircraftProjectCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenAircraftProjectCertificateMutation, { data, loading, error }] = useReopenAircraftProjectCertificateMutation({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      documentTypeId: // value for 'documentTypeId'
 *   },
 * });
 */
export function useReopenAircraftProjectCertificateMutation(baseOptions?: Apollo.MutationHookOptions<ReopenAircraftProjectCertificateMutation, ReopenAircraftProjectCertificateMutationVariables>) {
        return Apollo.useMutation<ReopenAircraftProjectCertificateMutation, ReopenAircraftProjectCertificateMutationVariables>(ReopenAircraftProjectCertificateDocument, baseOptions);
      }
export type ReopenAircraftProjectCertificateMutationHookResult = ReturnType<typeof useReopenAircraftProjectCertificateMutation>;
export type ReopenAircraftProjectCertificateMutationResult = Apollo.MutationResult<ReopenAircraftProjectCertificateMutation>;
export type ReopenAircraftProjectCertificateMutationOptions = Apollo.BaseMutationOptions<ReopenAircraftProjectCertificateMutation, ReopenAircraftProjectCertificateMutationVariables>;
export const ReturnAircraftProjectCertificateForAdditionalReviewDocument = gql`
    mutation returnAircraftProjectCertificateForAdditionalReview($aircraftProjectId: Int!, $documentTypeId: Int!) {
  returnAircraftProjectDocumentTypeForAdditionalReview(aircraftProjectId: $aircraftProjectId, documentTypeId: $documentTypeId) {
    id
    warnings
  }
}
    `;
export type ReturnAircraftProjectCertificateForAdditionalReviewMutationFn = Apollo.MutationFunction<ReturnAircraftProjectCertificateForAdditionalReviewMutation, ReturnAircraftProjectCertificateForAdditionalReviewMutationVariables>;

/**
 * __useReturnAircraftProjectCertificateForAdditionalReviewMutation__
 *
 * To run a mutation, you first call `useReturnAircraftProjectCertificateForAdditionalReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnAircraftProjectCertificateForAdditionalReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnAircraftProjectCertificateForAdditionalReviewMutation, { data, loading, error }] = useReturnAircraftProjectCertificateForAdditionalReviewMutation({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      documentTypeId: // value for 'documentTypeId'
 *   },
 * });
 */
export function useReturnAircraftProjectCertificateForAdditionalReviewMutation(baseOptions?: Apollo.MutationHookOptions<ReturnAircraftProjectCertificateForAdditionalReviewMutation, ReturnAircraftProjectCertificateForAdditionalReviewMutationVariables>) {
        return Apollo.useMutation<ReturnAircraftProjectCertificateForAdditionalReviewMutation, ReturnAircraftProjectCertificateForAdditionalReviewMutationVariables>(ReturnAircraftProjectCertificateForAdditionalReviewDocument, baseOptions);
      }
export type ReturnAircraftProjectCertificateForAdditionalReviewMutationHookResult = ReturnType<typeof useReturnAircraftProjectCertificateForAdditionalReviewMutation>;
export type ReturnAircraftProjectCertificateForAdditionalReviewMutationResult = Apollo.MutationResult<ReturnAircraftProjectCertificateForAdditionalReviewMutation>;
export type ReturnAircraftProjectCertificateForAdditionalReviewMutationOptions = Apollo.BaseMutationOptions<ReturnAircraftProjectCertificateForAdditionalReviewMutation, ReturnAircraftProjectCertificateForAdditionalReviewMutationVariables>;
export const SendAircraftProjectCertificateForApprovalDocument = gql`
    mutation sendAircraftProjectCertificateForApproval($aircraftProjectId: Int!, $documentTypeId: Int!, $ignoreWarnings: Boolean) {
  sendAircraftProjectDocumentTypeForApproval(aircraftProjectId: $aircraftProjectId, documentTypeId: $documentTypeId, ignoreWarnings: $ignoreWarnings) {
    id
    warnings
  }
}
    `;
export type SendAircraftProjectCertificateForApprovalMutationFn = Apollo.MutationFunction<SendAircraftProjectCertificateForApprovalMutation, SendAircraftProjectCertificateForApprovalMutationVariables>;

/**
 * __useSendAircraftProjectCertificateForApprovalMutation__
 *
 * To run a mutation, you first call `useSendAircraftProjectCertificateForApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAircraftProjectCertificateForApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAircraftProjectCertificateForApprovalMutation, { data, loading, error }] = useSendAircraftProjectCertificateForApprovalMutation({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      documentTypeId: // value for 'documentTypeId'
 *      ignoreWarnings: // value for 'ignoreWarnings'
 *   },
 * });
 */
export function useSendAircraftProjectCertificateForApprovalMutation(baseOptions?: Apollo.MutationHookOptions<SendAircraftProjectCertificateForApprovalMutation, SendAircraftProjectCertificateForApprovalMutationVariables>) {
        return Apollo.useMutation<SendAircraftProjectCertificateForApprovalMutation, SendAircraftProjectCertificateForApprovalMutationVariables>(SendAircraftProjectCertificateForApprovalDocument, baseOptions);
      }
export type SendAircraftProjectCertificateForApprovalMutationHookResult = ReturnType<typeof useSendAircraftProjectCertificateForApprovalMutation>;
export type SendAircraftProjectCertificateForApprovalMutationResult = Apollo.MutationResult<SendAircraftProjectCertificateForApprovalMutation>;
export type SendAircraftProjectCertificateForApprovalMutationOptions = Apollo.BaseMutationOptions<SendAircraftProjectCertificateForApprovalMutation, SendAircraftProjectCertificateForApprovalMutationVariables>;
export const ToggleAircraftProjectCertificateIsApprovalRequiredDocument = gql`
    mutation toggleAircraftProjectCertificateIsApprovalRequired($aircraftProjectId: Int!, $documentTypeId: Int!) {
  toggleAircraftProjectCertificateIsApprovalRequired(aircraftProjectId: $aircraftProjectId, documentTypeId: $documentTypeId)
}
    `;
export type ToggleAircraftProjectCertificateIsApprovalRequiredMutationFn = Apollo.MutationFunction<ToggleAircraftProjectCertificateIsApprovalRequiredMutation, ToggleAircraftProjectCertificateIsApprovalRequiredMutationVariables>;

/**
 * __useToggleAircraftProjectCertificateIsApprovalRequiredMutation__
 *
 * To run a mutation, you first call `useToggleAircraftProjectCertificateIsApprovalRequiredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAircraftProjectCertificateIsApprovalRequiredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAircraftProjectCertificateIsApprovalRequiredMutation, { data, loading, error }] = useToggleAircraftProjectCertificateIsApprovalRequiredMutation({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      documentTypeId: // value for 'documentTypeId'
 *   },
 * });
 */
export function useToggleAircraftProjectCertificateIsApprovalRequiredMutation(baseOptions?: Apollo.MutationHookOptions<ToggleAircraftProjectCertificateIsApprovalRequiredMutation, ToggleAircraftProjectCertificateIsApprovalRequiredMutationVariables>) {
        return Apollo.useMutation<ToggleAircraftProjectCertificateIsApprovalRequiredMutation, ToggleAircraftProjectCertificateIsApprovalRequiredMutationVariables>(ToggleAircraftProjectCertificateIsApprovalRequiredDocument, baseOptions);
      }
export type ToggleAircraftProjectCertificateIsApprovalRequiredMutationHookResult = ReturnType<typeof useToggleAircraftProjectCertificateIsApprovalRequiredMutation>;
export type ToggleAircraftProjectCertificateIsApprovalRequiredMutationResult = Apollo.MutationResult<ToggleAircraftProjectCertificateIsApprovalRequiredMutation>;
export type ToggleAircraftProjectCertificateIsApprovalRequiredMutationOptions = Apollo.BaseMutationOptions<ToggleAircraftProjectCertificateIsApprovalRequiredMutation, ToggleAircraftProjectCertificateIsApprovalRequiredMutationVariables>;
export const AircraftProjectIncompleteInspectionsDocument = gql`
    query aircraftProjectIncompleteInspections($id: Int!) {
  aircraftProject(id: $id) {
    aircraftProjectInspections {
      inspection {
        id
        inspectionStatus {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useAircraftProjectIncompleteInspectionsQuery__
 *
 * To run a query within a React component, call `useAircraftProjectIncompleteInspectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectIncompleteInspectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectIncompleteInspectionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAircraftProjectIncompleteInspectionsQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectIncompleteInspectionsQuery, AircraftProjectIncompleteInspectionsQueryVariables>) {
        return Apollo.useQuery<AircraftProjectIncompleteInspectionsQuery, AircraftProjectIncompleteInspectionsQueryVariables>(AircraftProjectIncompleteInspectionsDocument, baseOptions);
      }
export function useAircraftProjectIncompleteInspectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectIncompleteInspectionsQuery, AircraftProjectIncompleteInspectionsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectIncompleteInspectionsQuery, AircraftProjectIncompleteInspectionsQueryVariables>(AircraftProjectIncompleteInspectionsDocument, baseOptions);
        }
export type AircraftProjectIncompleteInspectionsQueryHookResult = ReturnType<typeof useAircraftProjectIncompleteInspectionsQuery>;
export type AircraftProjectIncompleteInspectionsLazyQueryHookResult = ReturnType<typeof useAircraftProjectIncompleteInspectionsLazyQuery>;
export type AircraftProjectIncompleteInspectionsQueryResult = Apollo.QueryResult<AircraftProjectIncompleteInspectionsQuery, AircraftProjectIncompleteInspectionsQueryVariables>;
export const AircraftProjectAccessCheckDocument = gql`
    query aircraftProjectAccessCheck($aircraftProjectId: Int!) {
  aircraftProject(id: $aircraftProjectId) {
    projectStatus {
      id
    }
  }
}
    `;

/**
 * __useAircraftProjectAccessCheckQuery__
 *
 * To run a query within a React component, call `useAircraftProjectAccessCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectAccessCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectAccessCheckQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *   },
 * });
 */
export function useAircraftProjectAccessCheckQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectAccessCheckQuery, AircraftProjectAccessCheckQueryVariables>) {
        return Apollo.useQuery<AircraftProjectAccessCheckQuery, AircraftProjectAccessCheckQueryVariables>(AircraftProjectAccessCheckDocument, baseOptions);
      }
export function useAircraftProjectAccessCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectAccessCheckQuery, AircraftProjectAccessCheckQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectAccessCheckQuery, AircraftProjectAccessCheckQueryVariables>(AircraftProjectAccessCheckDocument, baseOptions);
        }
export type AircraftProjectAccessCheckQueryHookResult = ReturnType<typeof useAircraftProjectAccessCheckQuery>;
export type AircraftProjectAccessCheckLazyQueryHookResult = ReturnType<typeof useAircraftProjectAccessCheckLazyQuery>;
export type AircraftProjectAccessCheckQueryResult = Apollo.QueryResult<AircraftProjectAccessCheckQuery, AircraftProjectAccessCheckQueryVariables>;
export const AircraftProjectDetailDocument = gql`
    query aircraftProjectDetail($id: Int!) {
  aircraftProject(id: $id) {
    ...aircraftProjectDetail
  }
  aircraftTypes(includeDeleted: true) {
    ...aircraftType
  }
  aircraftCategories(includeDeleted: true) {
    ...aircraftCategory
  }
  aircraftClasses(includeDeleted: true) {
    ...aircraftClass
  }
  aircraftModels(includeDeleted: true) {
    ...aircraftModel
  }
  aircraftManufacturers(includeDeleted: true) {
    ...aircraftManufacturer
  }
  aircraftEngineManufacturers(includeDeleted: true) {
    ...aircraftEngineManufacturer
  }
  aircraftPropellerManufacturers(includeDeleted: true) {
    ...aircraftPropellerManufacturer
  }
}
    ${AircraftProjectDetailFragmentDoc}
${AircraftTypeFragmentDoc}
${AircraftCategoryFragmentDoc}
${AircraftClassFragmentDoc}
${AircraftModelFragmentDoc}
${AircraftManufacturerFragmentDoc}
${AircraftEngineManufacturerFragmentDoc}
${AircraftPropellerManufacturerFragmentDoc}`;

/**
 * __useAircraftProjectDetailQuery__
 *
 * To run a query within a React component, call `useAircraftProjectDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAircraftProjectDetailQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectDetailQuery, AircraftProjectDetailQueryVariables>) {
        return Apollo.useQuery<AircraftProjectDetailQuery, AircraftProjectDetailQueryVariables>(AircraftProjectDetailDocument, baseOptions);
      }
export function useAircraftProjectDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectDetailQuery, AircraftProjectDetailQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectDetailQuery, AircraftProjectDetailQueryVariables>(AircraftProjectDetailDocument, baseOptions);
        }
export type AircraftProjectDetailQueryHookResult = ReturnType<typeof useAircraftProjectDetailQuery>;
export type AircraftProjectDetailLazyQueryHookResult = ReturnType<typeof useAircraftProjectDetailLazyQuery>;
export type AircraftProjectDetailQueryResult = Apollo.QueryResult<AircraftProjectDetailQuery, AircraftProjectDetailQueryVariables>;
export const AircraftProjectDocumentTypeApprovalStatusesDocument = gql`
    query aircraftProjectDocumentTypeApprovalStatuses($id: Int!) {
  aircraftProjectDocumentTypeApprovalStatuses(id: $id) {
    ...aircraftProjectDocumentTypeApprovalStatus
  }
}
    ${AircraftProjectDocumentTypeApprovalStatusFragmentDoc}`;

/**
 * __useAircraftProjectDocumentTypeApprovalStatusesQuery__
 *
 * To run a query within a React component, call `useAircraftProjectDocumentTypeApprovalStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectDocumentTypeApprovalStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectDocumentTypeApprovalStatusesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAircraftProjectDocumentTypeApprovalStatusesQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectDocumentTypeApprovalStatusesQuery, AircraftProjectDocumentTypeApprovalStatusesQueryVariables>) {
        return Apollo.useQuery<AircraftProjectDocumentTypeApprovalStatusesQuery, AircraftProjectDocumentTypeApprovalStatusesQueryVariables>(AircraftProjectDocumentTypeApprovalStatusesDocument, baseOptions);
      }
export function useAircraftProjectDocumentTypeApprovalStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectDocumentTypeApprovalStatusesQuery, AircraftProjectDocumentTypeApprovalStatusesQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectDocumentTypeApprovalStatusesQuery, AircraftProjectDocumentTypeApprovalStatusesQueryVariables>(AircraftProjectDocumentTypeApprovalStatusesDocument, baseOptions);
        }
export type AircraftProjectDocumentTypeApprovalStatusesQueryHookResult = ReturnType<typeof useAircraftProjectDocumentTypeApprovalStatusesQuery>;
export type AircraftProjectDocumentTypeApprovalStatusesLazyQueryHookResult = ReturnType<typeof useAircraftProjectDocumentTypeApprovalStatusesLazyQuery>;
export type AircraftProjectDocumentTypeApprovalStatusesQueryResult = Apollo.QueryResult<AircraftProjectDocumentTypeApprovalStatusesQuery, AircraftProjectDocumentTypeApprovalStatusesQueryVariables>;
export const AircraftProjectDocumentsDocument = gql`
    query aircraftProjectDocuments($aircraftProjectId: Int!, $aircraftProjectTypeId: Int!, $documentTypeCategoryIds: [DocumentTypeCategoryEnum!]!) {
  documents: aircraftProjectDocuments(aircraftProjectId: $aircraftProjectId, documentTypeCategoryIdIn: $documentTypeCategoryIds) {
    ...aircraftProjectDocument
  }
  documentTypes: aircraftProjectDocumentTypes(aircraftProjectId: $aircraftProjectId, aircraftProjectTypeId: $aircraftProjectTypeId, documentTypeCategoryIdIn: $documentTypeCategoryIds) {
    ...documentType
  }
}
    ${AircraftProjectDocumentFragmentDoc}
${DocumentTypeFragmentDoc}`;

/**
 * __useAircraftProjectDocumentsQuery__
 *
 * To run a query within a React component, call `useAircraftProjectDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectDocumentsQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      aircraftProjectTypeId: // value for 'aircraftProjectTypeId'
 *      documentTypeCategoryIds: // value for 'documentTypeCategoryIds'
 *   },
 * });
 */
export function useAircraftProjectDocumentsQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectDocumentsQuery, AircraftProjectDocumentsQueryVariables>) {
        return Apollo.useQuery<AircraftProjectDocumentsQuery, AircraftProjectDocumentsQueryVariables>(AircraftProjectDocumentsDocument, baseOptions);
      }
export function useAircraftProjectDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectDocumentsQuery, AircraftProjectDocumentsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectDocumentsQuery, AircraftProjectDocumentsQueryVariables>(AircraftProjectDocumentsDocument, baseOptions);
        }
export type AircraftProjectDocumentsQueryHookResult = ReturnType<typeof useAircraftProjectDocumentsQuery>;
export type AircraftProjectDocumentsLazyQueryHookResult = ReturnType<typeof useAircraftProjectDocumentsLazyQuery>;
export type AircraftProjectDocumentsQueryResult = Apollo.QueryResult<AircraftProjectDocumentsQuery, AircraftProjectDocumentsQueryVariables>;
export const AircraftProjectHeaderDocument = gql`
    query aircraftProjectHeader($aircraftProjectId: Int!) {
  aircraftProject(id: $aircraftProjectId) {
    ...aircraftProjectHeader
  }
  documentTypesForApproval: aircraftProjectDocumentTypesForProjectApproval(aircraftProjectId: $aircraftProjectId) {
    id
  }
  documentTypesApproved: aircraftProjectDocumentTypeApprovalStatuses(id: $aircraftProjectId, approvalStatus: Approved) {
    documentType {
      id
    }
  }
  documentTypesPendingApproval: aircraftProjectDocumentTypeApprovalStatuses(id: $aircraftProjectId, approvalStatus: PendingApproval) {
    documentType {
      name
    }
  }
  certificateTypes: aircraftProjectDocumentTypes(documentTypeCategoryId: Certificate, aircraftProjectId: $aircraftProjectId) {
    id
  }
}
    ${AircraftProjectHeaderFragmentDoc}`;

/**
 * __useAircraftProjectHeaderQuery__
 *
 * To run a query within a React component, call `useAircraftProjectHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectHeaderQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *   },
 * });
 */
export function useAircraftProjectHeaderQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectHeaderQuery, AircraftProjectHeaderQueryVariables>) {
        return Apollo.useQuery<AircraftProjectHeaderQuery, AircraftProjectHeaderQueryVariables>(AircraftProjectHeaderDocument, baseOptions);
      }
export function useAircraftProjectHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectHeaderQuery, AircraftProjectHeaderQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectHeaderQuery, AircraftProjectHeaderQueryVariables>(AircraftProjectHeaderDocument, baseOptions);
        }
export type AircraftProjectHeaderQueryHookResult = ReturnType<typeof useAircraftProjectHeaderQuery>;
export type AircraftProjectHeaderLazyQueryHookResult = ReturnType<typeof useAircraftProjectHeaderLazyQuery>;
export type AircraftProjectHeaderQueryResult = Apollo.QueryResult<AircraftProjectHeaderQuery, AircraftProjectHeaderQueryVariables>;
export const AircraftProjectInsFormAssociatedDocumentsDocument = gql`
    query aircraftProjectInsFormAssociatedDocuments($aircraftProjectId: Int!) {
  aircraftProject(id: $aircraftProjectId) {
    insFormAssociatedDocuments {
      ...aircraftProjectInsFormAssociatedDocument
    }
    projectInsForms: insForms {
      ...projectInsFormAssociatedDocumentTypes
    }
  }
  insFormAssociatedDocumentGroups {
    ...insFormAssociatedDocumentGroup
  }
}
    ${AircraftProjectInsFormAssociatedDocumentFragmentDoc}
${ProjectInsFormAssociatedDocumentTypesFragmentDoc}
${InsFormAssociatedDocumentGroupFragmentDoc}`;

/**
 * __useAircraftProjectInsFormAssociatedDocumentsQuery__
 *
 * To run a query within a React component, call `useAircraftProjectInsFormAssociatedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectInsFormAssociatedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectInsFormAssociatedDocumentsQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *   },
 * });
 */
export function useAircraftProjectInsFormAssociatedDocumentsQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectInsFormAssociatedDocumentsQuery, AircraftProjectInsFormAssociatedDocumentsQueryVariables>) {
        return Apollo.useQuery<AircraftProjectInsFormAssociatedDocumentsQuery, AircraftProjectInsFormAssociatedDocumentsQueryVariables>(AircraftProjectInsFormAssociatedDocumentsDocument, baseOptions);
      }
export function useAircraftProjectInsFormAssociatedDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectInsFormAssociatedDocumentsQuery, AircraftProjectInsFormAssociatedDocumentsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectInsFormAssociatedDocumentsQuery, AircraftProjectInsFormAssociatedDocumentsQueryVariables>(AircraftProjectInsFormAssociatedDocumentsDocument, baseOptions);
        }
export type AircraftProjectInsFormAssociatedDocumentsQueryHookResult = ReturnType<typeof useAircraftProjectInsFormAssociatedDocumentsQuery>;
export type AircraftProjectInsFormAssociatedDocumentsLazyQueryHookResult = ReturnType<typeof useAircraftProjectInsFormAssociatedDocumentsLazyQuery>;
export type AircraftProjectInsFormAssociatedDocumentsQueryResult = Apollo.QueryResult<AircraftProjectInsFormAssociatedDocumentsQuery, AircraftProjectInsFormAssociatedDocumentsQueryVariables>;
export const AircraftProjectInspectionsDocument = gql`
    query aircraftProjectInspections($aircraftProjectId: Int!) {
  aircraftProject(id: $aircraftProjectId) {
    currentInspections: aircraftProjectInspections {
      id
      inspection {
        ...inspectionDetailForAllProjects
      }
    }
    priorInspections: aircraftProjectInspections(isPrior: true) {
      id
      inspection {
        ...inspectionDetailForAllProjects
      }
    }
  }
}
    ${InspectionDetailForAllProjectsFragmentDoc}`;

/**
 * __useAircraftProjectInspectionsQuery__
 *
 * To run a query within a React component, call `useAircraftProjectInspectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectInspectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectInspectionsQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *   },
 * });
 */
export function useAircraftProjectInspectionsQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectInspectionsQuery, AircraftProjectInspectionsQueryVariables>) {
        return Apollo.useQuery<AircraftProjectInspectionsQuery, AircraftProjectInspectionsQueryVariables>(AircraftProjectInspectionsDocument, baseOptions);
      }
export function useAircraftProjectInspectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectInspectionsQuery, AircraftProjectInspectionsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectInspectionsQuery, AircraftProjectInspectionsQueryVariables>(AircraftProjectInspectionsDocument, baseOptions);
        }
export type AircraftProjectInspectionsQueryHookResult = ReturnType<typeof useAircraftProjectInspectionsQuery>;
export type AircraftProjectInspectionsLazyQueryHookResult = ReturnType<typeof useAircraftProjectInspectionsLazyQuery>;
export type AircraftProjectInspectionsQueryResult = Apollo.QueryResult<AircraftProjectInspectionsQuery, AircraftProjectInspectionsQueryVariables>;
export const AircraftProjectLinkedCrewProjectsCheckDocument = gql`
    query aircraftProjectLinkedCrewProjectsCheck($associatedAircraftProjectIdIn: [Int!], $projectStatusIdNotIn: [Int!]) {
  crewProjects(associatedAircraftProjectIdIn: $associatedAircraftProjectIdIn, projectStatusIdNotIn: $projectStatusIdNotIn) {
    ... on CrewProjects {
      crewProjects {
        id
      }
    }
  }
}
    `;

/**
 * __useAircraftProjectLinkedCrewProjectsCheckQuery__
 *
 * To run a query within a React component, call `useAircraftProjectLinkedCrewProjectsCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectLinkedCrewProjectsCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectLinkedCrewProjectsCheckQuery({
 *   variables: {
 *      associatedAircraftProjectIdIn: // value for 'associatedAircraftProjectIdIn'
 *      projectStatusIdNotIn: // value for 'projectStatusIdNotIn'
 *   },
 * });
 */
export function useAircraftProjectLinkedCrewProjectsCheckQuery(baseOptions?: Apollo.QueryHookOptions<AircraftProjectLinkedCrewProjectsCheckQuery, AircraftProjectLinkedCrewProjectsCheckQueryVariables>) {
        return Apollo.useQuery<AircraftProjectLinkedCrewProjectsCheckQuery, AircraftProjectLinkedCrewProjectsCheckQueryVariables>(AircraftProjectLinkedCrewProjectsCheckDocument, baseOptions);
      }
export function useAircraftProjectLinkedCrewProjectsCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectLinkedCrewProjectsCheckQuery, AircraftProjectLinkedCrewProjectsCheckQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectLinkedCrewProjectsCheckQuery, AircraftProjectLinkedCrewProjectsCheckQueryVariables>(AircraftProjectLinkedCrewProjectsCheckDocument, baseOptions);
        }
export type AircraftProjectLinkedCrewProjectsCheckQueryHookResult = ReturnType<typeof useAircraftProjectLinkedCrewProjectsCheckQuery>;
export type AircraftProjectLinkedCrewProjectsCheckLazyQueryHookResult = ReturnType<typeof useAircraftProjectLinkedCrewProjectsCheckLazyQuery>;
export type AircraftProjectLinkedCrewProjectsCheckQueryResult = Apollo.QueryResult<AircraftProjectLinkedCrewProjectsCheckQuery, AircraftProjectLinkedCrewProjectsCheckQueryVariables>;
export const AircraftProjectLinkedMechanicProjectsCheckDocument = gql`
    query aircraftProjectLinkedMechanicProjectsCheck($associatedAircraftProjectIdIn: [Int!], $projectStatusIdNotIn: [Int!]) {
  mechanicProjects(associatedAircraftProjectIdIn: $associatedAircraftProjectIdIn, projectStatusIdNotIn: $projectStatusIdNotIn) {
    ... on MechanicProjects {
      mechanicProjects {
        id
      }
    }
  }
}
    `;

/**
 * __useAircraftProjectLinkedMechanicProjectsCheckQuery__
 *
 * To run a query within a React component, call `useAircraftProjectLinkedMechanicProjectsCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectLinkedMechanicProjectsCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectLinkedMechanicProjectsCheckQuery({
 *   variables: {
 *      associatedAircraftProjectIdIn: // value for 'associatedAircraftProjectIdIn'
 *      projectStatusIdNotIn: // value for 'projectStatusIdNotIn'
 *   },
 * });
 */
export function useAircraftProjectLinkedMechanicProjectsCheckQuery(baseOptions?: Apollo.QueryHookOptions<AircraftProjectLinkedMechanicProjectsCheckQuery, AircraftProjectLinkedMechanicProjectsCheckQueryVariables>) {
        return Apollo.useQuery<AircraftProjectLinkedMechanicProjectsCheckQuery, AircraftProjectLinkedMechanicProjectsCheckQueryVariables>(AircraftProjectLinkedMechanicProjectsCheckDocument, baseOptions);
      }
export function useAircraftProjectLinkedMechanicProjectsCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectLinkedMechanicProjectsCheckQuery, AircraftProjectLinkedMechanicProjectsCheckQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectLinkedMechanicProjectsCheckQuery, AircraftProjectLinkedMechanicProjectsCheckQueryVariables>(AircraftProjectLinkedMechanicProjectsCheckDocument, baseOptions);
        }
export type AircraftProjectLinkedMechanicProjectsCheckQueryHookResult = ReturnType<typeof useAircraftProjectLinkedMechanicProjectsCheckQuery>;
export type AircraftProjectLinkedMechanicProjectsCheckLazyQueryHookResult = ReturnType<typeof useAircraftProjectLinkedMechanicProjectsCheckLazyQuery>;
export type AircraftProjectLinkedMechanicProjectsCheckQueryResult = Apollo.QueryResult<AircraftProjectLinkedMechanicProjectsCheckQuery, AircraftProjectLinkedMechanicProjectsCheckQueryVariables>;
export const AircraftProjectMissingInspectionFileAttachmentsDocument = gql`
    query aircraftProjectMissingInspectionFileAttachments($id: Int!) {
  aircraftProject(id: $id) {
    aircraftProjectInspections {
      inspection {
        ...aircraftProjectMissingInspectionFileAttachmentsInspection
      }
    }
  }
}
    ${AircraftProjectMissingInspectionFileAttachmentsInspectionFragmentDoc}`;

/**
 * __useAircraftProjectMissingInspectionFileAttachmentsQuery__
 *
 * To run a query within a React component, call `useAircraftProjectMissingInspectionFileAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectMissingInspectionFileAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectMissingInspectionFileAttachmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAircraftProjectMissingInspectionFileAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectMissingInspectionFileAttachmentsQuery, AircraftProjectMissingInspectionFileAttachmentsQueryVariables>) {
        return Apollo.useQuery<AircraftProjectMissingInspectionFileAttachmentsQuery, AircraftProjectMissingInspectionFileAttachmentsQueryVariables>(AircraftProjectMissingInspectionFileAttachmentsDocument, baseOptions);
      }
export function useAircraftProjectMissingInspectionFileAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectMissingInspectionFileAttachmentsQuery, AircraftProjectMissingInspectionFileAttachmentsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectMissingInspectionFileAttachmentsQuery, AircraftProjectMissingInspectionFileAttachmentsQueryVariables>(AircraftProjectMissingInspectionFileAttachmentsDocument, baseOptions);
        }
export type AircraftProjectMissingInspectionFileAttachmentsQueryHookResult = ReturnType<typeof useAircraftProjectMissingInspectionFileAttachmentsQuery>;
export type AircraftProjectMissingInspectionFileAttachmentsLazyQueryHookResult = ReturnType<typeof useAircraftProjectMissingInspectionFileAttachmentsLazyQuery>;
export type AircraftProjectMissingInspectionFileAttachmentsQueryResult = Apollo.QueryResult<AircraftProjectMissingInspectionFileAttachmentsQuery, AircraftProjectMissingInspectionFileAttachmentsQueryVariables>;
export const AircraftProjectMissingRequiredDocumentsDocument = gql`
    query aircraftProjectMissingRequiredDocuments($id: Int!) {
  aircraftProject(id: $id) {
    aircraftProjectMissingRequiredDocuments
  }
}
    `;

/**
 * __useAircraftProjectMissingRequiredDocumentsQuery__
 *
 * To run a query within a React component, call `useAircraftProjectMissingRequiredDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectMissingRequiredDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectMissingRequiredDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAircraftProjectMissingRequiredDocumentsQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectMissingRequiredDocumentsQuery, AircraftProjectMissingRequiredDocumentsQueryVariables>) {
        return Apollo.useQuery<AircraftProjectMissingRequiredDocumentsQuery, AircraftProjectMissingRequiredDocumentsQueryVariables>(AircraftProjectMissingRequiredDocumentsDocument, baseOptions);
      }
export function useAircraftProjectMissingRequiredDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectMissingRequiredDocumentsQuery, AircraftProjectMissingRequiredDocumentsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectMissingRequiredDocumentsQuery, AircraftProjectMissingRequiredDocumentsQueryVariables>(AircraftProjectMissingRequiredDocumentsDocument, baseOptions);
        }
export type AircraftProjectMissingRequiredDocumentsQueryHookResult = ReturnType<typeof useAircraftProjectMissingRequiredDocumentsQuery>;
export type AircraftProjectMissingRequiredDocumentsLazyQueryHookResult = ReturnType<typeof useAircraftProjectMissingRequiredDocumentsLazyQuery>;
export type AircraftProjectMissingRequiredDocumentsQueryResult = Apollo.QueryResult<AircraftProjectMissingRequiredDocumentsQuery, AircraftProjectMissingRequiredDocumentsQueryVariables>;
export const AircraftProjectOfficialLetterNotesDocument = gql`
    query aircraftProjectOfficialLetterNotes($aircraftProjectId: Int!) {
  aircraftProject(id: $aircraftProjectId) {
    officialLetterDocumentsNote
    documentTypeOfficialLetterNotes {
      documentType {
        id
        name
      }
      officialLetterNote
    }
  }
}
    `;

/**
 * __useAircraftProjectOfficialLetterNotesQuery__
 *
 * To run a query within a React component, call `useAircraftProjectOfficialLetterNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectOfficialLetterNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectOfficialLetterNotesQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *   },
 * });
 */
export function useAircraftProjectOfficialLetterNotesQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectOfficialLetterNotesQuery, AircraftProjectOfficialLetterNotesQueryVariables>) {
        return Apollo.useQuery<AircraftProjectOfficialLetterNotesQuery, AircraftProjectOfficialLetterNotesQueryVariables>(AircraftProjectOfficialLetterNotesDocument, baseOptions);
      }
export function useAircraftProjectOfficialLetterNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectOfficialLetterNotesQuery, AircraftProjectOfficialLetterNotesQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectOfficialLetterNotesQuery, AircraftProjectOfficialLetterNotesQueryVariables>(AircraftProjectOfficialLetterNotesDocument, baseOptions);
        }
export type AircraftProjectOfficialLetterNotesQueryHookResult = ReturnType<typeof useAircraftProjectOfficialLetterNotesQuery>;
export type AircraftProjectOfficialLetterNotesLazyQueryHookResult = ReturnType<typeof useAircraftProjectOfficialLetterNotesLazyQuery>;
export type AircraftProjectOfficialLetterNotesQueryResult = Apollo.QueryResult<AircraftProjectOfficialLetterNotesQuery, AircraftProjectOfficialLetterNotesQueryVariables>;
export const AircraftProjectQuickGlanceDocument = gql`
    query aircraftProjectQuickGlance($aircraftProjectId: Int!) {
  dcaHistory: aircraftProjectHistory(aircraftProjectId: $aircraftProjectId, filter: {dcaOnly: true}) {
    performedByName
    date
    projectStatus {
      id
      name
    }
    projectTransition {
      id
      name
    }
  }
}
    `;

/**
 * __useAircraftProjectQuickGlanceQuery__
 *
 * To run a query within a React component, call `useAircraftProjectQuickGlanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectQuickGlanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectQuickGlanceQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *   },
 * });
 */
export function useAircraftProjectQuickGlanceQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectQuickGlanceQuery, AircraftProjectQuickGlanceQueryVariables>) {
        return Apollo.useQuery<AircraftProjectQuickGlanceQuery, AircraftProjectQuickGlanceQueryVariables>(AircraftProjectQuickGlanceDocument, baseOptions);
      }
export function useAircraftProjectQuickGlanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectQuickGlanceQuery, AircraftProjectQuickGlanceQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectQuickGlanceQuery, AircraftProjectQuickGlanceQueryVariables>(AircraftProjectQuickGlanceDocument, baseOptions);
        }
export type AircraftProjectQuickGlanceQueryHookResult = ReturnType<typeof useAircraftProjectQuickGlanceQuery>;
export type AircraftProjectQuickGlanceLazyQueryHookResult = ReturnType<typeof useAircraftProjectQuickGlanceLazyQuery>;
export type AircraftProjectQuickGlanceQueryResult = Apollo.QueryResult<AircraftProjectQuickGlanceQuery, AircraftProjectQuickGlanceQueryVariables>;
export const AircraftProjectReopenByDcaOpenProjectsCheckDocument = gql`
    query aircraftProjectReopenByDcaOpenProjectsCheck($aircraftId: Int!, $projectStatusIdNotIn: [Int!]!) {
  aircraftProjects(aircraftId: $aircraftId, projectStatusIdNotIn: $projectStatusIdNotIn) {
    ... on AircraftProjects {
      aircraftProjects {
        id
      }
    }
  }
}
    `;

/**
 * __useAircraftProjectReopenByDcaOpenProjectsCheckQuery__
 *
 * To run a query within a React component, call `useAircraftProjectReopenByDcaOpenProjectsCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectReopenByDcaOpenProjectsCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectReopenByDcaOpenProjectsCheckQuery({
 *   variables: {
 *      aircraftId: // value for 'aircraftId'
 *      projectStatusIdNotIn: // value for 'projectStatusIdNotIn'
 *   },
 * });
 */
export function useAircraftProjectReopenByDcaOpenProjectsCheckQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectReopenByDcaOpenProjectsCheckQuery, AircraftProjectReopenByDcaOpenProjectsCheckQueryVariables>) {
        return Apollo.useQuery<AircraftProjectReopenByDcaOpenProjectsCheckQuery, AircraftProjectReopenByDcaOpenProjectsCheckQueryVariables>(AircraftProjectReopenByDcaOpenProjectsCheckDocument, baseOptions);
      }
export function useAircraftProjectReopenByDcaOpenProjectsCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectReopenByDcaOpenProjectsCheckQuery, AircraftProjectReopenByDcaOpenProjectsCheckQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectReopenByDcaOpenProjectsCheckQuery, AircraftProjectReopenByDcaOpenProjectsCheckQueryVariables>(AircraftProjectReopenByDcaOpenProjectsCheckDocument, baseOptions);
        }
export type AircraftProjectReopenByDcaOpenProjectsCheckQueryHookResult = ReturnType<typeof useAircraftProjectReopenByDcaOpenProjectsCheckQuery>;
export type AircraftProjectReopenByDcaOpenProjectsCheckLazyQueryHookResult = ReturnType<typeof useAircraftProjectReopenByDcaOpenProjectsCheckLazyQuery>;
export type AircraftProjectReopenByDcaOpenProjectsCheckQueryResult = Apollo.QueryResult<AircraftProjectReopenByDcaOpenProjectsCheckQuery, AircraftProjectReopenByDcaOpenProjectsCheckQueryVariables>;
export const AircraftProjectSendToDcaCheckDocument = gql`
    query aircraftProjectSendToDcaCheck($aircraftProjectId: Int!) {
  aircraftProjectInsForms(aircraftProjectId: $aircraftProjectId) {
    ...sendToDcaCheck
  }
}
    ${SendToDcaCheckFragmentDoc}`;

/**
 * __useAircraftProjectSendToDcaCheckQuery__
 *
 * To run a query within a React component, call `useAircraftProjectSendToDcaCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectSendToDcaCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectSendToDcaCheckQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *   },
 * });
 */
export function useAircraftProjectSendToDcaCheckQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectSendToDcaCheckQuery, AircraftProjectSendToDcaCheckQueryVariables>) {
        return Apollo.useQuery<AircraftProjectSendToDcaCheckQuery, AircraftProjectSendToDcaCheckQueryVariables>(AircraftProjectSendToDcaCheckDocument, baseOptions);
      }
export function useAircraftProjectSendToDcaCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectSendToDcaCheckQuery, AircraftProjectSendToDcaCheckQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectSendToDcaCheckQuery, AircraftProjectSendToDcaCheckQueryVariables>(AircraftProjectSendToDcaCheckDocument, baseOptions);
        }
export type AircraftProjectSendToDcaCheckQueryHookResult = ReturnType<typeof useAircraftProjectSendToDcaCheckQuery>;
export type AircraftProjectSendToDcaCheckLazyQueryHookResult = ReturnType<typeof useAircraftProjectSendToDcaCheckLazyQuery>;
export type AircraftProjectSendToDcaCheckQueryResult = Apollo.QueryResult<AircraftProjectSendToDcaCheckQuery, AircraftProjectSendToDcaCheckQueryVariables>;
export const AircraftProjectSummaryDocument = gql`
    query aircraftProjectSummary($aircraftProjectId: Int!) {
  aircraftProject(id: $aircraftProjectId) {
    id
    registrationMark
    aircraftProjectType {
      name
    }
    projectStatus {
      id
    }
    isHighImportance
    isOnHold
    isOnHoldByDca
    dcaHoldReason
    assignees {
      id
      firstName
      lastName
      ...user
    }
    assignedDepartmentUsers {
      displayName
    }
    projectCreatedByUser {
      id
      firstName
      lastName
    }
    projectCreationDate
    assignees {
      ...user
    }
    documents {
      id
      document {
        documentType {
          id
          isAlwaysVisibleToDca
        }
        fileAttachment {
          fileName
          fileSizeBytes
          mimeType
        }
      }
      isReleasedToDca
    }
    isNoDcaInvoiceRequired
    certificateOfAirworthinessExpirationDate
    certificateOfRegistrationExpirationDate
    noiseCertificateExpiryDate
    aircraftRadioStationLicenseExpiryDate
    airspaceApprovalCertificateExpiryDate
  }
}
    ${UserFragmentDoc}`;

/**
 * __useAircraftProjectSummaryQuery__
 *
 * To run a query within a React component, call `useAircraftProjectSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectSummaryQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *   },
 * });
 */
export function useAircraftProjectSummaryQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectSummaryQuery, AircraftProjectSummaryQueryVariables>) {
        return Apollo.useQuery<AircraftProjectSummaryQuery, AircraftProjectSummaryQueryVariables>(AircraftProjectSummaryDocument, baseOptions);
      }
export function useAircraftProjectSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectSummaryQuery, AircraftProjectSummaryQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectSummaryQuery, AircraftProjectSummaryQueryVariables>(AircraftProjectSummaryDocument, baseOptions);
        }
export type AircraftProjectSummaryQueryHookResult = ReturnType<typeof useAircraftProjectSummaryQuery>;
export type AircraftProjectSummaryLazyQueryHookResult = ReturnType<typeof useAircraftProjectSummaryLazyQuery>;
export type AircraftProjectSummaryQueryResult = Apollo.QueryResult<AircraftProjectSummaryQuery, AircraftProjectSummaryQueryVariables>;
export const ArgHoldAircraftProjectDocument = gql`
    mutation argHoldAircraftProject($id: Int!) {
  holdAircraftProject(id: $id) {
    id
  }
}
    `;
export type ArgHoldAircraftProjectMutationFn = Apollo.MutationFunction<ArgHoldAircraftProjectMutation, ArgHoldAircraftProjectMutationVariables>;

/**
 * __useArgHoldAircraftProjectMutation__
 *
 * To run a mutation, you first call `useArgHoldAircraftProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArgHoldAircraftProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [argHoldAircraftProjectMutation, { data, loading, error }] = useArgHoldAircraftProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArgHoldAircraftProjectMutation(baseOptions?: Apollo.MutationHookOptions<ArgHoldAircraftProjectMutation, ArgHoldAircraftProjectMutationVariables>) {
        return Apollo.useMutation<ArgHoldAircraftProjectMutation, ArgHoldAircraftProjectMutationVariables>(ArgHoldAircraftProjectDocument, baseOptions);
      }
export type ArgHoldAircraftProjectMutationHookResult = ReturnType<typeof useArgHoldAircraftProjectMutation>;
export type ArgHoldAircraftProjectMutationResult = Apollo.MutationResult<ArgHoldAircraftProjectMutation>;
export type ArgHoldAircraftProjectMutationOptions = Apollo.BaseMutationOptions<ArgHoldAircraftProjectMutation, ArgHoldAircraftProjectMutationVariables>;
export const ArgRemoveHoldAircraftProjectDocument = gql`
    mutation argRemoveHoldAircraftProject($id: Int!) {
  releaseAircraftProject(id: $id) {
    id
  }
}
    `;
export type ArgRemoveHoldAircraftProjectMutationFn = Apollo.MutationFunction<ArgRemoveHoldAircraftProjectMutation, ArgRemoveHoldAircraftProjectMutationVariables>;

/**
 * __useArgRemoveHoldAircraftProjectMutation__
 *
 * To run a mutation, you first call `useArgRemoveHoldAircraftProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArgRemoveHoldAircraftProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [argRemoveHoldAircraftProjectMutation, { data, loading, error }] = useArgRemoveHoldAircraftProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArgRemoveHoldAircraftProjectMutation(baseOptions?: Apollo.MutationHookOptions<ArgRemoveHoldAircraftProjectMutation, ArgRemoveHoldAircraftProjectMutationVariables>) {
        return Apollo.useMutation<ArgRemoveHoldAircraftProjectMutation, ArgRemoveHoldAircraftProjectMutationVariables>(ArgRemoveHoldAircraftProjectDocument, baseOptions);
      }
export type ArgRemoveHoldAircraftProjectMutationHookResult = ReturnType<typeof useArgRemoveHoldAircraftProjectMutation>;
export type ArgRemoveHoldAircraftProjectMutationResult = Apollo.MutationResult<ArgRemoveHoldAircraftProjectMutation>;
export type ArgRemoveHoldAircraftProjectMutationOptions = Apollo.BaseMutationOptions<ArgRemoveHoldAircraftProjectMutation, ArgRemoveHoldAircraftProjectMutationVariables>;
export const DcaCompleteAircraftProjectTaskDocument = gql`
    mutation dcaCompleteAircraftProjectTask($input: CompleteAircraftProjectTaskInput!) {
  completeAircraftProjectTask(input: $input) {
    id
    warnings
  }
}
    `;
export type DcaCompleteAircraftProjectTaskMutationFn = Apollo.MutationFunction<DcaCompleteAircraftProjectTaskMutation, DcaCompleteAircraftProjectTaskMutationVariables>;

/**
 * __useDcaCompleteAircraftProjectTaskMutation__
 *
 * To run a mutation, you first call `useDcaCompleteAircraftProjectTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDcaCompleteAircraftProjectTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dcaCompleteAircraftProjectTaskMutation, { data, loading, error }] = useDcaCompleteAircraftProjectTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDcaCompleteAircraftProjectTaskMutation(baseOptions?: Apollo.MutationHookOptions<DcaCompleteAircraftProjectTaskMutation, DcaCompleteAircraftProjectTaskMutationVariables>) {
        return Apollo.useMutation<DcaCompleteAircraftProjectTaskMutation, DcaCompleteAircraftProjectTaskMutationVariables>(DcaCompleteAircraftProjectTaskDocument, baseOptions);
      }
export type DcaCompleteAircraftProjectTaskMutationHookResult = ReturnType<typeof useDcaCompleteAircraftProjectTaskMutation>;
export type DcaCompleteAircraftProjectTaskMutationResult = Apollo.MutationResult<DcaCompleteAircraftProjectTaskMutation>;
export type DcaCompleteAircraftProjectTaskMutationOptions = Apollo.BaseMutationOptions<DcaCompleteAircraftProjectTaskMutation, DcaCompleteAircraftProjectTaskMutationVariables>;
export const DcaHoldAircraftProjectDocument = gql`
    mutation dcaHoldAircraftProject($input: DcaHoldAircraftProjectInput!) {
  dcaHoldAircraftProject(input: $input) {
    id
  }
}
    `;
export type DcaHoldAircraftProjectMutationFn = Apollo.MutationFunction<DcaHoldAircraftProjectMutation, DcaHoldAircraftProjectMutationVariables>;

/**
 * __useDcaHoldAircraftProjectMutation__
 *
 * To run a mutation, you first call `useDcaHoldAircraftProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDcaHoldAircraftProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dcaHoldAircraftProjectMutation, { data, loading, error }] = useDcaHoldAircraftProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDcaHoldAircraftProjectMutation(baseOptions?: Apollo.MutationHookOptions<DcaHoldAircraftProjectMutation, DcaHoldAircraftProjectMutationVariables>) {
        return Apollo.useMutation<DcaHoldAircraftProjectMutation, DcaHoldAircraftProjectMutationVariables>(DcaHoldAircraftProjectDocument, baseOptions);
      }
export type DcaHoldAircraftProjectMutationHookResult = ReturnType<typeof useDcaHoldAircraftProjectMutation>;
export type DcaHoldAircraftProjectMutationResult = Apollo.MutationResult<DcaHoldAircraftProjectMutation>;
export type DcaHoldAircraftProjectMutationOptions = Apollo.BaseMutationOptions<DcaHoldAircraftProjectMutation, DcaHoldAircraftProjectMutationVariables>;
export const DcaRemoveHoldAircraftProjectDocument = gql`
    mutation dcaRemoveHoldAircraftProject($id: Int!) {
  dcaReleaseAircraftProject(id: $id) {
    id
  }
}
    `;
export type DcaRemoveHoldAircraftProjectMutationFn = Apollo.MutationFunction<DcaRemoveHoldAircraftProjectMutation, DcaRemoveHoldAircraftProjectMutationVariables>;

/**
 * __useDcaRemoveHoldAircraftProjectMutation__
 *
 * To run a mutation, you first call `useDcaRemoveHoldAircraftProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDcaRemoveHoldAircraftProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dcaRemoveHoldAircraftProjectMutation, { data, loading, error }] = useDcaRemoveHoldAircraftProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDcaRemoveHoldAircraftProjectMutation(baseOptions?: Apollo.MutationHookOptions<DcaRemoveHoldAircraftProjectMutation, DcaRemoveHoldAircraftProjectMutationVariables>) {
        return Apollo.useMutation<DcaRemoveHoldAircraftProjectMutation, DcaRemoveHoldAircraftProjectMutationVariables>(DcaRemoveHoldAircraftProjectDocument, baseOptions);
      }
export type DcaRemoveHoldAircraftProjectMutationHookResult = ReturnType<typeof useDcaRemoveHoldAircraftProjectMutation>;
export type DcaRemoveHoldAircraftProjectMutationResult = Apollo.MutationResult<DcaRemoveHoldAircraftProjectMutation>;
export type DcaRemoveHoldAircraftProjectMutationOptions = Apollo.BaseMutationOptions<DcaRemoveHoldAircraftProjectMutation, DcaRemoveHoldAircraftProjectMutationVariables>;
export const DcaSendAircraftProjectBackToIasoDocument = gql`
    mutation dcaSendAircraftProjectBackToIaso($input: SendAircraftProjectToIasoInput!) {
  sendAircraftProjectBackToIaso(input: $input) {
    id
  }
}
    `;
export type DcaSendAircraftProjectBackToIasoMutationFn = Apollo.MutationFunction<DcaSendAircraftProjectBackToIasoMutation, DcaSendAircraftProjectBackToIasoMutationVariables>;

/**
 * __useDcaSendAircraftProjectBackToIasoMutation__
 *
 * To run a mutation, you first call `useDcaSendAircraftProjectBackToIasoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDcaSendAircraftProjectBackToIasoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dcaSendAircraftProjectBackToIasoMutation, { data, loading, error }] = useDcaSendAircraftProjectBackToIasoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDcaSendAircraftProjectBackToIasoMutation(baseOptions?: Apollo.MutationHookOptions<DcaSendAircraftProjectBackToIasoMutation, DcaSendAircraftProjectBackToIasoMutationVariables>) {
        return Apollo.useMutation<DcaSendAircraftProjectBackToIasoMutation, DcaSendAircraftProjectBackToIasoMutationVariables>(DcaSendAircraftProjectBackToIasoDocument, baseOptions);
      }
export type DcaSendAircraftProjectBackToIasoMutationHookResult = ReturnType<typeof useDcaSendAircraftProjectBackToIasoMutation>;
export type DcaSendAircraftProjectBackToIasoMutationResult = Apollo.MutationResult<DcaSendAircraftProjectBackToIasoMutation>;
export type DcaSendAircraftProjectBackToIasoMutationOptions = Apollo.BaseMutationOptions<DcaSendAircraftProjectBackToIasoMutation, DcaSendAircraftProjectBackToIasoMutationVariables>;
export const DeleteAircraftProjectDocument = gql`
    mutation deleteAircraftProject($id: Int!) {
  deleteAircraftProject(id: $id) {
    id
  }
}
    `;
export type DeleteAircraftProjectMutationFn = Apollo.MutationFunction<DeleteAircraftProjectMutation, DeleteAircraftProjectMutationVariables>;

/**
 * __useDeleteAircraftProjectMutation__
 *
 * To run a mutation, you first call `useDeleteAircraftProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAircraftProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAircraftProjectMutation, { data, loading, error }] = useDeleteAircraftProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAircraftProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAircraftProjectMutation, DeleteAircraftProjectMutationVariables>) {
        return Apollo.useMutation<DeleteAircraftProjectMutation, DeleteAircraftProjectMutationVariables>(DeleteAircraftProjectDocument, baseOptions);
      }
export type DeleteAircraftProjectMutationHookResult = ReturnType<typeof useDeleteAircraftProjectMutation>;
export type DeleteAircraftProjectMutationResult = Apollo.MutationResult<DeleteAircraftProjectMutation>;
export type DeleteAircraftProjectMutationOptions = Apollo.BaseMutationOptions<DeleteAircraftProjectMutation, DeleteAircraftProjectMutationVariables>;
export const TransitionAircraftProjectDocument = gql`
    mutation transitionAircraftProject($input: TransitionProjectInput!) {
  transitionAircraftProject(input: $input) {
    id
    warnings
  }
}
    `;
export type TransitionAircraftProjectMutationFn = Apollo.MutationFunction<TransitionAircraftProjectMutation, TransitionAircraftProjectMutationVariables>;

/**
 * __useTransitionAircraftProjectMutation__
 *
 * To run a mutation, you first call `useTransitionAircraftProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionAircraftProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionAircraftProjectMutation, { data, loading, error }] = useTransitionAircraftProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransitionAircraftProjectMutation(baseOptions?: Apollo.MutationHookOptions<TransitionAircraftProjectMutation, TransitionAircraftProjectMutationVariables>) {
        return Apollo.useMutation<TransitionAircraftProjectMutation, TransitionAircraftProjectMutationVariables>(TransitionAircraftProjectDocument, baseOptions);
      }
export type TransitionAircraftProjectMutationHookResult = ReturnType<typeof useTransitionAircraftProjectMutation>;
export type TransitionAircraftProjectMutationResult = Apollo.MutationResult<TransitionAircraftProjectMutation>;
export type TransitionAircraftProjectMutationOptions = Apollo.BaseMutationOptions<TransitionAircraftProjectMutation, TransitionAircraftProjectMutationVariables>;
export const SetAircraftProjectAssigneesDocument = gql`
    mutation setAircraftProjectAssignees($aircraftProjectId: Int!, $assigneeUserIds: [Int!]!) {
  setAircraftProjectAssignees(aircraftProjectId: $aircraftProjectId, assigneeUserIds: $assigneeUserIds) {
    id
  }
}
    `;
export type SetAircraftProjectAssigneesMutationFn = Apollo.MutationFunction<SetAircraftProjectAssigneesMutation, SetAircraftProjectAssigneesMutationVariables>;

/**
 * __useSetAircraftProjectAssigneesMutation__
 *
 * To run a mutation, you first call `useSetAircraftProjectAssigneesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAircraftProjectAssigneesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAircraftProjectAssigneesMutation, { data, loading, error }] = useSetAircraftProjectAssigneesMutation({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      assigneeUserIds: // value for 'assigneeUserIds'
 *   },
 * });
 */
export function useSetAircraftProjectAssigneesMutation(baseOptions?: Apollo.MutationHookOptions<SetAircraftProjectAssigneesMutation, SetAircraftProjectAssigneesMutationVariables>) {
        return Apollo.useMutation<SetAircraftProjectAssigneesMutation, SetAircraftProjectAssigneesMutationVariables>(SetAircraftProjectAssigneesDocument, baseOptions);
      }
export type SetAircraftProjectAssigneesMutationHookResult = ReturnType<typeof useSetAircraftProjectAssigneesMutation>;
export type SetAircraftProjectAssigneesMutationResult = Apollo.MutationResult<SetAircraftProjectAssigneesMutation>;
export type SetAircraftProjectAssigneesMutationOptions = Apollo.BaseMutationOptions<SetAircraftProjectAssigneesMutation, SetAircraftProjectAssigneesMutationVariables>;
export const SetAircraftProjectNoDcaInvoiceRequiredFlagDocument = gql`
    mutation setAircraftProjectNoDcaInvoiceRequiredFlag($id: Int!, $isNoDcaInvoiceRequired: Boolean!) {
  setAircraftProjectNoDcaInvoiceRequiredFlag(id: $id, isNoDcaInvoiceRequired: $isNoDcaInvoiceRequired)
}
    `;
export type SetAircraftProjectNoDcaInvoiceRequiredFlagMutationFn = Apollo.MutationFunction<SetAircraftProjectNoDcaInvoiceRequiredFlagMutation, SetAircraftProjectNoDcaInvoiceRequiredFlagMutationVariables>;

/**
 * __useSetAircraftProjectNoDcaInvoiceRequiredFlagMutation__
 *
 * To run a mutation, you first call `useSetAircraftProjectNoDcaInvoiceRequiredFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAircraftProjectNoDcaInvoiceRequiredFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAircraftProjectNoDcaInvoiceRequiredFlagMutation, { data, loading, error }] = useSetAircraftProjectNoDcaInvoiceRequiredFlagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isNoDcaInvoiceRequired: // value for 'isNoDcaInvoiceRequired'
 *   },
 * });
 */
export function useSetAircraftProjectNoDcaInvoiceRequiredFlagMutation(baseOptions?: Apollo.MutationHookOptions<SetAircraftProjectNoDcaInvoiceRequiredFlagMutation, SetAircraftProjectNoDcaInvoiceRequiredFlagMutationVariables>) {
        return Apollo.useMutation<SetAircraftProjectNoDcaInvoiceRequiredFlagMutation, SetAircraftProjectNoDcaInvoiceRequiredFlagMutationVariables>(SetAircraftProjectNoDcaInvoiceRequiredFlagDocument, baseOptions);
      }
export type SetAircraftProjectNoDcaInvoiceRequiredFlagMutationHookResult = ReturnType<typeof useSetAircraftProjectNoDcaInvoiceRequiredFlagMutation>;
export type SetAircraftProjectNoDcaInvoiceRequiredFlagMutationResult = Apollo.MutationResult<SetAircraftProjectNoDcaInvoiceRequiredFlagMutation>;
export type SetAircraftProjectNoDcaInvoiceRequiredFlagMutationOptions = Apollo.BaseMutationOptions<SetAircraftProjectNoDcaInvoiceRequiredFlagMutation, SetAircraftProjectNoDcaInvoiceRequiredFlagMutationVariables>;
export const SetAircraftProjectPriorityDocument = gql`
    mutation setAircraftProjectPriority($id: Int!, $isHighPriority: Boolean!) {
  setAircraftProjectPriority(id: $id, isHighPriority: $isHighPriority) {
    id
  }
}
    `;
export type SetAircraftProjectPriorityMutationFn = Apollo.MutationFunction<SetAircraftProjectPriorityMutation, SetAircraftProjectPriorityMutationVariables>;

/**
 * __useSetAircraftProjectPriorityMutation__
 *
 * To run a mutation, you first call `useSetAircraftProjectPriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAircraftProjectPriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAircraftProjectPriorityMutation, { data, loading, error }] = useSetAircraftProjectPriorityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isHighPriority: // value for 'isHighPriority'
 *   },
 * });
 */
export function useSetAircraftProjectPriorityMutation(baseOptions?: Apollo.MutationHookOptions<SetAircraftProjectPriorityMutation, SetAircraftProjectPriorityMutationVariables>) {
        return Apollo.useMutation<SetAircraftProjectPriorityMutation, SetAircraftProjectPriorityMutationVariables>(SetAircraftProjectPriorityDocument, baseOptions);
      }
export type SetAircraftProjectPriorityMutationHookResult = ReturnType<typeof useSetAircraftProjectPriorityMutation>;
export type SetAircraftProjectPriorityMutationResult = Apollo.MutationResult<SetAircraftProjectPriorityMutation>;
export type SetAircraftProjectPriorityMutationOptions = Apollo.BaseMutationOptions<SetAircraftProjectPriorityMutation, SetAircraftProjectPriorityMutationVariables>;
export const UpdateAircraftProjectMutationDocument = gql`
    mutation updateAircraftProjectMutation($updateAircraftProjectInput: UpdateAircraftProjectInput!, $ignoreWarnings: Boolean!) {
  updateAircraftProject(updateAircraftProjectInput: $updateAircraftProjectInput, ignoreWarnings: $ignoreWarnings) {
    aircraftProject {
      id
    }
    warnings
  }
}
    `;
export type UpdateAircraftProjectMutationMutationFn = Apollo.MutationFunction<UpdateAircraftProjectMutationMutation, UpdateAircraftProjectMutationMutationVariables>;

/**
 * __useUpdateAircraftProjectMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectMutationMutation, { data, loading, error }] = useUpdateAircraftProjectMutationMutation({
 *   variables: {
 *      updateAircraftProjectInput: // value for 'updateAircraftProjectInput'
 *      ignoreWarnings: // value for 'ignoreWarnings'
 *   },
 * });
 */
export function useUpdateAircraftProjectMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectMutationMutation, UpdateAircraftProjectMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectMutationMutation, UpdateAircraftProjectMutationMutationVariables>(UpdateAircraftProjectMutationDocument, baseOptions);
      }
export type UpdateAircraftProjectMutationMutationHookResult = ReturnType<typeof useUpdateAircraftProjectMutationMutation>;
export type UpdateAircraftProjectMutationMutationResult = Apollo.MutationResult<UpdateAircraftProjectMutationMutation>;
export type UpdateAircraftProjectMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectMutationMutation, UpdateAircraftProjectMutationMutationVariables>;
export const UpdateAircraftProjectInspectionsDocument = gql`
    mutation updateAircraftProjectInspections($input: UpdateAircraftProjectInspectionsInput!) {
  updateAircraftProjectInspections(input: $input)
}
    `;
export type UpdateAircraftProjectInspectionsMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInspectionsMutation, UpdateAircraftProjectInspectionsMutationVariables>;

/**
 * __useUpdateAircraftProjectInspectionsMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInspectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInspectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInspectionsMutation, { data, loading, error }] = useUpdateAircraftProjectInspectionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInspectionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInspectionsMutation, UpdateAircraftProjectInspectionsMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInspectionsMutation, UpdateAircraftProjectInspectionsMutationVariables>(UpdateAircraftProjectInspectionsDocument, baseOptions);
      }
export type UpdateAircraftProjectInspectionsMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInspectionsMutation>;
export type UpdateAircraftProjectInspectionsMutationResult = Apollo.MutationResult<UpdateAircraftProjectInspectionsMutation>;
export type UpdateAircraftProjectInspectionsMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInspectionsMutation, UpdateAircraftProjectInspectionsMutationVariables>;
export const UpdateAircraftProjectOfficialLetterDocumentNotesDocument = gql`
    mutation updateAircraftProjectOfficialLetterDocumentNotes($input: UpdateAircraftProjectOfficialLetterNotesInput!) {
  updateAircraftProjectOfficialLetterDocumentNotes(input: $input) {
    id
  }
}
    `;
export type UpdateAircraftProjectOfficialLetterDocumentNotesMutationFn = Apollo.MutationFunction<UpdateAircraftProjectOfficialLetterDocumentNotesMutation, UpdateAircraftProjectOfficialLetterDocumentNotesMutationVariables>;

/**
 * __useUpdateAircraftProjectOfficialLetterDocumentNotesMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectOfficialLetterDocumentNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectOfficialLetterDocumentNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectOfficialLetterDocumentNotesMutation, { data, loading, error }] = useUpdateAircraftProjectOfficialLetterDocumentNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectOfficialLetterDocumentNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectOfficialLetterDocumentNotesMutation, UpdateAircraftProjectOfficialLetterDocumentNotesMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectOfficialLetterDocumentNotesMutation, UpdateAircraftProjectOfficialLetterDocumentNotesMutationVariables>(UpdateAircraftProjectOfficialLetterDocumentNotesDocument, baseOptions);
      }
export type UpdateAircraftProjectOfficialLetterDocumentNotesMutationHookResult = ReturnType<typeof useUpdateAircraftProjectOfficialLetterDocumentNotesMutation>;
export type UpdateAircraftProjectOfficialLetterDocumentNotesMutationResult = Apollo.MutationResult<UpdateAircraftProjectOfficialLetterDocumentNotesMutation>;
export type UpdateAircraftProjectOfficialLetterDocumentNotesMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectOfficialLetterDocumentNotesMutation, UpdateAircraftProjectOfficialLetterDocumentNotesMutationVariables>;
export const AddAircraftProjectDocumentMutationDocument = gql`
    mutation addAircraftProjectDocumentMutation($addAircraftProjectDocumentInput: AddAircraftProjectDocumentInput!) {
  addAircraftProjectDocument(addAircraftProjectDocumentInput: $addAircraftProjectDocumentInput) {
    id
  }
}
    `;
export type AddAircraftProjectDocumentMutationMutationFn = Apollo.MutationFunction<AddAircraftProjectDocumentMutationMutation, AddAircraftProjectDocumentMutationMutationVariables>;

/**
 * __useAddAircraftProjectDocumentMutationMutation__
 *
 * To run a mutation, you first call `useAddAircraftProjectDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAircraftProjectDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAircraftProjectDocumentMutationMutation, { data, loading, error }] = useAddAircraftProjectDocumentMutationMutation({
 *   variables: {
 *      addAircraftProjectDocumentInput: // value for 'addAircraftProjectDocumentInput'
 *   },
 * });
 */
export function useAddAircraftProjectDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddAircraftProjectDocumentMutationMutation, AddAircraftProjectDocumentMutationMutationVariables>) {
        return Apollo.useMutation<AddAircraftProjectDocumentMutationMutation, AddAircraftProjectDocumentMutationMutationVariables>(AddAircraftProjectDocumentMutationDocument, baseOptions);
      }
export type AddAircraftProjectDocumentMutationMutationHookResult = ReturnType<typeof useAddAircraftProjectDocumentMutationMutation>;
export type AddAircraftProjectDocumentMutationMutationResult = Apollo.MutationResult<AddAircraftProjectDocumentMutationMutation>;
export type AddAircraftProjectDocumentMutationMutationOptions = Apollo.BaseMutationOptions<AddAircraftProjectDocumentMutationMutation, AddAircraftProjectDocumentMutationMutationVariables>;
export const UpdateAircraftProjectDocumentMutationDocument = gql`
    mutation updateAircraftProjectDocumentMutation($updateAircraftProjectDocumentInput: UpdateAircraftProjectDocumentInput!) {
  updateAircraftProjectDocument(updateAircraftProjectDocumentInput: $updateAircraftProjectDocumentInput) {
    id
  }
}
    `;
export type UpdateAircraftProjectDocumentMutationMutationFn = Apollo.MutationFunction<UpdateAircraftProjectDocumentMutationMutation, UpdateAircraftProjectDocumentMutationMutationVariables>;

/**
 * __useUpdateAircraftProjectDocumentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectDocumentMutationMutation, { data, loading, error }] = useUpdateAircraftProjectDocumentMutationMutation({
 *   variables: {
 *      updateAircraftProjectDocumentInput: // value for 'updateAircraftProjectDocumentInput'
 *   },
 * });
 */
export function useUpdateAircraftProjectDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectDocumentMutationMutation, UpdateAircraftProjectDocumentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectDocumentMutationMutation, UpdateAircraftProjectDocumentMutationMutationVariables>(UpdateAircraftProjectDocumentMutationDocument, baseOptions);
      }
export type UpdateAircraftProjectDocumentMutationMutationHookResult = ReturnType<typeof useUpdateAircraftProjectDocumentMutationMutation>;
export type UpdateAircraftProjectDocumentMutationMutationResult = Apollo.MutationResult<UpdateAircraftProjectDocumentMutationMutation>;
export type UpdateAircraftProjectDocumentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectDocumentMutationMutation, UpdateAircraftProjectDocumentMutationMutationVariables>;
export const RemoveAircraftProjectDocumentMutationDocument = gql`
    mutation removeAircraftProjectDocumentMutation($id: Int!) {
  removeAircraftProjectDocument(id: $id)
}
    `;
export type RemoveAircraftProjectDocumentMutationMutationFn = Apollo.MutationFunction<RemoveAircraftProjectDocumentMutationMutation, RemoveAircraftProjectDocumentMutationMutationVariables>;

/**
 * __useRemoveAircraftProjectDocumentMutationMutation__
 *
 * To run a mutation, you first call `useRemoveAircraftProjectDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAircraftProjectDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAircraftProjectDocumentMutationMutation, { data, loading, error }] = useRemoveAircraftProjectDocumentMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAircraftProjectDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAircraftProjectDocumentMutationMutation, RemoveAircraftProjectDocumentMutationMutationVariables>) {
        return Apollo.useMutation<RemoveAircraftProjectDocumentMutationMutation, RemoveAircraftProjectDocumentMutationMutationVariables>(RemoveAircraftProjectDocumentMutationDocument, baseOptions);
      }
export type RemoveAircraftProjectDocumentMutationMutationHookResult = ReturnType<typeof useRemoveAircraftProjectDocumentMutationMutation>;
export type RemoveAircraftProjectDocumentMutationMutationResult = Apollo.MutationResult<RemoveAircraftProjectDocumentMutationMutation>;
export type RemoveAircraftProjectDocumentMutationMutationOptions = Apollo.BaseMutationOptions<RemoveAircraftProjectDocumentMutationMutation, RemoveAircraftProjectDocumentMutationMutationVariables>;
export const DownloadAircraftProjectDocumentDocument = gql`
    query downloadAircraftProjectDocument($id: Int!, $aircraftProjectId: Int!) {
  file: downloadAircraftProjectDocument(id: $id, aircraftProjectId: $aircraftProjectId) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadAircraftProjectDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *   },
 * });
 */
export function useDownloadAircraftProjectDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectDocumentQuery, DownloadAircraftProjectDocumentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectDocumentQuery, DownloadAircraftProjectDocumentQueryVariables>(DownloadAircraftProjectDocumentDocument, baseOptions);
      }
export function useDownloadAircraftProjectDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectDocumentQuery, DownloadAircraftProjectDocumentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectDocumentQuery, DownloadAircraftProjectDocumentQueryVariables>(DownloadAircraftProjectDocumentDocument, baseOptions);
        }
export type DownloadAircraftProjectDocumentQueryHookResult = ReturnType<typeof useDownloadAircraftProjectDocumentQuery>;
export type DownloadAircraftProjectDocumentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectDocumentLazyQuery>;
export type DownloadAircraftProjectDocumentQueryResult = Apollo.QueryResult<DownloadAircraftProjectDocumentQuery, DownloadAircraftProjectDocumentQueryVariables>;
export const RequestAircraftProjectDocumentDownloadTokenMutationDocument = gql`
    mutation requestAircraftProjectDocumentDownloadTokenMutation($id: Int!, $aircraftProjectId: Int!, $downloadFileName: String) {
  requestAircraftProjectDocumentDownloadToken(id: $id, aircraftProjectId: $aircraftProjectId, downloadFileName: $downloadFileName)
}
    `;
export type RequestAircraftProjectDocumentDownloadTokenMutationMutationFn = Apollo.MutationFunction<RequestAircraftProjectDocumentDownloadTokenMutationMutation, RequestAircraftProjectDocumentDownloadTokenMutationMutationVariables>;

/**
 * __useRequestAircraftProjectDocumentDownloadTokenMutationMutation__
 *
 * To run a mutation, you first call `useRequestAircraftProjectDocumentDownloadTokenMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAircraftProjectDocumentDownloadTokenMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAircraftProjectDocumentDownloadTokenMutationMutation, { data, loading, error }] = useRequestAircraftProjectDocumentDownloadTokenMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      downloadFileName: // value for 'downloadFileName'
 *   },
 * });
 */
export function useRequestAircraftProjectDocumentDownloadTokenMutationMutation(baseOptions?: Apollo.MutationHookOptions<RequestAircraftProjectDocumentDownloadTokenMutationMutation, RequestAircraftProjectDocumentDownloadTokenMutationMutationVariables>) {
        return Apollo.useMutation<RequestAircraftProjectDocumentDownloadTokenMutationMutation, RequestAircraftProjectDocumentDownloadTokenMutationMutationVariables>(RequestAircraftProjectDocumentDownloadTokenMutationDocument, baseOptions);
      }
export type RequestAircraftProjectDocumentDownloadTokenMutationMutationHookResult = ReturnType<typeof useRequestAircraftProjectDocumentDownloadTokenMutationMutation>;
export type RequestAircraftProjectDocumentDownloadTokenMutationMutationResult = Apollo.MutationResult<RequestAircraftProjectDocumentDownloadTokenMutationMutation>;
export type RequestAircraftProjectDocumentDownloadTokenMutationMutationOptions = Apollo.BaseMutationOptions<RequestAircraftProjectDocumentDownloadTokenMutationMutation, RequestAircraftProjectDocumentDownloadTokenMutationMutationVariables>;
export const UpdateAircraftProjectDocumentReleasedToDcaMutationDocument = gql`
    mutation updateAircraftProjectDocumentReleasedToDcaMutation($input: UpdateAircraftProjectOperatorDocumentReleasedToDcaInput!) {
  updateAircraftProjectDocumentReleasedToDca(input: $input) {
    id
  }
}
    `;
export type UpdateAircraftProjectDocumentReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateAircraftProjectDocumentReleasedToDcaMutationMutation, UpdateAircraftProjectDocumentReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateAircraftProjectDocumentReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectDocumentReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectDocumentReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectDocumentReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateAircraftProjectDocumentReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectDocumentReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectDocumentReleasedToDcaMutationMutation, UpdateAircraftProjectDocumentReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectDocumentReleasedToDcaMutationMutation, UpdateAircraftProjectDocumentReleasedToDcaMutationMutationVariables>(UpdateAircraftProjectDocumentReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateAircraftProjectDocumentReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateAircraftProjectDocumentReleasedToDcaMutationMutation>;
export type UpdateAircraftProjectDocumentReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateAircraftProjectDocumentReleasedToDcaMutationMutation>;
export type UpdateAircraftProjectDocumentReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectDocumentReleasedToDcaMutationMutation, UpdateAircraftProjectDocumentReleasedToDcaMutationMutationVariables>;
export const AircraftProjectGridDocument = gql`
    query aircraftProjectGrid($sortBy: AircraftProjectsSortBy, $sortDirection: String, $aircraftId: Int, $projectStatusIdIn: [Int!], $projectStatusIdNotIn: [Int!], $operatorIdIn: [Int!], $keyword: String, $paginationOptions: PaginationOptions) {
  aircraftProjects(sortBy: $sortBy, sortDirection: $sortDirection, aircraftId: $aircraftId, projectStatusIdIn: $projectStatusIdIn, projectStatusIdNotIn: $projectStatusIdNotIn, operatorIdIn: $operatorIdIn, keyword: $keyword, paginationOptions: $paginationOptions) {
    ... on PaginatedAircraftProjects {
      totalItems
      aircraftProjects {
        ...aircraftProjectGridItem
      }
    }
    ... on AircraftProjects {
      aircraftProjects {
        ...aircraftProjectGridItem
      }
    }
  }
}
    ${AircraftProjectGridItemFragmentDoc}`;

/**
 * __useAircraftProjectGridQuery__
 *
 * To run a query within a React component, call `useAircraftProjectGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectGridQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      aircraftId: // value for 'aircraftId'
 *      projectStatusIdIn: // value for 'projectStatusIdIn'
 *      projectStatusIdNotIn: // value for 'projectStatusIdNotIn'
 *      operatorIdIn: // value for 'operatorIdIn'
 *      keyword: // value for 'keyword'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useAircraftProjectGridQuery(baseOptions?: Apollo.QueryHookOptions<AircraftProjectGridQuery, AircraftProjectGridQueryVariables>) {
        return Apollo.useQuery<AircraftProjectGridQuery, AircraftProjectGridQueryVariables>(AircraftProjectGridDocument, baseOptions);
      }
export function useAircraftProjectGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectGridQuery, AircraftProjectGridQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectGridQuery, AircraftProjectGridQueryVariables>(AircraftProjectGridDocument, baseOptions);
        }
export type AircraftProjectGridQueryHookResult = ReturnType<typeof useAircraftProjectGridQuery>;
export type AircraftProjectGridLazyQueryHookResult = ReturnType<typeof useAircraftProjectGridLazyQuery>;
export type AircraftProjectGridQueryResult = Apollo.QueryResult<AircraftProjectGridQuery, AircraftProjectGridQueryVariables>;
export const AddAircraftProjectInsFormAssociatedDocumentMutationDocument = gql`
    mutation addAircraftProjectInsFormAssociatedDocumentMutation($addAircraftProjectInsFormAssociatedDocumentInput: AddAircraftProjectInsFormAssociatedDocumentInput!) {
  addAircraftProjectInsFormAssociatedDocument(addAircraftProjectInsFormAssociatedDocumentInput: $addAircraftProjectInsFormAssociatedDocumentInput) {
    id
  }
}
    `;
export type AddAircraftProjectInsFormAssociatedDocumentMutationMutationFn = Apollo.MutationFunction<AddAircraftProjectInsFormAssociatedDocumentMutationMutation, AddAircraftProjectInsFormAssociatedDocumentMutationMutationVariables>;

/**
 * __useAddAircraftProjectInsFormAssociatedDocumentMutationMutation__
 *
 * To run a mutation, you first call `useAddAircraftProjectInsFormAssociatedDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAircraftProjectInsFormAssociatedDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAircraftProjectInsFormAssociatedDocumentMutationMutation, { data, loading, error }] = useAddAircraftProjectInsFormAssociatedDocumentMutationMutation({
 *   variables: {
 *      addAircraftProjectInsFormAssociatedDocumentInput: // value for 'addAircraftProjectInsFormAssociatedDocumentInput'
 *   },
 * });
 */
export function useAddAircraftProjectInsFormAssociatedDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddAircraftProjectInsFormAssociatedDocumentMutationMutation, AddAircraftProjectInsFormAssociatedDocumentMutationMutationVariables>) {
        return Apollo.useMutation<AddAircraftProjectInsFormAssociatedDocumentMutationMutation, AddAircraftProjectInsFormAssociatedDocumentMutationMutationVariables>(AddAircraftProjectInsFormAssociatedDocumentMutationDocument, baseOptions);
      }
export type AddAircraftProjectInsFormAssociatedDocumentMutationMutationHookResult = ReturnType<typeof useAddAircraftProjectInsFormAssociatedDocumentMutationMutation>;
export type AddAircraftProjectInsFormAssociatedDocumentMutationMutationResult = Apollo.MutationResult<AddAircraftProjectInsFormAssociatedDocumentMutationMutation>;
export type AddAircraftProjectInsFormAssociatedDocumentMutationMutationOptions = Apollo.BaseMutationOptions<AddAircraftProjectInsFormAssociatedDocumentMutationMutation, AddAircraftProjectInsFormAssociatedDocumentMutationMutationVariables>;
export const UpdateAircraftProjectInsFormAssociatedDocumentMutationDocument = gql`
    mutation updateAircraftProjectInsFormAssociatedDocumentMutation($updateAircraftProjectInsFormAssociatedDocumentInput: UpdateAircraftProjectInsFormAssociatedDocumentInput!) {
  updateAircraftProjectInsFormAssociatedDocument(updateAircraftProjectInsFormAssociatedDocumentInput: $updateAircraftProjectInsFormAssociatedDocumentInput) {
    id
  }
}
    `;
export type UpdateAircraftProjectInsFormAssociatedDocumentMutationMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInsFormAssociatedDocumentMutationMutation, UpdateAircraftProjectInsFormAssociatedDocumentMutationMutationVariables>;

/**
 * __useUpdateAircraftProjectInsFormAssociatedDocumentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInsFormAssociatedDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInsFormAssociatedDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInsFormAssociatedDocumentMutationMutation, { data, loading, error }] = useUpdateAircraftProjectInsFormAssociatedDocumentMutationMutation({
 *   variables: {
 *      updateAircraftProjectInsFormAssociatedDocumentInput: // value for 'updateAircraftProjectInsFormAssociatedDocumentInput'
 *   },
 * });
 */
export function useUpdateAircraftProjectInsFormAssociatedDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInsFormAssociatedDocumentMutationMutation, UpdateAircraftProjectInsFormAssociatedDocumentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInsFormAssociatedDocumentMutationMutation, UpdateAircraftProjectInsFormAssociatedDocumentMutationMutationVariables>(UpdateAircraftProjectInsFormAssociatedDocumentMutationDocument, baseOptions);
      }
export type UpdateAircraftProjectInsFormAssociatedDocumentMutationMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInsFormAssociatedDocumentMutationMutation>;
export type UpdateAircraftProjectInsFormAssociatedDocumentMutationMutationResult = Apollo.MutationResult<UpdateAircraftProjectInsFormAssociatedDocumentMutationMutation>;
export type UpdateAircraftProjectInsFormAssociatedDocumentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInsFormAssociatedDocumentMutationMutation, UpdateAircraftProjectInsFormAssociatedDocumentMutationMutationVariables>;
export const RemoveAircraftProjectInsFormAssociatedDocumentMutationDocument = gql`
    mutation removeAircraftProjectInsFormAssociatedDocumentMutation($id: Int!) {
  removeAircraftProjectInsFormAssociatedDocument(id: $id)
}
    `;
export type RemoveAircraftProjectInsFormAssociatedDocumentMutationMutationFn = Apollo.MutationFunction<RemoveAircraftProjectInsFormAssociatedDocumentMutationMutation, RemoveAircraftProjectInsFormAssociatedDocumentMutationMutationVariables>;

/**
 * __useRemoveAircraftProjectInsFormAssociatedDocumentMutationMutation__
 *
 * To run a mutation, you first call `useRemoveAircraftProjectInsFormAssociatedDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAircraftProjectInsFormAssociatedDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAircraftProjectInsFormAssociatedDocumentMutationMutation, { data, loading, error }] = useRemoveAircraftProjectInsFormAssociatedDocumentMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAircraftProjectInsFormAssociatedDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAircraftProjectInsFormAssociatedDocumentMutationMutation, RemoveAircraftProjectInsFormAssociatedDocumentMutationMutationVariables>) {
        return Apollo.useMutation<RemoveAircraftProjectInsFormAssociatedDocumentMutationMutation, RemoveAircraftProjectInsFormAssociatedDocumentMutationMutationVariables>(RemoveAircraftProjectInsFormAssociatedDocumentMutationDocument, baseOptions);
      }
export type RemoveAircraftProjectInsFormAssociatedDocumentMutationMutationHookResult = ReturnType<typeof useRemoveAircraftProjectInsFormAssociatedDocumentMutationMutation>;
export type RemoveAircraftProjectInsFormAssociatedDocumentMutationMutationResult = Apollo.MutationResult<RemoveAircraftProjectInsFormAssociatedDocumentMutationMutation>;
export type RemoveAircraftProjectInsFormAssociatedDocumentMutationMutationOptions = Apollo.BaseMutationOptions<RemoveAircraftProjectInsFormAssociatedDocumentMutationMutation, RemoveAircraftProjectInsFormAssociatedDocumentMutationMutationVariables>;
export const DownloadAircraftProjectInsFormAssociatedDocumentDocument = gql`
    query downloadAircraftProjectInsFormAssociatedDocument($id: Int!, $aircraftProjectId: Int!) {
  file: downloadAircraftProjectInsFormAssociatedDocument(id: $id, aircraftProjectId: $aircraftProjectId) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadAircraftProjectInsFormAssociatedDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectInsFormAssociatedDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectInsFormAssociatedDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectInsFormAssociatedDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *   },
 * });
 */
export function useDownloadAircraftProjectInsFormAssociatedDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectInsFormAssociatedDocumentQuery, DownloadAircraftProjectInsFormAssociatedDocumentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectInsFormAssociatedDocumentQuery, DownloadAircraftProjectInsFormAssociatedDocumentQueryVariables>(DownloadAircraftProjectInsFormAssociatedDocumentDocument, baseOptions);
      }
export function useDownloadAircraftProjectInsFormAssociatedDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectInsFormAssociatedDocumentQuery, DownloadAircraftProjectInsFormAssociatedDocumentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectInsFormAssociatedDocumentQuery, DownloadAircraftProjectInsFormAssociatedDocumentQueryVariables>(DownloadAircraftProjectInsFormAssociatedDocumentDocument, baseOptions);
        }
export type DownloadAircraftProjectInsFormAssociatedDocumentQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInsFormAssociatedDocumentQuery>;
export type DownloadAircraftProjectInsFormAssociatedDocumentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInsFormAssociatedDocumentLazyQuery>;
export type DownloadAircraftProjectInsFormAssociatedDocumentQueryResult = Apollo.QueryResult<DownloadAircraftProjectInsFormAssociatedDocumentQuery, DownloadAircraftProjectInsFormAssociatedDocumentQueryVariables>;
export const RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationDocument = gql`
    mutation requestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutation($id: Int!, $aircraftProjectId: Int!, $downloadFileName: String) {
  requestAircraftProjectInsFormAssociatedDocumentDownloadToken(id: $id, aircraftProjectId: $aircraftProjectId, downloadFileName: $downloadFileName)
}
    `;
export type RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutationFn = Apollo.MutationFunction<RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutation, RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutationVariables>;

/**
 * __useRequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutation__
 *
 * To run a mutation, you first call `useRequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutation, { data, loading, error }] = useRequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      downloadFileName: // value for 'downloadFileName'
 *   },
 * });
 */
export function useRequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutation(baseOptions?: Apollo.MutationHookOptions<RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutation, RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutationVariables>) {
        return Apollo.useMutation<RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutation, RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutationVariables>(RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationDocument, baseOptions);
      }
export type RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutationHookResult = ReturnType<typeof useRequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutation>;
export type RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutationResult = Apollo.MutationResult<RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutation>;
export type RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutationOptions = Apollo.BaseMutationOptions<RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutation, RequestAircraftProjectInsFormAssociatedDocumentDownloadTokenMutationMutationVariables>;
export const UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationDocument = gql`
    mutation updateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutation($input: UpdateAircraftProjectOperatorInsFormAssociatedDocumentReleasedToDcaInput!) {
  updateAircraftProjectInsFormAssociatedDocumentReleasedToDca(input: $input) {
    id
  }
}
    `;
export type UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutation, UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutation, UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutation, UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutationVariables>(UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutation>;
export type UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutation>;
export type UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutation, UpdateAircraftProjectInsFormAssociatedDocumentReleasedToDcaMutationMutationVariables>;
export const AircraftProjectInspectionCommentsDocument = gql`
    query aircraftProjectInspectionComments($id: Int!) {
  aircraftProjectInspectionComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useAircraftProjectInspectionCommentsQuery__
 *
 * To run a query within a React component, call `useAircraftProjectInspectionCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectInspectionCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectInspectionCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAircraftProjectInspectionCommentsQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectInspectionCommentsQuery, AircraftProjectInspectionCommentsQueryVariables>) {
        return Apollo.useQuery<AircraftProjectInspectionCommentsQuery, AircraftProjectInspectionCommentsQueryVariables>(AircraftProjectInspectionCommentsDocument, baseOptions);
      }
export function useAircraftProjectInspectionCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectInspectionCommentsQuery, AircraftProjectInspectionCommentsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectInspectionCommentsQuery, AircraftProjectInspectionCommentsQueryVariables>(AircraftProjectInspectionCommentsDocument, baseOptions);
        }
export type AircraftProjectInspectionCommentsQueryHookResult = ReturnType<typeof useAircraftProjectInspectionCommentsQuery>;
export type AircraftProjectInspectionCommentsLazyQueryHookResult = ReturnType<typeof useAircraftProjectInspectionCommentsLazyQuery>;
export type AircraftProjectInspectionCommentsQueryResult = Apollo.QueryResult<AircraftProjectInspectionCommentsQuery, AircraftProjectInspectionCommentsQueryVariables>;
export const AddAircraftProjectInspectionCommentDocument = gql`
    mutation addAircraftProjectInspectionComment($id: Int!, $input: CommentInput!) {
  addAircraftProjectInspectionComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddAircraftProjectInspectionCommentMutationFn = Apollo.MutationFunction<AddAircraftProjectInspectionCommentMutation, AddAircraftProjectInspectionCommentMutationVariables>;

/**
 * __useAddAircraftProjectInspectionCommentMutation__
 *
 * To run a mutation, you first call `useAddAircraftProjectInspectionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAircraftProjectInspectionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAircraftProjectInspectionCommentMutation, { data, loading, error }] = useAddAircraftProjectInspectionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAircraftProjectInspectionCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddAircraftProjectInspectionCommentMutation, AddAircraftProjectInspectionCommentMutationVariables>) {
        return Apollo.useMutation<AddAircraftProjectInspectionCommentMutation, AddAircraftProjectInspectionCommentMutationVariables>(AddAircraftProjectInspectionCommentDocument, baseOptions);
      }
export type AddAircraftProjectInspectionCommentMutationHookResult = ReturnType<typeof useAddAircraftProjectInspectionCommentMutation>;
export type AddAircraftProjectInspectionCommentMutationResult = Apollo.MutationResult<AddAircraftProjectInspectionCommentMutation>;
export type AddAircraftProjectInspectionCommentMutationOptions = Apollo.BaseMutationOptions<AddAircraftProjectInspectionCommentMutation, AddAircraftProjectInspectionCommentMutationVariables>;
export const UpdateAircraftProjectInspectionCommentDocument = gql`
    mutation updateAircraftProjectInspectionComment($id: Int!, $body: String!) {
  updateAircraftProjectInspectionComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateAircraftProjectInspectionCommentMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInspectionCommentMutation, UpdateAircraftProjectInspectionCommentMutationVariables>;

/**
 * __useUpdateAircraftProjectInspectionCommentMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInspectionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInspectionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInspectionCommentMutation, { data, loading, error }] = useUpdateAircraftProjectInspectionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateAircraftProjectInspectionCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInspectionCommentMutation, UpdateAircraftProjectInspectionCommentMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInspectionCommentMutation, UpdateAircraftProjectInspectionCommentMutationVariables>(UpdateAircraftProjectInspectionCommentDocument, baseOptions);
      }
export type UpdateAircraftProjectInspectionCommentMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInspectionCommentMutation>;
export type UpdateAircraftProjectInspectionCommentMutationResult = Apollo.MutationResult<UpdateAircraftProjectInspectionCommentMutation>;
export type UpdateAircraftProjectInspectionCommentMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInspectionCommentMutation, UpdateAircraftProjectInspectionCommentMutationVariables>;
export const UpdateAircraftProjectInspectionCommentsLastViewedDateDocument = gql`
    mutation updateAircraftProjectInspectionCommentsLastViewedDate($id: Int!) {
  updateAircraftProjectInspectionCommentsLastViewedDate(aircraftProjectOperatorInspectionMapId: $id) {
    id
  }
}
    `;
export type UpdateAircraftProjectInspectionCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInspectionCommentsLastViewedDateMutation, UpdateAircraftProjectInspectionCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateAircraftProjectInspectionCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInspectionCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInspectionCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInspectionCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateAircraftProjectInspectionCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAircraftProjectInspectionCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInspectionCommentsLastViewedDateMutation, UpdateAircraftProjectInspectionCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInspectionCommentsLastViewedDateMutation, UpdateAircraftProjectInspectionCommentsLastViewedDateMutationVariables>(UpdateAircraftProjectInspectionCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateAircraftProjectInspectionCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInspectionCommentsLastViewedDateMutation>;
export type UpdateAircraftProjectInspectionCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateAircraftProjectInspectionCommentsLastViewedDateMutation>;
export type UpdateAircraftProjectInspectionCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInspectionCommentsLastViewedDateMutation, UpdateAircraftProjectInspectionCommentsLastViewedDateMutationVariables>;
export const DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentDocument = gql`
    query downloadAircraftProjectInspectionLetterOfFindingsAttachmentContent($aircraftProjectId: Int!, $inspectionId: Int!) {
  downloadAircraftProjectInspectionLetterOfFindings(aircraftProjectId: $aircraftProjectId, inspectionId: $inspectionId)
}
    `;

/**
 * __useDownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useDownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQuery, DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQuery, DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQueryVariables>(DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentDocument, baseOptions);
      }
export function useDownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQuery, DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQuery, DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQueryVariables>(DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentDocument, baseOptions);
        }
export type DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQuery>;
export type DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentLazyQuery>;
export type DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQueryResult = Apollo.QueryResult<DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQuery, DownloadAircraftProjectInspectionLetterOfFindingsAttachmentContentQueryVariables>;
export const DownloadAircraftProjectInspectionInsForm4001AttachmentContentDocument = gql`
    query downloadAircraftProjectInspectionInsForm4001AttachmentContent($aircraftProjectId: Int!, $inspectionId: Int!) {
  downloadAircraftProjectInspectionInsForm4001(aircraftProjectId: $aircraftProjectId, inspectionId: $inspectionId)
}
    `;

/**
 * __useDownloadAircraftProjectInspectionInsForm4001AttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectInspectionInsForm4001AttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectInspectionInsForm4001AttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectInspectionInsForm4001AttachmentContentQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useDownloadAircraftProjectInspectionInsForm4001AttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectInspectionInsForm4001AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4001AttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectInspectionInsForm4001AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4001AttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInsForm4001AttachmentContentDocument, baseOptions);
      }
export function useDownloadAircraftProjectInspectionInsForm4001AttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectInspectionInsForm4001AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4001AttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectInspectionInsForm4001AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4001AttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInsForm4001AttachmentContentDocument, baseOptions);
        }
export type DownloadAircraftProjectInspectionInsForm4001AttachmentContentQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInsForm4001AttachmentContentQuery>;
export type DownloadAircraftProjectInspectionInsForm4001AttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInsForm4001AttachmentContentLazyQuery>;
export type DownloadAircraftProjectInspectionInsForm4001AttachmentContentQueryResult = Apollo.QueryResult<DownloadAircraftProjectInspectionInsForm4001AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4001AttachmentContentQueryVariables>;
export const DownloadAircraftProjectInspectionInsForm4007AttachmentContentDocument = gql`
    query downloadAircraftProjectInspectionInsForm4007AttachmentContent($aircraftProjectId: Int!, $inspectionId: Int!) {
  downloadAircraftProjectInspectionInsForm4007(aircraftProjectId: $aircraftProjectId, inspectionId: $inspectionId)
}
    `;

/**
 * __useDownloadAircraftProjectInspectionInsForm4007AttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectInspectionInsForm4007AttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectInspectionInsForm4007AttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectInspectionInsForm4007AttachmentContentQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useDownloadAircraftProjectInspectionInsForm4007AttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectInspectionInsForm4007AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4007AttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectInspectionInsForm4007AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4007AttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInsForm4007AttachmentContentDocument, baseOptions);
      }
export function useDownloadAircraftProjectInspectionInsForm4007AttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectInspectionInsForm4007AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4007AttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectInspectionInsForm4007AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4007AttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInsForm4007AttachmentContentDocument, baseOptions);
        }
export type DownloadAircraftProjectInspectionInsForm4007AttachmentContentQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInsForm4007AttachmentContentQuery>;
export type DownloadAircraftProjectInspectionInsForm4007AttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInsForm4007AttachmentContentLazyQuery>;
export type DownloadAircraftProjectInspectionInsForm4007AttachmentContentQueryResult = Apollo.QueryResult<DownloadAircraftProjectInspectionInsForm4007AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4007AttachmentContentQueryVariables>;
export const DownloadAircraftProjectInspectionInsForm4023BAttachmentContentDocument = gql`
    query downloadAircraftProjectInspectionInsForm4023BAttachmentContent($aircraftProjectId: Int!, $inspectionId: Int!) {
  downloadAircraftProjectInspectionInsForm4023B(aircraftProjectId: $aircraftProjectId, inspectionId: $inspectionId)
}
    `;

/**
 * __useDownloadAircraftProjectInspectionInsForm4023BAttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectInspectionInsForm4023BAttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectInspectionInsForm4023BAttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectInspectionInsForm4023BAttachmentContentQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useDownloadAircraftProjectInspectionInsForm4023BAttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectInspectionInsForm4023BAttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4023BAttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectInspectionInsForm4023BAttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4023BAttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInsForm4023BAttachmentContentDocument, baseOptions);
      }
export function useDownloadAircraftProjectInspectionInsForm4023BAttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectInspectionInsForm4023BAttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4023BAttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectInspectionInsForm4023BAttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4023BAttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInsForm4023BAttachmentContentDocument, baseOptions);
        }
export type DownloadAircraftProjectInspectionInsForm4023BAttachmentContentQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInsForm4023BAttachmentContentQuery>;
export type DownloadAircraftProjectInspectionInsForm4023BAttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInsForm4023BAttachmentContentLazyQuery>;
export type DownloadAircraftProjectInspectionInsForm4023BAttachmentContentQueryResult = Apollo.QueryResult<DownloadAircraftProjectInspectionInsForm4023BAttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4023BAttachmentContentQueryVariables>;
export const DownloadAircraftProjectInspectionInsForm4045AttachmentContentDocument = gql`
    query downloadAircraftProjectInspectionInsForm4045AttachmentContent($aircraftProjectId: Int!, $inspectionId: Int!) {
  downloadAircraftProjectInspectionInsForm4045(aircraftProjectId: $aircraftProjectId, inspectionId: $inspectionId)
}
    `;

/**
 * __useDownloadAircraftProjectInspectionInsForm4045AttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectInspectionInsForm4045AttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectInspectionInsForm4045AttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectInspectionInsForm4045AttachmentContentQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useDownloadAircraftProjectInspectionInsForm4045AttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectInspectionInsForm4045AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4045AttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectInspectionInsForm4045AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4045AttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInsForm4045AttachmentContentDocument, baseOptions);
      }
export function useDownloadAircraftProjectInspectionInsForm4045AttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectInspectionInsForm4045AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4045AttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectInspectionInsForm4045AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4045AttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInsForm4045AttachmentContentDocument, baseOptions);
        }
export type DownloadAircraftProjectInspectionInsForm4045AttachmentContentQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInsForm4045AttachmentContentQuery>;
export type DownloadAircraftProjectInspectionInsForm4045AttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInsForm4045AttachmentContentLazyQuery>;
export type DownloadAircraftProjectInspectionInsForm4045AttachmentContentQueryResult = Apollo.QueryResult<DownloadAircraftProjectInspectionInsForm4045AttachmentContentQuery, DownloadAircraftProjectInspectionInsForm4045AttachmentContentQueryVariables>;
export const DownloadAircraftProjectInspectionInsForm16005AAttachmentContentDocument = gql`
    query downloadAircraftProjectInspectionInsForm16005AAttachmentContent($aircraftProjectId: Int!, $inspectionId: Int!) {
  downloadAircraftProjectInspectionInsForm16005A(aircraftProjectId: $aircraftProjectId, inspectionId: $inspectionId)
}
    `;

/**
 * __useDownloadAircraftProjectInspectionInsForm16005AAttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectInspectionInsForm16005AAttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectInspectionInsForm16005AAttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectInspectionInsForm16005AAttachmentContentQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useDownloadAircraftProjectInspectionInsForm16005AAttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectInspectionInsForm16005AAttachmentContentQuery, DownloadAircraftProjectInspectionInsForm16005AAttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectInspectionInsForm16005AAttachmentContentQuery, DownloadAircraftProjectInspectionInsForm16005AAttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInsForm16005AAttachmentContentDocument, baseOptions);
      }
export function useDownloadAircraftProjectInspectionInsForm16005AAttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectInspectionInsForm16005AAttachmentContentQuery, DownloadAircraftProjectInspectionInsForm16005AAttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectInspectionInsForm16005AAttachmentContentQuery, DownloadAircraftProjectInspectionInsForm16005AAttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInsForm16005AAttachmentContentDocument, baseOptions);
        }
export type DownloadAircraftProjectInspectionInsForm16005AAttachmentContentQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInsForm16005AAttachmentContentQuery>;
export type DownloadAircraftProjectInspectionInsForm16005AAttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInsForm16005AAttachmentContentLazyQuery>;
export type DownloadAircraftProjectInspectionInsForm16005AAttachmentContentQueryResult = Apollo.QueryResult<DownloadAircraftProjectInspectionInsForm16005AAttachmentContentQuery, DownloadAircraftProjectInspectionInsForm16005AAttachmentContentQueryVariables>;
export const DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentDocument = gql`
    query downloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContent($aircraftProjectId: Int!, $inspectionId: Int!, $inspectorInspectionId: Int!) {
  downloadAircraftProjectInspectionInspectorInspectionEstimate(aircraftProjectId: $aircraftProjectId, inspectionId: $inspectionId, inspectorInspectionId: $inspectorInspectionId)
}
    `;

/**
 * __useDownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      inspectionId: // value for 'inspectionId'
 *      inspectorInspectionId: // value for 'inspectorInspectionId'
 *   },
 * });
 */
export function useDownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentDocument, baseOptions);
      }
export function useDownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentDocument, baseOptions);
        }
export type DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQuery>;
export type DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentLazyQuery>;
export type DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQueryResult = Apollo.QueryResult<DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionEstimateAttachmentContentQueryVariables>;
export const DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentDocument = gql`
    query downloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContent($aircraftProjectId: Int!, $inspectionId: Int!, $inspectorInspectionId: Int!) {
  downloadAircraftProjectInspectionInspectorInspectionInvoice(aircraftProjectId: $aircraftProjectId, inspectionId: $inspectionId, inspectorInspectionId: $inspectorInspectionId)
}
    `;

/**
 * __useDownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      inspectionId: // value for 'inspectionId'
 *      inspectorInspectionId: // value for 'inspectorInspectionId'
 *   },
 * });
 */
export function useDownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentDocument, baseOptions);
      }
export function useDownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentDocument, baseOptions);
        }
export type DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQuery>;
export type DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentLazyQuery>;
export type DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQueryResult = Apollo.QueryResult<DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionInvoiceAttachmentContentQueryVariables>;
export const DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentDocument = gql`
    query downloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContent($aircraftProjectId: Int!, $inspectionId: Int!, $inspectorInspectionId: Int!) {
  downloadAircraftProjectInspectionInspectorInspectionTimeLog(aircraftProjectId: $aircraftProjectId, inspectionId: $inspectionId, inspectorInspectionId: $inspectorInspectionId)
}
    `;

/**
 * __useDownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      inspectionId: // value for 'inspectionId'
 *      inspectorInspectionId: // value for 'inspectorInspectionId'
 *   },
 * });
 */
export function useDownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentDocument, baseOptions);
      }
export function useDownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQueryVariables>(DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentDocument, baseOptions);
        }
export type DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQuery>;
export type DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentLazyQuery>;
export type DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQueryResult = Apollo.QueryResult<DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQuery, DownloadAircraftProjectInspectionInspectorInspectionTimeLogAttachmentContentQueryVariables>;
export const AircraftProjectCommentsDocument = gql`
    query aircraftProjectComments($id: Int!) {
  aircraftProjectComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useAircraftProjectCommentsQuery__
 *
 * To run a query within a React component, call `useAircraftProjectCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAircraftProjectCommentsQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectCommentsQuery, AircraftProjectCommentsQueryVariables>) {
        return Apollo.useQuery<AircraftProjectCommentsQuery, AircraftProjectCommentsQueryVariables>(AircraftProjectCommentsDocument, baseOptions);
      }
export function useAircraftProjectCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectCommentsQuery, AircraftProjectCommentsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectCommentsQuery, AircraftProjectCommentsQueryVariables>(AircraftProjectCommentsDocument, baseOptions);
        }
export type AircraftProjectCommentsQueryHookResult = ReturnType<typeof useAircraftProjectCommentsQuery>;
export type AircraftProjectCommentsLazyQueryHookResult = ReturnType<typeof useAircraftProjectCommentsLazyQuery>;
export type AircraftProjectCommentsQueryResult = Apollo.QueryResult<AircraftProjectCommentsQuery, AircraftProjectCommentsQueryVariables>;
export const AddAircraftProjectCommentDocument = gql`
    mutation addAircraftProjectComment($id: Int!, $input: CommentInput!) {
  addAircraftProjectComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddAircraftProjectCommentMutationFn = Apollo.MutationFunction<AddAircraftProjectCommentMutation, AddAircraftProjectCommentMutationVariables>;

/**
 * __useAddAircraftProjectCommentMutation__
 *
 * To run a mutation, you first call `useAddAircraftProjectCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAircraftProjectCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAircraftProjectCommentMutation, { data, loading, error }] = useAddAircraftProjectCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAircraftProjectCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddAircraftProjectCommentMutation, AddAircraftProjectCommentMutationVariables>) {
        return Apollo.useMutation<AddAircraftProjectCommentMutation, AddAircraftProjectCommentMutationVariables>(AddAircraftProjectCommentDocument, baseOptions);
      }
export type AddAircraftProjectCommentMutationHookResult = ReturnType<typeof useAddAircraftProjectCommentMutation>;
export type AddAircraftProjectCommentMutationResult = Apollo.MutationResult<AddAircraftProjectCommentMutation>;
export type AddAircraftProjectCommentMutationOptions = Apollo.BaseMutationOptions<AddAircraftProjectCommentMutation, AddAircraftProjectCommentMutationVariables>;
export const UpdateAircraftProjectCommentDocument = gql`
    mutation updateAircraftProjectComment($id: Int!, $body: String!) {
  updateAircraftProjectComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateAircraftProjectCommentMutationFn = Apollo.MutationFunction<UpdateAircraftProjectCommentMutation, UpdateAircraftProjectCommentMutationVariables>;

/**
 * __useUpdateAircraftProjectCommentMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectCommentMutation, { data, loading, error }] = useUpdateAircraftProjectCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateAircraftProjectCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectCommentMutation, UpdateAircraftProjectCommentMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectCommentMutation, UpdateAircraftProjectCommentMutationVariables>(UpdateAircraftProjectCommentDocument, baseOptions);
      }
export type UpdateAircraftProjectCommentMutationHookResult = ReturnType<typeof useUpdateAircraftProjectCommentMutation>;
export type UpdateAircraftProjectCommentMutationResult = Apollo.MutationResult<UpdateAircraftProjectCommentMutation>;
export type UpdateAircraftProjectCommentMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectCommentMutation, UpdateAircraftProjectCommentMutationVariables>;
export const AircraftProjectDcaCommentsDocument = gql`
    query aircraftProjectDcaComments($id: Int!) {
  aircraftProjectDcaComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useAircraftProjectDcaCommentsQuery__
 *
 * To run a query within a React component, call `useAircraftProjectDcaCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectDcaCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectDcaCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAircraftProjectDcaCommentsQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectDcaCommentsQuery, AircraftProjectDcaCommentsQueryVariables>) {
        return Apollo.useQuery<AircraftProjectDcaCommentsQuery, AircraftProjectDcaCommentsQueryVariables>(AircraftProjectDcaCommentsDocument, baseOptions);
      }
export function useAircraftProjectDcaCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectDcaCommentsQuery, AircraftProjectDcaCommentsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectDcaCommentsQuery, AircraftProjectDcaCommentsQueryVariables>(AircraftProjectDcaCommentsDocument, baseOptions);
        }
export type AircraftProjectDcaCommentsQueryHookResult = ReturnType<typeof useAircraftProjectDcaCommentsQuery>;
export type AircraftProjectDcaCommentsLazyQueryHookResult = ReturnType<typeof useAircraftProjectDcaCommentsLazyQuery>;
export type AircraftProjectDcaCommentsQueryResult = Apollo.QueryResult<AircraftProjectDcaCommentsQuery, AircraftProjectDcaCommentsQueryVariables>;
export const AddAircraftProjectDcaCommentDocument = gql`
    mutation addAircraftProjectDcaComment($id: Int!, $input: CommentInput!) {
  addAircraftProjectDcaComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddAircraftProjectDcaCommentMutationFn = Apollo.MutationFunction<AddAircraftProjectDcaCommentMutation, AddAircraftProjectDcaCommentMutationVariables>;

/**
 * __useAddAircraftProjectDcaCommentMutation__
 *
 * To run a mutation, you first call `useAddAircraftProjectDcaCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAircraftProjectDcaCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAircraftProjectDcaCommentMutation, { data, loading, error }] = useAddAircraftProjectDcaCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAircraftProjectDcaCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddAircraftProjectDcaCommentMutation, AddAircraftProjectDcaCommentMutationVariables>) {
        return Apollo.useMutation<AddAircraftProjectDcaCommentMutation, AddAircraftProjectDcaCommentMutationVariables>(AddAircraftProjectDcaCommentDocument, baseOptions);
      }
export type AddAircraftProjectDcaCommentMutationHookResult = ReturnType<typeof useAddAircraftProjectDcaCommentMutation>;
export type AddAircraftProjectDcaCommentMutationResult = Apollo.MutationResult<AddAircraftProjectDcaCommentMutation>;
export type AddAircraftProjectDcaCommentMutationOptions = Apollo.BaseMutationOptions<AddAircraftProjectDcaCommentMutation, AddAircraftProjectDcaCommentMutationVariables>;
export const UpdateAircraftProjectDcaCommentDocument = gql`
    mutation updateAircraftProjectDcaComment($id: Int!, $body: String!) {
  updateAircraftProjectDcaComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateAircraftProjectDcaCommentMutationFn = Apollo.MutationFunction<UpdateAircraftProjectDcaCommentMutation, UpdateAircraftProjectDcaCommentMutationVariables>;

/**
 * __useUpdateAircraftProjectDcaCommentMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectDcaCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectDcaCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectDcaCommentMutation, { data, loading, error }] = useUpdateAircraftProjectDcaCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateAircraftProjectDcaCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectDcaCommentMutation, UpdateAircraftProjectDcaCommentMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectDcaCommentMutation, UpdateAircraftProjectDcaCommentMutationVariables>(UpdateAircraftProjectDcaCommentDocument, baseOptions);
      }
export type UpdateAircraftProjectDcaCommentMutationHookResult = ReturnType<typeof useUpdateAircraftProjectDcaCommentMutation>;
export type UpdateAircraftProjectDcaCommentMutationResult = Apollo.MutationResult<UpdateAircraftProjectDcaCommentMutation>;
export type UpdateAircraftProjectDcaCommentMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectDcaCommentMutation, UpdateAircraftProjectDcaCommentMutationVariables>;
export const UpdateAircraftProjectInspectionLetterOfFindingsDocument = gql`
    mutation updateAircraftProjectInspectionLetterOfFindings($input: UpdateAircraftProjectInspectionLetterOfFindingsInput!) {
  updateAircraftProjectInspectionLetterOfFindings(input: $input)
}
    `;
export type UpdateAircraftProjectInspectionLetterOfFindingsMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInspectionLetterOfFindingsMutation, UpdateAircraftProjectInspectionLetterOfFindingsMutationVariables>;

/**
 * __useUpdateAircraftProjectInspectionLetterOfFindingsMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInspectionLetterOfFindingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInspectionLetterOfFindingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInspectionLetterOfFindingsMutation, { data, loading, error }] = useUpdateAircraftProjectInspectionLetterOfFindingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInspectionLetterOfFindingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInspectionLetterOfFindingsMutation, UpdateAircraftProjectInspectionLetterOfFindingsMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInspectionLetterOfFindingsMutation, UpdateAircraftProjectInspectionLetterOfFindingsMutationVariables>(UpdateAircraftProjectInspectionLetterOfFindingsDocument, baseOptions);
      }
export type UpdateAircraftProjectInspectionLetterOfFindingsMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInspectionLetterOfFindingsMutation>;
export type UpdateAircraftProjectInspectionLetterOfFindingsMutationResult = Apollo.MutationResult<UpdateAircraftProjectInspectionLetterOfFindingsMutation>;
export type UpdateAircraftProjectInspectionLetterOfFindingsMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInspectionLetterOfFindingsMutation, UpdateAircraftProjectInspectionLetterOfFindingsMutationVariables>;
export const UpdateAircraftProjectInspectionInsForm4001Document = gql`
    mutation updateAircraftProjectInspectionInsForm4001($input: UpdateAircraftProjectInspectionInsForm4001Input!) {
  updateAircraftProjectInspectionInsForm4001(input: $input)
}
    `;
export type UpdateAircraftProjectInspectionInsForm4001MutationFn = Apollo.MutationFunction<UpdateAircraftProjectInspectionInsForm4001Mutation, UpdateAircraftProjectInspectionInsForm4001MutationVariables>;

/**
 * __useUpdateAircraftProjectInspectionInsForm4001Mutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInspectionInsForm4001Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInspectionInsForm4001Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInspectionInsForm4001Mutation, { data, loading, error }] = useUpdateAircraftProjectInspectionInsForm4001Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInspectionInsForm4001Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInspectionInsForm4001Mutation, UpdateAircraftProjectInspectionInsForm4001MutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInspectionInsForm4001Mutation, UpdateAircraftProjectInspectionInsForm4001MutationVariables>(UpdateAircraftProjectInspectionInsForm4001Document, baseOptions);
      }
export type UpdateAircraftProjectInspectionInsForm4001MutationHookResult = ReturnType<typeof useUpdateAircraftProjectInspectionInsForm4001Mutation>;
export type UpdateAircraftProjectInspectionInsForm4001MutationResult = Apollo.MutationResult<UpdateAircraftProjectInspectionInsForm4001Mutation>;
export type UpdateAircraftProjectInspectionInsForm4001MutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInspectionInsForm4001Mutation, UpdateAircraftProjectInspectionInsForm4001MutationVariables>;
export const UpdateAircraftProjectInspectionInsForm4007Document = gql`
    mutation updateAircraftProjectInspectionInsForm4007($input: UpdateAircraftProjectInspectionInsForm4007Input!) {
  updateAircraftProjectInspectionInsForm4007(input: $input)
}
    `;
export type UpdateAircraftProjectInspectionInsForm4007MutationFn = Apollo.MutationFunction<UpdateAircraftProjectInspectionInsForm4007Mutation, UpdateAircraftProjectInspectionInsForm4007MutationVariables>;

/**
 * __useUpdateAircraftProjectInspectionInsForm4007Mutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInspectionInsForm4007Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInspectionInsForm4007Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInspectionInsForm4007Mutation, { data, loading, error }] = useUpdateAircraftProjectInspectionInsForm4007Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInspectionInsForm4007Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInspectionInsForm4007Mutation, UpdateAircraftProjectInspectionInsForm4007MutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInspectionInsForm4007Mutation, UpdateAircraftProjectInspectionInsForm4007MutationVariables>(UpdateAircraftProjectInspectionInsForm4007Document, baseOptions);
      }
export type UpdateAircraftProjectInspectionInsForm4007MutationHookResult = ReturnType<typeof useUpdateAircraftProjectInspectionInsForm4007Mutation>;
export type UpdateAircraftProjectInspectionInsForm4007MutationResult = Apollo.MutationResult<UpdateAircraftProjectInspectionInsForm4007Mutation>;
export type UpdateAircraftProjectInspectionInsForm4007MutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInspectionInsForm4007Mutation, UpdateAircraftProjectInspectionInsForm4007MutationVariables>;
export const UpdateAircraftProjectInspectionInsForm4023BDocument = gql`
    mutation updateAircraftProjectInspectionInsForm4023B($input: UpdateAircraftProjectInspectionInsForm4023BInput!) {
  updateAircraftProjectInspectionInsForm4023B(input: $input)
}
    `;
export type UpdateAircraftProjectInspectionInsForm4023BMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInspectionInsForm4023BMutation, UpdateAircraftProjectInspectionInsForm4023BMutationVariables>;

/**
 * __useUpdateAircraftProjectInspectionInsForm4023BMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInspectionInsForm4023BMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInspectionInsForm4023BMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInspectionInsForm4023BMutation, { data, loading, error }] = useUpdateAircraftProjectInspectionInsForm4023BMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInspectionInsForm4023BMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInspectionInsForm4023BMutation, UpdateAircraftProjectInspectionInsForm4023BMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInspectionInsForm4023BMutation, UpdateAircraftProjectInspectionInsForm4023BMutationVariables>(UpdateAircraftProjectInspectionInsForm4023BDocument, baseOptions);
      }
export type UpdateAircraftProjectInspectionInsForm4023BMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInspectionInsForm4023BMutation>;
export type UpdateAircraftProjectInspectionInsForm4023BMutationResult = Apollo.MutationResult<UpdateAircraftProjectInspectionInsForm4023BMutation>;
export type UpdateAircraftProjectInspectionInsForm4023BMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInspectionInsForm4023BMutation, UpdateAircraftProjectInspectionInsForm4023BMutationVariables>;
export const UpdateAircraftProjectInspectionInsForm4045Document = gql`
    mutation updateAircraftProjectInspectionInsForm4045($input: UpdateAircraftProjectInspectionInsForm4045Input!) {
  updateAircraftProjectInspectionInsForm4045(input: $input)
}
    `;
export type UpdateAircraftProjectInspectionInsForm4045MutationFn = Apollo.MutationFunction<UpdateAircraftProjectInspectionInsForm4045Mutation, UpdateAircraftProjectInspectionInsForm4045MutationVariables>;

/**
 * __useUpdateAircraftProjectInspectionInsForm4045Mutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInspectionInsForm4045Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInspectionInsForm4045Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInspectionInsForm4045Mutation, { data, loading, error }] = useUpdateAircraftProjectInspectionInsForm4045Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInspectionInsForm4045Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInspectionInsForm4045Mutation, UpdateAircraftProjectInspectionInsForm4045MutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInspectionInsForm4045Mutation, UpdateAircraftProjectInspectionInsForm4045MutationVariables>(UpdateAircraftProjectInspectionInsForm4045Document, baseOptions);
      }
export type UpdateAircraftProjectInspectionInsForm4045MutationHookResult = ReturnType<typeof useUpdateAircraftProjectInspectionInsForm4045Mutation>;
export type UpdateAircraftProjectInspectionInsForm4045MutationResult = Apollo.MutationResult<UpdateAircraftProjectInspectionInsForm4045Mutation>;
export type UpdateAircraftProjectInspectionInsForm4045MutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInspectionInsForm4045Mutation, UpdateAircraftProjectInspectionInsForm4045MutationVariables>;
export const UpdateAircraftProjectInspectionInsForm16005ADocument = gql`
    mutation updateAircraftProjectInspectionInsForm16005A($input: UpdateAircraftProjectInspectionInsForm16005AInput!) {
  updateAircraftProjectInspectionInsForm16005A(input: $input)
}
    `;
export type UpdateAircraftProjectInspectionInsForm16005AMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInspectionInsForm16005AMutation, UpdateAircraftProjectInspectionInsForm16005AMutationVariables>;

/**
 * __useUpdateAircraftProjectInspectionInsForm16005AMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInspectionInsForm16005AMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInspectionInsForm16005AMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInspectionInsForm16005AMutation, { data, loading, error }] = useUpdateAircraftProjectInspectionInsForm16005AMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInspectionInsForm16005AMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInspectionInsForm16005AMutation, UpdateAircraftProjectInspectionInsForm16005AMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInspectionInsForm16005AMutation, UpdateAircraftProjectInspectionInsForm16005AMutationVariables>(UpdateAircraftProjectInspectionInsForm16005ADocument, baseOptions);
      }
export type UpdateAircraftProjectInspectionInsForm16005AMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInspectionInsForm16005AMutation>;
export type UpdateAircraftProjectInspectionInsForm16005AMutationResult = Apollo.MutationResult<UpdateAircraftProjectInspectionInsForm16005AMutation>;
export type UpdateAircraftProjectInspectionInsForm16005AMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInspectionInsForm16005AMutation, UpdateAircraftProjectInspectionInsForm16005AMutationVariables>;
export const UpdateAircraftProjectInspectionInspectionEstimateDocument = gql`
    mutation updateAircraftProjectInspectionInspectionEstimate($input: UpdateAircraftProjectInspectionInspectionEstimateInput!) {
  updateAircraftProjectInspectionInspectionEstimate(input: $input)
}
    `;
export type UpdateAircraftProjectInspectionInspectionEstimateMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInspectionInspectionEstimateMutation, UpdateAircraftProjectInspectionInspectionEstimateMutationVariables>;

/**
 * __useUpdateAircraftProjectInspectionInspectionEstimateMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInspectionInspectionEstimateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInspectionInspectionEstimateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInspectionInspectionEstimateMutation, { data, loading, error }] = useUpdateAircraftProjectInspectionInspectionEstimateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInspectionInspectionEstimateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInspectionInspectionEstimateMutation, UpdateAircraftProjectInspectionInspectionEstimateMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInspectionInspectionEstimateMutation, UpdateAircraftProjectInspectionInspectionEstimateMutationVariables>(UpdateAircraftProjectInspectionInspectionEstimateDocument, baseOptions);
      }
export type UpdateAircraftProjectInspectionInspectionEstimateMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInspectionInspectionEstimateMutation>;
export type UpdateAircraftProjectInspectionInspectionEstimateMutationResult = Apollo.MutationResult<UpdateAircraftProjectInspectionInspectionEstimateMutation>;
export type UpdateAircraftProjectInspectionInspectionEstimateMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInspectionInspectionEstimateMutation, UpdateAircraftProjectInspectionInspectionEstimateMutationVariables>;
export const UpdateAircraftProjectInspectionInspectionInvoiceDocument = gql`
    mutation updateAircraftProjectInspectionInspectionInvoice($input: UpdateAircraftProjectInspectionInspectionInvoiceInput!) {
  updateAircraftProjectInspectionInspectionInvoice(input: $input)
}
    `;
export type UpdateAircraftProjectInspectionInspectionInvoiceMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInspectionInspectionInvoiceMutation, UpdateAircraftProjectInspectionInspectionInvoiceMutationVariables>;

/**
 * __useUpdateAircraftProjectInspectionInspectionInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInspectionInspectionInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInspectionInspectionInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInspectionInspectionInvoiceMutation, { data, loading, error }] = useUpdateAircraftProjectInspectionInspectionInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInspectionInspectionInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInspectionInspectionInvoiceMutation, UpdateAircraftProjectInspectionInspectionInvoiceMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInspectionInspectionInvoiceMutation, UpdateAircraftProjectInspectionInspectionInvoiceMutationVariables>(UpdateAircraftProjectInspectionInspectionInvoiceDocument, baseOptions);
      }
export type UpdateAircraftProjectInspectionInspectionInvoiceMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInspectionInspectionInvoiceMutation>;
export type UpdateAircraftProjectInspectionInspectionInvoiceMutationResult = Apollo.MutationResult<UpdateAircraftProjectInspectionInspectionInvoiceMutation>;
export type UpdateAircraftProjectInspectionInspectionInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInspectionInspectionInvoiceMutation, UpdateAircraftProjectInspectionInspectionInvoiceMutationVariables>;
export const UpdateAircraftProjectInspectionInspectionTimeLogDocument = gql`
    mutation updateAircraftProjectInspectionInspectionTimeLog($input: UpdateAircraftProjectInspectionInspectionTimeLogInput!) {
  updateAircraftProjectInspectionInspectionTimeLog(input: $input)
}
    `;
export type UpdateAircraftProjectInspectionInspectionTimeLogMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInspectionInspectionTimeLogMutation, UpdateAircraftProjectInspectionInspectionTimeLogMutationVariables>;

/**
 * __useUpdateAircraftProjectInspectionInspectionTimeLogMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInspectionInspectionTimeLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInspectionInspectionTimeLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInspectionInspectionTimeLogMutation, { data, loading, error }] = useUpdateAircraftProjectInspectionInspectionTimeLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInspectionInspectionTimeLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInspectionInspectionTimeLogMutation, UpdateAircraftProjectInspectionInspectionTimeLogMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInspectionInspectionTimeLogMutation, UpdateAircraftProjectInspectionInspectionTimeLogMutationVariables>(UpdateAircraftProjectInspectionInspectionTimeLogDocument, baseOptions);
      }
export type UpdateAircraftProjectInspectionInspectionTimeLogMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInspectionInspectionTimeLogMutation>;
export type UpdateAircraftProjectInspectionInspectionTimeLogMutationResult = Apollo.MutationResult<UpdateAircraftProjectInspectionInspectionTimeLogMutation>;
export type UpdateAircraftProjectInspectionInspectionTimeLogMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInspectionInspectionTimeLogMutation, UpdateAircraftProjectInspectionInspectionTimeLogMutationVariables>;
export const AddAircraftProjectMutationDocument = gql`
    mutation addAircraftProjectMutation($addAircraftProjectInput: AddAircraftProjectInput!) {
  addAircraftProject(addAircraftProjectInput: $addAircraftProjectInput) {
    id
  }
}
    `;
export type AddAircraftProjectMutationMutationFn = Apollo.MutationFunction<AddAircraftProjectMutationMutation, AddAircraftProjectMutationMutationVariables>;

/**
 * __useAddAircraftProjectMutationMutation__
 *
 * To run a mutation, you first call `useAddAircraftProjectMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAircraftProjectMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAircraftProjectMutationMutation, { data, loading, error }] = useAddAircraftProjectMutationMutation({
 *   variables: {
 *      addAircraftProjectInput: // value for 'addAircraftProjectInput'
 *   },
 * });
 */
export function useAddAircraftProjectMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddAircraftProjectMutationMutation, AddAircraftProjectMutationMutationVariables>) {
        return Apollo.useMutation<AddAircraftProjectMutationMutation, AddAircraftProjectMutationMutationVariables>(AddAircraftProjectMutationDocument, baseOptions);
      }
export type AddAircraftProjectMutationMutationHookResult = ReturnType<typeof useAddAircraftProjectMutationMutation>;
export type AddAircraftProjectMutationMutationResult = Apollo.MutationResult<AddAircraftProjectMutationMutation>;
export type AddAircraftProjectMutationMutationOptions = Apollo.BaseMutationOptions<AddAircraftProjectMutationMutation, AddAircraftProjectMutationMutationVariables>;
export const AircraftInspectionsDocument = gql`
    query aircraftInspections {
  inspectorInspections {
    ... on InspectorInspections {
      inspectorInspections {
        ...inspectorAvailabilityEvent
      }
    }
  }
}
    ${InspectorAvailabilityEventFragmentDoc}`;

/**
 * __useAircraftInspectionsQuery__
 *
 * To run a query within a React component, call `useAircraftInspectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftInspectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftInspectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAircraftInspectionsQuery(baseOptions?: Apollo.QueryHookOptions<AircraftInspectionsQuery, AircraftInspectionsQueryVariables>) {
        return Apollo.useQuery<AircraftInspectionsQuery, AircraftInspectionsQueryVariables>(AircraftInspectionsDocument, baseOptions);
      }
export function useAircraftInspectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftInspectionsQuery, AircraftInspectionsQueryVariables>) {
          return Apollo.useLazyQuery<AircraftInspectionsQuery, AircraftInspectionsQueryVariables>(AircraftInspectionsDocument, baseOptions);
        }
export type AircraftInspectionsQueryHookResult = ReturnType<typeof useAircraftInspectionsQuery>;
export type AircraftInspectionsLazyQueryHookResult = ReturnType<typeof useAircraftInspectionsLazyQuery>;
export type AircraftInspectionsQueryResult = Apollo.QueryResult<AircraftInspectionsQuery, AircraftInspectionsQueryVariables>;
export const UpdateAllAircraftProjectDocumentsReleasedToDcaMutationDocument = gql`
    mutation updateAllAircraftProjectDocumentsReleasedToDcaMutation($input: UpdateAllAircraftProjectOperatorDocumentsReleasedToDcaInput!) {
  updateAllAircraftProjectDocumentsReleasedToDca(input: $input)
}
    `;
export type UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutation, UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllAircraftProjectDocumentsReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutation, UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutation, UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutationVariables>(UpdateAllAircraftProjectDocumentsReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutation>;
export type UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutation>;
export type UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutation, UpdateAllAircraftProjectDocumentsReleasedToDcaMutationMutationVariables>;
export const UpdateAllAircraftProjectInsFormsReleasedToDcaMutationDocument = gql`
    mutation updateAllAircraftProjectInsFormsReleasedToDcaMutation($input: UpdateAllProjectInsFormVersionsReleasedToDcaInput!) {
  updateAllAircraftProjectInsFormsReleasedToDca(input: $input)
}
    `;
export type UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutation, UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllAircraftProjectInsFormsReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutation, UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutation, UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutationVariables>(UpdateAllAircraftProjectInsFormsReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutation>;
export type UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutation>;
export type UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutation, UpdateAllAircraftProjectInsFormsReleasedToDcaMutationMutationVariables>;
export const AircraftProjectCertificatePreviewDocument = gql`
    query aircraftProjectCertificatePreview($aircraftProjectId: Int!, $certificateDocumentTypeId: Int!) {
  downloadAircraftCertificatePreview(aircraftProjectId: $aircraftProjectId, certificateDocumentTypeId: $certificateDocumentTypeId) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useAircraftProjectCertificatePreviewQuery__
 *
 * To run a query within a React component, call `useAircraftProjectCertificatePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectCertificatePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectCertificatePreviewQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      certificateDocumentTypeId: // value for 'certificateDocumentTypeId'
 *   },
 * });
 */
export function useAircraftProjectCertificatePreviewQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectCertificatePreviewQuery, AircraftProjectCertificatePreviewQueryVariables>) {
        return Apollo.useQuery<AircraftProjectCertificatePreviewQuery, AircraftProjectCertificatePreviewQueryVariables>(AircraftProjectCertificatePreviewDocument, baseOptions);
      }
export function useAircraftProjectCertificatePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectCertificatePreviewQuery, AircraftProjectCertificatePreviewQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectCertificatePreviewQuery, AircraftProjectCertificatePreviewQueryVariables>(AircraftProjectCertificatePreviewDocument, baseOptions);
        }
export type AircraftProjectCertificatePreviewQueryHookResult = ReturnType<typeof useAircraftProjectCertificatePreviewQuery>;
export type AircraftProjectCertificatePreviewLazyQueryHookResult = ReturnType<typeof useAircraftProjectCertificatePreviewLazyQuery>;
export type AircraftProjectCertificatePreviewQueryResult = Apollo.QueryResult<AircraftProjectCertificatePreviewQuery, AircraftProjectCertificatePreviewQueryVariables>;
export const AircraftProjectFormsTabDocument = gql`
    query aircraftProjectFormsTab($aircraftProjectId: Int!) {
  aircraftProject(id: $aircraftProjectId) {
    canToggleInsFormDcaApproved
  }
  aircraftProjectInsForms(aircraftProjectId: $aircraftProjectId) {
    ...projectInsFormVersion
  }
  aircraftProjectInsFormsExclusiveGroups(aircraftProjectId: $aircraftProjectId) {
    ...projectInsFormVersionExclusiveGroup
  }
}
    ${ProjectInsFormVersionFragmentDoc}
${ProjectInsFormVersionExclusiveGroupFragmentDoc}`;

/**
 * __useAircraftProjectFormsTabQuery__
 *
 * To run a query within a React component, call `useAircraftProjectFormsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectFormsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectFormsTabQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *   },
 * });
 */
export function useAircraftProjectFormsTabQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectFormsTabQuery, AircraftProjectFormsTabQueryVariables>) {
        return Apollo.useQuery<AircraftProjectFormsTabQuery, AircraftProjectFormsTabQueryVariables>(AircraftProjectFormsTabDocument, baseOptions);
      }
export function useAircraftProjectFormsTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectFormsTabQuery, AircraftProjectFormsTabQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectFormsTabQuery, AircraftProjectFormsTabQueryVariables>(AircraftProjectFormsTabDocument, baseOptions);
        }
export type AircraftProjectFormsTabQueryHookResult = ReturnType<typeof useAircraftProjectFormsTabQuery>;
export type AircraftProjectFormsTabLazyQueryHookResult = ReturnType<typeof useAircraftProjectFormsTabLazyQuery>;
export type AircraftProjectFormsTabQueryResult = Apollo.QueryResult<AircraftProjectFormsTabQuery, AircraftProjectFormsTabQueryVariables>;
export const AircraftProjectInsFormFieldValuesAndCommentsQueryDocument = gql`
    query aircraftProjectInsFormFieldValuesAndCommentsQuery($projectInsFormVersionId: Int!) {
  fieldValues: aircraftProjectInsFormFieldValues(projectInsFormVersionId: $projectInsFormVersionId) {
    ...projectInsFormVersionFieldValue
  }
  fieldComments: aircraftProjectInsFormFieldComments(projectInsFormVersionId: $projectInsFormVersionId) {
    ...projectInsFormVersionFieldComment
  }
}
    ${ProjectInsFormVersionFieldValueFragmentDoc}
${ProjectInsFormVersionFieldCommentFragmentDoc}`;

/**
 * __useAircraftProjectInsFormFieldValuesAndCommentsQueryQuery__
 *
 * To run a query within a React component, call `useAircraftProjectInsFormFieldValuesAndCommentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectInsFormFieldValuesAndCommentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectInsFormFieldValuesAndCommentsQueryQuery({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useAircraftProjectInsFormFieldValuesAndCommentsQueryQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectInsFormFieldValuesAndCommentsQueryQuery, AircraftProjectInsFormFieldValuesAndCommentsQueryQueryVariables>) {
        return Apollo.useQuery<AircraftProjectInsFormFieldValuesAndCommentsQueryQuery, AircraftProjectInsFormFieldValuesAndCommentsQueryQueryVariables>(AircraftProjectInsFormFieldValuesAndCommentsQueryDocument, baseOptions);
      }
export function useAircraftProjectInsFormFieldValuesAndCommentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectInsFormFieldValuesAndCommentsQueryQuery, AircraftProjectInsFormFieldValuesAndCommentsQueryQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectInsFormFieldValuesAndCommentsQueryQuery, AircraftProjectInsFormFieldValuesAndCommentsQueryQueryVariables>(AircraftProjectInsFormFieldValuesAndCommentsQueryDocument, baseOptions);
        }
export type AircraftProjectInsFormFieldValuesAndCommentsQueryQueryHookResult = ReturnType<typeof useAircraftProjectInsFormFieldValuesAndCommentsQueryQuery>;
export type AircraftProjectInsFormFieldValuesAndCommentsQueryLazyQueryHookResult = ReturnType<typeof useAircraftProjectInsFormFieldValuesAndCommentsQueryLazyQuery>;
export type AircraftProjectInsFormFieldValuesAndCommentsQueryQueryResult = Apollo.QueryResult<AircraftProjectInsFormFieldValuesAndCommentsQueryQuery, AircraftProjectInsFormFieldValuesAndCommentsQueryQueryVariables>;
export const AircraftProjectInsFormFieldValuesOnlyQueryDocument = gql`
    query aircraftProjectInsFormFieldValuesOnlyQuery($projectInsFormVersionId: Int!) {
  fieldValues: aircraftProjectInsFormFieldValues(projectInsFormVersionId: $projectInsFormVersionId) {
    ...projectInsFormVersionFieldValue
  }
}
    ${ProjectInsFormVersionFieldValueFragmentDoc}`;

/**
 * __useAircraftProjectInsFormFieldValuesOnlyQueryQuery__
 *
 * To run a query within a React component, call `useAircraftProjectInsFormFieldValuesOnlyQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectInsFormFieldValuesOnlyQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectInsFormFieldValuesOnlyQueryQuery({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useAircraftProjectInsFormFieldValuesOnlyQueryQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectInsFormFieldValuesOnlyQueryQuery, AircraftProjectInsFormFieldValuesOnlyQueryQueryVariables>) {
        return Apollo.useQuery<AircraftProjectInsFormFieldValuesOnlyQueryQuery, AircraftProjectInsFormFieldValuesOnlyQueryQueryVariables>(AircraftProjectInsFormFieldValuesOnlyQueryDocument, baseOptions);
      }
export function useAircraftProjectInsFormFieldValuesOnlyQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectInsFormFieldValuesOnlyQueryQuery, AircraftProjectInsFormFieldValuesOnlyQueryQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectInsFormFieldValuesOnlyQueryQuery, AircraftProjectInsFormFieldValuesOnlyQueryQueryVariables>(AircraftProjectInsFormFieldValuesOnlyQueryDocument, baseOptions);
        }
export type AircraftProjectInsFormFieldValuesOnlyQueryQueryHookResult = ReturnType<typeof useAircraftProjectInsFormFieldValuesOnlyQueryQuery>;
export type AircraftProjectInsFormFieldValuesOnlyQueryLazyQueryHookResult = ReturnType<typeof useAircraftProjectInsFormFieldValuesOnlyQueryLazyQuery>;
export type AircraftProjectInsFormFieldValuesOnlyQueryQueryResult = Apollo.QueryResult<AircraftProjectInsFormFieldValuesOnlyQueryQuery, AircraftProjectInsFormFieldValuesOnlyQueryQueryVariables>;
export const DownloadAircraftProjectUploadedInsFormDocument = gql`
    query downloadAircraftProjectUploadedInsForm($id: Int!) {
  file: downloadAircraftProjectUploadedInsForm(projectInsFormVersionId: $id) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadAircraftProjectUploadedInsFormQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectUploadedInsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectUploadedInsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectUploadedInsFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadAircraftProjectUploadedInsFormQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectUploadedInsFormQuery, DownloadAircraftProjectUploadedInsFormQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectUploadedInsFormQuery, DownloadAircraftProjectUploadedInsFormQueryVariables>(DownloadAircraftProjectUploadedInsFormDocument, baseOptions);
      }
export function useDownloadAircraftProjectUploadedInsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectUploadedInsFormQuery, DownloadAircraftProjectUploadedInsFormQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectUploadedInsFormQuery, DownloadAircraftProjectUploadedInsFormQueryVariables>(DownloadAircraftProjectUploadedInsFormDocument, baseOptions);
        }
export type DownloadAircraftProjectUploadedInsFormQueryHookResult = ReturnType<typeof useDownloadAircraftProjectUploadedInsFormQuery>;
export type DownloadAircraftProjectUploadedInsFormLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectUploadedInsFormLazyQuery>;
export type DownloadAircraftProjectUploadedInsFormQueryResult = Apollo.QueryResult<DownloadAircraftProjectUploadedInsFormQuery, DownloadAircraftProjectUploadedInsFormQueryVariables>;
export const DownloadAircraftProjectGeneratedInsFormDocumentDocument = gql`
    query downloadAircraftProjectGeneratedInsFormDocument($id: Int!) {
  file: downloadAircraftProjectGeneratedInsFormDocument(projectInsFormVersionId: $id) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadAircraftProjectGeneratedInsFormDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectGeneratedInsFormDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectGeneratedInsFormDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectGeneratedInsFormDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadAircraftProjectGeneratedInsFormDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectGeneratedInsFormDocumentQuery, DownloadAircraftProjectGeneratedInsFormDocumentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectGeneratedInsFormDocumentQuery, DownloadAircraftProjectGeneratedInsFormDocumentQueryVariables>(DownloadAircraftProjectGeneratedInsFormDocumentDocument, baseOptions);
      }
export function useDownloadAircraftProjectGeneratedInsFormDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectGeneratedInsFormDocumentQuery, DownloadAircraftProjectGeneratedInsFormDocumentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectGeneratedInsFormDocumentQuery, DownloadAircraftProjectGeneratedInsFormDocumentQueryVariables>(DownloadAircraftProjectGeneratedInsFormDocumentDocument, baseOptions);
        }
export type DownloadAircraftProjectGeneratedInsFormDocumentQueryHookResult = ReturnType<typeof useDownloadAircraftProjectGeneratedInsFormDocumentQuery>;
export type DownloadAircraftProjectGeneratedInsFormDocumentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectGeneratedInsFormDocumentLazyQuery>;
export type DownloadAircraftProjectGeneratedInsFormDocumentQueryResult = Apollo.QueryResult<DownloadAircraftProjectGeneratedInsFormDocumentQuery, DownloadAircraftProjectGeneratedInsFormDocumentQueryVariables>;
export const DownloadAircraftProjectFilledInInsFormDocument = gql`
    query downloadAircraftProjectFilledInInsForm($projectInsFormVersionId: Int!) {
  file: downloadAircraftProjectFilledInInsForm(projectInsFormVersionId: $projectInsFormVersionId) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadAircraftProjectFilledInInsFormQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectFilledInInsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectFilledInInsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectFilledInInsFormQuery({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useDownloadAircraftProjectFilledInInsFormQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectFilledInInsFormQuery, DownloadAircraftProjectFilledInInsFormQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectFilledInInsFormQuery, DownloadAircraftProjectFilledInInsFormQueryVariables>(DownloadAircraftProjectFilledInInsFormDocument, baseOptions);
      }
export function useDownloadAircraftProjectFilledInInsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectFilledInInsFormQuery, DownloadAircraftProjectFilledInInsFormQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectFilledInInsFormQuery, DownloadAircraftProjectFilledInInsFormQueryVariables>(DownloadAircraftProjectFilledInInsFormDocument, baseOptions);
        }
export type DownloadAircraftProjectFilledInInsFormQueryHookResult = ReturnType<typeof useDownloadAircraftProjectFilledInInsFormQuery>;
export type DownloadAircraftProjectFilledInInsFormLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectFilledInInsFormLazyQuery>;
export type DownloadAircraftProjectFilledInInsFormQueryResult = Apollo.QueryResult<DownloadAircraftProjectFilledInInsFormQuery, DownloadAircraftProjectFilledInInsFormQueryVariables>;
export const UpdateAircraftProjectInsFormTrgApprovalMutationDocument = gql`
    mutation updateAircraftProjectInsFormTrgApprovalMutation($input: UpdateProjectInsFormVersionTrgApprovalInput!) {
  updateAircraftProjectInsFormTrgApproval(input: $input) {
    ...projectInsFormVersion
  }
}
    ${ProjectInsFormVersionFragmentDoc}`;
export type UpdateAircraftProjectInsFormTrgApprovalMutationMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInsFormTrgApprovalMutationMutation, UpdateAircraftProjectInsFormTrgApprovalMutationMutationVariables>;

/**
 * __useUpdateAircraftProjectInsFormTrgApprovalMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInsFormTrgApprovalMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInsFormTrgApprovalMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInsFormTrgApprovalMutationMutation, { data, loading, error }] = useUpdateAircraftProjectInsFormTrgApprovalMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInsFormTrgApprovalMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInsFormTrgApprovalMutationMutation, UpdateAircraftProjectInsFormTrgApprovalMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInsFormTrgApprovalMutationMutation, UpdateAircraftProjectInsFormTrgApprovalMutationMutationVariables>(UpdateAircraftProjectInsFormTrgApprovalMutationDocument, baseOptions);
      }
export type UpdateAircraftProjectInsFormTrgApprovalMutationMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInsFormTrgApprovalMutationMutation>;
export type UpdateAircraftProjectInsFormTrgApprovalMutationMutationResult = Apollo.MutationResult<UpdateAircraftProjectInsFormTrgApprovalMutationMutation>;
export type UpdateAircraftProjectInsFormTrgApprovalMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInsFormTrgApprovalMutationMutation, UpdateAircraftProjectInsFormTrgApprovalMutationMutationVariables>;
export const UpdateAircraftProjectInsFormFileAttachmentMutationDocument = gql`
    mutation updateAircraftProjectInsFormFileAttachmentMutation($input: UpdateProjectInsFormVersionFileAttachmentInput!) {
  updateAircraftProjectInsFormFileAttachment(input: $input) {
    ...projectInsFormVersion
  }
}
    ${ProjectInsFormVersionFragmentDoc}`;
export type UpdateAircraftProjectInsFormFileAttachmentMutationMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInsFormFileAttachmentMutationMutation, UpdateAircraftProjectInsFormFileAttachmentMutationMutationVariables>;

/**
 * __useUpdateAircraftProjectInsFormFileAttachmentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInsFormFileAttachmentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInsFormFileAttachmentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInsFormFileAttachmentMutationMutation, { data, loading, error }] = useUpdateAircraftProjectInsFormFileAttachmentMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInsFormFileAttachmentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInsFormFileAttachmentMutationMutation, UpdateAircraftProjectInsFormFileAttachmentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInsFormFileAttachmentMutationMutation, UpdateAircraftProjectInsFormFileAttachmentMutationMutationVariables>(UpdateAircraftProjectInsFormFileAttachmentMutationDocument, baseOptions);
      }
export type UpdateAircraftProjectInsFormFileAttachmentMutationMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInsFormFileAttachmentMutationMutation>;
export type UpdateAircraftProjectInsFormFileAttachmentMutationMutationResult = Apollo.MutationResult<UpdateAircraftProjectInsFormFileAttachmentMutationMutation>;
export type UpdateAircraftProjectInsFormFileAttachmentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInsFormFileAttachmentMutationMutation, UpdateAircraftProjectInsFormFileAttachmentMutationMutationVariables>;
export const UpdateAircraftProjectInsFormReleasedToDcaMutationDocument = gql`
    mutation updateAircraftProjectInsFormReleasedToDcaMutation($input: UpdateProjectInsFormVersionReleasedToDcaInput!) {
  updateAircraftProjectInsFormReleasedToDca(input: $input) {
    ...projectInsFormVersion
  }
}
    ${ProjectInsFormVersionFragmentDoc}`;
export type UpdateAircraftProjectInsFormReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInsFormReleasedToDcaMutationMutation, UpdateAircraftProjectInsFormReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateAircraftProjectInsFormReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInsFormReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInsFormReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInsFormReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateAircraftProjectInsFormReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInsFormReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInsFormReleasedToDcaMutationMutation, UpdateAircraftProjectInsFormReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInsFormReleasedToDcaMutationMutation, UpdateAircraftProjectInsFormReleasedToDcaMutationMutationVariables>(UpdateAircraftProjectInsFormReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateAircraftProjectInsFormReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInsFormReleasedToDcaMutationMutation>;
export type UpdateAircraftProjectInsFormReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateAircraftProjectInsFormReleasedToDcaMutationMutation>;
export type UpdateAircraftProjectInsFormReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInsFormReleasedToDcaMutationMutation, UpdateAircraftProjectInsFormReleasedToDcaMutationMutationVariables>;
export const UpdateAircraftProjectInsFormFieldValuesDocument = gql`
    mutation updateAircraftProjectInsFormFieldValues($input: UpdateProjectInsFormVersionFieldValuesInput!) {
  updateAircraftProjectInsFormFieldValues(input: $input)
}
    `;
export type UpdateAircraftProjectInsFormFieldValuesMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInsFormFieldValuesMutation, UpdateAircraftProjectInsFormFieldValuesMutationVariables>;

/**
 * __useUpdateAircraftProjectInsFormFieldValuesMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInsFormFieldValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInsFormFieldValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInsFormFieldValuesMutation, { data, loading, error }] = useUpdateAircraftProjectInsFormFieldValuesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInsFormFieldValuesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInsFormFieldValuesMutation, UpdateAircraftProjectInsFormFieldValuesMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInsFormFieldValuesMutation, UpdateAircraftProjectInsFormFieldValuesMutationVariables>(UpdateAircraftProjectInsFormFieldValuesDocument, baseOptions);
      }
export type UpdateAircraftProjectInsFormFieldValuesMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInsFormFieldValuesMutation>;
export type UpdateAircraftProjectInsFormFieldValuesMutationResult = Apollo.MutationResult<UpdateAircraftProjectInsFormFieldValuesMutation>;
export type UpdateAircraftProjectInsFormFieldValuesMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInsFormFieldValuesMutation, UpdateAircraftProjectInsFormFieldValuesMutationVariables>;
export const UpdateAircraftProjectInsFormFieldCommentDocument = gql`
    mutation updateAircraftProjectInsFormFieldComment($input: UpdateProjectInsFormVersionFieldCommentInput!) {
  updateAircraftProjectInsFormFieldComment(input: $input)
}
    `;
export type UpdateAircraftProjectInsFormFieldCommentMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInsFormFieldCommentMutation, UpdateAircraftProjectInsFormFieldCommentMutationVariables>;

/**
 * __useUpdateAircraftProjectInsFormFieldCommentMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInsFormFieldCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInsFormFieldCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInsFormFieldCommentMutation, { data, loading, error }] = useUpdateAircraftProjectInsFormFieldCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInsFormFieldCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInsFormFieldCommentMutation, UpdateAircraftProjectInsFormFieldCommentMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInsFormFieldCommentMutation, UpdateAircraftProjectInsFormFieldCommentMutationVariables>(UpdateAircraftProjectInsFormFieldCommentDocument, baseOptions);
      }
export type UpdateAircraftProjectInsFormFieldCommentMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInsFormFieldCommentMutation>;
export type UpdateAircraftProjectInsFormFieldCommentMutationResult = Apollo.MutationResult<UpdateAircraftProjectInsFormFieldCommentMutation>;
export type UpdateAircraftProjectInsFormFieldCommentMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInsFormFieldCommentMutation, UpdateAircraftProjectInsFormFieldCommentMutationVariables>;
export const UpdateAircraftProjectInsFormIsDcaApprovedDocument = gql`
    mutation updateAircraftProjectInsFormIsDcaApproved($input: UpdateProjectInsFormIsDcaApprovedInput!) {
  updateAircraftProjectInsFormIsDcaApproved(input: $input)
}
    `;
export type UpdateAircraftProjectInsFormIsDcaApprovedMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInsFormIsDcaApprovedMutation, UpdateAircraftProjectInsFormIsDcaApprovedMutationVariables>;

/**
 * __useUpdateAircraftProjectInsFormIsDcaApprovedMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInsFormIsDcaApprovedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInsFormIsDcaApprovedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInsFormIsDcaApprovedMutation, { data, loading, error }] = useUpdateAircraftProjectInsFormIsDcaApprovedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAircraftProjectInsFormIsDcaApprovedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInsFormIsDcaApprovedMutation, UpdateAircraftProjectInsFormIsDcaApprovedMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInsFormIsDcaApprovedMutation, UpdateAircraftProjectInsFormIsDcaApprovedMutationVariables>(UpdateAircraftProjectInsFormIsDcaApprovedDocument, baseOptions);
      }
export type UpdateAircraftProjectInsFormIsDcaApprovedMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInsFormIsDcaApprovedMutation>;
export type UpdateAircraftProjectInsFormIsDcaApprovedMutationResult = Apollo.MutationResult<UpdateAircraftProjectInsFormIsDcaApprovedMutation>;
export type UpdateAircraftProjectInsFormIsDcaApprovedMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInsFormIsDcaApprovedMutation, UpdateAircraftProjectInsFormIsDcaApprovedMutationVariables>;
export const SignAircraftProjectInsFormVersionByIdDocument = gql`
    mutation signAircraftProjectInsFormVersionById($id: Int!, $input: SignProjectInsFormVersionInput!) {
  signAircraftProjectInsFormVersionById(id: $id, input: $input)
}
    `;
export type SignAircraftProjectInsFormVersionByIdMutationFn = Apollo.MutationFunction<SignAircraftProjectInsFormVersionByIdMutation, SignAircraftProjectInsFormVersionByIdMutationVariables>;

/**
 * __useSignAircraftProjectInsFormVersionByIdMutation__
 *
 * To run a mutation, you first call `useSignAircraftProjectInsFormVersionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignAircraftProjectInsFormVersionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signAircraftProjectInsFormVersionByIdMutation, { data, loading, error }] = useSignAircraftProjectInsFormVersionByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignAircraftProjectInsFormVersionByIdMutation(baseOptions?: Apollo.MutationHookOptions<SignAircraftProjectInsFormVersionByIdMutation, SignAircraftProjectInsFormVersionByIdMutationVariables>) {
        return Apollo.useMutation<SignAircraftProjectInsFormVersionByIdMutation, SignAircraftProjectInsFormVersionByIdMutationVariables>(SignAircraftProjectInsFormVersionByIdDocument, baseOptions);
      }
export type SignAircraftProjectInsFormVersionByIdMutationHookResult = ReturnType<typeof useSignAircraftProjectInsFormVersionByIdMutation>;
export type SignAircraftProjectInsFormVersionByIdMutationResult = Apollo.MutationResult<SignAircraftProjectInsFormVersionByIdMutation>;
export type SignAircraftProjectInsFormVersionByIdMutationOptions = Apollo.BaseMutationOptions<SignAircraftProjectInsFormVersionByIdMutation, SignAircraftProjectInsFormVersionByIdMutationVariables>;
export const SignAircraftProjectInsFormVersionByIdWithSignatureImageDocument = gql`
    mutation signAircraftProjectInsFormVersionByIdWithSignatureImage($id: Int!, $input: SignProjectInsFormVersionInputWithSignatureImageInput!) {
  signAircraftProjectInsFormVersionByIdWithSignatureImage(id: $id, input: $input) {
    warnings
  }
}
    `;
export type SignAircraftProjectInsFormVersionByIdWithSignatureImageMutationFn = Apollo.MutationFunction<SignAircraftProjectInsFormVersionByIdWithSignatureImageMutation, SignAircraftProjectInsFormVersionByIdWithSignatureImageMutationVariables>;

/**
 * __useSignAircraftProjectInsFormVersionByIdWithSignatureImageMutation__
 *
 * To run a mutation, you first call `useSignAircraftProjectInsFormVersionByIdWithSignatureImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignAircraftProjectInsFormVersionByIdWithSignatureImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signAircraftProjectInsFormVersionByIdWithSignatureImageMutation, { data, loading, error }] = useSignAircraftProjectInsFormVersionByIdWithSignatureImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignAircraftProjectInsFormVersionByIdWithSignatureImageMutation(baseOptions?: Apollo.MutationHookOptions<SignAircraftProjectInsFormVersionByIdWithSignatureImageMutation, SignAircraftProjectInsFormVersionByIdWithSignatureImageMutationVariables>) {
        return Apollo.useMutation<SignAircraftProjectInsFormVersionByIdWithSignatureImageMutation, SignAircraftProjectInsFormVersionByIdWithSignatureImageMutationVariables>(SignAircraftProjectInsFormVersionByIdWithSignatureImageDocument, baseOptions);
      }
export type SignAircraftProjectInsFormVersionByIdWithSignatureImageMutationHookResult = ReturnType<typeof useSignAircraftProjectInsFormVersionByIdWithSignatureImageMutation>;
export type SignAircraftProjectInsFormVersionByIdWithSignatureImageMutationResult = Apollo.MutationResult<SignAircraftProjectInsFormVersionByIdWithSignatureImageMutation>;
export type SignAircraftProjectInsFormVersionByIdWithSignatureImageMutationOptions = Apollo.BaseMutationOptions<SignAircraftProjectInsFormVersionByIdWithSignatureImageMutation, SignAircraftProjectInsFormVersionByIdWithSignatureImageMutationVariables>;
export const ClearAircraftProjectInsFormVersionSignatureByIdDocument = gql`
    mutation clearAircraftProjectInsFormVersionSignatureById($id: Int!, $fieldNumber: Int!) {
  clearAircraftProjectInsFormVersionSignatureById(id: $id, fieldNumber: $fieldNumber)
}
    `;
export type ClearAircraftProjectInsFormVersionSignatureByIdMutationFn = Apollo.MutationFunction<ClearAircraftProjectInsFormVersionSignatureByIdMutation, ClearAircraftProjectInsFormVersionSignatureByIdMutationVariables>;

/**
 * __useClearAircraftProjectInsFormVersionSignatureByIdMutation__
 *
 * To run a mutation, you first call `useClearAircraftProjectInsFormVersionSignatureByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAircraftProjectInsFormVersionSignatureByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAircraftProjectInsFormVersionSignatureByIdMutation, { data, loading, error }] = useClearAircraftProjectInsFormVersionSignatureByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fieldNumber: // value for 'fieldNumber'
 *   },
 * });
 */
export function useClearAircraftProjectInsFormVersionSignatureByIdMutation(baseOptions?: Apollo.MutationHookOptions<ClearAircraftProjectInsFormVersionSignatureByIdMutation, ClearAircraftProjectInsFormVersionSignatureByIdMutationVariables>) {
        return Apollo.useMutation<ClearAircraftProjectInsFormVersionSignatureByIdMutation, ClearAircraftProjectInsFormVersionSignatureByIdMutationVariables>(ClearAircraftProjectInsFormVersionSignatureByIdDocument, baseOptions);
      }
export type ClearAircraftProjectInsFormVersionSignatureByIdMutationHookResult = ReturnType<typeof useClearAircraftProjectInsFormVersionSignatureByIdMutation>;
export type ClearAircraftProjectInsFormVersionSignatureByIdMutationResult = Apollo.MutationResult<ClearAircraftProjectInsFormVersionSignatureByIdMutation>;
export type ClearAircraftProjectInsFormVersionSignatureByIdMutationOptions = Apollo.BaseMutationOptions<ClearAircraftProjectInsFormVersionSignatureByIdMutation, ClearAircraftProjectInsFormVersionSignatureByIdMutationVariables>;
export const AddAircraftProjectInsFormVersionCommentDocument = gql`
    mutation addAircraftProjectInsFormVersionComment($id: Int!, $input: CommentInput!) {
  addAircraftProjectInsFormVersionComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddAircraftProjectInsFormVersionCommentMutationFn = Apollo.MutationFunction<AddAircraftProjectInsFormVersionCommentMutation, AddAircraftProjectInsFormVersionCommentMutationVariables>;

/**
 * __useAddAircraftProjectInsFormVersionCommentMutation__
 *
 * To run a mutation, you first call `useAddAircraftProjectInsFormVersionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAircraftProjectInsFormVersionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAircraftProjectInsFormVersionCommentMutation, { data, loading, error }] = useAddAircraftProjectInsFormVersionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAircraftProjectInsFormVersionCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddAircraftProjectInsFormVersionCommentMutation, AddAircraftProjectInsFormVersionCommentMutationVariables>) {
        return Apollo.useMutation<AddAircraftProjectInsFormVersionCommentMutation, AddAircraftProjectInsFormVersionCommentMutationVariables>(AddAircraftProjectInsFormVersionCommentDocument, baseOptions);
      }
export type AddAircraftProjectInsFormVersionCommentMutationHookResult = ReturnType<typeof useAddAircraftProjectInsFormVersionCommentMutation>;
export type AddAircraftProjectInsFormVersionCommentMutationResult = Apollo.MutationResult<AddAircraftProjectInsFormVersionCommentMutation>;
export type AddAircraftProjectInsFormVersionCommentMutationOptions = Apollo.BaseMutationOptions<AddAircraftProjectInsFormVersionCommentMutation, AddAircraftProjectInsFormVersionCommentMutationVariables>;
export const UpdateAircraftProjectInsFormVersionCommentDocument = gql`
    mutation updateAircraftProjectInsFormVersionComment($id: Int!, $body: String!) {
  updateAircraftProjectInsFormVersionComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateAircraftProjectInsFormVersionCommentMutationFn = Apollo.MutationFunction<UpdateAircraftProjectInsFormVersionCommentMutation, UpdateAircraftProjectInsFormVersionCommentMutationVariables>;

/**
 * __useUpdateAircraftProjectInsFormVersionCommentMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectInsFormVersionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectInsFormVersionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectInsFormVersionCommentMutation, { data, loading, error }] = useUpdateAircraftProjectInsFormVersionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateAircraftProjectInsFormVersionCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectInsFormVersionCommentMutation, UpdateAircraftProjectInsFormVersionCommentMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectInsFormVersionCommentMutation, UpdateAircraftProjectInsFormVersionCommentMutationVariables>(UpdateAircraftProjectInsFormVersionCommentDocument, baseOptions);
      }
export type UpdateAircraftProjectInsFormVersionCommentMutationHookResult = ReturnType<typeof useUpdateAircraftProjectInsFormVersionCommentMutation>;
export type UpdateAircraftProjectInsFormVersionCommentMutationResult = Apollo.MutationResult<UpdateAircraftProjectInsFormVersionCommentMutation>;
export type UpdateAircraftProjectInsFormVersionCommentMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectInsFormVersionCommentMutation, UpdateAircraftProjectInsFormVersionCommentMutationVariables>;
export const AircraftProjectEmailHistoryDocument = gql`
    query aircraftProjectEmailHistory($aircraftProjectId: Int!, $sortBy: EmailHistorySortBy, $sortDirection: SortDirection) {
  aircraftProjectEmailHistory(aircraftProjectId: $aircraftProjectId, sortBy: $sortBy, sortDirection: $sortDirection) {
    ...emailHistory
  }
}
    ${EmailHistoryFragmentDoc}`;

/**
 * __useAircraftProjectEmailHistoryQuery__
 *
 * To run a query within a React component, call `useAircraftProjectEmailHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectEmailHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectEmailHistoryQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useAircraftProjectEmailHistoryQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectEmailHistoryQuery, AircraftProjectEmailHistoryQueryVariables>) {
        return Apollo.useQuery<AircraftProjectEmailHistoryQuery, AircraftProjectEmailHistoryQueryVariables>(AircraftProjectEmailHistoryDocument, baseOptions);
      }
export function useAircraftProjectEmailHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectEmailHistoryQuery, AircraftProjectEmailHistoryQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectEmailHistoryQuery, AircraftProjectEmailHistoryQueryVariables>(AircraftProjectEmailHistoryDocument, baseOptions);
        }
export type AircraftProjectEmailHistoryQueryHookResult = ReturnType<typeof useAircraftProjectEmailHistoryQuery>;
export type AircraftProjectEmailHistoryLazyQueryHookResult = ReturnType<typeof useAircraftProjectEmailHistoryLazyQuery>;
export type AircraftProjectEmailHistoryQueryResult = Apollo.QueryResult<AircraftProjectEmailHistoryQuery, AircraftProjectEmailHistoryQueryVariables>;
export const AircraftProjectHistoryDocument = gql`
    query aircraftProjectHistory($aircraftProjectId: Int!) {
  aircraftProjectHistory(aircraftProjectId: $aircraftProjectId) {
    ...projectHistory
  }
}
    ${ProjectHistoryFragmentDoc}`;

/**
 * __useAircraftProjectHistoryQuery__
 *
 * To run a query within a React component, call `useAircraftProjectHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectHistoryQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *   },
 * });
 */
export function useAircraftProjectHistoryQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectHistoryQuery, AircraftProjectHistoryQueryVariables>) {
        return Apollo.useQuery<AircraftProjectHistoryQuery, AircraftProjectHistoryQueryVariables>(AircraftProjectHistoryDocument, baseOptions);
      }
export function useAircraftProjectHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectHistoryQuery, AircraftProjectHistoryQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectHistoryQuery, AircraftProjectHistoryQueryVariables>(AircraftProjectHistoryDocument, baseOptions);
        }
export type AircraftProjectHistoryQueryHookResult = ReturnType<typeof useAircraftProjectHistoryQuery>;
export type AircraftProjectHistoryLazyQueryHookResult = ReturnType<typeof useAircraftProjectHistoryLazyQuery>;
export type AircraftProjectHistoryQueryResult = Apollo.QueryResult<AircraftProjectHistoryQuery, AircraftProjectHistoryQueryVariables>;
export const SendAircraftProjectEmailDocument = gql`
    mutation sendAircraftProjectEmail($aircraftProjectId: Int!, $email: EmailInput!) {
  sendAircraftProjectEmail(aircraftProjectId: $aircraftProjectId, email: $email) {
    id
  }
}
    `;
export type SendAircraftProjectEmailMutationFn = Apollo.MutationFunction<SendAircraftProjectEmailMutation, SendAircraftProjectEmailMutationVariables>;

/**
 * __useSendAircraftProjectEmailMutation__
 *
 * To run a mutation, you first call `useSendAircraftProjectEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAircraftProjectEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAircraftProjectEmailMutation, { data, loading, error }] = useSendAircraftProjectEmailMutation({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendAircraftProjectEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendAircraftProjectEmailMutation, SendAircraftProjectEmailMutationVariables>) {
        return Apollo.useMutation<SendAircraftProjectEmailMutation, SendAircraftProjectEmailMutationVariables>(SendAircraftProjectEmailDocument, baseOptions);
      }
export type SendAircraftProjectEmailMutationHookResult = ReturnType<typeof useSendAircraftProjectEmailMutation>;
export type SendAircraftProjectEmailMutationResult = Apollo.MutationResult<SendAircraftProjectEmailMutation>;
export type SendAircraftProjectEmailMutationOptions = Apollo.BaseMutationOptions<SendAircraftProjectEmailMutation, SendAircraftProjectEmailMutationVariables>;
export const UpdateAircraftProjectCommentsLastViewedDateDocument = gql`
    mutation updateAircraftProjectCommentsLastViewedDate($id: Int!) {
  updateAircraftProjectCommentsLastViewedDate(aircraftProjectId: $id) {
    id
  }
}
    `;
export type UpdateAircraftProjectCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateAircraftProjectCommentsLastViewedDateMutation, UpdateAircraftProjectCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateAircraftProjectCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateAircraftProjectCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAircraftProjectCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectCommentsLastViewedDateMutation, UpdateAircraftProjectCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectCommentsLastViewedDateMutation, UpdateAircraftProjectCommentsLastViewedDateMutationVariables>(UpdateAircraftProjectCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateAircraftProjectCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateAircraftProjectCommentsLastViewedDateMutation>;
export type UpdateAircraftProjectCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateAircraftProjectCommentsLastViewedDateMutation>;
export type UpdateAircraftProjectCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectCommentsLastViewedDateMutation, UpdateAircraftProjectCommentsLastViewedDateMutationVariables>;
export const UpdateAircraftProjectDcaCommentsLastViewedDateDocument = gql`
    mutation updateAircraftProjectDcaCommentsLastViewedDate($id: Int!) {
  updateAircraftProjectDcaCommentsLastViewedDate(aircraftProjectId: $id) {
    id
  }
}
    `;
export type UpdateAircraftProjectDcaCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateAircraftProjectDcaCommentsLastViewedDateMutation, UpdateAircraftProjectDcaCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateAircraftProjectDcaCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateAircraftProjectDcaCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAircraftProjectDcaCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAircraftProjectDcaCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateAircraftProjectDcaCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAircraftProjectDcaCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAircraftProjectDcaCommentsLastViewedDateMutation, UpdateAircraftProjectDcaCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateAircraftProjectDcaCommentsLastViewedDateMutation, UpdateAircraftProjectDcaCommentsLastViewedDateMutationVariables>(UpdateAircraftProjectDcaCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateAircraftProjectDcaCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateAircraftProjectDcaCommentsLastViewedDateMutation>;
export type UpdateAircraftProjectDcaCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateAircraftProjectDcaCommentsLastViewedDateMutation>;
export type UpdateAircraftProjectDcaCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateAircraftProjectDcaCommentsLastViewedDateMutation, UpdateAircraftProjectDcaCommentsLastViewedDateMutationVariables>;
export const AircraftProjectAssignableUsersDocument = gql`
    query aircraftProjectAssignableUsers {
  aircraftProjectAssignableUsers {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useAircraftProjectAssignableUsersQuery__
 *
 * To run a query within a React component, call `useAircraftProjectAssignableUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectAssignableUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectAssignableUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAircraftProjectAssignableUsersQuery(baseOptions?: Apollo.QueryHookOptions<AircraftProjectAssignableUsersQuery, AircraftProjectAssignableUsersQueryVariables>) {
        return Apollo.useQuery<AircraftProjectAssignableUsersQuery, AircraftProjectAssignableUsersQueryVariables>(AircraftProjectAssignableUsersDocument, baseOptions);
      }
export function useAircraftProjectAssignableUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectAssignableUsersQuery, AircraftProjectAssignableUsersQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectAssignableUsersQuery, AircraftProjectAssignableUsersQueryVariables>(AircraftProjectAssignableUsersDocument, baseOptions);
        }
export type AircraftProjectAssignableUsersQueryHookResult = ReturnType<typeof useAircraftProjectAssignableUsersQuery>;
export type AircraftProjectAssignableUsersLazyQueryHookResult = ReturnType<typeof useAircraftProjectAssignableUsersLazyQuery>;
export type AircraftProjectAssignableUsersQueryResult = Apollo.QueryResult<AircraftProjectAssignableUsersQuery, AircraftProjectAssignableUsersQueryVariables>;
export const AircraftProjectEmailViewDocument = gql`
    query aircraftProjectEmailView($id: Int!, $emailId: Int!, $includeFileAttachments: Boolean = false, $includeFileContent: Boolean = false) {
  aircraftProject(id: $id) {
    emails(filter: {id_in: [$emailId]}) {
      ...email
    }
  }
}
    ${EmailFragmentDoc}`;

/**
 * __useAircraftProjectEmailViewQuery__
 *
 * To run a query within a React component, call `useAircraftProjectEmailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftProjectEmailViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftProjectEmailViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      emailId: // value for 'emailId'
 *      includeFileAttachments: // value for 'includeFileAttachments'
 *      includeFileContent: // value for 'includeFileContent'
 *   },
 * });
 */
export function useAircraftProjectEmailViewQuery(baseOptions: Apollo.QueryHookOptions<AircraftProjectEmailViewQuery, AircraftProjectEmailViewQueryVariables>) {
        return Apollo.useQuery<AircraftProjectEmailViewQuery, AircraftProjectEmailViewQueryVariables>(AircraftProjectEmailViewDocument, baseOptions);
      }
export function useAircraftProjectEmailViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftProjectEmailViewQuery, AircraftProjectEmailViewQueryVariables>) {
          return Apollo.useLazyQuery<AircraftProjectEmailViewQuery, AircraftProjectEmailViewQueryVariables>(AircraftProjectEmailViewDocument, baseOptions);
        }
export type AircraftProjectEmailViewQueryHookResult = ReturnType<typeof useAircraftProjectEmailViewQuery>;
export type AircraftProjectEmailViewLazyQueryHookResult = ReturnType<typeof useAircraftProjectEmailViewLazyQuery>;
export type AircraftProjectEmailViewQueryResult = Apollo.QueryResult<AircraftProjectEmailViewQuery, AircraftProjectEmailViewQueryVariables>;
export const DownloadAircraftProjectEmailAttachmentContentDocument = gql`
    query downloadAircraftProjectEmailAttachmentContent($aircraftProjectId: Int!, $emailId: Int!, $attachmentId: Int!) {
  downloadAircraftProjectEmailAttachmentContent(aircraftProjectId: $aircraftProjectId, emailId: $emailId, attachmentId: $attachmentId)
}
    `;

/**
 * __useDownloadAircraftProjectEmailAttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadAircraftProjectEmailAttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAircraftProjectEmailAttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAircraftProjectEmailAttachmentContentQuery({
 *   variables: {
 *      aircraftProjectId: // value for 'aircraftProjectId'
 *      emailId: // value for 'emailId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDownloadAircraftProjectEmailAttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAircraftProjectEmailAttachmentContentQuery, DownloadAircraftProjectEmailAttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadAircraftProjectEmailAttachmentContentQuery, DownloadAircraftProjectEmailAttachmentContentQueryVariables>(DownloadAircraftProjectEmailAttachmentContentDocument, baseOptions);
      }
export function useDownloadAircraftProjectEmailAttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAircraftProjectEmailAttachmentContentQuery, DownloadAircraftProjectEmailAttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAircraftProjectEmailAttachmentContentQuery, DownloadAircraftProjectEmailAttachmentContentQueryVariables>(DownloadAircraftProjectEmailAttachmentContentDocument, baseOptions);
        }
export type DownloadAircraftProjectEmailAttachmentContentQueryHookResult = ReturnType<typeof useDownloadAircraftProjectEmailAttachmentContentQuery>;
export type DownloadAircraftProjectEmailAttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadAircraftProjectEmailAttachmentContentLazyQuery>;
export type DownloadAircraftProjectEmailAttachmentContentQueryResult = Apollo.QueryResult<DownloadAircraftProjectEmailAttachmentContentQuery, DownloadAircraftProjectEmailAttachmentContentQueryVariables>;
export const AmoProjectAuditCommentsDocument = gql`
    query amoProjectAuditComments($id: Int!) {
  amoProjectAuditComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useAmoProjectAuditCommentsQuery__
 *
 * To run a query within a React component, call `useAmoProjectAuditCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectAuditCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectAuditCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAmoProjectAuditCommentsQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectAuditCommentsQuery, AmoProjectAuditCommentsQueryVariables>) {
        return Apollo.useQuery<AmoProjectAuditCommentsQuery, AmoProjectAuditCommentsQueryVariables>(AmoProjectAuditCommentsDocument, baseOptions);
      }
export function useAmoProjectAuditCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectAuditCommentsQuery, AmoProjectAuditCommentsQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectAuditCommentsQuery, AmoProjectAuditCommentsQueryVariables>(AmoProjectAuditCommentsDocument, baseOptions);
        }
export type AmoProjectAuditCommentsQueryHookResult = ReturnType<typeof useAmoProjectAuditCommentsQuery>;
export type AmoProjectAuditCommentsLazyQueryHookResult = ReturnType<typeof useAmoProjectAuditCommentsLazyQuery>;
export type AmoProjectAuditCommentsQueryResult = Apollo.QueryResult<AmoProjectAuditCommentsQuery, AmoProjectAuditCommentsQueryVariables>;
export const AddAmoProjectAuditCommentDocument = gql`
    mutation addAmoProjectAuditComment($id: Int!, $input: CommentInput!) {
  addAmoProjectAuditComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddAmoProjectAuditCommentMutationFn = Apollo.MutationFunction<AddAmoProjectAuditCommentMutation, AddAmoProjectAuditCommentMutationVariables>;

/**
 * __useAddAmoProjectAuditCommentMutation__
 *
 * To run a mutation, you first call `useAddAmoProjectAuditCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAmoProjectAuditCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAmoProjectAuditCommentMutation, { data, loading, error }] = useAddAmoProjectAuditCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAmoProjectAuditCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddAmoProjectAuditCommentMutation, AddAmoProjectAuditCommentMutationVariables>) {
        return Apollo.useMutation<AddAmoProjectAuditCommentMutation, AddAmoProjectAuditCommentMutationVariables>(AddAmoProjectAuditCommentDocument, baseOptions);
      }
export type AddAmoProjectAuditCommentMutationHookResult = ReturnType<typeof useAddAmoProjectAuditCommentMutation>;
export type AddAmoProjectAuditCommentMutationResult = Apollo.MutationResult<AddAmoProjectAuditCommentMutation>;
export type AddAmoProjectAuditCommentMutationOptions = Apollo.BaseMutationOptions<AddAmoProjectAuditCommentMutation, AddAmoProjectAuditCommentMutationVariables>;
export const UpdateAmoProjectAuditCommentDocument = gql`
    mutation updateAmoProjectAuditComment($id: Int!, $body: String!) {
  updateAmoProjectAuditComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateAmoProjectAuditCommentMutationFn = Apollo.MutationFunction<UpdateAmoProjectAuditCommentMutation, UpdateAmoProjectAuditCommentMutationVariables>;

/**
 * __useUpdateAmoProjectAuditCommentMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectAuditCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectAuditCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectAuditCommentMutation, { data, loading, error }] = useUpdateAmoProjectAuditCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateAmoProjectAuditCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectAuditCommentMutation, UpdateAmoProjectAuditCommentMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectAuditCommentMutation, UpdateAmoProjectAuditCommentMutationVariables>(UpdateAmoProjectAuditCommentDocument, baseOptions);
      }
export type UpdateAmoProjectAuditCommentMutationHookResult = ReturnType<typeof useUpdateAmoProjectAuditCommentMutation>;
export type UpdateAmoProjectAuditCommentMutationResult = Apollo.MutationResult<UpdateAmoProjectAuditCommentMutation>;
export type UpdateAmoProjectAuditCommentMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectAuditCommentMutation, UpdateAmoProjectAuditCommentMutationVariables>;
export const UpdateAmoProjectAuditCommentsLastViewedDateDocument = gql`
    mutation updateAmoProjectAuditCommentsLastViewedDate($id: Int!) {
  updateAmoProjectAuditCommentsLastViewedDate(amoProjectAuditMapId: $id) {
    id
  }
}
    `;
export type UpdateAmoProjectAuditCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateAmoProjectAuditCommentsLastViewedDateMutation, UpdateAmoProjectAuditCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateAmoProjectAuditCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectAuditCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectAuditCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectAuditCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateAmoProjectAuditCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAmoProjectAuditCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectAuditCommentsLastViewedDateMutation, UpdateAmoProjectAuditCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectAuditCommentsLastViewedDateMutation, UpdateAmoProjectAuditCommentsLastViewedDateMutationVariables>(UpdateAmoProjectAuditCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateAmoProjectAuditCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateAmoProjectAuditCommentsLastViewedDateMutation>;
export type UpdateAmoProjectAuditCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateAmoProjectAuditCommentsLastViewedDateMutation>;
export type UpdateAmoProjectAuditCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectAuditCommentsLastViewedDateMutation, UpdateAmoProjectAuditCommentsLastViewedDateMutationVariables>;
export const AmoProjectCommentsDocument = gql`
    query amoProjectComments($id: Int!) {
  amoProjectComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useAmoProjectCommentsQuery__
 *
 * To run a query within a React component, call `useAmoProjectCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAmoProjectCommentsQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectCommentsQuery, AmoProjectCommentsQueryVariables>) {
        return Apollo.useQuery<AmoProjectCommentsQuery, AmoProjectCommentsQueryVariables>(AmoProjectCommentsDocument, baseOptions);
      }
export function useAmoProjectCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectCommentsQuery, AmoProjectCommentsQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectCommentsQuery, AmoProjectCommentsQueryVariables>(AmoProjectCommentsDocument, baseOptions);
        }
export type AmoProjectCommentsQueryHookResult = ReturnType<typeof useAmoProjectCommentsQuery>;
export type AmoProjectCommentsLazyQueryHookResult = ReturnType<typeof useAmoProjectCommentsLazyQuery>;
export type AmoProjectCommentsQueryResult = Apollo.QueryResult<AmoProjectCommentsQuery, AmoProjectCommentsQueryVariables>;
export const AddAmoProjectCommentDocument = gql`
    mutation addAmoProjectComment($id: Int!, $input: CommentInput!) {
  addAmoProjectComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddAmoProjectCommentMutationFn = Apollo.MutationFunction<AddAmoProjectCommentMutation, AddAmoProjectCommentMutationVariables>;

/**
 * __useAddAmoProjectCommentMutation__
 *
 * To run a mutation, you first call `useAddAmoProjectCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAmoProjectCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAmoProjectCommentMutation, { data, loading, error }] = useAddAmoProjectCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAmoProjectCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddAmoProjectCommentMutation, AddAmoProjectCommentMutationVariables>) {
        return Apollo.useMutation<AddAmoProjectCommentMutation, AddAmoProjectCommentMutationVariables>(AddAmoProjectCommentDocument, baseOptions);
      }
export type AddAmoProjectCommentMutationHookResult = ReturnType<typeof useAddAmoProjectCommentMutation>;
export type AddAmoProjectCommentMutationResult = Apollo.MutationResult<AddAmoProjectCommentMutation>;
export type AddAmoProjectCommentMutationOptions = Apollo.BaseMutationOptions<AddAmoProjectCommentMutation, AddAmoProjectCommentMutationVariables>;
export const UpdateAmoProjectCommentDocument = gql`
    mutation updateAmoProjectComment($id: Int!, $body: String!) {
  updateAmoProjectComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateAmoProjectCommentMutationFn = Apollo.MutationFunction<UpdateAmoProjectCommentMutation, UpdateAmoProjectCommentMutationVariables>;

/**
 * __useUpdateAmoProjectCommentMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectCommentMutation, { data, loading, error }] = useUpdateAmoProjectCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateAmoProjectCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectCommentMutation, UpdateAmoProjectCommentMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectCommentMutation, UpdateAmoProjectCommentMutationVariables>(UpdateAmoProjectCommentDocument, baseOptions);
      }
export type UpdateAmoProjectCommentMutationHookResult = ReturnType<typeof useUpdateAmoProjectCommentMutation>;
export type UpdateAmoProjectCommentMutationResult = Apollo.MutationResult<UpdateAmoProjectCommentMutation>;
export type UpdateAmoProjectCommentMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectCommentMutation, UpdateAmoProjectCommentMutationVariables>;
export const UpdateAmoProjectCommentsLastViewedDateDocument = gql`
    mutation updateAmoProjectCommentsLastViewedDate($id: Int!) {
  updateAmoProjectCommentsLastViewedDate(amoProjectId: $id) {
    id
  }
}
    `;
export type UpdateAmoProjectCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateAmoProjectCommentsLastViewedDateMutation, UpdateAmoProjectCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateAmoProjectCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateAmoProjectCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAmoProjectCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectCommentsLastViewedDateMutation, UpdateAmoProjectCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectCommentsLastViewedDateMutation, UpdateAmoProjectCommentsLastViewedDateMutationVariables>(UpdateAmoProjectCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateAmoProjectCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateAmoProjectCommentsLastViewedDateMutation>;
export type UpdateAmoProjectCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateAmoProjectCommentsLastViewedDateMutation>;
export type UpdateAmoProjectCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectCommentsLastViewedDateMutation, UpdateAmoProjectCommentsLastViewedDateMutationVariables>;
export const AmoProjectDcaCommentsDocument = gql`
    query amoProjectDcaComments($id: Int!) {
  amoProjectDcaComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useAmoProjectDcaCommentsQuery__
 *
 * To run a query within a React component, call `useAmoProjectDcaCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectDcaCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectDcaCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAmoProjectDcaCommentsQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectDcaCommentsQuery, AmoProjectDcaCommentsQueryVariables>) {
        return Apollo.useQuery<AmoProjectDcaCommentsQuery, AmoProjectDcaCommentsQueryVariables>(AmoProjectDcaCommentsDocument, baseOptions);
      }
export function useAmoProjectDcaCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectDcaCommentsQuery, AmoProjectDcaCommentsQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectDcaCommentsQuery, AmoProjectDcaCommentsQueryVariables>(AmoProjectDcaCommentsDocument, baseOptions);
        }
export type AmoProjectDcaCommentsQueryHookResult = ReturnType<typeof useAmoProjectDcaCommentsQuery>;
export type AmoProjectDcaCommentsLazyQueryHookResult = ReturnType<typeof useAmoProjectDcaCommentsLazyQuery>;
export type AmoProjectDcaCommentsQueryResult = Apollo.QueryResult<AmoProjectDcaCommentsQuery, AmoProjectDcaCommentsQueryVariables>;
export const AddAmoProjectDcaCommentDocument = gql`
    mutation addAmoProjectDcaComment($id: Int!, $input: CommentInput!) {
  addAmoProjectDcaComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddAmoProjectDcaCommentMutationFn = Apollo.MutationFunction<AddAmoProjectDcaCommentMutation, AddAmoProjectDcaCommentMutationVariables>;

/**
 * __useAddAmoProjectDcaCommentMutation__
 *
 * To run a mutation, you first call `useAddAmoProjectDcaCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAmoProjectDcaCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAmoProjectDcaCommentMutation, { data, loading, error }] = useAddAmoProjectDcaCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAmoProjectDcaCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddAmoProjectDcaCommentMutation, AddAmoProjectDcaCommentMutationVariables>) {
        return Apollo.useMutation<AddAmoProjectDcaCommentMutation, AddAmoProjectDcaCommentMutationVariables>(AddAmoProjectDcaCommentDocument, baseOptions);
      }
export type AddAmoProjectDcaCommentMutationHookResult = ReturnType<typeof useAddAmoProjectDcaCommentMutation>;
export type AddAmoProjectDcaCommentMutationResult = Apollo.MutationResult<AddAmoProjectDcaCommentMutation>;
export type AddAmoProjectDcaCommentMutationOptions = Apollo.BaseMutationOptions<AddAmoProjectDcaCommentMutation, AddAmoProjectDcaCommentMutationVariables>;
export const UpdateAmoProjectDcaCommentDocument = gql`
    mutation updateAmoProjectDcaComment($id: Int!, $body: String!) {
  updateAmoProjectDcaComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateAmoProjectDcaCommentMutationFn = Apollo.MutationFunction<UpdateAmoProjectDcaCommentMutation, UpdateAmoProjectDcaCommentMutationVariables>;

/**
 * __useUpdateAmoProjectDcaCommentMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectDcaCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectDcaCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectDcaCommentMutation, { data, loading, error }] = useUpdateAmoProjectDcaCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateAmoProjectDcaCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectDcaCommentMutation, UpdateAmoProjectDcaCommentMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectDcaCommentMutation, UpdateAmoProjectDcaCommentMutationVariables>(UpdateAmoProjectDcaCommentDocument, baseOptions);
      }
export type UpdateAmoProjectDcaCommentMutationHookResult = ReturnType<typeof useUpdateAmoProjectDcaCommentMutation>;
export type UpdateAmoProjectDcaCommentMutationResult = Apollo.MutationResult<UpdateAmoProjectDcaCommentMutation>;
export type UpdateAmoProjectDcaCommentMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectDcaCommentMutation, UpdateAmoProjectDcaCommentMutationVariables>;
export const UpdateAmoProjectDcaCommentsLastViewedDateDocument = gql`
    mutation updateAmoProjectDcaCommentsLastViewedDate($id: Int!) {
  updateAmoProjectDcaCommentsLastViewedDate(amoProjectId: $id) {
    id
  }
}
    `;
export type UpdateAmoProjectDcaCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateAmoProjectDcaCommentsLastViewedDateMutation, UpdateAmoProjectDcaCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateAmoProjectDcaCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectDcaCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectDcaCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectDcaCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateAmoProjectDcaCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAmoProjectDcaCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectDcaCommentsLastViewedDateMutation, UpdateAmoProjectDcaCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectDcaCommentsLastViewedDateMutation, UpdateAmoProjectDcaCommentsLastViewedDateMutationVariables>(UpdateAmoProjectDcaCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateAmoProjectDcaCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateAmoProjectDcaCommentsLastViewedDateMutation>;
export type UpdateAmoProjectDcaCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateAmoProjectDcaCommentsLastViewedDateMutation>;
export type UpdateAmoProjectDcaCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectDcaCommentsLastViewedDateMutation, UpdateAmoProjectDcaCommentsLastViewedDateMutationVariables>;
export const AmoProjectDocumentsQueryDocument = gql`
    query amoProjectDocumentsQuery($amoProjectId: Int!, $documentTypeCategoryId: DocumentTypeCategoryEnum!) {
  documents: amoProjectDocuments(amoProjectId: $amoProjectId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...amoProjectDocument
  }
  documentTypes: amoProjectDocumentTypes(amoProjectId: $amoProjectId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...documentType
  }
}
    ${AmoProjectDocumentFragmentDoc}
${DocumentTypeFragmentDoc}`;

/**
 * __useAmoProjectDocumentsQueryQuery__
 *
 * To run a query within a React component, call `useAmoProjectDocumentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectDocumentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectDocumentsQueryQuery({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *      documentTypeCategoryId: // value for 'documentTypeCategoryId'
 *   },
 * });
 */
export function useAmoProjectDocumentsQueryQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectDocumentsQueryQuery, AmoProjectDocumentsQueryQueryVariables>) {
        return Apollo.useQuery<AmoProjectDocumentsQueryQuery, AmoProjectDocumentsQueryQueryVariables>(AmoProjectDocumentsQueryDocument, baseOptions);
      }
export function useAmoProjectDocumentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectDocumentsQueryQuery, AmoProjectDocumentsQueryQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectDocumentsQueryQuery, AmoProjectDocumentsQueryQueryVariables>(AmoProjectDocumentsQueryDocument, baseOptions);
        }
export type AmoProjectDocumentsQueryQueryHookResult = ReturnType<typeof useAmoProjectDocumentsQueryQuery>;
export type AmoProjectDocumentsQueryLazyQueryHookResult = ReturnType<typeof useAmoProjectDocumentsQueryLazyQuery>;
export type AmoProjectDocumentsQueryQueryResult = Apollo.QueryResult<AmoProjectDocumentsQueryQuery, AmoProjectDocumentsQueryQueryVariables>;
export const AddAmoProjectDocumentMutationDocument = gql`
    mutation addAmoProjectDocumentMutation($addAmoProjectDocumentInput: AddAmoProjectDocumentInput!) {
  addAmoProjectDocument(addAmoProjectDocumentInput: $addAmoProjectDocumentInput) {
    id
  }
}
    `;
export type AddAmoProjectDocumentMutationMutationFn = Apollo.MutationFunction<AddAmoProjectDocumentMutationMutation, AddAmoProjectDocumentMutationMutationVariables>;

/**
 * __useAddAmoProjectDocumentMutationMutation__
 *
 * To run a mutation, you first call `useAddAmoProjectDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAmoProjectDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAmoProjectDocumentMutationMutation, { data, loading, error }] = useAddAmoProjectDocumentMutationMutation({
 *   variables: {
 *      addAmoProjectDocumentInput: // value for 'addAmoProjectDocumentInput'
 *   },
 * });
 */
export function useAddAmoProjectDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddAmoProjectDocumentMutationMutation, AddAmoProjectDocumentMutationMutationVariables>) {
        return Apollo.useMutation<AddAmoProjectDocumentMutationMutation, AddAmoProjectDocumentMutationMutationVariables>(AddAmoProjectDocumentMutationDocument, baseOptions);
      }
export type AddAmoProjectDocumentMutationMutationHookResult = ReturnType<typeof useAddAmoProjectDocumentMutationMutation>;
export type AddAmoProjectDocumentMutationMutationResult = Apollo.MutationResult<AddAmoProjectDocumentMutationMutation>;
export type AddAmoProjectDocumentMutationMutationOptions = Apollo.BaseMutationOptions<AddAmoProjectDocumentMutationMutation, AddAmoProjectDocumentMutationMutationVariables>;
export const UpdateAmoProjectDocumentMutationDocument = gql`
    mutation updateAmoProjectDocumentMutation($updateAmoProjectDocumentInput: UpdateAmoProjectDocumentInput!) {
  updateAmoProjectDocument(updateAmoProjectDocumentInput: $updateAmoProjectDocumentInput) {
    id
  }
}
    `;
export type UpdateAmoProjectDocumentMutationMutationFn = Apollo.MutationFunction<UpdateAmoProjectDocumentMutationMutation, UpdateAmoProjectDocumentMutationMutationVariables>;

/**
 * __useUpdateAmoProjectDocumentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectDocumentMutationMutation, { data, loading, error }] = useUpdateAmoProjectDocumentMutationMutation({
 *   variables: {
 *      updateAmoProjectDocumentInput: // value for 'updateAmoProjectDocumentInput'
 *   },
 * });
 */
export function useUpdateAmoProjectDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectDocumentMutationMutation, UpdateAmoProjectDocumentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectDocumentMutationMutation, UpdateAmoProjectDocumentMutationMutationVariables>(UpdateAmoProjectDocumentMutationDocument, baseOptions);
      }
export type UpdateAmoProjectDocumentMutationMutationHookResult = ReturnType<typeof useUpdateAmoProjectDocumentMutationMutation>;
export type UpdateAmoProjectDocumentMutationMutationResult = Apollo.MutationResult<UpdateAmoProjectDocumentMutationMutation>;
export type UpdateAmoProjectDocumentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectDocumentMutationMutation, UpdateAmoProjectDocumentMutationMutationVariables>;
export const RemoveAmoProjectDocumentMutationDocument = gql`
    mutation removeAmoProjectDocumentMutation($id: Int!) {
  removeAmoProjectDocument(id: $id)
}
    `;
export type RemoveAmoProjectDocumentMutationMutationFn = Apollo.MutationFunction<RemoveAmoProjectDocumentMutationMutation, RemoveAmoProjectDocumentMutationMutationVariables>;

/**
 * __useRemoveAmoProjectDocumentMutationMutation__
 *
 * To run a mutation, you first call `useRemoveAmoProjectDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAmoProjectDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAmoProjectDocumentMutationMutation, { data, loading, error }] = useRemoveAmoProjectDocumentMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAmoProjectDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAmoProjectDocumentMutationMutation, RemoveAmoProjectDocumentMutationMutationVariables>) {
        return Apollo.useMutation<RemoveAmoProjectDocumentMutationMutation, RemoveAmoProjectDocumentMutationMutationVariables>(RemoveAmoProjectDocumentMutationDocument, baseOptions);
      }
export type RemoveAmoProjectDocumentMutationMutationHookResult = ReturnType<typeof useRemoveAmoProjectDocumentMutationMutation>;
export type RemoveAmoProjectDocumentMutationMutationResult = Apollo.MutationResult<RemoveAmoProjectDocumentMutationMutation>;
export type RemoveAmoProjectDocumentMutationMutationOptions = Apollo.BaseMutationOptions<RemoveAmoProjectDocumentMutationMutation, RemoveAmoProjectDocumentMutationMutationVariables>;
export const DownloadAmoProjectDocumentDocument = gql`
    query downloadAmoProjectDocument($id: Int!) {
  file: downloadAmoProjectDocument(id: $id) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadAmoProjectDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadAmoProjectDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAmoProjectDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAmoProjectDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadAmoProjectDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAmoProjectDocumentQuery, DownloadAmoProjectDocumentQueryVariables>) {
        return Apollo.useQuery<DownloadAmoProjectDocumentQuery, DownloadAmoProjectDocumentQueryVariables>(DownloadAmoProjectDocumentDocument, baseOptions);
      }
export function useDownloadAmoProjectDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAmoProjectDocumentQuery, DownloadAmoProjectDocumentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAmoProjectDocumentQuery, DownloadAmoProjectDocumentQueryVariables>(DownloadAmoProjectDocumentDocument, baseOptions);
        }
export type DownloadAmoProjectDocumentQueryHookResult = ReturnType<typeof useDownloadAmoProjectDocumentQuery>;
export type DownloadAmoProjectDocumentLazyQueryHookResult = ReturnType<typeof useDownloadAmoProjectDocumentLazyQuery>;
export type DownloadAmoProjectDocumentQueryResult = Apollo.QueryResult<DownloadAmoProjectDocumentQuery, DownloadAmoProjectDocumentQueryVariables>;
export const UpdateAmoProjectDocumentReleasedToDcaMutationDocument = gql`
    mutation updateAmoProjectDocumentReleasedToDcaMutation($input: UpdateAmoProjectDocumentReleasedToDcaInput!) {
  updateAmoProjectDocumentReleasedToDca(input: $input) {
    id
  }
}
    `;
export type UpdateAmoProjectDocumentReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateAmoProjectDocumentReleasedToDcaMutationMutation, UpdateAmoProjectDocumentReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateAmoProjectDocumentReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectDocumentReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectDocumentReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectDocumentReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateAmoProjectDocumentReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAmoProjectDocumentReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectDocumentReleasedToDcaMutationMutation, UpdateAmoProjectDocumentReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectDocumentReleasedToDcaMutationMutation, UpdateAmoProjectDocumentReleasedToDcaMutationMutationVariables>(UpdateAmoProjectDocumentReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateAmoProjectDocumentReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateAmoProjectDocumentReleasedToDcaMutationMutation>;
export type UpdateAmoProjectDocumentReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateAmoProjectDocumentReleasedToDcaMutationMutation>;
export type UpdateAmoProjectDocumentReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectDocumentReleasedToDcaMutationMutation, UpdateAmoProjectDocumentReleasedToDcaMutationMutationVariables>;
export const AmoProjectGridDocument = gql`
    query amoProjectGrid($sortBy: AmoProjectsSortBy, $sortDirection: String, $projectStatusIdIn: [Int!], $projectStatusIdNotIn: [Int!], $assigneeIdIn: [Int!], $aircraftRegistrationMarkContains: String, $dateOfFirstIssue: DateRangeFilterInput, $dateOfExpiry: DateRangeFilterInput, $createDate: DateRangeFilterInput, $keyword: String, $paginationOptions: PaginationOptions) {
  amoProjects(sortBy: $sortBy, sortDirection: $sortDirection, projectStatusIdIn: $projectStatusIdIn, projectStatusIdNotIn: $projectStatusIdNotIn, assigneeIdIn: $assigneeIdIn, aircraftRegistrationMarkContains: $aircraftRegistrationMarkContains, dateOfFirstIssue: $dateOfFirstIssue, dateOfExpiry: $dateOfExpiry, createDate: $createDate, keyword: $keyword, paginationOptions: $paginationOptions) {
    ... on PaginatedAmoProjects {
      totalItems
      amoProjects {
        ...amoProjectGridItem
      }
    }
    ... on AmoProjects {
      amoProjects {
        ...amoProjectGridItem
      }
    }
  }
}
    ${AmoProjectGridItemFragmentDoc}`;

/**
 * __useAmoProjectGridQuery__
 *
 * To run a query within a React component, call `useAmoProjectGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectGridQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      projectStatusIdIn: // value for 'projectStatusIdIn'
 *      projectStatusIdNotIn: // value for 'projectStatusIdNotIn'
 *      assigneeIdIn: // value for 'assigneeIdIn'
 *      aircraftRegistrationMarkContains: // value for 'aircraftRegistrationMarkContains'
 *      dateOfFirstIssue: // value for 'dateOfFirstIssue'
 *      dateOfExpiry: // value for 'dateOfExpiry'
 *      createDate: // value for 'createDate'
 *      keyword: // value for 'keyword'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useAmoProjectGridQuery(baseOptions?: Apollo.QueryHookOptions<AmoProjectGridQuery, AmoProjectGridQueryVariables>) {
        return Apollo.useQuery<AmoProjectGridQuery, AmoProjectGridQueryVariables>(AmoProjectGridDocument, baseOptions);
      }
export function useAmoProjectGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectGridQuery, AmoProjectGridQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectGridQuery, AmoProjectGridQueryVariables>(AmoProjectGridDocument, baseOptions);
        }
export type AmoProjectGridQueryHookResult = ReturnType<typeof useAmoProjectGridQuery>;
export type AmoProjectGridLazyQueryHookResult = ReturnType<typeof useAmoProjectGridLazyQuery>;
export type AmoProjectGridQueryResult = Apollo.QueryResult<AmoProjectGridQuery, AmoProjectGridQueryVariables>;
export const AddAmoProjectModalAmoDocument = gql`
    query addAmoProjectModalAmo($id: Int!) {
  amo(id: $id) {
    id
    dcaCertificateNo
  }
}
    `;

/**
 * __useAddAmoProjectModalAmoQuery__
 *
 * To run a query within a React component, call `useAddAmoProjectModalAmoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddAmoProjectModalAmoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddAmoProjectModalAmoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddAmoProjectModalAmoQuery(baseOptions: Apollo.QueryHookOptions<AddAmoProjectModalAmoQuery, AddAmoProjectModalAmoQueryVariables>) {
        return Apollo.useQuery<AddAmoProjectModalAmoQuery, AddAmoProjectModalAmoQueryVariables>(AddAmoProjectModalAmoDocument, baseOptions);
      }
export function useAddAmoProjectModalAmoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddAmoProjectModalAmoQuery, AddAmoProjectModalAmoQueryVariables>) {
          return Apollo.useLazyQuery<AddAmoProjectModalAmoQuery, AddAmoProjectModalAmoQueryVariables>(AddAmoProjectModalAmoDocument, baseOptions);
        }
export type AddAmoProjectModalAmoQueryHookResult = ReturnType<typeof useAddAmoProjectModalAmoQuery>;
export type AddAmoProjectModalAmoLazyQueryHookResult = ReturnType<typeof useAddAmoProjectModalAmoLazyQuery>;
export type AddAmoProjectModalAmoQueryResult = Apollo.QueryResult<AddAmoProjectModalAmoQuery, AddAmoProjectModalAmoQueryVariables>;
export const AddAmoProjectMutationDocument = gql`
    mutation addAmoProjectMutation($addAmoProjectInput: AddAmoProjectInput!) {
  addAmoProject(addAmoProjectInput: $addAmoProjectInput) {
    id
  }
}
    `;
export type AddAmoProjectMutationMutationFn = Apollo.MutationFunction<AddAmoProjectMutationMutation, AddAmoProjectMutationMutationVariables>;

/**
 * __useAddAmoProjectMutationMutation__
 *
 * To run a mutation, you first call `useAddAmoProjectMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAmoProjectMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAmoProjectMutationMutation, { data, loading, error }] = useAddAmoProjectMutationMutation({
 *   variables: {
 *      addAmoProjectInput: // value for 'addAmoProjectInput'
 *   },
 * });
 */
export function useAddAmoProjectMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddAmoProjectMutationMutation, AddAmoProjectMutationMutationVariables>) {
        return Apollo.useMutation<AddAmoProjectMutationMutation, AddAmoProjectMutationMutationVariables>(AddAmoProjectMutationDocument, baseOptions);
      }
export type AddAmoProjectMutationMutationHookResult = ReturnType<typeof useAddAmoProjectMutationMutation>;
export type AddAmoProjectMutationMutationResult = Apollo.MutationResult<AddAmoProjectMutationMutation>;
export type AddAmoProjectMutationMutationOptions = Apollo.BaseMutationOptions<AddAmoProjectMutationMutation, AddAmoProjectMutationMutationVariables>;
export const AmoProjectPageDocument = gql`
    query amoProjectPage($id: Int!) {
  amoProject(id: $id) {
    id
    amoName
    dcaCertificateNo
    localApprovalOpsSpecsNumber
    specialProject
    amoProjectType {
      name
    }
    projectStatus {
      name
    }
    projectStage {
      name
    }
    country {
      name
    }
  }
}
    `;

/**
 * __useAmoProjectPageQuery__
 *
 * To run a query within a React component, call `useAmoProjectPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAmoProjectPageQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectPageQuery, AmoProjectPageQueryVariables>) {
        return Apollo.useQuery<AmoProjectPageQuery, AmoProjectPageQueryVariables>(AmoProjectPageDocument, baseOptions);
      }
export function useAmoProjectPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectPageQuery, AmoProjectPageQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectPageQuery, AmoProjectPageQueryVariables>(AmoProjectPageDocument, baseOptions);
        }
export type AmoProjectPageQueryHookResult = ReturnType<typeof useAmoProjectPageQuery>;
export type AmoProjectPageLazyQueryHookResult = ReturnType<typeof useAmoProjectPageLazyQuery>;
export type AmoProjectPageQueryResult = Apollo.QueryResult<AmoProjectPageQuery, AmoProjectPageQueryVariables>;
export const AmoProjectHeaderDocument = gql`
    query amoProjectHeader($id: Int!) {
  amoProject(id: $id) {
    id
    amoProjectType {
      name
    }
    amoName
    country {
      name
    }
    projectStatus {
      id
      name
    }
    projectCreationDate
    projectCreatedByUser {
      firstName
      lastName
    }
    isOnHold
    isOnHoldByDca
    dcaSubmissionDate
    assignees {
      id
    }
  }
}
    `;

/**
 * __useAmoProjectHeaderQuery__
 *
 * To run a query within a React component, call `useAmoProjectHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAmoProjectHeaderQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectHeaderQuery, AmoProjectHeaderQueryVariables>) {
        return Apollo.useQuery<AmoProjectHeaderQuery, AmoProjectHeaderQueryVariables>(AmoProjectHeaderDocument, baseOptions);
      }
export function useAmoProjectHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectHeaderQuery, AmoProjectHeaderQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectHeaderQuery, AmoProjectHeaderQueryVariables>(AmoProjectHeaderDocument, baseOptions);
        }
export type AmoProjectHeaderQueryHookResult = ReturnType<typeof useAmoProjectHeaderQuery>;
export type AmoProjectHeaderLazyQueryHookResult = ReturnType<typeof useAmoProjectHeaderLazyQuery>;
export type AmoProjectHeaderQueryResult = Apollo.QueryResult<AmoProjectHeaderQuery, AmoProjectHeaderQueryVariables>;
export const TransitionAmoProjectDocument = gql`
    mutation transitionAmoProject($input: TransitionProjectInput!) {
  transitionAmoProject(input: $input) {
    id
    warnings
  }
}
    `;
export type TransitionAmoProjectMutationFn = Apollo.MutationFunction<TransitionAmoProjectMutation, TransitionAmoProjectMutationVariables>;

/**
 * __useTransitionAmoProjectMutation__
 *
 * To run a mutation, you first call `useTransitionAmoProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionAmoProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionAmoProjectMutation, { data, loading, error }] = useTransitionAmoProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransitionAmoProjectMutation(baseOptions?: Apollo.MutationHookOptions<TransitionAmoProjectMutation, TransitionAmoProjectMutationVariables>) {
        return Apollo.useMutation<TransitionAmoProjectMutation, TransitionAmoProjectMutationVariables>(TransitionAmoProjectDocument, baseOptions);
      }
export type TransitionAmoProjectMutationHookResult = ReturnType<typeof useTransitionAmoProjectMutation>;
export type TransitionAmoProjectMutationResult = Apollo.MutationResult<TransitionAmoProjectMutation>;
export type TransitionAmoProjectMutationOptions = Apollo.BaseMutationOptions<TransitionAmoProjectMutation, TransitionAmoProjectMutationVariables>;
export const HoldAmoProjectDocument = gql`
    mutation holdAmoProject($id: Int!) {
  holdAmoProject(id: $id) {
    id
  }
}
    `;
export type HoldAmoProjectMutationFn = Apollo.MutationFunction<HoldAmoProjectMutation, HoldAmoProjectMutationVariables>;

/**
 * __useHoldAmoProjectMutation__
 *
 * To run a mutation, you first call `useHoldAmoProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHoldAmoProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [holdAmoProjectMutation, { data, loading, error }] = useHoldAmoProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHoldAmoProjectMutation(baseOptions?: Apollo.MutationHookOptions<HoldAmoProjectMutation, HoldAmoProjectMutationVariables>) {
        return Apollo.useMutation<HoldAmoProjectMutation, HoldAmoProjectMutationVariables>(HoldAmoProjectDocument, baseOptions);
      }
export type HoldAmoProjectMutationHookResult = ReturnType<typeof useHoldAmoProjectMutation>;
export type HoldAmoProjectMutationResult = Apollo.MutationResult<HoldAmoProjectMutation>;
export type HoldAmoProjectMutationOptions = Apollo.BaseMutationOptions<HoldAmoProjectMutation, HoldAmoProjectMutationVariables>;
export const ReleaseAmoProjectDocument = gql`
    mutation releaseAmoProject($id: Int!) {
  releaseAmoProject(id: $id) {
    id
  }
}
    `;
export type ReleaseAmoProjectMutationFn = Apollo.MutationFunction<ReleaseAmoProjectMutation, ReleaseAmoProjectMutationVariables>;

/**
 * __useReleaseAmoProjectMutation__
 *
 * To run a mutation, you first call `useReleaseAmoProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseAmoProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseAmoProjectMutation, { data, loading, error }] = useReleaseAmoProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReleaseAmoProjectMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseAmoProjectMutation, ReleaseAmoProjectMutationVariables>) {
        return Apollo.useMutation<ReleaseAmoProjectMutation, ReleaseAmoProjectMutationVariables>(ReleaseAmoProjectDocument, baseOptions);
      }
export type ReleaseAmoProjectMutationHookResult = ReturnType<typeof useReleaseAmoProjectMutation>;
export type ReleaseAmoProjectMutationResult = Apollo.MutationResult<ReleaseAmoProjectMutation>;
export type ReleaseAmoProjectMutationOptions = Apollo.BaseMutationOptions<ReleaseAmoProjectMutation, ReleaseAmoProjectMutationVariables>;
export const DcaHoldAmoProjectDocument = gql`
    mutation dcaHoldAmoProject($input: DcaHoldAmoProjectInput!) {
  dcaHoldAmoProject(input: $input) {
    id
  }
}
    `;
export type DcaHoldAmoProjectMutationFn = Apollo.MutationFunction<DcaHoldAmoProjectMutation, DcaHoldAmoProjectMutationVariables>;

/**
 * __useDcaHoldAmoProjectMutation__
 *
 * To run a mutation, you first call `useDcaHoldAmoProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDcaHoldAmoProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dcaHoldAmoProjectMutation, { data, loading, error }] = useDcaHoldAmoProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDcaHoldAmoProjectMutation(baseOptions?: Apollo.MutationHookOptions<DcaHoldAmoProjectMutation, DcaHoldAmoProjectMutationVariables>) {
        return Apollo.useMutation<DcaHoldAmoProjectMutation, DcaHoldAmoProjectMutationVariables>(DcaHoldAmoProjectDocument, baseOptions);
      }
export type DcaHoldAmoProjectMutationHookResult = ReturnType<typeof useDcaHoldAmoProjectMutation>;
export type DcaHoldAmoProjectMutationResult = Apollo.MutationResult<DcaHoldAmoProjectMutation>;
export type DcaHoldAmoProjectMutationOptions = Apollo.BaseMutationOptions<DcaHoldAmoProjectMutation, DcaHoldAmoProjectMutationVariables>;
export const DcaReleaseAmoProjectDocument = gql`
    mutation dcaReleaseAmoProject($id: Int!) {
  dcaReleaseAmoProject(id: $id) {
    id
  }
}
    `;
export type DcaReleaseAmoProjectMutationFn = Apollo.MutationFunction<DcaReleaseAmoProjectMutation, DcaReleaseAmoProjectMutationVariables>;

/**
 * __useDcaReleaseAmoProjectMutation__
 *
 * To run a mutation, you first call `useDcaReleaseAmoProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDcaReleaseAmoProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dcaReleaseAmoProjectMutation, { data, loading, error }] = useDcaReleaseAmoProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDcaReleaseAmoProjectMutation(baseOptions?: Apollo.MutationHookOptions<DcaReleaseAmoProjectMutation, DcaReleaseAmoProjectMutationVariables>) {
        return Apollo.useMutation<DcaReleaseAmoProjectMutation, DcaReleaseAmoProjectMutationVariables>(DcaReleaseAmoProjectDocument, baseOptions);
      }
export type DcaReleaseAmoProjectMutationHookResult = ReturnType<typeof useDcaReleaseAmoProjectMutation>;
export type DcaReleaseAmoProjectMutationResult = Apollo.MutationResult<DcaReleaseAmoProjectMutation>;
export type DcaReleaseAmoProjectMutationOptions = Apollo.BaseMutationOptions<DcaReleaseAmoProjectMutation, DcaReleaseAmoProjectMutationVariables>;
export const SendAmoProjectBackToIasoDocument = gql`
    mutation sendAmoProjectBackToIaso($input: SendAmoProjectToIasoInput!) {
  sendAmoProjectBackToIaso(input: $input) {
    id
  }
}
    `;
export type SendAmoProjectBackToIasoMutationFn = Apollo.MutationFunction<SendAmoProjectBackToIasoMutation, SendAmoProjectBackToIasoMutationVariables>;

/**
 * __useSendAmoProjectBackToIasoMutation__
 *
 * To run a mutation, you first call `useSendAmoProjectBackToIasoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAmoProjectBackToIasoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAmoProjectBackToIasoMutation, { data, loading, error }] = useSendAmoProjectBackToIasoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAmoProjectBackToIasoMutation(baseOptions?: Apollo.MutationHookOptions<SendAmoProjectBackToIasoMutation, SendAmoProjectBackToIasoMutationVariables>) {
        return Apollo.useMutation<SendAmoProjectBackToIasoMutation, SendAmoProjectBackToIasoMutationVariables>(SendAmoProjectBackToIasoDocument, baseOptions);
      }
export type SendAmoProjectBackToIasoMutationHookResult = ReturnType<typeof useSendAmoProjectBackToIasoMutation>;
export type SendAmoProjectBackToIasoMutationResult = Apollo.MutationResult<SendAmoProjectBackToIasoMutation>;
export type SendAmoProjectBackToIasoMutationOptions = Apollo.BaseMutationOptions<SendAmoProjectBackToIasoMutation, SendAmoProjectBackToIasoMutationVariables>;
export const DeleteAmoProjectDocument = gql`
    mutation deleteAmoProject($id: Int!) {
  deleteAmoProject(id: $id) {
    id
  }
}
    `;
export type DeleteAmoProjectMutationFn = Apollo.MutationFunction<DeleteAmoProjectMutation, DeleteAmoProjectMutationVariables>;

/**
 * __useDeleteAmoProjectMutation__
 *
 * To run a mutation, you first call `useDeleteAmoProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAmoProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAmoProjectMutation, { data, loading, error }] = useDeleteAmoProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAmoProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAmoProjectMutation, DeleteAmoProjectMutationVariables>) {
        return Apollo.useMutation<DeleteAmoProjectMutation, DeleteAmoProjectMutationVariables>(DeleteAmoProjectDocument, baseOptions);
      }
export type DeleteAmoProjectMutationHookResult = ReturnType<typeof useDeleteAmoProjectMutation>;
export type DeleteAmoProjectMutationResult = Apollo.MutationResult<DeleteAmoProjectMutation>;
export type DeleteAmoProjectMutationOptions = Apollo.BaseMutationOptions<DeleteAmoProjectMutation, DeleteAmoProjectMutationVariables>;
export const AmoProjectApplicationTabDocument = gql`
    query amoProjectApplicationTab($id: Int!) {
  amoProject(id: $id) {
    id
    amoProjectType {
      id
    }
    assocAircraftProject {
      id
      aircraft {
        registrationMark
      }
      aircraftProjectType {
        abbreviation
      }
    }
    amoName
    localApprovalOpsSpecsNumber
    country {
      id
    }
    localApprovalExpirationDate
    dcaCertificateNo
    issueDate
    dateOfExpiry
    dateOfFirstIssue
    authorizedLocations
    specialProject
    projectNumber
  }
}
    `;

/**
 * __useAmoProjectApplicationTabQuery__
 *
 * To run a query within a React component, call `useAmoProjectApplicationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectApplicationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectApplicationTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAmoProjectApplicationTabQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectApplicationTabQuery, AmoProjectApplicationTabQueryVariables>) {
        return Apollo.useQuery<AmoProjectApplicationTabQuery, AmoProjectApplicationTabQueryVariables>(AmoProjectApplicationTabDocument, baseOptions);
      }
export function useAmoProjectApplicationTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectApplicationTabQuery, AmoProjectApplicationTabQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectApplicationTabQuery, AmoProjectApplicationTabQueryVariables>(AmoProjectApplicationTabDocument, baseOptions);
        }
export type AmoProjectApplicationTabQueryHookResult = ReturnType<typeof useAmoProjectApplicationTabQuery>;
export type AmoProjectApplicationTabLazyQueryHookResult = ReturnType<typeof useAmoProjectApplicationTabLazyQuery>;
export type AmoProjectApplicationTabQueryResult = Apollo.QueryResult<AmoProjectApplicationTabQuery, AmoProjectApplicationTabQueryVariables>;
export const UpdateAmoProjectApplicationDocument = gql`
    mutation updateAmoProjectApplication($updateAmoProjectInput: UpdateAmoProjectInput!) {
  updateAmoProject(updateAmoProjectInput: $updateAmoProjectInput) {
    id
  }
}
    `;
export type UpdateAmoProjectApplicationMutationFn = Apollo.MutationFunction<UpdateAmoProjectApplicationMutation, UpdateAmoProjectApplicationMutationVariables>;

/**
 * __useUpdateAmoProjectApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectApplicationMutation, { data, loading, error }] = useUpdateAmoProjectApplicationMutation({
 *   variables: {
 *      updateAmoProjectInput: // value for 'updateAmoProjectInput'
 *   },
 * });
 */
export function useUpdateAmoProjectApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectApplicationMutation, UpdateAmoProjectApplicationMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectApplicationMutation, UpdateAmoProjectApplicationMutationVariables>(UpdateAmoProjectApplicationDocument, baseOptions);
      }
export type UpdateAmoProjectApplicationMutationHookResult = ReturnType<typeof useUpdateAmoProjectApplicationMutation>;
export type UpdateAmoProjectApplicationMutationResult = Apollo.MutationResult<UpdateAmoProjectApplicationMutation>;
export type UpdateAmoProjectApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectApplicationMutation, UpdateAmoProjectApplicationMutationVariables>;
export const AmoProjectAuditInfoDocument = gql`
    query amoProjectAuditInfo($id: Int!) {
  amoProject(id: $id) {
    id
    amoName
    dcaCertificateNo
    assocAircraftProject {
      id
      registrationMark
    }
    assignees {
      id
    }
  }
}
    `;

/**
 * __useAmoProjectAuditInfoQuery__
 *
 * To run a query within a React component, call `useAmoProjectAuditInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectAuditInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectAuditInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAmoProjectAuditInfoQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectAuditInfoQuery, AmoProjectAuditInfoQueryVariables>) {
        return Apollo.useQuery<AmoProjectAuditInfoQuery, AmoProjectAuditInfoQueryVariables>(AmoProjectAuditInfoDocument, baseOptions);
      }
export function useAmoProjectAuditInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectAuditInfoQuery, AmoProjectAuditInfoQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectAuditInfoQuery, AmoProjectAuditInfoQueryVariables>(AmoProjectAuditInfoDocument, baseOptions);
        }
export type AmoProjectAuditInfoQueryHookResult = ReturnType<typeof useAmoProjectAuditInfoQuery>;
export type AmoProjectAuditInfoLazyQueryHookResult = ReturnType<typeof useAmoProjectAuditInfoLazyQuery>;
export type AmoProjectAuditInfoQueryResult = Apollo.QueryResult<AmoProjectAuditInfoQuery, AmoProjectAuditInfoQueryVariables>;
export const AmoProjectAuditsDocument = gql`
    query amoProjectAudits($amoProjectId: Int!) {
  currentAudits: amoProjectAudits(amoProjectId: $amoProjectId) {
    id
    inspection {
      ...amoAuditDetailForAllProjects
    }
  }
  priorAudits: amoProjectAudits(amoProjectId: $amoProjectId, isPrior: true) {
    id
    inspection {
      ...amoAuditDetailForAllProjects
    }
  }
}
    ${AmoAuditDetailForAllProjectsFragmentDoc}`;

/**
 * __useAmoProjectAuditsQuery__
 *
 * To run a query within a React component, call `useAmoProjectAuditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectAuditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectAuditsQuery({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *   },
 * });
 */
export function useAmoProjectAuditsQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectAuditsQuery, AmoProjectAuditsQueryVariables>) {
        return Apollo.useQuery<AmoProjectAuditsQuery, AmoProjectAuditsQueryVariables>(AmoProjectAuditsDocument, baseOptions);
      }
export function useAmoProjectAuditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectAuditsQuery, AmoProjectAuditsQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectAuditsQuery, AmoProjectAuditsQueryVariables>(AmoProjectAuditsDocument, baseOptions);
        }
export type AmoProjectAuditsQueryHookResult = ReturnType<typeof useAmoProjectAuditsQuery>;
export type AmoProjectAuditsLazyQueryHookResult = ReturnType<typeof useAmoProjectAuditsLazyQuery>;
export type AmoProjectAuditsQueryResult = Apollo.QueryResult<AmoProjectAuditsQuery, AmoProjectAuditsQueryVariables>;
export const UpdateAmoProjectAuditsMutationDocument = gql`
    mutation updateAmoProjectAuditsMutation($input: UpdateAmoProjectAuditsInput!) {
  updateAmoProjectAudits(input: $input)
}
    `;
export type UpdateAmoProjectAuditsMutationMutationFn = Apollo.MutationFunction<UpdateAmoProjectAuditsMutationMutation, UpdateAmoProjectAuditsMutationMutationVariables>;

/**
 * __useUpdateAmoProjectAuditsMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectAuditsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectAuditsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectAuditsMutationMutation, { data, loading, error }] = useUpdateAmoProjectAuditsMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAmoProjectAuditsMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectAuditsMutationMutation, UpdateAmoProjectAuditsMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectAuditsMutationMutation, UpdateAmoProjectAuditsMutationMutationVariables>(UpdateAmoProjectAuditsMutationDocument, baseOptions);
      }
export type UpdateAmoProjectAuditsMutationMutationHookResult = ReturnType<typeof useUpdateAmoProjectAuditsMutationMutation>;
export type UpdateAmoProjectAuditsMutationMutationResult = Apollo.MutationResult<UpdateAmoProjectAuditsMutationMutation>;
export type UpdateAmoProjectAuditsMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectAuditsMutationMutation, UpdateAmoProjectAuditsMutationMutationVariables>;
export const DownloadAmoProjectAuditLetterOfFindingsDocument = gql`
    query downloadAmoProjectAuditLetterOfFindings($amoProjectId: Int!, $inspectionId: Int!) {
  downloadAmoProjectAuditLetterOfFindings(amoProjectId: $amoProjectId, inspectionId: $inspectionId)
}
    `;

/**
 * __useDownloadAmoProjectAuditLetterOfFindingsQuery__
 *
 * To run a query within a React component, call `useDownloadAmoProjectAuditLetterOfFindingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAmoProjectAuditLetterOfFindingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAmoProjectAuditLetterOfFindingsQuery({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useDownloadAmoProjectAuditLetterOfFindingsQuery(baseOptions: Apollo.QueryHookOptions<DownloadAmoProjectAuditLetterOfFindingsQuery, DownloadAmoProjectAuditLetterOfFindingsQueryVariables>) {
        return Apollo.useQuery<DownloadAmoProjectAuditLetterOfFindingsQuery, DownloadAmoProjectAuditLetterOfFindingsQueryVariables>(DownloadAmoProjectAuditLetterOfFindingsDocument, baseOptions);
      }
export function useDownloadAmoProjectAuditLetterOfFindingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAmoProjectAuditLetterOfFindingsQuery, DownloadAmoProjectAuditLetterOfFindingsQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAmoProjectAuditLetterOfFindingsQuery, DownloadAmoProjectAuditLetterOfFindingsQueryVariables>(DownloadAmoProjectAuditLetterOfFindingsDocument, baseOptions);
        }
export type DownloadAmoProjectAuditLetterOfFindingsQueryHookResult = ReturnType<typeof useDownloadAmoProjectAuditLetterOfFindingsQuery>;
export type DownloadAmoProjectAuditLetterOfFindingsLazyQueryHookResult = ReturnType<typeof useDownloadAmoProjectAuditLetterOfFindingsLazyQuery>;
export type DownloadAmoProjectAuditLetterOfFindingsQueryResult = Apollo.QueryResult<DownloadAmoProjectAuditLetterOfFindingsQuery, DownloadAmoProjectAuditLetterOfFindingsQueryVariables>;
export const DownloadAmoProjectAuditInsForm4004Document = gql`
    query downloadAmoProjectAuditInsForm4004($amoProjectId: Int!, $inspectionId: Int!) {
  downloadAmoProjectAuditInsForm4004(amoProjectId: $amoProjectId, inspectionId: $inspectionId)
}
    `;

/**
 * __useDownloadAmoProjectAuditInsForm4004Query__
 *
 * To run a query within a React component, call `useDownloadAmoProjectAuditInsForm4004Query` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAmoProjectAuditInsForm4004Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAmoProjectAuditInsForm4004Query({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useDownloadAmoProjectAuditInsForm4004Query(baseOptions: Apollo.QueryHookOptions<DownloadAmoProjectAuditInsForm4004Query, DownloadAmoProjectAuditInsForm4004QueryVariables>) {
        return Apollo.useQuery<DownloadAmoProjectAuditInsForm4004Query, DownloadAmoProjectAuditInsForm4004QueryVariables>(DownloadAmoProjectAuditInsForm4004Document, baseOptions);
      }
export function useDownloadAmoProjectAuditInsForm4004LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAmoProjectAuditInsForm4004Query, DownloadAmoProjectAuditInsForm4004QueryVariables>) {
          return Apollo.useLazyQuery<DownloadAmoProjectAuditInsForm4004Query, DownloadAmoProjectAuditInsForm4004QueryVariables>(DownloadAmoProjectAuditInsForm4004Document, baseOptions);
        }
export type DownloadAmoProjectAuditInsForm4004QueryHookResult = ReturnType<typeof useDownloadAmoProjectAuditInsForm4004Query>;
export type DownloadAmoProjectAuditInsForm4004LazyQueryHookResult = ReturnType<typeof useDownloadAmoProjectAuditInsForm4004LazyQuery>;
export type DownloadAmoProjectAuditInsForm4004QueryResult = Apollo.QueryResult<DownloadAmoProjectAuditInsForm4004Query, DownloadAmoProjectAuditInsForm4004QueryVariables>;
export const DownloadAmoProjectAuditInsForm4035Document = gql`
    query downloadAmoProjectAuditInsForm4035($amoProjectId: Int!, $inspectionId: Int!) {
  downloadAmoProjectAuditInsForm4035(amoProjectId: $amoProjectId, inspectionId: $inspectionId)
}
    `;

/**
 * __useDownloadAmoProjectAuditInsForm4035Query__
 *
 * To run a query within a React component, call `useDownloadAmoProjectAuditInsForm4035Query` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAmoProjectAuditInsForm4035Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAmoProjectAuditInsForm4035Query({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useDownloadAmoProjectAuditInsForm4035Query(baseOptions: Apollo.QueryHookOptions<DownloadAmoProjectAuditInsForm4035Query, DownloadAmoProjectAuditInsForm4035QueryVariables>) {
        return Apollo.useQuery<DownloadAmoProjectAuditInsForm4035Query, DownloadAmoProjectAuditInsForm4035QueryVariables>(DownloadAmoProjectAuditInsForm4035Document, baseOptions);
      }
export function useDownloadAmoProjectAuditInsForm4035LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAmoProjectAuditInsForm4035Query, DownloadAmoProjectAuditInsForm4035QueryVariables>) {
          return Apollo.useLazyQuery<DownloadAmoProjectAuditInsForm4035Query, DownloadAmoProjectAuditInsForm4035QueryVariables>(DownloadAmoProjectAuditInsForm4035Document, baseOptions);
        }
export type DownloadAmoProjectAuditInsForm4035QueryHookResult = ReturnType<typeof useDownloadAmoProjectAuditInsForm4035Query>;
export type DownloadAmoProjectAuditInsForm4035LazyQueryHookResult = ReturnType<typeof useDownloadAmoProjectAuditInsForm4035LazyQuery>;
export type DownloadAmoProjectAuditInsForm4035QueryResult = Apollo.QueryResult<DownloadAmoProjectAuditInsForm4035Query, DownloadAmoProjectAuditInsForm4035QueryVariables>;
export const DownloadAmoProjectAuditInspectorInspectionEstimateDocument = gql`
    query downloadAmoProjectAuditInspectorInspectionEstimate($amoProjectId: Int!, $inspectionId: Int!, $inspectorInspectionId: Int!) {
  downloadAmoProjectAuditInspectorInspectionEstimate(amoProjectId: $amoProjectId, inspectionId: $inspectionId, inspectorInspectionId: $inspectorInspectionId)
}
    `;

/**
 * __useDownloadAmoProjectAuditInspectorInspectionEstimateQuery__
 *
 * To run a query within a React component, call `useDownloadAmoProjectAuditInspectorInspectionEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAmoProjectAuditInspectorInspectionEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAmoProjectAuditInspectorInspectionEstimateQuery({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *      inspectionId: // value for 'inspectionId'
 *      inspectorInspectionId: // value for 'inspectorInspectionId'
 *   },
 * });
 */
export function useDownloadAmoProjectAuditInspectorInspectionEstimateQuery(baseOptions: Apollo.QueryHookOptions<DownloadAmoProjectAuditInspectorInspectionEstimateQuery, DownloadAmoProjectAuditInspectorInspectionEstimateQueryVariables>) {
        return Apollo.useQuery<DownloadAmoProjectAuditInspectorInspectionEstimateQuery, DownloadAmoProjectAuditInspectorInspectionEstimateQueryVariables>(DownloadAmoProjectAuditInspectorInspectionEstimateDocument, baseOptions);
      }
export function useDownloadAmoProjectAuditInspectorInspectionEstimateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAmoProjectAuditInspectorInspectionEstimateQuery, DownloadAmoProjectAuditInspectorInspectionEstimateQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAmoProjectAuditInspectorInspectionEstimateQuery, DownloadAmoProjectAuditInspectorInspectionEstimateQueryVariables>(DownloadAmoProjectAuditInspectorInspectionEstimateDocument, baseOptions);
        }
export type DownloadAmoProjectAuditInspectorInspectionEstimateQueryHookResult = ReturnType<typeof useDownloadAmoProjectAuditInspectorInspectionEstimateQuery>;
export type DownloadAmoProjectAuditInspectorInspectionEstimateLazyQueryHookResult = ReturnType<typeof useDownloadAmoProjectAuditInspectorInspectionEstimateLazyQuery>;
export type DownloadAmoProjectAuditInspectorInspectionEstimateQueryResult = Apollo.QueryResult<DownloadAmoProjectAuditInspectorInspectionEstimateQuery, DownloadAmoProjectAuditInspectorInspectionEstimateQueryVariables>;
export const DownloadAmoProjectAuditInspectorInspectionInvoiceDocument = gql`
    query downloadAmoProjectAuditInspectorInspectionInvoice($amoProjectId: Int!, $inspectionId: Int!, $inspectorInspectionId: Int!) {
  downloadAmoProjectAuditInspectorInspectionInvoice(amoProjectId: $amoProjectId, inspectionId: $inspectionId, inspectorInspectionId: $inspectorInspectionId)
}
    `;

/**
 * __useDownloadAmoProjectAuditInspectorInspectionInvoiceQuery__
 *
 * To run a query within a React component, call `useDownloadAmoProjectAuditInspectorInspectionInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAmoProjectAuditInspectorInspectionInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAmoProjectAuditInspectorInspectionInvoiceQuery({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *      inspectionId: // value for 'inspectionId'
 *      inspectorInspectionId: // value for 'inspectorInspectionId'
 *   },
 * });
 */
export function useDownloadAmoProjectAuditInspectorInspectionInvoiceQuery(baseOptions: Apollo.QueryHookOptions<DownloadAmoProjectAuditInspectorInspectionInvoiceQuery, DownloadAmoProjectAuditInspectorInspectionInvoiceQueryVariables>) {
        return Apollo.useQuery<DownloadAmoProjectAuditInspectorInspectionInvoiceQuery, DownloadAmoProjectAuditInspectorInspectionInvoiceQueryVariables>(DownloadAmoProjectAuditInspectorInspectionInvoiceDocument, baseOptions);
      }
export function useDownloadAmoProjectAuditInspectorInspectionInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAmoProjectAuditInspectorInspectionInvoiceQuery, DownloadAmoProjectAuditInspectorInspectionInvoiceQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAmoProjectAuditInspectorInspectionInvoiceQuery, DownloadAmoProjectAuditInspectorInspectionInvoiceQueryVariables>(DownloadAmoProjectAuditInspectorInspectionInvoiceDocument, baseOptions);
        }
export type DownloadAmoProjectAuditInspectorInspectionInvoiceQueryHookResult = ReturnType<typeof useDownloadAmoProjectAuditInspectorInspectionInvoiceQuery>;
export type DownloadAmoProjectAuditInspectorInspectionInvoiceLazyQueryHookResult = ReturnType<typeof useDownloadAmoProjectAuditInspectorInspectionInvoiceLazyQuery>;
export type DownloadAmoProjectAuditInspectorInspectionInvoiceQueryResult = Apollo.QueryResult<DownloadAmoProjectAuditInspectorInspectionInvoiceQuery, DownloadAmoProjectAuditInspectorInspectionInvoiceQueryVariables>;
export const DownloadAmoProjectAuditInspectorInspectionTimeLogDocument = gql`
    query downloadAmoProjectAuditInspectorInspectionTimeLog($amoProjectId: Int!, $inspectionId: Int!, $inspectorInspectionId: Int!) {
  downloadAmoProjectAuditInspectorInspectionTimeLog(amoProjectId: $amoProjectId, inspectionId: $inspectionId, inspectorInspectionId: $inspectorInspectionId)
}
    `;

/**
 * __useDownloadAmoProjectAuditInspectorInspectionTimeLogQuery__
 *
 * To run a query within a React component, call `useDownloadAmoProjectAuditInspectorInspectionTimeLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAmoProjectAuditInspectorInspectionTimeLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAmoProjectAuditInspectorInspectionTimeLogQuery({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *      inspectionId: // value for 'inspectionId'
 *      inspectorInspectionId: // value for 'inspectorInspectionId'
 *   },
 * });
 */
export function useDownloadAmoProjectAuditInspectorInspectionTimeLogQuery(baseOptions: Apollo.QueryHookOptions<DownloadAmoProjectAuditInspectorInspectionTimeLogQuery, DownloadAmoProjectAuditInspectorInspectionTimeLogQueryVariables>) {
        return Apollo.useQuery<DownloadAmoProjectAuditInspectorInspectionTimeLogQuery, DownloadAmoProjectAuditInspectorInspectionTimeLogQueryVariables>(DownloadAmoProjectAuditInspectorInspectionTimeLogDocument, baseOptions);
      }
export function useDownloadAmoProjectAuditInspectorInspectionTimeLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAmoProjectAuditInspectorInspectionTimeLogQuery, DownloadAmoProjectAuditInspectorInspectionTimeLogQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAmoProjectAuditInspectorInspectionTimeLogQuery, DownloadAmoProjectAuditInspectorInspectionTimeLogQueryVariables>(DownloadAmoProjectAuditInspectorInspectionTimeLogDocument, baseOptions);
        }
export type DownloadAmoProjectAuditInspectorInspectionTimeLogQueryHookResult = ReturnType<typeof useDownloadAmoProjectAuditInspectorInspectionTimeLogQuery>;
export type DownloadAmoProjectAuditInspectorInspectionTimeLogLazyQueryHookResult = ReturnType<typeof useDownloadAmoProjectAuditInspectorInspectionTimeLogLazyQuery>;
export type DownloadAmoProjectAuditInspectorInspectionTimeLogQueryResult = Apollo.QueryResult<DownloadAmoProjectAuditInspectorInspectionTimeLogQuery, DownloadAmoProjectAuditInspectorInspectionTimeLogQueryVariables>;
export const UpdateAllAmoProjectDocumentsReleasedToDcaMutationDocument = gql`
    mutation updateAllAmoProjectDocumentsReleasedToDcaMutation($input: UpdateAllAmoProjectDocumentsReleasedToDcaInput!) {
  updateAllAmoProjectDocumentsReleasedToDca(input: $input)
}
    `;
export type UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutation, UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateAllAmoProjectDocumentsReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAllAmoProjectDocumentsReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllAmoProjectDocumentsReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllAmoProjectDocumentsReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateAllAmoProjectDocumentsReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllAmoProjectDocumentsReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutation, UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutation, UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutationVariables>(UpdateAllAmoProjectDocumentsReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateAllAmoProjectDocumentsReleasedToDcaMutationMutation>;
export type UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutation>;
export type UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutation, UpdateAllAmoProjectDocumentsReleasedToDcaMutationMutationVariables>;
export const AmoProjectFormsTabDocument = gql`
    query amoProjectFormsTab($amoProjectId: Int!) {
  amoProject(id: $amoProjectId) {
    assignees {
      id
    }
    projectStatus {
      id
    }
  }
  amoProjectInsForms(amoProjectId: $amoProjectId) {
    ...projectInsFormVersion
  }
}
    ${ProjectInsFormVersionFragmentDoc}`;

/**
 * __useAmoProjectFormsTabQuery__
 *
 * To run a query within a React component, call `useAmoProjectFormsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectFormsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectFormsTabQuery({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *   },
 * });
 */
export function useAmoProjectFormsTabQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectFormsTabQuery, AmoProjectFormsTabQueryVariables>) {
        return Apollo.useQuery<AmoProjectFormsTabQuery, AmoProjectFormsTabQueryVariables>(AmoProjectFormsTabDocument, baseOptions);
      }
export function useAmoProjectFormsTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectFormsTabQuery, AmoProjectFormsTabQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectFormsTabQuery, AmoProjectFormsTabQueryVariables>(AmoProjectFormsTabDocument, baseOptions);
        }
export type AmoProjectFormsTabQueryHookResult = ReturnType<typeof useAmoProjectFormsTabQuery>;
export type AmoProjectFormsTabLazyQueryHookResult = ReturnType<typeof useAmoProjectFormsTabLazyQuery>;
export type AmoProjectFormsTabQueryResult = Apollo.QueryResult<AmoProjectFormsTabQuery, AmoProjectFormsTabQueryVariables>;
export const AmoProjectInsFormFieldValuesAndCommentsQueryDocument = gql`
    query amoProjectInsFormFieldValuesAndCommentsQuery($projectInsFormVersionId: Int!) {
  fieldValues: amoProjectInsFormFieldValues(projectInsFormVersionId: $projectInsFormVersionId) {
    ...projectInsFormVersionFieldValue
  }
  fieldComments: amoProjectInsFormFieldComments(projectInsFormVersionId: $projectInsFormVersionId) {
    ...projectInsFormVersionFieldComment
  }
}
    ${ProjectInsFormVersionFieldValueFragmentDoc}
${ProjectInsFormVersionFieldCommentFragmentDoc}`;

/**
 * __useAmoProjectInsFormFieldValuesAndCommentsQueryQuery__
 *
 * To run a query within a React component, call `useAmoProjectInsFormFieldValuesAndCommentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectInsFormFieldValuesAndCommentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectInsFormFieldValuesAndCommentsQueryQuery({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useAmoProjectInsFormFieldValuesAndCommentsQueryQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectInsFormFieldValuesAndCommentsQueryQuery, AmoProjectInsFormFieldValuesAndCommentsQueryQueryVariables>) {
        return Apollo.useQuery<AmoProjectInsFormFieldValuesAndCommentsQueryQuery, AmoProjectInsFormFieldValuesAndCommentsQueryQueryVariables>(AmoProjectInsFormFieldValuesAndCommentsQueryDocument, baseOptions);
      }
export function useAmoProjectInsFormFieldValuesAndCommentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectInsFormFieldValuesAndCommentsQueryQuery, AmoProjectInsFormFieldValuesAndCommentsQueryQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectInsFormFieldValuesAndCommentsQueryQuery, AmoProjectInsFormFieldValuesAndCommentsQueryQueryVariables>(AmoProjectInsFormFieldValuesAndCommentsQueryDocument, baseOptions);
        }
export type AmoProjectInsFormFieldValuesAndCommentsQueryQueryHookResult = ReturnType<typeof useAmoProjectInsFormFieldValuesAndCommentsQueryQuery>;
export type AmoProjectInsFormFieldValuesAndCommentsQueryLazyQueryHookResult = ReturnType<typeof useAmoProjectInsFormFieldValuesAndCommentsQueryLazyQuery>;
export type AmoProjectInsFormFieldValuesAndCommentsQueryQueryResult = Apollo.QueryResult<AmoProjectInsFormFieldValuesAndCommentsQueryQuery, AmoProjectInsFormFieldValuesAndCommentsQueryQueryVariables>;
export const AmoProjectInsFormFieldValuesOnlyQueryDocument = gql`
    query amoProjectInsFormFieldValuesOnlyQuery($projectInsFormVersionId: Int!) {
  fieldValues: amoProjectInsFormFieldValues(projectInsFormVersionId: $projectInsFormVersionId) {
    ...projectInsFormVersionFieldValue
  }
}
    ${ProjectInsFormVersionFieldValueFragmentDoc}`;

/**
 * __useAmoProjectInsFormFieldValuesOnlyQueryQuery__
 *
 * To run a query within a React component, call `useAmoProjectInsFormFieldValuesOnlyQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectInsFormFieldValuesOnlyQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectInsFormFieldValuesOnlyQueryQuery({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useAmoProjectInsFormFieldValuesOnlyQueryQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectInsFormFieldValuesOnlyQueryQuery, AmoProjectInsFormFieldValuesOnlyQueryQueryVariables>) {
        return Apollo.useQuery<AmoProjectInsFormFieldValuesOnlyQueryQuery, AmoProjectInsFormFieldValuesOnlyQueryQueryVariables>(AmoProjectInsFormFieldValuesOnlyQueryDocument, baseOptions);
      }
export function useAmoProjectInsFormFieldValuesOnlyQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectInsFormFieldValuesOnlyQueryQuery, AmoProjectInsFormFieldValuesOnlyQueryQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectInsFormFieldValuesOnlyQueryQuery, AmoProjectInsFormFieldValuesOnlyQueryQueryVariables>(AmoProjectInsFormFieldValuesOnlyQueryDocument, baseOptions);
        }
export type AmoProjectInsFormFieldValuesOnlyQueryQueryHookResult = ReturnType<typeof useAmoProjectInsFormFieldValuesOnlyQueryQuery>;
export type AmoProjectInsFormFieldValuesOnlyQueryLazyQueryHookResult = ReturnType<typeof useAmoProjectInsFormFieldValuesOnlyQueryLazyQuery>;
export type AmoProjectInsFormFieldValuesOnlyQueryQueryResult = Apollo.QueryResult<AmoProjectInsFormFieldValuesOnlyQueryQuery, AmoProjectInsFormFieldValuesOnlyQueryQueryVariables>;
export const DownloadAmoProjectUploadedInsFormDocument = gql`
    query downloadAmoProjectUploadedInsForm($id: Int!) {
  file: downloadAmoProjectUploadedInsForm(projectInsFormVersionId: $id) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadAmoProjectUploadedInsFormQuery__
 *
 * To run a query within a React component, call `useDownloadAmoProjectUploadedInsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAmoProjectUploadedInsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAmoProjectUploadedInsFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadAmoProjectUploadedInsFormQuery(baseOptions: Apollo.QueryHookOptions<DownloadAmoProjectUploadedInsFormQuery, DownloadAmoProjectUploadedInsFormQueryVariables>) {
        return Apollo.useQuery<DownloadAmoProjectUploadedInsFormQuery, DownloadAmoProjectUploadedInsFormQueryVariables>(DownloadAmoProjectUploadedInsFormDocument, baseOptions);
      }
export function useDownloadAmoProjectUploadedInsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAmoProjectUploadedInsFormQuery, DownloadAmoProjectUploadedInsFormQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAmoProjectUploadedInsFormQuery, DownloadAmoProjectUploadedInsFormQueryVariables>(DownloadAmoProjectUploadedInsFormDocument, baseOptions);
        }
export type DownloadAmoProjectUploadedInsFormQueryHookResult = ReturnType<typeof useDownloadAmoProjectUploadedInsFormQuery>;
export type DownloadAmoProjectUploadedInsFormLazyQueryHookResult = ReturnType<typeof useDownloadAmoProjectUploadedInsFormLazyQuery>;
export type DownloadAmoProjectUploadedInsFormQueryResult = Apollo.QueryResult<DownloadAmoProjectUploadedInsFormQuery, DownloadAmoProjectUploadedInsFormQueryVariables>;
export const DownloadAmoProjectFilledInInsFormDocument = gql`
    query downloadAmoProjectFilledInInsForm($projectInsFormVersionId: Int!) {
  file: downloadAmoProjectFilledInInsForm(projectInsFormVersionId: $projectInsFormVersionId) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadAmoProjectFilledInInsFormQuery__
 *
 * To run a query within a React component, call `useDownloadAmoProjectFilledInInsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAmoProjectFilledInInsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAmoProjectFilledInInsFormQuery({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useDownloadAmoProjectFilledInInsFormQuery(baseOptions: Apollo.QueryHookOptions<DownloadAmoProjectFilledInInsFormQuery, DownloadAmoProjectFilledInInsFormQueryVariables>) {
        return Apollo.useQuery<DownloadAmoProjectFilledInInsFormQuery, DownloadAmoProjectFilledInInsFormQueryVariables>(DownloadAmoProjectFilledInInsFormDocument, baseOptions);
      }
export function useDownloadAmoProjectFilledInInsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAmoProjectFilledInInsFormQuery, DownloadAmoProjectFilledInInsFormQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAmoProjectFilledInInsFormQuery, DownloadAmoProjectFilledInInsFormQueryVariables>(DownloadAmoProjectFilledInInsFormDocument, baseOptions);
        }
export type DownloadAmoProjectFilledInInsFormQueryHookResult = ReturnType<typeof useDownloadAmoProjectFilledInInsFormQuery>;
export type DownloadAmoProjectFilledInInsFormLazyQueryHookResult = ReturnType<typeof useDownloadAmoProjectFilledInInsFormLazyQuery>;
export type DownloadAmoProjectFilledInInsFormQueryResult = Apollo.QueryResult<DownloadAmoProjectFilledInInsFormQuery, DownloadAmoProjectFilledInInsFormQueryVariables>;
export const UpdateAmoProjectInsFormTrgApprovalMutationDocument = gql`
    mutation updateAmoProjectInsFormTrgApprovalMutation($input: UpdateProjectInsFormVersionTrgApprovalInput!) {
  updateAmoProjectInsFormTrgApproval(input: $input) {
    ...projectInsFormVersion
  }
}
    ${ProjectInsFormVersionFragmentDoc}`;
export type UpdateAmoProjectInsFormTrgApprovalMutationMutationFn = Apollo.MutationFunction<UpdateAmoProjectInsFormTrgApprovalMutationMutation, UpdateAmoProjectInsFormTrgApprovalMutationMutationVariables>;

/**
 * __useUpdateAmoProjectInsFormTrgApprovalMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectInsFormTrgApprovalMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectInsFormTrgApprovalMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectInsFormTrgApprovalMutationMutation, { data, loading, error }] = useUpdateAmoProjectInsFormTrgApprovalMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAmoProjectInsFormTrgApprovalMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectInsFormTrgApprovalMutationMutation, UpdateAmoProjectInsFormTrgApprovalMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectInsFormTrgApprovalMutationMutation, UpdateAmoProjectInsFormTrgApprovalMutationMutationVariables>(UpdateAmoProjectInsFormTrgApprovalMutationDocument, baseOptions);
      }
export type UpdateAmoProjectInsFormTrgApprovalMutationMutationHookResult = ReturnType<typeof useUpdateAmoProjectInsFormTrgApprovalMutationMutation>;
export type UpdateAmoProjectInsFormTrgApprovalMutationMutationResult = Apollo.MutationResult<UpdateAmoProjectInsFormTrgApprovalMutationMutation>;
export type UpdateAmoProjectInsFormTrgApprovalMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectInsFormTrgApprovalMutationMutation, UpdateAmoProjectInsFormTrgApprovalMutationMutationVariables>;
export const UpdateAmoProjectInsFormFileAttachmentMutationDocument = gql`
    mutation updateAmoProjectInsFormFileAttachmentMutation($input: UpdateProjectInsFormVersionFileAttachmentInput!) {
  updateAmoProjectInsFormFileAttachment(input: $input) {
    ...projectInsFormVersion
  }
}
    ${ProjectInsFormVersionFragmentDoc}`;
export type UpdateAmoProjectInsFormFileAttachmentMutationMutationFn = Apollo.MutationFunction<UpdateAmoProjectInsFormFileAttachmentMutationMutation, UpdateAmoProjectInsFormFileAttachmentMutationMutationVariables>;

/**
 * __useUpdateAmoProjectInsFormFileAttachmentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectInsFormFileAttachmentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectInsFormFileAttachmentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectInsFormFileAttachmentMutationMutation, { data, loading, error }] = useUpdateAmoProjectInsFormFileAttachmentMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAmoProjectInsFormFileAttachmentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectInsFormFileAttachmentMutationMutation, UpdateAmoProjectInsFormFileAttachmentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectInsFormFileAttachmentMutationMutation, UpdateAmoProjectInsFormFileAttachmentMutationMutationVariables>(UpdateAmoProjectInsFormFileAttachmentMutationDocument, baseOptions);
      }
export type UpdateAmoProjectInsFormFileAttachmentMutationMutationHookResult = ReturnType<typeof useUpdateAmoProjectInsFormFileAttachmentMutationMutation>;
export type UpdateAmoProjectInsFormFileAttachmentMutationMutationResult = Apollo.MutationResult<UpdateAmoProjectInsFormFileAttachmentMutationMutation>;
export type UpdateAmoProjectInsFormFileAttachmentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectInsFormFileAttachmentMutationMutation, UpdateAmoProjectInsFormFileAttachmentMutationMutationVariables>;
export const UpdateAmoProjectInsFormReleasedToDcaMutationDocument = gql`
    mutation updateAmoProjectInsFormReleasedToDcaMutation($input: UpdateProjectInsFormVersionReleasedToDcaInput!) {
  updateAmoProjectInsFormReleasedToDca(input: $input) {
    ...projectInsFormVersion
  }
}
    ${ProjectInsFormVersionFragmentDoc}`;
export type UpdateAmoProjectInsFormReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateAmoProjectInsFormReleasedToDcaMutationMutation, UpdateAmoProjectInsFormReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateAmoProjectInsFormReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectInsFormReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectInsFormReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectInsFormReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateAmoProjectInsFormReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAmoProjectInsFormReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectInsFormReleasedToDcaMutationMutation, UpdateAmoProjectInsFormReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectInsFormReleasedToDcaMutationMutation, UpdateAmoProjectInsFormReleasedToDcaMutationMutationVariables>(UpdateAmoProjectInsFormReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateAmoProjectInsFormReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateAmoProjectInsFormReleasedToDcaMutationMutation>;
export type UpdateAmoProjectInsFormReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateAmoProjectInsFormReleasedToDcaMutationMutation>;
export type UpdateAmoProjectInsFormReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectInsFormReleasedToDcaMutationMutation, UpdateAmoProjectInsFormReleasedToDcaMutationMutationVariables>;
export const UpdateAllAmoProjectInsFormsReleasedToDcaMutationDocument = gql`
    mutation updateAllAmoProjectInsFormsReleasedToDcaMutation($input: UpdateAllProjectInsFormVersionsReleasedToDcaInput!) {
  updateAllAmoProjectInsFormsReleasedToDca(input: $input)
}
    `;
export type UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutation, UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateAllAmoProjectInsFormsReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAllAmoProjectInsFormsReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllAmoProjectInsFormsReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllAmoProjectInsFormsReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateAllAmoProjectInsFormsReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllAmoProjectInsFormsReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutation, UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutation, UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutationVariables>(UpdateAllAmoProjectInsFormsReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateAllAmoProjectInsFormsReleasedToDcaMutationMutation>;
export type UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutation>;
export type UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutation, UpdateAllAmoProjectInsFormsReleasedToDcaMutationMutationVariables>;
export const UpdateAmoProjectInsFormFieldValuesDocument = gql`
    mutation updateAmoProjectInsFormFieldValues($input: UpdateProjectInsFormVersionFieldValuesInput!) {
  updateAmoProjectInsFormFieldValues(input: $input)
}
    `;
export type UpdateAmoProjectInsFormFieldValuesMutationFn = Apollo.MutationFunction<UpdateAmoProjectInsFormFieldValuesMutation, UpdateAmoProjectInsFormFieldValuesMutationVariables>;

/**
 * __useUpdateAmoProjectInsFormFieldValuesMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectInsFormFieldValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectInsFormFieldValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectInsFormFieldValuesMutation, { data, loading, error }] = useUpdateAmoProjectInsFormFieldValuesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAmoProjectInsFormFieldValuesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectInsFormFieldValuesMutation, UpdateAmoProjectInsFormFieldValuesMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectInsFormFieldValuesMutation, UpdateAmoProjectInsFormFieldValuesMutationVariables>(UpdateAmoProjectInsFormFieldValuesDocument, baseOptions);
      }
export type UpdateAmoProjectInsFormFieldValuesMutationHookResult = ReturnType<typeof useUpdateAmoProjectInsFormFieldValuesMutation>;
export type UpdateAmoProjectInsFormFieldValuesMutationResult = Apollo.MutationResult<UpdateAmoProjectInsFormFieldValuesMutation>;
export type UpdateAmoProjectInsFormFieldValuesMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectInsFormFieldValuesMutation, UpdateAmoProjectInsFormFieldValuesMutationVariables>;
export const UpdateAmoProjectInsFormFieldCommentDocument = gql`
    mutation updateAmoProjectInsFormFieldComment($input: UpdateProjectInsFormVersionFieldCommentInput!) {
  updateAmoProjectInsFormFieldComment(input: $input)
}
    `;
export type UpdateAmoProjectInsFormFieldCommentMutationFn = Apollo.MutationFunction<UpdateAmoProjectInsFormFieldCommentMutation, UpdateAmoProjectInsFormFieldCommentMutationVariables>;

/**
 * __useUpdateAmoProjectInsFormFieldCommentMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectInsFormFieldCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectInsFormFieldCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectInsFormFieldCommentMutation, { data, loading, error }] = useUpdateAmoProjectInsFormFieldCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAmoProjectInsFormFieldCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectInsFormFieldCommentMutation, UpdateAmoProjectInsFormFieldCommentMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectInsFormFieldCommentMutation, UpdateAmoProjectInsFormFieldCommentMutationVariables>(UpdateAmoProjectInsFormFieldCommentDocument, baseOptions);
      }
export type UpdateAmoProjectInsFormFieldCommentMutationHookResult = ReturnType<typeof useUpdateAmoProjectInsFormFieldCommentMutation>;
export type UpdateAmoProjectInsFormFieldCommentMutationResult = Apollo.MutationResult<UpdateAmoProjectInsFormFieldCommentMutation>;
export type UpdateAmoProjectInsFormFieldCommentMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectInsFormFieldCommentMutation, UpdateAmoProjectInsFormFieldCommentMutationVariables>;
export const UpdateAmoProjectInsFormIsDcaApprovedDocument = gql`
    mutation updateAmoProjectInsFormIsDcaApproved($input: UpdateProjectInsFormIsDcaApprovedInput!) {
  updateAmoProjectInsFormIsDcaApproved(input: $input)
}
    `;
export type UpdateAmoProjectInsFormIsDcaApprovedMutationFn = Apollo.MutationFunction<UpdateAmoProjectInsFormIsDcaApprovedMutation, UpdateAmoProjectInsFormIsDcaApprovedMutationVariables>;

/**
 * __useUpdateAmoProjectInsFormIsDcaApprovedMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectInsFormIsDcaApprovedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectInsFormIsDcaApprovedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectInsFormIsDcaApprovedMutation, { data, loading, error }] = useUpdateAmoProjectInsFormIsDcaApprovedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAmoProjectInsFormIsDcaApprovedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectInsFormIsDcaApprovedMutation, UpdateAmoProjectInsFormIsDcaApprovedMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectInsFormIsDcaApprovedMutation, UpdateAmoProjectInsFormIsDcaApprovedMutationVariables>(UpdateAmoProjectInsFormIsDcaApprovedDocument, baseOptions);
      }
export type UpdateAmoProjectInsFormIsDcaApprovedMutationHookResult = ReturnType<typeof useUpdateAmoProjectInsFormIsDcaApprovedMutation>;
export type UpdateAmoProjectInsFormIsDcaApprovedMutationResult = Apollo.MutationResult<UpdateAmoProjectInsFormIsDcaApprovedMutation>;
export type UpdateAmoProjectInsFormIsDcaApprovedMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectInsFormIsDcaApprovedMutation, UpdateAmoProjectInsFormIsDcaApprovedMutationVariables>;
export const SignAmoProjectInsFormVersionByIdDocument = gql`
    mutation signAmoProjectInsFormVersionById($id: Int!, $input: SignProjectInsFormVersionInput!) {
  signAmoProjectInsFormVersionById(id: $id, input: $input)
}
    `;
export type SignAmoProjectInsFormVersionByIdMutationFn = Apollo.MutationFunction<SignAmoProjectInsFormVersionByIdMutation, SignAmoProjectInsFormVersionByIdMutationVariables>;

/**
 * __useSignAmoProjectInsFormVersionByIdMutation__
 *
 * To run a mutation, you first call `useSignAmoProjectInsFormVersionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignAmoProjectInsFormVersionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signAmoProjectInsFormVersionByIdMutation, { data, loading, error }] = useSignAmoProjectInsFormVersionByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignAmoProjectInsFormVersionByIdMutation(baseOptions?: Apollo.MutationHookOptions<SignAmoProjectInsFormVersionByIdMutation, SignAmoProjectInsFormVersionByIdMutationVariables>) {
        return Apollo.useMutation<SignAmoProjectInsFormVersionByIdMutation, SignAmoProjectInsFormVersionByIdMutationVariables>(SignAmoProjectInsFormVersionByIdDocument, baseOptions);
      }
export type SignAmoProjectInsFormVersionByIdMutationHookResult = ReturnType<typeof useSignAmoProjectInsFormVersionByIdMutation>;
export type SignAmoProjectInsFormVersionByIdMutationResult = Apollo.MutationResult<SignAmoProjectInsFormVersionByIdMutation>;
export type SignAmoProjectInsFormVersionByIdMutationOptions = Apollo.BaseMutationOptions<SignAmoProjectInsFormVersionByIdMutation, SignAmoProjectInsFormVersionByIdMutationVariables>;
export const SignAmoProjectInsFormVersionByIdWithSignatureImageDocument = gql`
    mutation signAmoProjectInsFormVersionByIdWithSignatureImage($id: Int!, $input: SignProjectInsFormVersionInputWithSignatureImageInput!) {
  signAmoProjectInsFormVersionByIdWithSignatureImage(id: $id, input: $input) {
    warnings
  }
}
    `;
export type SignAmoProjectInsFormVersionByIdWithSignatureImageMutationFn = Apollo.MutationFunction<SignAmoProjectInsFormVersionByIdWithSignatureImageMutation, SignAmoProjectInsFormVersionByIdWithSignatureImageMutationVariables>;

/**
 * __useSignAmoProjectInsFormVersionByIdWithSignatureImageMutation__
 *
 * To run a mutation, you first call `useSignAmoProjectInsFormVersionByIdWithSignatureImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignAmoProjectInsFormVersionByIdWithSignatureImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signAmoProjectInsFormVersionByIdWithSignatureImageMutation, { data, loading, error }] = useSignAmoProjectInsFormVersionByIdWithSignatureImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignAmoProjectInsFormVersionByIdWithSignatureImageMutation(baseOptions?: Apollo.MutationHookOptions<SignAmoProjectInsFormVersionByIdWithSignatureImageMutation, SignAmoProjectInsFormVersionByIdWithSignatureImageMutationVariables>) {
        return Apollo.useMutation<SignAmoProjectInsFormVersionByIdWithSignatureImageMutation, SignAmoProjectInsFormVersionByIdWithSignatureImageMutationVariables>(SignAmoProjectInsFormVersionByIdWithSignatureImageDocument, baseOptions);
      }
export type SignAmoProjectInsFormVersionByIdWithSignatureImageMutationHookResult = ReturnType<typeof useSignAmoProjectInsFormVersionByIdWithSignatureImageMutation>;
export type SignAmoProjectInsFormVersionByIdWithSignatureImageMutationResult = Apollo.MutationResult<SignAmoProjectInsFormVersionByIdWithSignatureImageMutation>;
export type SignAmoProjectInsFormVersionByIdWithSignatureImageMutationOptions = Apollo.BaseMutationOptions<SignAmoProjectInsFormVersionByIdWithSignatureImageMutation, SignAmoProjectInsFormVersionByIdWithSignatureImageMutationVariables>;
export const ClearAmoProjectInsFormVersionSignatureByIdDocument = gql`
    mutation clearAmoProjectInsFormVersionSignatureById($id: Int!, $fieldNumber: Int!) {
  clearAmoProjectInsFormVersionSignatureById(id: $id, fieldNumber: $fieldNumber)
}
    `;
export type ClearAmoProjectInsFormVersionSignatureByIdMutationFn = Apollo.MutationFunction<ClearAmoProjectInsFormVersionSignatureByIdMutation, ClearAmoProjectInsFormVersionSignatureByIdMutationVariables>;

/**
 * __useClearAmoProjectInsFormVersionSignatureByIdMutation__
 *
 * To run a mutation, you first call `useClearAmoProjectInsFormVersionSignatureByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAmoProjectInsFormVersionSignatureByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAmoProjectInsFormVersionSignatureByIdMutation, { data, loading, error }] = useClearAmoProjectInsFormVersionSignatureByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fieldNumber: // value for 'fieldNumber'
 *   },
 * });
 */
export function useClearAmoProjectInsFormVersionSignatureByIdMutation(baseOptions?: Apollo.MutationHookOptions<ClearAmoProjectInsFormVersionSignatureByIdMutation, ClearAmoProjectInsFormVersionSignatureByIdMutationVariables>) {
        return Apollo.useMutation<ClearAmoProjectInsFormVersionSignatureByIdMutation, ClearAmoProjectInsFormVersionSignatureByIdMutationVariables>(ClearAmoProjectInsFormVersionSignatureByIdDocument, baseOptions);
      }
export type ClearAmoProjectInsFormVersionSignatureByIdMutationHookResult = ReturnType<typeof useClearAmoProjectInsFormVersionSignatureByIdMutation>;
export type ClearAmoProjectInsFormVersionSignatureByIdMutationResult = Apollo.MutationResult<ClearAmoProjectInsFormVersionSignatureByIdMutation>;
export type ClearAmoProjectInsFormVersionSignatureByIdMutationOptions = Apollo.BaseMutationOptions<ClearAmoProjectInsFormVersionSignatureByIdMutation, ClearAmoProjectInsFormVersionSignatureByIdMutationVariables>;
export const AddAmoProjectInsFormVersionCommentDocument = gql`
    mutation addAmoProjectInsFormVersionComment($id: Int!, $input: CommentInput!) {
  addAmoProjectInsFormVersionComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddAmoProjectInsFormVersionCommentMutationFn = Apollo.MutationFunction<AddAmoProjectInsFormVersionCommentMutation, AddAmoProjectInsFormVersionCommentMutationVariables>;

/**
 * __useAddAmoProjectInsFormVersionCommentMutation__
 *
 * To run a mutation, you first call `useAddAmoProjectInsFormVersionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAmoProjectInsFormVersionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAmoProjectInsFormVersionCommentMutation, { data, loading, error }] = useAddAmoProjectInsFormVersionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAmoProjectInsFormVersionCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddAmoProjectInsFormVersionCommentMutation, AddAmoProjectInsFormVersionCommentMutationVariables>) {
        return Apollo.useMutation<AddAmoProjectInsFormVersionCommentMutation, AddAmoProjectInsFormVersionCommentMutationVariables>(AddAmoProjectInsFormVersionCommentDocument, baseOptions);
      }
export type AddAmoProjectInsFormVersionCommentMutationHookResult = ReturnType<typeof useAddAmoProjectInsFormVersionCommentMutation>;
export type AddAmoProjectInsFormVersionCommentMutationResult = Apollo.MutationResult<AddAmoProjectInsFormVersionCommentMutation>;
export type AddAmoProjectInsFormVersionCommentMutationOptions = Apollo.BaseMutationOptions<AddAmoProjectInsFormVersionCommentMutation, AddAmoProjectInsFormVersionCommentMutationVariables>;
export const UpdateAmoProjectInsFormVersionCommentDocument = gql`
    mutation updateAmoProjectInsFormVersionComment($id: Int!, $body: String!) {
  updateAmoProjectInsFormVersionComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateAmoProjectInsFormVersionCommentMutationFn = Apollo.MutationFunction<UpdateAmoProjectInsFormVersionCommentMutation, UpdateAmoProjectInsFormVersionCommentMutationVariables>;

/**
 * __useUpdateAmoProjectInsFormVersionCommentMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectInsFormVersionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectInsFormVersionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectInsFormVersionCommentMutation, { data, loading, error }] = useUpdateAmoProjectInsFormVersionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateAmoProjectInsFormVersionCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectInsFormVersionCommentMutation, UpdateAmoProjectInsFormVersionCommentMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectInsFormVersionCommentMutation, UpdateAmoProjectInsFormVersionCommentMutationVariables>(UpdateAmoProjectInsFormVersionCommentDocument, baseOptions);
      }
export type UpdateAmoProjectInsFormVersionCommentMutationHookResult = ReturnType<typeof useUpdateAmoProjectInsFormVersionCommentMutation>;
export type UpdateAmoProjectInsFormVersionCommentMutationResult = Apollo.MutationResult<UpdateAmoProjectInsFormVersionCommentMutation>;
export type UpdateAmoProjectInsFormVersionCommentMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectInsFormVersionCommentMutation, UpdateAmoProjectInsFormVersionCommentMutationVariables>;
export const AmoProjectSummaryDocument = gql`
    query amoProjectSummary($id: Int!) {
  amoProject(id: $id) {
    id
    amoName
    isHighPriority
    isNoDcaInvoiceRequired
    officialLetterNotes
    amoProjectType {
      id
      name
    }
    projectStatus {
      id
      name
    }
    projectCreatedByUser {
      id
      firstName
      lastName
    }
    projectCreationDate
    assignees {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useAmoProjectSummaryQuery__
 *
 * To run a query within a React component, call `useAmoProjectSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAmoProjectSummaryQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectSummaryQuery, AmoProjectSummaryQueryVariables>) {
        return Apollo.useQuery<AmoProjectSummaryQuery, AmoProjectSummaryQueryVariables>(AmoProjectSummaryDocument, baseOptions);
      }
export function useAmoProjectSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectSummaryQuery, AmoProjectSummaryQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectSummaryQuery, AmoProjectSummaryQueryVariables>(AmoProjectSummaryDocument, baseOptions);
        }
export type AmoProjectSummaryQueryHookResult = ReturnType<typeof useAmoProjectSummaryQuery>;
export type AmoProjectSummaryLazyQueryHookResult = ReturnType<typeof useAmoProjectSummaryLazyQuery>;
export type AmoProjectSummaryQueryResult = Apollo.QueryResult<AmoProjectSummaryQuery, AmoProjectSummaryQueryVariables>;
export const AmoProjectDocumentTypeOfficialLetterNotesDocument = gql`
    query amoProjectDocumentTypeOfficialLetterNotes($amoProjectId: Int!) {
  amoProjectDocumentTypeOfficialLetterNotes(amoProjectId: $amoProjectId) {
    documentType {
      id
      name
    }
    officialLetterNote
  }
}
    `;

/**
 * __useAmoProjectDocumentTypeOfficialLetterNotesQuery__
 *
 * To run a query within a React component, call `useAmoProjectDocumentTypeOfficialLetterNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectDocumentTypeOfficialLetterNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectDocumentTypeOfficialLetterNotesQuery({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *   },
 * });
 */
export function useAmoProjectDocumentTypeOfficialLetterNotesQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectDocumentTypeOfficialLetterNotesQuery, AmoProjectDocumentTypeOfficialLetterNotesQueryVariables>) {
        return Apollo.useQuery<AmoProjectDocumentTypeOfficialLetterNotesQuery, AmoProjectDocumentTypeOfficialLetterNotesQueryVariables>(AmoProjectDocumentTypeOfficialLetterNotesDocument, baseOptions);
      }
export function useAmoProjectDocumentTypeOfficialLetterNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectDocumentTypeOfficialLetterNotesQuery, AmoProjectDocumentTypeOfficialLetterNotesQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectDocumentTypeOfficialLetterNotesQuery, AmoProjectDocumentTypeOfficialLetterNotesQueryVariables>(AmoProjectDocumentTypeOfficialLetterNotesDocument, baseOptions);
        }
export type AmoProjectDocumentTypeOfficialLetterNotesQueryHookResult = ReturnType<typeof useAmoProjectDocumentTypeOfficialLetterNotesQuery>;
export type AmoProjectDocumentTypeOfficialLetterNotesLazyQueryHookResult = ReturnType<typeof useAmoProjectDocumentTypeOfficialLetterNotesLazyQuery>;
export type AmoProjectDocumentTypeOfficialLetterNotesQueryResult = Apollo.QueryResult<AmoProjectDocumentTypeOfficialLetterNotesQuery, AmoProjectDocumentTypeOfficialLetterNotesQueryVariables>;
export const UpdateAmoProjectPriorityDocument = gql`
    mutation updateAmoProjectPriority($id: Int!) {
  updateAmoProjectPriority(id: $id) {
    id
    isHighPriority
  }
}
    `;
export type UpdateAmoProjectPriorityMutationFn = Apollo.MutationFunction<UpdateAmoProjectPriorityMutation, UpdateAmoProjectPriorityMutationVariables>;

/**
 * __useUpdateAmoProjectPriorityMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectPriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectPriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectPriorityMutation, { data, loading, error }] = useUpdateAmoProjectPriorityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAmoProjectPriorityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectPriorityMutation, UpdateAmoProjectPriorityMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectPriorityMutation, UpdateAmoProjectPriorityMutationVariables>(UpdateAmoProjectPriorityDocument, baseOptions);
      }
export type UpdateAmoProjectPriorityMutationHookResult = ReturnType<typeof useUpdateAmoProjectPriorityMutation>;
export type UpdateAmoProjectPriorityMutationResult = Apollo.MutationResult<UpdateAmoProjectPriorityMutation>;
export type UpdateAmoProjectPriorityMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectPriorityMutation, UpdateAmoProjectPriorityMutationVariables>;
export const UpdateAmoProjectNoDcaInvoiceRequiredDocument = gql`
    mutation updateAmoProjectNoDcaInvoiceRequired($id: Int!) {
  updateAmoProjectNoDcaInvoiceRequired(id: $id) {
    id
    isNoDcaInvoiceRequired
  }
}
    `;
export type UpdateAmoProjectNoDcaInvoiceRequiredMutationFn = Apollo.MutationFunction<UpdateAmoProjectNoDcaInvoiceRequiredMutation, UpdateAmoProjectNoDcaInvoiceRequiredMutationVariables>;

/**
 * __useUpdateAmoProjectNoDcaInvoiceRequiredMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectNoDcaInvoiceRequiredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectNoDcaInvoiceRequiredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectNoDcaInvoiceRequiredMutation, { data, loading, error }] = useUpdateAmoProjectNoDcaInvoiceRequiredMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAmoProjectNoDcaInvoiceRequiredMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectNoDcaInvoiceRequiredMutation, UpdateAmoProjectNoDcaInvoiceRequiredMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectNoDcaInvoiceRequiredMutation, UpdateAmoProjectNoDcaInvoiceRequiredMutationVariables>(UpdateAmoProjectNoDcaInvoiceRequiredDocument, baseOptions);
      }
export type UpdateAmoProjectNoDcaInvoiceRequiredMutationHookResult = ReturnType<typeof useUpdateAmoProjectNoDcaInvoiceRequiredMutation>;
export type UpdateAmoProjectNoDcaInvoiceRequiredMutationResult = Apollo.MutationResult<UpdateAmoProjectNoDcaInvoiceRequiredMutation>;
export type UpdateAmoProjectNoDcaInvoiceRequiredMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectNoDcaInvoiceRequiredMutation, UpdateAmoProjectNoDcaInvoiceRequiredMutationVariables>;
export const UpdateAmoProjectOfficialLetterNotesDocument = gql`
    mutation updateAmoProjectOfficialLetterNotes($input: UpdateAmoProjectOfficialLetterNotesInput!) {
  updateAmoProjectOfficialLetterNotes(input: $input) {
    id
  }
}
    `;
export type UpdateAmoProjectOfficialLetterNotesMutationFn = Apollo.MutationFunction<UpdateAmoProjectOfficialLetterNotesMutation, UpdateAmoProjectOfficialLetterNotesMutationVariables>;

/**
 * __useUpdateAmoProjectOfficialLetterNotesMutation__
 *
 * To run a mutation, you first call `useUpdateAmoProjectOfficialLetterNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmoProjectOfficialLetterNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmoProjectOfficialLetterNotesMutation, { data, loading, error }] = useUpdateAmoProjectOfficialLetterNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAmoProjectOfficialLetterNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmoProjectOfficialLetterNotesMutation, UpdateAmoProjectOfficialLetterNotesMutationVariables>) {
        return Apollo.useMutation<UpdateAmoProjectOfficialLetterNotesMutation, UpdateAmoProjectOfficialLetterNotesMutationVariables>(UpdateAmoProjectOfficialLetterNotesDocument, baseOptions);
      }
export type UpdateAmoProjectOfficialLetterNotesMutationHookResult = ReturnType<typeof useUpdateAmoProjectOfficialLetterNotesMutation>;
export type UpdateAmoProjectOfficialLetterNotesMutationResult = Apollo.MutationResult<UpdateAmoProjectOfficialLetterNotesMutation>;
export type UpdateAmoProjectOfficialLetterNotesMutationOptions = Apollo.BaseMutationOptions<UpdateAmoProjectOfficialLetterNotesMutation, UpdateAmoProjectOfficialLetterNotesMutationVariables>;
export const SetAmoProjectAssigneesDocument = gql`
    mutation setAmoProjectAssignees($amoProjectId: Int!, $assigneeUserIds: [Int!]!) {
  setAmoProjectAssignees(amoProjectId: $amoProjectId, assigneeUserIds: $assigneeUserIds) {
    id
  }
}
    `;
export type SetAmoProjectAssigneesMutationFn = Apollo.MutationFunction<SetAmoProjectAssigneesMutation, SetAmoProjectAssigneesMutationVariables>;

/**
 * __useSetAmoProjectAssigneesMutation__
 *
 * To run a mutation, you first call `useSetAmoProjectAssigneesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAmoProjectAssigneesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAmoProjectAssigneesMutation, { data, loading, error }] = useSetAmoProjectAssigneesMutation({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *      assigneeUserIds: // value for 'assigneeUserIds'
 *   },
 * });
 */
export function useSetAmoProjectAssigneesMutation(baseOptions?: Apollo.MutationHookOptions<SetAmoProjectAssigneesMutation, SetAmoProjectAssigneesMutationVariables>) {
        return Apollo.useMutation<SetAmoProjectAssigneesMutation, SetAmoProjectAssigneesMutationVariables>(SetAmoProjectAssigneesDocument, baseOptions);
      }
export type SetAmoProjectAssigneesMutationHookResult = ReturnType<typeof useSetAmoProjectAssigneesMutation>;
export type SetAmoProjectAssigneesMutationResult = Apollo.MutationResult<SetAmoProjectAssigneesMutation>;
export type SetAmoProjectAssigneesMutationOptions = Apollo.BaseMutationOptions<SetAmoProjectAssigneesMutation, SetAmoProjectAssigneesMutationVariables>;
export const AmoProjectAssignableUsersDocument = gql`
    query amoProjectAssignableUsers {
  amoProjectAssignableUsers {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useAmoProjectAssignableUsersQuery__
 *
 * To run a query within a React component, call `useAmoProjectAssignableUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectAssignableUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectAssignableUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAmoProjectAssignableUsersQuery(baseOptions?: Apollo.QueryHookOptions<AmoProjectAssignableUsersQuery, AmoProjectAssignableUsersQueryVariables>) {
        return Apollo.useQuery<AmoProjectAssignableUsersQuery, AmoProjectAssignableUsersQueryVariables>(AmoProjectAssignableUsersDocument, baseOptions);
      }
export function useAmoProjectAssignableUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectAssignableUsersQuery, AmoProjectAssignableUsersQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectAssignableUsersQuery, AmoProjectAssignableUsersQueryVariables>(AmoProjectAssignableUsersDocument, baseOptions);
        }
export type AmoProjectAssignableUsersQueryHookResult = ReturnType<typeof useAmoProjectAssignableUsersQuery>;
export type AmoProjectAssignableUsersLazyQueryHookResult = ReturnType<typeof useAmoProjectAssignableUsersLazyQuery>;
export type AmoProjectAssignableUsersQueryResult = Apollo.QueryResult<AmoProjectAssignableUsersQuery, AmoProjectAssignableUsersQueryVariables>;
export const AmoProjectHistoryDocument = gql`
    query amoProjectHistory($amoProjectId: Int!) {
  amoProjectHistory(amoProjectId: $amoProjectId) {
    ...projectHistory
  }
}
    ${ProjectHistoryFragmentDoc}`;

/**
 * __useAmoProjectHistoryQuery__
 *
 * To run a query within a React component, call `useAmoProjectHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectHistoryQuery({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *   },
 * });
 */
export function useAmoProjectHistoryQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectHistoryQuery, AmoProjectHistoryQueryVariables>) {
        return Apollo.useQuery<AmoProjectHistoryQuery, AmoProjectHistoryQueryVariables>(AmoProjectHistoryDocument, baseOptions);
      }
export function useAmoProjectHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectHistoryQuery, AmoProjectHistoryQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectHistoryQuery, AmoProjectHistoryQueryVariables>(AmoProjectHistoryDocument, baseOptions);
        }
export type AmoProjectHistoryQueryHookResult = ReturnType<typeof useAmoProjectHistoryQuery>;
export type AmoProjectHistoryLazyQueryHookResult = ReturnType<typeof useAmoProjectHistoryLazyQuery>;
export type AmoProjectHistoryQueryResult = Apollo.QueryResult<AmoProjectHistoryQuery, AmoProjectHistoryQueryVariables>;
export const AmoProjectEmailHistoryDocument = gql`
    query amoProjectEmailHistory($amoProjectId: Int!, $sortBy: EmailHistorySortBy, $sortDirection: SortDirection) {
  amoProjectEmailHistory(amoProjectId: $amoProjectId, sortBy: $sortBy, sortDirection: $sortDirection) {
    ...emailHistory
  }
}
    ${EmailHistoryFragmentDoc}`;

/**
 * __useAmoProjectEmailHistoryQuery__
 *
 * To run a query within a React component, call `useAmoProjectEmailHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectEmailHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectEmailHistoryQuery({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useAmoProjectEmailHistoryQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectEmailHistoryQuery, AmoProjectEmailHistoryQueryVariables>) {
        return Apollo.useQuery<AmoProjectEmailHistoryQuery, AmoProjectEmailHistoryQueryVariables>(AmoProjectEmailHistoryDocument, baseOptions);
      }
export function useAmoProjectEmailHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectEmailHistoryQuery, AmoProjectEmailHistoryQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectEmailHistoryQuery, AmoProjectEmailHistoryQueryVariables>(AmoProjectEmailHistoryDocument, baseOptions);
        }
export type AmoProjectEmailHistoryQueryHookResult = ReturnType<typeof useAmoProjectEmailHistoryQuery>;
export type AmoProjectEmailHistoryLazyQueryHookResult = ReturnType<typeof useAmoProjectEmailHistoryLazyQuery>;
export type AmoProjectEmailHistoryQueryResult = Apollo.QueryResult<AmoProjectEmailHistoryQuery, AmoProjectEmailHistoryQueryVariables>;
export const AmoProjectEmailViewDocument = gql`
    query amoProjectEmailView($id: Int!, $emailId: Int!, $includeFileAttachments: Boolean = false, $includeFileContent: Boolean = false) {
  amoProject(id: $id) {
    emails(filter: {idIn: [$emailId]}) {
      ...email
    }
  }
}
    ${EmailFragmentDoc}`;

/**
 * __useAmoProjectEmailViewQuery__
 *
 * To run a query within a React component, call `useAmoProjectEmailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmoProjectEmailViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmoProjectEmailViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      emailId: // value for 'emailId'
 *      includeFileAttachments: // value for 'includeFileAttachments'
 *      includeFileContent: // value for 'includeFileContent'
 *   },
 * });
 */
export function useAmoProjectEmailViewQuery(baseOptions: Apollo.QueryHookOptions<AmoProjectEmailViewQuery, AmoProjectEmailViewQueryVariables>) {
        return Apollo.useQuery<AmoProjectEmailViewQuery, AmoProjectEmailViewQueryVariables>(AmoProjectEmailViewDocument, baseOptions);
      }
export function useAmoProjectEmailViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmoProjectEmailViewQuery, AmoProjectEmailViewQueryVariables>) {
          return Apollo.useLazyQuery<AmoProjectEmailViewQuery, AmoProjectEmailViewQueryVariables>(AmoProjectEmailViewDocument, baseOptions);
        }
export type AmoProjectEmailViewQueryHookResult = ReturnType<typeof useAmoProjectEmailViewQuery>;
export type AmoProjectEmailViewLazyQueryHookResult = ReturnType<typeof useAmoProjectEmailViewLazyQuery>;
export type AmoProjectEmailViewQueryResult = Apollo.QueryResult<AmoProjectEmailViewQuery, AmoProjectEmailViewQueryVariables>;
export const DownloadAmoProjectEmailAttachmentContentDocument = gql`
    query downloadAmoProjectEmailAttachmentContent($amoProjectId: Int!, $emailId: Int!, $attachmentId: Int!) {
  downloadAmoProjectEmailAttachmentContent(amoProjectId: $amoProjectId, emailId: $emailId, attachmentId: $attachmentId)
}
    `;

/**
 * __useDownloadAmoProjectEmailAttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadAmoProjectEmailAttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAmoProjectEmailAttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAmoProjectEmailAttachmentContentQuery({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *      emailId: // value for 'emailId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDownloadAmoProjectEmailAttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAmoProjectEmailAttachmentContentQuery, DownloadAmoProjectEmailAttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadAmoProjectEmailAttachmentContentQuery, DownloadAmoProjectEmailAttachmentContentQueryVariables>(DownloadAmoProjectEmailAttachmentContentDocument, baseOptions);
      }
export function useDownloadAmoProjectEmailAttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAmoProjectEmailAttachmentContentQuery, DownloadAmoProjectEmailAttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadAmoProjectEmailAttachmentContentQuery, DownloadAmoProjectEmailAttachmentContentQueryVariables>(DownloadAmoProjectEmailAttachmentContentDocument, baseOptions);
        }
export type DownloadAmoProjectEmailAttachmentContentQueryHookResult = ReturnType<typeof useDownloadAmoProjectEmailAttachmentContentQuery>;
export type DownloadAmoProjectEmailAttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadAmoProjectEmailAttachmentContentLazyQuery>;
export type DownloadAmoProjectEmailAttachmentContentQueryResult = Apollo.QueryResult<DownloadAmoProjectEmailAttachmentContentQuery, DownloadAmoProjectEmailAttachmentContentQueryVariables>;
export const SendAmoProjectEmailDocument = gql`
    mutation sendAmoProjectEmail($amoProjectId: Int!, $email: EmailInput!) {
  sendAmoProjectEmail(amoProjectId: $amoProjectId, email: $email) {
    id
  }
}
    `;
export type SendAmoProjectEmailMutationFn = Apollo.MutationFunction<SendAmoProjectEmailMutation, SendAmoProjectEmailMutationVariables>;

/**
 * __useSendAmoProjectEmailMutation__
 *
 * To run a mutation, you first call `useSendAmoProjectEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAmoProjectEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAmoProjectEmailMutation, { data, loading, error }] = useSendAmoProjectEmailMutation({
 *   variables: {
 *      amoProjectId: // value for 'amoProjectId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendAmoProjectEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendAmoProjectEmailMutation, SendAmoProjectEmailMutationVariables>) {
        return Apollo.useMutation<SendAmoProjectEmailMutation, SendAmoProjectEmailMutationVariables>(SendAmoProjectEmailDocument, baseOptions);
      }
export type SendAmoProjectEmailMutationHookResult = ReturnType<typeof useSendAmoProjectEmailMutation>;
export type SendAmoProjectEmailMutationResult = Apollo.MutationResult<SendAmoProjectEmailMutation>;
export type SendAmoProjectEmailMutationOptions = Apollo.BaseMutationOptions<SendAmoProjectEmailMutation, SendAmoProjectEmailMutationVariables>;
export const ArgDashboardAircraftReportDocument = gql`
    query argDashboardAircraftReport($hasCertificateOfAirworthinessExpirationDate: Boolean, $hasCertificateOfRegistrationExpirationDate: Boolean, $hascertificateOfInsuranceExpirationDate: Boolean, $hasLeaseAgreementExpirationDate: Boolean, $hasManagementAgreementExpirationDate: Boolean, $aircraftStatusIdIn: [Int!], $sortBy: AircraftsSortBy, $sortDirection: String, $paginationOptions: PaginationOptions) {
  aircrafts(hasCertificateOfAirworthinessExpirationDate: $hasCertificateOfAirworthinessExpirationDate, hasCertificateOfRegistrationExpirationDate: $hasCertificateOfRegistrationExpirationDate, hascertificateOfInsuranceExpirationDate: $hascertificateOfInsuranceExpirationDate, hasLeaseAgreementExpirationDate: $hasLeaseAgreementExpirationDate, hasManagementAgreementExpirationDate: $hasManagementAgreementExpirationDate, aircraftStatusIdIn: $aircraftStatusIdIn, sortBy: $sortBy, sortDirection: $sortDirection, paginationOptions: $paginationOptions) {
    ... on PaginatedAircrafts {
      totalItems
      aircrafts {
        ...argDashboardAircraftReportItem
      }
    }
    ... on Aircrafts {
      aircrafts {
        ...argDashboardAircraftReportItem
      }
    }
  }
}
    ${ArgDashboardAircraftReportItemFragmentDoc}`;

/**
 * __useArgDashboardAircraftReportQuery__
 *
 * To run a query within a React component, call `useArgDashboardAircraftReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useArgDashboardAircraftReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArgDashboardAircraftReportQuery({
 *   variables: {
 *      hasCertificateOfAirworthinessExpirationDate: // value for 'hasCertificateOfAirworthinessExpirationDate'
 *      hasCertificateOfRegistrationExpirationDate: // value for 'hasCertificateOfRegistrationExpirationDate'
 *      hascertificateOfInsuranceExpirationDate: // value for 'hascertificateOfInsuranceExpirationDate'
 *      hasLeaseAgreementExpirationDate: // value for 'hasLeaseAgreementExpirationDate'
 *      hasManagementAgreementExpirationDate: // value for 'hasManagementAgreementExpirationDate'
 *      aircraftStatusIdIn: // value for 'aircraftStatusIdIn'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useArgDashboardAircraftReportQuery(baseOptions?: Apollo.QueryHookOptions<ArgDashboardAircraftReportQuery, ArgDashboardAircraftReportQueryVariables>) {
        return Apollo.useQuery<ArgDashboardAircraftReportQuery, ArgDashboardAircraftReportQueryVariables>(ArgDashboardAircraftReportDocument, baseOptions);
      }
export function useArgDashboardAircraftReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArgDashboardAircraftReportQuery, ArgDashboardAircraftReportQueryVariables>) {
          return Apollo.useLazyQuery<ArgDashboardAircraftReportQuery, ArgDashboardAircraftReportQueryVariables>(ArgDashboardAircraftReportDocument, baseOptions);
        }
export type ArgDashboardAircraftReportQueryHookResult = ReturnType<typeof useArgDashboardAircraftReportQuery>;
export type ArgDashboardAircraftReportLazyQueryHookResult = ReturnType<typeof useArgDashboardAircraftReportLazyQuery>;
export type ArgDashboardAircraftReportQueryResult = Apollo.QueryResult<ArgDashboardAircraftReportQuery, ArgDashboardAircraftReportQueryVariables>;
export const ArgDashboardCrewMembersReportDocument = gql`
    query argDashboardCrewMembersReport($hasCertificationExpiryDate: Boolean, $sortBy: CrewMembersSortBy, $sortDirection: String, $paginationOptions: PaginationOptions) {
  crewMembers(hasCertificationExpiryDate: $hasCertificationExpiryDate, expiringWithinDays: 60, excludeRetired: true, sortBy: $sortBy, sortDirection: $sortDirection, paginationOptions: $paginationOptions) {
    ... on PaginatedCrewMembers {
      totalItems
      crewMembers {
        ...argDashboardCrewMembersReportItem
      }
    }
    ... on CrewMembers {
      crewMembers {
        ...argDashboardCrewMembersReportItem
      }
    }
  }
}
    ${ArgDashboardCrewMembersReportItemFragmentDoc}`;

/**
 * __useArgDashboardCrewMembersReportQuery__
 *
 * To run a query within a React component, call `useArgDashboardCrewMembersReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useArgDashboardCrewMembersReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArgDashboardCrewMembersReportQuery({
 *   variables: {
 *      hasCertificationExpiryDate: // value for 'hasCertificationExpiryDate'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useArgDashboardCrewMembersReportQuery(baseOptions?: Apollo.QueryHookOptions<ArgDashboardCrewMembersReportQuery, ArgDashboardCrewMembersReportQueryVariables>) {
        return Apollo.useQuery<ArgDashboardCrewMembersReportQuery, ArgDashboardCrewMembersReportQueryVariables>(ArgDashboardCrewMembersReportDocument, baseOptions);
      }
export function useArgDashboardCrewMembersReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArgDashboardCrewMembersReportQuery, ArgDashboardCrewMembersReportQueryVariables>) {
          return Apollo.useLazyQuery<ArgDashboardCrewMembersReportQuery, ArgDashboardCrewMembersReportQueryVariables>(ArgDashboardCrewMembersReportDocument, baseOptions);
        }
export type ArgDashboardCrewMembersReportQueryHookResult = ReturnType<typeof useArgDashboardCrewMembersReportQuery>;
export type ArgDashboardCrewMembersReportLazyQueryHookResult = ReturnType<typeof useArgDashboardCrewMembersReportLazyQuery>;
export type ArgDashboardCrewMembersReportQueryResult = Apollo.QueryResult<ArgDashboardCrewMembersReportQuery, ArgDashboardCrewMembersReportQueryVariables>;
export const ArgDashboardInspectorsReportDocument = gql`
    query argDashboardInspectorsReport($hasAppointmentLetterExpirationDate: Boolean, $sortBy: InspectorsSortBy, $sortDirection: String, $paginationOptions: PaginationOptions) {
  inspectors(hasAppointmentLetterExpirationDate: $hasAppointmentLetterExpirationDate, isActive: true, sortBy: $sortBy, sortDirection: $sortDirection, paginationOptions: $paginationOptions) {
    ... on PaginatedInspectors {
      totalItems
      inspectors {
        ...argDashboardInspectorsReportItem
      }
    }
    ... on Inspectors {
      inspectors {
        ...argDashboardInspectorsReportItem
      }
    }
  }
}
    ${ArgDashboardInspectorsReportItemFragmentDoc}`;

/**
 * __useArgDashboardInspectorsReportQuery__
 *
 * To run a query within a React component, call `useArgDashboardInspectorsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useArgDashboardInspectorsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArgDashboardInspectorsReportQuery({
 *   variables: {
 *      hasAppointmentLetterExpirationDate: // value for 'hasAppointmentLetterExpirationDate'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useArgDashboardInspectorsReportQuery(baseOptions?: Apollo.QueryHookOptions<ArgDashboardInspectorsReportQuery, ArgDashboardInspectorsReportQueryVariables>) {
        return Apollo.useQuery<ArgDashboardInspectorsReportQuery, ArgDashboardInspectorsReportQueryVariables>(ArgDashboardInspectorsReportDocument, baseOptions);
      }
export function useArgDashboardInspectorsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArgDashboardInspectorsReportQuery, ArgDashboardInspectorsReportQueryVariables>) {
          return Apollo.useLazyQuery<ArgDashboardInspectorsReportQuery, ArgDashboardInspectorsReportQueryVariables>(ArgDashboardInspectorsReportDocument, baseOptions);
        }
export type ArgDashboardInspectorsReportQueryHookResult = ReturnType<typeof useArgDashboardInspectorsReportQuery>;
export type ArgDashboardInspectorsReportLazyQueryHookResult = ReturnType<typeof useArgDashboardInspectorsReportLazyQuery>;
export type ArgDashboardInspectorsReportQueryResult = Apollo.QueryResult<ArgDashboardInspectorsReportQuery, ArgDashboardInspectorsReportQueryVariables>;
export const ArgDashboardMechanicsReportDocument = gql`
    query argDashboardMechanicsReport($hasCertificationExpiryDate: Boolean, $sortBy: MechanicsSortBy, $sortDirection: String, $paginationOptions: PaginationOptions) {
  mechanics(hasCertificationExpiryDate: $hasCertificationExpiryDate, excludeRetired: true, sortBy: $sortBy, sortDirection: $sortDirection, paginationOptions: $paginationOptions) {
    ... on PaginatedMechanics {
      totalItems
      mechanics {
        ...argDashboardMechanicsReportItem
      }
    }
    ... on Mechanics {
      mechanics {
        ...argDashboardMechanicsReportItem
      }
    }
  }
}
    ${ArgDashboardMechanicsReportItemFragmentDoc}`;

/**
 * __useArgDashboardMechanicsReportQuery__
 *
 * To run a query within a React component, call `useArgDashboardMechanicsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useArgDashboardMechanicsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArgDashboardMechanicsReportQuery({
 *   variables: {
 *      hasCertificationExpiryDate: // value for 'hasCertificationExpiryDate'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useArgDashboardMechanicsReportQuery(baseOptions?: Apollo.QueryHookOptions<ArgDashboardMechanicsReportQuery, ArgDashboardMechanicsReportQueryVariables>) {
        return Apollo.useQuery<ArgDashboardMechanicsReportQuery, ArgDashboardMechanicsReportQueryVariables>(ArgDashboardMechanicsReportDocument, baseOptions);
      }
export function useArgDashboardMechanicsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArgDashboardMechanicsReportQuery, ArgDashboardMechanicsReportQueryVariables>) {
          return Apollo.useLazyQuery<ArgDashboardMechanicsReportQuery, ArgDashboardMechanicsReportQueryVariables>(ArgDashboardMechanicsReportDocument, baseOptions);
        }
export type ArgDashboardMechanicsReportQueryHookResult = ReturnType<typeof useArgDashboardMechanicsReportQuery>;
export type ArgDashboardMechanicsReportLazyQueryHookResult = ReturnType<typeof useArgDashboardMechanicsReportLazyQuery>;
export type ArgDashboardMechanicsReportQueryResult = Apollo.QueryResult<ArgDashboardMechanicsReportQuery, ArgDashboardMechanicsReportQueryVariables>;
export const RemindersDocument = gql`
    query reminders($reminderApplicabilityIdIn: [Int!], $reminderDate: DateRangeFilterInput, $createdByUserIdIn: [Int!], $sortBy: RemindersSortBy, $sortDirection: String) {
  reminders(reminderApplicabilityIdIn: $reminderApplicabilityIdIn, reminderDate: $reminderDate, createdByUserIdIn: $createdByUserIdIn, sortBy: $sortBy, sortDirection: $sortDirection) {
    ...reminder
  }
}
    ${ReminderFragmentDoc}`;

/**
 * __useRemindersQuery__
 *
 * To run a query within a React component, call `useRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemindersQuery({
 *   variables: {
 *      reminderApplicabilityIdIn: // value for 'reminderApplicabilityIdIn'
 *      reminderDate: // value for 'reminderDate'
 *      createdByUserIdIn: // value for 'createdByUserIdIn'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useRemindersQuery(baseOptions?: Apollo.QueryHookOptions<RemindersQuery, RemindersQueryVariables>) {
        return Apollo.useQuery<RemindersQuery, RemindersQueryVariables>(RemindersDocument, baseOptions);
      }
export function useRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RemindersQuery, RemindersQueryVariables>) {
          return Apollo.useLazyQuery<RemindersQuery, RemindersQueryVariables>(RemindersDocument, baseOptions);
        }
export type RemindersQueryHookResult = ReturnType<typeof useRemindersQuery>;
export type RemindersLazyQueryHookResult = ReturnType<typeof useRemindersLazyQuery>;
export type RemindersQueryResult = Apollo.QueryResult<RemindersQuery, RemindersQueryVariables>;
export const AddReminderDocument = gql`
    mutation addReminder($input: ReminderInput!) {
  addReminder(input: $input) {
    ...reminder
  }
}
    ${ReminderFragmentDoc}`;
export type AddReminderMutationFn = Apollo.MutationFunction<AddReminderMutation, AddReminderMutationVariables>;

/**
 * __useAddReminderMutation__
 *
 * To run a mutation, you first call `useAddReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReminderMutation, { data, loading, error }] = useAddReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddReminderMutation(baseOptions?: Apollo.MutationHookOptions<AddReminderMutation, AddReminderMutationVariables>) {
        return Apollo.useMutation<AddReminderMutation, AddReminderMutationVariables>(AddReminderDocument, baseOptions);
      }
export type AddReminderMutationHookResult = ReturnType<typeof useAddReminderMutation>;
export type AddReminderMutationResult = Apollo.MutationResult<AddReminderMutation>;
export type AddReminderMutationOptions = Apollo.BaseMutationOptions<AddReminderMutation, AddReminderMutationVariables>;
export const UpdateReminderDocument = gql`
    mutation updateReminder($id: Int!, $input: ReminderInput!) {
  updateReminder(id: $id, input: $input) {
    ...reminder
  }
}
    ${ReminderFragmentDoc}`;
export type UpdateReminderMutationFn = Apollo.MutationFunction<UpdateReminderMutation, UpdateReminderMutationVariables>;

/**
 * __useUpdateReminderMutation__
 *
 * To run a mutation, you first call `useUpdateReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReminderMutation, { data, loading, error }] = useUpdateReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReminderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReminderMutation, UpdateReminderMutationVariables>) {
        return Apollo.useMutation<UpdateReminderMutation, UpdateReminderMutationVariables>(UpdateReminderDocument, baseOptions);
      }
export type UpdateReminderMutationHookResult = ReturnType<typeof useUpdateReminderMutation>;
export type UpdateReminderMutationResult = Apollo.MutationResult<UpdateReminderMutation>;
export type UpdateReminderMutationOptions = Apollo.BaseMutationOptions<UpdateReminderMutation, UpdateReminderMutationVariables>;
export const DeleteReminderDocument = gql`
    mutation deleteReminder($id: Int!) {
  deleteReminder(id: $id) {
    ...reminder
  }
}
    ${ReminderFragmentDoc}`;
export type DeleteReminderMutationFn = Apollo.MutationFunction<DeleteReminderMutation, DeleteReminderMutationVariables>;

/**
 * __useDeleteReminderMutation__
 *
 * To run a mutation, you first call `useDeleteReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReminderMutation, { data, loading, error }] = useDeleteReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReminderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReminderMutation, DeleteReminderMutationVariables>) {
        return Apollo.useMutation<DeleteReminderMutation, DeleteReminderMutationVariables>(DeleteReminderDocument, baseOptions);
      }
export type DeleteReminderMutationHookResult = ReturnType<typeof useDeleteReminderMutation>;
export type DeleteReminderMutationResult = Apollo.MutationResult<DeleteReminderMutation>;
export type DeleteReminderMutationOptions = Apollo.BaseMutationOptions<DeleteReminderMutation, DeleteReminderMutationVariables>;
export const DownloadCrewCertificateDocument = gql`
    query downloadCrewCertificate($identifier: String!) {
  downloadCrewCertificate(identifier: $identifier) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadCrewCertificateQuery__
 *
 * To run a query within a React component, call `useDownloadCrewCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCrewCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCrewCertificateQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useDownloadCrewCertificateQuery(baseOptions: Apollo.QueryHookOptions<DownloadCrewCertificateQuery, DownloadCrewCertificateQueryVariables>) {
        return Apollo.useQuery<DownloadCrewCertificateQuery, DownloadCrewCertificateQueryVariables>(DownloadCrewCertificateDocument, baseOptions);
      }
export function useDownloadCrewCertificateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCrewCertificateQuery, DownloadCrewCertificateQueryVariables>) {
          return Apollo.useLazyQuery<DownloadCrewCertificateQuery, DownloadCrewCertificateQueryVariables>(DownloadCrewCertificateDocument, baseOptions);
        }
export type DownloadCrewCertificateQueryHookResult = ReturnType<typeof useDownloadCrewCertificateQuery>;
export type DownloadCrewCertificateLazyQueryHookResult = ReturnType<typeof useDownloadCrewCertificateLazyQuery>;
export type DownloadCrewCertificateQueryResult = Apollo.QueryResult<DownloadCrewCertificateQuery, DownloadCrewCertificateQueryVariables>;
export const ValidateLegacyCrewCertificateOfValidationQrCodeDocument = gql`
    query validateLegacyCrewCertificateOfValidationQrCode($identifier: String!) {
  validateLegacyCrewCertificateOfValidationQrCode(identifier: $identifier) {
    ...crewCertificateValidationInfoV1
  }
}
    ${CrewCertificateValidationInfoV1FragmentDoc}`;

/**
 * __useValidateLegacyCrewCertificateOfValidationQrCodeQuery__
 *
 * To run a query within a React component, call `useValidateLegacyCrewCertificateOfValidationQrCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateLegacyCrewCertificateOfValidationQrCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateLegacyCrewCertificateOfValidationQrCodeQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useValidateLegacyCrewCertificateOfValidationQrCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidateLegacyCrewCertificateOfValidationQrCodeQuery, ValidateLegacyCrewCertificateOfValidationQrCodeQueryVariables>) {
        return Apollo.useQuery<ValidateLegacyCrewCertificateOfValidationQrCodeQuery, ValidateLegacyCrewCertificateOfValidationQrCodeQueryVariables>(ValidateLegacyCrewCertificateOfValidationQrCodeDocument, baseOptions);
      }
export function useValidateLegacyCrewCertificateOfValidationQrCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateLegacyCrewCertificateOfValidationQrCodeQuery, ValidateLegacyCrewCertificateOfValidationQrCodeQueryVariables>) {
          return Apollo.useLazyQuery<ValidateLegacyCrewCertificateOfValidationQrCodeQuery, ValidateLegacyCrewCertificateOfValidationQrCodeQueryVariables>(ValidateLegacyCrewCertificateOfValidationQrCodeDocument, baseOptions);
        }
export type ValidateLegacyCrewCertificateOfValidationQrCodeQueryHookResult = ReturnType<typeof useValidateLegacyCrewCertificateOfValidationQrCodeQuery>;
export type ValidateLegacyCrewCertificateOfValidationQrCodeLazyQueryHookResult = ReturnType<typeof useValidateLegacyCrewCertificateOfValidationQrCodeLazyQuery>;
export type ValidateLegacyCrewCertificateOfValidationQrCodeQueryResult = Apollo.QueryResult<ValidateLegacyCrewCertificateOfValidationQrCodeQuery, ValidateLegacyCrewCertificateOfValidationQrCodeQueryVariables>;
export const ValidateCrewCertificateOfValidationQrCodeV1Document = gql`
    query validateCrewCertificateOfValidationQrCodeV1($qrCodeUrlSearchParams: String!) {
  validateCrewCertificateOfValidationQrCodeV1(qrCodeUrlSearchParams: $qrCodeUrlSearchParams) {
    isQrCodeValid
    validationInfo {
      ...crewCertificateValidationInfoV1
    }
  }
}
    ${CrewCertificateValidationInfoV1FragmentDoc}`;

/**
 * __useValidateCrewCertificateOfValidationQrCodeV1Query__
 *
 * To run a query within a React component, call `useValidateCrewCertificateOfValidationQrCodeV1Query` and pass it any options that fit your needs.
 * When your component renders, `useValidateCrewCertificateOfValidationQrCodeV1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCrewCertificateOfValidationQrCodeV1Query({
 *   variables: {
 *      qrCodeUrlSearchParams: // value for 'qrCodeUrlSearchParams'
 *   },
 * });
 */
export function useValidateCrewCertificateOfValidationQrCodeV1Query(baseOptions: Apollo.QueryHookOptions<ValidateCrewCertificateOfValidationQrCodeV1Query, ValidateCrewCertificateOfValidationQrCodeV1QueryVariables>) {
        return Apollo.useQuery<ValidateCrewCertificateOfValidationQrCodeV1Query, ValidateCrewCertificateOfValidationQrCodeV1QueryVariables>(ValidateCrewCertificateOfValidationQrCodeV1Document, baseOptions);
      }
export function useValidateCrewCertificateOfValidationQrCodeV1LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCrewCertificateOfValidationQrCodeV1Query, ValidateCrewCertificateOfValidationQrCodeV1QueryVariables>) {
          return Apollo.useLazyQuery<ValidateCrewCertificateOfValidationQrCodeV1Query, ValidateCrewCertificateOfValidationQrCodeV1QueryVariables>(ValidateCrewCertificateOfValidationQrCodeV1Document, baseOptions);
        }
export type ValidateCrewCertificateOfValidationQrCodeV1QueryHookResult = ReturnType<typeof useValidateCrewCertificateOfValidationQrCodeV1Query>;
export type ValidateCrewCertificateOfValidationQrCodeV1LazyQueryHookResult = ReturnType<typeof useValidateCrewCertificateOfValidationQrCodeV1LazyQuery>;
export type ValidateCrewCertificateOfValidationQrCodeV1QueryResult = Apollo.QueryResult<ValidateCrewCertificateOfValidationQrCodeV1Query, ValidateCrewCertificateOfValidationQrCodeV1QueryVariables>;
export const ValidateCrewCertificateOfValidationQrCodeV2Document = gql`
    query validateCrewCertificateOfValidationQrCodeV2($qrCodeUrlSearchParams: String!) {
  validateCrewCertificateOfValidationQrCodeV2(qrCodeUrlSearchParams: $qrCodeUrlSearchParams) {
    isQrCodeValid
    validationInfo {
      ...crewCertificateValidationInfoV2
    }
  }
}
    ${CrewCertificateValidationInfoV2FragmentDoc}`;

/**
 * __useValidateCrewCertificateOfValidationQrCodeV2Query__
 *
 * To run a query within a React component, call `useValidateCrewCertificateOfValidationQrCodeV2Query` and pass it any options that fit your needs.
 * When your component renders, `useValidateCrewCertificateOfValidationQrCodeV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCrewCertificateOfValidationQrCodeV2Query({
 *   variables: {
 *      qrCodeUrlSearchParams: // value for 'qrCodeUrlSearchParams'
 *   },
 * });
 */
export function useValidateCrewCertificateOfValidationQrCodeV2Query(baseOptions: Apollo.QueryHookOptions<ValidateCrewCertificateOfValidationQrCodeV2Query, ValidateCrewCertificateOfValidationQrCodeV2QueryVariables>) {
        return Apollo.useQuery<ValidateCrewCertificateOfValidationQrCodeV2Query, ValidateCrewCertificateOfValidationQrCodeV2QueryVariables>(ValidateCrewCertificateOfValidationQrCodeV2Document, baseOptions);
      }
export function useValidateCrewCertificateOfValidationQrCodeV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCrewCertificateOfValidationQrCodeV2Query, ValidateCrewCertificateOfValidationQrCodeV2QueryVariables>) {
          return Apollo.useLazyQuery<ValidateCrewCertificateOfValidationQrCodeV2Query, ValidateCrewCertificateOfValidationQrCodeV2QueryVariables>(ValidateCrewCertificateOfValidationQrCodeV2Document, baseOptions);
        }
export type ValidateCrewCertificateOfValidationQrCodeV2QueryHookResult = ReturnType<typeof useValidateCrewCertificateOfValidationQrCodeV2Query>;
export type ValidateCrewCertificateOfValidationQrCodeV2LazyQueryHookResult = ReturnType<typeof useValidateCrewCertificateOfValidationQrCodeV2LazyQuery>;
export type ValidateCrewCertificateOfValidationQrCodeV2QueryResult = Apollo.QueryResult<ValidateCrewCertificateOfValidationQrCodeV2Query, ValidateCrewCertificateOfValidationQrCodeV2QueryVariables>;
export const DownloadMechanicCertificateDocument = gql`
    query downloadMechanicCertificate($identifier: String!) {
  downloadMechanicCertificate(identifier: $identifier) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadMechanicCertificateQuery__
 *
 * To run a query within a React component, call `useDownloadMechanicCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadMechanicCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadMechanicCertificateQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useDownloadMechanicCertificateQuery(baseOptions: Apollo.QueryHookOptions<DownloadMechanicCertificateQuery, DownloadMechanicCertificateQueryVariables>) {
        return Apollo.useQuery<DownloadMechanicCertificateQuery, DownloadMechanicCertificateQueryVariables>(DownloadMechanicCertificateDocument, baseOptions);
      }
export function useDownloadMechanicCertificateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadMechanicCertificateQuery, DownloadMechanicCertificateQueryVariables>) {
          return Apollo.useLazyQuery<DownloadMechanicCertificateQuery, DownloadMechanicCertificateQueryVariables>(DownloadMechanicCertificateDocument, baseOptions);
        }
export type DownloadMechanicCertificateQueryHookResult = ReturnType<typeof useDownloadMechanicCertificateQuery>;
export type DownloadMechanicCertificateLazyQueryHookResult = ReturnType<typeof useDownloadMechanicCertificateLazyQuery>;
export type DownloadMechanicCertificateQueryResult = Apollo.QueryResult<DownloadMechanicCertificateQuery, DownloadMechanicCertificateQueryVariables>;
export const ValidateMechanicCertificateOfValidationQrCodeV1Document = gql`
    query validateMechanicCertificateOfValidationQrCodeV1($qrCodeUrlSearchParams: String!) {
  validateMechanicCertificateOfValidationQrCodeV1(qrCodeUrlSearchParams: $qrCodeUrlSearchParams) {
    isQrCodeValid
    validationInfo {
      ...mechanicCertificateValidationInfoV1
    }
  }
}
    ${MechanicCertificateValidationInfoV1FragmentDoc}`;

/**
 * __useValidateMechanicCertificateOfValidationQrCodeV1Query__
 *
 * To run a query within a React component, call `useValidateMechanicCertificateOfValidationQrCodeV1Query` and pass it any options that fit your needs.
 * When your component renders, `useValidateMechanicCertificateOfValidationQrCodeV1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateMechanicCertificateOfValidationQrCodeV1Query({
 *   variables: {
 *      qrCodeUrlSearchParams: // value for 'qrCodeUrlSearchParams'
 *   },
 * });
 */
export function useValidateMechanicCertificateOfValidationQrCodeV1Query(baseOptions: Apollo.QueryHookOptions<ValidateMechanicCertificateOfValidationQrCodeV1Query, ValidateMechanicCertificateOfValidationQrCodeV1QueryVariables>) {
        return Apollo.useQuery<ValidateMechanicCertificateOfValidationQrCodeV1Query, ValidateMechanicCertificateOfValidationQrCodeV1QueryVariables>(ValidateMechanicCertificateOfValidationQrCodeV1Document, baseOptions);
      }
export function useValidateMechanicCertificateOfValidationQrCodeV1LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateMechanicCertificateOfValidationQrCodeV1Query, ValidateMechanicCertificateOfValidationQrCodeV1QueryVariables>) {
          return Apollo.useLazyQuery<ValidateMechanicCertificateOfValidationQrCodeV1Query, ValidateMechanicCertificateOfValidationQrCodeV1QueryVariables>(ValidateMechanicCertificateOfValidationQrCodeV1Document, baseOptions);
        }
export type ValidateMechanicCertificateOfValidationQrCodeV1QueryHookResult = ReturnType<typeof useValidateMechanicCertificateOfValidationQrCodeV1Query>;
export type ValidateMechanicCertificateOfValidationQrCodeV1LazyQueryHookResult = ReturnType<typeof useValidateMechanicCertificateOfValidationQrCodeV1LazyQuery>;
export type ValidateMechanicCertificateOfValidationQrCodeV1QueryResult = Apollo.QueryResult<ValidateMechanicCertificateOfValidationQrCodeV1Query, ValidateMechanicCertificateOfValidationQrCodeV1QueryVariables>;
export const CrewMemberGridFilterLookupsQueryDocument = gql`
    query crewMemberGridFilterLookupsQuery {
  countries {
    ...crewMemberCountry
  }
  crewRatings {
    ...crewRating
  }
  operators {
    ... on Operators {
      operators {
        ...crewMemberOperator
      }
    }
  }
}
    ${CrewMemberCountryFragmentDoc}
${CrewRatingFragmentDoc}
${CrewMemberOperatorFragmentDoc}`;

/**
 * __useCrewMemberGridFilterLookupsQueryQuery__
 *
 * To run a query within a React component, call `useCrewMemberGridFilterLookupsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewMemberGridFilterLookupsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewMemberGridFilterLookupsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrewMemberGridFilterLookupsQueryQuery(baseOptions?: Apollo.QueryHookOptions<CrewMemberGridFilterLookupsQueryQuery, CrewMemberGridFilterLookupsQueryQueryVariables>) {
        return Apollo.useQuery<CrewMemberGridFilterLookupsQueryQuery, CrewMemberGridFilterLookupsQueryQueryVariables>(CrewMemberGridFilterLookupsQueryDocument, baseOptions);
      }
export function useCrewMemberGridFilterLookupsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewMemberGridFilterLookupsQueryQuery, CrewMemberGridFilterLookupsQueryQueryVariables>) {
          return Apollo.useLazyQuery<CrewMemberGridFilterLookupsQueryQuery, CrewMemberGridFilterLookupsQueryQueryVariables>(CrewMemberGridFilterLookupsQueryDocument, baseOptions);
        }
export type CrewMemberGridFilterLookupsQueryQueryHookResult = ReturnType<typeof useCrewMemberGridFilterLookupsQueryQuery>;
export type CrewMemberGridFilterLookupsQueryLazyQueryHookResult = ReturnType<typeof useCrewMemberGridFilterLookupsQueryLazyQuery>;
export type CrewMemberGridFilterLookupsQueryQueryResult = Apollo.QueryResult<CrewMemberGridFilterLookupsQueryQuery, CrewMemberGridFilterLookupsQueryQueryVariables>;
export const CrewMemberGridDocument = gql`
    query crewMemberGrid($sortBy: CrewMembersSortBy, $sortDirection: String, $lastNameContains: String, $crewMemberStatusId: Int, $licenseCountryIdIn: [Int!], $crewRatingIdIn: [Int!], $operatorIdIn: [Int!], $aircraftIdIn: [Int!], $keyword: String, $paginationOptions: PaginationOptions) {
  crewMembers(sortBy: $sortBy, sortDirection: $sortDirection, lastNameContains: $lastNameContains, crewMemberStatusId: $crewMemberStatusId, licenseCountryIdIn: $licenseCountryIdIn, crewRatingIdIn: $crewRatingIdIn, operatorIdIn: $operatorIdIn, aircraftIdIn: $aircraftIdIn, keyword: $keyword, paginationOptions: $paginationOptions) {
    ... on PaginatedCrewMembers {
      totalItems
      crewMembers {
        ...crewMemberGridItem
      }
    }
    ... on CrewMembers {
      crewMembers {
        ...crewMemberGridItem
      }
    }
  }
}
    ${CrewMemberGridItemFragmentDoc}`;

/**
 * __useCrewMemberGridQuery__
 *
 * To run a query within a React component, call `useCrewMemberGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewMemberGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewMemberGridQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      lastNameContains: // value for 'lastNameContains'
 *      crewMemberStatusId: // value for 'crewMemberStatusId'
 *      licenseCountryIdIn: // value for 'licenseCountryIdIn'
 *      crewRatingIdIn: // value for 'crewRatingIdIn'
 *      operatorIdIn: // value for 'operatorIdIn'
 *      aircraftIdIn: // value for 'aircraftIdIn'
 *      keyword: // value for 'keyword'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useCrewMemberGridQuery(baseOptions?: Apollo.QueryHookOptions<CrewMemberGridQuery, CrewMemberGridQueryVariables>) {
        return Apollo.useQuery<CrewMemberGridQuery, CrewMemberGridQueryVariables>(CrewMemberGridDocument, baseOptions);
      }
export function useCrewMemberGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewMemberGridQuery, CrewMemberGridQueryVariables>) {
          return Apollo.useLazyQuery<CrewMemberGridQuery, CrewMemberGridQueryVariables>(CrewMemberGridDocument, baseOptions);
        }
export type CrewMemberGridQueryHookResult = ReturnType<typeof useCrewMemberGridQuery>;
export type CrewMemberGridLazyQueryHookResult = ReturnType<typeof useCrewMemberGridLazyQuery>;
export type CrewMemberGridQueryResult = Apollo.QueryResult<CrewMemberGridQuery, CrewMemberGridQueryVariables>;
export const CrewMemberPageQueryDocument = gql`
    query crewMemberPageQuery($id: Int!) {
  crewMember(id: $id) {
    id
    firstName
    lastName
    crewMemberStatus {
      id
    }
    crewPosition {
      id
    }
    country {
      id
    }
    crewLicenseType {
      id
    }
    licenseNumber
    elpLevel {
      id
    }
    elpExpiryDate
    operators {
      ...crewMemberOperator
    }
    validationNumber
    employmentCompanies {
      ...crewMemberEmploymentCompany
    }
    crewRatings {
      ...crewRating
    }
    aircrafts {
      ...crewMemberAircraft
    }
    genericLvCompanies {
      ...crewMemberGenericLvCompany
    }
    aircraftModels {
      ...aircraftModel
    }
    certificateDateOfFirstIssue
    certificateIssuedDate
    certificateExpiryDate
    hasActiveProjects
  }
  employmentCompanies(includeDeleted: true) {
    ...crewMemberEmploymentCompany
  }
  operators(includeInactive: true, includeDeleted: true) {
    ... on Operators {
      operators {
        ...crewMemberOperator
      }
    }
  }
  aircrafts {
    ... on Aircrafts {
      aircrafts {
        ...crewMemberAircraft
      }
    }
  }
}
    ${CrewMemberOperatorFragmentDoc}
${CrewMemberEmploymentCompanyFragmentDoc}
${CrewRatingFragmentDoc}
${CrewMemberAircraftFragmentDoc}
${CrewMemberGenericLvCompanyFragmentDoc}
${AircraftModelFragmentDoc}`;

/**
 * __useCrewMemberPageQueryQuery__
 *
 * To run a query within a React component, call `useCrewMemberPageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewMemberPageQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewMemberPageQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCrewMemberPageQueryQuery(baseOptions: Apollo.QueryHookOptions<CrewMemberPageQueryQuery, CrewMemberPageQueryQueryVariables>) {
        return Apollo.useQuery<CrewMemberPageQueryQuery, CrewMemberPageQueryQueryVariables>(CrewMemberPageQueryDocument, baseOptions);
      }
export function useCrewMemberPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewMemberPageQueryQuery, CrewMemberPageQueryQueryVariables>) {
          return Apollo.useLazyQuery<CrewMemberPageQueryQuery, CrewMemberPageQueryQueryVariables>(CrewMemberPageQueryDocument, baseOptions);
        }
export type CrewMemberPageQueryQueryHookResult = ReturnType<typeof useCrewMemberPageQueryQuery>;
export type CrewMemberPageQueryLazyQueryHookResult = ReturnType<typeof useCrewMemberPageQueryLazyQuery>;
export type CrewMemberPageQueryQueryResult = Apollo.QueryResult<CrewMemberPageQueryQuery, CrewMemberPageQueryQueryVariables>;
export const CrewMemberPageDateOfFirstIssueQueryDocument = gql`
    query crewMemberPageDateOfFirstIssueQuery($id: Int!) {
  crewMember(id: $id) {
    crewMemberStatus {
      id
    }
    certificateDateOfFirstIssue
  }
}
    `;

/**
 * __useCrewMemberPageDateOfFirstIssueQueryQuery__
 *
 * To run a query within a React component, call `useCrewMemberPageDateOfFirstIssueQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewMemberPageDateOfFirstIssueQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewMemberPageDateOfFirstIssueQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCrewMemberPageDateOfFirstIssueQueryQuery(baseOptions: Apollo.QueryHookOptions<CrewMemberPageDateOfFirstIssueQueryQuery, CrewMemberPageDateOfFirstIssueQueryQueryVariables>) {
        return Apollo.useQuery<CrewMemberPageDateOfFirstIssueQueryQuery, CrewMemberPageDateOfFirstIssueQueryQueryVariables>(CrewMemberPageDateOfFirstIssueQueryDocument, baseOptions);
      }
export function useCrewMemberPageDateOfFirstIssueQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewMemberPageDateOfFirstIssueQueryQuery, CrewMemberPageDateOfFirstIssueQueryQueryVariables>) {
          return Apollo.useLazyQuery<CrewMemberPageDateOfFirstIssueQueryQuery, CrewMemberPageDateOfFirstIssueQueryQueryVariables>(CrewMemberPageDateOfFirstIssueQueryDocument, baseOptions);
        }
export type CrewMemberPageDateOfFirstIssueQueryQueryHookResult = ReturnType<typeof useCrewMemberPageDateOfFirstIssueQueryQuery>;
export type CrewMemberPageDateOfFirstIssueQueryLazyQueryHookResult = ReturnType<typeof useCrewMemberPageDateOfFirstIssueQueryLazyQuery>;
export type CrewMemberPageDateOfFirstIssueQueryQueryResult = Apollo.QueryResult<CrewMemberPageDateOfFirstIssueQueryQuery, CrewMemberPageDateOfFirstIssueQueryQueryVariables>;
export const UpdateCrewMemberMutationDocument = gql`
    mutation updateCrewMemberMutation($updateCrewMemberInput: UpdateCrewMemberInput!) {
  updateCrewMember(updateCrewMemberInput: $updateCrewMemberInput) {
    id
  }
}
    `;
export type UpdateCrewMemberMutationMutationFn = Apollo.MutationFunction<UpdateCrewMemberMutationMutation, UpdateCrewMemberMutationMutationVariables>;

/**
 * __useUpdateCrewMemberMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCrewMemberMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewMemberMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewMemberMutationMutation, { data, loading, error }] = useUpdateCrewMemberMutationMutation({
 *   variables: {
 *      updateCrewMemberInput: // value for 'updateCrewMemberInput'
 *   },
 * });
 */
export function useUpdateCrewMemberMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewMemberMutationMutation, UpdateCrewMemberMutationMutationVariables>) {
        return Apollo.useMutation<UpdateCrewMemberMutationMutation, UpdateCrewMemberMutationMutationVariables>(UpdateCrewMemberMutationDocument, baseOptions);
      }
export type UpdateCrewMemberMutationMutationHookResult = ReturnType<typeof useUpdateCrewMemberMutationMutation>;
export type UpdateCrewMemberMutationMutationResult = Apollo.MutationResult<UpdateCrewMemberMutationMutation>;
export type UpdateCrewMemberMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCrewMemberMutationMutation, UpdateCrewMemberMutationMutationVariables>;
export const CrewMemberCommentsDocument = gql`
    query crewMemberComments($id: Int!) {
  crewMemberComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useCrewMemberCommentsQuery__
 *
 * To run a query within a React component, call `useCrewMemberCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewMemberCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewMemberCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCrewMemberCommentsQuery(baseOptions: Apollo.QueryHookOptions<CrewMemberCommentsQuery, CrewMemberCommentsQueryVariables>) {
        return Apollo.useQuery<CrewMemberCommentsQuery, CrewMemberCommentsQueryVariables>(CrewMemberCommentsDocument, baseOptions);
      }
export function useCrewMemberCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewMemberCommentsQuery, CrewMemberCommentsQueryVariables>) {
          return Apollo.useLazyQuery<CrewMemberCommentsQuery, CrewMemberCommentsQueryVariables>(CrewMemberCommentsDocument, baseOptions);
        }
export type CrewMemberCommentsQueryHookResult = ReturnType<typeof useCrewMemberCommentsQuery>;
export type CrewMemberCommentsLazyQueryHookResult = ReturnType<typeof useCrewMemberCommentsLazyQuery>;
export type CrewMemberCommentsQueryResult = Apollo.QueryResult<CrewMemberCommentsQuery, CrewMemberCommentsQueryVariables>;
export const AddCrewMemberCommentDocument = gql`
    mutation addCrewMemberComment($id: Int!, $input: CommentInput!) {
  addCrewMemberComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddCrewMemberCommentMutationFn = Apollo.MutationFunction<AddCrewMemberCommentMutation, AddCrewMemberCommentMutationVariables>;

/**
 * __useAddCrewMemberCommentMutation__
 *
 * To run a mutation, you first call `useAddCrewMemberCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCrewMemberCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCrewMemberCommentMutation, { data, loading, error }] = useAddCrewMemberCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCrewMemberCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCrewMemberCommentMutation, AddCrewMemberCommentMutationVariables>) {
        return Apollo.useMutation<AddCrewMemberCommentMutation, AddCrewMemberCommentMutationVariables>(AddCrewMemberCommentDocument, baseOptions);
      }
export type AddCrewMemberCommentMutationHookResult = ReturnType<typeof useAddCrewMemberCommentMutation>;
export type AddCrewMemberCommentMutationResult = Apollo.MutationResult<AddCrewMemberCommentMutation>;
export type AddCrewMemberCommentMutationOptions = Apollo.BaseMutationOptions<AddCrewMemberCommentMutation, AddCrewMemberCommentMutationVariables>;
export const UpdateCrewMemberCommentDocument = gql`
    mutation updateCrewMemberComment($id: Int!, $body: String!) {
  updateCrewMemberComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateCrewMemberCommentMutationFn = Apollo.MutationFunction<UpdateCrewMemberCommentMutation, UpdateCrewMemberCommentMutationVariables>;

/**
 * __useUpdateCrewMemberCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCrewMemberCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewMemberCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewMemberCommentMutation, { data, loading, error }] = useUpdateCrewMemberCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateCrewMemberCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewMemberCommentMutation, UpdateCrewMemberCommentMutationVariables>) {
        return Apollo.useMutation<UpdateCrewMemberCommentMutation, UpdateCrewMemberCommentMutationVariables>(UpdateCrewMemberCommentDocument, baseOptions);
      }
export type UpdateCrewMemberCommentMutationHookResult = ReturnType<typeof useUpdateCrewMemberCommentMutation>;
export type UpdateCrewMemberCommentMutationResult = Apollo.MutationResult<UpdateCrewMemberCommentMutation>;
export type UpdateCrewMemberCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCrewMemberCommentMutation, UpdateCrewMemberCommentMutationVariables>;
export const UpdateCrewMemberCommentsLastViewedDateDocument = gql`
    mutation updateCrewMemberCommentsLastViewedDate($id: Int!) {
  updateCrewMemberCommentsLastViewedDate(crewMemberId: $id) {
    id
  }
}
    `;
export type UpdateCrewMemberCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateCrewMemberCommentsLastViewedDateMutation, UpdateCrewMemberCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateCrewMemberCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateCrewMemberCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewMemberCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewMemberCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateCrewMemberCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCrewMemberCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewMemberCommentsLastViewedDateMutation, UpdateCrewMemberCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateCrewMemberCommentsLastViewedDateMutation, UpdateCrewMemberCommentsLastViewedDateMutationVariables>(UpdateCrewMemberCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateCrewMemberCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateCrewMemberCommentsLastViewedDateMutation>;
export type UpdateCrewMemberCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateCrewMemberCommentsLastViewedDateMutation>;
export type UpdateCrewMemberCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateCrewMemberCommentsLastViewedDateMutation, UpdateCrewMemberCommentsLastViewedDateMutationVariables>;
export const CrewMemberDocumentsQueryDocument = gql`
    query crewMemberDocumentsQuery($crewMemberId: Int!, $documentTypeCategoryId: DocumentTypeCategoryEnum!) {
  crewMember(id: $crewMemberId) {
    certificateDateOfFirstIssue
  }
  documents: crewMemberDocuments(crewMemberId: $crewMemberId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...crewMemberDocument
  }
  documentTypes: crewMemberDocumentTypes(crewMemberId: $crewMemberId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...documentType
  }
}
    ${CrewMemberDocumentFragmentDoc}
${DocumentTypeFragmentDoc}`;

/**
 * __useCrewMemberDocumentsQueryQuery__
 *
 * To run a query within a React component, call `useCrewMemberDocumentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewMemberDocumentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewMemberDocumentsQueryQuery({
 *   variables: {
 *      crewMemberId: // value for 'crewMemberId'
 *      documentTypeCategoryId: // value for 'documentTypeCategoryId'
 *   },
 * });
 */
export function useCrewMemberDocumentsQueryQuery(baseOptions: Apollo.QueryHookOptions<CrewMemberDocumentsQueryQuery, CrewMemberDocumentsQueryQueryVariables>) {
        return Apollo.useQuery<CrewMemberDocumentsQueryQuery, CrewMemberDocumentsQueryQueryVariables>(CrewMemberDocumentsQueryDocument, baseOptions);
      }
export function useCrewMemberDocumentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewMemberDocumentsQueryQuery, CrewMemberDocumentsQueryQueryVariables>) {
          return Apollo.useLazyQuery<CrewMemberDocumentsQueryQuery, CrewMemberDocumentsQueryQueryVariables>(CrewMemberDocumentsQueryDocument, baseOptions);
        }
export type CrewMemberDocumentsQueryQueryHookResult = ReturnType<typeof useCrewMemberDocumentsQueryQuery>;
export type CrewMemberDocumentsQueryLazyQueryHookResult = ReturnType<typeof useCrewMemberDocumentsQueryLazyQuery>;
export type CrewMemberDocumentsQueryQueryResult = Apollo.QueryResult<CrewMemberDocumentsQueryQuery, CrewMemberDocumentsQueryQueryVariables>;
export const AddCrewMemberDocumentMutationDocument = gql`
    mutation addCrewMemberDocumentMutation($addCrewMemberDocumentInput: AddCrewMemberDocumentInput!) {
  addCrewMemberDocument(addCrewMemberDocumentInput: $addCrewMemberDocumentInput) {
    id
  }
}
    `;
export type AddCrewMemberDocumentMutationMutationFn = Apollo.MutationFunction<AddCrewMemberDocumentMutationMutation, AddCrewMemberDocumentMutationMutationVariables>;

/**
 * __useAddCrewMemberDocumentMutationMutation__
 *
 * To run a mutation, you first call `useAddCrewMemberDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCrewMemberDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCrewMemberDocumentMutationMutation, { data, loading, error }] = useAddCrewMemberDocumentMutationMutation({
 *   variables: {
 *      addCrewMemberDocumentInput: // value for 'addCrewMemberDocumentInput'
 *   },
 * });
 */
export function useAddCrewMemberDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddCrewMemberDocumentMutationMutation, AddCrewMemberDocumentMutationMutationVariables>) {
        return Apollo.useMutation<AddCrewMemberDocumentMutationMutation, AddCrewMemberDocumentMutationMutationVariables>(AddCrewMemberDocumentMutationDocument, baseOptions);
      }
export type AddCrewMemberDocumentMutationMutationHookResult = ReturnType<typeof useAddCrewMemberDocumentMutationMutation>;
export type AddCrewMemberDocumentMutationMutationResult = Apollo.MutationResult<AddCrewMemberDocumentMutationMutation>;
export type AddCrewMemberDocumentMutationMutationOptions = Apollo.BaseMutationOptions<AddCrewMemberDocumentMutationMutation, AddCrewMemberDocumentMutationMutationVariables>;
export const UpdateCrewMemberDocumentMutationDocument = gql`
    mutation updateCrewMemberDocumentMutation($updateCrewMemberDocumentInput: UpdateCrewMemberDocumentInput!) {
  updateCrewMemberDocument(updateCrewMemberDocumentInput: $updateCrewMemberDocumentInput) {
    id
  }
}
    `;
export type UpdateCrewMemberDocumentMutationMutationFn = Apollo.MutationFunction<UpdateCrewMemberDocumentMutationMutation, UpdateCrewMemberDocumentMutationMutationVariables>;

/**
 * __useUpdateCrewMemberDocumentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCrewMemberDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewMemberDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewMemberDocumentMutationMutation, { data, loading, error }] = useUpdateCrewMemberDocumentMutationMutation({
 *   variables: {
 *      updateCrewMemberDocumentInput: // value for 'updateCrewMemberDocumentInput'
 *   },
 * });
 */
export function useUpdateCrewMemberDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewMemberDocumentMutationMutation, UpdateCrewMemberDocumentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateCrewMemberDocumentMutationMutation, UpdateCrewMemberDocumentMutationMutationVariables>(UpdateCrewMemberDocumentMutationDocument, baseOptions);
      }
export type UpdateCrewMemberDocumentMutationMutationHookResult = ReturnType<typeof useUpdateCrewMemberDocumentMutationMutation>;
export type UpdateCrewMemberDocumentMutationMutationResult = Apollo.MutationResult<UpdateCrewMemberDocumentMutationMutation>;
export type UpdateCrewMemberDocumentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCrewMemberDocumentMutationMutation, UpdateCrewMemberDocumentMutationMutationVariables>;
export const RemoveCrewMemberDocumentMutationDocument = gql`
    mutation removeCrewMemberDocumentMutation($id: Int!) {
  removeCrewMemberDocument(id: $id)
}
    `;
export type RemoveCrewMemberDocumentMutationMutationFn = Apollo.MutationFunction<RemoveCrewMemberDocumentMutationMutation, RemoveCrewMemberDocumentMutationMutationVariables>;

/**
 * __useRemoveCrewMemberDocumentMutationMutation__
 *
 * To run a mutation, you first call `useRemoveCrewMemberDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCrewMemberDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCrewMemberDocumentMutationMutation, { data, loading, error }] = useRemoveCrewMemberDocumentMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCrewMemberDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCrewMemberDocumentMutationMutation, RemoveCrewMemberDocumentMutationMutationVariables>) {
        return Apollo.useMutation<RemoveCrewMemberDocumentMutationMutation, RemoveCrewMemberDocumentMutationMutationVariables>(RemoveCrewMemberDocumentMutationDocument, baseOptions);
      }
export type RemoveCrewMemberDocumentMutationMutationHookResult = ReturnType<typeof useRemoveCrewMemberDocumentMutationMutation>;
export type RemoveCrewMemberDocumentMutationMutationResult = Apollo.MutationResult<RemoveCrewMemberDocumentMutationMutation>;
export type RemoveCrewMemberDocumentMutationMutationOptions = Apollo.BaseMutationOptions<RemoveCrewMemberDocumentMutationMutation, RemoveCrewMemberDocumentMutationMutationVariables>;
export const DownloadCrewMemberDocumentDocument = gql`
    query downloadCrewMemberDocument($id: Int!) {
  file: downloadCrewMemberDocument(id: $id) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadCrewMemberDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadCrewMemberDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCrewMemberDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCrewMemberDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadCrewMemberDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadCrewMemberDocumentQuery, DownloadCrewMemberDocumentQueryVariables>) {
        return Apollo.useQuery<DownloadCrewMemberDocumentQuery, DownloadCrewMemberDocumentQueryVariables>(DownloadCrewMemberDocumentDocument, baseOptions);
      }
export function useDownloadCrewMemberDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCrewMemberDocumentQuery, DownloadCrewMemberDocumentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadCrewMemberDocumentQuery, DownloadCrewMemberDocumentQueryVariables>(DownloadCrewMemberDocumentDocument, baseOptions);
        }
export type DownloadCrewMemberDocumentQueryHookResult = ReturnType<typeof useDownloadCrewMemberDocumentQuery>;
export type DownloadCrewMemberDocumentLazyQueryHookResult = ReturnType<typeof useDownloadCrewMemberDocumentLazyQuery>;
export type DownloadCrewMemberDocumentQueryResult = Apollo.QueryResult<DownloadCrewMemberDocumentQuery, DownloadCrewMemberDocumentQueryVariables>;
export const AddCrewMemberMutationDocument = gql`
    mutation addCrewMemberMutation($addCrewMemberInput: AddCrewMemberInput!) {
  addCrewMember(addCrewMemberInput: $addCrewMemberInput) {
    id
  }
}
    `;
export type AddCrewMemberMutationMutationFn = Apollo.MutationFunction<AddCrewMemberMutationMutation, AddCrewMemberMutationMutationVariables>;

/**
 * __useAddCrewMemberMutationMutation__
 *
 * To run a mutation, you first call `useAddCrewMemberMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCrewMemberMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCrewMemberMutationMutation, { data, loading, error }] = useAddCrewMemberMutationMutation({
 *   variables: {
 *      addCrewMemberInput: // value for 'addCrewMemberInput'
 *   },
 * });
 */
export function useAddCrewMemberMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddCrewMemberMutationMutation, AddCrewMemberMutationMutationVariables>) {
        return Apollo.useMutation<AddCrewMemberMutationMutation, AddCrewMemberMutationMutationVariables>(AddCrewMemberMutationDocument, baseOptions);
      }
export type AddCrewMemberMutationMutationHookResult = ReturnType<typeof useAddCrewMemberMutationMutation>;
export type AddCrewMemberMutationMutationResult = Apollo.MutationResult<AddCrewMemberMutationMutation>;
export type AddCrewMemberMutationMutationOptions = Apollo.BaseMutationOptions<AddCrewMemberMutationMutation, AddCrewMemberMutationMutationVariables>;
export const BulkUpdateCrewMemberStatusDocument = gql`
    mutation bulkUpdateCrewMemberStatus($crewMemberIds: [Int!]!, $crewMemberStatusId: Int!) {
  bulkUpdateCrewMemberStatus(input: {crewMemberIds: $crewMemberIds, crewMemberStatusId: $crewMemberStatusId}) {
    updatedCount
    skippedCrewMemberNames
  }
}
    `;
export type BulkUpdateCrewMemberStatusMutationFn = Apollo.MutationFunction<BulkUpdateCrewMemberStatusMutation, BulkUpdateCrewMemberStatusMutationVariables>;

/**
 * __useBulkUpdateCrewMemberStatusMutation__
 *
 * To run a mutation, you first call `useBulkUpdateCrewMemberStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateCrewMemberStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateCrewMemberStatusMutation, { data, loading, error }] = useBulkUpdateCrewMemberStatusMutation({
 *   variables: {
 *      crewMemberIds: // value for 'crewMemberIds'
 *      crewMemberStatusId: // value for 'crewMemberStatusId'
 *   },
 * });
 */
export function useBulkUpdateCrewMemberStatusMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateCrewMemberStatusMutation, BulkUpdateCrewMemberStatusMutationVariables>) {
        return Apollo.useMutation<BulkUpdateCrewMemberStatusMutation, BulkUpdateCrewMemberStatusMutationVariables>(BulkUpdateCrewMemberStatusDocument, baseOptions);
      }
export type BulkUpdateCrewMemberStatusMutationHookResult = ReturnType<typeof useBulkUpdateCrewMemberStatusMutation>;
export type BulkUpdateCrewMemberStatusMutationResult = Apollo.MutationResult<BulkUpdateCrewMemberStatusMutation>;
export type BulkUpdateCrewMemberStatusMutationOptions = Apollo.BaseMutationOptions<BulkUpdateCrewMemberStatusMutation, BulkUpdateCrewMemberStatusMutationVariables>;
export const CrewProjectDocumentsQueryDocument = gql`
    query crewProjectDocumentsQuery($crewProjectId: Int!, $documentTypeCategoryId: DocumentTypeCategoryEnum!) {
  crewProject(id: $crewProjectId) {
    crewMember {
      certificateDateOfFirstIssue
    }
    certificateExpiryDate
  }
  documents: crewProjectDocuments(crewProjectId: $crewProjectId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...crewProjectDocument
  }
  documentTypes: crewProjectDocumentTypes(crewProjectId: $crewProjectId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...documentType
  }
}
    ${CrewProjectDocumentFragmentDoc}
${DocumentTypeFragmentDoc}`;

/**
 * __useCrewProjectDocumentsQueryQuery__
 *
 * To run a query within a React component, call `useCrewProjectDocumentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectDocumentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectDocumentsQueryQuery({
 *   variables: {
 *      crewProjectId: // value for 'crewProjectId'
 *      documentTypeCategoryId: // value for 'documentTypeCategoryId'
 *   },
 * });
 */
export function useCrewProjectDocumentsQueryQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectDocumentsQueryQuery, CrewProjectDocumentsQueryQueryVariables>) {
        return Apollo.useQuery<CrewProjectDocumentsQueryQuery, CrewProjectDocumentsQueryQueryVariables>(CrewProjectDocumentsQueryDocument, baseOptions);
      }
export function useCrewProjectDocumentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectDocumentsQueryQuery, CrewProjectDocumentsQueryQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectDocumentsQueryQuery, CrewProjectDocumentsQueryQueryVariables>(CrewProjectDocumentsQueryDocument, baseOptions);
        }
export type CrewProjectDocumentsQueryQueryHookResult = ReturnType<typeof useCrewProjectDocumentsQueryQuery>;
export type CrewProjectDocumentsQueryLazyQueryHookResult = ReturnType<typeof useCrewProjectDocumentsQueryLazyQuery>;
export type CrewProjectDocumentsQueryQueryResult = Apollo.QueryResult<CrewProjectDocumentsQueryQuery, CrewProjectDocumentsQueryQueryVariables>;
export const AddCrewProjectDocumentMutationDocument = gql`
    mutation addCrewProjectDocumentMutation($addCrewProjectDocumentInput: AddCrewProjectDocumentInput!) {
  addCrewProjectDocument(addCrewProjectDocumentInput: $addCrewProjectDocumentInput) {
    id
  }
}
    `;
export type AddCrewProjectDocumentMutationMutationFn = Apollo.MutationFunction<AddCrewProjectDocumentMutationMutation, AddCrewProjectDocumentMutationMutationVariables>;

/**
 * __useAddCrewProjectDocumentMutationMutation__
 *
 * To run a mutation, you first call `useAddCrewProjectDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCrewProjectDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCrewProjectDocumentMutationMutation, { data, loading, error }] = useAddCrewProjectDocumentMutationMutation({
 *   variables: {
 *      addCrewProjectDocumentInput: // value for 'addCrewProjectDocumentInput'
 *   },
 * });
 */
export function useAddCrewProjectDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddCrewProjectDocumentMutationMutation, AddCrewProjectDocumentMutationMutationVariables>) {
        return Apollo.useMutation<AddCrewProjectDocumentMutationMutation, AddCrewProjectDocumentMutationMutationVariables>(AddCrewProjectDocumentMutationDocument, baseOptions);
      }
export type AddCrewProjectDocumentMutationMutationHookResult = ReturnType<typeof useAddCrewProjectDocumentMutationMutation>;
export type AddCrewProjectDocumentMutationMutationResult = Apollo.MutationResult<AddCrewProjectDocumentMutationMutation>;
export type AddCrewProjectDocumentMutationMutationOptions = Apollo.BaseMutationOptions<AddCrewProjectDocumentMutationMutation, AddCrewProjectDocumentMutationMutationVariables>;
export const UpdateCrewProjectDocumentMutationDocument = gql`
    mutation updateCrewProjectDocumentMutation($updateCrewProjectDocumentInput: UpdateCrewProjectDocumentInput!) {
  updateCrewProjectDocument(updateCrewProjectDocumentInput: $updateCrewProjectDocumentInput) {
    id
  }
}
    `;
export type UpdateCrewProjectDocumentMutationMutationFn = Apollo.MutationFunction<UpdateCrewProjectDocumentMutationMutation, UpdateCrewProjectDocumentMutationMutationVariables>;

/**
 * __useUpdateCrewProjectDocumentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectDocumentMutationMutation, { data, loading, error }] = useUpdateCrewProjectDocumentMutationMutation({
 *   variables: {
 *      updateCrewProjectDocumentInput: // value for 'updateCrewProjectDocumentInput'
 *   },
 * });
 */
export function useUpdateCrewProjectDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectDocumentMutationMutation, UpdateCrewProjectDocumentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectDocumentMutationMutation, UpdateCrewProjectDocumentMutationMutationVariables>(UpdateCrewProjectDocumentMutationDocument, baseOptions);
      }
export type UpdateCrewProjectDocumentMutationMutationHookResult = ReturnType<typeof useUpdateCrewProjectDocumentMutationMutation>;
export type UpdateCrewProjectDocumentMutationMutationResult = Apollo.MutationResult<UpdateCrewProjectDocumentMutationMutation>;
export type UpdateCrewProjectDocumentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectDocumentMutationMutation, UpdateCrewProjectDocumentMutationMutationVariables>;
export const RemoveCrewProjectDocumentMutationDocument = gql`
    mutation removeCrewProjectDocumentMutation($id: Int!) {
  removeCrewProjectDocument(id: $id)
}
    `;
export type RemoveCrewProjectDocumentMutationMutationFn = Apollo.MutationFunction<RemoveCrewProjectDocumentMutationMutation, RemoveCrewProjectDocumentMutationMutationVariables>;

/**
 * __useRemoveCrewProjectDocumentMutationMutation__
 *
 * To run a mutation, you first call `useRemoveCrewProjectDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCrewProjectDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCrewProjectDocumentMutationMutation, { data, loading, error }] = useRemoveCrewProjectDocumentMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCrewProjectDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCrewProjectDocumentMutationMutation, RemoveCrewProjectDocumentMutationMutationVariables>) {
        return Apollo.useMutation<RemoveCrewProjectDocumentMutationMutation, RemoveCrewProjectDocumentMutationMutationVariables>(RemoveCrewProjectDocumentMutationDocument, baseOptions);
      }
export type RemoveCrewProjectDocumentMutationMutationHookResult = ReturnType<typeof useRemoveCrewProjectDocumentMutationMutation>;
export type RemoveCrewProjectDocumentMutationMutationResult = Apollo.MutationResult<RemoveCrewProjectDocumentMutationMutation>;
export type RemoveCrewProjectDocumentMutationMutationOptions = Apollo.BaseMutationOptions<RemoveCrewProjectDocumentMutationMutation, RemoveCrewProjectDocumentMutationMutationVariables>;
export const DownloadCrewProjectDocumentDocument = gql`
    query downloadCrewProjectDocument($id: Int!) {
  file: downloadCrewProjectDocument(id: $id) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadCrewProjectDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadCrewProjectDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCrewProjectDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCrewProjectDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadCrewProjectDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadCrewProjectDocumentQuery, DownloadCrewProjectDocumentQueryVariables>) {
        return Apollo.useQuery<DownloadCrewProjectDocumentQuery, DownloadCrewProjectDocumentQueryVariables>(DownloadCrewProjectDocumentDocument, baseOptions);
      }
export function useDownloadCrewProjectDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCrewProjectDocumentQuery, DownloadCrewProjectDocumentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadCrewProjectDocumentQuery, DownloadCrewProjectDocumentQueryVariables>(DownloadCrewProjectDocumentDocument, baseOptions);
        }
export type DownloadCrewProjectDocumentQueryHookResult = ReturnType<typeof useDownloadCrewProjectDocumentQuery>;
export type DownloadCrewProjectDocumentLazyQueryHookResult = ReturnType<typeof useDownloadCrewProjectDocumentLazyQuery>;
export type DownloadCrewProjectDocumentQueryResult = Apollo.QueryResult<DownloadCrewProjectDocumentQuery, DownloadCrewProjectDocumentQueryVariables>;
export const RequestCrewProjectDocumentDownloadTokenMutationDocument = gql`
    mutation requestCrewProjectDocumentDownloadTokenMutation($id: Int!, $downloadFileName: String) {
  requestCrewProjectDocumentDownloadToken(id: $id, downloadFileName: $downloadFileName)
}
    `;
export type RequestCrewProjectDocumentDownloadTokenMutationMutationFn = Apollo.MutationFunction<RequestCrewProjectDocumentDownloadTokenMutationMutation, RequestCrewProjectDocumentDownloadTokenMutationMutationVariables>;

/**
 * __useRequestCrewProjectDocumentDownloadTokenMutationMutation__
 *
 * To run a mutation, you first call `useRequestCrewProjectDocumentDownloadTokenMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCrewProjectDocumentDownloadTokenMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCrewProjectDocumentDownloadTokenMutationMutation, { data, loading, error }] = useRequestCrewProjectDocumentDownloadTokenMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      downloadFileName: // value for 'downloadFileName'
 *   },
 * });
 */
export function useRequestCrewProjectDocumentDownloadTokenMutationMutation(baseOptions?: Apollo.MutationHookOptions<RequestCrewProjectDocumentDownloadTokenMutationMutation, RequestCrewProjectDocumentDownloadTokenMutationMutationVariables>) {
        return Apollo.useMutation<RequestCrewProjectDocumentDownloadTokenMutationMutation, RequestCrewProjectDocumentDownloadTokenMutationMutationVariables>(RequestCrewProjectDocumentDownloadTokenMutationDocument, baseOptions);
      }
export type RequestCrewProjectDocumentDownloadTokenMutationMutationHookResult = ReturnType<typeof useRequestCrewProjectDocumentDownloadTokenMutationMutation>;
export type RequestCrewProjectDocumentDownloadTokenMutationMutationResult = Apollo.MutationResult<RequestCrewProjectDocumentDownloadTokenMutationMutation>;
export type RequestCrewProjectDocumentDownloadTokenMutationMutationOptions = Apollo.BaseMutationOptions<RequestCrewProjectDocumentDownloadTokenMutationMutation, RequestCrewProjectDocumentDownloadTokenMutationMutationVariables>;
export const UpdateCrewProjectDocumentReleasedToDcaMutationDocument = gql`
    mutation updateCrewProjectDocumentReleasedToDcaMutation($input: UpdateCrewProjectDocumentReleasedToDcaInput!) {
  updateCrewProjectDocumentReleasedToDca(input: $input) {
    id
  }
}
    `;
export type UpdateCrewProjectDocumentReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateCrewProjectDocumentReleasedToDcaMutationMutation, UpdateCrewProjectDocumentReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateCrewProjectDocumentReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectDocumentReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectDocumentReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectDocumentReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateCrewProjectDocumentReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCrewProjectDocumentReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectDocumentReleasedToDcaMutationMutation, UpdateCrewProjectDocumentReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectDocumentReleasedToDcaMutationMutation, UpdateCrewProjectDocumentReleasedToDcaMutationMutationVariables>(UpdateCrewProjectDocumentReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateCrewProjectDocumentReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateCrewProjectDocumentReleasedToDcaMutationMutation>;
export type UpdateCrewProjectDocumentReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateCrewProjectDocumentReleasedToDcaMutationMutation>;
export type UpdateCrewProjectDocumentReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectDocumentReleasedToDcaMutationMutation, UpdateCrewProjectDocumentReleasedToDcaMutationMutationVariables>;
export const CrewProjectGridDocument = gql`
    query crewProjectGrid($sortBy: CrewProjectsSortBy, $sortDirection: String, $crewMemberId: Int, $operatorIdIn: [Int!], $associatedAircraftProjectIdIn: [Int!], $projectStatusIdIn: [Int!], $projectStatusIdNotIn: [Int!], $paginationOptions: PaginationOptions) {
  crewProjects(sortBy: $sortBy, sortDirection: $sortDirection, crewMemberId: $crewMemberId, operatorIdIn: $operatorIdIn, associatedAircraftProjectIdIn: $associatedAircraftProjectIdIn, projectStatusIdIn: $projectStatusIdIn, projectStatusIdNotIn: $projectStatusIdNotIn, paginationOptions: $paginationOptions) {
    ... on PaginatedCrewProjects {
      totalItems
      crewProjects {
        ...crewProjectGridItem
      }
    }
    ... on CrewProjects {
      crewProjects {
        ...crewProjectGridItem
      }
    }
  }
}
    ${CrewProjectGridItemFragmentDoc}`;

/**
 * __useCrewProjectGridQuery__
 *
 * To run a query within a React component, call `useCrewProjectGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectGridQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      crewMemberId: // value for 'crewMemberId'
 *      operatorIdIn: // value for 'operatorIdIn'
 *      associatedAircraftProjectIdIn: // value for 'associatedAircraftProjectIdIn'
 *      projectStatusIdIn: // value for 'projectStatusIdIn'
 *      projectStatusIdNotIn: // value for 'projectStatusIdNotIn'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useCrewProjectGridQuery(baseOptions?: Apollo.QueryHookOptions<CrewProjectGridQuery, CrewProjectGridQueryVariables>) {
        return Apollo.useQuery<CrewProjectGridQuery, CrewProjectGridQueryVariables>(CrewProjectGridDocument, baseOptions);
      }
export function useCrewProjectGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectGridQuery, CrewProjectGridQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectGridQuery, CrewProjectGridQueryVariables>(CrewProjectGridDocument, baseOptions);
        }
export type CrewProjectGridQueryHookResult = ReturnType<typeof useCrewProjectGridQuery>;
export type CrewProjectGridLazyQueryHookResult = ReturnType<typeof useCrewProjectGridLazyQuery>;
export type CrewProjectGridQueryResult = Apollo.QueryResult<CrewProjectGridQuery, CrewProjectGridQueryVariables>;
export const CrewProjectCertificatePreviewDocument = gql`
    query crewProjectCertificatePreview($crewProjectId: Int!) {
  downloadCrewCertificatePreview(crewProjectId: $crewProjectId) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useCrewProjectCertificatePreviewQuery__
 *
 * To run a query within a React component, call `useCrewProjectCertificatePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectCertificatePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectCertificatePreviewQuery({
 *   variables: {
 *      crewProjectId: // value for 'crewProjectId'
 *   },
 * });
 */
export function useCrewProjectCertificatePreviewQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectCertificatePreviewQuery, CrewProjectCertificatePreviewQueryVariables>) {
        return Apollo.useQuery<CrewProjectCertificatePreviewQuery, CrewProjectCertificatePreviewQueryVariables>(CrewProjectCertificatePreviewDocument, baseOptions);
      }
export function useCrewProjectCertificatePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectCertificatePreviewQuery, CrewProjectCertificatePreviewQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectCertificatePreviewQuery, CrewProjectCertificatePreviewQueryVariables>(CrewProjectCertificatePreviewDocument, baseOptions);
        }
export type CrewProjectCertificatePreviewQueryHookResult = ReturnType<typeof useCrewProjectCertificatePreviewQuery>;
export type CrewProjectCertificatePreviewLazyQueryHookResult = ReturnType<typeof useCrewProjectCertificatePreviewLazyQuery>;
export type CrewProjectCertificatePreviewQueryResult = Apollo.QueryResult<CrewProjectCertificatePreviewQuery, CrewProjectCertificatePreviewQueryVariables>;
export const DownloadCrewProjectOfficialLetterPreviewDocument = gql`
    query downloadCrewProjectOfficialLetterPreview($crewProjectId: Int!) {
  downloadCrewProjectOfficialLetterPreview(crewProjectId: $crewProjectId) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadCrewProjectOfficialLetterPreviewQuery__
 *
 * To run a query within a React component, call `useDownloadCrewProjectOfficialLetterPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCrewProjectOfficialLetterPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCrewProjectOfficialLetterPreviewQuery({
 *   variables: {
 *      crewProjectId: // value for 'crewProjectId'
 *   },
 * });
 */
export function useDownloadCrewProjectOfficialLetterPreviewQuery(baseOptions: Apollo.QueryHookOptions<DownloadCrewProjectOfficialLetterPreviewQuery, DownloadCrewProjectOfficialLetterPreviewQueryVariables>) {
        return Apollo.useQuery<DownloadCrewProjectOfficialLetterPreviewQuery, DownloadCrewProjectOfficialLetterPreviewQueryVariables>(DownloadCrewProjectOfficialLetterPreviewDocument, baseOptions);
      }
export function useDownloadCrewProjectOfficialLetterPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCrewProjectOfficialLetterPreviewQuery, DownloadCrewProjectOfficialLetterPreviewQueryVariables>) {
          return Apollo.useLazyQuery<DownloadCrewProjectOfficialLetterPreviewQuery, DownloadCrewProjectOfficialLetterPreviewQueryVariables>(DownloadCrewProjectOfficialLetterPreviewDocument, baseOptions);
        }
export type DownloadCrewProjectOfficialLetterPreviewQueryHookResult = ReturnType<typeof useDownloadCrewProjectOfficialLetterPreviewQuery>;
export type DownloadCrewProjectOfficialLetterPreviewLazyQueryHookResult = ReturnType<typeof useDownloadCrewProjectOfficialLetterPreviewLazyQuery>;
export type DownloadCrewProjectOfficialLetterPreviewQueryResult = Apollo.QueryResult<DownloadCrewProjectOfficialLetterPreviewQuery, DownloadCrewProjectOfficialLetterPreviewQueryVariables>;
export const AddCrewProjectModalCrewMemberDocument = gql`
    query addCrewProjectModalCrewMember($id: Int!) {
  crewMember(id: $id) {
    id
    crewPosition {
      id
    }
  }
}
    `;

/**
 * __useAddCrewProjectModalCrewMemberQuery__
 *
 * To run a query within a React component, call `useAddCrewProjectModalCrewMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddCrewProjectModalCrewMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddCrewProjectModalCrewMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddCrewProjectModalCrewMemberQuery(baseOptions: Apollo.QueryHookOptions<AddCrewProjectModalCrewMemberQuery, AddCrewProjectModalCrewMemberQueryVariables>) {
        return Apollo.useQuery<AddCrewProjectModalCrewMemberQuery, AddCrewProjectModalCrewMemberQueryVariables>(AddCrewProjectModalCrewMemberDocument, baseOptions);
      }
export function useAddCrewProjectModalCrewMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddCrewProjectModalCrewMemberQuery, AddCrewProjectModalCrewMemberQueryVariables>) {
          return Apollo.useLazyQuery<AddCrewProjectModalCrewMemberQuery, AddCrewProjectModalCrewMemberQueryVariables>(AddCrewProjectModalCrewMemberDocument, baseOptions);
        }
export type AddCrewProjectModalCrewMemberQueryHookResult = ReturnType<typeof useAddCrewProjectModalCrewMemberQuery>;
export type AddCrewProjectModalCrewMemberLazyQueryHookResult = ReturnType<typeof useAddCrewProjectModalCrewMemberLazyQuery>;
export type AddCrewProjectModalCrewMemberQueryResult = Apollo.QueryResult<AddCrewProjectModalCrewMemberQuery, AddCrewProjectModalCrewMemberQueryVariables>;
export const AddCrewProjectMutationDocument = gql`
    mutation addCrewProjectMutation($addCrewProjectInput: AddCrewProjectInput!) {
  addCrewProject(addCrewProjectInput: $addCrewProjectInput) {
    id
  }
}
    `;
export type AddCrewProjectMutationMutationFn = Apollo.MutationFunction<AddCrewProjectMutationMutation, AddCrewProjectMutationMutationVariables>;

/**
 * __useAddCrewProjectMutationMutation__
 *
 * To run a mutation, you first call `useAddCrewProjectMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCrewProjectMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCrewProjectMutationMutation, { data, loading, error }] = useAddCrewProjectMutationMutation({
 *   variables: {
 *      addCrewProjectInput: // value for 'addCrewProjectInput'
 *   },
 * });
 */
export function useAddCrewProjectMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddCrewProjectMutationMutation, AddCrewProjectMutationMutationVariables>) {
        return Apollo.useMutation<AddCrewProjectMutationMutation, AddCrewProjectMutationMutationVariables>(AddCrewProjectMutationDocument, baseOptions);
      }
export type AddCrewProjectMutationMutationHookResult = ReturnType<typeof useAddCrewProjectMutationMutation>;
export type AddCrewProjectMutationMutationResult = Apollo.MutationResult<AddCrewProjectMutationMutation>;
export type AddCrewProjectMutationMutationOptions = Apollo.BaseMutationOptions<AddCrewProjectMutationMutation, AddCrewProjectMutationMutationVariables>;
export const CrewProjectHeaderDocument = gql`
    query crewProjectHeader($crewProjectId: Int!) {
  crewProject(id: $crewProjectId) {
    ...crewProjectHeader
  }
}
    ${CrewProjectHeaderFragmentDoc}`;

/**
 * __useCrewProjectHeaderQuery__
 *
 * To run a query within a React component, call `useCrewProjectHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectHeaderQuery({
 *   variables: {
 *      crewProjectId: // value for 'crewProjectId'
 *   },
 * });
 */
export function useCrewProjectHeaderQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectHeaderQuery, CrewProjectHeaderQueryVariables>) {
        return Apollo.useQuery<CrewProjectHeaderQuery, CrewProjectHeaderQueryVariables>(CrewProjectHeaderDocument, baseOptions);
      }
export function useCrewProjectHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectHeaderQuery, CrewProjectHeaderQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectHeaderQuery, CrewProjectHeaderQueryVariables>(CrewProjectHeaderDocument, baseOptions);
        }
export type CrewProjectHeaderQueryHookResult = ReturnType<typeof useCrewProjectHeaderQuery>;
export type CrewProjectHeaderLazyQueryHookResult = ReturnType<typeof useCrewProjectHeaderLazyQuery>;
export type CrewProjectHeaderQueryResult = Apollo.QueryResult<CrewProjectHeaderQuery, CrewProjectHeaderQueryVariables>;
export const CrewProjectCommentsDocument = gql`
    query crewProjectComments($id: Int!) {
  crewProjectComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useCrewProjectCommentsQuery__
 *
 * To run a query within a React component, call `useCrewProjectCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCrewProjectCommentsQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectCommentsQuery, CrewProjectCommentsQueryVariables>) {
        return Apollo.useQuery<CrewProjectCommentsQuery, CrewProjectCommentsQueryVariables>(CrewProjectCommentsDocument, baseOptions);
      }
export function useCrewProjectCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectCommentsQuery, CrewProjectCommentsQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectCommentsQuery, CrewProjectCommentsQueryVariables>(CrewProjectCommentsDocument, baseOptions);
        }
export type CrewProjectCommentsQueryHookResult = ReturnType<typeof useCrewProjectCommentsQuery>;
export type CrewProjectCommentsLazyQueryHookResult = ReturnType<typeof useCrewProjectCommentsLazyQuery>;
export type CrewProjectCommentsQueryResult = Apollo.QueryResult<CrewProjectCommentsQuery, CrewProjectCommentsQueryVariables>;
export const CrewProjectSendToDcaCheckDocument = gql`
    query crewProjectSendToDcaCheck($crewProjectId: Int!) {
  crewProjectInsForms(crewProjectId: $crewProjectId) {
    ...sendToDcaCheck
  }
}
    ${SendToDcaCheckFragmentDoc}`;

/**
 * __useCrewProjectSendToDcaCheckQuery__
 *
 * To run a query within a React component, call `useCrewProjectSendToDcaCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectSendToDcaCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectSendToDcaCheckQuery({
 *   variables: {
 *      crewProjectId: // value for 'crewProjectId'
 *   },
 * });
 */
export function useCrewProjectSendToDcaCheckQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectSendToDcaCheckQuery, CrewProjectSendToDcaCheckQueryVariables>) {
        return Apollo.useQuery<CrewProjectSendToDcaCheckQuery, CrewProjectSendToDcaCheckQueryVariables>(CrewProjectSendToDcaCheckDocument, baseOptions);
      }
export function useCrewProjectSendToDcaCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectSendToDcaCheckQuery, CrewProjectSendToDcaCheckQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectSendToDcaCheckQuery, CrewProjectSendToDcaCheckQueryVariables>(CrewProjectSendToDcaCheckDocument, baseOptions);
        }
export type CrewProjectSendToDcaCheckQueryHookResult = ReturnType<typeof useCrewProjectSendToDcaCheckQuery>;
export type CrewProjectSendToDcaCheckLazyQueryHookResult = ReturnType<typeof useCrewProjectSendToDcaCheckLazyQuery>;
export type CrewProjectSendToDcaCheckQueryResult = Apollo.QueryResult<CrewProjectSendToDcaCheckQuery, CrewProjectSendToDcaCheckQueryVariables>;
export const CrewProjectReopenByDcaOpenProjectsCheckDocument = gql`
    query crewProjectReopenByDcaOpenProjectsCheck($crewMemberId: Int!, $projectStatusIdNotIn: [Int!]!) {
  crewProjects(crewMemberId: $crewMemberId, projectStatusIdNotIn: $projectStatusIdNotIn) {
    ... on CrewProjects {
      crewProjects {
        id
      }
    }
  }
}
    `;

/**
 * __useCrewProjectReopenByDcaOpenProjectsCheckQuery__
 *
 * To run a query within a React component, call `useCrewProjectReopenByDcaOpenProjectsCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectReopenByDcaOpenProjectsCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectReopenByDcaOpenProjectsCheckQuery({
 *   variables: {
 *      crewMemberId: // value for 'crewMemberId'
 *      projectStatusIdNotIn: // value for 'projectStatusIdNotIn'
 *   },
 * });
 */
export function useCrewProjectReopenByDcaOpenProjectsCheckQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectReopenByDcaOpenProjectsCheckQuery, CrewProjectReopenByDcaOpenProjectsCheckQueryVariables>) {
        return Apollo.useQuery<CrewProjectReopenByDcaOpenProjectsCheckQuery, CrewProjectReopenByDcaOpenProjectsCheckQueryVariables>(CrewProjectReopenByDcaOpenProjectsCheckDocument, baseOptions);
      }
export function useCrewProjectReopenByDcaOpenProjectsCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectReopenByDcaOpenProjectsCheckQuery, CrewProjectReopenByDcaOpenProjectsCheckQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectReopenByDcaOpenProjectsCheckQuery, CrewProjectReopenByDcaOpenProjectsCheckQueryVariables>(CrewProjectReopenByDcaOpenProjectsCheckDocument, baseOptions);
        }
export type CrewProjectReopenByDcaOpenProjectsCheckQueryHookResult = ReturnType<typeof useCrewProjectReopenByDcaOpenProjectsCheckQuery>;
export type CrewProjectReopenByDcaOpenProjectsCheckLazyQueryHookResult = ReturnType<typeof useCrewProjectReopenByDcaOpenProjectsCheckLazyQuery>;
export type CrewProjectReopenByDcaOpenProjectsCheckQueryResult = Apollo.QueryResult<CrewProjectReopenByDcaOpenProjectsCheckQuery, CrewProjectReopenByDcaOpenProjectsCheckQueryVariables>;
export const AddCrewProjectCommentDocument = gql`
    mutation addCrewProjectComment($id: Int!, $input: CommentInput!) {
  addCrewProjectComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddCrewProjectCommentMutationFn = Apollo.MutationFunction<AddCrewProjectCommentMutation, AddCrewProjectCommentMutationVariables>;

/**
 * __useAddCrewProjectCommentMutation__
 *
 * To run a mutation, you first call `useAddCrewProjectCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCrewProjectCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCrewProjectCommentMutation, { data, loading, error }] = useAddCrewProjectCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCrewProjectCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCrewProjectCommentMutation, AddCrewProjectCommentMutationVariables>) {
        return Apollo.useMutation<AddCrewProjectCommentMutation, AddCrewProjectCommentMutationVariables>(AddCrewProjectCommentDocument, baseOptions);
      }
export type AddCrewProjectCommentMutationHookResult = ReturnType<typeof useAddCrewProjectCommentMutation>;
export type AddCrewProjectCommentMutationResult = Apollo.MutationResult<AddCrewProjectCommentMutation>;
export type AddCrewProjectCommentMutationOptions = Apollo.BaseMutationOptions<AddCrewProjectCommentMutation, AddCrewProjectCommentMutationVariables>;
export const UpdateCrewProjectCommentDocument = gql`
    mutation updateCrewProjectComment($id: Int!, $body: String!) {
  updateCrewProjectComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateCrewProjectCommentMutationFn = Apollo.MutationFunction<UpdateCrewProjectCommentMutation, UpdateCrewProjectCommentMutationVariables>;

/**
 * __useUpdateCrewProjectCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectCommentMutation, { data, loading, error }] = useUpdateCrewProjectCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateCrewProjectCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectCommentMutation, UpdateCrewProjectCommentMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectCommentMutation, UpdateCrewProjectCommentMutationVariables>(UpdateCrewProjectCommentDocument, baseOptions);
      }
export type UpdateCrewProjectCommentMutationHookResult = ReturnType<typeof useUpdateCrewProjectCommentMutation>;
export type UpdateCrewProjectCommentMutationResult = Apollo.MutationResult<UpdateCrewProjectCommentMutation>;
export type UpdateCrewProjectCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectCommentMutation, UpdateCrewProjectCommentMutationVariables>;
export const CrewProjectDcaCommentsDocument = gql`
    query crewProjectDcaComments($id: Int!) {
  crewProjectDcaComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useCrewProjectDcaCommentsQuery__
 *
 * To run a query within a React component, call `useCrewProjectDcaCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectDcaCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectDcaCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCrewProjectDcaCommentsQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectDcaCommentsQuery, CrewProjectDcaCommentsQueryVariables>) {
        return Apollo.useQuery<CrewProjectDcaCommentsQuery, CrewProjectDcaCommentsQueryVariables>(CrewProjectDcaCommentsDocument, baseOptions);
      }
export function useCrewProjectDcaCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectDcaCommentsQuery, CrewProjectDcaCommentsQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectDcaCommentsQuery, CrewProjectDcaCommentsQueryVariables>(CrewProjectDcaCommentsDocument, baseOptions);
        }
export type CrewProjectDcaCommentsQueryHookResult = ReturnType<typeof useCrewProjectDcaCommentsQuery>;
export type CrewProjectDcaCommentsLazyQueryHookResult = ReturnType<typeof useCrewProjectDcaCommentsLazyQuery>;
export type CrewProjectDcaCommentsQueryResult = Apollo.QueryResult<CrewProjectDcaCommentsQuery, CrewProjectDcaCommentsQueryVariables>;
export const AddCrewProjectDcaCommentDocument = gql`
    mutation addCrewProjectDcaComment($id: Int!, $input: CommentInput!) {
  addCrewProjectDcaComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddCrewProjectDcaCommentMutationFn = Apollo.MutationFunction<AddCrewProjectDcaCommentMutation, AddCrewProjectDcaCommentMutationVariables>;

/**
 * __useAddCrewProjectDcaCommentMutation__
 *
 * To run a mutation, you first call `useAddCrewProjectDcaCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCrewProjectDcaCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCrewProjectDcaCommentMutation, { data, loading, error }] = useAddCrewProjectDcaCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCrewProjectDcaCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCrewProjectDcaCommentMutation, AddCrewProjectDcaCommentMutationVariables>) {
        return Apollo.useMutation<AddCrewProjectDcaCommentMutation, AddCrewProjectDcaCommentMutationVariables>(AddCrewProjectDcaCommentDocument, baseOptions);
      }
export type AddCrewProjectDcaCommentMutationHookResult = ReturnType<typeof useAddCrewProjectDcaCommentMutation>;
export type AddCrewProjectDcaCommentMutationResult = Apollo.MutationResult<AddCrewProjectDcaCommentMutation>;
export type AddCrewProjectDcaCommentMutationOptions = Apollo.BaseMutationOptions<AddCrewProjectDcaCommentMutation, AddCrewProjectDcaCommentMutationVariables>;
export const UpdateCrewProjectDcaCommentDocument = gql`
    mutation updateCrewProjectDcaComment($id: Int!, $body: String!) {
  updateCrewProjectDcaComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateCrewProjectDcaCommentMutationFn = Apollo.MutationFunction<UpdateCrewProjectDcaCommentMutation, UpdateCrewProjectDcaCommentMutationVariables>;

/**
 * __useUpdateCrewProjectDcaCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectDcaCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectDcaCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectDcaCommentMutation, { data, loading, error }] = useUpdateCrewProjectDcaCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateCrewProjectDcaCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectDcaCommentMutation, UpdateCrewProjectDcaCommentMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectDcaCommentMutation, UpdateCrewProjectDcaCommentMutationVariables>(UpdateCrewProjectDcaCommentDocument, baseOptions);
      }
export type UpdateCrewProjectDcaCommentMutationHookResult = ReturnType<typeof useUpdateCrewProjectDcaCommentMutation>;
export type UpdateCrewProjectDcaCommentMutationResult = Apollo.MutationResult<UpdateCrewProjectDcaCommentMutation>;
export type UpdateCrewProjectDcaCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectDcaCommentMutation, UpdateCrewProjectDcaCommentMutationVariables>;
export const HoldCrewProjectDocument = gql`
    mutation holdCrewProject($id: Int!) {
  holdCrewProject(id: $id) {
    id
  }
}
    `;
export type HoldCrewProjectMutationFn = Apollo.MutationFunction<HoldCrewProjectMutation, HoldCrewProjectMutationVariables>;

/**
 * __useHoldCrewProjectMutation__
 *
 * To run a mutation, you first call `useHoldCrewProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHoldCrewProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [holdCrewProjectMutation, { data, loading, error }] = useHoldCrewProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHoldCrewProjectMutation(baseOptions?: Apollo.MutationHookOptions<HoldCrewProjectMutation, HoldCrewProjectMutationVariables>) {
        return Apollo.useMutation<HoldCrewProjectMutation, HoldCrewProjectMutationVariables>(HoldCrewProjectDocument, baseOptions);
      }
export type HoldCrewProjectMutationHookResult = ReturnType<typeof useHoldCrewProjectMutation>;
export type HoldCrewProjectMutationResult = Apollo.MutationResult<HoldCrewProjectMutation>;
export type HoldCrewProjectMutationOptions = Apollo.BaseMutationOptions<HoldCrewProjectMutation, HoldCrewProjectMutationVariables>;
export const ReleaseCrewProjectDocument = gql`
    mutation releaseCrewProject($id: Int!) {
  releaseCrewProject(id: $id) {
    id
  }
}
    `;
export type ReleaseCrewProjectMutationFn = Apollo.MutationFunction<ReleaseCrewProjectMutation, ReleaseCrewProjectMutationVariables>;

/**
 * __useReleaseCrewProjectMutation__
 *
 * To run a mutation, you first call `useReleaseCrewProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseCrewProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseCrewProjectMutation, { data, loading, error }] = useReleaseCrewProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReleaseCrewProjectMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseCrewProjectMutation, ReleaseCrewProjectMutationVariables>) {
        return Apollo.useMutation<ReleaseCrewProjectMutation, ReleaseCrewProjectMutationVariables>(ReleaseCrewProjectDocument, baseOptions);
      }
export type ReleaseCrewProjectMutationHookResult = ReturnType<typeof useReleaseCrewProjectMutation>;
export type ReleaseCrewProjectMutationResult = Apollo.MutationResult<ReleaseCrewProjectMutation>;
export type ReleaseCrewProjectMutationOptions = Apollo.BaseMutationOptions<ReleaseCrewProjectMutation, ReleaseCrewProjectMutationVariables>;
export const DcaHoldCrewProjectDocument = gql`
    mutation dcaHoldCrewProject($input: DcaHoldCrewProjectInput!) {
  dcaHoldCrewProject(input: $input) {
    id
  }
}
    `;
export type DcaHoldCrewProjectMutationFn = Apollo.MutationFunction<DcaHoldCrewProjectMutation, DcaHoldCrewProjectMutationVariables>;

/**
 * __useDcaHoldCrewProjectMutation__
 *
 * To run a mutation, you first call `useDcaHoldCrewProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDcaHoldCrewProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dcaHoldCrewProjectMutation, { data, loading, error }] = useDcaHoldCrewProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDcaHoldCrewProjectMutation(baseOptions?: Apollo.MutationHookOptions<DcaHoldCrewProjectMutation, DcaHoldCrewProjectMutationVariables>) {
        return Apollo.useMutation<DcaHoldCrewProjectMutation, DcaHoldCrewProjectMutationVariables>(DcaHoldCrewProjectDocument, baseOptions);
      }
export type DcaHoldCrewProjectMutationHookResult = ReturnType<typeof useDcaHoldCrewProjectMutation>;
export type DcaHoldCrewProjectMutationResult = Apollo.MutationResult<DcaHoldCrewProjectMutation>;
export type DcaHoldCrewProjectMutationOptions = Apollo.BaseMutationOptions<DcaHoldCrewProjectMutation, DcaHoldCrewProjectMutationVariables>;
export const DcaReleaseCrewProjectDocument = gql`
    mutation dcaReleaseCrewProject($id: Int!) {
  dcaReleaseCrewProject(id: $id) {
    id
  }
}
    `;
export type DcaReleaseCrewProjectMutationFn = Apollo.MutationFunction<DcaReleaseCrewProjectMutation, DcaReleaseCrewProjectMutationVariables>;

/**
 * __useDcaReleaseCrewProjectMutation__
 *
 * To run a mutation, you first call `useDcaReleaseCrewProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDcaReleaseCrewProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dcaReleaseCrewProjectMutation, { data, loading, error }] = useDcaReleaseCrewProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDcaReleaseCrewProjectMutation(baseOptions?: Apollo.MutationHookOptions<DcaReleaseCrewProjectMutation, DcaReleaseCrewProjectMutationVariables>) {
        return Apollo.useMutation<DcaReleaseCrewProjectMutation, DcaReleaseCrewProjectMutationVariables>(DcaReleaseCrewProjectDocument, baseOptions);
      }
export type DcaReleaseCrewProjectMutationHookResult = ReturnType<typeof useDcaReleaseCrewProjectMutation>;
export type DcaReleaseCrewProjectMutationResult = Apollo.MutationResult<DcaReleaseCrewProjectMutation>;
export type DcaReleaseCrewProjectMutationOptions = Apollo.BaseMutationOptions<DcaReleaseCrewProjectMutation, DcaReleaseCrewProjectMutationVariables>;
export const DeleteCrewProjectDocument = gql`
    mutation deleteCrewProject($id: Int!) {
  deleteCrewProject(id: $id) {
    id
  }
}
    `;
export type DeleteCrewProjectMutationFn = Apollo.MutationFunction<DeleteCrewProjectMutation, DeleteCrewProjectMutationVariables>;

/**
 * __useDeleteCrewProjectMutation__
 *
 * To run a mutation, you first call `useDeleteCrewProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCrewProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCrewProjectMutation, { data, loading, error }] = useDeleteCrewProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCrewProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCrewProjectMutation, DeleteCrewProjectMutationVariables>) {
        return Apollo.useMutation<DeleteCrewProjectMutation, DeleteCrewProjectMutationVariables>(DeleteCrewProjectDocument, baseOptions);
      }
export type DeleteCrewProjectMutationHookResult = ReturnType<typeof useDeleteCrewProjectMutation>;
export type DeleteCrewProjectMutationResult = Apollo.MutationResult<DeleteCrewProjectMutation>;
export type DeleteCrewProjectMutationOptions = Apollo.BaseMutationOptions<DeleteCrewProjectMutation, DeleteCrewProjectMutationVariables>;
export const TransitionCrewProjectDocument = gql`
    mutation transitionCrewProject($input: TransitionProjectInput!) {
  transitionCrewProject(input: $input) {
    id
    projectStatus {
      id
    }
  }
}
    `;
export type TransitionCrewProjectMutationFn = Apollo.MutationFunction<TransitionCrewProjectMutation, TransitionCrewProjectMutationVariables>;

/**
 * __useTransitionCrewProjectMutation__
 *
 * To run a mutation, you first call `useTransitionCrewProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionCrewProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionCrewProjectMutation, { data, loading, error }] = useTransitionCrewProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransitionCrewProjectMutation(baseOptions?: Apollo.MutationHookOptions<TransitionCrewProjectMutation, TransitionCrewProjectMutationVariables>) {
        return Apollo.useMutation<TransitionCrewProjectMutation, TransitionCrewProjectMutationVariables>(TransitionCrewProjectDocument, baseOptions);
      }
export type TransitionCrewProjectMutationHookResult = ReturnType<typeof useTransitionCrewProjectMutation>;
export type TransitionCrewProjectMutationResult = Apollo.MutationResult<TransitionCrewProjectMutation>;
export type TransitionCrewProjectMutationOptions = Apollo.BaseMutationOptions<TransitionCrewProjectMutation, TransitionCrewProjectMutationVariables>;
export const SendCrewProjectBackToIasoDocument = gql`
    mutation sendCrewProjectBackToIaso($input: SendCrewProjectToIasoInput!) {
  sendCrewProjectBackToIaso(input: $input) {
    id
  }
}
    `;
export type SendCrewProjectBackToIasoMutationFn = Apollo.MutationFunction<SendCrewProjectBackToIasoMutation, SendCrewProjectBackToIasoMutationVariables>;

/**
 * __useSendCrewProjectBackToIasoMutation__
 *
 * To run a mutation, you first call `useSendCrewProjectBackToIasoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCrewProjectBackToIasoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCrewProjectBackToIasoMutation, { data, loading, error }] = useSendCrewProjectBackToIasoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCrewProjectBackToIasoMutation(baseOptions?: Apollo.MutationHookOptions<SendCrewProjectBackToIasoMutation, SendCrewProjectBackToIasoMutationVariables>) {
        return Apollo.useMutation<SendCrewProjectBackToIasoMutation, SendCrewProjectBackToIasoMutationVariables>(SendCrewProjectBackToIasoDocument, baseOptions);
      }
export type SendCrewProjectBackToIasoMutationHookResult = ReturnType<typeof useSendCrewProjectBackToIasoMutation>;
export type SendCrewProjectBackToIasoMutationResult = Apollo.MutationResult<SendCrewProjectBackToIasoMutation>;
export type SendCrewProjectBackToIasoMutationOptions = Apollo.BaseMutationOptions<SendCrewProjectBackToIasoMutation, SendCrewProjectBackToIasoMutationVariables>;
export const CompleteCrewProjectTaskDocument = gql`
    mutation completeCrewProjectTask($input: CompleteCrewProjectTaskInput!) {
  completeCrewProjectTask(input: $input) {
    id
  }
}
    `;
export type CompleteCrewProjectTaskMutationFn = Apollo.MutationFunction<CompleteCrewProjectTaskMutation, CompleteCrewProjectTaskMutationVariables>;

/**
 * __useCompleteCrewProjectTaskMutation__
 *
 * To run a mutation, you first call `useCompleteCrewProjectTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCrewProjectTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeCrewProjectTaskMutation, { data, loading, error }] = useCompleteCrewProjectTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteCrewProjectTaskMutation(baseOptions?: Apollo.MutationHookOptions<CompleteCrewProjectTaskMutation, CompleteCrewProjectTaskMutationVariables>) {
        return Apollo.useMutation<CompleteCrewProjectTaskMutation, CompleteCrewProjectTaskMutationVariables>(CompleteCrewProjectTaskDocument, baseOptions);
      }
export type CompleteCrewProjectTaskMutationHookResult = ReturnType<typeof useCompleteCrewProjectTaskMutation>;
export type CompleteCrewProjectTaskMutationResult = Apollo.MutationResult<CompleteCrewProjectTaskMutation>;
export type CompleteCrewProjectTaskMutationOptions = Apollo.BaseMutationOptions<CompleteCrewProjectTaskMutation, CompleteCrewProjectTaskMutationVariables>;
export const SendCrewProjectInsFormVersionForExecutionDocument = gql`
    mutation sendCrewProjectInsFormVersionForExecution($input: SendForExecutionInput!) {
  sendCrewProjectInsFormVersionForExecution(input: $input) {
    id
  }
}
    `;
export type SendCrewProjectInsFormVersionForExecutionMutationFn = Apollo.MutationFunction<SendCrewProjectInsFormVersionForExecutionMutation, SendCrewProjectInsFormVersionForExecutionMutationVariables>;

/**
 * __useSendCrewProjectInsFormVersionForExecutionMutation__
 *
 * To run a mutation, you first call `useSendCrewProjectInsFormVersionForExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCrewProjectInsFormVersionForExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCrewProjectInsFormVersionForExecutionMutation, { data, loading, error }] = useSendCrewProjectInsFormVersionForExecutionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCrewProjectInsFormVersionForExecutionMutation(baseOptions?: Apollo.MutationHookOptions<SendCrewProjectInsFormVersionForExecutionMutation, SendCrewProjectInsFormVersionForExecutionMutationVariables>) {
        return Apollo.useMutation<SendCrewProjectInsFormVersionForExecutionMutation, SendCrewProjectInsFormVersionForExecutionMutationVariables>(SendCrewProjectInsFormVersionForExecutionDocument, baseOptions);
      }
export type SendCrewProjectInsFormVersionForExecutionMutationHookResult = ReturnType<typeof useSendCrewProjectInsFormVersionForExecutionMutation>;
export type SendCrewProjectInsFormVersionForExecutionMutationResult = Apollo.MutationResult<SendCrewProjectInsFormVersionForExecutionMutation>;
export type SendCrewProjectInsFormVersionForExecutionMutationOptions = Apollo.BaseMutationOptions<SendCrewProjectInsFormVersionForExecutionMutation, SendCrewProjectInsFormVersionForExecutionMutationVariables>;
export const ResendCrewProjectInsFormVersionForExecutionDocument = gql`
    mutation resendCrewProjectInsFormVersionForExecution($projectInsFormVersionId: Int!) {
  resendCrewProjectInsFormVersionForExecution(projectInsFormVersionId: $projectInsFormVersionId) {
    id
  }
}
    `;
export type ResendCrewProjectInsFormVersionForExecutionMutationFn = Apollo.MutationFunction<ResendCrewProjectInsFormVersionForExecutionMutation, ResendCrewProjectInsFormVersionForExecutionMutationVariables>;

/**
 * __useResendCrewProjectInsFormVersionForExecutionMutation__
 *
 * To run a mutation, you first call `useResendCrewProjectInsFormVersionForExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendCrewProjectInsFormVersionForExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendCrewProjectInsFormVersionForExecutionMutation, { data, loading, error }] = useResendCrewProjectInsFormVersionForExecutionMutation({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useResendCrewProjectInsFormVersionForExecutionMutation(baseOptions?: Apollo.MutationHookOptions<ResendCrewProjectInsFormVersionForExecutionMutation, ResendCrewProjectInsFormVersionForExecutionMutationVariables>) {
        return Apollo.useMutation<ResendCrewProjectInsFormVersionForExecutionMutation, ResendCrewProjectInsFormVersionForExecutionMutationVariables>(ResendCrewProjectInsFormVersionForExecutionDocument, baseOptions);
      }
export type ResendCrewProjectInsFormVersionForExecutionMutationHookResult = ReturnType<typeof useResendCrewProjectInsFormVersionForExecutionMutation>;
export type ResendCrewProjectInsFormVersionForExecutionMutationResult = Apollo.MutationResult<ResendCrewProjectInsFormVersionForExecutionMutation>;
export type ResendCrewProjectInsFormVersionForExecutionMutationOptions = Apollo.BaseMutationOptions<ResendCrewProjectInsFormVersionForExecutionMutation, ResendCrewProjectInsFormVersionForExecutionMutationVariables>;
export const RevokeCrewProjectInsFormVersionExecutionDocument = gql`
    mutation revokeCrewProjectInsFormVersionExecution($projectInsFormVersionId: Int!) {
  revokeCrewProjectInsFormVersionExecution(projectInsFormVersionId: $projectInsFormVersionId) {
    id
  }
}
    `;
export type RevokeCrewProjectInsFormVersionExecutionMutationFn = Apollo.MutationFunction<RevokeCrewProjectInsFormVersionExecutionMutation, RevokeCrewProjectInsFormVersionExecutionMutationVariables>;

/**
 * __useRevokeCrewProjectInsFormVersionExecutionMutation__
 *
 * To run a mutation, you first call `useRevokeCrewProjectInsFormVersionExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeCrewProjectInsFormVersionExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeCrewProjectInsFormVersionExecutionMutation, { data, loading, error }] = useRevokeCrewProjectInsFormVersionExecutionMutation({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useRevokeCrewProjectInsFormVersionExecutionMutation(baseOptions?: Apollo.MutationHookOptions<RevokeCrewProjectInsFormVersionExecutionMutation, RevokeCrewProjectInsFormVersionExecutionMutationVariables>) {
        return Apollo.useMutation<RevokeCrewProjectInsFormVersionExecutionMutation, RevokeCrewProjectInsFormVersionExecutionMutationVariables>(RevokeCrewProjectInsFormVersionExecutionDocument, baseOptions);
      }
export type RevokeCrewProjectInsFormVersionExecutionMutationHookResult = ReturnType<typeof useRevokeCrewProjectInsFormVersionExecutionMutation>;
export type RevokeCrewProjectInsFormVersionExecutionMutationResult = Apollo.MutationResult<RevokeCrewProjectInsFormVersionExecutionMutation>;
export type RevokeCrewProjectInsFormVersionExecutionMutationOptions = Apollo.BaseMutationOptions<RevokeCrewProjectInsFormVersionExecutionMutation, RevokeCrewProjectInsFormVersionExecutionMutationVariables>;
export const UpdateAllCrewProjectDocumentsReleasedToDcaMutationDocument = gql`
    mutation updateAllCrewProjectDocumentsReleasedToDcaMutation($input: UpdateAllCrewProjectDocumentsReleasedToDcaInput!) {
  updateAllCrewProjectDocumentsReleasedToDca(input: $input)
}
    `;
export type UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutation, UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateAllCrewProjectDocumentsReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAllCrewProjectDocumentsReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllCrewProjectDocumentsReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllCrewProjectDocumentsReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateAllCrewProjectDocumentsReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllCrewProjectDocumentsReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutation, UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutation, UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutationVariables>(UpdateAllCrewProjectDocumentsReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateAllCrewProjectDocumentsReleasedToDcaMutationMutation>;
export type UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutation>;
export type UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutation, UpdateAllCrewProjectDocumentsReleasedToDcaMutationMutationVariables>;
export const CrewProjectCertificateInformationDocument = gql`
    query crewProjectCertificateInformation($crewProjectId: Int!) {
  crewProjectCertificate(crewProjectId: $crewProjectId) {
    ...crewProjectCertificateInformation
  }
  crewProject(id: $crewProjectId) {
    provisionalOperatorNames
  }
}
    ${CrewProjectCertificateInformationFragmentDoc}`;

/**
 * __useCrewProjectCertificateInformationQuery__
 *
 * To run a query within a React component, call `useCrewProjectCertificateInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectCertificateInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectCertificateInformationQuery({
 *   variables: {
 *      crewProjectId: // value for 'crewProjectId'
 *   },
 * });
 */
export function useCrewProjectCertificateInformationQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectCertificateInformationQuery, CrewProjectCertificateInformationQueryVariables>) {
        return Apollo.useQuery<CrewProjectCertificateInformationQuery, CrewProjectCertificateInformationQueryVariables>(CrewProjectCertificateInformationDocument, baseOptions);
      }
export function useCrewProjectCertificateInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectCertificateInformationQuery, CrewProjectCertificateInformationQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectCertificateInformationQuery, CrewProjectCertificateInformationQueryVariables>(CrewProjectCertificateInformationDocument, baseOptions);
        }
export type CrewProjectCertificateInformationQueryHookResult = ReturnType<typeof useCrewProjectCertificateInformationQuery>;
export type CrewProjectCertificateInformationLazyQueryHookResult = ReturnType<typeof useCrewProjectCertificateInformationLazyQuery>;
export type CrewProjectCertificateInformationQueryResult = Apollo.QueryResult<CrewProjectCertificateInformationQuery, CrewProjectCertificateInformationQueryVariables>;
export const UpdateCrewProjectCertificateDocument = gql`
    mutation updateCrewProjectCertificate($input: UpdateCrewProjectCertificateInput!, $recordHistory: Boolean, $ignoreWarnings: Boolean) {
  updateCrewProjectCertificate(input: $input, recordHistory: $recordHistory, ignoreWarnings: $ignoreWarnings) {
    crewProjectCertificate {
      ...crewProjectCertificateInformation
    }
    warnings
  }
}
    ${CrewProjectCertificateInformationFragmentDoc}`;
export type UpdateCrewProjectCertificateMutationFn = Apollo.MutationFunction<UpdateCrewProjectCertificateMutation, UpdateCrewProjectCertificateMutationVariables>;

/**
 * __useUpdateCrewProjectCertificateMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectCertificateMutation, { data, loading, error }] = useUpdateCrewProjectCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      recordHistory: // value for 'recordHistory'
 *      ignoreWarnings: // value for 'ignoreWarnings'
 *   },
 * });
 */
export function useUpdateCrewProjectCertificateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectCertificateMutation, UpdateCrewProjectCertificateMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectCertificateMutation, UpdateCrewProjectCertificateMutationVariables>(UpdateCrewProjectCertificateDocument, baseOptions);
      }
export type UpdateCrewProjectCertificateMutationHookResult = ReturnType<typeof useUpdateCrewProjectCertificateMutation>;
export type UpdateCrewProjectCertificateMutationResult = Apollo.MutationResult<UpdateCrewProjectCertificateMutation>;
export type UpdateCrewProjectCertificateMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectCertificateMutation, UpdateCrewProjectCertificateMutationVariables>;
export const CrewProjectDcaProjectApproversDocument = gql`
    query crewProjectDcaProjectApprovers {
  dcaProjectApprovers: crewProjectDcaProjectApprovers {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useCrewProjectDcaProjectApproversQuery__
 *
 * To run a query within a React component, call `useCrewProjectDcaProjectApproversQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectDcaProjectApproversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectDcaProjectApproversQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrewProjectDcaProjectApproversQuery(baseOptions?: Apollo.QueryHookOptions<CrewProjectDcaProjectApproversQuery, CrewProjectDcaProjectApproversQueryVariables>) {
        return Apollo.useQuery<CrewProjectDcaProjectApproversQuery, CrewProjectDcaProjectApproversQueryVariables>(CrewProjectDcaProjectApproversDocument, baseOptions);
      }
export function useCrewProjectDcaProjectApproversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectDcaProjectApproversQuery, CrewProjectDcaProjectApproversQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectDcaProjectApproversQuery, CrewProjectDcaProjectApproversQueryVariables>(CrewProjectDcaProjectApproversDocument, baseOptions);
        }
export type CrewProjectDcaProjectApproversQueryHookResult = ReturnType<typeof useCrewProjectDcaProjectApproversQuery>;
export type CrewProjectDcaProjectApproversLazyQueryHookResult = ReturnType<typeof useCrewProjectDcaProjectApproversLazyQuery>;
export type CrewProjectDcaProjectApproversQueryResult = Apollo.QueryResult<CrewProjectDcaProjectApproversQuery, CrewProjectDcaProjectApproversQueryVariables>;
export const CrewProjectFormsTabDocument = gql`
    query crewProjectFormsTab($crewProjectId: Int!) {
  crewProject(id: $crewProjectId) {
    canToggleInsFormDcaApproved
  }
  crewProjectInsForms(crewProjectId: $crewProjectId) {
    ...projectInsFormVersion
  }
  crewProjectInsFormsExclusiveGroups(crewProjectId: $crewProjectId) {
    ...projectInsFormVersionExclusiveGroup
  }
}
    ${ProjectInsFormVersionFragmentDoc}
${ProjectInsFormVersionExclusiveGroupFragmentDoc}`;

/**
 * __useCrewProjectFormsTabQuery__
 *
 * To run a query within a React component, call `useCrewProjectFormsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectFormsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectFormsTabQuery({
 *   variables: {
 *      crewProjectId: // value for 'crewProjectId'
 *   },
 * });
 */
export function useCrewProjectFormsTabQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectFormsTabQuery, CrewProjectFormsTabQueryVariables>) {
        return Apollo.useQuery<CrewProjectFormsTabQuery, CrewProjectFormsTabQueryVariables>(CrewProjectFormsTabDocument, baseOptions);
      }
export function useCrewProjectFormsTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectFormsTabQuery, CrewProjectFormsTabQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectFormsTabQuery, CrewProjectFormsTabQueryVariables>(CrewProjectFormsTabDocument, baseOptions);
        }
export type CrewProjectFormsTabQueryHookResult = ReturnType<typeof useCrewProjectFormsTabQuery>;
export type CrewProjectFormsTabLazyQueryHookResult = ReturnType<typeof useCrewProjectFormsTabLazyQuery>;
export type CrewProjectFormsTabQueryResult = Apollo.QueryResult<CrewProjectFormsTabQuery, CrewProjectFormsTabQueryVariables>;
export const CrewProjectInsFormFieldValuesAndCommentsQueryDocument = gql`
    query crewProjectInsFormFieldValuesAndCommentsQuery($projectInsFormVersionId: Int!) {
  fieldValues: crewProjectInsFormFieldValues(projectInsFormVersionId: $projectInsFormVersionId) {
    ...projectInsFormVersionFieldValue
  }
  fieldComments: crewProjectInsFormFieldComments(projectInsFormVersionId: $projectInsFormVersionId) {
    ...projectInsFormVersionFieldComment
  }
}
    ${ProjectInsFormVersionFieldValueFragmentDoc}
${ProjectInsFormVersionFieldCommentFragmentDoc}`;

/**
 * __useCrewProjectInsFormFieldValuesAndCommentsQueryQuery__
 *
 * To run a query within a React component, call `useCrewProjectInsFormFieldValuesAndCommentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectInsFormFieldValuesAndCommentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectInsFormFieldValuesAndCommentsQueryQuery({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useCrewProjectInsFormFieldValuesAndCommentsQueryQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectInsFormFieldValuesAndCommentsQueryQuery, CrewProjectInsFormFieldValuesAndCommentsQueryQueryVariables>) {
        return Apollo.useQuery<CrewProjectInsFormFieldValuesAndCommentsQueryQuery, CrewProjectInsFormFieldValuesAndCommentsQueryQueryVariables>(CrewProjectInsFormFieldValuesAndCommentsQueryDocument, baseOptions);
      }
export function useCrewProjectInsFormFieldValuesAndCommentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectInsFormFieldValuesAndCommentsQueryQuery, CrewProjectInsFormFieldValuesAndCommentsQueryQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectInsFormFieldValuesAndCommentsQueryQuery, CrewProjectInsFormFieldValuesAndCommentsQueryQueryVariables>(CrewProjectInsFormFieldValuesAndCommentsQueryDocument, baseOptions);
        }
export type CrewProjectInsFormFieldValuesAndCommentsQueryQueryHookResult = ReturnType<typeof useCrewProjectInsFormFieldValuesAndCommentsQueryQuery>;
export type CrewProjectInsFormFieldValuesAndCommentsQueryLazyQueryHookResult = ReturnType<typeof useCrewProjectInsFormFieldValuesAndCommentsQueryLazyQuery>;
export type CrewProjectInsFormFieldValuesAndCommentsQueryQueryResult = Apollo.QueryResult<CrewProjectInsFormFieldValuesAndCommentsQueryQuery, CrewProjectInsFormFieldValuesAndCommentsQueryQueryVariables>;
export const CrewProjectInsFormFieldValuesOnlyQueryDocument = gql`
    query crewProjectInsFormFieldValuesOnlyQuery($projectInsFormVersionId: Int!) {
  fieldValues: crewProjectInsFormFieldValues(projectInsFormVersionId: $projectInsFormVersionId) {
    ...projectInsFormVersionFieldValue
  }
}
    ${ProjectInsFormVersionFieldValueFragmentDoc}`;

/**
 * __useCrewProjectInsFormFieldValuesOnlyQueryQuery__
 *
 * To run a query within a React component, call `useCrewProjectInsFormFieldValuesOnlyQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectInsFormFieldValuesOnlyQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectInsFormFieldValuesOnlyQueryQuery({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useCrewProjectInsFormFieldValuesOnlyQueryQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectInsFormFieldValuesOnlyQueryQuery, CrewProjectInsFormFieldValuesOnlyQueryQueryVariables>) {
        return Apollo.useQuery<CrewProjectInsFormFieldValuesOnlyQueryQuery, CrewProjectInsFormFieldValuesOnlyQueryQueryVariables>(CrewProjectInsFormFieldValuesOnlyQueryDocument, baseOptions);
      }
export function useCrewProjectInsFormFieldValuesOnlyQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectInsFormFieldValuesOnlyQueryQuery, CrewProjectInsFormFieldValuesOnlyQueryQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectInsFormFieldValuesOnlyQueryQuery, CrewProjectInsFormFieldValuesOnlyQueryQueryVariables>(CrewProjectInsFormFieldValuesOnlyQueryDocument, baseOptions);
        }
export type CrewProjectInsFormFieldValuesOnlyQueryQueryHookResult = ReturnType<typeof useCrewProjectInsFormFieldValuesOnlyQueryQuery>;
export type CrewProjectInsFormFieldValuesOnlyQueryLazyQueryHookResult = ReturnType<typeof useCrewProjectInsFormFieldValuesOnlyQueryLazyQuery>;
export type CrewProjectInsFormFieldValuesOnlyQueryQueryResult = Apollo.QueryResult<CrewProjectInsFormFieldValuesOnlyQueryQuery, CrewProjectInsFormFieldValuesOnlyQueryQueryVariables>;
export const DownloadCrewProjectUploadedInsFormDocument = gql`
    query downloadCrewProjectUploadedInsForm($id: Int!) {
  file: downloadCrewProjectUploadedInsForm(projectInsFormVersionId: $id) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadCrewProjectUploadedInsFormQuery__
 *
 * To run a query within a React component, call `useDownloadCrewProjectUploadedInsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCrewProjectUploadedInsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCrewProjectUploadedInsFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadCrewProjectUploadedInsFormQuery(baseOptions: Apollo.QueryHookOptions<DownloadCrewProjectUploadedInsFormQuery, DownloadCrewProjectUploadedInsFormQueryVariables>) {
        return Apollo.useQuery<DownloadCrewProjectUploadedInsFormQuery, DownloadCrewProjectUploadedInsFormQueryVariables>(DownloadCrewProjectUploadedInsFormDocument, baseOptions);
      }
export function useDownloadCrewProjectUploadedInsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCrewProjectUploadedInsFormQuery, DownloadCrewProjectUploadedInsFormQueryVariables>) {
          return Apollo.useLazyQuery<DownloadCrewProjectUploadedInsFormQuery, DownloadCrewProjectUploadedInsFormQueryVariables>(DownloadCrewProjectUploadedInsFormDocument, baseOptions);
        }
export type DownloadCrewProjectUploadedInsFormQueryHookResult = ReturnType<typeof useDownloadCrewProjectUploadedInsFormQuery>;
export type DownloadCrewProjectUploadedInsFormLazyQueryHookResult = ReturnType<typeof useDownloadCrewProjectUploadedInsFormLazyQuery>;
export type DownloadCrewProjectUploadedInsFormQueryResult = Apollo.QueryResult<DownloadCrewProjectUploadedInsFormQuery, DownloadCrewProjectUploadedInsFormQueryVariables>;
export const DownloadCrewProjectFilledInInsFormDocument = gql`
    query downloadCrewProjectFilledInInsForm($projectInsFormVersionId: Int!) {
  file: downloadCrewProjectFilledInInsForm(projectInsFormVersionId: $projectInsFormVersionId) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadCrewProjectFilledInInsFormQuery__
 *
 * To run a query within a React component, call `useDownloadCrewProjectFilledInInsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCrewProjectFilledInInsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCrewProjectFilledInInsFormQuery({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useDownloadCrewProjectFilledInInsFormQuery(baseOptions: Apollo.QueryHookOptions<DownloadCrewProjectFilledInInsFormQuery, DownloadCrewProjectFilledInInsFormQueryVariables>) {
        return Apollo.useQuery<DownloadCrewProjectFilledInInsFormQuery, DownloadCrewProjectFilledInInsFormQueryVariables>(DownloadCrewProjectFilledInInsFormDocument, baseOptions);
      }
export function useDownloadCrewProjectFilledInInsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCrewProjectFilledInInsFormQuery, DownloadCrewProjectFilledInInsFormQueryVariables>) {
          return Apollo.useLazyQuery<DownloadCrewProjectFilledInInsFormQuery, DownloadCrewProjectFilledInInsFormQueryVariables>(DownloadCrewProjectFilledInInsFormDocument, baseOptions);
        }
export type DownloadCrewProjectFilledInInsFormQueryHookResult = ReturnType<typeof useDownloadCrewProjectFilledInInsFormQuery>;
export type DownloadCrewProjectFilledInInsFormLazyQueryHookResult = ReturnType<typeof useDownloadCrewProjectFilledInInsFormLazyQuery>;
export type DownloadCrewProjectFilledInInsFormQueryResult = Apollo.QueryResult<DownloadCrewProjectFilledInInsFormQuery, DownloadCrewProjectFilledInInsFormQueryVariables>;
export const UpdateCrewProjectInsFormTrgApprovalMutationDocument = gql`
    mutation updateCrewProjectInsFormTrgApprovalMutation($input: UpdateProjectInsFormVersionTrgApprovalInput!) {
  updateCrewProjectInsFormTrgApproval(input: $input) {
    ...projectInsFormVersion
  }
}
    ${ProjectInsFormVersionFragmentDoc}`;
export type UpdateCrewProjectInsFormTrgApprovalMutationMutationFn = Apollo.MutationFunction<UpdateCrewProjectInsFormTrgApprovalMutationMutation, UpdateCrewProjectInsFormTrgApprovalMutationMutationVariables>;

/**
 * __useUpdateCrewProjectInsFormTrgApprovalMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectInsFormTrgApprovalMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectInsFormTrgApprovalMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectInsFormTrgApprovalMutationMutation, { data, loading, error }] = useUpdateCrewProjectInsFormTrgApprovalMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCrewProjectInsFormTrgApprovalMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectInsFormTrgApprovalMutationMutation, UpdateCrewProjectInsFormTrgApprovalMutationMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectInsFormTrgApprovalMutationMutation, UpdateCrewProjectInsFormTrgApprovalMutationMutationVariables>(UpdateCrewProjectInsFormTrgApprovalMutationDocument, baseOptions);
      }
export type UpdateCrewProjectInsFormTrgApprovalMutationMutationHookResult = ReturnType<typeof useUpdateCrewProjectInsFormTrgApprovalMutationMutation>;
export type UpdateCrewProjectInsFormTrgApprovalMutationMutationResult = Apollo.MutationResult<UpdateCrewProjectInsFormTrgApprovalMutationMutation>;
export type UpdateCrewProjectInsFormTrgApprovalMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectInsFormTrgApprovalMutationMutation, UpdateCrewProjectInsFormTrgApprovalMutationMutationVariables>;
export const UpdateCrewProjectInsFormFileAttachmentMutationDocument = gql`
    mutation updateCrewProjectInsFormFileAttachmentMutation($input: UpdateProjectInsFormVersionFileAttachmentInput!) {
  updateCrewProjectInsFormFileAttachment(input: $input) {
    ...projectInsFormVersion
  }
}
    ${ProjectInsFormVersionFragmentDoc}`;
export type UpdateCrewProjectInsFormFileAttachmentMutationMutationFn = Apollo.MutationFunction<UpdateCrewProjectInsFormFileAttachmentMutationMutation, UpdateCrewProjectInsFormFileAttachmentMutationMutationVariables>;

/**
 * __useUpdateCrewProjectInsFormFileAttachmentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectInsFormFileAttachmentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectInsFormFileAttachmentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectInsFormFileAttachmentMutationMutation, { data, loading, error }] = useUpdateCrewProjectInsFormFileAttachmentMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCrewProjectInsFormFileAttachmentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectInsFormFileAttachmentMutationMutation, UpdateCrewProjectInsFormFileAttachmentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectInsFormFileAttachmentMutationMutation, UpdateCrewProjectInsFormFileAttachmentMutationMutationVariables>(UpdateCrewProjectInsFormFileAttachmentMutationDocument, baseOptions);
      }
export type UpdateCrewProjectInsFormFileAttachmentMutationMutationHookResult = ReturnType<typeof useUpdateCrewProjectInsFormFileAttachmentMutationMutation>;
export type UpdateCrewProjectInsFormFileAttachmentMutationMutationResult = Apollo.MutationResult<UpdateCrewProjectInsFormFileAttachmentMutationMutation>;
export type UpdateCrewProjectInsFormFileAttachmentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectInsFormFileAttachmentMutationMutation, UpdateCrewProjectInsFormFileAttachmentMutationMutationVariables>;
export const UpdateCrewProjectInsFormReleasedToDcaMutationDocument = gql`
    mutation updateCrewProjectInsFormReleasedToDcaMutation($input: UpdateProjectInsFormVersionReleasedToDcaInput!) {
  updateCrewProjectInsFormReleasedToDca(input: $input) {
    ...projectInsFormVersion
  }
}
    ${ProjectInsFormVersionFragmentDoc}`;
export type UpdateCrewProjectInsFormReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateCrewProjectInsFormReleasedToDcaMutationMutation, UpdateCrewProjectInsFormReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateCrewProjectInsFormReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectInsFormReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectInsFormReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectInsFormReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateCrewProjectInsFormReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCrewProjectInsFormReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectInsFormReleasedToDcaMutationMutation, UpdateCrewProjectInsFormReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectInsFormReleasedToDcaMutationMutation, UpdateCrewProjectInsFormReleasedToDcaMutationMutationVariables>(UpdateCrewProjectInsFormReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateCrewProjectInsFormReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateCrewProjectInsFormReleasedToDcaMutationMutation>;
export type UpdateCrewProjectInsFormReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateCrewProjectInsFormReleasedToDcaMutationMutation>;
export type UpdateCrewProjectInsFormReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectInsFormReleasedToDcaMutationMutation, UpdateCrewProjectInsFormReleasedToDcaMutationMutationVariables>;
export const UpdateCrewProjectInsFormFieldValuesDocument = gql`
    mutation updateCrewProjectInsFormFieldValues($input: UpdateProjectInsFormVersionFieldValuesInput!) {
  updateCrewProjectInsFormFieldValues(input: $input)
}
    `;
export type UpdateCrewProjectInsFormFieldValuesMutationFn = Apollo.MutationFunction<UpdateCrewProjectInsFormFieldValuesMutation, UpdateCrewProjectInsFormFieldValuesMutationVariables>;

/**
 * __useUpdateCrewProjectInsFormFieldValuesMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectInsFormFieldValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectInsFormFieldValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectInsFormFieldValuesMutation, { data, loading, error }] = useUpdateCrewProjectInsFormFieldValuesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCrewProjectInsFormFieldValuesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectInsFormFieldValuesMutation, UpdateCrewProjectInsFormFieldValuesMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectInsFormFieldValuesMutation, UpdateCrewProjectInsFormFieldValuesMutationVariables>(UpdateCrewProjectInsFormFieldValuesDocument, baseOptions);
      }
export type UpdateCrewProjectInsFormFieldValuesMutationHookResult = ReturnType<typeof useUpdateCrewProjectInsFormFieldValuesMutation>;
export type UpdateCrewProjectInsFormFieldValuesMutationResult = Apollo.MutationResult<UpdateCrewProjectInsFormFieldValuesMutation>;
export type UpdateCrewProjectInsFormFieldValuesMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectInsFormFieldValuesMutation, UpdateCrewProjectInsFormFieldValuesMutationVariables>;
export const UpdateCrewProjectInsFormFieldCommentDocument = gql`
    mutation updateCrewProjectInsFormFieldComment($input: UpdateProjectInsFormVersionFieldCommentInput!) {
  updateCrewProjectInsFormFieldComment(input: $input)
}
    `;
export type UpdateCrewProjectInsFormFieldCommentMutationFn = Apollo.MutationFunction<UpdateCrewProjectInsFormFieldCommentMutation, UpdateCrewProjectInsFormFieldCommentMutationVariables>;

/**
 * __useUpdateCrewProjectInsFormFieldCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectInsFormFieldCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectInsFormFieldCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectInsFormFieldCommentMutation, { data, loading, error }] = useUpdateCrewProjectInsFormFieldCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCrewProjectInsFormFieldCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectInsFormFieldCommentMutation, UpdateCrewProjectInsFormFieldCommentMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectInsFormFieldCommentMutation, UpdateCrewProjectInsFormFieldCommentMutationVariables>(UpdateCrewProjectInsFormFieldCommentDocument, baseOptions);
      }
export type UpdateCrewProjectInsFormFieldCommentMutationHookResult = ReturnType<typeof useUpdateCrewProjectInsFormFieldCommentMutation>;
export type UpdateCrewProjectInsFormFieldCommentMutationResult = Apollo.MutationResult<UpdateCrewProjectInsFormFieldCommentMutation>;
export type UpdateCrewProjectInsFormFieldCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectInsFormFieldCommentMutation, UpdateCrewProjectInsFormFieldCommentMutationVariables>;
export const UpdateCrewProjectInsFormIsDcaApprovedDocument = gql`
    mutation updateCrewProjectInsFormIsDcaApproved($input: UpdateProjectInsFormIsDcaApprovedInput!) {
  updateCrewProjectInsFormIsDcaApproved(input: $input)
}
    `;
export type UpdateCrewProjectInsFormIsDcaApprovedMutationFn = Apollo.MutationFunction<UpdateCrewProjectInsFormIsDcaApprovedMutation, UpdateCrewProjectInsFormIsDcaApprovedMutationVariables>;

/**
 * __useUpdateCrewProjectInsFormIsDcaApprovedMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectInsFormIsDcaApprovedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectInsFormIsDcaApprovedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectInsFormIsDcaApprovedMutation, { data, loading, error }] = useUpdateCrewProjectInsFormIsDcaApprovedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCrewProjectInsFormIsDcaApprovedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectInsFormIsDcaApprovedMutation, UpdateCrewProjectInsFormIsDcaApprovedMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectInsFormIsDcaApprovedMutation, UpdateCrewProjectInsFormIsDcaApprovedMutationVariables>(UpdateCrewProjectInsFormIsDcaApprovedDocument, baseOptions);
      }
export type UpdateCrewProjectInsFormIsDcaApprovedMutationHookResult = ReturnType<typeof useUpdateCrewProjectInsFormIsDcaApprovedMutation>;
export type UpdateCrewProjectInsFormIsDcaApprovedMutationResult = Apollo.MutationResult<UpdateCrewProjectInsFormIsDcaApprovedMutation>;
export type UpdateCrewProjectInsFormIsDcaApprovedMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectInsFormIsDcaApprovedMutation, UpdateCrewProjectInsFormIsDcaApprovedMutationVariables>;
export const AddCrewProjectInsFormVersionCommentDocument = gql`
    mutation addCrewProjectInsFormVersionComment($id: Int!, $input: CommentInput!) {
  addCrewProjectInsFormVersionComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddCrewProjectInsFormVersionCommentMutationFn = Apollo.MutationFunction<AddCrewProjectInsFormVersionCommentMutation, AddCrewProjectInsFormVersionCommentMutationVariables>;

/**
 * __useAddCrewProjectInsFormVersionCommentMutation__
 *
 * To run a mutation, you first call `useAddCrewProjectInsFormVersionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCrewProjectInsFormVersionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCrewProjectInsFormVersionCommentMutation, { data, loading, error }] = useAddCrewProjectInsFormVersionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCrewProjectInsFormVersionCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCrewProjectInsFormVersionCommentMutation, AddCrewProjectInsFormVersionCommentMutationVariables>) {
        return Apollo.useMutation<AddCrewProjectInsFormVersionCommentMutation, AddCrewProjectInsFormVersionCommentMutationVariables>(AddCrewProjectInsFormVersionCommentDocument, baseOptions);
      }
export type AddCrewProjectInsFormVersionCommentMutationHookResult = ReturnType<typeof useAddCrewProjectInsFormVersionCommentMutation>;
export type AddCrewProjectInsFormVersionCommentMutationResult = Apollo.MutationResult<AddCrewProjectInsFormVersionCommentMutation>;
export type AddCrewProjectInsFormVersionCommentMutationOptions = Apollo.BaseMutationOptions<AddCrewProjectInsFormVersionCommentMutation, AddCrewProjectInsFormVersionCommentMutationVariables>;
export const UpdateCrewProjectInsFormVersionCommentDocument = gql`
    mutation updateCrewProjectInsFormVersionComment($id: Int!, $body: String!) {
  updateCrewProjectInsFormVersionComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateCrewProjectInsFormVersionCommentMutationFn = Apollo.MutationFunction<UpdateCrewProjectInsFormVersionCommentMutation, UpdateCrewProjectInsFormVersionCommentMutationVariables>;

/**
 * __useUpdateCrewProjectInsFormVersionCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectInsFormVersionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectInsFormVersionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectInsFormVersionCommentMutation, { data, loading, error }] = useUpdateCrewProjectInsFormVersionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateCrewProjectInsFormVersionCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectInsFormVersionCommentMutation, UpdateCrewProjectInsFormVersionCommentMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectInsFormVersionCommentMutation, UpdateCrewProjectInsFormVersionCommentMutationVariables>(UpdateCrewProjectInsFormVersionCommentDocument, baseOptions);
      }
export type UpdateCrewProjectInsFormVersionCommentMutationHookResult = ReturnType<typeof useUpdateCrewProjectInsFormVersionCommentMutation>;
export type UpdateCrewProjectInsFormVersionCommentMutationResult = Apollo.MutationResult<UpdateCrewProjectInsFormVersionCommentMutation>;
export type UpdateCrewProjectInsFormVersionCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectInsFormVersionCommentMutation, UpdateCrewProjectInsFormVersionCommentMutationVariables>;
export const ClearCrewProjectInsFormVersionSignatureByIdDocument = gql`
    mutation clearCrewProjectInsFormVersionSignatureById($projectInsFormVersionId: Int!, $fieldNumber: Int!) {
  clearCrewProjectInsFormVersionSignatureById(projectInsFormVersionId: $projectInsFormVersionId, fieldNumber: $fieldNumber)
}
    `;
export type ClearCrewProjectInsFormVersionSignatureByIdMutationFn = Apollo.MutationFunction<ClearCrewProjectInsFormVersionSignatureByIdMutation, ClearCrewProjectInsFormVersionSignatureByIdMutationVariables>;

/**
 * __useClearCrewProjectInsFormVersionSignatureByIdMutation__
 *
 * To run a mutation, you first call `useClearCrewProjectInsFormVersionSignatureByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearCrewProjectInsFormVersionSignatureByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearCrewProjectInsFormVersionSignatureByIdMutation, { data, loading, error }] = useClearCrewProjectInsFormVersionSignatureByIdMutation({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *      fieldNumber: // value for 'fieldNumber'
 *   },
 * });
 */
export function useClearCrewProjectInsFormVersionSignatureByIdMutation(baseOptions?: Apollo.MutationHookOptions<ClearCrewProjectInsFormVersionSignatureByIdMutation, ClearCrewProjectInsFormVersionSignatureByIdMutationVariables>) {
        return Apollo.useMutation<ClearCrewProjectInsFormVersionSignatureByIdMutation, ClearCrewProjectInsFormVersionSignatureByIdMutationVariables>(ClearCrewProjectInsFormVersionSignatureByIdDocument, baseOptions);
      }
export type ClearCrewProjectInsFormVersionSignatureByIdMutationHookResult = ReturnType<typeof useClearCrewProjectInsFormVersionSignatureByIdMutation>;
export type ClearCrewProjectInsFormVersionSignatureByIdMutationResult = Apollo.MutationResult<ClearCrewProjectInsFormVersionSignatureByIdMutation>;
export type ClearCrewProjectInsFormVersionSignatureByIdMutationOptions = Apollo.BaseMutationOptions<ClearCrewProjectInsFormVersionSignatureByIdMutation, ClearCrewProjectInsFormVersionSignatureByIdMutationVariables>;
export const CrewProjectEmailHistoryDocument = gql`
    query crewProjectEmailHistory($crewProjectId: Int!, $sortBy: EmailHistorySortBy, $sortDirection: SortDirection) {
  crewProjectEmailHistory(crewProjectId: $crewProjectId, sortBy: $sortBy, sortDirection: $sortDirection) {
    ...emailHistory
  }
}
    ${EmailHistoryFragmentDoc}`;

/**
 * __useCrewProjectEmailHistoryQuery__
 *
 * To run a query within a React component, call `useCrewProjectEmailHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectEmailHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectEmailHistoryQuery({
 *   variables: {
 *      crewProjectId: // value for 'crewProjectId'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useCrewProjectEmailHistoryQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectEmailHistoryQuery, CrewProjectEmailHistoryQueryVariables>) {
        return Apollo.useQuery<CrewProjectEmailHistoryQuery, CrewProjectEmailHistoryQueryVariables>(CrewProjectEmailHistoryDocument, baseOptions);
      }
export function useCrewProjectEmailHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectEmailHistoryQuery, CrewProjectEmailHistoryQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectEmailHistoryQuery, CrewProjectEmailHistoryQueryVariables>(CrewProjectEmailHistoryDocument, baseOptions);
        }
export type CrewProjectEmailHistoryQueryHookResult = ReturnType<typeof useCrewProjectEmailHistoryQuery>;
export type CrewProjectEmailHistoryLazyQueryHookResult = ReturnType<typeof useCrewProjectEmailHistoryLazyQuery>;
export type CrewProjectEmailHistoryQueryResult = Apollo.QueryResult<CrewProjectEmailHistoryQuery, CrewProjectEmailHistoryQueryVariables>;
export const CrewProjectHistoryDocument = gql`
    query crewProjectHistory($crewProjectId: Int!) {
  crewProjectHistory(crewProjectId: $crewProjectId) {
    ...projectHistory
  }
}
    ${ProjectHistoryFragmentDoc}`;

/**
 * __useCrewProjectHistoryQuery__
 *
 * To run a query within a React component, call `useCrewProjectHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectHistoryQuery({
 *   variables: {
 *      crewProjectId: // value for 'crewProjectId'
 *   },
 * });
 */
export function useCrewProjectHistoryQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectHistoryQuery, CrewProjectHistoryQueryVariables>) {
        return Apollo.useQuery<CrewProjectHistoryQuery, CrewProjectHistoryQueryVariables>(CrewProjectHistoryDocument, baseOptions);
      }
export function useCrewProjectHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectHistoryQuery, CrewProjectHistoryQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectHistoryQuery, CrewProjectHistoryQueryVariables>(CrewProjectHistoryDocument, baseOptions);
        }
export type CrewProjectHistoryQueryHookResult = ReturnType<typeof useCrewProjectHistoryQuery>;
export type CrewProjectHistoryLazyQueryHookResult = ReturnType<typeof useCrewProjectHistoryLazyQuery>;
export type CrewProjectHistoryQueryResult = Apollo.QueryResult<CrewProjectHistoryQuery, CrewProjectHistoryQueryVariables>;
export const CrewProjectSummaryTabDocument = gql`
    query crewProjectSummaryTab($crewProjectId: Int!) {
  crewProject(id: $crewProjectId) {
    id
    crewProjectType {
      id
      name
    }
    crewProjectSpecialProjectType {
      id
      name
    }
    crewProjectRenewalTypes {
      id
      name
    }
    projectStatus {
      id
    }
    firstName
    lastName
    country {
      id
      name
    }
    crewLicenseType {
      id
      name
    }
    licenseNumber
    crewPosition {
      id
      name
    }
    validationNumber
    operators {
      id
      company {
        name
      }
    }
    provisionalOperatorNames
    aircrafts {
      id
      registrationMark
      aircraftModel {
        id
        name
      }
    }
    provisionalAircraftRegistrationMarks
    isHighImportance
    isOnHold
    isOnHoldByDca
    dcaHoldReason
    assignees {
      id
      firstName
      lastName
      ...user
    }
    projectCreatedByUser {
      id
      firstName
      lastName
    }
    projectCreationDate
    assignees {
      ...user
    }
    dcaAssigneeUser {
      ...user
    }
    documents {
      id
      document {
        documentType {
          id
          isAlwaysVisibleToDca
        }
        fileAttachment {
          fileName
          fileSizeBytes
          mimeType
        }
      }
      isReleasedToDca
    }
    isNoDcaInvoiceRequired
  }
  dcaHistory: crewProjectHistory(crewProjectId: $crewProjectId, filter: {dcaOnly: true}) {
    performedByName
    date
    projectStatus {
      id
      name
    }
    projectTransition {
      id
      name
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useCrewProjectSummaryTabQuery__
 *
 * To run a query within a React component, call `useCrewProjectSummaryTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectSummaryTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectSummaryTabQuery({
 *   variables: {
 *      crewProjectId: // value for 'crewProjectId'
 *   },
 * });
 */
export function useCrewProjectSummaryTabQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectSummaryTabQuery, CrewProjectSummaryTabQueryVariables>) {
        return Apollo.useQuery<CrewProjectSummaryTabQuery, CrewProjectSummaryTabQueryVariables>(CrewProjectSummaryTabDocument, baseOptions);
      }
export function useCrewProjectSummaryTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectSummaryTabQuery, CrewProjectSummaryTabQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectSummaryTabQuery, CrewProjectSummaryTabQueryVariables>(CrewProjectSummaryTabDocument, baseOptions);
        }
export type CrewProjectSummaryTabQueryHookResult = ReturnType<typeof useCrewProjectSummaryTabQuery>;
export type CrewProjectSummaryTabLazyQueryHookResult = ReturnType<typeof useCrewProjectSummaryTabLazyQuery>;
export type CrewProjectSummaryTabQueryResult = Apollo.QueryResult<CrewProjectSummaryTabQuery, CrewProjectSummaryTabQueryVariables>;
export const CrewProjectOfficialLetterNotesDocument = gql`
    query crewProjectOfficialLetterNotes($crewProjectId: Int!) {
  crewProject(id: $crewProjectId) {
    officialLetterDocumentsNote
    documentTypeOfficialLetterNotes {
      documentType {
        id
        name
      }
      officialLetterNote
    }
  }
}
    `;

/**
 * __useCrewProjectOfficialLetterNotesQuery__
 *
 * To run a query within a React component, call `useCrewProjectOfficialLetterNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectOfficialLetterNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectOfficialLetterNotesQuery({
 *   variables: {
 *      crewProjectId: // value for 'crewProjectId'
 *   },
 * });
 */
export function useCrewProjectOfficialLetterNotesQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectOfficialLetterNotesQuery, CrewProjectOfficialLetterNotesQueryVariables>) {
        return Apollo.useQuery<CrewProjectOfficialLetterNotesQuery, CrewProjectOfficialLetterNotesQueryVariables>(CrewProjectOfficialLetterNotesDocument, baseOptions);
      }
export function useCrewProjectOfficialLetterNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectOfficialLetterNotesQuery, CrewProjectOfficialLetterNotesQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectOfficialLetterNotesQuery, CrewProjectOfficialLetterNotesQueryVariables>(CrewProjectOfficialLetterNotesDocument, baseOptions);
        }
export type CrewProjectOfficialLetterNotesQueryHookResult = ReturnType<typeof useCrewProjectOfficialLetterNotesQuery>;
export type CrewProjectOfficialLetterNotesLazyQueryHookResult = ReturnType<typeof useCrewProjectOfficialLetterNotesLazyQuery>;
export type CrewProjectOfficialLetterNotesQueryResult = Apollo.QueryResult<CrewProjectOfficialLetterNotesQuery, CrewProjectOfficialLetterNotesQueryVariables>;
export const UpdateCrewProjectOfficialLetterDocumentNotesDocument = gql`
    mutation updateCrewProjectOfficialLetterDocumentNotes($input: UpdateCrewProjectOfficialLetterNotesInput!) {
  updateCrewProjectOfficialLetterDocumentNotes(input: $input) {
    id
  }
}
    `;
export type UpdateCrewProjectOfficialLetterDocumentNotesMutationFn = Apollo.MutationFunction<UpdateCrewProjectOfficialLetterDocumentNotesMutation, UpdateCrewProjectOfficialLetterDocumentNotesMutationVariables>;

/**
 * __useUpdateCrewProjectOfficialLetterDocumentNotesMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectOfficialLetterDocumentNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectOfficialLetterDocumentNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectOfficialLetterDocumentNotesMutation, { data, loading, error }] = useUpdateCrewProjectOfficialLetterDocumentNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCrewProjectOfficialLetterDocumentNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectOfficialLetterDocumentNotesMutation, UpdateCrewProjectOfficialLetterDocumentNotesMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectOfficialLetterDocumentNotesMutation, UpdateCrewProjectOfficialLetterDocumentNotesMutationVariables>(UpdateCrewProjectOfficialLetterDocumentNotesDocument, baseOptions);
      }
export type UpdateCrewProjectOfficialLetterDocumentNotesMutationHookResult = ReturnType<typeof useUpdateCrewProjectOfficialLetterDocumentNotesMutation>;
export type UpdateCrewProjectOfficialLetterDocumentNotesMutationResult = Apollo.MutationResult<UpdateCrewProjectOfficialLetterDocumentNotesMutation>;
export type UpdateCrewProjectOfficialLetterDocumentNotesMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectOfficialLetterDocumentNotesMutation, UpdateCrewProjectOfficialLetterDocumentNotesMutationVariables>;
export const SendCrewProjectEmailDocument = gql`
    mutation sendCrewProjectEmail($crewProjectId: Int!, $email: EmailInput!) {
  sendCrewProjectEmail(crewProjectId: $crewProjectId, email: $email) {
    id
  }
}
    `;
export type SendCrewProjectEmailMutationFn = Apollo.MutationFunction<SendCrewProjectEmailMutation, SendCrewProjectEmailMutationVariables>;

/**
 * __useSendCrewProjectEmailMutation__
 *
 * To run a mutation, you first call `useSendCrewProjectEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCrewProjectEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCrewProjectEmailMutation, { data, loading, error }] = useSendCrewProjectEmailMutation({
 *   variables: {
 *      crewProjectId: // value for 'crewProjectId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendCrewProjectEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendCrewProjectEmailMutation, SendCrewProjectEmailMutationVariables>) {
        return Apollo.useMutation<SendCrewProjectEmailMutation, SendCrewProjectEmailMutationVariables>(SendCrewProjectEmailDocument, baseOptions);
      }
export type SendCrewProjectEmailMutationHookResult = ReturnType<typeof useSendCrewProjectEmailMutation>;
export type SendCrewProjectEmailMutationResult = Apollo.MutationResult<SendCrewProjectEmailMutation>;
export type SendCrewProjectEmailMutationOptions = Apollo.BaseMutationOptions<SendCrewProjectEmailMutation, SendCrewProjectEmailMutationVariables>;
export const UpdateCrewProjectCommentsLastViewedDateDocument = gql`
    mutation updateCrewProjectCommentsLastViewedDate($id: Int!) {
  updateCrewProjectCommentsLastViewedDate(crewProjectId: $id) {
    id
  }
}
    `;
export type UpdateCrewProjectCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateCrewProjectCommentsLastViewedDateMutation, UpdateCrewProjectCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateCrewProjectCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateCrewProjectCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCrewProjectCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectCommentsLastViewedDateMutation, UpdateCrewProjectCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectCommentsLastViewedDateMutation, UpdateCrewProjectCommentsLastViewedDateMutationVariables>(UpdateCrewProjectCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateCrewProjectCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateCrewProjectCommentsLastViewedDateMutation>;
export type UpdateCrewProjectCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateCrewProjectCommentsLastViewedDateMutation>;
export type UpdateCrewProjectCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectCommentsLastViewedDateMutation, UpdateCrewProjectCommentsLastViewedDateMutationVariables>;
export const UpdateCrewProjectDcaCommentsLastViewedDateDocument = gql`
    mutation updateCrewProjectDcaCommentsLastViewedDate($id: Int!) {
  updateCrewProjectDcaCommentsLastViewedDate(crewProjectId: $id) {
    id
  }
}
    `;
export type UpdateCrewProjectDcaCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateCrewProjectDcaCommentsLastViewedDateMutation, UpdateCrewProjectDcaCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateCrewProjectDcaCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectDcaCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectDcaCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectDcaCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateCrewProjectDcaCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCrewProjectDcaCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectDcaCommentsLastViewedDateMutation, UpdateCrewProjectDcaCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectDcaCommentsLastViewedDateMutation, UpdateCrewProjectDcaCommentsLastViewedDateMutationVariables>(UpdateCrewProjectDcaCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateCrewProjectDcaCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateCrewProjectDcaCommentsLastViewedDateMutation>;
export type UpdateCrewProjectDcaCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateCrewProjectDcaCommentsLastViewedDateMutation>;
export type UpdateCrewProjectDcaCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectDcaCommentsLastViewedDateMutation, UpdateCrewProjectDcaCommentsLastViewedDateMutationVariables>;
export const CrewProjectAssignableUsersDocument = gql`
    query crewProjectAssignableUsers {
  crewProjectAssignableUsers {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useCrewProjectAssignableUsersQuery__
 *
 * To run a query within a React component, call `useCrewProjectAssignableUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectAssignableUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectAssignableUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrewProjectAssignableUsersQuery(baseOptions?: Apollo.QueryHookOptions<CrewProjectAssignableUsersQuery, CrewProjectAssignableUsersQueryVariables>) {
        return Apollo.useQuery<CrewProjectAssignableUsersQuery, CrewProjectAssignableUsersQueryVariables>(CrewProjectAssignableUsersDocument, baseOptions);
      }
export function useCrewProjectAssignableUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectAssignableUsersQuery, CrewProjectAssignableUsersQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectAssignableUsersQuery, CrewProjectAssignableUsersQueryVariables>(CrewProjectAssignableUsersDocument, baseOptions);
        }
export type CrewProjectAssignableUsersQueryHookResult = ReturnType<typeof useCrewProjectAssignableUsersQuery>;
export type CrewProjectAssignableUsersLazyQueryHookResult = ReturnType<typeof useCrewProjectAssignableUsersLazyQuery>;
export type CrewProjectAssignableUsersQueryResult = Apollo.QueryResult<CrewProjectAssignableUsersQuery, CrewProjectAssignableUsersQueryVariables>;
export const SetCrewProjectAssigneesDocument = gql`
    mutation setCrewProjectAssignees($crewProjectId: Int!, $assigneeUserIds: [Int!]!) {
  setCrewProjectAssignees(crewProjectId: $crewProjectId, assigneeUserIds: $assigneeUserIds) {
    id
  }
}
    `;
export type SetCrewProjectAssigneesMutationFn = Apollo.MutationFunction<SetCrewProjectAssigneesMutation, SetCrewProjectAssigneesMutationVariables>;

/**
 * __useSetCrewProjectAssigneesMutation__
 *
 * To run a mutation, you first call `useSetCrewProjectAssigneesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCrewProjectAssigneesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCrewProjectAssigneesMutation, { data, loading, error }] = useSetCrewProjectAssigneesMutation({
 *   variables: {
 *      crewProjectId: // value for 'crewProjectId'
 *      assigneeUserIds: // value for 'assigneeUserIds'
 *   },
 * });
 */
export function useSetCrewProjectAssigneesMutation(baseOptions?: Apollo.MutationHookOptions<SetCrewProjectAssigneesMutation, SetCrewProjectAssigneesMutationVariables>) {
        return Apollo.useMutation<SetCrewProjectAssigneesMutation, SetCrewProjectAssigneesMutationVariables>(SetCrewProjectAssigneesDocument, baseOptions);
      }
export type SetCrewProjectAssigneesMutationHookResult = ReturnType<typeof useSetCrewProjectAssigneesMutation>;
export type SetCrewProjectAssigneesMutationResult = Apollo.MutationResult<SetCrewProjectAssigneesMutation>;
export type SetCrewProjectAssigneesMutationOptions = Apollo.BaseMutationOptions<SetCrewProjectAssigneesMutation, SetCrewProjectAssigneesMutationVariables>;
export const SetCrewProjectPriorityDocument = gql`
    mutation setCrewProjectPriority($id: Int!, $isHighPriority: Boolean!) {
  setCrewProjectPriority(id: $id, isHighPriority: $isHighPriority) {
    id
  }
}
    `;
export type SetCrewProjectPriorityMutationFn = Apollo.MutationFunction<SetCrewProjectPriorityMutation, SetCrewProjectPriorityMutationVariables>;

/**
 * __useSetCrewProjectPriorityMutation__
 *
 * To run a mutation, you first call `useSetCrewProjectPriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCrewProjectPriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCrewProjectPriorityMutation, { data, loading, error }] = useSetCrewProjectPriorityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isHighPriority: // value for 'isHighPriority'
 *   },
 * });
 */
export function useSetCrewProjectPriorityMutation(baseOptions?: Apollo.MutationHookOptions<SetCrewProjectPriorityMutation, SetCrewProjectPriorityMutationVariables>) {
        return Apollo.useMutation<SetCrewProjectPriorityMutation, SetCrewProjectPriorityMutationVariables>(SetCrewProjectPriorityDocument, baseOptions);
      }
export type SetCrewProjectPriorityMutationHookResult = ReturnType<typeof useSetCrewProjectPriorityMutation>;
export type SetCrewProjectPriorityMutationResult = Apollo.MutationResult<SetCrewProjectPriorityMutation>;
export type SetCrewProjectPriorityMutationOptions = Apollo.BaseMutationOptions<SetCrewProjectPriorityMutation, SetCrewProjectPriorityMutationVariables>;
export const SetCrewProjectNoDcaInvoiceRequiredFlagDocument = gql`
    mutation setCrewProjectNoDcaInvoiceRequiredFlag($id: Int!, $isNoDcaInvoiceRequired: Boolean!) {
  setCrewProjectNoDcaInvoiceRequiredFlag(id: $id, isNoDcaInvoiceRequired: $isNoDcaInvoiceRequired)
}
    `;
export type SetCrewProjectNoDcaInvoiceRequiredFlagMutationFn = Apollo.MutationFunction<SetCrewProjectNoDcaInvoiceRequiredFlagMutation, SetCrewProjectNoDcaInvoiceRequiredFlagMutationVariables>;

/**
 * __useSetCrewProjectNoDcaInvoiceRequiredFlagMutation__
 *
 * To run a mutation, you first call `useSetCrewProjectNoDcaInvoiceRequiredFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCrewProjectNoDcaInvoiceRequiredFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCrewProjectNoDcaInvoiceRequiredFlagMutation, { data, loading, error }] = useSetCrewProjectNoDcaInvoiceRequiredFlagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isNoDcaInvoiceRequired: // value for 'isNoDcaInvoiceRequired'
 *   },
 * });
 */
export function useSetCrewProjectNoDcaInvoiceRequiredFlagMutation(baseOptions?: Apollo.MutationHookOptions<SetCrewProjectNoDcaInvoiceRequiredFlagMutation, SetCrewProjectNoDcaInvoiceRequiredFlagMutationVariables>) {
        return Apollo.useMutation<SetCrewProjectNoDcaInvoiceRequiredFlagMutation, SetCrewProjectNoDcaInvoiceRequiredFlagMutationVariables>(SetCrewProjectNoDcaInvoiceRequiredFlagDocument, baseOptions);
      }
export type SetCrewProjectNoDcaInvoiceRequiredFlagMutationHookResult = ReturnType<typeof useSetCrewProjectNoDcaInvoiceRequiredFlagMutation>;
export type SetCrewProjectNoDcaInvoiceRequiredFlagMutationResult = Apollo.MutationResult<SetCrewProjectNoDcaInvoiceRequiredFlagMutation>;
export type SetCrewProjectNoDcaInvoiceRequiredFlagMutationOptions = Apollo.BaseMutationOptions<SetCrewProjectNoDcaInvoiceRequiredFlagMutation, SetCrewProjectNoDcaInvoiceRequiredFlagMutationVariables>;
export const CrewProjectEmailViewDocument = gql`
    query crewProjectEmailView($id: Int!, $emailId: Int!, $includeFileAttachments: Boolean = false, $includeFileContent: Boolean = false) {
  crewProject(id: $id) {
    emails(filter: {id_in: [$emailId]}) {
      ...email
    }
  }
}
    ${EmailFragmentDoc}`;

/**
 * __useCrewProjectEmailViewQuery__
 *
 * To run a query within a React component, call `useCrewProjectEmailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectEmailViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectEmailViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      emailId: // value for 'emailId'
 *      includeFileAttachments: // value for 'includeFileAttachments'
 *      includeFileContent: // value for 'includeFileContent'
 *   },
 * });
 */
export function useCrewProjectEmailViewQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectEmailViewQuery, CrewProjectEmailViewQueryVariables>) {
        return Apollo.useQuery<CrewProjectEmailViewQuery, CrewProjectEmailViewQueryVariables>(CrewProjectEmailViewDocument, baseOptions);
      }
export function useCrewProjectEmailViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectEmailViewQuery, CrewProjectEmailViewQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectEmailViewQuery, CrewProjectEmailViewQueryVariables>(CrewProjectEmailViewDocument, baseOptions);
        }
export type CrewProjectEmailViewQueryHookResult = ReturnType<typeof useCrewProjectEmailViewQuery>;
export type CrewProjectEmailViewLazyQueryHookResult = ReturnType<typeof useCrewProjectEmailViewLazyQuery>;
export type CrewProjectEmailViewQueryResult = Apollo.QueryResult<CrewProjectEmailViewQuery, CrewProjectEmailViewQueryVariables>;
export const DownloadCrewProjectEmailAttachmentContentDocument = gql`
    query downloadCrewProjectEmailAttachmentContent($crewProjectId: Int!, $emailId: Int!, $attachmentId: Int!) {
  downloadCrewProjectEmailAttachmentContent(crewProjectId: $crewProjectId, emailId: $emailId, attachmentId: $attachmentId)
}
    `;

/**
 * __useDownloadCrewProjectEmailAttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadCrewProjectEmailAttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCrewProjectEmailAttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCrewProjectEmailAttachmentContentQuery({
 *   variables: {
 *      crewProjectId: // value for 'crewProjectId'
 *      emailId: // value for 'emailId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDownloadCrewProjectEmailAttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadCrewProjectEmailAttachmentContentQuery, DownloadCrewProjectEmailAttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadCrewProjectEmailAttachmentContentQuery, DownloadCrewProjectEmailAttachmentContentQueryVariables>(DownloadCrewProjectEmailAttachmentContentDocument, baseOptions);
      }
export function useDownloadCrewProjectEmailAttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCrewProjectEmailAttachmentContentQuery, DownloadCrewProjectEmailAttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadCrewProjectEmailAttachmentContentQuery, DownloadCrewProjectEmailAttachmentContentQueryVariables>(DownloadCrewProjectEmailAttachmentContentDocument, baseOptions);
        }
export type DownloadCrewProjectEmailAttachmentContentQueryHookResult = ReturnType<typeof useDownloadCrewProjectEmailAttachmentContentQuery>;
export type DownloadCrewProjectEmailAttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadCrewProjectEmailAttachmentContentLazyQuery>;
export type DownloadCrewProjectEmailAttachmentContentQueryResult = Apollo.QueryResult<DownloadCrewProjectEmailAttachmentContentQuery, DownloadCrewProjectEmailAttachmentContentQueryVariables>;
export const CrewProjectApplicationTabQueryDocument = gql`
    query crewProjectApplicationTabQuery($id: Int!) {
  crewProject(id: $id) {
    id
    crewProjectType {
      id
      name
    }
    crewProjectSpecialProjectType {
      id
      name
    }
    crewProjectRenewalTypes {
      id
    }
    certificateFirstIssuedDate
    certificateDateOfIssue
    validationNumber
    certificateExpiryDate
    clientSubmissionDate
    dcaSubmissionDate
    firstName
    lastName
    crewPosition {
      id
    }
    country {
      id
    }
    crewLicenseType {
      id
    }
    licenseNumber
    elpLevel {
      id
    }
    elpExpiryDate
    operators {
      ...crewProjectOperator
    }
    provisionalOperatorNames
    genericLvCompanies {
      ...crewProjectGenericLvCompany
    }
    crewProjectCategory {
      id
    }
    aircraftModels {
      ...aircraftModel
    }
    employmentCompanies {
      ...crewProjectEmploymentCompany
    }
    crewRatings {
      ...crewProjectCrewRating
    }
    aircrafts {
      ...crewProjectAircraft
    }
    provisionalAircraftRegistrationMarks
    associatedAircraftProject {
      id
    }
  }
  crewPositions(includeDeleted: true) {
    ...crewProjectCrewPosition
  }
  elpLevels(includeDeleted: true) {
    ...crewProjectElpLevel
  }
  crewProjectCategories(includeDeleted: true) {
    ...crewProjectCategory
  }
  genericLvCompanies(includeDeleted: true) {
    ...crewProjectGenericLvCompany
  }
  aircraftModels(includeDeleted: true) {
    ...aircraftModel
  }
  employmentCompanies(includeDeleted: true) {
    ...crewProjectEmploymentCompany
  }
  crewRatings(includeDeleted: true) {
    ...crewProjectCrewRating
  }
  operators(includeInactive: true, includeDeleted: true, sortBy: name, sortDirection: "ASC") {
    ... on Operators {
      operators {
        ...crewProjectOperator
      }
    }
  }
}
    ${CrewProjectOperatorFragmentDoc}
${CrewProjectGenericLvCompanyFragmentDoc}
${AircraftModelFragmentDoc}
${CrewProjectEmploymentCompanyFragmentDoc}
${CrewProjectCrewRatingFragmentDoc}
${CrewProjectAircraftFragmentDoc}
${CrewProjectCrewPositionFragmentDoc}
${CrewProjectElpLevelFragmentDoc}
${CrewProjectCategoryFragmentDoc}`;

/**
 * __useCrewProjectApplicationTabQueryQuery__
 *
 * To run a query within a React component, call `useCrewProjectApplicationTabQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectApplicationTabQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectApplicationTabQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCrewProjectApplicationTabQueryQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectApplicationTabQueryQuery, CrewProjectApplicationTabQueryQueryVariables>) {
        return Apollo.useQuery<CrewProjectApplicationTabQueryQuery, CrewProjectApplicationTabQueryQueryVariables>(CrewProjectApplicationTabQueryDocument, baseOptions);
      }
export function useCrewProjectApplicationTabQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectApplicationTabQueryQuery, CrewProjectApplicationTabQueryQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectApplicationTabQueryQuery, CrewProjectApplicationTabQueryQueryVariables>(CrewProjectApplicationTabQueryDocument, baseOptions);
        }
export type CrewProjectApplicationTabQueryQueryHookResult = ReturnType<typeof useCrewProjectApplicationTabQueryQuery>;
export type CrewProjectApplicationTabQueryLazyQueryHookResult = ReturnType<typeof useCrewProjectApplicationTabQueryLazyQuery>;
export type CrewProjectApplicationTabQueryQueryResult = Apollo.QueryResult<CrewProjectApplicationTabQueryQuery, CrewProjectApplicationTabQueryQueryVariables>;
export const UpdateCrewProjectMutationDocument = gql`
    mutation updateCrewProjectMutation($updateCrewProjectInput: UpdateCrewProjectInput!, $recordHistory: Boolean, $ignoreWarnings: Boolean) {
  updateCrewProject(updateCrewProjectInput: $updateCrewProjectInput, recordHistory: $recordHistory, ignoreWarnings: $ignoreWarnings) {
    warnings
  }
}
    `;
export type UpdateCrewProjectMutationMutationFn = Apollo.MutationFunction<UpdateCrewProjectMutationMutation, UpdateCrewProjectMutationMutationVariables>;

/**
 * __useUpdateCrewProjectMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectMutationMutation, { data, loading, error }] = useUpdateCrewProjectMutationMutation({
 *   variables: {
 *      updateCrewProjectInput: // value for 'updateCrewProjectInput'
 *      recordHistory: // value for 'recordHistory'
 *      ignoreWarnings: // value for 'ignoreWarnings'
 *   },
 * });
 */
export function useUpdateCrewProjectMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectMutationMutation, UpdateCrewProjectMutationMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectMutationMutation, UpdateCrewProjectMutationMutationVariables>(UpdateCrewProjectMutationDocument, baseOptions);
      }
export type UpdateCrewProjectMutationMutationHookResult = ReturnType<typeof useUpdateCrewProjectMutationMutation>;
export type UpdateCrewProjectMutationMutationResult = Apollo.MutationResult<UpdateCrewProjectMutationMutation>;
export type UpdateCrewProjectMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectMutationMutation, UpdateCrewProjectMutationMutationVariables>;
export const DashboardUserDocument = gql`
    query dashboardUser($id: Int!) {
  user(id: $id) {
    id
    operator {
      id
    }
    inspector {
      id
    }
  }
}
    `;

/**
 * __useDashboardUserQuery__
 *
 * To run a query within a React component, call `useDashboardUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardUserQuery(baseOptions: Apollo.QueryHookOptions<DashboardUserQuery, DashboardUserQueryVariables>) {
        return Apollo.useQuery<DashboardUserQuery, DashboardUserQueryVariables>(DashboardUserDocument, baseOptions);
      }
export function useDashboardUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardUserQuery, DashboardUserQueryVariables>) {
          return Apollo.useLazyQuery<DashboardUserQuery, DashboardUserQueryVariables>(DashboardUserDocument, baseOptions);
        }
export type DashboardUserQueryHookResult = ReturnType<typeof useDashboardUserQuery>;
export type DashboardUserLazyQueryHookResult = ReturnType<typeof useDashboardUserLazyQuery>;
export type DashboardUserQueryResult = Apollo.QueryResult<DashboardUserQuery, DashboardUserQueryVariables>;
export const AircraftLicensingGridDocument = gql`
    query aircraftLicensingGrid($registrationMark: String, $operatorIdIn: [Int!], $projectStatusIdIn: [Int!], $projectStatusIdNotIn: [Int!], $aircraftProjectTypeIdIn: [Int!], $archivedDate: DateRangeFilterInput, $sortBy: AircraftProjectsSortBy, $sortDirection: String) {
  aircraftProjects(registrationMark: $registrationMark, operatorIdIn: $operatorIdIn, projectStatusIdIn: $projectStatusIdIn, projectStatusIdNotIn: $projectStatusIdNotIn, aircraftProjectTypeIdIn: $aircraftProjectTypeIdIn, archivedDate: $archivedDate, sortBy: $sortBy, sortDirection: $sortDirection, isSubmittedToDca: true) {
    ... on AircraftProjects {
      aircraftProjects {
        ...aircraftLicensingGridItem
      }
    }
  }
}
    ${AircraftLicensingGridItemFragmentDoc}`;

/**
 * __useAircraftLicensingGridQuery__
 *
 * To run a query within a React component, call `useAircraftLicensingGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useAircraftLicensingGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAircraftLicensingGridQuery({
 *   variables: {
 *      registrationMark: // value for 'registrationMark'
 *      operatorIdIn: // value for 'operatorIdIn'
 *      projectStatusIdIn: // value for 'projectStatusIdIn'
 *      projectStatusIdNotIn: // value for 'projectStatusIdNotIn'
 *      aircraftProjectTypeIdIn: // value for 'aircraftProjectTypeIdIn'
 *      archivedDate: // value for 'archivedDate'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useAircraftLicensingGridQuery(baseOptions?: Apollo.QueryHookOptions<AircraftLicensingGridQuery, AircraftLicensingGridQueryVariables>) {
        return Apollo.useQuery<AircraftLicensingGridQuery, AircraftLicensingGridQueryVariables>(AircraftLicensingGridDocument, baseOptions);
      }
export function useAircraftLicensingGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AircraftLicensingGridQuery, AircraftLicensingGridQueryVariables>) {
          return Apollo.useLazyQuery<AircraftLicensingGridQuery, AircraftLicensingGridQueryVariables>(AircraftLicensingGridDocument, baseOptions);
        }
export type AircraftLicensingGridQueryHookResult = ReturnType<typeof useAircraftLicensingGridQuery>;
export type AircraftLicensingGridLazyQueryHookResult = ReturnType<typeof useAircraftLicensingGridLazyQuery>;
export type AircraftLicensingGridQueryResult = Apollo.QueryResult<AircraftLicensingGridQuery, AircraftLicensingGridQueryVariables>;
export const CrewLicenseValidationsGridDocument = gql`
    query crewLicenseValidationsGrid($projectStatusIdIn: [Int!], $projectStatusIdNotIn: [Int!], $archivedDate: DateRangeFilterInput, $certificateDateOfIssue: DateRangeFilterInput, $lastNameContains: String, $validationNumberContains: String, $operatorIdIn: [Int!], $sortBy: CrewProjectsSortBy, $sortDirection: String) {
  crewProjects(projectStatusIdIn: $projectStatusIdIn, projectStatusIdNotIn: $projectStatusIdNotIn, archivedDate: $archivedDate, certificateDateOfIssue: $certificateDateOfIssue, lastNameContains: $lastNameContains, validationNumberContains: $validationNumberContains, operatorIdIn: $operatorIdIn, sortBy: $sortBy, sortDirection: $sortDirection, isSubmittedToDca: true) {
    ... on CrewProjects {
      crewProjects {
        ...crewLicenseValidationsGridItem
      }
    }
  }
}
    ${CrewLicenseValidationsGridItemFragmentDoc}`;

/**
 * __useCrewLicenseValidationsGridQuery__
 *
 * To run a query within a React component, call `useCrewLicenseValidationsGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewLicenseValidationsGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewLicenseValidationsGridQuery({
 *   variables: {
 *      projectStatusIdIn: // value for 'projectStatusIdIn'
 *      projectStatusIdNotIn: // value for 'projectStatusIdNotIn'
 *      archivedDate: // value for 'archivedDate'
 *      certificateDateOfIssue: // value for 'certificateDateOfIssue'
 *      lastNameContains: // value for 'lastNameContains'
 *      validationNumberContains: // value for 'validationNumberContains'
 *      operatorIdIn: // value for 'operatorIdIn'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useCrewLicenseValidationsGridQuery(baseOptions?: Apollo.QueryHookOptions<CrewLicenseValidationsGridQuery, CrewLicenseValidationsGridQueryVariables>) {
        return Apollo.useQuery<CrewLicenseValidationsGridQuery, CrewLicenseValidationsGridQueryVariables>(CrewLicenseValidationsGridDocument, baseOptions);
      }
export function useCrewLicenseValidationsGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewLicenseValidationsGridQuery, CrewLicenseValidationsGridQueryVariables>) {
          return Apollo.useLazyQuery<CrewLicenseValidationsGridQuery, CrewLicenseValidationsGridQueryVariables>(CrewLicenseValidationsGridDocument, baseOptions);
        }
export type CrewLicenseValidationsGridQueryHookResult = ReturnType<typeof useCrewLicenseValidationsGridQuery>;
export type CrewLicenseValidationsGridLazyQueryHookResult = ReturnType<typeof useCrewLicenseValidationsGridLazyQuery>;
export type CrewLicenseValidationsGridQueryResult = Apollo.QueryResult<CrewLicenseValidationsGridQuery, CrewLicenseValidationsGridQueryVariables>;
export const MechanicLicenseValidationsGridDocument = gql`
    query mechanicLicenseValidationsGrid($projectStatusIdIn: [Int!], $projectStatusIdNotIn: [Int!], $archivedDate: DateRangeFilterInput, $certificateDateOfIssue: DateRangeFilterInput, $lastNameContains: String, $validationNumberContains: String, $operatorIdIn: [Int!], $sortBy: MechanicProjectsSortBy, $sortDirection: String) {
  mechanicProjects(projectStatusIdIn: $projectStatusIdIn, projectStatusIdNotIn: $projectStatusIdNotIn, archivedDate: $archivedDate, certificateDateOfIssue: $certificateDateOfIssue, lastNameContains: $lastNameContains, validationNumberContains: $validationNumberContains, operatorIdIn: $operatorIdIn, sortBy: $sortBy, sortDirection: $sortDirection, isSubmittedToDca: true) {
    ... on MechanicProjects {
      mechanicProjects {
        ...mechanicLicenseValidationsGridItem
      }
    }
  }
}
    ${MechanicLicenseValidationsGridItemFragmentDoc}`;

/**
 * __useMechanicLicenseValidationsGridQuery__
 *
 * To run a query within a React component, call `useMechanicLicenseValidationsGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicLicenseValidationsGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicLicenseValidationsGridQuery({
 *   variables: {
 *      projectStatusIdIn: // value for 'projectStatusIdIn'
 *      projectStatusIdNotIn: // value for 'projectStatusIdNotIn'
 *      archivedDate: // value for 'archivedDate'
 *      certificateDateOfIssue: // value for 'certificateDateOfIssue'
 *      lastNameContains: // value for 'lastNameContains'
 *      validationNumberContains: // value for 'validationNumberContains'
 *      operatorIdIn: // value for 'operatorIdIn'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useMechanicLicenseValidationsGridQuery(baseOptions?: Apollo.QueryHookOptions<MechanicLicenseValidationsGridQuery, MechanicLicenseValidationsGridQueryVariables>) {
        return Apollo.useQuery<MechanicLicenseValidationsGridQuery, MechanicLicenseValidationsGridQueryVariables>(MechanicLicenseValidationsGridDocument, baseOptions);
      }
export function useMechanicLicenseValidationsGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicLicenseValidationsGridQuery, MechanicLicenseValidationsGridQueryVariables>) {
          return Apollo.useLazyQuery<MechanicLicenseValidationsGridQuery, MechanicLicenseValidationsGridQueryVariables>(MechanicLicenseValidationsGridDocument, baseOptions);
        }
export type MechanicLicenseValidationsGridQueryHookResult = ReturnType<typeof useMechanicLicenseValidationsGridQuery>;
export type MechanicLicenseValidationsGridLazyQueryHookResult = ReturnType<typeof useMechanicLicenseValidationsGridLazyQuery>;
export type MechanicLicenseValidationsGridQueryResult = Apollo.QueryResult<MechanicLicenseValidationsGridQuery, MechanicLicenseValidationsGridQueryVariables>;
export const CrewProjectInformationForInsFormDocument = gql`
    query crewProjectInformationForInsForm($id: Int!) {
  crewProject(id: $id) {
    projectStatus {
      id
    }
  }
}
    `;

/**
 * __useCrewProjectInformationForInsFormQuery__
 *
 * To run a query within a React component, call `useCrewProjectInformationForInsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrewProjectInformationForInsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrewProjectInformationForInsFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCrewProjectInformationForInsFormQuery(baseOptions: Apollo.QueryHookOptions<CrewProjectInformationForInsFormQuery, CrewProjectInformationForInsFormQueryVariables>) {
        return Apollo.useQuery<CrewProjectInformationForInsFormQuery, CrewProjectInformationForInsFormQueryVariables>(CrewProjectInformationForInsFormDocument, baseOptions);
      }
export function useCrewProjectInformationForInsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrewProjectInformationForInsFormQuery, CrewProjectInformationForInsFormQueryVariables>) {
          return Apollo.useLazyQuery<CrewProjectInformationForInsFormQuery, CrewProjectInformationForInsFormQueryVariables>(CrewProjectInformationForInsFormDocument, baseOptions);
        }
export type CrewProjectInformationForInsFormQueryHookResult = ReturnType<typeof useCrewProjectInformationForInsFormQuery>;
export type CrewProjectInformationForInsFormLazyQueryHookResult = ReturnType<typeof useCrewProjectInformationForInsFormLazyQuery>;
export type CrewProjectInformationForInsFormQueryResult = Apollo.QueryResult<CrewProjectInformationForInsFormQuery, CrewProjectInformationForInsFormQueryVariables>;
export const SignCrewProjectInsFormVersionByExecutionKeyDocument = gql`
    mutation signCrewProjectInsFormVersionByExecutionKey($executionKey: String!, $input: SignProjectInsFormVersionInput!) {
  signCrewProjectInsFormVersionByExecutionKey(executionKey: $executionKey, input: $input)
}
    `;
export type SignCrewProjectInsFormVersionByExecutionKeyMutationFn = Apollo.MutationFunction<SignCrewProjectInsFormVersionByExecutionKeyMutation, SignCrewProjectInsFormVersionByExecutionKeyMutationVariables>;

/**
 * __useSignCrewProjectInsFormVersionByExecutionKeyMutation__
 *
 * To run a mutation, you first call `useSignCrewProjectInsFormVersionByExecutionKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignCrewProjectInsFormVersionByExecutionKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signCrewProjectInsFormVersionByExecutionKeyMutation, { data, loading, error }] = useSignCrewProjectInsFormVersionByExecutionKeyMutation({
 *   variables: {
 *      executionKey: // value for 'executionKey'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignCrewProjectInsFormVersionByExecutionKeyMutation(baseOptions?: Apollo.MutationHookOptions<SignCrewProjectInsFormVersionByExecutionKeyMutation, SignCrewProjectInsFormVersionByExecutionKeyMutationVariables>) {
        return Apollo.useMutation<SignCrewProjectInsFormVersionByExecutionKeyMutation, SignCrewProjectInsFormVersionByExecutionKeyMutationVariables>(SignCrewProjectInsFormVersionByExecutionKeyDocument, baseOptions);
      }
export type SignCrewProjectInsFormVersionByExecutionKeyMutationHookResult = ReturnType<typeof useSignCrewProjectInsFormVersionByExecutionKeyMutation>;
export type SignCrewProjectInsFormVersionByExecutionKeyMutationResult = Apollo.MutationResult<SignCrewProjectInsFormVersionByExecutionKeyMutation>;
export type SignCrewProjectInsFormVersionByExecutionKeyMutationOptions = Apollo.BaseMutationOptions<SignCrewProjectInsFormVersionByExecutionKeyMutation, SignCrewProjectInsFormVersionByExecutionKeyMutationVariables>;
export const ClearCrewProjectInsFormVersionSignatureByExecutionKeyDocument = gql`
    mutation clearCrewProjectInsFormVersionSignatureByExecutionKey($executionKey: String!, $fieldNumber: Int!) {
  clearCrewProjectInsFormVersionSignatureByExecutionKey(executionKey: $executionKey, fieldNumber: $fieldNumber)
}
    `;
export type ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutationFn = Apollo.MutationFunction<ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutation, ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutationVariables>;

/**
 * __useClearCrewProjectInsFormVersionSignatureByExecutionKeyMutation__
 *
 * To run a mutation, you first call `useClearCrewProjectInsFormVersionSignatureByExecutionKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearCrewProjectInsFormVersionSignatureByExecutionKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearCrewProjectInsFormVersionSignatureByExecutionKeyMutation, { data, loading, error }] = useClearCrewProjectInsFormVersionSignatureByExecutionKeyMutation({
 *   variables: {
 *      executionKey: // value for 'executionKey'
 *      fieldNumber: // value for 'fieldNumber'
 *   },
 * });
 */
export function useClearCrewProjectInsFormVersionSignatureByExecutionKeyMutation(baseOptions?: Apollo.MutationHookOptions<ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutation, ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutationVariables>) {
        return Apollo.useMutation<ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutation, ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutationVariables>(ClearCrewProjectInsFormVersionSignatureByExecutionKeyDocument, baseOptions);
      }
export type ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutationHookResult = ReturnType<typeof useClearCrewProjectInsFormVersionSignatureByExecutionKeyMutation>;
export type ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutationResult = Apollo.MutationResult<ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutation>;
export type ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutationOptions = Apollo.BaseMutationOptions<ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutation, ClearCrewProjectInsFormVersionSignatureByExecutionKeyMutationVariables>;
export const DownloadCrewProjectFilledInInsFormByExecutionKeyDocument = gql`
    query downloadCrewProjectFilledInInsFormByExecutionKey($key: String!) {
  file: downloadCrewProjectFilledInInsFormByExecutionKey(key: $key) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadCrewProjectFilledInInsFormByExecutionKeyQuery__
 *
 * To run a query within a React component, call `useDownloadCrewProjectFilledInInsFormByExecutionKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCrewProjectFilledInInsFormByExecutionKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCrewProjectFilledInInsFormByExecutionKeyQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDownloadCrewProjectFilledInInsFormByExecutionKeyQuery(baseOptions: Apollo.QueryHookOptions<DownloadCrewProjectFilledInInsFormByExecutionKeyQuery, DownloadCrewProjectFilledInInsFormByExecutionKeyQueryVariables>) {
        return Apollo.useQuery<DownloadCrewProjectFilledInInsFormByExecutionKeyQuery, DownloadCrewProjectFilledInInsFormByExecutionKeyQueryVariables>(DownloadCrewProjectFilledInInsFormByExecutionKeyDocument, baseOptions);
      }
export function useDownloadCrewProjectFilledInInsFormByExecutionKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCrewProjectFilledInInsFormByExecutionKeyQuery, DownloadCrewProjectFilledInInsFormByExecutionKeyQueryVariables>) {
          return Apollo.useLazyQuery<DownloadCrewProjectFilledInInsFormByExecutionKeyQuery, DownloadCrewProjectFilledInInsFormByExecutionKeyQueryVariables>(DownloadCrewProjectFilledInInsFormByExecutionKeyDocument, baseOptions);
        }
export type DownloadCrewProjectFilledInInsFormByExecutionKeyQueryHookResult = ReturnType<typeof useDownloadCrewProjectFilledInInsFormByExecutionKeyQuery>;
export type DownloadCrewProjectFilledInInsFormByExecutionKeyLazyQueryHookResult = ReturnType<typeof useDownloadCrewProjectFilledInInsFormByExecutionKeyLazyQuery>;
export type DownloadCrewProjectFilledInInsFormByExecutionKeyQueryResult = Apollo.QueryResult<DownloadCrewProjectFilledInInsFormByExecutionKeyQuery, DownloadCrewProjectFilledInInsFormByExecutionKeyQueryVariables>;
export const UpdateCrewProjectInsFormFieldValuesByExecutionKeyDocument = gql`
    mutation updateCrewProjectInsFormFieldValuesByExecutionKey($key: String!, $fieldValues: [UpdateProjectInsFormVersionFieldValueInput!]!) {
  updateCrewProjectInsFormFieldValuesByExecutionKey(key: $key, fieldValues: $fieldValues)
}
    `;
export type UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutationFn = Apollo.MutationFunction<UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutation, UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutationVariables>;

/**
 * __useUpdateCrewProjectInsFormFieldValuesByExecutionKeyMutation__
 *
 * To run a mutation, you first call `useUpdateCrewProjectInsFormFieldValuesByExecutionKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewProjectInsFormFieldValuesByExecutionKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewProjectInsFormFieldValuesByExecutionKeyMutation, { data, loading, error }] = useUpdateCrewProjectInsFormFieldValuesByExecutionKeyMutation({
 *   variables: {
 *      key: // value for 'key'
 *      fieldValues: // value for 'fieldValues'
 *   },
 * });
 */
export function useUpdateCrewProjectInsFormFieldValuesByExecutionKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutation, UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutationVariables>) {
        return Apollo.useMutation<UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutation, UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutationVariables>(UpdateCrewProjectInsFormFieldValuesByExecutionKeyDocument, baseOptions);
      }
export type UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutationHookResult = ReturnType<typeof useUpdateCrewProjectInsFormFieldValuesByExecutionKeyMutation>;
export type UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutationResult = Apollo.MutationResult<UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutation>;
export type UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutationOptions = Apollo.BaseMutationOptions<UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutation, UpdateCrewProjectInsFormFieldValuesByExecutionKeyMutationVariables>;
export const MechanicProjectInformationForInsFormDocument = gql`
    query mechanicProjectInformationForInsForm($id: Int!) {
  mechanicProject(id: $id) {
    projectStatus {
      id
    }
  }
}
    `;

/**
 * __useMechanicProjectInformationForInsFormQuery__
 *
 * To run a query within a React component, call `useMechanicProjectInformationForInsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectInformationForInsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectInformationForInsFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMechanicProjectInformationForInsFormQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectInformationForInsFormQuery, MechanicProjectInformationForInsFormQueryVariables>) {
        return Apollo.useQuery<MechanicProjectInformationForInsFormQuery, MechanicProjectInformationForInsFormQueryVariables>(MechanicProjectInformationForInsFormDocument, baseOptions);
      }
export function useMechanicProjectInformationForInsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectInformationForInsFormQuery, MechanicProjectInformationForInsFormQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectInformationForInsFormQuery, MechanicProjectInformationForInsFormQueryVariables>(MechanicProjectInformationForInsFormDocument, baseOptions);
        }
export type MechanicProjectInformationForInsFormQueryHookResult = ReturnType<typeof useMechanicProjectInformationForInsFormQuery>;
export type MechanicProjectInformationForInsFormLazyQueryHookResult = ReturnType<typeof useMechanicProjectInformationForInsFormLazyQuery>;
export type MechanicProjectInformationForInsFormQueryResult = Apollo.QueryResult<MechanicProjectInformationForInsFormQuery, MechanicProjectInformationForInsFormQueryVariables>;
export const SignMechanicProjectInsFormVersionByExecutionKeyDocument = gql`
    mutation signMechanicProjectInsFormVersionByExecutionKey($executionKey: String!, $input: SignProjectInsFormVersionInput!) {
  signMechanicProjectInsFormVersionByExecutionKey(executionKey: $executionKey, input: $input)
}
    `;
export type SignMechanicProjectInsFormVersionByExecutionKeyMutationFn = Apollo.MutationFunction<SignMechanicProjectInsFormVersionByExecutionKeyMutation, SignMechanicProjectInsFormVersionByExecutionKeyMutationVariables>;

/**
 * __useSignMechanicProjectInsFormVersionByExecutionKeyMutation__
 *
 * To run a mutation, you first call `useSignMechanicProjectInsFormVersionByExecutionKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignMechanicProjectInsFormVersionByExecutionKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signMechanicProjectInsFormVersionByExecutionKeyMutation, { data, loading, error }] = useSignMechanicProjectInsFormVersionByExecutionKeyMutation({
 *   variables: {
 *      executionKey: // value for 'executionKey'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignMechanicProjectInsFormVersionByExecutionKeyMutation(baseOptions?: Apollo.MutationHookOptions<SignMechanicProjectInsFormVersionByExecutionKeyMutation, SignMechanicProjectInsFormVersionByExecutionKeyMutationVariables>) {
        return Apollo.useMutation<SignMechanicProjectInsFormVersionByExecutionKeyMutation, SignMechanicProjectInsFormVersionByExecutionKeyMutationVariables>(SignMechanicProjectInsFormVersionByExecutionKeyDocument, baseOptions);
      }
export type SignMechanicProjectInsFormVersionByExecutionKeyMutationHookResult = ReturnType<typeof useSignMechanicProjectInsFormVersionByExecutionKeyMutation>;
export type SignMechanicProjectInsFormVersionByExecutionKeyMutationResult = Apollo.MutationResult<SignMechanicProjectInsFormVersionByExecutionKeyMutation>;
export type SignMechanicProjectInsFormVersionByExecutionKeyMutationOptions = Apollo.BaseMutationOptions<SignMechanicProjectInsFormVersionByExecutionKeyMutation, SignMechanicProjectInsFormVersionByExecutionKeyMutationVariables>;
export const ClearMechanicProjectInsFormVersionSignatureByExecutionKeyDocument = gql`
    mutation clearMechanicProjectInsFormVersionSignatureByExecutionKey($executionKey: String!, $fieldNumber: Int!) {
  clearMechanicProjectInsFormVersionSignatureByExecutionKey(executionKey: $executionKey, fieldNumber: $fieldNumber)
}
    `;
export type ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutationFn = Apollo.MutationFunction<ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutation, ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutationVariables>;

/**
 * __useClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutation__
 *
 * To run a mutation, you first call `useClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearMechanicProjectInsFormVersionSignatureByExecutionKeyMutation, { data, loading, error }] = useClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutation({
 *   variables: {
 *      executionKey: // value for 'executionKey'
 *      fieldNumber: // value for 'fieldNumber'
 *   },
 * });
 */
export function useClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutation(baseOptions?: Apollo.MutationHookOptions<ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutation, ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutationVariables>) {
        return Apollo.useMutation<ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutation, ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutationVariables>(ClearMechanicProjectInsFormVersionSignatureByExecutionKeyDocument, baseOptions);
      }
export type ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutationHookResult = ReturnType<typeof useClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutation>;
export type ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutationResult = Apollo.MutationResult<ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutation>;
export type ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutationOptions = Apollo.BaseMutationOptions<ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutation, ClearMechanicProjectInsFormVersionSignatureByExecutionKeyMutationVariables>;
export const DownloadMechanicProjectFilledInInsFormByExecutionKeyDocument = gql`
    query downloadMechanicProjectFilledInInsFormByExecutionKey($key: String!) {
  file: downloadMechanicProjectFilledInInsFormByExecutionKey(key: $key) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadMechanicProjectFilledInInsFormByExecutionKeyQuery__
 *
 * To run a query within a React component, call `useDownloadMechanicProjectFilledInInsFormByExecutionKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadMechanicProjectFilledInInsFormByExecutionKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadMechanicProjectFilledInInsFormByExecutionKeyQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDownloadMechanicProjectFilledInInsFormByExecutionKeyQuery(baseOptions: Apollo.QueryHookOptions<DownloadMechanicProjectFilledInInsFormByExecutionKeyQuery, DownloadMechanicProjectFilledInInsFormByExecutionKeyQueryVariables>) {
        return Apollo.useQuery<DownloadMechanicProjectFilledInInsFormByExecutionKeyQuery, DownloadMechanicProjectFilledInInsFormByExecutionKeyQueryVariables>(DownloadMechanicProjectFilledInInsFormByExecutionKeyDocument, baseOptions);
      }
export function useDownloadMechanicProjectFilledInInsFormByExecutionKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadMechanicProjectFilledInInsFormByExecutionKeyQuery, DownloadMechanicProjectFilledInInsFormByExecutionKeyQueryVariables>) {
          return Apollo.useLazyQuery<DownloadMechanicProjectFilledInInsFormByExecutionKeyQuery, DownloadMechanicProjectFilledInInsFormByExecutionKeyQueryVariables>(DownloadMechanicProjectFilledInInsFormByExecutionKeyDocument, baseOptions);
        }
export type DownloadMechanicProjectFilledInInsFormByExecutionKeyQueryHookResult = ReturnType<typeof useDownloadMechanicProjectFilledInInsFormByExecutionKeyQuery>;
export type DownloadMechanicProjectFilledInInsFormByExecutionKeyLazyQueryHookResult = ReturnType<typeof useDownloadMechanicProjectFilledInInsFormByExecutionKeyLazyQuery>;
export type DownloadMechanicProjectFilledInInsFormByExecutionKeyQueryResult = Apollo.QueryResult<DownloadMechanicProjectFilledInInsFormByExecutionKeyQuery, DownloadMechanicProjectFilledInInsFormByExecutionKeyQueryVariables>;
export const UpdateMechanicProjectInsFormFieldValuesByExecutionKeyDocument = gql`
    mutation updateMechanicProjectInsFormFieldValuesByExecutionKey($key: String!, $fieldValues: [UpdateProjectInsFormVersionFieldValueInput!]!) {
  updateMechanicProjectInsFormFieldValuesByExecutionKey(key: $key, fieldValues: $fieldValues)
}
    `;
export type UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutationFn = Apollo.MutationFunction<UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutation, UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutationVariables>;

/**
 * __useUpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectInsFormFieldValuesByExecutionKeyMutation, { data, loading, error }] = useUpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutation({
 *   variables: {
 *      key: // value for 'key'
 *      fieldValues: // value for 'fieldValues'
 *   },
 * });
 */
export function useUpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutation, UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutation, UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutationVariables>(UpdateMechanicProjectInsFormFieldValuesByExecutionKeyDocument, baseOptions);
      }
export type UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutationHookResult = ReturnType<typeof useUpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutation>;
export type UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutationResult = Apollo.MutationResult<UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutation>;
export type UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutation, UpdateMechanicProjectInsFormFieldValuesByExecutionKeyMutationVariables>;
export const ProjectInsFormVersionByExecutionKeyDocument = gql`
    query projectInsFormVersionByExecutionKey($key: String!) {
  projectInsFormVersionByExecutionKey(key: $key) {
    ...projectInsFormVersionByExecutionKey
  }
}
    ${ProjectInsFormVersionByExecutionKeyFragmentDoc}`;

/**
 * __useProjectInsFormVersionByExecutionKeyQuery__
 *
 * To run a query within a React component, call `useProjectInsFormVersionByExecutionKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectInsFormVersionByExecutionKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectInsFormVersionByExecutionKeyQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useProjectInsFormVersionByExecutionKeyQuery(baseOptions: Apollo.QueryHookOptions<ProjectInsFormVersionByExecutionKeyQuery, ProjectInsFormVersionByExecutionKeyQueryVariables>) {
        return Apollo.useQuery<ProjectInsFormVersionByExecutionKeyQuery, ProjectInsFormVersionByExecutionKeyQueryVariables>(ProjectInsFormVersionByExecutionKeyDocument, baseOptions);
      }
export function useProjectInsFormVersionByExecutionKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectInsFormVersionByExecutionKeyQuery, ProjectInsFormVersionByExecutionKeyQueryVariables>) {
          return Apollo.useLazyQuery<ProjectInsFormVersionByExecutionKeyQuery, ProjectInsFormVersionByExecutionKeyQueryVariables>(ProjectInsFormVersionByExecutionKeyDocument, baseOptions);
        }
export type ProjectInsFormVersionByExecutionKeyQueryHookResult = ReturnType<typeof useProjectInsFormVersionByExecutionKeyQuery>;
export type ProjectInsFormVersionByExecutionKeyLazyQueryHookResult = ReturnType<typeof useProjectInsFormVersionByExecutionKeyLazyQuery>;
export type ProjectInsFormVersionByExecutionKeyQueryResult = Apollo.QueryResult<ProjectInsFormVersionByExecutionKeyQuery, ProjectInsFormVersionByExecutionKeyQueryVariables>;
export const ProjectInsFormVersionByExecutionKeyForDownloadDocument = gql`
    query projectInsFormVersionByExecutionKeyForDownload($key: String!) {
  projectInsFormVersionByExecutionKey(key: $key) {
    ...projectInsFormVersionByExecutionKeyForDownload
  }
}
    ${ProjectInsFormVersionByExecutionKeyForDownloadFragmentDoc}`;

/**
 * __useProjectInsFormVersionByExecutionKeyForDownloadQuery__
 *
 * To run a query within a React component, call `useProjectInsFormVersionByExecutionKeyForDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectInsFormVersionByExecutionKeyForDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectInsFormVersionByExecutionKeyForDownloadQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useProjectInsFormVersionByExecutionKeyForDownloadQuery(baseOptions: Apollo.QueryHookOptions<ProjectInsFormVersionByExecutionKeyForDownloadQuery, ProjectInsFormVersionByExecutionKeyForDownloadQueryVariables>) {
        return Apollo.useQuery<ProjectInsFormVersionByExecutionKeyForDownloadQuery, ProjectInsFormVersionByExecutionKeyForDownloadQueryVariables>(ProjectInsFormVersionByExecutionKeyForDownloadDocument, baseOptions);
      }
export function useProjectInsFormVersionByExecutionKeyForDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectInsFormVersionByExecutionKeyForDownloadQuery, ProjectInsFormVersionByExecutionKeyForDownloadQueryVariables>) {
          return Apollo.useLazyQuery<ProjectInsFormVersionByExecutionKeyForDownloadQuery, ProjectInsFormVersionByExecutionKeyForDownloadQueryVariables>(ProjectInsFormVersionByExecutionKeyForDownloadDocument, baseOptions);
        }
export type ProjectInsFormVersionByExecutionKeyForDownloadQueryHookResult = ReturnType<typeof useProjectInsFormVersionByExecutionKeyForDownloadQuery>;
export type ProjectInsFormVersionByExecutionKeyForDownloadLazyQueryHookResult = ReturnType<typeof useProjectInsFormVersionByExecutionKeyForDownloadLazyQuery>;
export type ProjectInsFormVersionByExecutionKeyForDownloadQueryResult = Apollo.QueryResult<ProjectInsFormVersionByExecutionKeyForDownloadQuery, ProjectInsFormVersionByExecutionKeyForDownloadQueryVariables>;
export const InspectorGridFilterLookupsQueryDocument = gql`
    query inspectorGridFilterLookupsQuery {
  regions {
    ...inspectorRegion
  }
  countries {
    ...inspectorCountry
  }
}
    ${InspectorRegionFragmentDoc}
${InspectorCountryFragmentDoc}`;

/**
 * __useInspectorGridFilterLookupsQueryQuery__
 *
 * To run a query within a React component, call `useInspectorGridFilterLookupsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectorGridFilterLookupsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectorGridFilterLookupsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useInspectorGridFilterLookupsQueryQuery(baseOptions?: Apollo.QueryHookOptions<InspectorGridFilterLookupsQueryQuery, InspectorGridFilterLookupsQueryQueryVariables>) {
        return Apollo.useQuery<InspectorGridFilterLookupsQueryQuery, InspectorGridFilterLookupsQueryQueryVariables>(InspectorGridFilterLookupsQueryDocument, baseOptions);
      }
export function useInspectorGridFilterLookupsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectorGridFilterLookupsQueryQuery, InspectorGridFilterLookupsQueryQueryVariables>) {
          return Apollo.useLazyQuery<InspectorGridFilterLookupsQueryQuery, InspectorGridFilterLookupsQueryQueryVariables>(InspectorGridFilterLookupsQueryDocument, baseOptions);
        }
export type InspectorGridFilterLookupsQueryQueryHookResult = ReturnType<typeof useInspectorGridFilterLookupsQueryQuery>;
export type InspectorGridFilterLookupsQueryLazyQueryHookResult = ReturnType<typeof useInspectorGridFilterLookupsQueryLazyQuery>;
export type InspectorGridFilterLookupsQueryQueryResult = Apollo.QueryResult<InspectorGridFilterLookupsQueryQuery, InspectorGridFilterLookupsQueryQueryVariables>;
export const InspectorGridDocument = gql`
    query inspectorGrid($regionIdIn: [Int!], $countryIdIn: [Int!], $isActive: Boolean, $coverageAreaRegionIdIn: [Int!], $inspectorTypeIdIn: [Int!], $inspectorCategoryIdIn: [Int!], $inspectorCategoryTypeIdIn: [Int!], $inspectorPassportCountryIdIn: [Int!], $inspectorVisaCountryIdIn: [Int!], $sortBy: InspectorsSortBy, $sortDirection: String, $paginationOptions: PaginationOptions) {
  inspectors(regionIdIn: $regionIdIn, countryIdIn: $countryIdIn, isActive: $isActive, coverageAreaRegionIdIn: $coverageAreaRegionIdIn, inspectorTypeIdIn: $inspectorTypeIdIn, inspectorCategoryIdIn: $inspectorCategoryIdIn, inspectorCategoryTypeIdIn: $inspectorCategoryTypeIdIn, inspectorPassportCountryIdIn: $inspectorPassportCountryIdIn, inspectorVisaCountryIdIn: $inspectorVisaCountryIdIn, sortBy: $sortBy, sortDirection: $sortDirection, paginationOptions: $paginationOptions) {
    ... on PaginatedInspectors {
      totalItems
      inspectors {
        ...inspectorGridItem
      }
    }
    ... on Inspectors {
      inspectors {
        ...inspectorGridItem
      }
    }
  }
}
    ${InspectorGridItemFragmentDoc}`;

/**
 * __useInspectorGridQuery__
 *
 * To run a query within a React component, call `useInspectorGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectorGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectorGridQuery({
 *   variables: {
 *      regionIdIn: // value for 'regionIdIn'
 *      countryIdIn: // value for 'countryIdIn'
 *      isActive: // value for 'isActive'
 *      coverageAreaRegionIdIn: // value for 'coverageAreaRegionIdIn'
 *      inspectorTypeIdIn: // value for 'inspectorTypeIdIn'
 *      inspectorCategoryIdIn: // value for 'inspectorCategoryIdIn'
 *      inspectorCategoryTypeIdIn: // value for 'inspectorCategoryTypeIdIn'
 *      inspectorPassportCountryIdIn: // value for 'inspectorPassportCountryIdIn'
 *      inspectorVisaCountryIdIn: // value for 'inspectorVisaCountryIdIn'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useInspectorGridQuery(baseOptions?: Apollo.QueryHookOptions<InspectorGridQuery, InspectorGridQueryVariables>) {
        return Apollo.useQuery<InspectorGridQuery, InspectorGridQueryVariables>(InspectorGridDocument, baseOptions);
      }
export function useInspectorGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectorGridQuery, InspectorGridQueryVariables>) {
          return Apollo.useLazyQuery<InspectorGridQuery, InspectorGridQueryVariables>(InspectorGridDocument, baseOptions);
        }
export type InspectorGridQueryHookResult = ReturnType<typeof useInspectorGridQuery>;
export type InspectorGridLazyQueryHookResult = ReturnType<typeof useInspectorGridLazyQuery>;
export type InspectorGridQueryResult = Apollo.QueryResult<InspectorGridQuery, InspectorGridQueryVariables>;
export const InspectorInspectionGridDocument = gql`
    query inspectorInspectionGrid($sortBy: InspectorInspectionsSortBy, $sortDirection: String, $inspectorIdIn: [Int!], $includePeerInspectionsForInspectors: Boolean, $projectStatusIdNotIn: [Int!], $paginationOptions: PaginationOptions) {
  inspectorInspections(sortBy: $sortBy, sortDirection: $sortDirection, includePeerInspectionsForInspectors: $includePeerInspectionsForInspectors, inspectorIdIn: $inspectorIdIn, projectStatusIdNotIn: $projectStatusIdNotIn, paginationOptions: $paginationOptions) {
    ... on PaginatedInspectorInspections {
      totalItems
      inspectorInspections {
        ...inspectorInspectionsGridItem
      }
    }
    ... on InspectorInspections {
      inspectorInspections {
        ...inspectorInspectionsGridItem
      }
    }
  }
}
    ${InspectorInspectionsGridItemFragmentDoc}`;

/**
 * __useInspectorInspectionGridQuery__
 *
 * To run a query within a React component, call `useInspectorInspectionGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectorInspectionGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectorInspectionGridQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      inspectorIdIn: // value for 'inspectorIdIn'
 *      includePeerInspectionsForInspectors: // value for 'includePeerInspectionsForInspectors'
 *      projectStatusIdNotIn: // value for 'projectStatusIdNotIn'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useInspectorInspectionGridQuery(baseOptions?: Apollo.QueryHookOptions<InspectorInspectionGridQuery, InspectorInspectionGridQueryVariables>) {
        return Apollo.useQuery<InspectorInspectionGridQuery, InspectorInspectionGridQueryVariables>(InspectorInspectionGridDocument, baseOptions);
      }
export function useInspectorInspectionGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectorInspectionGridQuery, InspectorInspectionGridQueryVariables>) {
          return Apollo.useLazyQuery<InspectorInspectionGridQuery, InspectorInspectionGridQueryVariables>(InspectorInspectionGridDocument, baseOptions);
        }
export type InspectorInspectionGridQueryHookResult = ReturnType<typeof useInspectorInspectionGridQuery>;
export type InspectorInspectionGridLazyQueryHookResult = ReturnType<typeof useInspectorInspectionGridLazyQuery>;
export type InspectorInspectionGridQueryResult = Apollo.QueryResult<InspectorInspectionGridQuery, InspectorInspectionGridQueryVariables>;
export const InspectorAvailabilityDocument = gql`
    query inspectorAvailability($inspectorIdIn: [Int!]) {
  inspectorInspections(inspectorIdIn: $inspectorIdIn, includeAllProjects: true) {
    ... on InspectorInspections {
      inspectorInspections {
        ...inspectorAvailabilityEvent
      }
    }
  }
  inspectorBlockedDates(inspectorIdIn: $inspectorIdIn) {
    ...inspectorAvailabilityBlockedDate
  }
}
    ${InspectorAvailabilityEventFragmentDoc}
${InspectorAvailabilityBlockedDateFragmentDoc}`;

/**
 * __useInspectorAvailabilityQuery__
 *
 * To run a query within a React component, call `useInspectorAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectorAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectorAvailabilityQuery({
 *   variables: {
 *      inspectorIdIn: // value for 'inspectorIdIn'
 *   },
 * });
 */
export function useInspectorAvailabilityQuery(baseOptions?: Apollo.QueryHookOptions<InspectorAvailabilityQuery, InspectorAvailabilityQueryVariables>) {
        return Apollo.useQuery<InspectorAvailabilityQuery, InspectorAvailabilityQueryVariables>(InspectorAvailabilityDocument, baseOptions);
      }
export function useInspectorAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectorAvailabilityQuery, InspectorAvailabilityQueryVariables>) {
          return Apollo.useLazyQuery<InspectorAvailabilityQuery, InspectorAvailabilityQueryVariables>(InspectorAvailabilityDocument, baseOptions);
        }
export type InspectorAvailabilityQueryHookResult = ReturnType<typeof useInspectorAvailabilityQuery>;
export type InspectorAvailabilityLazyQueryHookResult = ReturnType<typeof useInspectorAvailabilityLazyQuery>;
export type InspectorAvailabilityQueryResult = Apollo.QueryResult<InspectorAvailabilityQuery, InspectorAvailabilityQueryVariables>;
export const InspectorDetailDocument = gql`
    query inspectorDetail($id: Int!) {
  inspector(id: $id) {
    ...inspectorDetail
  }
}
    ${InspectorDetailFragmentDoc}`;

/**
 * __useInspectorDetailQuery__
 *
 * To run a query within a React component, call `useInspectorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInspectorDetailQuery(baseOptions: Apollo.QueryHookOptions<InspectorDetailQuery, InspectorDetailQueryVariables>) {
        return Apollo.useQuery<InspectorDetailQuery, InspectorDetailQueryVariables>(InspectorDetailDocument, baseOptions);
      }
export function useInspectorDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectorDetailQuery, InspectorDetailQueryVariables>) {
          return Apollo.useLazyQuery<InspectorDetailQuery, InspectorDetailQueryVariables>(InspectorDetailDocument, baseOptions);
        }
export type InspectorDetailQueryHookResult = ReturnType<typeof useInspectorDetailQuery>;
export type InspectorDetailLazyQueryHookResult = ReturnType<typeof useInspectorDetailLazyQuery>;
export type InspectorDetailQueryResult = Apollo.QueryResult<InspectorDetailQuery, InspectorDetailQueryVariables>;
export const AddInspectorModalDocument = gql`
    query addInspectorModal {
  countries {
    ...countryLookup
  }
  regions {
    ...regionLookup
  }
  states {
    ...stateLookup
  }
}
    ${CountryLookupFragmentDoc}
${RegionLookupFragmentDoc}
${StateLookupFragmentDoc}`;

/**
 * __useAddInspectorModalQuery__
 *
 * To run a query within a React component, call `useAddInspectorModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddInspectorModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddInspectorModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddInspectorModalQuery(baseOptions?: Apollo.QueryHookOptions<AddInspectorModalQuery, AddInspectorModalQueryVariables>) {
        return Apollo.useQuery<AddInspectorModalQuery, AddInspectorModalQueryVariables>(AddInspectorModalDocument, baseOptions);
      }
export function useAddInspectorModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddInspectorModalQuery, AddInspectorModalQueryVariables>) {
          return Apollo.useLazyQuery<AddInspectorModalQuery, AddInspectorModalQueryVariables>(AddInspectorModalDocument, baseOptions);
        }
export type AddInspectorModalQueryHookResult = ReturnType<typeof useAddInspectorModalQuery>;
export type AddInspectorModalLazyQueryHookResult = ReturnType<typeof useAddInspectorModalLazyQuery>;
export type AddInspectorModalQueryResult = Apollo.QueryResult<AddInspectorModalQuery, AddInspectorModalQueryVariables>;
export const AddInspectorDocument = gql`
    mutation addInspector($input: AddInspectorInput!) {
  addInspector(input: $input) {
    id
  }
}
    `;
export type AddInspectorMutationFn = Apollo.MutationFunction<AddInspectorMutation, AddInspectorMutationVariables>;

/**
 * __useAddInspectorMutation__
 *
 * To run a mutation, you first call `useAddInspectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInspectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInspectorMutation, { data, loading, error }] = useAddInspectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddInspectorMutation(baseOptions?: Apollo.MutationHookOptions<AddInspectorMutation, AddInspectorMutationVariables>) {
        return Apollo.useMutation<AddInspectorMutation, AddInspectorMutationVariables>(AddInspectorDocument, baseOptions);
      }
export type AddInspectorMutationHookResult = ReturnType<typeof useAddInspectorMutation>;
export type AddInspectorMutationResult = Apollo.MutationResult<AddInspectorMutation>;
export type AddInspectorMutationOptions = Apollo.BaseMutationOptions<AddInspectorMutation, AddInspectorMutationVariables>;
export const UpdateInspectorDocument = gql`
    mutation updateInspector($id: Int!, $input: InspectorInput!) {
  updateInspector(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateInspectorMutationFn = Apollo.MutationFunction<UpdateInspectorMutation, UpdateInspectorMutationVariables>;

/**
 * __useUpdateInspectorMutation__
 *
 * To run a mutation, you first call `useUpdateInspectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInspectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInspectorMutation, { data, loading, error }] = useUpdateInspectorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInspectorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInspectorMutation, UpdateInspectorMutationVariables>) {
        return Apollo.useMutation<UpdateInspectorMutation, UpdateInspectorMutationVariables>(UpdateInspectorDocument, baseOptions);
      }
export type UpdateInspectorMutationHookResult = ReturnType<typeof useUpdateInspectorMutation>;
export type UpdateInspectorMutationResult = Apollo.MutationResult<UpdateInspectorMutation>;
export type UpdateInspectorMutationOptions = Apollo.BaseMutationOptions<UpdateInspectorMutation, UpdateInspectorMutationVariables>;
export const InspectorBlockedDatesDocument = gql`
    query inspectorBlockedDates($inspectorIdIn: [Int!]) {
  inspectorBlockedDates(inspectorIdIn: $inspectorIdIn) {
    ...inspectorBlockedDate
  }
}
    ${InspectorBlockedDateFragmentDoc}`;

/**
 * __useInspectorBlockedDatesQuery__
 *
 * To run a query within a React component, call `useInspectorBlockedDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectorBlockedDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectorBlockedDatesQuery({
 *   variables: {
 *      inspectorIdIn: // value for 'inspectorIdIn'
 *   },
 * });
 */
export function useInspectorBlockedDatesQuery(baseOptions?: Apollo.QueryHookOptions<InspectorBlockedDatesQuery, InspectorBlockedDatesQueryVariables>) {
        return Apollo.useQuery<InspectorBlockedDatesQuery, InspectorBlockedDatesQueryVariables>(InspectorBlockedDatesDocument, baseOptions);
      }
export function useInspectorBlockedDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectorBlockedDatesQuery, InspectorBlockedDatesQueryVariables>) {
          return Apollo.useLazyQuery<InspectorBlockedDatesQuery, InspectorBlockedDatesQueryVariables>(InspectorBlockedDatesDocument, baseOptions);
        }
export type InspectorBlockedDatesQueryHookResult = ReturnType<typeof useInspectorBlockedDatesQuery>;
export type InspectorBlockedDatesLazyQueryHookResult = ReturnType<typeof useInspectorBlockedDatesLazyQuery>;
export type InspectorBlockedDatesQueryResult = Apollo.QueryResult<InspectorBlockedDatesQuery, InspectorBlockedDatesQueryVariables>;
export const AddInspectorBlockedDateDocument = gql`
    mutation addInspectorBlockedDate($input: AddInspectorBlockedDateInput!) {
  addInspectorBlockedDate(input: $input) {
    id
  }
}
    `;
export type AddInspectorBlockedDateMutationFn = Apollo.MutationFunction<AddInspectorBlockedDateMutation, AddInspectorBlockedDateMutationVariables>;

/**
 * __useAddInspectorBlockedDateMutation__
 *
 * To run a mutation, you first call `useAddInspectorBlockedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInspectorBlockedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInspectorBlockedDateMutation, { data, loading, error }] = useAddInspectorBlockedDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddInspectorBlockedDateMutation(baseOptions?: Apollo.MutationHookOptions<AddInspectorBlockedDateMutation, AddInspectorBlockedDateMutationVariables>) {
        return Apollo.useMutation<AddInspectorBlockedDateMutation, AddInspectorBlockedDateMutationVariables>(AddInspectorBlockedDateDocument, baseOptions);
      }
export type AddInspectorBlockedDateMutationHookResult = ReturnType<typeof useAddInspectorBlockedDateMutation>;
export type AddInspectorBlockedDateMutationResult = Apollo.MutationResult<AddInspectorBlockedDateMutation>;
export type AddInspectorBlockedDateMutationOptions = Apollo.BaseMutationOptions<AddInspectorBlockedDateMutation, AddInspectorBlockedDateMutationVariables>;
export const UpdateInspectorBlockedDateDocument = gql`
    mutation updateInspectorBlockedDate($input: UpdateInspectorBlockedDateInput!) {
  updateInspectorBlockedDate(input: $input) {
    id
  }
}
    `;
export type UpdateInspectorBlockedDateMutationFn = Apollo.MutationFunction<UpdateInspectorBlockedDateMutation, UpdateInspectorBlockedDateMutationVariables>;

/**
 * __useUpdateInspectorBlockedDateMutation__
 *
 * To run a mutation, you first call `useUpdateInspectorBlockedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInspectorBlockedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInspectorBlockedDateMutation, { data, loading, error }] = useUpdateInspectorBlockedDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInspectorBlockedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInspectorBlockedDateMutation, UpdateInspectorBlockedDateMutationVariables>) {
        return Apollo.useMutation<UpdateInspectorBlockedDateMutation, UpdateInspectorBlockedDateMutationVariables>(UpdateInspectorBlockedDateDocument, baseOptions);
      }
export type UpdateInspectorBlockedDateMutationHookResult = ReturnType<typeof useUpdateInspectorBlockedDateMutation>;
export type UpdateInspectorBlockedDateMutationResult = Apollo.MutationResult<UpdateInspectorBlockedDateMutation>;
export type UpdateInspectorBlockedDateMutationOptions = Apollo.BaseMutationOptions<UpdateInspectorBlockedDateMutation, UpdateInspectorBlockedDateMutationVariables>;
export const RemoveInspectorBlockedDateDocument = gql`
    mutation removeInspectorBlockedDate($inspectorBlockedDateId: Int!) {
  removeInspectorBlockedDate(inspectorBlockedDateId: $inspectorBlockedDateId)
}
    `;
export type RemoveInspectorBlockedDateMutationFn = Apollo.MutationFunction<RemoveInspectorBlockedDateMutation, RemoveInspectorBlockedDateMutationVariables>;

/**
 * __useRemoveInspectorBlockedDateMutation__
 *
 * To run a mutation, you first call `useRemoveInspectorBlockedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInspectorBlockedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInspectorBlockedDateMutation, { data, loading, error }] = useRemoveInspectorBlockedDateMutation({
 *   variables: {
 *      inspectorBlockedDateId: // value for 'inspectorBlockedDateId'
 *   },
 * });
 */
export function useRemoveInspectorBlockedDateMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInspectorBlockedDateMutation, RemoveInspectorBlockedDateMutationVariables>) {
        return Apollo.useMutation<RemoveInspectorBlockedDateMutation, RemoveInspectorBlockedDateMutationVariables>(RemoveInspectorBlockedDateDocument, baseOptions);
      }
export type RemoveInspectorBlockedDateMutationHookResult = ReturnType<typeof useRemoveInspectorBlockedDateMutation>;
export type RemoveInspectorBlockedDateMutationResult = Apollo.MutationResult<RemoveInspectorBlockedDateMutation>;
export type RemoveInspectorBlockedDateMutationOptions = Apollo.BaseMutationOptions<RemoveInspectorBlockedDateMutation, RemoveInspectorBlockedDateMutationVariables>;
export const InspectorCommentsDocument = gql`
    query inspectorComments($id: Int!) {
  inspectorComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useInspectorCommentsQuery__
 *
 * To run a query within a React component, call `useInspectorCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectorCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectorCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInspectorCommentsQuery(baseOptions: Apollo.QueryHookOptions<InspectorCommentsQuery, InspectorCommentsQueryVariables>) {
        return Apollo.useQuery<InspectorCommentsQuery, InspectorCommentsQueryVariables>(InspectorCommentsDocument, baseOptions);
      }
export function useInspectorCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectorCommentsQuery, InspectorCommentsQueryVariables>) {
          return Apollo.useLazyQuery<InspectorCommentsQuery, InspectorCommentsQueryVariables>(InspectorCommentsDocument, baseOptions);
        }
export type InspectorCommentsQueryHookResult = ReturnType<typeof useInspectorCommentsQuery>;
export type InspectorCommentsLazyQueryHookResult = ReturnType<typeof useInspectorCommentsLazyQuery>;
export type InspectorCommentsQueryResult = Apollo.QueryResult<InspectorCommentsQuery, InspectorCommentsQueryVariables>;
export const AddInspectorCommentDocument = gql`
    mutation addInspectorComment($id: Int!, $input: CommentInput!) {
  addInspectorComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddInspectorCommentMutationFn = Apollo.MutationFunction<AddInspectorCommentMutation, AddInspectorCommentMutationVariables>;

/**
 * __useAddInspectorCommentMutation__
 *
 * To run a mutation, you first call `useAddInspectorCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInspectorCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInspectorCommentMutation, { data, loading, error }] = useAddInspectorCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddInspectorCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddInspectorCommentMutation, AddInspectorCommentMutationVariables>) {
        return Apollo.useMutation<AddInspectorCommentMutation, AddInspectorCommentMutationVariables>(AddInspectorCommentDocument, baseOptions);
      }
export type AddInspectorCommentMutationHookResult = ReturnType<typeof useAddInspectorCommentMutation>;
export type AddInspectorCommentMutationResult = Apollo.MutationResult<AddInspectorCommentMutation>;
export type AddInspectorCommentMutationOptions = Apollo.BaseMutationOptions<AddInspectorCommentMutation, AddInspectorCommentMutationVariables>;
export const UpdateInspectorCommentDocument = gql`
    mutation updateInspectorComment($id: Int!, $body: String!) {
  updateInspectorComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateInspectorCommentMutationFn = Apollo.MutationFunction<UpdateInspectorCommentMutation, UpdateInspectorCommentMutationVariables>;

/**
 * __useUpdateInspectorCommentMutation__
 *
 * To run a mutation, you first call `useUpdateInspectorCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInspectorCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInspectorCommentMutation, { data, loading, error }] = useUpdateInspectorCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateInspectorCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInspectorCommentMutation, UpdateInspectorCommentMutationVariables>) {
        return Apollo.useMutation<UpdateInspectorCommentMutation, UpdateInspectorCommentMutationVariables>(UpdateInspectorCommentDocument, baseOptions);
      }
export type UpdateInspectorCommentMutationHookResult = ReturnType<typeof useUpdateInspectorCommentMutation>;
export type UpdateInspectorCommentMutationResult = Apollo.MutationResult<UpdateInspectorCommentMutation>;
export type UpdateInspectorCommentMutationOptions = Apollo.BaseMutationOptions<UpdateInspectorCommentMutation, UpdateInspectorCommentMutationVariables>;
export const UpdateInspectorCommentsLastViewedDateDocument = gql`
    mutation updateInspectorCommentsLastViewedDate($id: Int!) {
  updateInspectorCommentsLastViewedDate(inspectorId: $id) {
    id
  }
}
    `;
export type UpdateInspectorCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateInspectorCommentsLastViewedDateMutation, UpdateInspectorCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateInspectorCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateInspectorCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInspectorCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInspectorCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateInspectorCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateInspectorCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInspectorCommentsLastViewedDateMutation, UpdateInspectorCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateInspectorCommentsLastViewedDateMutation, UpdateInspectorCommentsLastViewedDateMutationVariables>(UpdateInspectorCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateInspectorCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateInspectorCommentsLastViewedDateMutation>;
export type UpdateInspectorCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateInspectorCommentsLastViewedDateMutation>;
export type UpdateInspectorCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateInspectorCommentsLastViewedDateMutation, UpdateInspectorCommentsLastViewedDateMutationVariables>;
export const InspectorDocumentsQueryDocument = gql`
    query inspectorDocumentsQuery($inspectorId: Int!, $documentTypeCategoryId: DocumentTypeCategoryEnum!) {
  documents: inspectorDocuments(inspectorId: $inspectorId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...inspectorDocument
  }
  documentTypes: inspectorDocumentTypes(inspectorId: $inspectorId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...documentType
  }
  documentTypeIdsEditableByInspector
}
    ${InspectorDocumentFragmentDoc}
${DocumentTypeFragmentDoc}`;

/**
 * __useInspectorDocumentsQueryQuery__
 *
 * To run a query within a React component, call `useInspectorDocumentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectorDocumentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectorDocumentsQueryQuery({
 *   variables: {
 *      inspectorId: // value for 'inspectorId'
 *      documentTypeCategoryId: // value for 'documentTypeCategoryId'
 *   },
 * });
 */
export function useInspectorDocumentsQueryQuery(baseOptions: Apollo.QueryHookOptions<InspectorDocumentsQueryQuery, InspectorDocumentsQueryQueryVariables>) {
        return Apollo.useQuery<InspectorDocumentsQueryQuery, InspectorDocumentsQueryQueryVariables>(InspectorDocumentsQueryDocument, baseOptions);
      }
export function useInspectorDocumentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectorDocumentsQueryQuery, InspectorDocumentsQueryQueryVariables>) {
          return Apollo.useLazyQuery<InspectorDocumentsQueryQuery, InspectorDocumentsQueryQueryVariables>(InspectorDocumentsQueryDocument, baseOptions);
        }
export type InspectorDocumentsQueryQueryHookResult = ReturnType<typeof useInspectorDocumentsQueryQuery>;
export type InspectorDocumentsQueryLazyQueryHookResult = ReturnType<typeof useInspectorDocumentsQueryLazyQuery>;
export type InspectorDocumentsQueryQueryResult = Apollo.QueryResult<InspectorDocumentsQueryQuery, InspectorDocumentsQueryQueryVariables>;
export const AddInspectorDocumentMutationDocument = gql`
    mutation addInspectorDocumentMutation($addInspectorDocumentInput: AddInspectorDocumentInput!) {
  addInspectorDocument(addInspectorDocumentInput: $addInspectorDocumentInput) {
    id
  }
}
    `;
export type AddInspectorDocumentMutationMutationFn = Apollo.MutationFunction<AddInspectorDocumentMutationMutation, AddInspectorDocumentMutationMutationVariables>;

/**
 * __useAddInspectorDocumentMutationMutation__
 *
 * To run a mutation, you first call `useAddInspectorDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInspectorDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInspectorDocumentMutationMutation, { data, loading, error }] = useAddInspectorDocumentMutationMutation({
 *   variables: {
 *      addInspectorDocumentInput: // value for 'addInspectorDocumentInput'
 *   },
 * });
 */
export function useAddInspectorDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddInspectorDocumentMutationMutation, AddInspectorDocumentMutationMutationVariables>) {
        return Apollo.useMutation<AddInspectorDocumentMutationMutation, AddInspectorDocumentMutationMutationVariables>(AddInspectorDocumentMutationDocument, baseOptions);
      }
export type AddInspectorDocumentMutationMutationHookResult = ReturnType<typeof useAddInspectorDocumentMutationMutation>;
export type AddInspectorDocumentMutationMutationResult = Apollo.MutationResult<AddInspectorDocumentMutationMutation>;
export type AddInspectorDocumentMutationMutationOptions = Apollo.BaseMutationOptions<AddInspectorDocumentMutationMutation, AddInspectorDocumentMutationMutationVariables>;
export const UpdateInspectorDocumentMutationDocument = gql`
    mutation updateInspectorDocumentMutation($updateInspectorDocumentInput: UpdateInspectorDocumentInput!) {
  updateInspectorDocument(updateInspectorDocumentInput: $updateInspectorDocumentInput) {
    id
  }
}
    `;
export type UpdateInspectorDocumentMutationMutationFn = Apollo.MutationFunction<UpdateInspectorDocumentMutationMutation, UpdateInspectorDocumentMutationMutationVariables>;

/**
 * __useUpdateInspectorDocumentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateInspectorDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInspectorDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInspectorDocumentMutationMutation, { data, loading, error }] = useUpdateInspectorDocumentMutationMutation({
 *   variables: {
 *      updateInspectorDocumentInput: // value for 'updateInspectorDocumentInput'
 *   },
 * });
 */
export function useUpdateInspectorDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInspectorDocumentMutationMutation, UpdateInspectorDocumentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateInspectorDocumentMutationMutation, UpdateInspectorDocumentMutationMutationVariables>(UpdateInspectorDocumentMutationDocument, baseOptions);
      }
export type UpdateInspectorDocumentMutationMutationHookResult = ReturnType<typeof useUpdateInspectorDocumentMutationMutation>;
export type UpdateInspectorDocumentMutationMutationResult = Apollo.MutationResult<UpdateInspectorDocumentMutationMutation>;
export type UpdateInspectorDocumentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateInspectorDocumentMutationMutation, UpdateInspectorDocumentMutationMutationVariables>;
export const RemoveInspectorDocumentMutationDocument = gql`
    mutation removeInspectorDocumentMutation($id: Int!) {
  removeInspectorDocument(id: $id)
}
    `;
export type RemoveInspectorDocumentMutationMutationFn = Apollo.MutationFunction<RemoveInspectorDocumentMutationMutation, RemoveInspectorDocumentMutationMutationVariables>;

/**
 * __useRemoveInspectorDocumentMutationMutation__
 *
 * To run a mutation, you first call `useRemoveInspectorDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInspectorDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInspectorDocumentMutationMutation, { data, loading, error }] = useRemoveInspectorDocumentMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveInspectorDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInspectorDocumentMutationMutation, RemoveInspectorDocumentMutationMutationVariables>) {
        return Apollo.useMutation<RemoveInspectorDocumentMutationMutation, RemoveInspectorDocumentMutationMutationVariables>(RemoveInspectorDocumentMutationDocument, baseOptions);
      }
export type RemoveInspectorDocumentMutationMutationHookResult = ReturnType<typeof useRemoveInspectorDocumentMutationMutation>;
export type RemoveInspectorDocumentMutationMutationResult = Apollo.MutationResult<RemoveInspectorDocumentMutationMutation>;
export type RemoveInspectorDocumentMutationMutationOptions = Apollo.BaseMutationOptions<RemoveInspectorDocumentMutationMutation, RemoveInspectorDocumentMutationMutationVariables>;
export const DownloadInspectorDocumentDocument = gql`
    query downloadInspectorDocument($id: Int!) {
  file: downloadInspectorDocument(id: $id) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadInspectorDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadInspectorDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadInspectorDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadInspectorDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadInspectorDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadInspectorDocumentQuery, DownloadInspectorDocumentQueryVariables>) {
        return Apollo.useQuery<DownloadInspectorDocumentQuery, DownloadInspectorDocumentQueryVariables>(DownloadInspectorDocumentDocument, baseOptions);
      }
export function useDownloadInspectorDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadInspectorDocumentQuery, DownloadInspectorDocumentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadInspectorDocumentQuery, DownloadInspectorDocumentQueryVariables>(DownloadInspectorDocumentDocument, baseOptions);
        }
export type DownloadInspectorDocumentQueryHookResult = ReturnType<typeof useDownloadInspectorDocumentQuery>;
export type DownloadInspectorDocumentLazyQueryHookResult = ReturnType<typeof useDownloadInspectorDocumentLazyQuery>;
export type DownloadInspectorDocumentQueryResult = Apollo.QueryResult<DownloadInspectorDocumentQuery, DownloadInspectorDocumentQueryVariables>;
export const InspectorEmailHistoryDocument = gql`
    query inspectorEmailHistory($inspectorId: Int!, $sortBy: EmailHistorySortBy, $sortDirection: SortDirection) {
  inspector(id: $inspectorId) {
    emailHistory(sortBy: $sortBy, sortDirection: $sortDirection) {
      ...emailHistory
    }
  }
}
    ${EmailHistoryFragmentDoc}`;

/**
 * __useInspectorEmailHistoryQuery__
 *
 * To run a query within a React component, call `useInspectorEmailHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectorEmailHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectorEmailHistoryQuery({
 *   variables: {
 *      inspectorId: // value for 'inspectorId'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useInspectorEmailHistoryQuery(baseOptions: Apollo.QueryHookOptions<InspectorEmailHistoryQuery, InspectorEmailHistoryQueryVariables>) {
        return Apollo.useQuery<InspectorEmailHistoryQuery, InspectorEmailHistoryQueryVariables>(InspectorEmailHistoryDocument, baseOptions);
      }
export function useInspectorEmailHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectorEmailHistoryQuery, InspectorEmailHistoryQueryVariables>) {
          return Apollo.useLazyQuery<InspectorEmailHistoryQuery, InspectorEmailHistoryQueryVariables>(InspectorEmailHistoryDocument, baseOptions);
        }
export type InspectorEmailHistoryQueryHookResult = ReturnType<typeof useInspectorEmailHistoryQuery>;
export type InspectorEmailHistoryLazyQueryHookResult = ReturnType<typeof useInspectorEmailHistoryLazyQuery>;
export type InspectorEmailHistoryQueryResult = Apollo.QueryResult<InspectorEmailHistoryQuery, InspectorEmailHistoryQueryVariables>;
export const InspectorEmailViewDocument = gql`
    query inspectorEmailView($id: Int!, $emailId: Int!, $includeFileAttachments: Boolean = false, $includeFileContent: Boolean = false) {
  inspector(id: $id) {
    emails(filter: {id_in: [$emailId]}) {
      ...email
    }
  }
}
    ${EmailFragmentDoc}`;

/**
 * __useInspectorEmailViewQuery__
 *
 * To run a query within a React component, call `useInspectorEmailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectorEmailViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectorEmailViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      emailId: // value for 'emailId'
 *      includeFileAttachments: // value for 'includeFileAttachments'
 *      includeFileContent: // value for 'includeFileContent'
 *   },
 * });
 */
export function useInspectorEmailViewQuery(baseOptions: Apollo.QueryHookOptions<InspectorEmailViewQuery, InspectorEmailViewQueryVariables>) {
        return Apollo.useQuery<InspectorEmailViewQuery, InspectorEmailViewQueryVariables>(InspectorEmailViewDocument, baseOptions);
      }
export function useInspectorEmailViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectorEmailViewQuery, InspectorEmailViewQueryVariables>) {
          return Apollo.useLazyQuery<InspectorEmailViewQuery, InspectorEmailViewQueryVariables>(InspectorEmailViewDocument, baseOptions);
        }
export type InspectorEmailViewQueryHookResult = ReturnType<typeof useInspectorEmailViewQuery>;
export type InspectorEmailViewLazyQueryHookResult = ReturnType<typeof useInspectorEmailViewLazyQuery>;
export type InspectorEmailViewQueryResult = Apollo.QueryResult<InspectorEmailViewQuery, InspectorEmailViewQueryVariables>;
export const DownloadInspectorEmailAttachmentContentDocument = gql`
    query downloadInspectorEmailAttachmentContent($inspectorId: Int!, $emailId: Int!, $attachmentId: Int!) {
  downloadInspectorEmailAttachmentContent(inspectorId: $inspectorId, emailId: $emailId, attachmentId: $attachmentId)
}
    `;

/**
 * __useDownloadInspectorEmailAttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadInspectorEmailAttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadInspectorEmailAttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadInspectorEmailAttachmentContentQuery({
 *   variables: {
 *      inspectorId: // value for 'inspectorId'
 *      emailId: // value for 'emailId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDownloadInspectorEmailAttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadInspectorEmailAttachmentContentQuery, DownloadInspectorEmailAttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadInspectorEmailAttachmentContentQuery, DownloadInspectorEmailAttachmentContentQueryVariables>(DownloadInspectorEmailAttachmentContentDocument, baseOptions);
      }
export function useDownloadInspectorEmailAttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadInspectorEmailAttachmentContentQuery, DownloadInspectorEmailAttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadInspectorEmailAttachmentContentQuery, DownloadInspectorEmailAttachmentContentQueryVariables>(DownloadInspectorEmailAttachmentContentDocument, baseOptions);
        }
export type DownloadInspectorEmailAttachmentContentQueryHookResult = ReturnType<typeof useDownloadInspectorEmailAttachmentContentQuery>;
export type DownloadInspectorEmailAttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadInspectorEmailAttachmentContentLazyQuery>;
export type DownloadInspectorEmailAttachmentContentQueryResult = Apollo.QueryResult<DownloadInspectorEmailAttachmentContentQuery, DownloadInspectorEmailAttachmentContentQueryVariables>;
export const SendInspectorEmailDocument = gql`
    mutation sendInspectorEmail($inspectorId: Int!, $email: EmailInput!) {
  sendInspectorEmail(inspectorId: $inspectorId, email: $email) {
    id
  }
}
    `;
export type SendInspectorEmailMutationFn = Apollo.MutationFunction<SendInspectorEmailMutation, SendInspectorEmailMutationVariables>;

/**
 * __useSendInspectorEmailMutation__
 *
 * To run a mutation, you first call `useSendInspectorEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInspectorEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInspectorEmailMutation, { data, loading, error }] = useSendInspectorEmailMutation({
 *   variables: {
 *      inspectorId: // value for 'inspectorId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendInspectorEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendInspectorEmailMutation, SendInspectorEmailMutationVariables>) {
        return Apollo.useMutation<SendInspectorEmailMutation, SendInspectorEmailMutationVariables>(SendInspectorEmailDocument, baseOptions);
      }
export type SendInspectorEmailMutationHookResult = ReturnType<typeof useSendInspectorEmailMutation>;
export type SendInspectorEmailMutationResult = Apollo.MutationResult<SendInspectorEmailMutation>;
export type SendInspectorEmailMutationOptions = Apollo.BaseMutationOptions<SendInspectorEmailMutation, SendInspectorEmailMutationVariables>;
export const InvoiceGridDocument = gql`
    query invoiceGrid($isArgInvoice: Boolean, $aircraftProjectIdIn: [Int!], $crewProjectIdIn: [Int!], $mechanicProjectIdIn: [Int!], $createDate: DateRangeFilterInput, $sortBy: InvoicesSortBy, $sortDirection: String, $paginationOptions: PaginationOptions) {
  invoices(isArgInvoice: $isArgInvoice, aircraftProjectIdIn: $aircraftProjectIdIn, crewProjectIdIn: $crewProjectIdIn, mechanicProjectIdIn: $mechanicProjectIdIn, createDate: $createDate, sortBy: $sortBy, sortDirection: $sortDirection, paginationOptions: $paginationOptions) {
    ... on PaginatedInvoices {
      totalItems
      invoices {
        ...invoiceGridItem
      }
    }
    ... on Invoices {
      invoices {
        ...invoiceGridItem
      }
    }
  }
}
    ${InvoiceGridItemFragmentDoc}`;

/**
 * __useInvoiceGridQuery__
 *
 * To run a query within a React component, call `useInvoiceGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceGridQuery({
 *   variables: {
 *      isArgInvoice: // value for 'isArgInvoice'
 *      aircraftProjectIdIn: // value for 'aircraftProjectIdIn'
 *      crewProjectIdIn: // value for 'crewProjectIdIn'
 *      mechanicProjectIdIn: // value for 'mechanicProjectIdIn'
 *      createDate: // value for 'createDate'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useInvoiceGridQuery(baseOptions?: Apollo.QueryHookOptions<InvoiceGridQuery, InvoiceGridQueryVariables>) {
        return Apollo.useQuery<InvoiceGridQuery, InvoiceGridQueryVariables>(InvoiceGridDocument, baseOptions);
      }
export function useInvoiceGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceGridQuery, InvoiceGridQueryVariables>) {
          return Apollo.useLazyQuery<InvoiceGridQuery, InvoiceGridQueryVariables>(InvoiceGridDocument, baseOptions);
        }
export type InvoiceGridQueryHookResult = ReturnType<typeof useInvoiceGridQuery>;
export type InvoiceGridLazyQueryHookResult = ReturnType<typeof useInvoiceGridLazyQuery>;
export type InvoiceGridQueryResult = Apollo.QueryResult<InvoiceGridQuery, InvoiceGridQueryVariables>;
export const InvoiceProjectSelectionDocument = gql`
    query invoiceProjectSelection($invoiceId: Int) {
  aircraftProjectsForSelectionOnInvoice(invoiceId: $invoiceId) {
    id
    aircraftProjectNameForInvoicing
  }
  crewProjectsForSelectionOnInvoice(invoiceId: $invoiceId) {
    id
    crewProjectNameForInvoicing
  }
  mechanicProjectsForSelectionOnInvoice(invoiceId: $invoiceId) {
    id
    mechanicProjectNameForInvoicing
  }
}
    `;

/**
 * __useInvoiceProjectSelectionQuery__
 *
 * To run a query within a React component, call `useInvoiceProjectSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceProjectSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceProjectSelectionQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoiceProjectSelectionQuery(baseOptions?: Apollo.QueryHookOptions<InvoiceProjectSelectionQuery, InvoiceProjectSelectionQueryVariables>) {
        return Apollo.useQuery<InvoiceProjectSelectionQuery, InvoiceProjectSelectionQueryVariables>(InvoiceProjectSelectionDocument, baseOptions);
      }
export function useInvoiceProjectSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceProjectSelectionQuery, InvoiceProjectSelectionQueryVariables>) {
          return Apollo.useLazyQuery<InvoiceProjectSelectionQuery, InvoiceProjectSelectionQueryVariables>(InvoiceProjectSelectionDocument, baseOptions);
        }
export type InvoiceProjectSelectionQueryHookResult = ReturnType<typeof useInvoiceProjectSelectionQuery>;
export type InvoiceProjectSelectionLazyQueryHookResult = ReturnType<typeof useInvoiceProjectSelectionLazyQuery>;
export type InvoiceProjectSelectionQueryResult = Apollo.QueryResult<InvoiceProjectSelectionQuery, InvoiceProjectSelectionQueryVariables>;
export const InvoiceModalDocument = gql`
    query invoiceModal($invoiceId: Int!) {
  invoice(id: $invoiceId) {
    invoiceNumber
    invoiceDate
    fileAttachment {
      fileName
      fileSizeBytes
      mimeType
    }
    aircraftProjects {
      id
      aircraftProjectNameForInvoicing
    }
    crewProjects {
      id
      crewProjectNameForInvoicing
    }
    mechanicProjects {
      id
      mechanicProjectNameForInvoicing
    }
    paymentStatus {
      id
    }
    notes
  }
}
    `;

/**
 * __useInvoiceModalQuery__
 *
 * To run a query within a React component, call `useInvoiceModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceModalQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoiceModalQuery(baseOptions: Apollo.QueryHookOptions<InvoiceModalQuery, InvoiceModalQueryVariables>) {
        return Apollo.useQuery<InvoiceModalQuery, InvoiceModalQueryVariables>(InvoiceModalDocument, baseOptions);
      }
export function useInvoiceModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceModalQuery, InvoiceModalQueryVariables>) {
          return Apollo.useLazyQuery<InvoiceModalQuery, InvoiceModalQueryVariables>(InvoiceModalDocument, baseOptions);
        }
export type InvoiceModalQueryHookResult = ReturnType<typeof useInvoiceModalQuery>;
export type InvoiceModalLazyQueryHookResult = ReturnType<typeof useInvoiceModalLazyQuery>;
export type InvoiceModalQueryResult = Apollo.QueryResult<InvoiceModalQuery, InvoiceModalQueryVariables>;
export const DownloadInvoiceFileAttachmentContentDocument = gql`
    query downloadInvoiceFileAttachmentContent($invoiceId: Int!) {
  downloadInvoiceFileAttachment(invoiceId: $invoiceId)
}
    `;

/**
 * __useDownloadInvoiceFileAttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadInvoiceFileAttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadInvoiceFileAttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadInvoiceFileAttachmentContentQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useDownloadInvoiceFileAttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadInvoiceFileAttachmentContentQuery, DownloadInvoiceFileAttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadInvoiceFileAttachmentContentQuery, DownloadInvoiceFileAttachmentContentQueryVariables>(DownloadInvoiceFileAttachmentContentDocument, baseOptions);
      }
export function useDownloadInvoiceFileAttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadInvoiceFileAttachmentContentQuery, DownloadInvoiceFileAttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadInvoiceFileAttachmentContentQuery, DownloadInvoiceFileAttachmentContentQueryVariables>(DownloadInvoiceFileAttachmentContentDocument, baseOptions);
        }
export type DownloadInvoiceFileAttachmentContentQueryHookResult = ReturnType<typeof useDownloadInvoiceFileAttachmentContentQuery>;
export type DownloadInvoiceFileAttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadInvoiceFileAttachmentContentLazyQuery>;
export type DownloadInvoiceFileAttachmentContentQueryResult = Apollo.QueryResult<DownloadInvoiceFileAttachmentContentQuery, DownloadInvoiceFileAttachmentContentQueryVariables>;
export const AddInvoiceDocument = gql`
    mutation addInvoice($addInvoiceInput: AddInvoiceInput!) {
  addInvoice(addInvoiceInput: $addInvoiceInput) {
    id
  }
}
    `;
export type AddInvoiceMutationFn = Apollo.MutationFunction<AddInvoiceMutation, AddInvoiceMutationVariables>;

/**
 * __useAddInvoiceMutation__
 *
 * To run a mutation, you first call `useAddInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInvoiceMutation, { data, loading, error }] = useAddInvoiceMutation({
 *   variables: {
 *      addInvoiceInput: // value for 'addInvoiceInput'
 *   },
 * });
 */
export function useAddInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<AddInvoiceMutation, AddInvoiceMutationVariables>) {
        return Apollo.useMutation<AddInvoiceMutation, AddInvoiceMutationVariables>(AddInvoiceDocument, baseOptions);
      }
export type AddInvoiceMutationHookResult = ReturnType<typeof useAddInvoiceMutation>;
export type AddInvoiceMutationResult = Apollo.MutationResult<AddInvoiceMutation>;
export type AddInvoiceMutationOptions = Apollo.BaseMutationOptions<AddInvoiceMutation, AddInvoiceMutationVariables>;
export const UpdateInvoiceDocument = gql`
    mutation updateInvoice($updateInvoiceInput: UpdateInvoiceInput!) {
  updateInvoice(updateInvoiceInput: $updateInvoiceInput) {
    id
  }
}
    `;
export type UpdateInvoiceMutationFn = Apollo.MutationFunction<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceMutation, { data, loading, error }] = useUpdateInvoiceMutation({
 *   variables: {
 *      updateInvoiceInput: // value for 'updateInvoiceInput'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>) {
        return Apollo.useMutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, baseOptions);
      }
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>;
export type UpdateInvoiceMutationResult = Apollo.MutationResult<UpdateInvoiceMutation>;
export type UpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const DeleteInvoiceDocument = gql`
    mutation deleteInvoice($id: Int!) {
  deleteInvoice(id: $id)
}
    `;
export type DeleteInvoiceMutationFn = Apollo.MutationFunction<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;

/**
 * __useDeleteInvoiceMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceMutation, { data, loading, error }] = useDeleteInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>) {
        return Apollo.useMutation<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>(DeleteInvoiceDocument, baseOptions);
      }
export type DeleteInvoiceMutationHookResult = ReturnType<typeof useDeleteInvoiceMutation>;
export type DeleteInvoiceMutationResult = Apollo.MutationResult<DeleteInvoiceMutation>;
export type DeleteInvoiceMutationOptions = Apollo.BaseMutationOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;
export const ListManagementAircraftEngineManufacturersDocument = gql`
    query listManagementAircraftEngineManufacturers($paginationOptions: PaginationOptions) {
  listManagementItems: listManagementAircraftEngineManufacturers(paginationOptions: $paginationOptions) {
    totalItems
    items {
      ...listManagementAircraftEngineManufacturer
    }
  }
}
    ${ListManagementAircraftEngineManufacturerFragmentDoc}`;

/**
 * __useListManagementAircraftEngineManufacturersQuery__
 *
 * To run a query within a React component, call `useListManagementAircraftEngineManufacturersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListManagementAircraftEngineManufacturersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListManagementAircraftEngineManufacturersQuery({
 *   variables: {
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useListManagementAircraftEngineManufacturersQuery(baseOptions?: Apollo.QueryHookOptions<ListManagementAircraftEngineManufacturersQuery, ListManagementAircraftEngineManufacturersQueryVariables>) {
        return Apollo.useQuery<ListManagementAircraftEngineManufacturersQuery, ListManagementAircraftEngineManufacturersQueryVariables>(ListManagementAircraftEngineManufacturersDocument, baseOptions);
      }
export function useListManagementAircraftEngineManufacturersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListManagementAircraftEngineManufacturersQuery, ListManagementAircraftEngineManufacturersQueryVariables>) {
          return Apollo.useLazyQuery<ListManagementAircraftEngineManufacturersQuery, ListManagementAircraftEngineManufacturersQueryVariables>(ListManagementAircraftEngineManufacturersDocument, baseOptions);
        }
export type ListManagementAircraftEngineManufacturersQueryHookResult = ReturnType<typeof useListManagementAircraftEngineManufacturersQuery>;
export type ListManagementAircraftEngineManufacturersLazyQueryHookResult = ReturnType<typeof useListManagementAircraftEngineManufacturersLazyQuery>;
export type ListManagementAircraftEngineManufacturersQueryResult = Apollo.QueryResult<ListManagementAircraftEngineManufacturersQuery, ListManagementAircraftEngineManufacturersQueryVariables>;
export const ConsolidateAircraftEngineManufacturersDocument = gql`
    mutation consolidateAircraftEngineManufacturers($input: ListManagementLookupConsolidationInput!) {
  consolidateAircraftEngineManufacturers(input: $input)
}
    `;
export type ConsolidateAircraftEngineManufacturersMutationFn = Apollo.MutationFunction<ConsolidateAircraftEngineManufacturersMutation, ConsolidateAircraftEngineManufacturersMutationVariables>;

/**
 * __useConsolidateAircraftEngineManufacturersMutation__
 *
 * To run a mutation, you first call `useConsolidateAircraftEngineManufacturersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsolidateAircraftEngineManufacturersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consolidateAircraftEngineManufacturersMutation, { data, loading, error }] = useConsolidateAircraftEngineManufacturersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsolidateAircraftEngineManufacturersMutation(baseOptions?: Apollo.MutationHookOptions<ConsolidateAircraftEngineManufacturersMutation, ConsolidateAircraftEngineManufacturersMutationVariables>) {
        return Apollo.useMutation<ConsolidateAircraftEngineManufacturersMutation, ConsolidateAircraftEngineManufacturersMutationVariables>(ConsolidateAircraftEngineManufacturersDocument, baseOptions);
      }
export type ConsolidateAircraftEngineManufacturersMutationHookResult = ReturnType<typeof useConsolidateAircraftEngineManufacturersMutation>;
export type ConsolidateAircraftEngineManufacturersMutationResult = Apollo.MutationResult<ConsolidateAircraftEngineManufacturersMutation>;
export type ConsolidateAircraftEngineManufacturersMutationOptions = Apollo.BaseMutationOptions<ConsolidateAircraftEngineManufacturersMutation, ConsolidateAircraftEngineManufacturersMutationVariables>;
export const ListManagementAircraftManufacturersDocument = gql`
    query listManagementAircraftManufacturers($paginationOptions: PaginationOptions) {
  listManagementItems: listManagementAircraftManufacturers(paginationOptions: $paginationOptions) {
    totalItems
    items {
      ...listManagementAircraftManufacturer
    }
  }
}
    ${ListManagementAircraftManufacturerFragmentDoc}`;

/**
 * __useListManagementAircraftManufacturersQuery__
 *
 * To run a query within a React component, call `useListManagementAircraftManufacturersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListManagementAircraftManufacturersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListManagementAircraftManufacturersQuery({
 *   variables: {
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useListManagementAircraftManufacturersQuery(baseOptions?: Apollo.QueryHookOptions<ListManagementAircraftManufacturersQuery, ListManagementAircraftManufacturersQueryVariables>) {
        return Apollo.useQuery<ListManagementAircraftManufacturersQuery, ListManagementAircraftManufacturersQueryVariables>(ListManagementAircraftManufacturersDocument, baseOptions);
      }
export function useListManagementAircraftManufacturersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListManagementAircraftManufacturersQuery, ListManagementAircraftManufacturersQueryVariables>) {
          return Apollo.useLazyQuery<ListManagementAircraftManufacturersQuery, ListManagementAircraftManufacturersQueryVariables>(ListManagementAircraftManufacturersDocument, baseOptions);
        }
export type ListManagementAircraftManufacturersQueryHookResult = ReturnType<typeof useListManagementAircraftManufacturersQuery>;
export type ListManagementAircraftManufacturersLazyQueryHookResult = ReturnType<typeof useListManagementAircraftManufacturersLazyQuery>;
export type ListManagementAircraftManufacturersQueryResult = Apollo.QueryResult<ListManagementAircraftManufacturersQuery, ListManagementAircraftManufacturersQueryVariables>;
export const ConsolidateAircraftManufacturersDocument = gql`
    mutation consolidateAircraftManufacturers($input: ListManagementLookupConsolidationInput!) {
  consolidateAircraftManufacturers(input: $input)
}
    `;
export type ConsolidateAircraftManufacturersMutationFn = Apollo.MutationFunction<ConsolidateAircraftManufacturersMutation, ConsolidateAircraftManufacturersMutationVariables>;

/**
 * __useConsolidateAircraftManufacturersMutation__
 *
 * To run a mutation, you first call `useConsolidateAircraftManufacturersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsolidateAircraftManufacturersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consolidateAircraftManufacturersMutation, { data, loading, error }] = useConsolidateAircraftManufacturersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsolidateAircraftManufacturersMutation(baseOptions?: Apollo.MutationHookOptions<ConsolidateAircraftManufacturersMutation, ConsolidateAircraftManufacturersMutationVariables>) {
        return Apollo.useMutation<ConsolidateAircraftManufacturersMutation, ConsolidateAircraftManufacturersMutationVariables>(ConsolidateAircraftManufacturersDocument, baseOptions);
      }
export type ConsolidateAircraftManufacturersMutationHookResult = ReturnType<typeof useConsolidateAircraftManufacturersMutation>;
export type ConsolidateAircraftManufacturersMutationResult = Apollo.MutationResult<ConsolidateAircraftManufacturersMutation>;
export type ConsolidateAircraftManufacturersMutationOptions = Apollo.BaseMutationOptions<ConsolidateAircraftManufacturersMutation, ConsolidateAircraftManufacturersMutationVariables>;
export const ListManagementAircraftModelsDocument = gql`
    query listManagementAircraftModels($paginationOptions: PaginationOptions) {
  listManagementItems: listManagementAircraftModels(paginationOptions: $paginationOptions) {
    totalItems
    items {
      ...listManagementAircraftModel
    }
  }
}
    ${ListManagementAircraftModelFragmentDoc}`;

/**
 * __useListManagementAircraftModelsQuery__
 *
 * To run a query within a React component, call `useListManagementAircraftModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListManagementAircraftModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListManagementAircraftModelsQuery({
 *   variables: {
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useListManagementAircraftModelsQuery(baseOptions?: Apollo.QueryHookOptions<ListManagementAircraftModelsQuery, ListManagementAircraftModelsQueryVariables>) {
        return Apollo.useQuery<ListManagementAircraftModelsQuery, ListManagementAircraftModelsQueryVariables>(ListManagementAircraftModelsDocument, baseOptions);
      }
export function useListManagementAircraftModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListManagementAircraftModelsQuery, ListManagementAircraftModelsQueryVariables>) {
          return Apollo.useLazyQuery<ListManagementAircraftModelsQuery, ListManagementAircraftModelsQueryVariables>(ListManagementAircraftModelsDocument, baseOptions);
        }
export type ListManagementAircraftModelsQueryHookResult = ReturnType<typeof useListManagementAircraftModelsQuery>;
export type ListManagementAircraftModelsLazyQueryHookResult = ReturnType<typeof useListManagementAircraftModelsLazyQuery>;
export type ListManagementAircraftModelsQueryResult = Apollo.QueryResult<ListManagementAircraftModelsQuery, ListManagementAircraftModelsQueryVariables>;
export const ConsolidateAircraftModelsDocument = gql`
    mutation consolidateAircraftModels($input: ListManagementLookupConsolidationInput!) {
  consolidateAircraftModels(input: $input)
}
    `;
export type ConsolidateAircraftModelsMutationFn = Apollo.MutationFunction<ConsolidateAircraftModelsMutation, ConsolidateAircraftModelsMutationVariables>;

/**
 * __useConsolidateAircraftModelsMutation__
 *
 * To run a mutation, you first call `useConsolidateAircraftModelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsolidateAircraftModelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consolidateAircraftModelsMutation, { data, loading, error }] = useConsolidateAircraftModelsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsolidateAircraftModelsMutation(baseOptions?: Apollo.MutationHookOptions<ConsolidateAircraftModelsMutation, ConsolidateAircraftModelsMutationVariables>) {
        return Apollo.useMutation<ConsolidateAircraftModelsMutation, ConsolidateAircraftModelsMutationVariables>(ConsolidateAircraftModelsDocument, baseOptions);
      }
export type ConsolidateAircraftModelsMutationHookResult = ReturnType<typeof useConsolidateAircraftModelsMutation>;
export type ConsolidateAircraftModelsMutationResult = Apollo.MutationResult<ConsolidateAircraftModelsMutation>;
export type ConsolidateAircraftModelsMutationOptions = Apollo.BaseMutationOptions<ConsolidateAircraftModelsMutation, ConsolidateAircraftModelsMutationVariables>;
export const ListManagementAircraftPropellerManufacturersDocument = gql`
    query listManagementAircraftPropellerManufacturers($paginationOptions: PaginationOptions) {
  listManagementItems: listManagementAircraftPropellerManufacturers(paginationOptions: $paginationOptions) {
    totalItems
    items {
      ...listManagementAircraftPropellerManufacturer
    }
  }
}
    ${ListManagementAircraftPropellerManufacturerFragmentDoc}`;

/**
 * __useListManagementAircraftPropellerManufacturersQuery__
 *
 * To run a query within a React component, call `useListManagementAircraftPropellerManufacturersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListManagementAircraftPropellerManufacturersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListManagementAircraftPropellerManufacturersQuery({
 *   variables: {
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useListManagementAircraftPropellerManufacturersQuery(baseOptions?: Apollo.QueryHookOptions<ListManagementAircraftPropellerManufacturersQuery, ListManagementAircraftPropellerManufacturersQueryVariables>) {
        return Apollo.useQuery<ListManagementAircraftPropellerManufacturersQuery, ListManagementAircraftPropellerManufacturersQueryVariables>(ListManagementAircraftPropellerManufacturersDocument, baseOptions);
      }
export function useListManagementAircraftPropellerManufacturersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListManagementAircraftPropellerManufacturersQuery, ListManagementAircraftPropellerManufacturersQueryVariables>) {
          return Apollo.useLazyQuery<ListManagementAircraftPropellerManufacturersQuery, ListManagementAircraftPropellerManufacturersQueryVariables>(ListManagementAircraftPropellerManufacturersDocument, baseOptions);
        }
export type ListManagementAircraftPropellerManufacturersQueryHookResult = ReturnType<typeof useListManagementAircraftPropellerManufacturersQuery>;
export type ListManagementAircraftPropellerManufacturersLazyQueryHookResult = ReturnType<typeof useListManagementAircraftPropellerManufacturersLazyQuery>;
export type ListManagementAircraftPropellerManufacturersQueryResult = Apollo.QueryResult<ListManagementAircraftPropellerManufacturersQuery, ListManagementAircraftPropellerManufacturersQueryVariables>;
export const ConsolidateAircraftPropellerManufacturersDocument = gql`
    mutation consolidateAircraftPropellerManufacturers($input: ListManagementLookupConsolidationInput!) {
  consolidateAircraftPropellerManufacturers(input: $input)
}
    `;
export type ConsolidateAircraftPropellerManufacturersMutationFn = Apollo.MutationFunction<ConsolidateAircraftPropellerManufacturersMutation, ConsolidateAircraftPropellerManufacturersMutationVariables>;

/**
 * __useConsolidateAircraftPropellerManufacturersMutation__
 *
 * To run a mutation, you first call `useConsolidateAircraftPropellerManufacturersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsolidateAircraftPropellerManufacturersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consolidateAircraftPropellerManufacturersMutation, { data, loading, error }] = useConsolidateAircraftPropellerManufacturersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsolidateAircraftPropellerManufacturersMutation(baseOptions?: Apollo.MutationHookOptions<ConsolidateAircraftPropellerManufacturersMutation, ConsolidateAircraftPropellerManufacturersMutationVariables>) {
        return Apollo.useMutation<ConsolidateAircraftPropellerManufacturersMutation, ConsolidateAircraftPropellerManufacturersMutationVariables>(ConsolidateAircraftPropellerManufacturersDocument, baseOptions);
      }
export type ConsolidateAircraftPropellerManufacturersMutationHookResult = ReturnType<typeof useConsolidateAircraftPropellerManufacturersMutation>;
export type ConsolidateAircraftPropellerManufacturersMutationResult = Apollo.MutationResult<ConsolidateAircraftPropellerManufacturersMutation>;
export type ConsolidateAircraftPropellerManufacturersMutationOptions = Apollo.BaseMutationOptions<ConsolidateAircraftPropellerManufacturersMutation, ConsolidateAircraftPropellerManufacturersMutationVariables>;
export const ListManagementCrewRatingsDocument = gql`
    query listManagementCrewRatings($paginationOptions: PaginationOptions) {
  listManagementItems: listManagementCrewRatings(paginationOptions: $paginationOptions) {
    totalItems
    items {
      ...listManagementCrewRating
    }
  }
}
    ${ListManagementCrewRatingFragmentDoc}`;

/**
 * __useListManagementCrewRatingsQuery__
 *
 * To run a query within a React component, call `useListManagementCrewRatingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListManagementCrewRatingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListManagementCrewRatingsQuery({
 *   variables: {
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useListManagementCrewRatingsQuery(baseOptions?: Apollo.QueryHookOptions<ListManagementCrewRatingsQuery, ListManagementCrewRatingsQueryVariables>) {
        return Apollo.useQuery<ListManagementCrewRatingsQuery, ListManagementCrewRatingsQueryVariables>(ListManagementCrewRatingsDocument, baseOptions);
      }
export function useListManagementCrewRatingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListManagementCrewRatingsQuery, ListManagementCrewRatingsQueryVariables>) {
          return Apollo.useLazyQuery<ListManagementCrewRatingsQuery, ListManagementCrewRatingsQueryVariables>(ListManagementCrewRatingsDocument, baseOptions);
        }
export type ListManagementCrewRatingsQueryHookResult = ReturnType<typeof useListManagementCrewRatingsQuery>;
export type ListManagementCrewRatingsLazyQueryHookResult = ReturnType<typeof useListManagementCrewRatingsLazyQuery>;
export type ListManagementCrewRatingsQueryResult = Apollo.QueryResult<ListManagementCrewRatingsQuery, ListManagementCrewRatingsQueryVariables>;
export const ConsolidateCrewRatingsDocument = gql`
    mutation consolidateCrewRatings($input: ListManagementLookupConsolidationInput!) {
  consolidateCrewRatings(input: $input)
}
    `;
export type ConsolidateCrewRatingsMutationFn = Apollo.MutationFunction<ConsolidateCrewRatingsMutation, ConsolidateCrewRatingsMutationVariables>;

/**
 * __useConsolidateCrewRatingsMutation__
 *
 * To run a mutation, you first call `useConsolidateCrewRatingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsolidateCrewRatingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consolidateCrewRatingsMutation, { data, loading, error }] = useConsolidateCrewRatingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsolidateCrewRatingsMutation(baseOptions?: Apollo.MutationHookOptions<ConsolidateCrewRatingsMutation, ConsolidateCrewRatingsMutationVariables>) {
        return Apollo.useMutation<ConsolidateCrewRatingsMutation, ConsolidateCrewRatingsMutationVariables>(ConsolidateCrewRatingsDocument, baseOptions);
      }
export type ConsolidateCrewRatingsMutationHookResult = ReturnType<typeof useConsolidateCrewRatingsMutation>;
export type ConsolidateCrewRatingsMutationResult = Apollo.MutationResult<ConsolidateCrewRatingsMutation>;
export type ConsolidateCrewRatingsMutationOptions = Apollo.BaseMutationOptions<ConsolidateCrewRatingsMutation, ConsolidateCrewRatingsMutationVariables>;
export const ListManagementEmploymentCompaniesDocument = gql`
    query listManagementEmploymentCompanies($paginationOptions: PaginationOptions) {
  listManagementItems: listManagementEmploymentCompanies(paginationOptions: $paginationOptions) {
    totalItems
    items {
      ...listManagementEmploymentCompany
    }
  }
}
    ${ListManagementEmploymentCompanyFragmentDoc}`;

/**
 * __useListManagementEmploymentCompaniesQuery__
 *
 * To run a query within a React component, call `useListManagementEmploymentCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListManagementEmploymentCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListManagementEmploymentCompaniesQuery({
 *   variables: {
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useListManagementEmploymentCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<ListManagementEmploymentCompaniesQuery, ListManagementEmploymentCompaniesQueryVariables>) {
        return Apollo.useQuery<ListManagementEmploymentCompaniesQuery, ListManagementEmploymentCompaniesQueryVariables>(ListManagementEmploymentCompaniesDocument, baseOptions);
      }
export function useListManagementEmploymentCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListManagementEmploymentCompaniesQuery, ListManagementEmploymentCompaniesQueryVariables>) {
          return Apollo.useLazyQuery<ListManagementEmploymentCompaniesQuery, ListManagementEmploymentCompaniesQueryVariables>(ListManagementEmploymentCompaniesDocument, baseOptions);
        }
export type ListManagementEmploymentCompaniesQueryHookResult = ReturnType<typeof useListManagementEmploymentCompaniesQuery>;
export type ListManagementEmploymentCompaniesLazyQueryHookResult = ReturnType<typeof useListManagementEmploymentCompaniesLazyQuery>;
export type ListManagementEmploymentCompaniesQueryResult = Apollo.QueryResult<ListManagementEmploymentCompaniesQuery, ListManagementEmploymentCompaniesQueryVariables>;
export const ConsolidateEmploymentCompaniesDocument = gql`
    mutation consolidateEmploymentCompanies($input: ListManagementLookupConsolidationInput!) {
  consolidateEmploymentCompanies(input: $input)
}
    `;
export type ConsolidateEmploymentCompaniesMutationFn = Apollo.MutationFunction<ConsolidateEmploymentCompaniesMutation, ConsolidateEmploymentCompaniesMutationVariables>;

/**
 * __useConsolidateEmploymentCompaniesMutation__
 *
 * To run a mutation, you first call `useConsolidateEmploymentCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsolidateEmploymentCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consolidateEmploymentCompaniesMutation, { data, loading, error }] = useConsolidateEmploymentCompaniesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsolidateEmploymentCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<ConsolidateEmploymentCompaniesMutation, ConsolidateEmploymentCompaniesMutationVariables>) {
        return Apollo.useMutation<ConsolidateEmploymentCompaniesMutation, ConsolidateEmploymentCompaniesMutationVariables>(ConsolidateEmploymentCompaniesDocument, baseOptions);
      }
export type ConsolidateEmploymentCompaniesMutationHookResult = ReturnType<typeof useConsolidateEmploymentCompaniesMutation>;
export type ConsolidateEmploymentCompaniesMutationResult = Apollo.MutationResult<ConsolidateEmploymentCompaniesMutation>;
export type ConsolidateEmploymentCompaniesMutationOptions = Apollo.BaseMutationOptions<ConsolidateEmploymentCompaniesMutation, ConsolidateEmploymentCompaniesMutationVariables>;
export const ListManagementGenericLvCompaniesDocument = gql`
    query listManagementGenericLvCompanies($paginationOptions: PaginationOptions) {
  listManagementItems: listManagementGenericLvCompanies(paginationOptions: $paginationOptions) {
    totalItems
    items {
      ...listManagementGenericLvCompany
    }
  }
}
    ${ListManagementGenericLvCompanyFragmentDoc}`;

/**
 * __useListManagementGenericLvCompaniesQuery__
 *
 * To run a query within a React component, call `useListManagementGenericLvCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListManagementGenericLvCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListManagementGenericLvCompaniesQuery({
 *   variables: {
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useListManagementGenericLvCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<ListManagementGenericLvCompaniesQuery, ListManagementGenericLvCompaniesQueryVariables>) {
        return Apollo.useQuery<ListManagementGenericLvCompaniesQuery, ListManagementGenericLvCompaniesQueryVariables>(ListManagementGenericLvCompaniesDocument, baseOptions);
      }
export function useListManagementGenericLvCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListManagementGenericLvCompaniesQuery, ListManagementGenericLvCompaniesQueryVariables>) {
          return Apollo.useLazyQuery<ListManagementGenericLvCompaniesQuery, ListManagementGenericLvCompaniesQueryVariables>(ListManagementGenericLvCompaniesDocument, baseOptions);
        }
export type ListManagementGenericLvCompaniesQueryHookResult = ReturnType<typeof useListManagementGenericLvCompaniesQuery>;
export type ListManagementGenericLvCompaniesLazyQueryHookResult = ReturnType<typeof useListManagementGenericLvCompaniesLazyQuery>;
export type ListManagementGenericLvCompaniesQueryResult = Apollo.QueryResult<ListManagementGenericLvCompaniesQuery, ListManagementGenericLvCompaniesQueryVariables>;
export const ConsolidateGenericLvCompaniesDocument = gql`
    mutation consolidateGenericLvCompanies($input: ListManagementLookupConsolidationInput!) {
  consolidateGenericLvCompanies(input: $input)
}
    `;
export type ConsolidateGenericLvCompaniesMutationFn = Apollo.MutationFunction<ConsolidateGenericLvCompaniesMutation, ConsolidateGenericLvCompaniesMutationVariables>;

/**
 * __useConsolidateGenericLvCompaniesMutation__
 *
 * To run a mutation, you first call `useConsolidateGenericLvCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsolidateGenericLvCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consolidateGenericLvCompaniesMutation, { data, loading, error }] = useConsolidateGenericLvCompaniesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsolidateGenericLvCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<ConsolidateGenericLvCompaniesMutation, ConsolidateGenericLvCompaniesMutationVariables>) {
        return Apollo.useMutation<ConsolidateGenericLvCompaniesMutation, ConsolidateGenericLvCompaniesMutationVariables>(ConsolidateGenericLvCompaniesDocument, baseOptions);
      }
export type ConsolidateGenericLvCompaniesMutationHookResult = ReturnType<typeof useConsolidateGenericLvCompaniesMutation>;
export type ConsolidateGenericLvCompaniesMutationResult = Apollo.MutationResult<ConsolidateGenericLvCompaniesMutation>;
export type ConsolidateGenericLvCompaniesMutationOptions = Apollo.BaseMutationOptions<ConsolidateGenericLvCompaniesMutation, ConsolidateGenericLvCompaniesMutationVariables>;
export const ListManagementMechanicRatingsDocument = gql`
    query listManagementMechanicRatings($paginationOptions: PaginationOptions) {
  listManagementItems: listManagementMechanicRatings(paginationOptions: $paginationOptions) {
    totalItems
    items {
      ...listManagementMechanicRating
    }
  }
}
    ${ListManagementMechanicRatingFragmentDoc}`;

/**
 * __useListManagementMechanicRatingsQuery__
 *
 * To run a query within a React component, call `useListManagementMechanicRatingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListManagementMechanicRatingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListManagementMechanicRatingsQuery({
 *   variables: {
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useListManagementMechanicRatingsQuery(baseOptions?: Apollo.QueryHookOptions<ListManagementMechanicRatingsQuery, ListManagementMechanicRatingsQueryVariables>) {
        return Apollo.useQuery<ListManagementMechanicRatingsQuery, ListManagementMechanicRatingsQueryVariables>(ListManagementMechanicRatingsDocument, baseOptions);
      }
export function useListManagementMechanicRatingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListManagementMechanicRatingsQuery, ListManagementMechanicRatingsQueryVariables>) {
          return Apollo.useLazyQuery<ListManagementMechanicRatingsQuery, ListManagementMechanicRatingsQueryVariables>(ListManagementMechanicRatingsDocument, baseOptions);
        }
export type ListManagementMechanicRatingsQueryHookResult = ReturnType<typeof useListManagementMechanicRatingsQuery>;
export type ListManagementMechanicRatingsLazyQueryHookResult = ReturnType<typeof useListManagementMechanicRatingsLazyQuery>;
export type ListManagementMechanicRatingsQueryResult = Apollo.QueryResult<ListManagementMechanicRatingsQuery, ListManagementMechanicRatingsQueryVariables>;
export const ConsolidateMechanicRatingsDocument = gql`
    mutation consolidateMechanicRatings($input: ListManagementLookupConsolidationInput!) {
  consolidateMechanicRatings(input: $input)
}
    `;
export type ConsolidateMechanicRatingsMutationFn = Apollo.MutationFunction<ConsolidateMechanicRatingsMutation, ConsolidateMechanicRatingsMutationVariables>;

/**
 * __useConsolidateMechanicRatingsMutation__
 *
 * To run a mutation, you first call `useConsolidateMechanicRatingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsolidateMechanicRatingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consolidateMechanicRatingsMutation, { data, loading, error }] = useConsolidateMechanicRatingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsolidateMechanicRatingsMutation(baseOptions?: Apollo.MutationHookOptions<ConsolidateMechanicRatingsMutation, ConsolidateMechanicRatingsMutationVariables>) {
        return Apollo.useMutation<ConsolidateMechanicRatingsMutation, ConsolidateMechanicRatingsMutationVariables>(ConsolidateMechanicRatingsDocument, baseOptions);
      }
export type ConsolidateMechanicRatingsMutationHookResult = ReturnType<typeof useConsolidateMechanicRatingsMutation>;
export type ConsolidateMechanicRatingsMutationResult = Apollo.MutationResult<ConsolidateMechanicRatingsMutation>;
export type ConsolidateMechanicRatingsMutationOptions = Apollo.BaseMutationOptions<ConsolidateMechanicRatingsMutation, ConsolidateMechanicRatingsMutationVariables>;
export const MechanicGridFilterLookupsQueryDocument = gql`
    query mechanicGridFilterLookupsQuery {
  countries {
    ...mechanicCountry
  }
  mechanicRatings {
    ...mechanicRating
  }
  operators {
    ... on Operators {
      operators {
        ...mechanicOperator
      }
    }
  }
}
    ${MechanicCountryFragmentDoc}
${MechanicRatingFragmentDoc}
${MechanicOperatorFragmentDoc}`;

/**
 * __useMechanicGridFilterLookupsQueryQuery__
 *
 * To run a query within a React component, call `useMechanicGridFilterLookupsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicGridFilterLookupsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicGridFilterLookupsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMechanicGridFilterLookupsQueryQuery(baseOptions?: Apollo.QueryHookOptions<MechanicGridFilterLookupsQueryQuery, MechanicGridFilterLookupsQueryQueryVariables>) {
        return Apollo.useQuery<MechanicGridFilterLookupsQueryQuery, MechanicGridFilterLookupsQueryQueryVariables>(MechanicGridFilterLookupsQueryDocument, baseOptions);
      }
export function useMechanicGridFilterLookupsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicGridFilterLookupsQueryQuery, MechanicGridFilterLookupsQueryQueryVariables>) {
          return Apollo.useLazyQuery<MechanicGridFilterLookupsQueryQuery, MechanicGridFilterLookupsQueryQueryVariables>(MechanicGridFilterLookupsQueryDocument, baseOptions);
        }
export type MechanicGridFilterLookupsQueryQueryHookResult = ReturnType<typeof useMechanicGridFilterLookupsQueryQuery>;
export type MechanicGridFilterLookupsQueryLazyQueryHookResult = ReturnType<typeof useMechanicGridFilterLookupsQueryLazyQuery>;
export type MechanicGridFilterLookupsQueryQueryResult = Apollo.QueryResult<MechanicGridFilterLookupsQueryQuery, MechanicGridFilterLookupsQueryQueryVariables>;
export const MechanicGridDocument = gql`
    query mechanicGrid($sortBy: MechanicsSortBy, $sortDirection: String, $lastNameContains: String, $mechanicStatusId: Int, $licenseCountryIdIn: [Int!], $mechanicRatingIdIn: [Int!], $operatorIdIn: [Int!], $aircraftIdIn: [Int!], $keyword: String, $paginationOptions: PaginationOptions) {
  mechanics(sortBy: $sortBy, sortDirection: $sortDirection, lastNameContains: $lastNameContains, mechanicStatusId: $mechanicStatusId, licenseCountryIdIn: $licenseCountryIdIn, mechanicRatingIdIn: $mechanicRatingIdIn, operatorIdIn: $operatorIdIn, aircraftIdIn: $aircraftIdIn, keyword: $keyword, paginationOptions: $paginationOptions) {
    ... on PaginatedMechanics {
      totalItems
      mechanics {
        ...mechanicGridItem
      }
    }
    ... on Mechanics {
      mechanics {
        ...mechanicGridItem
      }
    }
  }
}
    ${MechanicGridItemFragmentDoc}`;

/**
 * __useMechanicGridQuery__
 *
 * To run a query within a React component, call `useMechanicGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicGridQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      lastNameContains: // value for 'lastNameContains'
 *      mechanicStatusId: // value for 'mechanicStatusId'
 *      licenseCountryIdIn: // value for 'licenseCountryIdIn'
 *      mechanicRatingIdIn: // value for 'mechanicRatingIdIn'
 *      operatorIdIn: // value for 'operatorIdIn'
 *      aircraftIdIn: // value for 'aircraftIdIn'
 *      keyword: // value for 'keyword'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useMechanicGridQuery(baseOptions?: Apollo.QueryHookOptions<MechanicGridQuery, MechanicGridQueryVariables>) {
        return Apollo.useQuery<MechanicGridQuery, MechanicGridQueryVariables>(MechanicGridDocument, baseOptions);
      }
export function useMechanicGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicGridQuery, MechanicGridQueryVariables>) {
          return Apollo.useLazyQuery<MechanicGridQuery, MechanicGridQueryVariables>(MechanicGridDocument, baseOptions);
        }
export type MechanicGridQueryHookResult = ReturnType<typeof useMechanicGridQuery>;
export type MechanicGridLazyQueryHookResult = ReturnType<typeof useMechanicGridLazyQuery>;
export type MechanicGridQueryResult = Apollo.QueryResult<MechanicGridQuery, MechanicGridQueryVariables>;
export const MechanicPageQueryDocument = gql`
    query mechanicPageQuery($id: Int!) {
  mechanic(id: $id) {
    id
    firstName
    lastName
    mechanicStatus {
      id
    }
    mechanicPosition {
      id
    }
    country {
      id
    }
    mechanicLicenseType {
      id
    }
    licenseNumber
    operators {
      ...mechanicOperator
    }
    validationNumber
    employmentCompanies {
      ...mechanicEmploymentCompany
    }
    mechanicRatings {
      ...mechanicRating
    }
    aircrafts {
      ...mechanicAircraft
    }
    certificateDateOfFirstIssue
    certificateIssuedDate
    certificateExpiryDate
    activeMechanicProjects {
      id
    }
  }
  employmentCompanies(includeDeleted: true) {
    ...mechanicEmploymentCompany
  }
  operators(includeInactive: true, includeDeleted: true) {
    ... on Operators {
      operators {
        ...mechanicOperator
      }
    }
  }
  aircrafts {
    ... on Aircrafts {
      aircrafts {
        ...mechanicAircraft
      }
    }
  }
}
    ${MechanicOperatorFragmentDoc}
${MechanicEmploymentCompanyFragmentDoc}
${MechanicRatingFragmentDoc}
${MechanicAircraftFragmentDoc}`;

/**
 * __useMechanicPageQueryQuery__
 *
 * To run a query within a React component, call `useMechanicPageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicPageQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicPageQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMechanicPageQueryQuery(baseOptions: Apollo.QueryHookOptions<MechanicPageQueryQuery, MechanicPageQueryQueryVariables>) {
        return Apollo.useQuery<MechanicPageQueryQuery, MechanicPageQueryQueryVariables>(MechanicPageQueryDocument, baseOptions);
      }
export function useMechanicPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicPageQueryQuery, MechanicPageQueryQueryVariables>) {
          return Apollo.useLazyQuery<MechanicPageQueryQuery, MechanicPageQueryQueryVariables>(MechanicPageQueryDocument, baseOptions);
        }
export type MechanicPageQueryQueryHookResult = ReturnType<typeof useMechanicPageQueryQuery>;
export type MechanicPageQueryLazyQueryHookResult = ReturnType<typeof useMechanicPageQueryLazyQuery>;
export type MechanicPageQueryQueryResult = Apollo.QueryResult<MechanicPageQueryQuery, MechanicPageQueryQueryVariables>;
export const MechanicPageDateOfFirstIssueQueryDocument = gql`
    query mechanicPageDateOfFirstIssueQuery($id: Int!) {
  mechanic(id: $id) {
    mechanicStatus {
      id
    }
    certificateDateOfFirstIssue
  }
}
    `;

/**
 * __useMechanicPageDateOfFirstIssueQueryQuery__
 *
 * To run a query within a React component, call `useMechanicPageDateOfFirstIssueQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicPageDateOfFirstIssueQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicPageDateOfFirstIssueQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMechanicPageDateOfFirstIssueQueryQuery(baseOptions: Apollo.QueryHookOptions<MechanicPageDateOfFirstIssueQueryQuery, MechanicPageDateOfFirstIssueQueryQueryVariables>) {
        return Apollo.useQuery<MechanicPageDateOfFirstIssueQueryQuery, MechanicPageDateOfFirstIssueQueryQueryVariables>(MechanicPageDateOfFirstIssueQueryDocument, baseOptions);
      }
export function useMechanicPageDateOfFirstIssueQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicPageDateOfFirstIssueQueryQuery, MechanicPageDateOfFirstIssueQueryQueryVariables>) {
          return Apollo.useLazyQuery<MechanicPageDateOfFirstIssueQueryQuery, MechanicPageDateOfFirstIssueQueryQueryVariables>(MechanicPageDateOfFirstIssueQueryDocument, baseOptions);
        }
export type MechanicPageDateOfFirstIssueQueryQueryHookResult = ReturnType<typeof useMechanicPageDateOfFirstIssueQueryQuery>;
export type MechanicPageDateOfFirstIssueQueryLazyQueryHookResult = ReturnType<typeof useMechanicPageDateOfFirstIssueQueryLazyQuery>;
export type MechanicPageDateOfFirstIssueQueryQueryResult = Apollo.QueryResult<MechanicPageDateOfFirstIssueQueryQuery, MechanicPageDateOfFirstIssueQueryQueryVariables>;
export const UpdateMechanicMutationDocument = gql`
    mutation updateMechanicMutation($updateMechanicInput: UpdateMechanicInput!) {
  updateMechanic(updateMechanicInput: $updateMechanicInput) {
    id
  }
}
    `;
export type UpdateMechanicMutationMutationFn = Apollo.MutationFunction<UpdateMechanicMutationMutation, UpdateMechanicMutationMutationVariables>;

/**
 * __useUpdateMechanicMutationMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicMutationMutation, { data, loading, error }] = useUpdateMechanicMutationMutation({
 *   variables: {
 *      updateMechanicInput: // value for 'updateMechanicInput'
 *   },
 * });
 */
export function useUpdateMechanicMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicMutationMutation, UpdateMechanicMutationMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicMutationMutation, UpdateMechanicMutationMutationVariables>(UpdateMechanicMutationDocument, baseOptions);
      }
export type UpdateMechanicMutationMutationHookResult = ReturnType<typeof useUpdateMechanicMutationMutation>;
export type UpdateMechanicMutationMutationResult = Apollo.MutationResult<UpdateMechanicMutationMutation>;
export type UpdateMechanicMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicMutationMutation, UpdateMechanicMutationMutationVariables>;
export const MechanicCommentsDocument = gql`
    query mechanicComments($id: Int!) {
  mechanicComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useMechanicCommentsQuery__
 *
 * To run a query within a React component, call `useMechanicCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMechanicCommentsQuery(baseOptions: Apollo.QueryHookOptions<MechanicCommentsQuery, MechanicCommentsQueryVariables>) {
        return Apollo.useQuery<MechanicCommentsQuery, MechanicCommentsQueryVariables>(MechanicCommentsDocument, baseOptions);
      }
export function useMechanicCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicCommentsQuery, MechanicCommentsQueryVariables>) {
          return Apollo.useLazyQuery<MechanicCommentsQuery, MechanicCommentsQueryVariables>(MechanicCommentsDocument, baseOptions);
        }
export type MechanicCommentsQueryHookResult = ReturnType<typeof useMechanicCommentsQuery>;
export type MechanicCommentsLazyQueryHookResult = ReturnType<typeof useMechanicCommentsLazyQuery>;
export type MechanicCommentsQueryResult = Apollo.QueryResult<MechanicCommentsQuery, MechanicCommentsQueryVariables>;
export const AddMechanicCommentDocument = gql`
    mutation addMechanicComment($id: Int!, $input: CommentInput!) {
  addMechanicComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddMechanicCommentMutationFn = Apollo.MutationFunction<AddMechanicCommentMutation, AddMechanicCommentMutationVariables>;

/**
 * __useAddMechanicCommentMutation__
 *
 * To run a mutation, you first call `useAddMechanicCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMechanicCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMechanicCommentMutation, { data, loading, error }] = useAddMechanicCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMechanicCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddMechanicCommentMutation, AddMechanicCommentMutationVariables>) {
        return Apollo.useMutation<AddMechanicCommentMutation, AddMechanicCommentMutationVariables>(AddMechanicCommentDocument, baseOptions);
      }
export type AddMechanicCommentMutationHookResult = ReturnType<typeof useAddMechanicCommentMutation>;
export type AddMechanicCommentMutationResult = Apollo.MutationResult<AddMechanicCommentMutation>;
export type AddMechanicCommentMutationOptions = Apollo.BaseMutationOptions<AddMechanicCommentMutation, AddMechanicCommentMutationVariables>;
export const UpdateMechanicCommentDocument = gql`
    mutation updateMechanicComment($id: Int!, $body: String!) {
  updateMechanicComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateMechanicCommentMutationFn = Apollo.MutationFunction<UpdateMechanicCommentMutation, UpdateMechanicCommentMutationVariables>;

/**
 * __useUpdateMechanicCommentMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicCommentMutation, { data, loading, error }] = useUpdateMechanicCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateMechanicCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicCommentMutation, UpdateMechanicCommentMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicCommentMutation, UpdateMechanicCommentMutationVariables>(UpdateMechanicCommentDocument, baseOptions);
      }
export type UpdateMechanicCommentMutationHookResult = ReturnType<typeof useUpdateMechanicCommentMutation>;
export type UpdateMechanicCommentMutationResult = Apollo.MutationResult<UpdateMechanicCommentMutation>;
export type UpdateMechanicCommentMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicCommentMutation, UpdateMechanicCommentMutationVariables>;
export const UpdateMechanicCommentsLastViewedDateDocument = gql`
    mutation updateMechanicCommentsLastViewedDate($id: Int!) {
  updateMechanicCommentsLastViewedDate(mechanicId: $id) {
    id
  }
}
    `;
export type UpdateMechanicCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateMechanicCommentsLastViewedDateMutation, UpdateMechanicCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateMechanicCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateMechanicCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateMechanicCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicCommentsLastViewedDateMutation, UpdateMechanicCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicCommentsLastViewedDateMutation, UpdateMechanicCommentsLastViewedDateMutationVariables>(UpdateMechanicCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateMechanicCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateMechanicCommentsLastViewedDateMutation>;
export type UpdateMechanicCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateMechanicCommentsLastViewedDateMutation>;
export type UpdateMechanicCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicCommentsLastViewedDateMutation, UpdateMechanicCommentsLastViewedDateMutationVariables>;
export const MechanicDocumentsQueryDocument = gql`
    query mechanicDocumentsQuery($mechanicId: Int!, $documentTypeCategoryId: DocumentTypeCategoryEnum!) {
  mechanic(id: $mechanicId) {
    certificateDateOfFirstIssue
  }
  documents: mechanicDocuments(mechanicId: $mechanicId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...mechanicDocument
  }
  documentTypes: mechanicDocumentTypes(mechanicId: $mechanicId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...documentType
  }
}
    ${MechanicDocumentFragmentDoc}
${DocumentTypeFragmentDoc}`;

/**
 * __useMechanicDocumentsQueryQuery__
 *
 * To run a query within a React component, call `useMechanicDocumentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicDocumentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicDocumentsQueryQuery({
 *   variables: {
 *      mechanicId: // value for 'mechanicId'
 *      documentTypeCategoryId: // value for 'documentTypeCategoryId'
 *   },
 * });
 */
export function useMechanicDocumentsQueryQuery(baseOptions: Apollo.QueryHookOptions<MechanicDocumentsQueryQuery, MechanicDocumentsQueryQueryVariables>) {
        return Apollo.useQuery<MechanicDocumentsQueryQuery, MechanicDocumentsQueryQueryVariables>(MechanicDocumentsQueryDocument, baseOptions);
      }
export function useMechanicDocumentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicDocumentsQueryQuery, MechanicDocumentsQueryQueryVariables>) {
          return Apollo.useLazyQuery<MechanicDocumentsQueryQuery, MechanicDocumentsQueryQueryVariables>(MechanicDocumentsQueryDocument, baseOptions);
        }
export type MechanicDocumentsQueryQueryHookResult = ReturnType<typeof useMechanicDocumentsQueryQuery>;
export type MechanicDocumentsQueryLazyQueryHookResult = ReturnType<typeof useMechanicDocumentsQueryLazyQuery>;
export type MechanicDocumentsQueryQueryResult = Apollo.QueryResult<MechanicDocumentsQueryQuery, MechanicDocumentsQueryQueryVariables>;
export const AddMechanicDocumentMutationDocument = gql`
    mutation addMechanicDocumentMutation($addMechanicDocumentInput: AddMechanicDocumentInput!) {
  addMechanicDocument(addMechanicDocumentInput: $addMechanicDocumentInput) {
    id
  }
}
    `;
export type AddMechanicDocumentMutationMutationFn = Apollo.MutationFunction<AddMechanicDocumentMutationMutation, AddMechanicDocumentMutationMutationVariables>;

/**
 * __useAddMechanicDocumentMutationMutation__
 *
 * To run a mutation, you first call `useAddMechanicDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMechanicDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMechanicDocumentMutationMutation, { data, loading, error }] = useAddMechanicDocumentMutationMutation({
 *   variables: {
 *      addMechanicDocumentInput: // value for 'addMechanicDocumentInput'
 *   },
 * });
 */
export function useAddMechanicDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddMechanicDocumentMutationMutation, AddMechanicDocumentMutationMutationVariables>) {
        return Apollo.useMutation<AddMechanicDocumentMutationMutation, AddMechanicDocumentMutationMutationVariables>(AddMechanicDocumentMutationDocument, baseOptions);
      }
export type AddMechanicDocumentMutationMutationHookResult = ReturnType<typeof useAddMechanicDocumentMutationMutation>;
export type AddMechanicDocumentMutationMutationResult = Apollo.MutationResult<AddMechanicDocumentMutationMutation>;
export type AddMechanicDocumentMutationMutationOptions = Apollo.BaseMutationOptions<AddMechanicDocumentMutationMutation, AddMechanicDocumentMutationMutationVariables>;
export const UpdateMechanicDocumentMutationDocument = gql`
    mutation updateMechanicDocumentMutation($updateMechanicDocumentInput: UpdateMechanicDocumentInput!) {
  updateMechanicDocument(updateMechanicDocumentInput: $updateMechanicDocumentInput) {
    id
  }
}
    `;
export type UpdateMechanicDocumentMutationMutationFn = Apollo.MutationFunction<UpdateMechanicDocumentMutationMutation, UpdateMechanicDocumentMutationMutationVariables>;

/**
 * __useUpdateMechanicDocumentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicDocumentMutationMutation, { data, loading, error }] = useUpdateMechanicDocumentMutationMutation({
 *   variables: {
 *      updateMechanicDocumentInput: // value for 'updateMechanicDocumentInput'
 *   },
 * });
 */
export function useUpdateMechanicDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicDocumentMutationMutation, UpdateMechanicDocumentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicDocumentMutationMutation, UpdateMechanicDocumentMutationMutationVariables>(UpdateMechanicDocumentMutationDocument, baseOptions);
      }
export type UpdateMechanicDocumentMutationMutationHookResult = ReturnType<typeof useUpdateMechanicDocumentMutationMutation>;
export type UpdateMechanicDocumentMutationMutationResult = Apollo.MutationResult<UpdateMechanicDocumentMutationMutation>;
export type UpdateMechanicDocumentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicDocumentMutationMutation, UpdateMechanicDocumentMutationMutationVariables>;
export const RemoveMechanicDocumentMutationDocument = gql`
    mutation removeMechanicDocumentMutation($id: Int!) {
  removeMechanicDocument(id: $id)
}
    `;
export type RemoveMechanicDocumentMutationMutationFn = Apollo.MutationFunction<RemoveMechanicDocumentMutationMutation, RemoveMechanicDocumentMutationMutationVariables>;

/**
 * __useRemoveMechanicDocumentMutationMutation__
 *
 * To run a mutation, you first call `useRemoveMechanicDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMechanicDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMechanicDocumentMutationMutation, { data, loading, error }] = useRemoveMechanicDocumentMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMechanicDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMechanicDocumentMutationMutation, RemoveMechanicDocumentMutationMutationVariables>) {
        return Apollo.useMutation<RemoveMechanicDocumentMutationMutation, RemoveMechanicDocumentMutationMutationVariables>(RemoveMechanicDocumentMutationDocument, baseOptions);
      }
export type RemoveMechanicDocumentMutationMutationHookResult = ReturnType<typeof useRemoveMechanicDocumentMutationMutation>;
export type RemoveMechanicDocumentMutationMutationResult = Apollo.MutationResult<RemoveMechanicDocumentMutationMutation>;
export type RemoveMechanicDocumentMutationMutationOptions = Apollo.BaseMutationOptions<RemoveMechanicDocumentMutationMutation, RemoveMechanicDocumentMutationMutationVariables>;
export const DownloadMechanicDocumentDocument = gql`
    query downloadMechanicDocument($id: Int!) {
  file: downloadMechanicDocument(id: $id) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadMechanicDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadMechanicDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadMechanicDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadMechanicDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadMechanicDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadMechanicDocumentQuery, DownloadMechanicDocumentQueryVariables>) {
        return Apollo.useQuery<DownloadMechanicDocumentQuery, DownloadMechanicDocumentQueryVariables>(DownloadMechanicDocumentDocument, baseOptions);
      }
export function useDownloadMechanicDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadMechanicDocumentQuery, DownloadMechanicDocumentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadMechanicDocumentQuery, DownloadMechanicDocumentQueryVariables>(DownloadMechanicDocumentDocument, baseOptions);
        }
export type DownloadMechanicDocumentQueryHookResult = ReturnType<typeof useDownloadMechanicDocumentQuery>;
export type DownloadMechanicDocumentLazyQueryHookResult = ReturnType<typeof useDownloadMechanicDocumentLazyQuery>;
export type DownloadMechanicDocumentQueryResult = Apollo.QueryResult<DownloadMechanicDocumentQuery, DownloadMechanicDocumentQueryVariables>;
export const AddMechanicMutationDocument = gql`
    mutation addMechanicMutation($addMechanicInput: AddMechanicInput!) {
  addMechanic(addMechanicInput: $addMechanicInput) {
    id
  }
}
    `;
export type AddMechanicMutationMutationFn = Apollo.MutationFunction<AddMechanicMutationMutation, AddMechanicMutationMutationVariables>;

/**
 * __useAddMechanicMutationMutation__
 *
 * To run a mutation, you first call `useAddMechanicMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMechanicMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMechanicMutationMutation, { data, loading, error }] = useAddMechanicMutationMutation({
 *   variables: {
 *      addMechanicInput: // value for 'addMechanicInput'
 *   },
 * });
 */
export function useAddMechanicMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddMechanicMutationMutation, AddMechanicMutationMutationVariables>) {
        return Apollo.useMutation<AddMechanicMutationMutation, AddMechanicMutationMutationVariables>(AddMechanicMutationDocument, baseOptions);
      }
export type AddMechanicMutationMutationHookResult = ReturnType<typeof useAddMechanicMutationMutation>;
export type AddMechanicMutationMutationResult = Apollo.MutationResult<AddMechanicMutationMutation>;
export type AddMechanicMutationMutationOptions = Apollo.BaseMutationOptions<AddMechanicMutationMutation, AddMechanicMutationMutationVariables>;
export const MechanicProjectDocumentsQueryDocument = gql`
    query mechanicProjectDocumentsQuery($mechanicProjectId: Int!, $documentTypeCategoryId: DocumentTypeCategoryEnum!) {
  mechanicProject(id: $mechanicProjectId) {
    mechanic {
      certificateDateOfFirstIssue
    }
    certificateExpiryDate
  }
  documents: mechanicProjectDocuments(mechanicProjectId: $mechanicProjectId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...mechanicProjectDocument
  }
  documentTypes: mechanicProjectDocumentTypes(mechanicProjectId: $mechanicProjectId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...documentType
  }
}
    ${MechanicProjectDocumentFragmentDoc}
${DocumentTypeFragmentDoc}`;

/**
 * __useMechanicProjectDocumentsQueryQuery__
 *
 * To run a query within a React component, call `useMechanicProjectDocumentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectDocumentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectDocumentsQueryQuery({
 *   variables: {
 *      mechanicProjectId: // value for 'mechanicProjectId'
 *      documentTypeCategoryId: // value for 'documentTypeCategoryId'
 *   },
 * });
 */
export function useMechanicProjectDocumentsQueryQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectDocumentsQueryQuery, MechanicProjectDocumentsQueryQueryVariables>) {
        return Apollo.useQuery<MechanicProjectDocumentsQueryQuery, MechanicProjectDocumentsQueryQueryVariables>(MechanicProjectDocumentsQueryDocument, baseOptions);
      }
export function useMechanicProjectDocumentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectDocumentsQueryQuery, MechanicProjectDocumentsQueryQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectDocumentsQueryQuery, MechanicProjectDocumentsQueryQueryVariables>(MechanicProjectDocumentsQueryDocument, baseOptions);
        }
export type MechanicProjectDocumentsQueryQueryHookResult = ReturnType<typeof useMechanicProjectDocumentsQueryQuery>;
export type MechanicProjectDocumentsQueryLazyQueryHookResult = ReturnType<typeof useMechanicProjectDocumentsQueryLazyQuery>;
export type MechanicProjectDocumentsQueryQueryResult = Apollo.QueryResult<MechanicProjectDocumentsQueryQuery, MechanicProjectDocumentsQueryQueryVariables>;
export const AddMechanicProjectDocumentMutationDocument = gql`
    mutation addMechanicProjectDocumentMutation($addMechanicProjectDocumentInput: AddMechanicProjectDocumentInput!) {
  addMechanicProjectDocument(addMechanicProjectDocumentInput: $addMechanicProjectDocumentInput) {
    id
  }
}
    `;
export type AddMechanicProjectDocumentMutationMutationFn = Apollo.MutationFunction<AddMechanicProjectDocumentMutationMutation, AddMechanicProjectDocumentMutationMutationVariables>;

/**
 * __useAddMechanicProjectDocumentMutationMutation__
 *
 * To run a mutation, you first call `useAddMechanicProjectDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMechanicProjectDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMechanicProjectDocumentMutationMutation, { data, loading, error }] = useAddMechanicProjectDocumentMutationMutation({
 *   variables: {
 *      addMechanicProjectDocumentInput: // value for 'addMechanicProjectDocumentInput'
 *   },
 * });
 */
export function useAddMechanicProjectDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddMechanicProjectDocumentMutationMutation, AddMechanicProjectDocumentMutationMutationVariables>) {
        return Apollo.useMutation<AddMechanicProjectDocumentMutationMutation, AddMechanicProjectDocumentMutationMutationVariables>(AddMechanicProjectDocumentMutationDocument, baseOptions);
      }
export type AddMechanicProjectDocumentMutationMutationHookResult = ReturnType<typeof useAddMechanicProjectDocumentMutationMutation>;
export type AddMechanicProjectDocumentMutationMutationResult = Apollo.MutationResult<AddMechanicProjectDocumentMutationMutation>;
export type AddMechanicProjectDocumentMutationMutationOptions = Apollo.BaseMutationOptions<AddMechanicProjectDocumentMutationMutation, AddMechanicProjectDocumentMutationMutationVariables>;
export const UpdateMechanicProjectDocumentMutationDocument = gql`
    mutation updateMechanicProjectDocumentMutation($updateMechanicProjectDocumentInput: UpdateMechanicProjectDocumentInput!) {
  updateMechanicProjectDocument(updateMechanicProjectDocumentInput: $updateMechanicProjectDocumentInput) {
    id
  }
}
    `;
export type UpdateMechanicProjectDocumentMutationMutationFn = Apollo.MutationFunction<UpdateMechanicProjectDocumentMutationMutation, UpdateMechanicProjectDocumentMutationMutationVariables>;

/**
 * __useUpdateMechanicProjectDocumentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectDocumentMutationMutation, { data, loading, error }] = useUpdateMechanicProjectDocumentMutationMutation({
 *   variables: {
 *      updateMechanicProjectDocumentInput: // value for 'updateMechanicProjectDocumentInput'
 *   },
 * });
 */
export function useUpdateMechanicProjectDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectDocumentMutationMutation, UpdateMechanicProjectDocumentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectDocumentMutationMutation, UpdateMechanicProjectDocumentMutationMutationVariables>(UpdateMechanicProjectDocumentMutationDocument, baseOptions);
      }
export type UpdateMechanicProjectDocumentMutationMutationHookResult = ReturnType<typeof useUpdateMechanicProjectDocumentMutationMutation>;
export type UpdateMechanicProjectDocumentMutationMutationResult = Apollo.MutationResult<UpdateMechanicProjectDocumentMutationMutation>;
export type UpdateMechanicProjectDocumentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectDocumentMutationMutation, UpdateMechanicProjectDocumentMutationMutationVariables>;
export const RemoveMechanicProjectDocumentMutationDocument = gql`
    mutation removeMechanicProjectDocumentMutation($id: Int!) {
  removeMechanicProjectDocument(id: $id)
}
    `;
export type RemoveMechanicProjectDocumentMutationMutationFn = Apollo.MutationFunction<RemoveMechanicProjectDocumentMutationMutation, RemoveMechanicProjectDocumentMutationMutationVariables>;

/**
 * __useRemoveMechanicProjectDocumentMutationMutation__
 *
 * To run a mutation, you first call `useRemoveMechanicProjectDocumentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMechanicProjectDocumentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMechanicProjectDocumentMutationMutation, { data, loading, error }] = useRemoveMechanicProjectDocumentMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMechanicProjectDocumentMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMechanicProjectDocumentMutationMutation, RemoveMechanicProjectDocumentMutationMutationVariables>) {
        return Apollo.useMutation<RemoveMechanicProjectDocumentMutationMutation, RemoveMechanicProjectDocumentMutationMutationVariables>(RemoveMechanicProjectDocumentMutationDocument, baseOptions);
      }
export type RemoveMechanicProjectDocumentMutationMutationHookResult = ReturnType<typeof useRemoveMechanicProjectDocumentMutationMutation>;
export type RemoveMechanicProjectDocumentMutationMutationResult = Apollo.MutationResult<RemoveMechanicProjectDocumentMutationMutation>;
export type RemoveMechanicProjectDocumentMutationMutationOptions = Apollo.BaseMutationOptions<RemoveMechanicProjectDocumentMutationMutation, RemoveMechanicProjectDocumentMutationMutationVariables>;
export const DownloadMechanicProjectDocumentDocument = gql`
    query downloadMechanicProjectDocument($id: Int!) {
  file: downloadMechanicProjectDocument(id: $id) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadMechanicProjectDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadMechanicProjectDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadMechanicProjectDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadMechanicProjectDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadMechanicProjectDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadMechanicProjectDocumentQuery, DownloadMechanicProjectDocumentQueryVariables>) {
        return Apollo.useQuery<DownloadMechanicProjectDocumentQuery, DownloadMechanicProjectDocumentQueryVariables>(DownloadMechanicProjectDocumentDocument, baseOptions);
      }
export function useDownloadMechanicProjectDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadMechanicProjectDocumentQuery, DownloadMechanicProjectDocumentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadMechanicProjectDocumentQuery, DownloadMechanicProjectDocumentQueryVariables>(DownloadMechanicProjectDocumentDocument, baseOptions);
        }
export type DownloadMechanicProjectDocumentQueryHookResult = ReturnType<typeof useDownloadMechanicProjectDocumentQuery>;
export type DownloadMechanicProjectDocumentLazyQueryHookResult = ReturnType<typeof useDownloadMechanicProjectDocumentLazyQuery>;
export type DownloadMechanicProjectDocumentQueryResult = Apollo.QueryResult<DownloadMechanicProjectDocumentQuery, DownloadMechanicProjectDocumentQueryVariables>;
export const RequestMechanicProjectDocumentDownloadTokenMutationDocument = gql`
    mutation requestMechanicProjectDocumentDownloadTokenMutation($id: Int!, $downloadFileName: String) {
  requestMechanicProjectDocumentDownloadToken(id: $id, downloadFileName: $downloadFileName)
}
    `;
export type RequestMechanicProjectDocumentDownloadTokenMutationMutationFn = Apollo.MutationFunction<RequestMechanicProjectDocumentDownloadTokenMutationMutation, RequestMechanicProjectDocumentDownloadTokenMutationMutationVariables>;

/**
 * __useRequestMechanicProjectDocumentDownloadTokenMutationMutation__
 *
 * To run a mutation, you first call `useRequestMechanicProjectDocumentDownloadTokenMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMechanicProjectDocumentDownloadTokenMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMechanicProjectDocumentDownloadTokenMutationMutation, { data, loading, error }] = useRequestMechanicProjectDocumentDownloadTokenMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      downloadFileName: // value for 'downloadFileName'
 *   },
 * });
 */
export function useRequestMechanicProjectDocumentDownloadTokenMutationMutation(baseOptions?: Apollo.MutationHookOptions<RequestMechanicProjectDocumentDownloadTokenMutationMutation, RequestMechanicProjectDocumentDownloadTokenMutationMutationVariables>) {
        return Apollo.useMutation<RequestMechanicProjectDocumentDownloadTokenMutationMutation, RequestMechanicProjectDocumentDownloadTokenMutationMutationVariables>(RequestMechanicProjectDocumentDownloadTokenMutationDocument, baseOptions);
      }
export type RequestMechanicProjectDocumentDownloadTokenMutationMutationHookResult = ReturnType<typeof useRequestMechanicProjectDocumentDownloadTokenMutationMutation>;
export type RequestMechanicProjectDocumentDownloadTokenMutationMutationResult = Apollo.MutationResult<RequestMechanicProjectDocumentDownloadTokenMutationMutation>;
export type RequestMechanicProjectDocumentDownloadTokenMutationMutationOptions = Apollo.BaseMutationOptions<RequestMechanicProjectDocumentDownloadTokenMutationMutation, RequestMechanicProjectDocumentDownloadTokenMutationMutationVariables>;
export const UpdateMechanicProjectDocumentReleasedToDcaMutationDocument = gql`
    mutation updateMechanicProjectDocumentReleasedToDcaMutation($input: UpdateMechanicProjectDocumentReleasedToDcaInput!) {
  updateMechanicProjectDocumentReleasedToDca(input: $input) {
    id
  }
}
    `;
export type UpdateMechanicProjectDocumentReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateMechanicProjectDocumentReleasedToDcaMutationMutation, UpdateMechanicProjectDocumentReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateMechanicProjectDocumentReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectDocumentReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectDocumentReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectDocumentReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateMechanicProjectDocumentReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMechanicProjectDocumentReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectDocumentReleasedToDcaMutationMutation, UpdateMechanicProjectDocumentReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectDocumentReleasedToDcaMutationMutation, UpdateMechanicProjectDocumentReleasedToDcaMutationMutationVariables>(UpdateMechanicProjectDocumentReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateMechanicProjectDocumentReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateMechanicProjectDocumentReleasedToDcaMutationMutation>;
export type UpdateMechanicProjectDocumentReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateMechanicProjectDocumentReleasedToDcaMutationMutation>;
export type UpdateMechanicProjectDocumentReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectDocumentReleasedToDcaMutationMutation, UpdateMechanicProjectDocumentReleasedToDcaMutationMutationVariables>;
export const MechanicProjectGridDocument = gql`
    query mechanicProjectGrid($sortBy: MechanicProjectsSortBy, $sortDirection: String, $mechanicId: Int, $operatorIdIn: [Int!], $associatedAircraftProjectIdIn: [Int!], $projectStatusIdIn: [Int!], $projectStatusIdNotIn: [Int!], $paginationOptions: PaginationOptions) {
  mechanicProjects(sortBy: $sortBy, sortDirection: $sortDirection, mechanicId: $mechanicId, operatorIdIn: $operatorIdIn, associatedAircraftProjectIdIn: $associatedAircraftProjectIdIn, projectStatusIdIn: $projectStatusIdIn, projectStatusIdNotIn: $projectStatusIdNotIn, paginationOptions: $paginationOptions) {
    ... on PaginatedMechanicProjects {
      totalItems
      mechanicProjects {
        ...mechanicProjectGridItem
      }
    }
    ... on MechanicProjects {
      mechanicProjects {
        ...mechanicProjectGridItem
      }
    }
  }
}
    ${MechanicProjectGridItemFragmentDoc}`;

/**
 * __useMechanicProjectGridQuery__
 *
 * To run a query within a React component, call `useMechanicProjectGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectGridQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      mechanicId: // value for 'mechanicId'
 *      operatorIdIn: // value for 'operatorIdIn'
 *      associatedAircraftProjectIdIn: // value for 'associatedAircraftProjectIdIn'
 *      projectStatusIdIn: // value for 'projectStatusIdIn'
 *      projectStatusIdNotIn: // value for 'projectStatusIdNotIn'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useMechanicProjectGridQuery(baseOptions?: Apollo.QueryHookOptions<MechanicProjectGridQuery, MechanicProjectGridQueryVariables>) {
        return Apollo.useQuery<MechanicProjectGridQuery, MechanicProjectGridQueryVariables>(MechanicProjectGridDocument, baseOptions);
      }
export function useMechanicProjectGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectGridQuery, MechanicProjectGridQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectGridQuery, MechanicProjectGridQueryVariables>(MechanicProjectGridDocument, baseOptions);
        }
export type MechanicProjectGridQueryHookResult = ReturnType<typeof useMechanicProjectGridQuery>;
export type MechanicProjectGridLazyQueryHookResult = ReturnType<typeof useMechanicProjectGridLazyQuery>;
export type MechanicProjectGridQueryResult = Apollo.QueryResult<MechanicProjectGridQuery, MechanicProjectGridQueryVariables>;
export const MechanicProjectCertificatePreviewDocument = gql`
    query mechanicProjectCertificatePreview($mechanicProjectId: Int!) {
  downloadMechanicCertificatePreview(mechanicProjectId: $mechanicProjectId) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useMechanicProjectCertificatePreviewQuery__
 *
 * To run a query within a React component, call `useMechanicProjectCertificatePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectCertificatePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectCertificatePreviewQuery({
 *   variables: {
 *      mechanicProjectId: // value for 'mechanicProjectId'
 *   },
 * });
 */
export function useMechanicProjectCertificatePreviewQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectCertificatePreviewQuery, MechanicProjectCertificatePreviewQueryVariables>) {
        return Apollo.useQuery<MechanicProjectCertificatePreviewQuery, MechanicProjectCertificatePreviewQueryVariables>(MechanicProjectCertificatePreviewDocument, baseOptions);
      }
export function useMechanicProjectCertificatePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectCertificatePreviewQuery, MechanicProjectCertificatePreviewQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectCertificatePreviewQuery, MechanicProjectCertificatePreviewQueryVariables>(MechanicProjectCertificatePreviewDocument, baseOptions);
        }
export type MechanicProjectCertificatePreviewQueryHookResult = ReturnType<typeof useMechanicProjectCertificatePreviewQuery>;
export type MechanicProjectCertificatePreviewLazyQueryHookResult = ReturnType<typeof useMechanicProjectCertificatePreviewLazyQuery>;
export type MechanicProjectCertificatePreviewQueryResult = Apollo.QueryResult<MechanicProjectCertificatePreviewQuery, MechanicProjectCertificatePreviewQueryVariables>;
export const DownloadMechanicProjectOfficialLetterPreviewDocument = gql`
    query downloadMechanicProjectOfficialLetterPreview($mechanicProjectId: Int!) {
  downloadMechanicProjectOfficialLetterPreview(mechanicProjectId: $mechanicProjectId) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadMechanicProjectOfficialLetterPreviewQuery__
 *
 * To run a query within a React component, call `useDownloadMechanicProjectOfficialLetterPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadMechanicProjectOfficialLetterPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadMechanicProjectOfficialLetterPreviewQuery({
 *   variables: {
 *      mechanicProjectId: // value for 'mechanicProjectId'
 *   },
 * });
 */
export function useDownloadMechanicProjectOfficialLetterPreviewQuery(baseOptions: Apollo.QueryHookOptions<DownloadMechanicProjectOfficialLetterPreviewQuery, DownloadMechanicProjectOfficialLetterPreviewQueryVariables>) {
        return Apollo.useQuery<DownloadMechanicProjectOfficialLetterPreviewQuery, DownloadMechanicProjectOfficialLetterPreviewQueryVariables>(DownloadMechanicProjectOfficialLetterPreviewDocument, baseOptions);
      }
export function useDownloadMechanicProjectOfficialLetterPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadMechanicProjectOfficialLetterPreviewQuery, DownloadMechanicProjectOfficialLetterPreviewQueryVariables>) {
          return Apollo.useLazyQuery<DownloadMechanicProjectOfficialLetterPreviewQuery, DownloadMechanicProjectOfficialLetterPreviewQueryVariables>(DownloadMechanicProjectOfficialLetterPreviewDocument, baseOptions);
        }
export type DownloadMechanicProjectOfficialLetterPreviewQueryHookResult = ReturnType<typeof useDownloadMechanicProjectOfficialLetterPreviewQuery>;
export type DownloadMechanicProjectOfficialLetterPreviewLazyQueryHookResult = ReturnType<typeof useDownloadMechanicProjectOfficialLetterPreviewLazyQuery>;
export type DownloadMechanicProjectOfficialLetterPreviewQueryResult = Apollo.QueryResult<DownloadMechanicProjectOfficialLetterPreviewQuery, DownloadMechanicProjectOfficialLetterPreviewQueryVariables>;
export const AddMechanicProjectMutationDocument = gql`
    mutation addMechanicProjectMutation($addMechanicProjectInput: AddMechanicProjectInput!) {
  addMechanicProject(addMechanicProjectInput: $addMechanicProjectInput) {
    id
  }
}
    `;
export type AddMechanicProjectMutationMutationFn = Apollo.MutationFunction<AddMechanicProjectMutationMutation, AddMechanicProjectMutationMutationVariables>;

/**
 * __useAddMechanicProjectMutationMutation__
 *
 * To run a mutation, you first call `useAddMechanicProjectMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMechanicProjectMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMechanicProjectMutationMutation, { data, loading, error }] = useAddMechanicProjectMutationMutation({
 *   variables: {
 *      addMechanicProjectInput: // value for 'addMechanicProjectInput'
 *   },
 * });
 */
export function useAddMechanicProjectMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddMechanicProjectMutationMutation, AddMechanicProjectMutationMutationVariables>) {
        return Apollo.useMutation<AddMechanicProjectMutationMutation, AddMechanicProjectMutationMutationVariables>(AddMechanicProjectMutationDocument, baseOptions);
      }
export type AddMechanicProjectMutationMutationHookResult = ReturnType<typeof useAddMechanicProjectMutationMutation>;
export type AddMechanicProjectMutationMutationResult = Apollo.MutationResult<AddMechanicProjectMutationMutation>;
export type AddMechanicProjectMutationMutationOptions = Apollo.BaseMutationOptions<AddMechanicProjectMutationMutation, AddMechanicProjectMutationMutationVariables>;
export const AddMechanicProjectModalMechanicDocument = gql`
    query addMechanicProjectModalMechanic($id: Int!) {
  mechanic(id: $id) {
    id
    mechanicPosition {
      id
    }
  }
}
    `;

/**
 * __useAddMechanicProjectModalMechanicQuery__
 *
 * To run a query within a React component, call `useAddMechanicProjectModalMechanicQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddMechanicProjectModalMechanicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddMechanicProjectModalMechanicQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddMechanicProjectModalMechanicQuery(baseOptions: Apollo.QueryHookOptions<AddMechanicProjectModalMechanicQuery, AddMechanicProjectModalMechanicQueryVariables>) {
        return Apollo.useQuery<AddMechanicProjectModalMechanicQuery, AddMechanicProjectModalMechanicQueryVariables>(AddMechanicProjectModalMechanicDocument, baseOptions);
      }
export function useAddMechanicProjectModalMechanicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddMechanicProjectModalMechanicQuery, AddMechanicProjectModalMechanicQueryVariables>) {
          return Apollo.useLazyQuery<AddMechanicProjectModalMechanicQuery, AddMechanicProjectModalMechanicQueryVariables>(AddMechanicProjectModalMechanicDocument, baseOptions);
        }
export type AddMechanicProjectModalMechanicQueryHookResult = ReturnType<typeof useAddMechanicProjectModalMechanicQuery>;
export type AddMechanicProjectModalMechanicLazyQueryHookResult = ReturnType<typeof useAddMechanicProjectModalMechanicLazyQuery>;
export type AddMechanicProjectModalMechanicQueryResult = Apollo.QueryResult<AddMechanicProjectModalMechanicQuery, AddMechanicProjectModalMechanicQueryVariables>;
export const MechanicProjectHeaderDocument = gql`
    query mechanicProjectHeader($mechanicProjectId: Int!) {
  mechanicProject(id: $mechanicProjectId) {
    ...mechanicProjectHeader
  }
}
    ${MechanicProjectHeaderFragmentDoc}`;

/**
 * __useMechanicProjectHeaderQuery__
 *
 * To run a query within a React component, call `useMechanicProjectHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectHeaderQuery({
 *   variables: {
 *      mechanicProjectId: // value for 'mechanicProjectId'
 *   },
 * });
 */
export function useMechanicProjectHeaderQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectHeaderQuery, MechanicProjectHeaderQueryVariables>) {
        return Apollo.useQuery<MechanicProjectHeaderQuery, MechanicProjectHeaderQueryVariables>(MechanicProjectHeaderDocument, baseOptions);
      }
export function useMechanicProjectHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectHeaderQuery, MechanicProjectHeaderQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectHeaderQuery, MechanicProjectHeaderQueryVariables>(MechanicProjectHeaderDocument, baseOptions);
        }
export type MechanicProjectHeaderQueryHookResult = ReturnType<typeof useMechanicProjectHeaderQuery>;
export type MechanicProjectHeaderLazyQueryHookResult = ReturnType<typeof useMechanicProjectHeaderLazyQuery>;
export type MechanicProjectHeaderQueryResult = Apollo.QueryResult<MechanicProjectHeaderQuery, MechanicProjectHeaderQueryVariables>;
export const MechanicProjectCommentsDocument = gql`
    query mechanicProjectComments($id: Int!) {
  mechanicProjectComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useMechanicProjectCommentsQuery__
 *
 * To run a query within a React component, call `useMechanicProjectCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMechanicProjectCommentsQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectCommentsQuery, MechanicProjectCommentsQueryVariables>) {
        return Apollo.useQuery<MechanicProjectCommentsQuery, MechanicProjectCommentsQueryVariables>(MechanicProjectCommentsDocument, baseOptions);
      }
export function useMechanicProjectCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectCommentsQuery, MechanicProjectCommentsQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectCommentsQuery, MechanicProjectCommentsQueryVariables>(MechanicProjectCommentsDocument, baseOptions);
        }
export type MechanicProjectCommentsQueryHookResult = ReturnType<typeof useMechanicProjectCommentsQuery>;
export type MechanicProjectCommentsLazyQueryHookResult = ReturnType<typeof useMechanicProjectCommentsLazyQuery>;
export type MechanicProjectCommentsQueryResult = Apollo.QueryResult<MechanicProjectCommentsQuery, MechanicProjectCommentsQueryVariables>;
export const MechanicProjectSendToDcaCheckDocument = gql`
    query mechanicProjectSendToDcaCheck($mechanicProjectId: Int!) {
  mechanicProjectInsForms(mechanicProjectId: $mechanicProjectId) {
    ...sendToDcaCheck
  }
}
    ${SendToDcaCheckFragmentDoc}`;

/**
 * __useMechanicProjectSendToDcaCheckQuery__
 *
 * To run a query within a React component, call `useMechanicProjectSendToDcaCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectSendToDcaCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectSendToDcaCheckQuery({
 *   variables: {
 *      mechanicProjectId: // value for 'mechanicProjectId'
 *   },
 * });
 */
export function useMechanicProjectSendToDcaCheckQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectSendToDcaCheckQuery, MechanicProjectSendToDcaCheckQueryVariables>) {
        return Apollo.useQuery<MechanicProjectSendToDcaCheckQuery, MechanicProjectSendToDcaCheckQueryVariables>(MechanicProjectSendToDcaCheckDocument, baseOptions);
      }
export function useMechanicProjectSendToDcaCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectSendToDcaCheckQuery, MechanicProjectSendToDcaCheckQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectSendToDcaCheckQuery, MechanicProjectSendToDcaCheckQueryVariables>(MechanicProjectSendToDcaCheckDocument, baseOptions);
        }
export type MechanicProjectSendToDcaCheckQueryHookResult = ReturnType<typeof useMechanicProjectSendToDcaCheckQuery>;
export type MechanicProjectSendToDcaCheckLazyQueryHookResult = ReturnType<typeof useMechanicProjectSendToDcaCheckLazyQuery>;
export type MechanicProjectSendToDcaCheckQueryResult = Apollo.QueryResult<MechanicProjectSendToDcaCheckQuery, MechanicProjectSendToDcaCheckQueryVariables>;
export const MechanicProjectReopenByDcaOpenProjectsCheckDocument = gql`
    query mechanicProjectReopenByDcaOpenProjectsCheck($mechanicId: Int!, $projectStatusIdNotIn: [Int!]!) {
  mechanicProjects(mechanicId: $mechanicId, projectStatusIdNotIn: $projectStatusIdNotIn) {
    ... on MechanicProjects {
      mechanicProjects {
        id
      }
    }
  }
}
    `;

/**
 * __useMechanicProjectReopenByDcaOpenProjectsCheckQuery__
 *
 * To run a query within a React component, call `useMechanicProjectReopenByDcaOpenProjectsCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectReopenByDcaOpenProjectsCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectReopenByDcaOpenProjectsCheckQuery({
 *   variables: {
 *      mechanicId: // value for 'mechanicId'
 *      projectStatusIdNotIn: // value for 'projectStatusIdNotIn'
 *   },
 * });
 */
export function useMechanicProjectReopenByDcaOpenProjectsCheckQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectReopenByDcaOpenProjectsCheckQuery, MechanicProjectReopenByDcaOpenProjectsCheckQueryVariables>) {
        return Apollo.useQuery<MechanicProjectReopenByDcaOpenProjectsCheckQuery, MechanicProjectReopenByDcaOpenProjectsCheckQueryVariables>(MechanicProjectReopenByDcaOpenProjectsCheckDocument, baseOptions);
      }
export function useMechanicProjectReopenByDcaOpenProjectsCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectReopenByDcaOpenProjectsCheckQuery, MechanicProjectReopenByDcaOpenProjectsCheckQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectReopenByDcaOpenProjectsCheckQuery, MechanicProjectReopenByDcaOpenProjectsCheckQueryVariables>(MechanicProjectReopenByDcaOpenProjectsCheckDocument, baseOptions);
        }
export type MechanicProjectReopenByDcaOpenProjectsCheckQueryHookResult = ReturnType<typeof useMechanicProjectReopenByDcaOpenProjectsCheckQuery>;
export type MechanicProjectReopenByDcaOpenProjectsCheckLazyQueryHookResult = ReturnType<typeof useMechanicProjectReopenByDcaOpenProjectsCheckLazyQuery>;
export type MechanicProjectReopenByDcaOpenProjectsCheckQueryResult = Apollo.QueryResult<MechanicProjectReopenByDcaOpenProjectsCheckQuery, MechanicProjectReopenByDcaOpenProjectsCheckQueryVariables>;
export const AddMechanicProjectCommentDocument = gql`
    mutation addMechanicProjectComment($id: Int!, $input: CommentInput!) {
  addMechanicProjectComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddMechanicProjectCommentMutationFn = Apollo.MutationFunction<AddMechanicProjectCommentMutation, AddMechanicProjectCommentMutationVariables>;

/**
 * __useAddMechanicProjectCommentMutation__
 *
 * To run a mutation, you first call `useAddMechanicProjectCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMechanicProjectCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMechanicProjectCommentMutation, { data, loading, error }] = useAddMechanicProjectCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMechanicProjectCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddMechanicProjectCommentMutation, AddMechanicProjectCommentMutationVariables>) {
        return Apollo.useMutation<AddMechanicProjectCommentMutation, AddMechanicProjectCommentMutationVariables>(AddMechanicProjectCommentDocument, baseOptions);
      }
export type AddMechanicProjectCommentMutationHookResult = ReturnType<typeof useAddMechanicProjectCommentMutation>;
export type AddMechanicProjectCommentMutationResult = Apollo.MutationResult<AddMechanicProjectCommentMutation>;
export type AddMechanicProjectCommentMutationOptions = Apollo.BaseMutationOptions<AddMechanicProjectCommentMutation, AddMechanicProjectCommentMutationVariables>;
export const UpdateMechanicProjectCommentDocument = gql`
    mutation updateMechanicProjectComment($id: Int!, $body: String!) {
  updateMechanicProjectComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateMechanicProjectCommentMutationFn = Apollo.MutationFunction<UpdateMechanicProjectCommentMutation, UpdateMechanicProjectCommentMutationVariables>;

/**
 * __useUpdateMechanicProjectCommentMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectCommentMutation, { data, loading, error }] = useUpdateMechanicProjectCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateMechanicProjectCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectCommentMutation, UpdateMechanicProjectCommentMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectCommentMutation, UpdateMechanicProjectCommentMutationVariables>(UpdateMechanicProjectCommentDocument, baseOptions);
      }
export type UpdateMechanicProjectCommentMutationHookResult = ReturnType<typeof useUpdateMechanicProjectCommentMutation>;
export type UpdateMechanicProjectCommentMutationResult = Apollo.MutationResult<UpdateMechanicProjectCommentMutation>;
export type UpdateMechanicProjectCommentMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectCommentMutation, UpdateMechanicProjectCommentMutationVariables>;
export const MechanicProjectDcaCommentsDocument = gql`
    query mechanicProjectDcaComments($id: Int!) {
  mechanicProjectDcaComments(id: $id) {
    ...comments
  }
}
    ${CommentsFragmentDoc}`;

/**
 * __useMechanicProjectDcaCommentsQuery__
 *
 * To run a query within a React component, call `useMechanicProjectDcaCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectDcaCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectDcaCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMechanicProjectDcaCommentsQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectDcaCommentsQuery, MechanicProjectDcaCommentsQueryVariables>) {
        return Apollo.useQuery<MechanicProjectDcaCommentsQuery, MechanicProjectDcaCommentsQueryVariables>(MechanicProjectDcaCommentsDocument, baseOptions);
      }
export function useMechanicProjectDcaCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectDcaCommentsQuery, MechanicProjectDcaCommentsQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectDcaCommentsQuery, MechanicProjectDcaCommentsQueryVariables>(MechanicProjectDcaCommentsDocument, baseOptions);
        }
export type MechanicProjectDcaCommentsQueryHookResult = ReturnType<typeof useMechanicProjectDcaCommentsQuery>;
export type MechanicProjectDcaCommentsLazyQueryHookResult = ReturnType<typeof useMechanicProjectDcaCommentsLazyQuery>;
export type MechanicProjectDcaCommentsQueryResult = Apollo.QueryResult<MechanicProjectDcaCommentsQuery, MechanicProjectDcaCommentsQueryVariables>;
export const AddMechanicProjectDcaCommentDocument = gql`
    mutation addMechanicProjectDcaComment($id: Int!, $input: CommentInput!) {
  addMechanicProjectDcaComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddMechanicProjectDcaCommentMutationFn = Apollo.MutationFunction<AddMechanicProjectDcaCommentMutation, AddMechanicProjectDcaCommentMutationVariables>;

/**
 * __useAddMechanicProjectDcaCommentMutation__
 *
 * To run a mutation, you first call `useAddMechanicProjectDcaCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMechanicProjectDcaCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMechanicProjectDcaCommentMutation, { data, loading, error }] = useAddMechanicProjectDcaCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMechanicProjectDcaCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddMechanicProjectDcaCommentMutation, AddMechanicProjectDcaCommentMutationVariables>) {
        return Apollo.useMutation<AddMechanicProjectDcaCommentMutation, AddMechanicProjectDcaCommentMutationVariables>(AddMechanicProjectDcaCommentDocument, baseOptions);
      }
export type AddMechanicProjectDcaCommentMutationHookResult = ReturnType<typeof useAddMechanicProjectDcaCommentMutation>;
export type AddMechanicProjectDcaCommentMutationResult = Apollo.MutationResult<AddMechanicProjectDcaCommentMutation>;
export type AddMechanicProjectDcaCommentMutationOptions = Apollo.BaseMutationOptions<AddMechanicProjectDcaCommentMutation, AddMechanicProjectDcaCommentMutationVariables>;
export const UpdateMechanicProjectDcaCommentDocument = gql`
    mutation updateMechanicProjectDcaComment($id: Int!, $body: String!) {
  updateMechanicProjectDcaComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateMechanicProjectDcaCommentMutationFn = Apollo.MutationFunction<UpdateMechanicProjectDcaCommentMutation, UpdateMechanicProjectDcaCommentMutationVariables>;

/**
 * __useUpdateMechanicProjectDcaCommentMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectDcaCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectDcaCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectDcaCommentMutation, { data, loading, error }] = useUpdateMechanicProjectDcaCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateMechanicProjectDcaCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectDcaCommentMutation, UpdateMechanicProjectDcaCommentMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectDcaCommentMutation, UpdateMechanicProjectDcaCommentMutationVariables>(UpdateMechanicProjectDcaCommentDocument, baseOptions);
      }
export type UpdateMechanicProjectDcaCommentMutationHookResult = ReturnType<typeof useUpdateMechanicProjectDcaCommentMutation>;
export type UpdateMechanicProjectDcaCommentMutationResult = Apollo.MutationResult<UpdateMechanicProjectDcaCommentMutation>;
export type UpdateMechanicProjectDcaCommentMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectDcaCommentMutation, UpdateMechanicProjectDcaCommentMutationVariables>;
export const HoldMechanicProjectDocument = gql`
    mutation holdMechanicProject($id: Int!) {
  holdMechanicProject(id: $id) {
    id
  }
}
    `;
export type HoldMechanicProjectMutationFn = Apollo.MutationFunction<HoldMechanicProjectMutation, HoldMechanicProjectMutationVariables>;

/**
 * __useHoldMechanicProjectMutation__
 *
 * To run a mutation, you first call `useHoldMechanicProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHoldMechanicProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [holdMechanicProjectMutation, { data, loading, error }] = useHoldMechanicProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHoldMechanicProjectMutation(baseOptions?: Apollo.MutationHookOptions<HoldMechanicProjectMutation, HoldMechanicProjectMutationVariables>) {
        return Apollo.useMutation<HoldMechanicProjectMutation, HoldMechanicProjectMutationVariables>(HoldMechanicProjectDocument, baseOptions);
      }
export type HoldMechanicProjectMutationHookResult = ReturnType<typeof useHoldMechanicProjectMutation>;
export type HoldMechanicProjectMutationResult = Apollo.MutationResult<HoldMechanicProjectMutation>;
export type HoldMechanicProjectMutationOptions = Apollo.BaseMutationOptions<HoldMechanicProjectMutation, HoldMechanicProjectMutationVariables>;
export const ReleaseMechanicProjectDocument = gql`
    mutation releaseMechanicProject($id: Int!) {
  releaseMechanicProject(id: $id) {
    id
  }
}
    `;
export type ReleaseMechanicProjectMutationFn = Apollo.MutationFunction<ReleaseMechanicProjectMutation, ReleaseMechanicProjectMutationVariables>;

/**
 * __useReleaseMechanicProjectMutation__
 *
 * To run a mutation, you first call `useReleaseMechanicProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseMechanicProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseMechanicProjectMutation, { data, loading, error }] = useReleaseMechanicProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReleaseMechanicProjectMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseMechanicProjectMutation, ReleaseMechanicProjectMutationVariables>) {
        return Apollo.useMutation<ReleaseMechanicProjectMutation, ReleaseMechanicProjectMutationVariables>(ReleaseMechanicProjectDocument, baseOptions);
      }
export type ReleaseMechanicProjectMutationHookResult = ReturnType<typeof useReleaseMechanicProjectMutation>;
export type ReleaseMechanicProjectMutationResult = Apollo.MutationResult<ReleaseMechanicProjectMutation>;
export type ReleaseMechanicProjectMutationOptions = Apollo.BaseMutationOptions<ReleaseMechanicProjectMutation, ReleaseMechanicProjectMutationVariables>;
export const DcaHoldMechanicProjectDocument = gql`
    mutation dcaHoldMechanicProject($input: DcaHoldMechanicProjectInput!) {
  dcaHoldMechanicProject(input: $input) {
    id
  }
}
    `;
export type DcaHoldMechanicProjectMutationFn = Apollo.MutationFunction<DcaHoldMechanicProjectMutation, DcaHoldMechanicProjectMutationVariables>;

/**
 * __useDcaHoldMechanicProjectMutation__
 *
 * To run a mutation, you first call `useDcaHoldMechanicProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDcaHoldMechanicProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dcaHoldMechanicProjectMutation, { data, loading, error }] = useDcaHoldMechanicProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDcaHoldMechanicProjectMutation(baseOptions?: Apollo.MutationHookOptions<DcaHoldMechanicProjectMutation, DcaHoldMechanicProjectMutationVariables>) {
        return Apollo.useMutation<DcaHoldMechanicProjectMutation, DcaHoldMechanicProjectMutationVariables>(DcaHoldMechanicProjectDocument, baseOptions);
      }
export type DcaHoldMechanicProjectMutationHookResult = ReturnType<typeof useDcaHoldMechanicProjectMutation>;
export type DcaHoldMechanicProjectMutationResult = Apollo.MutationResult<DcaHoldMechanicProjectMutation>;
export type DcaHoldMechanicProjectMutationOptions = Apollo.BaseMutationOptions<DcaHoldMechanicProjectMutation, DcaHoldMechanicProjectMutationVariables>;
export const DcaReleaseMechanicProjectDocument = gql`
    mutation dcaReleaseMechanicProject($id: Int!) {
  dcaReleaseMechanicProject(id: $id) {
    id
  }
}
    `;
export type DcaReleaseMechanicProjectMutationFn = Apollo.MutationFunction<DcaReleaseMechanicProjectMutation, DcaReleaseMechanicProjectMutationVariables>;

/**
 * __useDcaReleaseMechanicProjectMutation__
 *
 * To run a mutation, you first call `useDcaReleaseMechanicProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDcaReleaseMechanicProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dcaReleaseMechanicProjectMutation, { data, loading, error }] = useDcaReleaseMechanicProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDcaReleaseMechanicProjectMutation(baseOptions?: Apollo.MutationHookOptions<DcaReleaseMechanicProjectMutation, DcaReleaseMechanicProjectMutationVariables>) {
        return Apollo.useMutation<DcaReleaseMechanicProjectMutation, DcaReleaseMechanicProjectMutationVariables>(DcaReleaseMechanicProjectDocument, baseOptions);
      }
export type DcaReleaseMechanicProjectMutationHookResult = ReturnType<typeof useDcaReleaseMechanicProjectMutation>;
export type DcaReleaseMechanicProjectMutationResult = Apollo.MutationResult<DcaReleaseMechanicProjectMutation>;
export type DcaReleaseMechanicProjectMutationOptions = Apollo.BaseMutationOptions<DcaReleaseMechanicProjectMutation, DcaReleaseMechanicProjectMutationVariables>;
export const DeleteMechanicProjectDocument = gql`
    mutation deleteMechanicProject($id: Int!) {
  deleteMechanicProject(id: $id) {
    id
  }
}
    `;
export type DeleteMechanicProjectMutationFn = Apollo.MutationFunction<DeleteMechanicProjectMutation, DeleteMechanicProjectMutationVariables>;

/**
 * __useDeleteMechanicProjectMutation__
 *
 * To run a mutation, you first call `useDeleteMechanicProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMechanicProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMechanicProjectMutation, { data, loading, error }] = useDeleteMechanicProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMechanicProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMechanicProjectMutation, DeleteMechanicProjectMutationVariables>) {
        return Apollo.useMutation<DeleteMechanicProjectMutation, DeleteMechanicProjectMutationVariables>(DeleteMechanicProjectDocument, baseOptions);
      }
export type DeleteMechanicProjectMutationHookResult = ReturnType<typeof useDeleteMechanicProjectMutation>;
export type DeleteMechanicProjectMutationResult = Apollo.MutationResult<DeleteMechanicProjectMutation>;
export type DeleteMechanicProjectMutationOptions = Apollo.BaseMutationOptions<DeleteMechanicProjectMutation, DeleteMechanicProjectMutationVariables>;
export const TransitionMechanicProjectDocument = gql`
    mutation transitionMechanicProject($input: TransitionProjectInput!) {
  transitionMechanicProject(input: $input) {
    id
    projectStatus {
      id
    }
  }
}
    `;
export type TransitionMechanicProjectMutationFn = Apollo.MutationFunction<TransitionMechanicProjectMutation, TransitionMechanicProjectMutationVariables>;

/**
 * __useTransitionMechanicProjectMutation__
 *
 * To run a mutation, you first call `useTransitionMechanicProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionMechanicProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionMechanicProjectMutation, { data, loading, error }] = useTransitionMechanicProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransitionMechanicProjectMutation(baseOptions?: Apollo.MutationHookOptions<TransitionMechanicProjectMutation, TransitionMechanicProjectMutationVariables>) {
        return Apollo.useMutation<TransitionMechanicProjectMutation, TransitionMechanicProjectMutationVariables>(TransitionMechanicProjectDocument, baseOptions);
      }
export type TransitionMechanicProjectMutationHookResult = ReturnType<typeof useTransitionMechanicProjectMutation>;
export type TransitionMechanicProjectMutationResult = Apollo.MutationResult<TransitionMechanicProjectMutation>;
export type TransitionMechanicProjectMutationOptions = Apollo.BaseMutationOptions<TransitionMechanicProjectMutation, TransitionMechanicProjectMutationVariables>;
export const SendMechanicProjectBackToIasoDocument = gql`
    mutation sendMechanicProjectBackToIaso($input: SendMechanicProjectToIasoInput!) {
  sendMechanicProjectBackToIaso(input: $input) {
    id
  }
}
    `;
export type SendMechanicProjectBackToIasoMutationFn = Apollo.MutationFunction<SendMechanicProjectBackToIasoMutation, SendMechanicProjectBackToIasoMutationVariables>;

/**
 * __useSendMechanicProjectBackToIasoMutation__
 *
 * To run a mutation, you first call `useSendMechanicProjectBackToIasoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMechanicProjectBackToIasoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMechanicProjectBackToIasoMutation, { data, loading, error }] = useSendMechanicProjectBackToIasoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMechanicProjectBackToIasoMutation(baseOptions?: Apollo.MutationHookOptions<SendMechanicProjectBackToIasoMutation, SendMechanicProjectBackToIasoMutationVariables>) {
        return Apollo.useMutation<SendMechanicProjectBackToIasoMutation, SendMechanicProjectBackToIasoMutationVariables>(SendMechanicProjectBackToIasoDocument, baseOptions);
      }
export type SendMechanicProjectBackToIasoMutationHookResult = ReturnType<typeof useSendMechanicProjectBackToIasoMutation>;
export type SendMechanicProjectBackToIasoMutationResult = Apollo.MutationResult<SendMechanicProjectBackToIasoMutation>;
export type SendMechanicProjectBackToIasoMutationOptions = Apollo.BaseMutationOptions<SendMechanicProjectBackToIasoMutation, SendMechanicProjectBackToIasoMutationVariables>;
export const CompleteMechanicProjectTaskDocument = gql`
    mutation completeMechanicProjectTask($input: CompleteMechanicProjectTaskInput!) {
  completeMechanicProjectTask(input: $input) {
    id
  }
}
    `;
export type CompleteMechanicProjectTaskMutationFn = Apollo.MutationFunction<CompleteMechanicProjectTaskMutation, CompleteMechanicProjectTaskMutationVariables>;

/**
 * __useCompleteMechanicProjectTaskMutation__
 *
 * To run a mutation, you first call `useCompleteMechanicProjectTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteMechanicProjectTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeMechanicProjectTaskMutation, { data, loading, error }] = useCompleteMechanicProjectTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteMechanicProjectTaskMutation(baseOptions?: Apollo.MutationHookOptions<CompleteMechanicProjectTaskMutation, CompleteMechanicProjectTaskMutationVariables>) {
        return Apollo.useMutation<CompleteMechanicProjectTaskMutation, CompleteMechanicProjectTaskMutationVariables>(CompleteMechanicProjectTaskDocument, baseOptions);
      }
export type CompleteMechanicProjectTaskMutationHookResult = ReturnType<typeof useCompleteMechanicProjectTaskMutation>;
export type CompleteMechanicProjectTaskMutationResult = Apollo.MutationResult<CompleteMechanicProjectTaskMutation>;
export type CompleteMechanicProjectTaskMutationOptions = Apollo.BaseMutationOptions<CompleteMechanicProjectTaskMutation, CompleteMechanicProjectTaskMutationVariables>;
export const SendMechanicProjectInsFormVersionForExecutionDocument = gql`
    mutation sendMechanicProjectInsFormVersionForExecution($input: SendForExecutionInput!) {
  sendMechanicProjectInsFormVersionForExecution(input: $input) {
    id
  }
}
    `;
export type SendMechanicProjectInsFormVersionForExecutionMutationFn = Apollo.MutationFunction<SendMechanicProjectInsFormVersionForExecutionMutation, SendMechanicProjectInsFormVersionForExecutionMutationVariables>;

/**
 * __useSendMechanicProjectInsFormVersionForExecutionMutation__
 *
 * To run a mutation, you first call `useSendMechanicProjectInsFormVersionForExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMechanicProjectInsFormVersionForExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMechanicProjectInsFormVersionForExecutionMutation, { data, loading, error }] = useSendMechanicProjectInsFormVersionForExecutionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMechanicProjectInsFormVersionForExecutionMutation(baseOptions?: Apollo.MutationHookOptions<SendMechanicProjectInsFormVersionForExecutionMutation, SendMechanicProjectInsFormVersionForExecutionMutationVariables>) {
        return Apollo.useMutation<SendMechanicProjectInsFormVersionForExecutionMutation, SendMechanicProjectInsFormVersionForExecutionMutationVariables>(SendMechanicProjectInsFormVersionForExecutionDocument, baseOptions);
      }
export type SendMechanicProjectInsFormVersionForExecutionMutationHookResult = ReturnType<typeof useSendMechanicProjectInsFormVersionForExecutionMutation>;
export type SendMechanicProjectInsFormVersionForExecutionMutationResult = Apollo.MutationResult<SendMechanicProjectInsFormVersionForExecutionMutation>;
export type SendMechanicProjectInsFormVersionForExecutionMutationOptions = Apollo.BaseMutationOptions<SendMechanicProjectInsFormVersionForExecutionMutation, SendMechanicProjectInsFormVersionForExecutionMutationVariables>;
export const ResendMechanicProjectInsFormVersionForExecutionDocument = gql`
    mutation resendMechanicProjectInsFormVersionForExecution($projectInsFormVersionId: Int!) {
  resendMechanicProjectInsFormVersionForExecution(projectInsFormVersionId: $projectInsFormVersionId) {
    id
  }
}
    `;
export type ResendMechanicProjectInsFormVersionForExecutionMutationFn = Apollo.MutationFunction<ResendMechanicProjectInsFormVersionForExecutionMutation, ResendMechanicProjectInsFormVersionForExecutionMutationVariables>;

/**
 * __useResendMechanicProjectInsFormVersionForExecutionMutation__
 *
 * To run a mutation, you first call `useResendMechanicProjectInsFormVersionForExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendMechanicProjectInsFormVersionForExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendMechanicProjectInsFormVersionForExecutionMutation, { data, loading, error }] = useResendMechanicProjectInsFormVersionForExecutionMutation({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useResendMechanicProjectInsFormVersionForExecutionMutation(baseOptions?: Apollo.MutationHookOptions<ResendMechanicProjectInsFormVersionForExecutionMutation, ResendMechanicProjectInsFormVersionForExecutionMutationVariables>) {
        return Apollo.useMutation<ResendMechanicProjectInsFormVersionForExecutionMutation, ResendMechanicProjectInsFormVersionForExecutionMutationVariables>(ResendMechanicProjectInsFormVersionForExecutionDocument, baseOptions);
      }
export type ResendMechanicProjectInsFormVersionForExecutionMutationHookResult = ReturnType<typeof useResendMechanicProjectInsFormVersionForExecutionMutation>;
export type ResendMechanicProjectInsFormVersionForExecutionMutationResult = Apollo.MutationResult<ResendMechanicProjectInsFormVersionForExecutionMutation>;
export type ResendMechanicProjectInsFormVersionForExecutionMutationOptions = Apollo.BaseMutationOptions<ResendMechanicProjectInsFormVersionForExecutionMutation, ResendMechanicProjectInsFormVersionForExecutionMutationVariables>;
export const RevokeMechanicProjectInsFormVersionExecutionDocument = gql`
    mutation revokeMechanicProjectInsFormVersionExecution($projectInsFormVersionId: Int!) {
  revokeMechanicProjectInsFormVersionExecution(projectInsFormVersionId: $projectInsFormVersionId) {
    id
  }
}
    `;
export type RevokeMechanicProjectInsFormVersionExecutionMutationFn = Apollo.MutationFunction<RevokeMechanicProjectInsFormVersionExecutionMutation, RevokeMechanicProjectInsFormVersionExecutionMutationVariables>;

/**
 * __useRevokeMechanicProjectInsFormVersionExecutionMutation__
 *
 * To run a mutation, you first call `useRevokeMechanicProjectInsFormVersionExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeMechanicProjectInsFormVersionExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeMechanicProjectInsFormVersionExecutionMutation, { data, loading, error }] = useRevokeMechanicProjectInsFormVersionExecutionMutation({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useRevokeMechanicProjectInsFormVersionExecutionMutation(baseOptions?: Apollo.MutationHookOptions<RevokeMechanicProjectInsFormVersionExecutionMutation, RevokeMechanicProjectInsFormVersionExecutionMutationVariables>) {
        return Apollo.useMutation<RevokeMechanicProjectInsFormVersionExecutionMutation, RevokeMechanicProjectInsFormVersionExecutionMutationVariables>(RevokeMechanicProjectInsFormVersionExecutionDocument, baseOptions);
      }
export type RevokeMechanicProjectInsFormVersionExecutionMutationHookResult = ReturnType<typeof useRevokeMechanicProjectInsFormVersionExecutionMutation>;
export type RevokeMechanicProjectInsFormVersionExecutionMutationResult = Apollo.MutationResult<RevokeMechanicProjectInsFormVersionExecutionMutation>;
export type RevokeMechanicProjectInsFormVersionExecutionMutationOptions = Apollo.BaseMutationOptions<RevokeMechanicProjectInsFormVersionExecutionMutation, RevokeMechanicProjectInsFormVersionExecutionMutationVariables>;
export const UpdateAllMechanicProjectDocumentsReleasedToDcaMutationDocument = gql`
    mutation updateAllMechanicProjectDocumentsReleasedToDcaMutation($input: UpdateAllMechanicProjectDocumentsReleasedToDcaInput!) {
  updateAllMechanicProjectDocumentsReleasedToDca(input: $input)
}
    `;
export type UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutation, UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllMechanicProjectDocumentsReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutation, UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutation, UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutationVariables>(UpdateAllMechanicProjectDocumentsReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutation>;
export type UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutation>;
export type UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutation, UpdateAllMechanicProjectDocumentsReleasedToDcaMutationMutationVariables>;
export const MechanicProjectCertificateInformationDocument = gql`
    query mechanicProjectCertificateInformation($mechanicProjectId: Int!) {
  mechanicProjectCertificate(mechanicProjectId: $mechanicProjectId) {
    ...mechanicProjectCertificateInformation
  }
  mechanicProject(id: $mechanicProjectId) {
    provisionalOperatorNames
  }
}
    ${MechanicProjectCertificateInformationFragmentDoc}`;

/**
 * __useMechanicProjectCertificateInformationQuery__
 *
 * To run a query within a React component, call `useMechanicProjectCertificateInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectCertificateInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectCertificateInformationQuery({
 *   variables: {
 *      mechanicProjectId: // value for 'mechanicProjectId'
 *   },
 * });
 */
export function useMechanicProjectCertificateInformationQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectCertificateInformationQuery, MechanicProjectCertificateInformationQueryVariables>) {
        return Apollo.useQuery<MechanicProjectCertificateInformationQuery, MechanicProjectCertificateInformationQueryVariables>(MechanicProjectCertificateInformationDocument, baseOptions);
      }
export function useMechanicProjectCertificateInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectCertificateInformationQuery, MechanicProjectCertificateInformationQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectCertificateInformationQuery, MechanicProjectCertificateInformationQueryVariables>(MechanicProjectCertificateInformationDocument, baseOptions);
        }
export type MechanicProjectCertificateInformationQueryHookResult = ReturnType<typeof useMechanicProjectCertificateInformationQuery>;
export type MechanicProjectCertificateInformationLazyQueryHookResult = ReturnType<typeof useMechanicProjectCertificateInformationLazyQuery>;
export type MechanicProjectCertificateInformationQueryResult = Apollo.QueryResult<MechanicProjectCertificateInformationQuery, MechanicProjectCertificateInformationQueryVariables>;
export const UpdateMechanicProjectCertificateDocument = gql`
    mutation updateMechanicProjectCertificate($input: UpdateMechanicProjectCertificateInput!, $recordHistory: Boolean, $ignoreWarnings: Boolean) {
  updateMechanicProjectCertificate(input: $input, recordHistory: $recordHistory, ignoreWarnings: $ignoreWarnings) {
    mechanicProjectCertificate {
      ...mechanicProjectCertificateInformation
    }
    warnings
  }
}
    ${MechanicProjectCertificateInformationFragmentDoc}`;
export type UpdateMechanicProjectCertificateMutationFn = Apollo.MutationFunction<UpdateMechanicProjectCertificateMutation, UpdateMechanicProjectCertificateMutationVariables>;

/**
 * __useUpdateMechanicProjectCertificateMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectCertificateMutation, { data, loading, error }] = useUpdateMechanicProjectCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      recordHistory: // value for 'recordHistory'
 *      ignoreWarnings: // value for 'ignoreWarnings'
 *   },
 * });
 */
export function useUpdateMechanicProjectCertificateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectCertificateMutation, UpdateMechanicProjectCertificateMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectCertificateMutation, UpdateMechanicProjectCertificateMutationVariables>(UpdateMechanicProjectCertificateDocument, baseOptions);
      }
export type UpdateMechanicProjectCertificateMutationHookResult = ReturnType<typeof useUpdateMechanicProjectCertificateMutation>;
export type UpdateMechanicProjectCertificateMutationResult = Apollo.MutationResult<UpdateMechanicProjectCertificateMutation>;
export type UpdateMechanicProjectCertificateMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectCertificateMutation, UpdateMechanicProjectCertificateMutationVariables>;
export const MechanicProjectDcaReviewerUsersDocument = gql`
    query mechanicProjectDcaReviewerUsers($includeId: Int) {
  dcaProjectApprovers: mechanicProjectDcaReviewerUsers(includeId: $includeId) {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useMechanicProjectDcaReviewerUsersQuery__
 *
 * To run a query within a React component, call `useMechanicProjectDcaReviewerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectDcaReviewerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectDcaReviewerUsersQuery({
 *   variables: {
 *      includeId: // value for 'includeId'
 *   },
 * });
 */
export function useMechanicProjectDcaReviewerUsersQuery(baseOptions?: Apollo.QueryHookOptions<MechanicProjectDcaReviewerUsersQuery, MechanicProjectDcaReviewerUsersQueryVariables>) {
        return Apollo.useQuery<MechanicProjectDcaReviewerUsersQuery, MechanicProjectDcaReviewerUsersQueryVariables>(MechanicProjectDcaReviewerUsersDocument, baseOptions);
      }
export function useMechanicProjectDcaReviewerUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectDcaReviewerUsersQuery, MechanicProjectDcaReviewerUsersQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectDcaReviewerUsersQuery, MechanicProjectDcaReviewerUsersQueryVariables>(MechanicProjectDcaReviewerUsersDocument, baseOptions);
        }
export type MechanicProjectDcaReviewerUsersQueryHookResult = ReturnType<typeof useMechanicProjectDcaReviewerUsersQuery>;
export type MechanicProjectDcaReviewerUsersLazyQueryHookResult = ReturnType<typeof useMechanicProjectDcaReviewerUsersLazyQuery>;
export type MechanicProjectDcaReviewerUsersQueryResult = Apollo.QueryResult<MechanicProjectDcaReviewerUsersQuery, MechanicProjectDcaReviewerUsersQueryVariables>;
export const MechanicProjectDcaSentForApprovalByUsersDocument = gql`
    query mechanicProjectDcaSentForApprovalByUsers($includeId: Int) {
  dcaProjectApprovers: mechanicProjectDcaSentForApprovalByUsers(includeId: $includeId) {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useMechanicProjectDcaSentForApprovalByUsersQuery__
 *
 * To run a query within a React component, call `useMechanicProjectDcaSentForApprovalByUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectDcaSentForApprovalByUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectDcaSentForApprovalByUsersQuery({
 *   variables: {
 *      includeId: // value for 'includeId'
 *   },
 * });
 */
export function useMechanicProjectDcaSentForApprovalByUsersQuery(baseOptions?: Apollo.QueryHookOptions<MechanicProjectDcaSentForApprovalByUsersQuery, MechanicProjectDcaSentForApprovalByUsersQueryVariables>) {
        return Apollo.useQuery<MechanicProjectDcaSentForApprovalByUsersQuery, MechanicProjectDcaSentForApprovalByUsersQueryVariables>(MechanicProjectDcaSentForApprovalByUsersDocument, baseOptions);
      }
export function useMechanicProjectDcaSentForApprovalByUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectDcaSentForApprovalByUsersQuery, MechanicProjectDcaSentForApprovalByUsersQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectDcaSentForApprovalByUsersQuery, MechanicProjectDcaSentForApprovalByUsersQueryVariables>(MechanicProjectDcaSentForApprovalByUsersDocument, baseOptions);
        }
export type MechanicProjectDcaSentForApprovalByUsersQueryHookResult = ReturnType<typeof useMechanicProjectDcaSentForApprovalByUsersQuery>;
export type MechanicProjectDcaSentForApprovalByUsersLazyQueryHookResult = ReturnType<typeof useMechanicProjectDcaSentForApprovalByUsersLazyQuery>;
export type MechanicProjectDcaSentForApprovalByUsersQueryResult = Apollo.QueryResult<MechanicProjectDcaSentForApprovalByUsersQuery, MechanicProjectDcaSentForApprovalByUsersQueryVariables>;
export const MechanicProjectDcaApprovedByUsersDocument = gql`
    query mechanicProjectDcaApprovedByUsers($includeId: Int) {
  dcaProjectApprovers: mechanicProjectDcaApprovedByUsers(includeId: $includeId) {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useMechanicProjectDcaApprovedByUsersQuery__
 *
 * To run a query within a React component, call `useMechanicProjectDcaApprovedByUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectDcaApprovedByUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectDcaApprovedByUsersQuery({
 *   variables: {
 *      includeId: // value for 'includeId'
 *   },
 * });
 */
export function useMechanicProjectDcaApprovedByUsersQuery(baseOptions?: Apollo.QueryHookOptions<MechanicProjectDcaApprovedByUsersQuery, MechanicProjectDcaApprovedByUsersQueryVariables>) {
        return Apollo.useQuery<MechanicProjectDcaApprovedByUsersQuery, MechanicProjectDcaApprovedByUsersQueryVariables>(MechanicProjectDcaApprovedByUsersDocument, baseOptions);
      }
export function useMechanicProjectDcaApprovedByUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectDcaApprovedByUsersQuery, MechanicProjectDcaApprovedByUsersQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectDcaApprovedByUsersQuery, MechanicProjectDcaApprovedByUsersQueryVariables>(MechanicProjectDcaApprovedByUsersDocument, baseOptions);
        }
export type MechanicProjectDcaApprovedByUsersQueryHookResult = ReturnType<typeof useMechanicProjectDcaApprovedByUsersQuery>;
export type MechanicProjectDcaApprovedByUsersLazyQueryHookResult = ReturnType<typeof useMechanicProjectDcaApprovedByUsersLazyQuery>;
export type MechanicProjectDcaApprovedByUsersQueryResult = Apollo.QueryResult<MechanicProjectDcaApprovedByUsersQuery, MechanicProjectDcaApprovedByUsersQueryVariables>;
export const MechanicProjectFormsTabDocument = gql`
    query mechanicProjectFormsTab($mechanicProjectId: Int!) {
  mechanicProject(id: $mechanicProjectId) {
    canToggleInsFormDcaApproved
  }
  mechanicProjectInsForms(mechanicProjectId: $mechanicProjectId) {
    ...projectInsFormVersion
  }
  mechanicProjectInsFormsExclusiveGroups(mechanicProjectId: $mechanicProjectId) {
    ...projectInsFormVersionExclusiveGroup
  }
}
    ${ProjectInsFormVersionFragmentDoc}
${ProjectInsFormVersionExclusiveGroupFragmentDoc}`;

/**
 * __useMechanicProjectFormsTabQuery__
 *
 * To run a query within a React component, call `useMechanicProjectFormsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectFormsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectFormsTabQuery({
 *   variables: {
 *      mechanicProjectId: // value for 'mechanicProjectId'
 *   },
 * });
 */
export function useMechanicProjectFormsTabQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectFormsTabQuery, MechanicProjectFormsTabQueryVariables>) {
        return Apollo.useQuery<MechanicProjectFormsTabQuery, MechanicProjectFormsTabQueryVariables>(MechanicProjectFormsTabDocument, baseOptions);
      }
export function useMechanicProjectFormsTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectFormsTabQuery, MechanicProjectFormsTabQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectFormsTabQuery, MechanicProjectFormsTabQueryVariables>(MechanicProjectFormsTabDocument, baseOptions);
        }
export type MechanicProjectFormsTabQueryHookResult = ReturnType<typeof useMechanicProjectFormsTabQuery>;
export type MechanicProjectFormsTabLazyQueryHookResult = ReturnType<typeof useMechanicProjectFormsTabLazyQuery>;
export type MechanicProjectFormsTabQueryResult = Apollo.QueryResult<MechanicProjectFormsTabQuery, MechanicProjectFormsTabQueryVariables>;
export const MechanicProjectInsFormFieldValuesAndCommentsQueryDocument = gql`
    query mechanicProjectInsFormFieldValuesAndCommentsQuery($projectInsFormVersionId: Int!) {
  fieldValues: mechanicProjectInsFormFieldValues(projectInsFormVersionId: $projectInsFormVersionId) {
    ...projectInsFormVersionFieldValue
  }
  fieldComments: mechanicProjectInsFormFieldComments(projectInsFormVersionId: $projectInsFormVersionId) {
    ...projectInsFormVersionFieldComment
  }
}
    ${ProjectInsFormVersionFieldValueFragmentDoc}
${ProjectInsFormVersionFieldCommentFragmentDoc}`;

/**
 * __useMechanicProjectInsFormFieldValuesAndCommentsQueryQuery__
 *
 * To run a query within a React component, call `useMechanicProjectInsFormFieldValuesAndCommentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectInsFormFieldValuesAndCommentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectInsFormFieldValuesAndCommentsQueryQuery({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useMechanicProjectInsFormFieldValuesAndCommentsQueryQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectInsFormFieldValuesAndCommentsQueryQuery, MechanicProjectInsFormFieldValuesAndCommentsQueryQueryVariables>) {
        return Apollo.useQuery<MechanicProjectInsFormFieldValuesAndCommentsQueryQuery, MechanicProjectInsFormFieldValuesAndCommentsQueryQueryVariables>(MechanicProjectInsFormFieldValuesAndCommentsQueryDocument, baseOptions);
      }
export function useMechanicProjectInsFormFieldValuesAndCommentsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectInsFormFieldValuesAndCommentsQueryQuery, MechanicProjectInsFormFieldValuesAndCommentsQueryQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectInsFormFieldValuesAndCommentsQueryQuery, MechanicProjectInsFormFieldValuesAndCommentsQueryQueryVariables>(MechanicProjectInsFormFieldValuesAndCommentsQueryDocument, baseOptions);
        }
export type MechanicProjectInsFormFieldValuesAndCommentsQueryQueryHookResult = ReturnType<typeof useMechanicProjectInsFormFieldValuesAndCommentsQueryQuery>;
export type MechanicProjectInsFormFieldValuesAndCommentsQueryLazyQueryHookResult = ReturnType<typeof useMechanicProjectInsFormFieldValuesAndCommentsQueryLazyQuery>;
export type MechanicProjectInsFormFieldValuesAndCommentsQueryQueryResult = Apollo.QueryResult<MechanicProjectInsFormFieldValuesAndCommentsQueryQuery, MechanicProjectInsFormFieldValuesAndCommentsQueryQueryVariables>;
export const MechanicProjectInsFormFieldValuesOnlyQueryDocument = gql`
    query mechanicProjectInsFormFieldValuesOnlyQuery($projectInsFormVersionId: Int!) {
  fieldValues: mechanicProjectInsFormFieldValues(projectInsFormVersionId: $projectInsFormVersionId) {
    ...projectInsFormVersionFieldValue
  }
}
    ${ProjectInsFormVersionFieldValueFragmentDoc}`;

/**
 * __useMechanicProjectInsFormFieldValuesOnlyQueryQuery__
 *
 * To run a query within a React component, call `useMechanicProjectInsFormFieldValuesOnlyQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectInsFormFieldValuesOnlyQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectInsFormFieldValuesOnlyQueryQuery({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useMechanicProjectInsFormFieldValuesOnlyQueryQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectInsFormFieldValuesOnlyQueryQuery, MechanicProjectInsFormFieldValuesOnlyQueryQueryVariables>) {
        return Apollo.useQuery<MechanicProjectInsFormFieldValuesOnlyQueryQuery, MechanicProjectInsFormFieldValuesOnlyQueryQueryVariables>(MechanicProjectInsFormFieldValuesOnlyQueryDocument, baseOptions);
      }
export function useMechanicProjectInsFormFieldValuesOnlyQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectInsFormFieldValuesOnlyQueryQuery, MechanicProjectInsFormFieldValuesOnlyQueryQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectInsFormFieldValuesOnlyQueryQuery, MechanicProjectInsFormFieldValuesOnlyQueryQueryVariables>(MechanicProjectInsFormFieldValuesOnlyQueryDocument, baseOptions);
        }
export type MechanicProjectInsFormFieldValuesOnlyQueryQueryHookResult = ReturnType<typeof useMechanicProjectInsFormFieldValuesOnlyQueryQuery>;
export type MechanicProjectInsFormFieldValuesOnlyQueryLazyQueryHookResult = ReturnType<typeof useMechanicProjectInsFormFieldValuesOnlyQueryLazyQuery>;
export type MechanicProjectInsFormFieldValuesOnlyQueryQueryResult = Apollo.QueryResult<MechanicProjectInsFormFieldValuesOnlyQueryQuery, MechanicProjectInsFormFieldValuesOnlyQueryQueryVariables>;
export const DownloadMechanicProjectUploadedInsFormDocument = gql`
    query downloadMechanicProjectUploadedInsForm($id: Int!) {
  file: downloadMechanicProjectUploadedInsForm(projectInsFormVersionId: $id) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadMechanicProjectUploadedInsFormQuery__
 *
 * To run a query within a React component, call `useDownloadMechanicProjectUploadedInsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadMechanicProjectUploadedInsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadMechanicProjectUploadedInsFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadMechanicProjectUploadedInsFormQuery(baseOptions: Apollo.QueryHookOptions<DownloadMechanicProjectUploadedInsFormQuery, DownloadMechanicProjectUploadedInsFormQueryVariables>) {
        return Apollo.useQuery<DownloadMechanicProjectUploadedInsFormQuery, DownloadMechanicProjectUploadedInsFormQueryVariables>(DownloadMechanicProjectUploadedInsFormDocument, baseOptions);
      }
export function useDownloadMechanicProjectUploadedInsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadMechanicProjectUploadedInsFormQuery, DownloadMechanicProjectUploadedInsFormQueryVariables>) {
          return Apollo.useLazyQuery<DownloadMechanicProjectUploadedInsFormQuery, DownloadMechanicProjectUploadedInsFormQueryVariables>(DownloadMechanicProjectUploadedInsFormDocument, baseOptions);
        }
export type DownloadMechanicProjectUploadedInsFormQueryHookResult = ReturnType<typeof useDownloadMechanicProjectUploadedInsFormQuery>;
export type DownloadMechanicProjectUploadedInsFormLazyQueryHookResult = ReturnType<typeof useDownloadMechanicProjectUploadedInsFormLazyQuery>;
export type DownloadMechanicProjectUploadedInsFormQueryResult = Apollo.QueryResult<DownloadMechanicProjectUploadedInsFormQuery, DownloadMechanicProjectUploadedInsFormQueryVariables>;
export const DownloadMechanicProjectFilledInInsFormDocument = gql`
    query downloadMechanicProjectFilledInInsForm($projectInsFormVersionId: Int!) {
  file: downloadMechanicProjectFilledInInsForm(projectInsFormVersionId: $projectInsFormVersionId) {
    ...downloadFile
  }
}
    ${DownloadFileFragmentDoc}`;

/**
 * __useDownloadMechanicProjectFilledInInsFormQuery__
 *
 * To run a query within a React component, call `useDownloadMechanicProjectFilledInInsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadMechanicProjectFilledInInsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadMechanicProjectFilledInInsFormQuery({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *   },
 * });
 */
export function useDownloadMechanicProjectFilledInInsFormQuery(baseOptions: Apollo.QueryHookOptions<DownloadMechanicProjectFilledInInsFormQuery, DownloadMechanicProjectFilledInInsFormQueryVariables>) {
        return Apollo.useQuery<DownloadMechanicProjectFilledInInsFormQuery, DownloadMechanicProjectFilledInInsFormQueryVariables>(DownloadMechanicProjectFilledInInsFormDocument, baseOptions);
      }
export function useDownloadMechanicProjectFilledInInsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadMechanicProjectFilledInInsFormQuery, DownloadMechanicProjectFilledInInsFormQueryVariables>) {
          return Apollo.useLazyQuery<DownloadMechanicProjectFilledInInsFormQuery, DownloadMechanicProjectFilledInInsFormQueryVariables>(DownloadMechanicProjectFilledInInsFormDocument, baseOptions);
        }
export type DownloadMechanicProjectFilledInInsFormQueryHookResult = ReturnType<typeof useDownloadMechanicProjectFilledInInsFormQuery>;
export type DownloadMechanicProjectFilledInInsFormLazyQueryHookResult = ReturnType<typeof useDownloadMechanicProjectFilledInInsFormLazyQuery>;
export type DownloadMechanicProjectFilledInInsFormQueryResult = Apollo.QueryResult<DownloadMechanicProjectFilledInInsFormQuery, DownloadMechanicProjectFilledInInsFormQueryVariables>;
export const UpdateMechanicProjectInsFormTrgApprovalMutationDocument = gql`
    mutation updateMechanicProjectInsFormTrgApprovalMutation($input: UpdateProjectInsFormVersionTrgApprovalInput!) {
  updateMechanicProjectInsFormTrgApproval(input: $input) {
    ...projectInsFormVersion
  }
}
    ${ProjectInsFormVersionFragmentDoc}`;
export type UpdateMechanicProjectInsFormTrgApprovalMutationMutationFn = Apollo.MutationFunction<UpdateMechanicProjectInsFormTrgApprovalMutationMutation, UpdateMechanicProjectInsFormTrgApprovalMutationMutationVariables>;

/**
 * __useUpdateMechanicProjectInsFormTrgApprovalMutationMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectInsFormTrgApprovalMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectInsFormTrgApprovalMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectInsFormTrgApprovalMutationMutation, { data, loading, error }] = useUpdateMechanicProjectInsFormTrgApprovalMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMechanicProjectInsFormTrgApprovalMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectInsFormTrgApprovalMutationMutation, UpdateMechanicProjectInsFormTrgApprovalMutationMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectInsFormTrgApprovalMutationMutation, UpdateMechanicProjectInsFormTrgApprovalMutationMutationVariables>(UpdateMechanicProjectInsFormTrgApprovalMutationDocument, baseOptions);
      }
export type UpdateMechanicProjectInsFormTrgApprovalMutationMutationHookResult = ReturnType<typeof useUpdateMechanicProjectInsFormTrgApprovalMutationMutation>;
export type UpdateMechanicProjectInsFormTrgApprovalMutationMutationResult = Apollo.MutationResult<UpdateMechanicProjectInsFormTrgApprovalMutationMutation>;
export type UpdateMechanicProjectInsFormTrgApprovalMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectInsFormTrgApprovalMutationMutation, UpdateMechanicProjectInsFormTrgApprovalMutationMutationVariables>;
export const UpdateMechanicProjectInsFormFileAttachmentMutationDocument = gql`
    mutation updateMechanicProjectInsFormFileAttachmentMutation($input: UpdateProjectInsFormVersionFileAttachmentInput!) {
  updateMechanicProjectInsFormFileAttachment(input: $input) {
    ...projectInsFormVersion
  }
}
    ${ProjectInsFormVersionFragmentDoc}`;
export type UpdateMechanicProjectInsFormFileAttachmentMutationMutationFn = Apollo.MutationFunction<UpdateMechanicProjectInsFormFileAttachmentMutationMutation, UpdateMechanicProjectInsFormFileAttachmentMutationMutationVariables>;

/**
 * __useUpdateMechanicProjectInsFormFileAttachmentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectInsFormFileAttachmentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectInsFormFileAttachmentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectInsFormFileAttachmentMutationMutation, { data, loading, error }] = useUpdateMechanicProjectInsFormFileAttachmentMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMechanicProjectInsFormFileAttachmentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectInsFormFileAttachmentMutationMutation, UpdateMechanicProjectInsFormFileAttachmentMutationMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectInsFormFileAttachmentMutationMutation, UpdateMechanicProjectInsFormFileAttachmentMutationMutationVariables>(UpdateMechanicProjectInsFormFileAttachmentMutationDocument, baseOptions);
      }
export type UpdateMechanicProjectInsFormFileAttachmentMutationMutationHookResult = ReturnType<typeof useUpdateMechanicProjectInsFormFileAttachmentMutationMutation>;
export type UpdateMechanicProjectInsFormFileAttachmentMutationMutationResult = Apollo.MutationResult<UpdateMechanicProjectInsFormFileAttachmentMutationMutation>;
export type UpdateMechanicProjectInsFormFileAttachmentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectInsFormFileAttachmentMutationMutation, UpdateMechanicProjectInsFormFileAttachmentMutationMutationVariables>;
export const UpdateMechanicProjectInsFormReleasedToDcaMutationDocument = gql`
    mutation updateMechanicProjectInsFormReleasedToDcaMutation($input: UpdateProjectInsFormVersionReleasedToDcaInput!) {
  updateMechanicProjectInsFormReleasedToDca(input: $input) {
    ...projectInsFormVersion
  }
}
    ${ProjectInsFormVersionFragmentDoc}`;
export type UpdateMechanicProjectInsFormReleasedToDcaMutationMutationFn = Apollo.MutationFunction<UpdateMechanicProjectInsFormReleasedToDcaMutationMutation, UpdateMechanicProjectInsFormReleasedToDcaMutationMutationVariables>;

/**
 * __useUpdateMechanicProjectInsFormReleasedToDcaMutationMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectInsFormReleasedToDcaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectInsFormReleasedToDcaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectInsFormReleasedToDcaMutationMutation, { data, loading, error }] = useUpdateMechanicProjectInsFormReleasedToDcaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMechanicProjectInsFormReleasedToDcaMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectInsFormReleasedToDcaMutationMutation, UpdateMechanicProjectInsFormReleasedToDcaMutationMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectInsFormReleasedToDcaMutationMutation, UpdateMechanicProjectInsFormReleasedToDcaMutationMutationVariables>(UpdateMechanicProjectInsFormReleasedToDcaMutationDocument, baseOptions);
      }
export type UpdateMechanicProjectInsFormReleasedToDcaMutationMutationHookResult = ReturnType<typeof useUpdateMechanicProjectInsFormReleasedToDcaMutationMutation>;
export type UpdateMechanicProjectInsFormReleasedToDcaMutationMutationResult = Apollo.MutationResult<UpdateMechanicProjectInsFormReleasedToDcaMutationMutation>;
export type UpdateMechanicProjectInsFormReleasedToDcaMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectInsFormReleasedToDcaMutationMutation, UpdateMechanicProjectInsFormReleasedToDcaMutationMutationVariables>;
export const UpdateMechanicProjectInsFormFieldValuesDocument = gql`
    mutation updateMechanicProjectInsFormFieldValues($input: UpdateProjectInsFormVersionFieldValuesInput!) {
  updateMechanicProjectInsFormFieldValues(input: $input)
}
    `;
export type UpdateMechanicProjectInsFormFieldValuesMutationFn = Apollo.MutationFunction<UpdateMechanicProjectInsFormFieldValuesMutation, UpdateMechanicProjectInsFormFieldValuesMutationVariables>;

/**
 * __useUpdateMechanicProjectInsFormFieldValuesMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectInsFormFieldValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectInsFormFieldValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectInsFormFieldValuesMutation, { data, loading, error }] = useUpdateMechanicProjectInsFormFieldValuesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMechanicProjectInsFormFieldValuesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectInsFormFieldValuesMutation, UpdateMechanicProjectInsFormFieldValuesMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectInsFormFieldValuesMutation, UpdateMechanicProjectInsFormFieldValuesMutationVariables>(UpdateMechanicProjectInsFormFieldValuesDocument, baseOptions);
      }
export type UpdateMechanicProjectInsFormFieldValuesMutationHookResult = ReturnType<typeof useUpdateMechanicProjectInsFormFieldValuesMutation>;
export type UpdateMechanicProjectInsFormFieldValuesMutationResult = Apollo.MutationResult<UpdateMechanicProjectInsFormFieldValuesMutation>;
export type UpdateMechanicProjectInsFormFieldValuesMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectInsFormFieldValuesMutation, UpdateMechanicProjectInsFormFieldValuesMutationVariables>;
export const UpdateMechanicProjectInsFormFieldCommentDocument = gql`
    mutation updateMechanicProjectInsFormFieldComment($input: UpdateProjectInsFormVersionFieldCommentInput!) {
  updateMechanicProjectInsFormFieldComment(input: $input)
}
    `;
export type UpdateMechanicProjectInsFormFieldCommentMutationFn = Apollo.MutationFunction<UpdateMechanicProjectInsFormFieldCommentMutation, UpdateMechanicProjectInsFormFieldCommentMutationVariables>;

/**
 * __useUpdateMechanicProjectInsFormFieldCommentMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectInsFormFieldCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectInsFormFieldCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectInsFormFieldCommentMutation, { data, loading, error }] = useUpdateMechanicProjectInsFormFieldCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMechanicProjectInsFormFieldCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectInsFormFieldCommentMutation, UpdateMechanicProjectInsFormFieldCommentMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectInsFormFieldCommentMutation, UpdateMechanicProjectInsFormFieldCommentMutationVariables>(UpdateMechanicProjectInsFormFieldCommentDocument, baseOptions);
      }
export type UpdateMechanicProjectInsFormFieldCommentMutationHookResult = ReturnType<typeof useUpdateMechanicProjectInsFormFieldCommentMutation>;
export type UpdateMechanicProjectInsFormFieldCommentMutationResult = Apollo.MutationResult<UpdateMechanicProjectInsFormFieldCommentMutation>;
export type UpdateMechanicProjectInsFormFieldCommentMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectInsFormFieldCommentMutation, UpdateMechanicProjectInsFormFieldCommentMutationVariables>;
export const UpdateMechanicProjectInsFormIsDcaApprovedDocument = gql`
    mutation updateMechanicProjectInsFormIsDcaApproved($input: UpdateProjectInsFormIsDcaApprovedInput!) {
  updateMechanicProjectInsFormIsDcaApproved(input: $input)
}
    `;
export type UpdateMechanicProjectInsFormIsDcaApprovedMutationFn = Apollo.MutationFunction<UpdateMechanicProjectInsFormIsDcaApprovedMutation, UpdateMechanicProjectInsFormIsDcaApprovedMutationVariables>;

/**
 * __useUpdateMechanicProjectInsFormIsDcaApprovedMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectInsFormIsDcaApprovedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectInsFormIsDcaApprovedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectInsFormIsDcaApprovedMutation, { data, loading, error }] = useUpdateMechanicProjectInsFormIsDcaApprovedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMechanicProjectInsFormIsDcaApprovedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectInsFormIsDcaApprovedMutation, UpdateMechanicProjectInsFormIsDcaApprovedMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectInsFormIsDcaApprovedMutation, UpdateMechanicProjectInsFormIsDcaApprovedMutationVariables>(UpdateMechanicProjectInsFormIsDcaApprovedDocument, baseOptions);
      }
export type UpdateMechanicProjectInsFormIsDcaApprovedMutationHookResult = ReturnType<typeof useUpdateMechanicProjectInsFormIsDcaApprovedMutation>;
export type UpdateMechanicProjectInsFormIsDcaApprovedMutationResult = Apollo.MutationResult<UpdateMechanicProjectInsFormIsDcaApprovedMutation>;
export type UpdateMechanicProjectInsFormIsDcaApprovedMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectInsFormIsDcaApprovedMutation, UpdateMechanicProjectInsFormIsDcaApprovedMutationVariables>;
export const AddMechanicProjectInsFormVersionCommentDocument = gql`
    mutation addMechanicProjectInsFormVersionComment($id: Int!, $input: CommentInput!) {
  addMechanicProjectInsFormVersionComment(input: $input, id: $id) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type AddMechanicProjectInsFormVersionCommentMutationFn = Apollo.MutationFunction<AddMechanicProjectInsFormVersionCommentMutation, AddMechanicProjectInsFormVersionCommentMutationVariables>;

/**
 * __useAddMechanicProjectInsFormVersionCommentMutation__
 *
 * To run a mutation, you first call `useAddMechanicProjectInsFormVersionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMechanicProjectInsFormVersionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMechanicProjectInsFormVersionCommentMutation, { data, loading, error }] = useAddMechanicProjectInsFormVersionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMechanicProjectInsFormVersionCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddMechanicProjectInsFormVersionCommentMutation, AddMechanicProjectInsFormVersionCommentMutationVariables>) {
        return Apollo.useMutation<AddMechanicProjectInsFormVersionCommentMutation, AddMechanicProjectInsFormVersionCommentMutationVariables>(AddMechanicProjectInsFormVersionCommentDocument, baseOptions);
      }
export type AddMechanicProjectInsFormVersionCommentMutationHookResult = ReturnType<typeof useAddMechanicProjectInsFormVersionCommentMutation>;
export type AddMechanicProjectInsFormVersionCommentMutationResult = Apollo.MutationResult<AddMechanicProjectInsFormVersionCommentMutation>;
export type AddMechanicProjectInsFormVersionCommentMutationOptions = Apollo.BaseMutationOptions<AddMechanicProjectInsFormVersionCommentMutation, AddMechanicProjectInsFormVersionCommentMutationVariables>;
export const UpdateMechanicProjectInsFormVersionCommentDocument = gql`
    mutation updateMechanicProjectInsFormVersionComment($id: Int!, $body: String!) {
  updateMechanicProjectInsFormVersionComment(id: $id, body: $body) {
    ...comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateMechanicProjectInsFormVersionCommentMutationFn = Apollo.MutationFunction<UpdateMechanicProjectInsFormVersionCommentMutation, UpdateMechanicProjectInsFormVersionCommentMutationVariables>;

/**
 * __useUpdateMechanicProjectInsFormVersionCommentMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectInsFormVersionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectInsFormVersionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectInsFormVersionCommentMutation, { data, loading, error }] = useUpdateMechanicProjectInsFormVersionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateMechanicProjectInsFormVersionCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectInsFormVersionCommentMutation, UpdateMechanicProjectInsFormVersionCommentMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectInsFormVersionCommentMutation, UpdateMechanicProjectInsFormVersionCommentMutationVariables>(UpdateMechanicProjectInsFormVersionCommentDocument, baseOptions);
      }
export type UpdateMechanicProjectInsFormVersionCommentMutationHookResult = ReturnType<typeof useUpdateMechanicProjectInsFormVersionCommentMutation>;
export type UpdateMechanicProjectInsFormVersionCommentMutationResult = Apollo.MutationResult<UpdateMechanicProjectInsFormVersionCommentMutation>;
export type UpdateMechanicProjectInsFormVersionCommentMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectInsFormVersionCommentMutation, UpdateMechanicProjectInsFormVersionCommentMutationVariables>;
export const ClearMechanicProjectInsFormVersionSignatureByIdDocument = gql`
    mutation clearMechanicProjectInsFormVersionSignatureById($projectInsFormVersionId: Int!, $fieldNumber: Int!) {
  clearMechanicProjectInsFormVersionSignatureById(projectInsFormVersionId: $projectInsFormVersionId, fieldNumber: $fieldNumber)
}
    `;
export type ClearMechanicProjectInsFormVersionSignatureByIdMutationFn = Apollo.MutationFunction<ClearMechanicProjectInsFormVersionSignatureByIdMutation, ClearMechanicProjectInsFormVersionSignatureByIdMutationVariables>;

/**
 * __useClearMechanicProjectInsFormVersionSignatureByIdMutation__
 *
 * To run a mutation, you first call `useClearMechanicProjectInsFormVersionSignatureByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearMechanicProjectInsFormVersionSignatureByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearMechanicProjectInsFormVersionSignatureByIdMutation, { data, loading, error }] = useClearMechanicProjectInsFormVersionSignatureByIdMutation({
 *   variables: {
 *      projectInsFormVersionId: // value for 'projectInsFormVersionId'
 *      fieldNumber: // value for 'fieldNumber'
 *   },
 * });
 */
export function useClearMechanicProjectInsFormVersionSignatureByIdMutation(baseOptions?: Apollo.MutationHookOptions<ClearMechanicProjectInsFormVersionSignatureByIdMutation, ClearMechanicProjectInsFormVersionSignatureByIdMutationVariables>) {
        return Apollo.useMutation<ClearMechanicProjectInsFormVersionSignatureByIdMutation, ClearMechanicProjectInsFormVersionSignatureByIdMutationVariables>(ClearMechanicProjectInsFormVersionSignatureByIdDocument, baseOptions);
      }
export type ClearMechanicProjectInsFormVersionSignatureByIdMutationHookResult = ReturnType<typeof useClearMechanicProjectInsFormVersionSignatureByIdMutation>;
export type ClearMechanicProjectInsFormVersionSignatureByIdMutationResult = Apollo.MutationResult<ClearMechanicProjectInsFormVersionSignatureByIdMutation>;
export type ClearMechanicProjectInsFormVersionSignatureByIdMutationOptions = Apollo.BaseMutationOptions<ClearMechanicProjectInsFormVersionSignatureByIdMutation, ClearMechanicProjectInsFormVersionSignatureByIdMutationVariables>;
export const MechanicProjectEmailHistoryDocument = gql`
    query mechanicProjectEmailHistory($mechanicProjectId: Int!, $sortBy: EmailHistorySortBy, $sortDirection: SortDirection) {
  mechanicProjectEmailHistory(mechanicProjectId: $mechanicProjectId, sortBy: $sortBy, sortDirection: $sortDirection) {
    ...emailHistory
  }
}
    ${EmailHistoryFragmentDoc}`;

/**
 * __useMechanicProjectEmailHistoryQuery__
 *
 * To run a query within a React component, call `useMechanicProjectEmailHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectEmailHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectEmailHistoryQuery({
 *   variables: {
 *      mechanicProjectId: // value for 'mechanicProjectId'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useMechanicProjectEmailHistoryQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectEmailHistoryQuery, MechanicProjectEmailHistoryQueryVariables>) {
        return Apollo.useQuery<MechanicProjectEmailHistoryQuery, MechanicProjectEmailHistoryQueryVariables>(MechanicProjectEmailHistoryDocument, baseOptions);
      }
export function useMechanicProjectEmailHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectEmailHistoryQuery, MechanicProjectEmailHistoryQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectEmailHistoryQuery, MechanicProjectEmailHistoryQueryVariables>(MechanicProjectEmailHistoryDocument, baseOptions);
        }
export type MechanicProjectEmailHistoryQueryHookResult = ReturnType<typeof useMechanicProjectEmailHistoryQuery>;
export type MechanicProjectEmailHistoryLazyQueryHookResult = ReturnType<typeof useMechanicProjectEmailHistoryLazyQuery>;
export type MechanicProjectEmailHistoryQueryResult = Apollo.QueryResult<MechanicProjectEmailHistoryQuery, MechanicProjectEmailHistoryQueryVariables>;
export const MechanicProjectHistoryDocument = gql`
    query mechanicProjectHistory($mechanicProjectId: Int!) {
  mechanicProjectHistory(mechanicProjectId: $mechanicProjectId) {
    ...projectHistory
  }
}
    ${ProjectHistoryFragmentDoc}`;

/**
 * __useMechanicProjectHistoryQuery__
 *
 * To run a query within a React component, call `useMechanicProjectHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectHistoryQuery({
 *   variables: {
 *      mechanicProjectId: // value for 'mechanicProjectId'
 *   },
 * });
 */
export function useMechanicProjectHistoryQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectHistoryQuery, MechanicProjectHistoryQueryVariables>) {
        return Apollo.useQuery<MechanicProjectHistoryQuery, MechanicProjectHistoryQueryVariables>(MechanicProjectHistoryDocument, baseOptions);
      }
export function useMechanicProjectHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectHistoryQuery, MechanicProjectHistoryQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectHistoryQuery, MechanicProjectHistoryQueryVariables>(MechanicProjectHistoryDocument, baseOptions);
        }
export type MechanicProjectHistoryQueryHookResult = ReturnType<typeof useMechanicProjectHistoryQuery>;
export type MechanicProjectHistoryLazyQueryHookResult = ReturnType<typeof useMechanicProjectHistoryLazyQuery>;
export type MechanicProjectHistoryQueryResult = Apollo.QueryResult<MechanicProjectHistoryQuery, MechanicProjectHistoryQueryVariables>;
export const MechanicProjectSummaryTabDocument = gql`
    query mechanicProjectSummaryTab($mechanicProjectId: Int!) {
  mechanicProject(id: $mechanicProjectId) {
    id
    mechanicProjectType {
      id
      name
    }
    mechanicProjectRenewalTypes {
      id
      name
    }
    projectStatus {
      id
    }
    firstName
    lastName
    country {
      id
      name
    }
    mechanicLicenseType {
      id
      name
    }
    licenseNumber
    mechanicPosition {
      id
      name
    }
    validationNumber
    operators {
      id
      company {
        name
      }
    }
    provisionalOperatorNames
    aircrafts {
      id
      registrationMark
      aircraftModel {
        id
        name
      }
    }
    provisionalAircraftRegistrationMarks
    isHighImportance
    isOnHold
    isOnHoldByDca
    dcaHoldReason
    assignees {
      id
      firstName
      lastName
      ...user
    }
    projectCreatedByUser {
      id
      firstName
      lastName
    }
    projectCreationDate
    assignees {
      ...user
    }
    dcaReviewerUser {
      ...user
    }
    documents {
      id
      document {
        documentType {
          id
          isAlwaysVisibleToDca
        }
        fileAttachment {
          fileName
          fileSizeBytes
          mimeType
        }
      }
      isReleasedToDca
    }
    isNoDcaInvoiceRequired
  }
  dcaHistory: mechanicProjectHistory(mechanicProjectId: $mechanicProjectId, filter: {dcaOnly: true}) {
    performedByName
    date
    projectStatus {
      id
      name
    }
    projectTransition {
      id
      name
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useMechanicProjectSummaryTabQuery__
 *
 * To run a query within a React component, call `useMechanicProjectSummaryTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectSummaryTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectSummaryTabQuery({
 *   variables: {
 *      mechanicProjectId: // value for 'mechanicProjectId'
 *   },
 * });
 */
export function useMechanicProjectSummaryTabQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectSummaryTabQuery, MechanicProjectSummaryTabQueryVariables>) {
        return Apollo.useQuery<MechanicProjectSummaryTabQuery, MechanicProjectSummaryTabQueryVariables>(MechanicProjectSummaryTabDocument, baseOptions);
      }
export function useMechanicProjectSummaryTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectSummaryTabQuery, MechanicProjectSummaryTabQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectSummaryTabQuery, MechanicProjectSummaryTabQueryVariables>(MechanicProjectSummaryTabDocument, baseOptions);
        }
export type MechanicProjectSummaryTabQueryHookResult = ReturnType<typeof useMechanicProjectSummaryTabQuery>;
export type MechanicProjectSummaryTabLazyQueryHookResult = ReturnType<typeof useMechanicProjectSummaryTabLazyQuery>;
export type MechanicProjectSummaryTabQueryResult = Apollo.QueryResult<MechanicProjectSummaryTabQuery, MechanicProjectSummaryTabQueryVariables>;
export const MechanicProjectOfficialLetterNotesDocument = gql`
    query mechanicProjectOfficialLetterNotes($mechanicProjectId: Int!) {
  mechanicProject(id: $mechanicProjectId) {
    officialLetterDocumentsNote
    documentTypeOfficialLetterNotes {
      documentType {
        id
        name
      }
      officialLetterNote
    }
  }
}
    `;

/**
 * __useMechanicProjectOfficialLetterNotesQuery__
 *
 * To run a query within a React component, call `useMechanicProjectOfficialLetterNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectOfficialLetterNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectOfficialLetterNotesQuery({
 *   variables: {
 *      mechanicProjectId: // value for 'mechanicProjectId'
 *   },
 * });
 */
export function useMechanicProjectOfficialLetterNotesQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectOfficialLetterNotesQuery, MechanicProjectOfficialLetterNotesQueryVariables>) {
        return Apollo.useQuery<MechanicProjectOfficialLetterNotesQuery, MechanicProjectOfficialLetterNotesQueryVariables>(MechanicProjectOfficialLetterNotesDocument, baseOptions);
      }
export function useMechanicProjectOfficialLetterNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectOfficialLetterNotesQuery, MechanicProjectOfficialLetterNotesQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectOfficialLetterNotesQuery, MechanicProjectOfficialLetterNotesQueryVariables>(MechanicProjectOfficialLetterNotesDocument, baseOptions);
        }
export type MechanicProjectOfficialLetterNotesQueryHookResult = ReturnType<typeof useMechanicProjectOfficialLetterNotesQuery>;
export type MechanicProjectOfficialLetterNotesLazyQueryHookResult = ReturnType<typeof useMechanicProjectOfficialLetterNotesLazyQuery>;
export type MechanicProjectOfficialLetterNotesQueryResult = Apollo.QueryResult<MechanicProjectOfficialLetterNotesQuery, MechanicProjectOfficialLetterNotesQueryVariables>;
export const UpdateMechanicProjectOfficialLetterDocumentNotesDocument = gql`
    mutation updateMechanicProjectOfficialLetterDocumentNotes($input: UpdateMechanicProjectOfficialLetterNotesInput!) {
  updateMechanicProjectOfficialLetterDocumentNotes(input: $input) {
    id
  }
}
    `;
export type UpdateMechanicProjectOfficialLetterDocumentNotesMutationFn = Apollo.MutationFunction<UpdateMechanicProjectOfficialLetterDocumentNotesMutation, UpdateMechanicProjectOfficialLetterDocumentNotesMutationVariables>;

/**
 * __useUpdateMechanicProjectOfficialLetterDocumentNotesMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectOfficialLetterDocumentNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectOfficialLetterDocumentNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectOfficialLetterDocumentNotesMutation, { data, loading, error }] = useUpdateMechanicProjectOfficialLetterDocumentNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMechanicProjectOfficialLetterDocumentNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectOfficialLetterDocumentNotesMutation, UpdateMechanicProjectOfficialLetterDocumentNotesMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectOfficialLetterDocumentNotesMutation, UpdateMechanicProjectOfficialLetterDocumentNotesMutationVariables>(UpdateMechanicProjectOfficialLetterDocumentNotesDocument, baseOptions);
      }
export type UpdateMechanicProjectOfficialLetterDocumentNotesMutationHookResult = ReturnType<typeof useUpdateMechanicProjectOfficialLetterDocumentNotesMutation>;
export type UpdateMechanicProjectOfficialLetterDocumentNotesMutationResult = Apollo.MutationResult<UpdateMechanicProjectOfficialLetterDocumentNotesMutation>;
export type UpdateMechanicProjectOfficialLetterDocumentNotesMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectOfficialLetterDocumentNotesMutation, UpdateMechanicProjectOfficialLetterDocumentNotesMutationVariables>;
export const SendMechanicProjectEmailDocument = gql`
    mutation sendMechanicProjectEmail($mechanicProjectId: Int!, $email: EmailInput!) {
  sendMechanicProjectEmail(mechanicProjectId: $mechanicProjectId, email: $email) {
    id
  }
}
    `;
export type SendMechanicProjectEmailMutationFn = Apollo.MutationFunction<SendMechanicProjectEmailMutation, SendMechanicProjectEmailMutationVariables>;

/**
 * __useSendMechanicProjectEmailMutation__
 *
 * To run a mutation, you first call `useSendMechanicProjectEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMechanicProjectEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMechanicProjectEmailMutation, { data, loading, error }] = useSendMechanicProjectEmailMutation({
 *   variables: {
 *      mechanicProjectId: // value for 'mechanicProjectId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendMechanicProjectEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendMechanicProjectEmailMutation, SendMechanicProjectEmailMutationVariables>) {
        return Apollo.useMutation<SendMechanicProjectEmailMutation, SendMechanicProjectEmailMutationVariables>(SendMechanicProjectEmailDocument, baseOptions);
      }
export type SendMechanicProjectEmailMutationHookResult = ReturnType<typeof useSendMechanicProjectEmailMutation>;
export type SendMechanicProjectEmailMutationResult = Apollo.MutationResult<SendMechanicProjectEmailMutation>;
export type SendMechanicProjectEmailMutationOptions = Apollo.BaseMutationOptions<SendMechanicProjectEmailMutation, SendMechanicProjectEmailMutationVariables>;
export const UpdateMechanicProjectCommentsLastViewedDateDocument = gql`
    mutation updateMechanicProjectCommentsLastViewedDate($id: Int!) {
  updateMechanicProjectCommentsLastViewedDate(mechanicProjectId: $id) {
    id
  }
}
    `;
export type UpdateMechanicProjectCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateMechanicProjectCommentsLastViewedDateMutation, UpdateMechanicProjectCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateMechanicProjectCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateMechanicProjectCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateMechanicProjectCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectCommentsLastViewedDateMutation, UpdateMechanicProjectCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectCommentsLastViewedDateMutation, UpdateMechanicProjectCommentsLastViewedDateMutationVariables>(UpdateMechanicProjectCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateMechanicProjectCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateMechanicProjectCommentsLastViewedDateMutation>;
export type UpdateMechanicProjectCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateMechanicProjectCommentsLastViewedDateMutation>;
export type UpdateMechanicProjectCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectCommentsLastViewedDateMutation, UpdateMechanicProjectCommentsLastViewedDateMutationVariables>;
export const UpdateMechanicProjectDcaCommentsLastViewedDateDocument = gql`
    mutation updateMechanicProjectDcaCommentsLastViewedDate($id: Int!) {
  updateMechanicProjectDcaCommentsLastViewedDate(mechanicProjectId: $id) {
    id
  }
}
    `;
export type UpdateMechanicProjectDcaCommentsLastViewedDateMutationFn = Apollo.MutationFunction<UpdateMechanicProjectDcaCommentsLastViewedDateMutation, UpdateMechanicProjectDcaCommentsLastViewedDateMutationVariables>;

/**
 * __useUpdateMechanicProjectDcaCommentsLastViewedDateMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectDcaCommentsLastViewedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectDcaCommentsLastViewedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectDcaCommentsLastViewedDateMutation, { data, loading, error }] = useUpdateMechanicProjectDcaCommentsLastViewedDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateMechanicProjectDcaCommentsLastViewedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectDcaCommentsLastViewedDateMutation, UpdateMechanicProjectDcaCommentsLastViewedDateMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectDcaCommentsLastViewedDateMutation, UpdateMechanicProjectDcaCommentsLastViewedDateMutationVariables>(UpdateMechanicProjectDcaCommentsLastViewedDateDocument, baseOptions);
      }
export type UpdateMechanicProjectDcaCommentsLastViewedDateMutationHookResult = ReturnType<typeof useUpdateMechanicProjectDcaCommentsLastViewedDateMutation>;
export type UpdateMechanicProjectDcaCommentsLastViewedDateMutationResult = Apollo.MutationResult<UpdateMechanicProjectDcaCommentsLastViewedDateMutation>;
export type UpdateMechanicProjectDcaCommentsLastViewedDateMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectDcaCommentsLastViewedDateMutation, UpdateMechanicProjectDcaCommentsLastViewedDateMutationVariables>;
export const MechanicProjectAssignableUsersDocument = gql`
    query mechanicProjectAssignableUsers {
  mechanicProjectAssignableUsers {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useMechanicProjectAssignableUsersQuery__
 *
 * To run a query within a React component, call `useMechanicProjectAssignableUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectAssignableUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectAssignableUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMechanicProjectAssignableUsersQuery(baseOptions?: Apollo.QueryHookOptions<MechanicProjectAssignableUsersQuery, MechanicProjectAssignableUsersQueryVariables>) {
        return Apollo.useQuery<MechanicProjectAssignableUsersQuery, MechanicProjectAssignableUsersQueryVariables>(MechanicProjectAssignableUsersDocument, baseOptions);
      }
export function useMechanicProjectAssignableUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectAssignableUsersQuery, MechanicProjectAssignableUsersQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectAssignableUsersQuery, MechanicProjectAssignableUsersQueryVariables>(MechanicProjectAssignableUsersDocument, baseOptions);
        }
export type MechanicProjectAssignableUsersQueryHookResult = ReturnType<typeof useMechanicProjectAssignableUsersQuery>;
export type MechanicProjectAssignableUsersLazyQueryHookResult = ReturnType<typeof useMechanicProjectAssignableUsersLazyQuery>;
export type MechanicProjectAssignableUsersQueryResult = Apollo.QueryResult<MechanicProjectAssignableUsersQuery, MechanicProjectAssignableUsersQueryVariables>;
export const SetMechanicProjectAssigneesDocument = gql`
    mutation setMechanicProjectAssignees($mechanicProjectId: Int!, $assigneeUserIds: [Int!]!) {
  setMechanicProjectAssignees(mechanicProjectId: $mechanicProjectId, assigneeUserIds: $assigneeUserIds) {
    id
  }
}
    `;
export type SetMechanicProjectAssigneesMutationFn = Apollo.MutationFunction<SetMechanicProjectAssigneesMutation, SetMechanicProjectAssigneesMutationVariables>;

/**
 * __useSetMechanicProjectAssigneesMutation__
 *
 * To run a mutation, you first call `useSetMechanicProjectAssigneesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMechanicProjectAssigneesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMechanicProjectAssigneesMutation, { data, loading, error }] = useSetMechanicProjectAssigneesMutation({
 *   variables: {
 *      mechanicProjectId: // value for 'mechanicProjectId'
 *      assigneeUserIds: // value for 'assigneeUserIds'
 *   },
 * });
 */
export function useSetMechanicProjectAssigneesMutation(baseOptions?: Apollo.MutationHookOptions<SetMechanicProjectAssigneesMutation, SetMechanicProjectAssigneesMutationVariables>) {
        return Apollo.useMutation<SetMechanicProjectAssigneesMutation, SetMechanicProjectAssigneesMutationVariables>(SetMechanicProjectAssigneesDocument, baseOptions);
      }
export type SetMechanicProjectAssigneesMutationHookResult = ReturnType<typeof useSetMechanicProjectAssigneesMutation>;
export type SetMechanicProjectAssigneesMutationResult = Apollo.MutationResult<SetMechanicProjectAssigneesMutation>;
export type SetMechanicProjectAssigneesMutationOptions = Apollo.BaseMutationOptions<SetMechanicProjectAssigneesMutation, SetMechanicProjectAssigneesMutationVariables>;
export const SetMechanicProjectPriorityDocument = gql`
    mutation setMechanicProjectPriority($id: Int!, $isHighPriority: Boolean!) {
  setMechanicProjectPriority(id: $id, isHighPriority: $isHighPriority) {
    id
  }
}
    `;
export type SetMechanicProjectPriorityMutationFn = Apollo.MutationFunction<SetMechanicProjectPriorityMutation, SetMechanicProjectPriorityMutationVariables>;

/**
 * __useSetMechanicProjectPriorityMutation__
 *
 * To run a mutation, you first call `useSetMechanicProjectPriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMechanicProjectPriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMechanicProjectPriorityMutation, { data, loading, error }] = useSetMechanicProjectPriorityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isHighPriority: // value for 'isHighPriority'
 *   },
 * });
 */
export function useSetMechanicProjectPriorityMutation(baseOptions?: Apollo.MutationHookOptions<SetMechanicProjectPriorityMutation, SetMechanicProjectPriorityMutationVariables>) {
        return Apollo.useMutation<SetMechanicProjectPriorityMutation, SetMechanicProjectPriorityMutationVariables>(SetMechanicProjectPriorityDocument, baseOptions);
      }
export type SetMechanicProjectPriorityMutationHookResult = ReturnType<typeof useSetMechanicProjectPriorityMutation>;
export type SetMechanicProjectPriorityMutationResult = Apollo.MutationResult<SetMechanicProjectPriorityMutation>;
export type SetMechanicProjectPriorityMutationOptions = Apollo.BaseMutationOptions<SetMechanicProjectPriorityMutation, SetMechanicProjectPriorityMutationVariables>;
export const SetMechanicProjectNoDcaInvoiceRequiredFlagDocument = gql`
    mutation setMechanicProjectNoDcaInvoiceRequiredFlag($id: Int!, $isNoDcaInvoiceRequired: Boolean!) {
  setMechanicProjectNoDcaInvoiceRequiredFlag(id: $id, isNoDcaInvoiceRequired: $isNoDcaInvoiceRequired)
}
    `;
export type SetMechanicProjectNoDcaInvoiceRequiredFlagMutationFn = Apollo.MutationFunction<SetMechanicProjectNoDcaInvoiceRequiredFlagMutation, SetMechanicProjectNoDcaInvoiceRequiredFlagMutationVariables>;

/**
 * __useSetMechanicProjectNoDcaInvoiceRequiredFlagMutation__
 *
 * To run a mutation, you first call `useSetMechanicProjectNoDcaInvoiceRequiredFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMechanicProjectNoDcaInvoiceRequiredFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMechanicProjectNoDcaInvoiceRequiredFlagMutation, { data, loading, error }] = useSetMechanicProjectNoDcaInvoiceRequiredFlagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isNoDcaInvoiceRequired: // value for 'isNoDcaInvoiceRequired'
 *   },
 * });
 */
export function useSetMechanicProjectNoDcaInvoiceRequiredFlagMutation(baseOptions?: Apollo.MutationHookOptions<SetMechanicProjectNoDcaInvoiceRequiredFlagMutation, SetMechanicProjectNoDcaInvoiceRequiredFlagMutationVariables>) {
        return Apollo.useMutation<SetMechanicProjectNoDcaInvoiceRequiredFlagMutation, SetMechanicProjectNoDcaInvoiceRequiredFlagMutationVariables>(SetMechanicProjectNoDcaInvoiceRequiredFlagDocument, baseOptions);
      }
export type SetMechanicProjectNoDcaInvoiceRequiredFlagMutationHookResult = ReturnType<typeof useSetMechanicProjectNoDcaInvoiceRequiredFlagMutation>;
export type SetMechanicProjectNoDcaInvoiceRequiredFlagMutationResult = Apollo.MutationResult<SetMechanicProjectNoDcaInvoiceRequiredFlagMutation>;
export type SetMechanicProjectNoDcaInvoiceRequiredFlagMutationOptions = Apollo.BaseMutationOptions<SetMechanicProjectNoDcaInvoiceRequiredFlagMutation, SetMechanicProjectNoDcaInvoiceRequiredFlagMutationVariables>;
export const MechanicProjectEmailViewDocument = gql`
    query mechanicProjectEmailView($id: Int!, $emailId: Int!, $includeFileAttachments: Boolean = false, $includeFileContent: Boolean = false) {
  mechanicProject(id: $id) {
    emails(filter: {id_in: [$emailId]}) {
      ...email
    }
  }
}
    ${EmailFragmentDoc}`;

/**
 * __useMechanicProjectEmailViewQuery__
 *
 * To run a query within a React component, call `useMechanicProjectEmailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectEmailViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectEmailViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      emailId: // value for 'emailId'
 *      includeFileAttachments: // value for 'includeFileAttachments'
 *      includeFileContent: // value for 'includeFileContent'
 *   },
 * });
 */
export function useMechanicProjectEmailViewQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectEmailViewQuery, MechanicProjectEmailViewQueryVariables>) {
        return Apollo.useQuery<MechanicProjectEmailViewQuery, MechanicProjectEmailViewQueryVariables>(MechanicProjectEmailViewDocument, baseOptions);
      }
export function useMechanicProjectEmailViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectEmailViewQuery, MechanicProjectEmailViewQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectEmailViewQuery, MechanicProjectEmailViewQueryVariables>(MechanicProjectEmailViewDocument, baseOptions);
        }
export type MechanicProjectEmailViewQueryHookResult = ReturnType<typeof useMechanicProjectEmailViewQuery>;
export type MechanicProjectEmailViewLazyQueryHookResult = ReturnType<typeof useMechanicProjectEmailViewLazyQuery>;
export type MechanicProjectEmailViewQueryResult = Apollo.QueryResult<MechanicProjectEmailViewQuery, MechanicProjectEmailViewQueryVariables>;
export const DownloadMechanicProjectEmailAttachmentContentDocument = gql`
    query downloadMechanicProjectEmailAttachmentContent($mechanicProjectId: Int!, $emailId: Int!, $attachmentId: Int!) {
  downloadMechanicProjectEmailAttachmentContent(mechanicProjectId: $mechanicProjectId, emailId: $emailId, attachmentId: $attachmentId)
}
    `;

/**
 * __useDownloadMechanicProjectEmailAttachmentContentQuery__
 *
 * To run a query within a React component, call `useDownloadMechanicProjectEmailAttachmentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadMechanicProjectEmailAttachmentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadMechanicProjectEmailAttachmentContentQuery({
 *   variables: {
 *      mechanicProjectId: // value for 'mechanicProjectId'
 *      emailId: // value for 'emailId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDownloadMechanicProjectEmailAttachmentContentQuery(baseOptions: Apollo.QueryHookOptions<DownloadMechanicProjectEmailAttachmentContentQuery, DownloadMechanicProjectEmailAttachmentContentQueryVariables>) {
        return Apollo.useQuery<DownloadMechanicProjectEmailAttachmentContentQuery, DownloadMechanicProjectEmailAttachmentContentQueryVariables>(DownloadMechanicProjectEmailAttachmentContentDocument, baseOptions);
      }
export function useDownloadMechanicProjectEmailAttachmentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadMechanicProjectEmailAttachmentContentQuery, DownloadMechanicProjectEmailAttachmentContentQueryVariables>) {
          return Apollo.useLazyQuery<DownloadMechanicProjectEmailAttachmentContentQuery, DownloadMechanicProjectEmailAttachmentContentQueryVariables>(DownloadMechanicProjectEmailAttachmentContentDocument, baseOptions);
        }
export type DownloadMechanicProjectEmailAttachmentContentQueryHookResult = ReturnType<typeof useDownloadMechanicProjectEmailAttachmentContentQuery>;
export type DownloadMechanicProjectEmailAttachmentContentLazyQueryHookResult = ReturnType<typeof useDownloadMechanicProjectEmailAttachmentContentLazyQuery>;
export type DownloadMechanicProjectEmailAttachmentContentQueryResult = Apollo.QueryResult<DownloadMechanicProjectEmailAttachmentContentQuery, DownloadMechanicProjectEmailAttachmentContentQueryVariables>;
export const MechanicProjectApplicationTabQueryDocument = gql`
    query mechanicProjectApplicationTabQuery($id: Int!) {
  mechanicProject(id: $id) {
    id
    mechanicProjectType {
      id
      name
    }
    mechanicProjectRenewalTypes {
      id
    }
    certificateFirstIssuedDate
    certificateDateOfIssue
    validationNumber
    certificateExpiryDate
    clientSubmissionDate
    dcaSubmissionDate
    firstName
    lastName
    mechanicPosition {
      id
    }
    country {
      id
    }
    mechanicLicenseType {
      id
    }
    licenseNumber
    operators {
      ...mechanicProjectOperator
    }
    provisionalOperatorNames
    employmentCompanies {
      ...mechanicProjectEmploymentCompany
    }
    mechanicRatings {
      ...mechanicProjectMechanicRating
    }
    aircrafts {
      ...mechanicProjectAircraft
    }
    provisionalAircraftRegistrationMarks
    associatedAircraftProject {
      id
    }
  }
  mechanicPositions(includeDeleted: true) {
    ...mechanicProjectMechanicPosition
  }
  employmentCompanies(includeDeleted: true) {
    ...mechanicProjectEmploymentCompany
  }
  mechanicRatings(includeDeleted: true) {
    ...mechanicProjectMechanicRating
  }
  operators(includeInactive: true, includeDeleted: true, sortBy: name, sortDirection: "ASC") {
    ... on Operators {
      operators {
        ...mechanicProjectOperator
      }
    }
  }
}
    ${MechanicProjectOperatorFragmentDoc}
${MechanicProjectEmploymentCompanyFragmentDoc}
${MechanicProjectMechanicRatingFragmentDoc}
${MechanicProjectAircraftFragmentDoc}
${MechanicProjectMechanicPositionFragmentDoc}`;

/**
 * __useMechanicProjectApplicationTabQueryQuery__
 *
 * To run a query within a React component, call `useMechanicProjectApplicationTabQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMechanicProjectApplicationTabQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMechanicProjectApplicationTabQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMechanicProjectApplicationTabQueryQuery(baseOptions: Apollo.QueryHookOptions<MechanicProjectApplicationTabQueryQuery, MechanicProjectApplicationTabQueryQueryVariables>) {
        return Apollo.useQuery<MechanicProjectApplicationTabQueryQuery, MechanicProjectApplicationTabQueryQueryVariables>(MechanicProjectApplicationTabQueryDocument, baseOptions);
      }
export function useMechanicProjectApplicationTabQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MechanicProjectApplicationTabQueryQuery, MechanicProjectApplicationTabQueryQueryVariables>) {
          return Apollo.useLazyQuery<MechanicProjectApplicationTabQueryQuery, MechanicProjectApplicationTabQueryQueryVariables>(MechanicProjectApplicationTabQueryDocument, baseOptions);
        }
export type MechanicProjectApplicationTabQueryQueryHookResult = ReturnType<typeof useMechanicProjectApplicationTabQueryQuery>;
export type MechanicProjectApplicationTabQueryLazyQueryHookResult = ReturnType<typeof useMechanicProjectApplicationTabQueryLazyQuery>;
export type MechanicProjectApplicationTabQueryQueryResult = Apollo.QueryResult<MechanicProjectApplicationTabQueryQuery, MechanicProjectApplicationTabQueryQueryVariables>;
export const UpdateMechanicProjectMutationDocument = gql`
    mutation updateMechanicProjectMutation($updateMechanicProjectInput: UpdateMechanicProjectInput!, $recordHistory: Boolean, $ignoreWarnings: Boolean) {
  updateMechanicProject(updateMechanicProjectInput: $updateMechanicProjectInput, recordHistory: $recordHistory, ignoreWarnings: $ignoreWarnings) {
    warnings
  }
}
    `;
export type UpdateMechanicProjectMutationMutationFn = Apollo.MutationFunction<UpdateMechanicProjectMutationMutation, UpdateMechanicProjectMutationMutationVariables>;

/**
 * __useUpdateMechanicProjectMutationMutation__
 *
 * To run a mutation, you first call `useUpdateMechanicProjectMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMechanicProjectMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMechanicProjectMutationMutation, { data, loading, error }] = useUpdateMechanicProjectMutationMutation({
 *   variables: {
 *      updateMechanicProjectInput: // value for 'updateMechanicProjectInput'
 *      recordHistory: // value for 'recordHistory'
 *      ignoreWarnings: // value for 'ignoreWarnings'
 *   },
 * });
 */
export function useUpdateMechanicProjectMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMechanicProjectMutationMutation, UpdateMechanicProjectMutationMutationVariables>) {
        return Apollo.useMutation<UpdateMechanicProjectMutationMutation, UpdateMechanicProjectMutationMutationVariables>(UpdateMechanicProjectMutationDocument, baseOptions);
      }
export type UpdateMechanicProjectMutationMutationHookResult = ReturnType<typeof useUpdateMechanicProjectMutationMutation>;
export type UpdateMechanicProjectMutationMutationResult = Apollo.MutationResult<UpdateMechanicProjectMutationMutation>;
export type UpdateMechanicProjectMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMechanicProjectMutationMutation, UpdateMechanicProjectMutationMutationVariables>;
export const OperatorGridFilterLookupsDocument = gql`
    query operatorGridFilterLookups {
  countries {
    ...countryLookup
  }
  regions {
    ...regionLookup
  }
}
    ${CountryLookupFragmentDoc}
${RegionLookupFragmentDoc}`;

/**
 * __useOperatorGridFilterLookupsQuery__
 *
 * To run a query within a React component, call `useOperatorGridFilterLookupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorGridFilterLookupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorGridFilterLookupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOperatorGridFilterLookupsQuery(baseOptions?: Apollo.QueryHookOptions<OperatorGridFilterLookupsQuery, OperatorGridFilterLookupsQueryVariables>) {
        return Apollo.useQuery<OperatorGridFilterLookupsQuery, OperatorGridFilterLookupsQueryVariables>(OperatorGridFilterLookupsDocument, baseOptions);
      }
export function useOperatorGridFilterLookupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorGridFilterLookupsQuery, OperatorGridFilterLookupsQueryVariables>) {
          return Apollo.useLazyQuery<OperatorGridFilterLookupsQuery, OperatorGridFilterLookupsQueryVariables>(OperatorGridFilterLookupsDocument, baseOptions);
        }
export type OperatorGridFilterLookupsQueryHookResult = ReturnType<typeof useOperatorGridFilterLookupsQuery>;
export type OperatorGridFilterLookupsLazyQueryHookResult = ReturnType<typeof useOperatorGridFilterLookupsLazyQuery>;
export type OperatorGridFilterLookupsQueryResult = Apollo.QueryResult<OperatorGridFilterLookupsQuery, OperatorGridFilterLookupsQueryVariables>;
export const OperatorGridDocument = gql`
    query operatorGrid($sortBy: OperatorsSortBy, $sortDirection: String, $nameContains: String, $countryIdIn: [Int!], $regionIdIn: [Int!], $hasActiveAircraft: Boolean, $isActive: Boolean, $includeInactive: Boolean, $keyword: String, $paginationOptions: PaginationOptions) {
  operators(sortBy: $sortBy, sortDirection: $sortDirection, nameContains: $nameContains, countryIdIn: $countryIdIn, regionIdIn: $regionIdIn, hasActiveAircraft: $hasActiveAircraft, isActive: $isActive, includeInactive: $includeInactive, keyword: $keyword, paginationOptions: $paginationOptions) {
    ... on PaginatedOperators {
      totalItems
      operators {
        ...operatorGridItem
      }
    }
    ... on Operators {
      operators {
        ...operatorGridItem
      }
    }
  }
}
    ${OperatorGridItemFragmentDoc}`;

/**
 * __useOperatorGridQuery__
 *
 * To run a query within a React component, call `useOperatorGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorGridQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      nameContains: // value for 'nameContains'
 *      countryIdIn: // value for 'countryIdIn'
 *      regionIdIn: // value for 'regionIdIn'
 *      hasActiveAircraft: // value for 'hasActiveAircraft'
 *      isActive: // value for 'isActive'
 *      includeInactive: // value for 'includeInactive'
 *      keyword: // value for 'keyword'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useOperatorGridQuery(baseOptions?: Apollo.QueryHookOptions<OperatorGridQuery, OperatorGridQueryVariables>) {
        return Apollo.useQuery<OperatorGridQuery, OperatorGridQueryVariables>(OperatorGridDocument, baseOptions);
      }
export function useOperatorGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorGridQuery, OperatorGridQueryVariables>) {
          return Apollo.useLazyQuery<OperatorGridQuery, OperatorGridQueryVariables>(OperatorGridDocument, baseOptions);
        }
export type OperatorGridQueryHookResult = ReturnType<typeof useOperatorGridQuery>;
export type OperatorGridLazyQueryHookResult = ReturnType<typeof useOperatorGridLazyQuery>;
export type OperatorGridQueryResult = Apollo.QueryResult<OperatorGridQuery, OperatorGridQueryVariables>;
export const OperatorDetailDocument = gql`
    query operatorDetail($id: Int!) {
  operator(id: $id) {
    ...operatorDetail
  }
}
    ${OperatorDetailFragmentDoc}`;

/**
 * __useOperatorDetailQuery__
 *
 * To run a query within a React component, call `useOperatorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOperatorDetailQuery(baseOptions: Apollo.QueryHookOptions<OperatorDetailQuery, OperatorDetailQueryVariables>) {
        return Apollo.useQuery<OperatorDetailQuery, OperatorDetailQueryVariables>(OperatorDetailDocument, baseOptions);
      }
export function useOperatorDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorDetailQuery, OperatorDetailQueryVariables>) {
          return Apollo.useLazyQuery<OperatorDetailQuery, OperatorDetailQueryVariables>(OperatorDetailDocument, baseOptions);
        }
export type OperatorDetailQueryHookResult = ReturnType<typeof useOperatorDetailQuery>;
export type OperatorDetailLazyQueryHookResult = ReturnType<typeof useOperatorDetailLazyQuery>;
export type OperatorDetailQueryResult = Apollo.QueryResult<OperatorDetailQuery, OperatorDetailQueryVariables>;
export const AddOperatorDocument = gql`
    mutation addOperator($input: OperatorInput!) {
  addOperator(input: $input) {
    id
    company {
      id
      name
    }
  }
}
    `;
export type AddOperatorMutationFn = Apollo.MutationFunction<AddOperatorMutation, AddOperatorMutationVariables>;

/**
 * __useAddOperatorMutation__
 *
 * To run a mutation, you first call `useAddOperatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOperatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOperatorMutation, { data, loading, error }] = useAddOperatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOperatorMutation(baseOptions?: Apollo.MutationHookOptions<AddOperatorMutation, AddOperatorMutationVariables>) {
        return Apollo.useMutation<AddOperatorMutation, AddOperatorMutationVariables>(AddOperatorDocument, baseOptions);
      }
export type AddOperatorMutationHookResult = ReturnType<typeof useAddOperatorMutation>;
export type AddOperatorMutationResult = Apollo.MutationResult<AddOperatorMutation>;
export type AddOperatorMutationOptions = Apollo.BaseMutationOptions<AddOperatorMutation, AddOperatorMutationVariables>;
export const UpdateOperatorDocument = gql`
    mutation updateOperator($id: Int!, $input: OperatorInput!) {
  updateOperator(id: $id, input: $input) {
    id
    company {
      id
      name
    }
  }
}
    `;
export type UpdateOperatorMutationFn = Apollo.MutationFunction<UpdateOperatorMutation, UpdateOperatorMutationVariables>;

/**
 * __useUpdateOperatorMutation__
 *
 * To run a mutation, you first call `useUpdateOperatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOperatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOperatorMutation, { data, loading, error }] = useUpdateOperatorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOperatorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOperatorMutation, UpdateOperatorMutationVariables>) {
        return Apollo.useMutation<UpdateOperatorMutation, UpdateOperatorMutationVariables>(UpdateOperatorDocument, baseOptions);
      }
export type UpdateOperatorMutationHookResult = ReturnType<typeof useUpdateOperatorMutation>;
export type UpdateOperatorMutationResult = Apollo.MutationResult<UpdateOperatorMutation>;
export type UpdateOperatorMutationOptions = Apollo.BaseMutationOptions<UpdateOperatorMutation, UpdateOperatorMutationVariables>;
export const OperatorDocumentTypesQueryDocument = gql`
    query operatorDocumentTypesQuery($companyId: Int!, $documentTypeCategoryId: DocumentTypeCategoryEnum!) {
  documentTypes: operatorDocumentTypes(companyId: $companyId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...documentType
  }
}
    ${DocumentTypeFragmentDoc}`;

/**
 * __useOperatorDocumentTypesQueryQuery__
 *
 * To run a query within a React component, call `useOperatorDocumentTypesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorDocumentTypesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorDocumentTypesQueryQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      documentTypeCategoryId: // value for 'documentTypeCategoryId'
 *   },
 * });
 */
export function useOperatorDocumentTypesQueryQuery(baseOptions: Apollo.QueryHookOptions<OperatorDocumentTypesQueryQuery, OperatorDocumentTypesQueryQueryVariables>) {
        return Apollo.useQuery<OperatorDocumentTypesQueryQuery, OperatorDocumentTypesQueryQueryVariables>(OperatorDocumentTypesQueryDocument, baseOptions);
      }
export function useOperatorDocumentTypesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorDocumentTypesQueryQuery, OperatorDocumentTypesQueryQueryVariables>) {
          return Apollo.useLazyQuery<OperatorDocumentTypesQueryQuery, OperatorDocumentTypesQueryQueryVariables>(OperatorDocumentTypesQueryDocument, baseOptions);
        }
export type OperatorDocumentTypesQueryQueryHookResult = ReturnType<typeof useOperatorDocumentTypesQueryQuery>;
export type OperatorDocumentTypesQueryLazyQueryHookResult = ReturnType<typeof useOperatorDocumentTypesQueryLazyQuery>;
export type OperatorDocumentTypesQueryQueryResult = Apollo.QueryResult<OperatorDocumentTypesQueryQuery, OperatorDocumentTypesQueryQueryVariables>;
export const OperatorAddCrewProjectCrewMemberDetailQueryDocument = gql`
    query operatorAddCrewProjectCrewMemberDetailQuery($id: Int!) {
  crewMember(id: $id) {
    id
    firstName
    lastName
    crewPosition {
      id
    }
    country {
      id
    }
    crewLicenseType {
      id
    }
    licenseNumber
  }
}
    `;

/**
 * __useOperatorAddCrewProjectCrewMemberDetailQueryQuery__
 *
 * To run a query within a React component, call `useOperatorAddCrewProjectCrewMemberDetailQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorAddCrewProjectCrewMemberDetailQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorAddCrewProjectCrewMemberDetailQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOperatorAddCrewProjectCrewMemberDetailQueryQuery(baseOptions: Apollo.QueryHookOptions<OperatorAddCrewProjectCrewMemberDetailQueryQuery, OperatorAddCrewProjectCrewMemberDetailQueryQueryVariables>) {
        return Apollo.useQuery<OperatorAddCrewProjectCrewMemberDetailQueryQuery, OperatorAddCrewProjectCrewMemberDetailQueryQueryVariables>(OperatorAddCrewProjectCrewMemberDetailQueryDocument, baseOptions);
      }
export function useOperatorAddCrewProjectCrewMemberDetailQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorAddCrewProjectCrewMemberDetailQueryQuery, OperatorAddCrewProjectCrewMemberDetailQueryQueryVariables>) {
          return Apollo.useLazyQuery<OperatorAddCrewProjectCrewMemberDetailQueryQuery, OperatorAddCrewProjectCrewMemberDetailQueryQueryVariables>(OperatorAddCrewProjectCrewMemberDetailQueryDocument, baseOptions);
        }
export type OperatorAddCrewProjectCrewMemberDetailQueryQueryHookResult = ReturnType<typeof useOperatorAddCrewProjectCrewMemberDetailQueryQuery>;
export type OperatorAddCrewProjectCrewMemberDetailQueryLazyQueryHookResult = ReturnType<typeof useOperatorAddCrewProjectCrewMemberDetailQueryLazyQuery>;
export type OperatorAddCrewProjectCrewMemberDetailQueryQueryResult = Apollo.QueryResult<OperatorAddCrewProjectCrewMemberDetailQueryQuery, OperatorAddCrewProjectCrewMemberDetailQueryQueryVariables>;
export const OperatorAddCrewProjectMutationDocument = gql`
    mutation operatorAddCrewProjectMutation($operatorAddCrewProjectInput: OperatorAddCrewProjectInput!) {
  operatorAddCrewProject(operatorAddCrewProjectInput: $operatorAddCrewProjectInput) {
    id
  }
}
    `;
export type OperatorAddCrewProjectMutationMutationFn = Apollo.MutationFunction<OperatorAddCrewProjectMutationMutation, OperatorAddCrewProjectMutationMutationVariables>;

/**
 * __useOperatorAddCrewProjectMutationMutation__
 *
 * To run a mutation, you first call `useOperatorAddCrewProjectMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorAddCrewProjectMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorAddCrewProjectMutationMutation, { data, loading, error }] = useOperatorAddCrewProjectMutationMutation({
 *   variables: {
 *      operatorAddCrewProjectInput: // value for 'operatorAddCrewProjectInput'
 *   },
 * });
 */
export function useOperatorAddCrewProjectMutationMutation(baseOptions?: Apollo.MutationHookOptions<OperatorAddCrewProjectMutationMutation, OperatorAddCrewProjectMutationMutationVariables>) {
        return Apollo.useMutation<OperatorAddCrewProjectMutationMutation, OperatorAddCrewProjectMutationMutationVariables>(OperatorAddCrewProjectMutationDocument, baseOptions);
      }
export type OperatorAddCrewProjectMutationMutationHookResult = ReturnType<typeof useOperatorAddCrewProjectMutationMutation>;
export type OperatorAddCrewProjectMutationMutationResult = Apollo.MutationResult<OperatorAddCrewProjectMutationMutation>;
export type OperatorAddCrewProjectMutationMutationOptions = Apollo.BaseMutationOptions<OperatorAddCrewProjectMutationMutation, OperatorAddCrewProjectMutationMutationVariables>;
export const OperatorAddCrewProjectSubmittedMutationDocument = gql`
    mutation operatorAddCrewProjectSubmittedMutation($id: Int!) {
  operatorAddCrewProjectSubmitted(id: $id) {
    id
  }
}
    `;
export type OperatorAddCrewProjectSubmittedMutationMutationFn = Apollo.MutationFunction<OperatorAddCrewProjectSubmittedMutationMutation, OperatorAddCrewProjectSubmittedMutationMutationVariables>;

/**
 * __useOperatorAddCrewProjectSubmittedMutationMutation__
 *
 * To run a mutation, you first call `useOperatorAddCrewProjectSubmittedMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorAddCrewProjectSubmittedMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorAddCrewProjectSubmittedMutationMutation, { data, loading, error }] = useOperatorAddCrewProjectSubmittedMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOperatorAddCrewProjectSubmittedMutationMutation(baseOptions?: Apollo.MutationHookOptions<OperatorAddCrewProjectSubmittedMutationMutation, OperatorAddCrewProjectSubmittedMutationMutationVariables>) {
        return Apollo.useMutation<OperatorAddCrewProjectSubmittedMutationMutation, OperatorAddCrewProjectSubmittedMutationMutationVariables>(OperatorAddCrewProjectSubmittedMutationDocument, baseOptions);
      }
export type OperatorAddCrewProjectSubmittedMutationMutationHookResult = ReturnType<typeof useOperatorAddCrewProjectSubmittedMutationMutation>;
export type OperatorAddCrewProjectSubmittedMutationMutationResult = Apollo.MutationResult<OperatorAddCrewProjectSubmittedMutationMutation>;
export type OperatorAddCrewProjectSubmittedMutationMutationOptions = Apollo.BaseMutationOptions<OperatorAddCrewProjectSubmittedMutationMutation, OperatorAddCrewProjectSubmittedMutationMutationVariables>;
export const OperatorAddMechanicProjectMechanicDetailQueryDocument = gql`
    query operatorAddMechanicProjectMechanicDetailQuery($id: Int!) {
  mechanic(id: $id) {
    id
    firstName
    lastName
    mechanicPosition {
      id
    }
    country {
      id
    }
    mechanicLicenseType {
      id
    }
    licenseNumber
  }
}
    `;

/**
 * __useOperatorAddMechanicProjectMechanicDetailQueryQuery__
 *
 * To run a query within a React component, call `useOperatorAddMechanicProjectMechanicDetailQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorAddMechanicProjectMechanicDetailQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorAddMechanicProjectMechanicDetailQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOperatorAddMechanicProjectMechanicDetailQueryQuery(baseOptions: Apollo.QueryHookOptions<OperatorAddMechanicProjectMechanicDetailQueryQuery, OperatorAddMechanicProjectMechanicDetailQueryQueryVariables>) {
        return Apollo.useQuery<OperatorAddMechanicProjectMechanicDetailQueryQuery, OperatorAddMechanicProjectMechanicDetailQueryQueryVariables>(OperatorAddMechanicProjectMechanicDetailQueryDocument, baseOptions);
      }
export function useOperatorAddMechanicProjectMechanicDetailQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorAddMechanicProjectMechanicDetailQueryQuery, OperatorAddMechanicProjectMechanicDetailQueryQueryVariables>) {
          return Apollo.useLazyQuery<OperatorAddMechanicProjectMechanicDetailQueryQuery, OperatorAddMechanicProjectMechanicDetailQueryQueryVariables>(OperatorAddMechanicProjectMechanicDetailQueryDocument, baseOptions);
        }
export type OperatorAddMechanicProjectMechanicDetailQueryQueryHookResult = ReturnType<typeof useOperatorAddMechanicProjectMechanicDetailQueryQuery>;
export type OperatorAddMechanicProjectMechanicDetailQueryLazyQueryHookResult = ReturnType<typeof useOperatorAddMechanicProjectMechanicDetailQueryLazyQuery>;
export type OperatorAddMechanicProjectMechanicDetailQueryQueryResult = Apollo.QueryResult<OperatorAddMechanicProjectMechanicDetailQueryQuery, OperatorAddMechanicProjectMechanicDetailQueryQueryVariables>;
export const OperatorAddMechanicProjectMutationDocument = gql`
    mutation operatorAddMechanicProjectMutation($operatorAddMechanicProjectInput: OperatorAddMechanicProjectInput!) {
  operatorAddMechanicProject(operatorAddMechanicProjectInput: $operatorAddMechanicProjectInput) {
    id
  }
}
    `;
export type OperatorAddMechanicProjectMutationMutationFn = Apollo.MutationFunction<OperatorAddMechanicProjectMutationMutation, OperatorAddMechanicProjectMutationMutationVariables>;

/**
 * __useOperatorAddMechanicProjectMutationMutation__
 *
 * To run a mutation, you first call `useOperatorAddMechanicProjectMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorAddMechanicProjectMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorAddMechanicProjectMutationMutation, { data, loading, error }] = useOperatorAddMechanicProjectMutationMutation({
 *   variables: {
 *      operatorAddMechanicProjectInput: // value for 'operatorAddMechanicProjectInput'
 *   },
 * });
 */
export function useOperatorAddMechanicProjectMutationMutation(baseOptions?: Apollo.MutationHookOptions<OperatorAddMechanicProjectMutationMutation, OperatorAddMechanicProjectMutationMutationVariables>) {
        return Apollo.useMutation<OperatorAddMechanicProjectMutationMutation, OperatorAddMechanicProjectMutationMutationVariables>(OperatorAddMechanicProjectMutationDocument, baseOptions);
      }
export type OperatorAddMechanicProjectMutationMutationHookResult = ReturnType<typeof useOperatorAddMechanicProjectMutationMutation>;
export type OperatorAddMechanicProjectMutationMutationResult = Apollo.MutationResult<OperatorAddMechanicProjectMutationMutation>;
export type OperatorAddMechanicProjectMutationMutationOptions = Apollo.BaseMutationOptions<OperatorAddMechanicProjectMutationMutation, OperatorAddMechanicProjectMutationMutationVariables>;
export const OperatorAddMechanicProjectSubmittedMutationDocument = gql`
    mutation operatorAddMechanicProjectSubmittedMutation($id: Int!) {
  operatorAddMechanicProjectSubmitted(id: $id) {
    id
  }
}
    `;
export type OperatorAddMechanicProjectSubmittedMutationMutationFn = Apollo.MutationFunction<OperatorAddMechanicProjectSubmittedMutationMutation, OperatorAddMechanicProjectSubmittedMutationMutationVariables>;

/**
 * __useOperatorAddMechanicProjectSubmittedMutationMutation__
 *
 * To run a mutation, you first call `useOperatorAddMechanicProjectSubmittedMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorAddMechanicProjectSubmittedMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorAddMechanicProjectSubmittedMutationMutation, { data, loading, error }] = useOperatorAddMechanicProjectSubmittedMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOperatorAddMechanicProjectSubmittedMutationMutation(baseOptions?: Apollo.MutationHookOptions<OperatorAddMechanicProjectSubmittedMutationMutation, OperatorAddMechanicProjectSubmittedMutationMutationVariables>) {
        return Apollo.useMutation<OperatorAddMechanicProjectSubmittedMutationMutation, OperatorAddMechanicProjectSubmittedMutationMutationVariables>(OperatorAddMechanicProjectSubmittedMutationDocument, baseOptions);
      }
export type OperatorAddMechanicProjectSubmittedMutationMutationHookResult = ReturnType<typeof useOperatorAddMechanicProjectSubmittedMutationMutation>;
export type OperatorAddMechanicProjectSubmittedMutationMutationResult = Apollo.MutationResult<OperatorAddMechanicProjectSubmittedMutationMutation>;
export type OperatorAddMechanicProjectSubmittedMutationMutationOptions = Apollo.BaseMutationOptions<OperatorAddMechanicProjectSubmittedMutationMutation, OperatorAddMechanicProjectSubmittedMutationMutationVariables>;
export const OperatorDashboardCrewMembersReportDocument = gql`
    query operatorDashboardCrewMembersReport($operatorIdIn: [Int!], $hasCertificationExpiryDate: Boolean, $sortBy: CrewMembersSortBy, $sortDirection: String, $paginationOptions: PaginationOptions) {
  crewMembers(operatorIdIn: $operatorIdIn, hasCertificationExpiryDate: $hasCertificationExpiryDate, sortBy: $sortBy, sortDirection: $sortDirection, paginationOptions: $paginationOptions) {
    ... on PaginatedCrewMembers {
      totalItems
      crewMembers {
        ...operatorDashboardCrewMembersReportItem
      }
    }
    ... on CrewMembers {
      crewMembers {
        ...operatorDashboardCrewMembersReportItem
      }
    }
  }
}
    ${OperatorDashboardCrewMembersReportItemFragmentDoc}`;

/**
 * __useOperatorDashboardCrewMembersReportQuery__
 *
 * To run a query within a React component, call `useOperatorDashboardCrewMembersReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorDashboardCrewMembersReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorDashboardCrewMembersReportQuery({
 *   variables: {
 *      operatorIdIn: // value for 'operatorIdIn'
 *      hasCertificationExpiryDate: // value for 'hasCertificationExpiryDate'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useOperatorDashboardCrewMembersReportQuery(baseOptions?: Apollo.QueryHookOptions<OperatorDashboardCrewMembersReportQuery, OperatorDashboardCrewMembersReportQueryVariables>) {
        return Apollo.useQuery<OperatorDashboardCrewMembersReportQuery, OperatorDashboardCrewMembersReportQueryVariables>(OperatorDashboardCrewMembersReportDocument, baseOptions);
      }
export function useOperatorDashboardCrewMembersReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorDashboardCrewMembersReportQuery, OperatorDashboardCrewMembersReportQueryVariables>) {
          return Apollo.useLazyQuery<OperatorDashboardCrewMembersReportQuery, OperatorDashboardCrewMembersReportQueryVariables>(OperatorDashboardCrewMembersReportDocument, baseOptions);
        }
export type OperatorDashboardCrewMembersReportQueryHookResult = ReturnType<typeof useOperatorDashboardCrewMembersReportQuery>;
export type OperatorDashboardCrewMembersReportLazyQueryHookResult = ReturnType<typeof useOperatorDashboardCrewMembersReportLazyQuery>;
export type OperatorDashboardCrewMembersReportQueryResult = Apollo.QueryResult<OperatorDashboardCrewMembersReportQuery, OperatorDashboardCrewMembersReportQueryVariables>;
export const OperatorDashboardAircraftReportDocument = gql`
    query operatorDashboardAircraftReport($operatorIdIn: [Int!], $hasCertificateOfAirworthinessExpirationDate: Boolean, $hasCertificateOfRegistrationExpirationDate: Boolean, $hascertificateOfInsuranceExpirationDate: Boolean, $hasLeaseAgreementExpirationDate: Boolean, $hasManagementAgreementExpirationDate: Boolean, $sortBy: AircraftsSortBy, $sortDirection: String, $paginationOptions: PaginationOptions) {
  aircrafts(operatorIdIn: $operatorIdIn, hasCertificateOfAirworthinessExpirationDate: $hasCertificateOfAirworthinessExpirationDate, hasCertificateOfRegistrationExpirationDate: $hasCertificateOfRegistrationExpirationDate, hascertificateOfInsuranceExpirationDate: $hascertificateOfInsuranceExpirationDate, hasLeaseAgreementExpirationDate: $hasLeaseAgreementExpirationDate, hasManagementAgreementExpirationDate: $hasManagementAgreementExpirationDate, sortBy: $sortBy, sortDirection: $sortDirection, paginationOptions: $paginationOptions) {
    ... on PaginatedAircrafts {
      totalItems
      aircrafts {
        ...operatorDashboardAircraftReportItem
      }
    }
    ... on Aircrafts {
      aircrafts {
        ...operatorDashboardAircraftReportItem
      }
    }
  }
}
    ${OperatorDashboardAircraftReportItemFragmentDoc}`;

/**
 * __useOperatorDashboardAircraftReportQuery__
 *
 * To run a query within a React component, call `useOperatorDashboardAircraftReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorDashboardAircraftReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorDashboardAircraftReportQuery({
 *   variables: {
 *      operatorIdIn: // value for 'operatorIdIn'
 *      hasCertificateOfAirworthinessExpirationDate: // value for 'hasCertificateOfAirworthinessExpirationDate'
 *      hasCertificateOfRegistrationExpirationDate: // value for 'hasCertificateOfRegistrationExpirationDate'
 *      hascertificateOfInsuranceExpirationDate: // value for 'hascertificateOfInsuranceExpirationDate'
 *      hasLeaseAgreementExpirationDate: // value for 'hasLeaseAgreementExpirationDate'
 *      hasManagementAgreementExpirationDate: // value for 'hasManagementAgreementExpirationDate'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useOperatorDashboardAircraftReportQuery(baseOptions?: Apollo.QueryHookOptions<OperatorDashboardAircraftReportQuery, OperatorDashboardAircraftReportQueryVariables>) {
        return Apollo.useQuery<OperatorDashboardAircraftReportQuery, OperatorDashboardAircraftReportQueryVariables>(OperatorDashboardAircraftReportDocument, baseOptions);
      }
export function useOperatorDashboardAircraftReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorDashboardAircraftReportQuery, OperatorDashboardAircraftReportQueryVariables>) {
          return Apollo.useLazyQuery<OperatorDashboardAircraftReportQuery, OperatorDashboardAircraftReportQueryVariables>(OperatorDashboardAircraftReportDocument, baseOptions);
        }
export type OperatorDashboardAircraftReportQueryHookResult = ReturnType<typeof useOperatorDashboardAircraftReportQuery>;
export type OperatorDashboardAircraftReportLazyQueryHookResult = ReturnType<typeof useOperatorDashboardAircraftReportLazyQuery>;
export type OperatorDashboardAircraftReportQueryResult = Apollo.QueryResult<OperatorDashboardAircraftReportQuery, OperatorDashboardAircraftReportQueryVariables>;
export const OperatorDashboardMechanicsReportDocument = gql`
    query operatorDashboardMechanicsReport($operatorIdIn: [Int!], $hasCertificationExpiryDate: Boolean, $sortBy: MechanicsSortBy, $sortDirection: String, $paginationOptions: PaginationOptions) {
  mechanics(operatorIdIn: $operatorIdIn, hasCertificationExpiryDate: $hasCertificationExpiryDate, sortBy: $sortBy, sortDirection: $sortDirection, paginationOptions: $paginationOptions) {
    ... on PaginatedMechanics {
      totalItems
      mechanics {
        ...operatorDashboardMechanicsReportItem
      }
    }
    ... on Mechanics {
      mechanics {
        ...operatorDashboardMechanicsReportItem
      }
    }
  }
}
    ${OperatorDashboardMechanicsReportItemFragmentDoc}`;

/**
 * __useOperatorDashboardMechanicsReportQuery__
 *
 * To run a query within a React component, call `useOperatorDashboardMechanicsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorDashboardMechanicsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorDashboardMechanicsReportQuery({
 *   variables: {
 *      operatorIdIn: // value for 'operatorIdIn'
 *      hasCertificationExpiryDate: // value for 'hasCertificationExpiryDate'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useOperatorDashboardMechanicsReportQuery(baseOptions?: Apollo.QueryHookOptions<OperatorDashboardMechanicsReportQuery, OperatorDashboardMechanicsReportQueryVariables>) {
        return Apollo.useQuery<OperatorDashboardMechanicsReportQuery, OperatorDashboardMechanicsReportQueryVariables>(OperatorDashboardMechanicsReportDocument, baseOptions);
      }
export function useOperatorDashboardMechanicsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorDashboardMechanicsReportQuery, OperatorDashboardMechanicsReportQueryVariables>) {
          return Apollo.useLazyQuery<OperatorDashboardMechanicsReportQuery, OperatorDashboardMechanicsReportQueryVariables>(OperatorDashboardMechanicsReportDocument, baseOptions);
        }
export type OperatorDashboardMechanicsReportQueryHookResult = ReturnType<typeof useOperatorDashboardMechanicsReportQuery>;
export type OperatorDashboardMechanicsReportLazyQueryHookResult = ReturnType<typeof useOperatorDashboardMechanicsReportLazyQuery>;
export type OperatorDashboardMechanicsReportQueryResult = Apollo.QueryResult<OperatorDashboardMechanicsReportQuery, OperatorDashboardMechanicsReportQueryVariables>;
export const NewOperatorContactRequestDocument = gql`
    mutation newOperatorContactRequest($input: NewContactRequestInput!) {
  sendNewContactRequest(input: $input) {
    id
  }
}
    `;
export type NewOperatorContactRequestMutationFn = Apollo.MutationFunction<NewOperatorContactRequestMutation, NewOperatorContactRequestMutationVariables>;

/**
 * __useNewOperatorContactRequestMutation__
 *
 * To run a mutation, you first call `useNewOperatorContactRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewOperatorContactRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newOperatorContactRequestMutation, { data, loading, error }] = useNewOperatorContactRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewOperatorContactRequestMutation(baseOptions?: Apollo.MutationHookOptions<NewOperatorContactRequestMutation, NewOperatorContactRequestMutationVariables>) {
        return Apollo.useMutation<NewOperatorContactRequestMutation, NewOperatorContactRequestMutationVariables>(NewOperatorContactRequestDocument, baseOptions);
      }
export type NewOperatorContactRequestMutationHookResult = ReturnType<typeof useNewOperatorContactRequestMutation>;
export type NewOperatorContactRequestMutationResult = Apollo.MutationResult<NewOperatorContactRequestMutation>;
export type NewOperatorContactRequestMutationOptions = Apollo.BaseMutationOptions<NewOperatorContactRequestMutation, NewOperatorContactRequestMutationVariables>;
export const OwnerGridFilterLookupsDocument = gql`
    query ownerGridFilterLookups {
  countries {
    ...countryLookup
  }
  regions {
    ...regionLookup
  }
}
    ${CountryLookupFragmentDoc}
${RegionLookupFragmentDoc}`;

/**
 * __useOwnerGridFilterLookupsQuery__
 *
 * To run a query within a React component, call `useOwnerGridFilterLookupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnerGridFilterLookupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOwnerGridFilterLookupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOwnerGridFilterLookupsQuery(baseOptions?: Apollo.QueryHookOptions<OwnerGridFilterLookupsQuery, OwnerGridFilterLookupsQueryVariables>) {
        return Apollo.useQuery<OwnerGridFilterLookupsQuery, OwnerGridFilterLookupsQueryVariables>(OwnerGridFilterLookupsDocument, baseOptions);
      }
export function useOwnerGridFilterLookupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OwnerGridFilterLookupsQuery, OwnerGridFilterLookupsQueryVariables>) {
          return Apollo.useLazyQuery<OwnerGridFilterLookupsQuery, OwnerGridFilterLookupsQueryVariables>(OwnerGridFilterLookupsDocument, baseOptions);
        }
export type OwnerGridFilterLookupsQueryHookResult = ReturnType<typeof useOwnerGridFilterLookupsQuery>;
export type OwnerGridFilterLookupsLazyQueryHookResult = ReturnType<typeof useOwnerGridFilterLookupsLazyQuery>;
export type OwnerGridFilterLookupsQueryResult = Apollo.QueryResult<OwnerGridFilterLookupsQuery, OwnerGridFilterLookupsQueryVariables>;
export const OwnerGridDocument = gql`
    query ownerGrid($sortBy: OwnersSortBy, $sortDirection: String, $nameContains: String, $countryIdIn: [Int!], $regionIdIn: [Int!], $isActive: Boolean, $includeInactive: Boolean, $keyword: String, $paginationOptions: PaginationOptions) {
  owners(sortBy: $sortBy, sortDirection: $sortDirection, nameContains: $nameContains, countryIdIn: $countryIdIn, regionIdIn: $regionIdIn, isActive: $isActive, includeInactive: $includeInactive, keyword: $keyword, paginationOptions: $paginationOptions) {
    ... on PaginatedOwners {
      totalItems
      owners {
        ...ownerGridItem
      }
    }
    ... on Owners {
      owners {
        ...ownerGridItem
      }
    }
  }
}
    ${OwnerGridItemFragmentDoc}`;

/**
 * __useOwnerGridQuery__
 *
 * To run a query within a React component, call `useOwnerGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnerGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOwnerGridQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      nameContains: // value for 'nameContains'
 *      countryIdIn: // value for 'countryIdIn'
 *      regionIdIn: // value for 'regionIdIn'
 *      isActive: // value for 'isActive'
 *      includeInactive: // value for 'includeInactive'
 *      keyword: // value for 'keyword'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useOwnerGridQuery(baseOptions?: Apollo.QueryHookOptions<OwnerGridQuery, OwnerGridQueryVariables>) {
        return Apollo.useQuery<OwnerGridQuery, OwnerGridQueryVariables>(OwnerGridDocument, baseOptions);
      }
export function useOwnerGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OwnerGridQuery, OwnerGridQueryVariables>) {
          return Apollo.useLazyQuery<OwnerGridQuery, OwnerGridQueryVariables>(OwnerGridDocument, baseOptions);
        }
export type OwnerGridQueryHookResult = ReturnType<typeof useOwnerGridQuery>;
export type OwnerGridLazyQueryHookResult = ReturnType<typeof useOwnerGridLazyQuery>;
export type OwnerGridQueryResult = Apollo.QueryResult<OwnerGridQuery, OwnerGridQueryVariables>;
export const OwnerDetailDocument = gql`
    query ownerDetail($id: Int!) {
  owner(id: $id) {
    ...ownerDetail
  }
}
    ${OwnerDetailFragmentDoc}`;

/**
 * __useOwnerDetailQuery__
 *
 * To run a query within a React component, call `useOwnerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOwnerDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOwnerDetailQuery(baseOptions: Apollo.QueryHookOptions<OwnerDetailQuery, OwnerDetailQueryVariables>) {
        return Apollo.useQuery<OwnerDetailQuery, OwnerDetailQueryVariables>(OwnerDetailDocument, baseOptions);
      }
export function useOwnerDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OwnerDetailQuery, OwnerDetailQueryVariables>) {
          return Apollo.useLazyQuery<OwnerDetailQuery, OwnerDetailQueryVariables>(OwnerDetailDocument, baseOptions);
        }
export type OwnerDetailQueryHookResult = ReturnType<typeof useOwnerDetailQuery>;
export type OwnerDetailLazyQueryHookResult = ReturnType<typeof useOwnerDetailLazyQuery>;
export type OwnerDetailQueryResult = Apollo.QueryResult<OwnerDetailQuery, OwnerDetailQueryVariables>;
export const AddOwnerDocument = gql`
    mutation addOwner($input: OwnerInput!) {
  addOwner(input: $input) {
    id
    company {
      id
      name
    }
  }
}
    `;
export type AddOwnerMutationFn = Apollo.MutationFunction<AddOwnerMutation, AddOwnerMutationVariables>;

/**
 * __useAddOwnerMutation__
 *
 * To run a mutation, you first call `useAddOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOwnerMutation, { data, loading, error }] = useAddOwnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOwnerMutation(baseOptions?: Apollo.MutationHookOptions<AddOwnerMutation, AddOwnerMutationVariables>) {
        return Apollo.useMutation<AddOwnerMutation, AddOwnerMutationVariables>(AddOwnerDocument, baseOptions);
      }
export type AddOwnerMutationHookResult = ReturnType<typeof useAddOwnerMutation>;
export type AddOwnerMutationResult = Apollo.MutationResult<AddOwnerMutation>;
export type AddOwnerMutationOptions = Apollo.BaseMutationOptions<AddOwnerMutation, AddOwnerMutationVariables>;
export const UpdateOwnerDocument = gql`
    mutation updateOwner($id: Int!, $input: OwnerInput!) {
  updateOwner(id: $id, input: $input) {
    id
    company {
      id
      name
    }
  }
}
    `;
export type UpdateOwnerMutationFn = Apollo.MutationFunction<UpdateOwnerMutation, UpdateOwnerMutationVariables>;

/**
 * __useUpdateOwnerMutation__
 *
 * To run a mutation, you first call `useUpdateOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOwnerMutation, { data, loading, error }] = useUpdateOwnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOwnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOwnerMutation, UpdateOwnerMutationVariables>) {
        return Apollo.useMutation<UpdateOwnerMutation, UpdateOwnerMutationVariables>(UpdateOwnerDocument, baseOptions);
      }
export type UpdateOwnerMutationHookResult = ReturnType<typeof useUpdateOwnerMutation>;
export type UpdateOwnerMutationResult = Apollo.MutationResult<UpdateOwnerMutation>;
export type UpdateOwnerMutationOptions = Apollo.BaseMutationOptions<UpdateOwnerMutation, UpdateOwnerMutationVariables>;
export const OwnerDocumentTypesQueryDocument = gql`
    query ownerDocumentTypesQuery($companyId: Int!, $documentTypeCategoryId: DocumentTypeCategoryEnum!) {
  documentTypes: ownerDocumentTypes(companyId: $companyId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...documentType
  }
}
    ${DocumentTypeFragmentDoc}`;

/**
 * __useOwnerDocumentTypesQueryQuery__
 *
 * To run a query within a React component, call `useOwnerDocumentTypesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnerDocumentTypesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOwnerDocumentTypesQueryQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      documentTypeCategoryId: // value for 'documentTypeCategoryId'
 *   },
 * });
 */
export function useOwnerDocumentTypesQueryQuery(baseOptions: Apollo.QueryHookOptions<OwnerDocumentTypesQueryQuery, OwnerDocumentTypesQueryQueryVariables>) {
        return Apollo.useQuery<OwnerDocumentTypesQueryQuery, OwnerDocumentTypesQueryQueryVariables>(OwnerDocumentTypesQueryDocument, baseOptions);
      }
export function useOwnerDocumentTypesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OwnerDocumentTypesQueryQuery, OwnerDocumentTypesQueryQueryVariables>) {
          return Apollo.useLazyQuery<OwnerDocumentTypesQueryQuery, OwnerDocumentTypesQueryQueryVariables>(OwnerDocumentTypesQueryDocument, baseOptions);
        }
export type OwnerDocumentTypesQueryQueryHookResult = ReturnType<typeof useOwnerDocumentTypesQueryQuery>;
export type OwnerDocumentTypesQueryLazyQueryHookResult = ReturnType<typeof useOwnerDocumentTypesQueryLazyQuery>;
export type OwnerDocumentTypesQueryQueryResult = Apollo.QueryResult<OwnerDocumentTypesQueryQuery, OwnerDocumentTypesQueryQueryVariables>;
export const RegisteredHolderGridFilterLookupsDocument = gql`
    query registeredHolderGridFilterLookups {
  countries {
    ...countryLookup
  }
  regions {
    ...regionLookup
  }
}
    ${CountryLookupFragmentDoc}
${RegionLookupFragmentDoc}`;

/**
 * __useRegisteredHolderGridFilterLookupsQuery__
 *
 * To run a query within a React component, call `useRegisteredHolderGridFilterLookupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisteredHolderGridFilterLookupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisteredHolderGridFilterLookupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegisteredHolderGridFilterLookupsQuery(baseOptions?: Apollo.QueryHookOptions<RegisteredHolderGridFilterLookupsQuery, RegisteredHolderGridFilterLookupsQueryVariables>) {
        return Apollo.useQuery<RegisteredHolderGridFilterLookupsQuery, RegisteredHolderGridFilterLookupsQueryVariables>(RegisteredHolderGridFilterLookupsDocument, baseOptions);
      }
export function useRegisteredHolderGridFilterLookupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisteredHolderGridFilterLookupsQuery, RegisteredHolderGridFilterLookupsQueryVariables>) {
          return Apollo.useLazyQuery<RegisteredHolderGridFilterLookupsQuery, RegisteredHolderGridFilterLookupsQueryVariables>(RegisteredHolderGridFilterLookupsDocument, baseOptions);
        }
export type RegisteredHolderGridFilterLookupsQueryHookResult = ReturnType<typeof useRegisteredHolderGridFilterLookupsQuery>;
export type RegisteredHolderGridFilterLookupsLazyQueryHookResult = ReturnType<typeof useRegisteredHolderGridFilterLookupsLazyQuery>;
export type RegisteredHolderGridFilterLookupsQueryResult = Apollo.QueryResult<RegisteredHolderGridFilterLookupsQuery, RegisteredHolderGridFilterLookupsQueryVariables>;
export const RegisteredHolderGridDocument = gql`
    query registeredHolderGrid($sortBy: RegisteredHoldersSortBy, $sortDirection: String, $nameContains: String, $countryIdIn: [Int!], $regionIdIn: [Int!], $isActive: Boolean, $includeInactive: Boolean, $keyword: String, $paginationOptions: PaginationOptions) {
  registeredHolders(sortBy: $sortBy, sortDirection: $sortDirection, nameContains: $nameContains, countryIdIn: $countryIdIn, regionIdIn: $regionIdIn, isActive: $isActive, includeInactive: $includeInactive, keyword: $keyword, paginationOptions: $paginationOptions) {
    ... on PaginatedRegisteredHolders {
      totalItems
      registeredHolders {
        ...registeredHolderGridItem
      }
    }
    ... on RegisteredHolders {
      registeredHolders {
        ...registeredHolderGridItem
      }
    }
  }
}
    ${RegisteredHolderGridItemFragmentDoc}`;

/**
 * __useRegisteredHolderGridQuery__
 *
 * To run a query within a React component, call `useRegisteredHolderGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisteredHolderGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisteredHolderGridQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      nameContains: // value for 'nameContains'
 *      countryIdIn: // value for 'countryIdIn'
 *      regionIdIn: // value for 'regionIdIn'
 *      isActive: // value for 'isActive'
 *      includeInactive: // value for 'includeInactive'
 *      keyword: // value for 'keyword'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useRegisteredHolderGridQuery(baseOptions?: Apollo.QueryHookOptions<RegisteredHolderGridQuery, RegisteredHolderGridQueryVariables>) {
        return Apollo.useQuery<RegisteredHolderGridQuery, RegisteredHolderGridQueryVariables>(RegisteredHolderGridDocument, baseOptions);
      }
export function useRegisteredHolderGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisteredHolderGridQuery, RegisteredHolderGridQueryVariables>) {
          return Apollo.useLazyQuery<RegisteredHolderGridQuery, RegisteredHolderGridQueryVariables>(RegisteredHolderGridDocument, baseOptions);
        }
export type RegisteredHolderGridQueryHookResult = ReturnType<typeof useRegisteredHolderGridQuery>;
export type RegisteredHolderGridLazyQueryHookResult = ReturnType<typeof useRegisteredHolderGridLazyQuery>;
export type RegisteredHolderGridQueryResult = Apollo.QueryResult<RegisteredHolderGridQuery, RegisteredHolderGridQueryVariables>;
export const RegisteredHolderDetailDocument = gql`
    query registeredHolderDetail($id: Int!) {
  registeredHolder(id: $id) {
    ...registeredHolderDetail
  }
}
    ${RegisteredHolderDetailFragmentDoc}`;

/**
 * __useRegisteredHolderDetailQuery__
 *
 * To run a query within a React component, call `useRegisteredHolderDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisteredHolderDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisteredHolderDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegisteredHolderDetailQuery(baseOptions: Apollo.QueryHookOptions<RegisteredHolderDetailQuery, RegisteredHolderDetailQueryVariables>) {
        return Apollo.useQuery<RegisteredHolderDetailQuery, RegisteredHolderDetailQueryVariables>(RegisteredHolderDetailDocument, baseOptions);
      }
export function useRegisteredHolderDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisteredHolderDetailQuery, RegisteredHolderDetailQueryVariables>) {
          return Apollo.useLazyQuery<RegisteredHolderDetailQuery, RegisteredHolderDetailQueryVariables>(RegisteredHolderDetailDocument, baseOptions);
        }
export type RegisteredHolderDetailQueryHookResult = ReturnType<typeof useRegisteredHolderDetailQuery>;
export type RegisteredHolderDetailLazyQueryHookResult = ReturnType<typeof useRegisteredHolderDetailLazyQuery>;
export type RegisteredHolderDetailQueryResult = Apollo.QueryResult<RegisteredHolderDetailQuery, RegisteredHolderDetailQueryVariables>;
export const AddRegisteredHolderDocument = gql`
    mutation addRegisteredHolder($input: RegisteredHolderInput!) {
  addRegisteredHolder(input: $input) {
    id
    company {
      id
      name
    }
  }
}
    `;
export type AddRegisteredHolderMutationFn = Apollo.MutationFunction<AddRegisteredHolderMutation, AddRegisteredHolderMutationVariables>;

/**
 * __useAddRegisteredHolderMutation__
 *
 * To run a mutation, you first call `useAddRegisteredHolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRegisteredHolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRegisteredHolderMutation, { data, loading, error }] = useAddRegisteredHolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRegisteredHolderMutation(baseOptions?: Apollo.MutationHookOptions<AddRegisteredHolderMutation, AddRegisteredHolderMutationVariables>) {
        return Apollo.useMutation<AddRegisteredHolderMutation, AddRegisteredHolderMutationVariables>(AddRegisteredHolderDocument, baseOptions);
      }
export type AddRegisteredHolderMutationHookResult = ReturnType<typeof useAddRegisteredHolderMutation>;
export type AddRegisteredHolderMutationResult = Apollo.MutationResult<AddRegisteredHolderMutation>;
export type AddRegisteredHolderMutationOptions = Apollo.BaseMutationOptions<AddRegisteredHolderMutation, AddRegisteredHolderMutationVariables>;
export const UpdateRegisteredHolderDocument = gql`
    mutation updateRegisteredHolder($id: Int!, $input: RegisteredHolderInput!) {
  updateRegisteredHolder(id: $id, input: $input) {
    id
    company {
      id
      name
    }
  }
}
    `;
export type UpdateRegisteredHolderMutationFn = Apollo.MutationFunction<UpdateRegisteredHolderMutation, UpdateRegisteredHolderMutationVariables>;

/**
 * __useUpdateRegisteredHolderMutation__
 *
 * To run a mutation, you first call `useUpdateRegisteredHolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegisteredHolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegisteredHolderMutation, { data, loading, error }] = useUpdateRegisteredHolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegisteredHolderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegisteredHolderMutation, UpdateRegisteredHolderMutationVariables>) {
        return Apollo.useMutation<UpdateRegisteredHolderMutation, UpdateRegisteredHolderMutationVariables>(UpdateRegisteredHolderDocument, baseOptions);
      }
export type UpdateRegisteredHolderMutationHookResult = ReturnType<typeof useUpdateRegisteredHolderMutation>;
export type UpdateRegisteredHolderMutationResult = Apollo.MutationResult<UpdateRegisteredHolderMutation>;
export type UpdateRegisteredHolderMutationOptions = Apollo.BaseMutationOptions<UpdateRegisteredHolderMutation, UpdateRegisteredHolderMutationVariables>;
export const RegisteredHolderDocumentTypesQueryDocument = gql`
    query registeredHolderDocumentTypesQuery($companyId: Int!, $documentTypeCategoryId: DocumentTypeCategoryEnum!) {
  documentTypes: registeredHolderDocumentTypes(companyId: $companyId, documentTypeCategoryId: $documentTypeCategoryId) {
    ...documentType
  }
}
    ${DocumentTypeFragmentDoc}`;

/**
 * __useRegisteredHolderDocumentTypesQueryQuery__
 *
 * To run a query within a React component, call `useRegisteredHolderDocumentTypesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisteredHolderDocumentTypesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisteredHolderDocumentTypesQueryQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      documentTypeCategoryId: // value for 'documentTypeCategoryId'
 *   },
 * });
 */
export function useRegisteredHolderDocumentTypesQueryQuery(baseOptions: Apollo.QueryHookOptions<RegisteredHolderDocumentTypesQueryQuery, RegisteredHolderDocumentTypesQueryQueryVariables>) {
        return Apollo.useQuery<RegisteredHolderDocumentTypesQueryQuery, RegisteredHolderDocumentTypesQueryQueryVariables>(RegisteredHolderDocumentTypesQueryDocument, baseOptions);
      }
export function useRegisteredHolderDocumentTypesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisteredHolderDocumentTypesQueryQuery, RegisteredHolderDocumentTypesQueryQueryVariables>) {
          return Apollo.useLazyQuery<RegisteredHolderDocumentTypesQueryQuery, RegisteredHolderDocumentTypesQueryQueryVariables>(RegisteredHolderDocumentTypesQueryDocument, baseOptions);
        }
export type RegisteredHolderDocumentTypesQueryQueryHookResult = ReturnType<typeof useRegisteredHolderDocumentTypesQueryQuery>;
export type RegisteredHolderDocumentTypesQueryLazyQueryHookResult = ReturnType<typeof useRegisteredHolderDocumentTypesQueryLazyQuery>;
export type RegisteredHolderDocumentTypesQueryQueryResult = Apollo.QueryResult<RegisteredHolderDocumentTypesQueryQuery, RegisteredHolderDocumentTypesQueryQueryVariables>;
export const UserGridFilterLookupsQueryDocument = gql`
    query userGridFilterLookupsQuery {
  roles {
    ...userRole
  }
}
    ${UserRoleFragmentDoc}`;

/**
 * __useUserGridFilterLookupsQueryQuery__
 *
 * To run a query within a React component, call `useUserGridFilterLookupsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGridFilterLookupsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGridFilterLookupsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserGridFilterLookupsQueryQuery(baseOptions?: Apollo.QueryHookOptions<UserGridFilterLookupsQueryQuery, UserGridFilterLookupsQueryQueryVariables>) {
        return Apollo.useQuery<UserGridFilterLookupsQueryQuery, UserGridFilterLookupsQueryQueryVariables>(UserGridFilterLookupsQueryDocument, baseOptions);
      }
export function useUserGridFilterLookupsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGridFilterLookupsQueryQuery, UserGridFilterLookupsQueryQueryVariables>) {
          return Apollo.useLazyQuery<UserGridFilterLookupsQueryQuery, UserGridFilterLookupsQueryQueryVariables>(UserGridFilterLookupsQueryDocument, baseOptions);
        }
export type UserGridFilterLookupsQueryQueryHookResult = ReturnType<typeof useUserGridFilterLookupsQueryQuery>;
export type UserGridFilterLookupsQueryLazyQueryHookResult = ReturnType<typeof useUserGridFilterLookupsQueryLazyQuery>;
export type UserGridFilterLookupsQueryQueryResult = Apollo.QueryResult<UserGridFilterLookupsQueryQuery, UserGridFilterLookupsQueryQueryVariables>;
export const UserGridDocument = gql`
    query userGrid($roleIdIn: [Int!], $isActive: Boolean, $sortBy: UsersSortBy, $sortDirection: String, $paginationOptions: PaginationOptions) {
  users(roleIdIn: $roleIdIn, isActive: $isActive, sortBy: $sortBy, sortDirection: $sortDirection, paginationOptions: $paginationOptions) {
    ... on PaginatedUsers {
      totalItems
      users {
        ...userGridItem
      }
    }
    ... on Users {
      users {
        ...userGridItem
      }
    }
  }
}
    ${UserGridItemFragmentDoc}`;

/**
 * __useUserGridQuery__
 *
 * To run a query within a React component, call `useUserGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGridQuery({
 *   variables: {
 *      roleIdIn: // value for 'roleIdIn'
 *      isActive: // value for 'isActive'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      paginationOptions: // value for 'paginationOptions'
 *   },
 * });
 */
export function useUserGridQuery(baseOptions?: Apollo.QueryHookOptions<UserGridQuery, UserGridQueryVariables>) {
        return Apollo.useQuery<UserGridQuery, UserGridQueryVariables>(UserGridDocument, baseOptions);
      }
export function useUserGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGridQuery, UserGridQueryVariables>) {
          return Apollo.useLazyQuery<UserGridQuery, UserGridQueryVariables>(UserGridDocument, baseOptions);
        }
export type UserGridQueryHookResult = ReturnType<typeof useUserGridQuery>;
export type UserGridLazyQueryHookResult = ReturnType<typeof useUserGridLazyQuery>;
export type UserGridQueryResult = Apollo.QueryResult<UserGridQuery, UserGridQueryVariables>;
export const UserGridCompanyContactsDocument = gql`
    query userGridCompanyContacts {
  companyContacts {
    ...contact
  }
}
    ${ContactFragmentDoc}`;

/**
 * __useUserGridCompanyContactsQuery__
 *
 * To run a query within a React component, call `useUserGridCompanyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGridCompanyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGridCompanyContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserGridCompanyContactsQuery(baseOptions?: Apollo.QueryHookOptions<UserGridCompanyContactsQuery, UserGridCompanyContactsQueryVariables>) {
        return Apollo.useQuery<UserGridCompanyContactsQuery, UserGridCompanyContactsQueryVariables>(UserGridCompanyContactsDocument, baseOptions);
      }
export function useUserGridCompanyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGridCompanyContactsQuery, UserGridCompanyContactsQueryVariables>) {
          return Apollo.useLazyQuery<UserGridCompanyContactsQuery, UserGridCompanyContactsQueryVariables>(UserGridCompanyContactsDocument, baseOptions);
        }
export type UserGridCompanyContactsQueryHookResult = ReturnType<typeof useUserGridCompanyContactsQuery>;
export type UserGridCompanyContactsLazyQueryHookResult = ReturnType<typeof useUserGridCompanyContactsLazyQuery>;
export type UserGridCompanyContactsQueryResult = Apollo.QueryResult<UserGridCompanyContactsQuery, UserGridCompanyContactsQueryVariables>;
export const UserDetailDocument = gql`
    query userDetail($id: Int!) {
  user(id: $id) {
    id
    firstName
    lastName
    initials
    userName
    jobTitle
    role {
      id
    }
    isActive
    emailAddresses {
      id
      emailAddressTypeId
      emailAddress
    }
    phoneNumbers {
      id
      phoneNumberTypeId
      phoneNumber
    }
    notes
    signatureImageFileAttachment {
      mimeType
      content
    }
    signatureName
    department {
      id
    }
    departmentRoleId
    isMaintenanceInspector
    isMechanicProjectDcaReviewerUser
    isMechanicProjectDcaSentForApprovalByUser
    isMechanicProjectDcaApprovedByUser
    canCancelMechanicProjects
  }
}
    `;

/**
 * __useUserDetailQuery__
 *
 * To run a query within a React component, call `useUserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDetailQuery(baseOptions: Apollo.QueryHookOptions<UserDetailQuery, UserDetailQueryVariables>) {
        return Apollo.useQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, baseOptions);
      }
export function useUserDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailQuery, UserDetailQueryVariables>) {
          return Apollo.useLazyQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, baseOptions);
        }
export type UserDetailQueryHookResult = ReturnType<typeof useUserDetailQuery>;
export type UserDetailLazyQueryHookResult = ReturnType<typeof useUserDetailLazyQuery>;
export type UserDetailQueryResult = Apollo.QueryResult<UserDetailQuery, UserDetailQueryVariables>;
export const AddUserDocument = gql`
    mutation addUser($input: UserInput!) {
  addUser(input: $input) {
    id
  }
}
    `;
export type AddUserMutationFn = Apollo.MutationFunction<AddUserMutation, AddUserMutationVariables>;

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserMutation(baseOptions?: Apollo.MutationHookOptions<AddUserMutation, AddUserMutationVariables>) {
        return Apollo.useMutation<AddUserMutation, AddUserMutationVariables>(AddUserDocument, baseOptions);
      }
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>;
export type AddUserMutationResult = Apollo.MutationResult<AddUserMutation>;
export type AddUserMutationOptions = Apollo.BaseMutationOptions<AddUserMutation, AddUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UserInput!) {
  updateUser(input: $input) {
    id
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, baseOptions);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AircraftProjectsResult": [
      "AircraftProjects",
      "PaginatedAircraftProjects"
    ],
    "AircraftsResult": [
      "Aircrafts",
      "PaginatedAircrafts"
    ],
    "AmoProjectsResult": [
      "AmoProjects",
      "PaginatedAmoProjects"
    ],
    "AmosResult": [
      "Amos",
      "PaginatedAmos"
    ],
    "CrewMembersResult": [
      "CrewMembers",
      "PaginatedCrewMembers"
    ],
    "CrewProjectsResult": [
      "CrewProjects",
      "PaginatedCrewProjects"
    ],
    "InspectorInspectionsResult": [
      "InspectorInspections",
      "PaginatedInspectorInspections"
    ],
    "InspectorsResult": [
      "Inspectors",
      "PaginatedInspectors"
    ],
    "InvoicesResult": [
      "Invoices",
      "PaginatedInvoices"
    ],
    "MechanicProjectsResult": [
      "MechanicProjects",
      "PaginatedMechanicProjects"
    ],
    "MechanicsResult": [
      "Mechanics",
      "PaginatedMechanics"
    ],
    "OperatorsResult": [
      "Operators",
      "PaginatedOperators"
    ],
    "OwnersResult": [
      "Owners",
      "PaginatedOwners"
    ],
    "RegisteredHoldersResult": [
      "PaginatedRegisteredHolders",
      "RegisteredHolders"
    ],
    "UsersResult": [
      "PaginatedUsers",
      "Users"
    ]
  }
};
      export default result;
    